
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("77FPb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a41f1d4e1ad9317c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $7CMCs = parcelRequire("7CMCs");

var $id7K0 = parcelRequire("id7K0");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $g5X3G = parcelRequire("g5X3G");

var $giP9y = parcelRequire("giP9y");

var $caivO = parcelRequire("caivO");

var $9dbF6 = parcelRequire("9dbF6");

var $d31Su = parcelRequire("d31Su");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");

var $2O3HP = parcelRequire("2O3HP");

var $fGFTb = parcelRequire("fGFTb");

var $8Gk6V = parcelRequire("8Gk6V");
const $a41f1d4e1ad9317c$var$DeploymentFrequencyReportSpa = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const projectKey = match.params.projectKey ?? '';
    const boardId = match.params.boardId ?? '';
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const onViewDeploymentFrequencyReportExperienceFail = (0, $caivO.useViewDeploymentFrequencyReportExperienceFail)();
    const hasSoftwareLicense = (0, $3RV1W.checkLicense)(tenantContext, 'software');
    const newCmpReportsUrl = boardId.length > 0 ? `/jira/software/c/projects/${projectKey}/boards/${boardId}/reports` : `/jira/software/c/projects/${projectKey}/reports`;
    const cmpReportsUrl = (0, $4R6GH.fg)('reports-overview-page-migration') ? newCmpReportsUrl : `${tenantContext.baseUrl}/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    const reportsUrl = projectContext?.simplified ? `${tenantContext.baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports` : cmpReportsUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caivO.ViewDeploymentFrequencyReportExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, hasSoftwareLicense ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSpaAppsSoftwareReportsDeploymentFrequencyReport",
        teamName: "fusion-solaris",
        extraEventData: {
            isSimplifiedProject: projectContext?.simplified ?? false
        },
        onError: (location, error)=>{
            onViewDeploymentFrequencyReportExperienceFail(location, error, {
                isNetworkError: (0, $8Gk6V.isNetworkError)(error)
            });
        },
        attributes: (error)=>({
                isNetworkError: (0, $8Gk6V.isNetworkError)(error),
                isSimplifiedProject: projectContext?.simplified ?? false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKey,
        projectName: projectContext?.projectName ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $2O3HP.default).reports),
            href: reportsUrl
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fGFTb.PreconditionCheck), {
        projectKey: (0, $g5X3G.toProjectKey)(projectKey)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $2O3HP.default).browserTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $giP9y.default), null)))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caivO.ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker), {
        reason: "No Jira Software license"
    }))));
};
var $a41f1d4e1ad9317c$export$2e2bcd8739ae039 = $a41f1d4e1ad9317c$var$DeploymentFrequencyReportSpa;

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("giP9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21cee832c458e31$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZs4b = parcelRequire("jZs4b");

var $auW2i = parcelRequire("auW2i");

var $ilLj2 = parcelRequire("ilLj2");

var $l7in8 = parcelRequire("l7in8");

var $6UHF0 = parcelRequire("6UHF0");
const $e21cee832c458e31$var$DeploymentFrequencyReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZs4b.RelayMigrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ilLj2.ProjectIdProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auW2i.DeploymentProviderServiceQueryResultProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7in8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UHF0.default), null)))));
var $e21cee832c458e31$export$2e2bcd8739ae039 = $e21cee832c458e31$var$DeploymentFrequencyReport;

});
parcelRegister("jZs4b", function(module, exports) {

$parcel$export(module.exports, "RelayMigrationProvider", () => $93ac221a9aae18c4$export$234eaa9a198021f7);
$parcel$export(module.exports, "useQuery", () => $93ac221a9aae18c4$export$dd0a697e1782aedd);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $7Jxgt = parcelRequire("7Jxgt");

var $bGCOz = parcelRequire("bGCOz");

var $eWq1m = parcelRequire("eWq1m");

var $cXWJp = parcelRequire("cXWJp");

var $i4e0f = parcelRequire("i4e0f");
const $93ac221a9aae18c4$var$QueryRenderer = ({ id: id })=>{
    const [queryConfig] = (0, $cXWJp.useGetQueryById)(id);
    if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
    const { skip: skip } = queryConfig;
    if (skip) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4e0f.Suspense), {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGCOz.ErrorBoundary), {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWq1m.Query), {
        id: id
    })));
};
const $93ac221a9aae18c4$var$Queries = ()=>{
    const [queries] = (0, $cXWJp.useGetQueries)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, queries.map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$QueryRenderer, {
            key: id,
            id: id
        })));
};
// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
const $93ac221a9aae18c4$var$RelayMigrationContext = /*#__PURE__*/ (0, $5uXOq.createContext)();
const $93ac221a9aae18c4$export$234eaa9a198021f7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cXWJp.QueriesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$RelayMigrationContext.Provider, {
        value: true
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93ac221a9aae18c4$var$Queries, null)));
const $93ac221a9aae18c4$export$dd0a697e1782aedd = (query, options = {})=>{
    // Note: It's not safe to default variables to `{}`, as that doesn't
    // necessary match the variables type expected by the query
    const { skip: skip = false, variables: variables = {}, fetchPolicy: fetchPolicy } = options; // TODO: add support for errorPolicy, etc
    const isProviderInitialized = (0, $5uXOq.useContext)($93ac221a9aae18c4$var$RelayMigrationContext);
    if (isProviderInitialized !== true) throw new Error(`Look like you forgot to wrap package root component with 

            import { RelayMigrationProvider } from '@atlassian/jira-relay-apollo-migration-utils';

            <RelayMigrationProvider>
                <MyApp>
            </RelayMigrationProvider>`);
    const env = (0, $8Uumt.useRelayEnvironment)();
    const id = (0, $5uXOq.useRef)(`query-key-${(0, $7Jxgt.v4)()}`).current;
    const [queryConfig, { registerOrUpdateQuery: registerOrUpdateQuery, removeQuery: removeQuery, forceCacheRecheck: forceCacheRecheck }] = (0, $cXWJp.useGetQueryById)(id);
    const prevProps = (0, $5uXOq.useRef)();
    const refetch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newVariables' implicitly has an 'any' type.
    (newVariables)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const vars = newVariables || variables;
        // @ts-expect-error - TS2344 - Type 'Variables' is missing the following properties from type 'OperationType': variables, response
        const promise = (0, $8Uumt.fetchQuery)(env, query, vars, {
            fetchPolicy: 'network-only'
        }).toPromise();
        forceCacheRecheck({
            query: query,
            variables: vars
        });
        return promise;
    }, [
        env,
        query,
        variables,
        forceCacheRecheck
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // deepEqual check in case object reference changed but key/values are the same.
        // For example: variables
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps.current, {
            skip: skip,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy
        })) return;
        prevProps.current = {
            skip: skip,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy
        };
        registerOrUpdateQuery({
            id: id,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            skip: skip
        });
    }, [
        id,
        registerOrUpdateQuery,
        removeQuery,
        skip,
        query,
        variables,
        fetchPolicy
    ]);
    // cleap up query after useQuery unmount
    // @ts-expect-error - TS2322 - Type '() => void | Promise<void>' is not assignable to type 'void | Destructor'.
    (0, $5uXOq.useEffect)(()=>()=>removeQuery(id), [
        removeQuery,
        id
    ]);
    const result = queryConfig ? {
        ...queryConfig.result,
        refetch: refetch
    } : {
        loading: true,
        data: null,
        error: undefined,
        refetch: ()=>Promise.resolve()
    };
    // @ts-expect-error - TS2322 - Type '{ refetch: (newVariables: any) => Promise<TVariables["response"] | undefined>; data: unknown; error: Error | undefined; loading: boolean; } | { loading: boolean; data: null; error: undefined; refetch: () => Promise<...>; }' is not assignable to type 'QueryResult<TVariables, TData>'.
    return result;
};

});
parcelRegister("bGCOz", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ddcb6cd87ff4cf07$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $cXWJp = parcelRequire("cXWJp");
class $ddcb6cd87ff4cf07$var$RelayMigrationUtilsErrorBoundary extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps) {
        const { variables: variables, fetchKey: fetchKey } = this.props;
        const { variables: prevVariables, fetchKey: prevFetchKey } = prevProps;
        // reset error state and give a chance query to recover after variables/fetchKey change
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variables, prevVariables) || fetchKey !== prevFetchKey) this.setState({
            error: undefined
        });
    }
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError(error);
    }
    render() {
        const { error: error } = this.state;
        if (error) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $ddcb6cd87ff4cf07$export$e926676385687eaf = ({ id: id, children: children })=>{
    const [queryConfig, { setQueryError: setQueryError }] = (0, $cXWJp.useGetQueryById)(id);
    // this case is not possible, this check is here just to make flow happy
    if (!queryConfig) throw new Error(`Query config not found for id=${id}`);
    const { variables: variables, fetchKey: fetchKey } = queryConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddcb6cd87ff4cf07$var$RelayMigrationUtilsErrorBoundary, {
        variables: variables,
        fetchKey: fetchKey,
        onError: (error)=>setQueryError(id, error)
    }, children);
};

});
parcelRegister("cXWJp", function(module, exports) {

$parcel$export(module.exports, "useGetQueries", () => $ad1c5b05d6b542cb$export$d6811137951eda62);
$parcel$export(module.exports, "useGetQueryById", () => $ad1c5b05d6b542cb$export$6d96567132090f48);
$parcel$export(module.exports, "QueriesContainer", () => $ad1c5b05d6b542cb$export$ecb4f76d577c3dc5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dDxBh = parcelRequire("dDxBh");
const $ad1c5b05d6b542cb$var$storeId = 'RELAY_APOLLO_MIGRATION_STORE';
const $ad1c5b05d6b542cb$var$initialState = {
    queries: []
};
// @ts-expect-error - TS2322 - Type 'Store<{ readonly queries: readonly []; }, Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>>' is not assignable to type 'Store<State, Actions>'.
const $ad1c5b05d6b542cb$var$QueriesStore = (0, $iXqE5.createStore)({
    name: $ad1c5b05d6b542cb$var$storeId,
    initialState: $ad1c5b05d6b542cb$var$initialState,
    actions: // @ts-expect-error - TS2322 - Type '{ readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; readonly setQueryLoading: SetQueryLoadingAction; readonly setQueryError: SetQueryErrorAction; readonly removeQuery: RemoveQueryAction; readonly updateQuery: UpdateQueryAction; readonly forceCacheRecheck: ForceCa...' is not assignable to type 'Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>'.
    $dDxBh.actions
});
const $ad1c5b05d6b542cb$export$d6811137951eda62 = (0, $3sQ5x.createHook)($ad1c5b05d6b542cb$var$QueriesStore, {
    selector: (state)=>state.queries
});
const $ad1c5b05d6b542cb$export$6d96567132090f48 = (0, $3sQ5x.createHook)($ad1c5b05d6b542cb$var$QueriesStore, {
    selector: (state, id)=>state.queries.find((q)=>q.id === id)
});
const $ad1c5b05d6b542cb$export$ecb4f76d577c3dc5 = (0, $gg7kZ.createContainer)($ad1c5b05d6b542cb$var$QueriesStore);

});
parcelRegister("dDxBh", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8d50d363b184069d$export$e324594224ef24da);

var $ajpes = parcelRequire("ajpes");

var $7Jxgt = parcelRequire("7Jxgt");
const $8d50d363b184069d$export$4c8508db433a86f5 = (config)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const existingQueryConfig = state.queries.find((q)=>q.id === config.id);
        if (existingQueryConfig) setState({
            queries: state.queries.map((q)=>{
                if (q.id === config.id) return {
                    ...q,
                    ...config
                };
                return q;
            })
        });
        else setState({
            queries: state.queries.concat({
                ...config,
                fetchKey: config.id,
                result: {
                    data: null,
                    error: undefined,
                    loading: true
                }
            })
        });
    };
const $8d50d363b184069d$export$f58ce67e5a1edf5 = (id, data)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: false,
                        error: undefined,
                        data: data
                    }
                } : item)
        });
    };
const $8d50d363b184069d$export$636198fd10e804fd = (id)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: true,
                        error: undefined,
                        data: null
                    }
                } : item)
        });
    };
const $8d50d363b184069d$export$71ca895ec712e8ca = (id, error)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: false,
                        error: error,
                        data: null
                    }
                } : item)
        });
    };
const $8d50d363b184069d$export$d9584b9a625da95f = (id)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.filter((item)=>item.id !== id)
        });
    };
const $8d50d363b184069d$var$updateQuery = (id, props)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    ...props
                } : item)
        });
    };
const $8d50d363b184069d$var$forceCacheRecheck = ({ query: query, variables: variables })=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.query === query && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(item.variables, variables) ? {
                    ...item,
                    fetchKey: `query-key-${(0, $7Jxgt.v4)()}`
                } : item)
        });
    };
const $8d50d363b184069d$export$e324594224ef24da = {
    registerOrUpdateQuery: $8d50d363b184069d$export$4c8508db433a86f5,
    setQueryData: $8d50d363b184069d$export$f58ce67e5a1edf5,
    setQueryLoading: $8d50d363b184069d$export$636198fd10e804fd,
    setQueryError: $8d50d363b184069d$export$71ca895ec712e8ca,
    removeQuery: $8d50d363b184069d$export$d9584b9a625da95f,
    updateQuery: $8d50d363b184069d$var$updateQuery,
    forceCacheRecheck: $8d50d363b184069d$var$forceCacheRecheck
};

});



parcelRegister("eWq1m", function(module, exports) {

$parcel$export(module.exports, "Query", () => $0336126d6c7b21af$export$62297b13309008b2);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cXWJp = parcelRequire("cXWJp");
const $0336126d6c7b21af$export$62297b13309008b2 = ({ id: id })=>{
    const [queryConfig, { setQueryData: setQueryData }] = (0, $cXWJp.useGetQueryById)(id);
    if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
    const { query: query, variables: variables, fetchKey: fetchKey, fetchPolicy: fetchPolicy } = queryConfig;
    /* eslint-disable @atlassian/relay/generated-typescript-types */ /* eslint-disable @atlassian/relay/query-restriction */ const data = (0, $8Uumt.useLazyLoadQuery)(query, variables, {
        fetchKey: fetchKey,
        fetchPolicy: fetchPolicy
    });
    /* eslint-enable @atlassian/relay/generated-typescript-types */ /* eslint-enable @atlassian/relay/query-restriction */ (0, $5uXOq.useEffect)(()=>{
        setQueryData(id, data);
    }, [
        id,
        data,
        setQueryData
    ]);
    return null;
};

});

parcelRegister("i4e0f", function(module, exports) {

$parcel$export(module.exports, "Suspense", () => $b12830c4bd104661$export$74bf444e3cd11ea5);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $cXWJp = parcelRequire("cXWJp");
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
const $b12830c4bd104661$var$PlaceholderFallback = ({ id: id })=>{
    const [, { setQueryLoading: setQueryLoading }] = (0, $cXWJp.useGetQueryById)(id);
    (0, $5uXOq.useEffect)(()=>{
        setQueryLoading(id);
    }, [
        id,
        setQueryLoading
    ]);
    return null;
};
const $b12830c4bd104661$export$74bf444e3cd11ea5 = ({ id: id, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "query-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b12830c4bd104661$var$PlaceholderFallback, {
            id: id
        })
    }, children);

});


parcelRegister("auW2i", function(module, exports) {

$parcel$export(module.exports, "DeploymentProviderServiceQueryResultProvider", () => $3212eaa12d9cc8e3$export$9bd326d4dbb7068d);
$parcel$export(module.exports, "useDeploymentProviders", () => $3212eaa12d9cc8e3$export$29125d17c01d4dd4);

var $5uXOq = parcelRequire("5uXOq");

var $fMtXj = parcelRequire("fMtXj");
const $3212eaa12d9cc8e3$var$DeploymentProviderContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $3212eaa12d9cc8e3$export$9bd326d4dbb7068d = ({ children: children })=>{
    const deploymentProvidersResult = (0, $fMtXj.useDeploymentProviders)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3212eaa12d9cc8e3$var$DeploymentProviderContext.Provider, {
        value: deploymentProvidersResult
    }, children);
};
const $3212eaa12d9cc8e3$export$29125d17c01d4dd4 = ()=>{
    const result = (0, $5uXOq.useContext)($3212eaa12d9cc8e3$var$DeploymentProviderContext);
    if (result === null) throw new Error('Missing DeploymentProviderContext');
    return result;
};

});
parcelRegister("fMtXj", function(module, exports) {

$parcel$export(module.exports, "useDeploymentProviders", () => $6ce04b9aa6eb61a7$export$29125d17c01d4dd4);
$parcel$export(module.exports, "DeploymentProvidersInfoProvider", () => $6ce04b9aa6eb61a7$export$a516226a9640cf25);
$parcel$export(module.exports, "useDeploymentProvidersInfoContext", () => $6ce04b9aa6eb61a7$export$6251344ce2dc3a61);
$parcel$export(module.exports, "useVCSProviders", () => $6ce04b9aa6eb61a7$export$29eeae32fa3976ef);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $7f4tk = parcelRequire("7f4tk");

var $fPB66 = parcelRequire("fPB66");
const $6ce04b9aa6eb61a7$export$67c00945e310134c = ()=>{
    const baseUrl = '';
    const request = (0, $5uXOq.useCallback)(()=>(0, $7f4tk.default)(`${baseUrl}/rest/dev-status/1.0/provider/capabilities`), [
        baseUrl
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch
    };
};
const $6ce04b9aa6eb61a7$var$useMemoByProviderId = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    if (ref.current.length !== value.length || !ref.current.every((x, i)=>x.providerId === value[i].providerId)) ref.current = value;
    return ref.current;
};
const $6ce04b9aa6eb61a7$export$20e408ba77735d66 = (devOpsProviders)=>{
    const isBitbucketConnectedToJira = devOpsProviders.some((0, $fPB66.isBitbucketSCMProvider));
    const isBitbucketPipelineFound = devOpsProviders.some((0, $fPB66.isBitbucketPipelineProvider));
    // All tenants should have the bitbucket pipeline provider. Only return it if they have the "bitbucket" provider - indicating they have set up the bitbucket integration
    if (!isBitbucketConnectedToJira && isBitbucketPipelineFound) return devOpsProviders.filter((x)=>!(0, $fPB66.isBitbucketProvider)(x));
    return devOpsProviders;
};
const $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders = (devOpsProviderResult)=>{
    const data = devOpsProviderResult.data ? $6ce04b9aa6eb61a7$export$20e408ba77735d66(devOpsProviderResult.data).filter((x)=>x.capabilities.includes('DEPLOYMENT')) : [];
    return $6ce04b9aa6eb61a7$var$useMemoByProviderId(data);
};
const $6ce04b9aa6eb61a7$export$29125d17c01d4dd4 = ()=>{
    const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
    const memoizedProviders = $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders(devOpsProviderResult);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: memoizedProviders
    } : devOpsProviderResult;
};
const $6ce04b9aa6eb61a7$export$f96e97389b7d3d58 = ()=>{
    const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
    const memoizedProviders = $6ce04b9aa6eb61a7$var$useMemoizedDeploymentProviders(devOpsProviderResult);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: {
            deploymentProviders: memoizedProviders,
            isBitbucketDvcsConnectedToJira: devOpsProviderResult.data.some((0, $fPB66.isBitbucketSCMProvider))
        }
    } : {
        ...devOpsProviderResult,
        data: undefined
    };
};
const $6ce04b9aa6eb61a7$export$77e6c6311405f4e8 = /*#__PURE__*/ (0, $5uXOq.createContext)();
const $6ce04b9aa6eb61a7$export$a516226a9640cf25 = ({ children: children })=>{
    const deploymentProvidersState = $6ce04b9aa6eb61a7$export$f96e97389b7d3d58();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ce04b9aa6eb61a7$export$77e6c6311405f4e8.Provider, {
        value: deploymentProvidersState
    }, children);
};
const $6ce04b9aa6eb61a7$export$6251344ce2dc3a61 = ()=>{
    const result = (0, $5uXOq.useContext)($6ce04b9aa6eb61a7$export$77e6c6311405f4e8);
    if (result === undefined) throw new Error('Missing service provider');
    return result;
};
const $6ce04b9aa6eb61a7$export$29eeae32fa3976ef = ()=>{
    const devOpsProviderResult = $6ce04b9aa6eb61a7$export$67c00945e310134c();
    const data = devOpsProviderResult.data ? devOpsProviderResult.data.filter((x)=>x.capabilities.includes('COMMIT')) : [];
    const memoizedData = $6ce04b9aa6eb61a7$var$useMemoByProviderId(data);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: memoizedData
    } : devOpsProviderResult;
};

});
parcelRegister("fPB66", function(module, exports) {

$parcel$export(module.exports, "isBitbucketPipelineProvider", () => $9d57478229acd603$export$e945008be2be190e);
$parcel$export(module.exports, "isBitbucketSCMProvider", () => $9d57478229acd603$export$43d8b667cc725f05);
$parcel$export(module.exports, "isBitbucketProvider", () => $9d57478229acd603$export$1f508885be28c4e);
$parcel$export(module.exports, "hideUGCProviderName", () => $9d57478229acd603$export$6159c89b7d198212);

const $9d57478229acd603$export$e945008be2be190e = (provider)=>provider.providerId === (0, $40fb154f860edb01$export$832d1d859726f915) || provider.providerId === (0, $40fb154f860edb01$export$5007979ef33118fc);
const $9d57478229acd603$export$43d8b667cc725f05 = (provider)=>provider.providerId === (0, $40fb154f860edb01$export$d7f081d6dd0e72fc);
const $9d57478229acd603$export$4deeacd9e5868b0b = (provider)=>{
    if (provider.iconUrl !== undefined && provider.iconUrl !== '' && provider.iconUrl.toLowerCase().includes('jenkins')) return true;
    if (provider.name.toLowerCase().includes('jenkins')) return true;
    return false;
};
const $9d57478229acd603$export$1f508885be28c4e = (provider)=>$9d57478229acd603$export$43d8b667cc725f05(provider) || $9d57478229acd603$export$e945008be2be190e(provider);
const $9d57478229acd603$export$b77d18aa396395e0 = (provider)=>provider.providerNamespace === 'oauth';
const $9d57478229acd603$export$6159c89b7d198212 = (providers)=>providers.map((provider)=>$9d57478229acd603$export$b77d18aa396395e0(provider) ? {
            ...provider,
            name: 'UGC provider name hidden'
        } : provider);

});
const $40fb154f860edb01$export$d7f081d6dd0e72fc = 'bitbucket';
const $40fb154f860edb01$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $40fb154f860edb01$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';




parcelRegister("ilLj2", function(module, exports) {

$parcel$export(module.exports, "ProjectIdProvider", () => $f5450870e2107699$export$681f6276e993f4e8);
$parcel$export(module.exports, "useProjectId", () => $f5450870e2107699$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectSimplified", () => $f5450870e2107699$export$9f0c70b531288073);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $f5450870e2107699$export$b6a91b2d78273787);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $g5X3G = parcelRequire("g5X3G");

var $bmKPg = parcelRequire("bmKPg");
const $f5450870e2107699$export$f87be37f8e8be65 = ()=>{
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $g5X3G.toProjectKey)(projectKey);
};
const $f5450870e2107699$var$ProjectIdContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $f5450870e2107699$export$681f6276e993f4e8 = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectId = data === null ? null : (0, $g5X3G.toProjectId)(`${data.projectId}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f5450870e2107699$var$ProjectIdContext.Provider, {
        value: projectId
    }, projectId === null ? null : children);
};
const $f5450870e2107699$export$16d1475ed6c26568 = ()=>{
    const projectId = (0, $5uXOq.useContext)($f5450870e2107699$var$ProjectIdContext);
    if (projectId === null) throw new Error('Project ID provider missing');
    return projectId;
};
const $f5450870e2107699$export$4d975d76445a6650 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    if (data === null) return null;
    const { isProjectAdmin: isProjectAdmin } = data;
    return isProjectAdmin === undefined ? null : isProjectAdmin;
};
const $f5450870e2107699$export$9f0c70b531288073 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return data === null ? null : data.simplified;
};
const $f5450870e2107699$export$b6a91b2d78273787 = ()=>{
    const projectId = $f5450870e2107699$export$16d1475ed6c26568();
    const isProjectAdmin = $f5450870e2107699$export$4d975d76445a6650();
    const isProjectSimplified = $f5450870e2107699$export$9f0c70b531288073();
    if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
    return {
        isSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});

parcelRegister("l7in8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbde8377ad119f06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3Ws3s = parcelRequire("3Ws3s");

var $claG0 = parcelRequire("claG0");

var $ilLj2 = parcelRequire("ilLj2");
// This component is not part of DeploymentFrequencyDataAnalyticsWrapper since it needs access to the ContextualAnalyticsData
const $dbde8377ad119f06$var$DeploymentFrequencyDataAnalytics = ()=>{
    const { data: data, loading: loading } = (0, $3Ws3s.useReportCoreData)();
    const hasFiredRef = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (hasFiredRef.current) return;
        if (!loading && data) {
            const attributes = {
                hasSufficientData: !(0, $claG0.isDataAbsolutelyEmpty)(data),
                hasDeploymentProvider: data.hasDeploymentProvider
            };
            (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), attributes);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'report viewed', 'deploymentFrequency', attributes);
            hasFiredRef.current = true;
        }
    }, [
        createAnalyticsEvent,
        data,
        loading
    ]);
    return null;
};
const $dbde8377ad119f06$var$DeploymentFrequencyDataAnalyticsWrapper = ({ children: children })=>{
    const projectInfo = (0, $ilLj2.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "deploymentFrequencyReportPage",
        attributes: {
            ...projectInfo
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbde8377ad119f06$var$DeploymentFrequencyDataAnalytics, null), children);
};
var $dbde8377ad119f06$export$2e2bcd8739ae039 = $dbde8377ad119f06$var$DeploymentFrequencyDataAnalyticsWrapper;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3Ws3s", function(module, exports) {

$parcel$export(module.exports, "useReportCoreData", () => $9b970ddda9736e13$export$446065eeb0323d4c);

var $26qIQ = parcelRequire("26qIQ");

var $jZs4b = parcelRequire("jZs4b");

var $koeKL = parcelRequire("koeKL");

var $kBSee = parcelRequire("kBSee");

var $auW2i = parcelRequire("auW2i");

var $ilLj2 = parcelRequire("ilLj2");

var $claG0 = parcelRequire("claG0");
const $9b970ddda9736e13$export$446065eeb0323d4c = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectId = (0, $ilLj2.useProjectId)();
    const deploymentProvidersResult = (0, $auW2i.useDeploymentProviders)();
    const variables = (0, $claG0.buildQueryVariables)(cloudId, projectId, (0, $kBSee.calculateDateRangeFor12Weeks)((0, $kBSee.getCurrentDate)()));
    const queryResult = (0, $jZs4b.useQuery)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $26qIQ.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        variables: {
            ...variables
        },
        // @ts-expect-error - TS2345 - Argument of type '{ variables: { deploymentFrequencyRollupType: DevOpsMetricsRollupType; deploymentSizeRollupType: DevOpsMetricsRollupType; filter: DevOpsMetricsFilterInput; }; errorPolicy: string; }' is not assignable to parameter of type '{ variables?: deploymentFrequencyCoreRelayQuery$variables | undefined; skip?: boolean | undefined; fetchPolicy?: FetchPolicy | undefined; }'.
        errorPolicy: 'all'
    });
    return (0, $claG0.mergeResult)((0, $claG0.transformResult)(queryResult), deploymentProvidersResult);
};

});
parcelRegister("26qIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa8d5cd38990dbab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9e8c4729992a32310f4787dfbf095d9>>
 * @relayHash 181e900ed9b184b727eacc0e8e01751a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d022230a6ccb1bba619a35fbd2eaf7a54075e73cab018187129e8a9f21a7060
const $fa8d5cd38990dbab$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "deploymentFrequencyRollupType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "deploymentSizeRollupType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v4 = {
        "kind": "Variable",
        "name": "rollupType",
        "variableName": "deploymentFrequencyRollupType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v6 = {
        "concreteType": "DevOpsMetricsDeploymentFrequencyData",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "alias": "deploymentFrequencyDev",
        "args": [
            {
                "kind": "Literal",
                "name": "environmentCategory",
                "value": "DEVELOPMENT"
            },
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ],
        "concreteType": "DevOpsMetricsDeploymentFrequency",
        "kind": "LinkedField",
        "name": "deploymentFrequency",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "alias": "deploymentFrequencyTesting",
        "args": [
            {
                "kind": "Literal",
                "name": "environmentCategory",
                "value": "TESTING"
            },
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ],
        "concreteType": "DevOpsMetricsDeploymentFrequency",
        "kind": "LinkedField",
        "name": "deploymentFrequency",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "alias": "deploymentFrequencyStg",
        "args": [
            {
                "kind": "Literal",
                "name": "environmentCategory",
                "value": "STAGING"
            },
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ],
        "concreteType": "DevOpsMetricsDeploymentFrequency",
        "kind": "LinkedField",
        "name": "deploymentFrequency",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "Literal",
        "name": "environmentCategory",
        "value": "PRODUCTION"
    }, v12 = {
        "kind": "ScalarField",
        "name": "aggregateData"
    }, v13 = {
        "alias": "deploymentFrequencyProd",
        "args": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ],
        "concreteType": "DevOpsMetricsDeploymentFrequency",
        "kind": "LinkedField",
        "name": "deploymentFrequency",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = {
        "alias": "deploymentFrequencyUnmapped",
        "args": [
            {
                "kind": "Literal",
                "name": "environmentCategory",
                "value": "UNMAPPED"
            },
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ],
        "concreteType": "DevOpsMetricsDeploymentFrequency",
        "kind": "LinkedField",
        "name": "deploymentFrequency",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v15 = {
        "alias": "deploymentSizeProd",
        "args": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "rollupType",
                "variableName": "deploymentSizeRollupType"
            }
        ],
        "concreteType": "DevOpsMetricsDeploymentSize",
        "kind": "LinkedField",
        "name": "deploymentSize",
        "plural": false,
        "selections": [
            {
                "concreteType": "DevOpsMetricsDeploymentSizeData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "deploymentSize"
                    }
                ]
            },
            v12 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "deploymentFrequencyCoreRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOpsMetrics",
                        "kind": "LinkedField",
                        "name": "devOpsMetrics",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v8 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentFrequencyDev"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v9 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentFrequencyTesting"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v10 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentFrequencyStg"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v13 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentFrequencyProd"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v14 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentFrequencyUnmapped"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v15 /*: any*/ ,
                                "action": "THROW",
                                "path": "devOpsMetrics.deploymentSizeProd"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOpsMetrics"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "deploymentFrequencyCoreRelayQuery",
            "selections": [
                {
                    "concreteType": "DevOpsMetrics",
                    "kind": "LinkedField",
                    "name": "devOpsMetrics",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4d022230a6ccb1bba619a35fbd2eaf7a54075e73cab018187129e8a9f21a7060",
            "metadata": {},
            "name": "deploymentFrequencyCoreRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa8d5cd38990dbab$var$node.hash = "420efc85afb618301c4c9a412536d149";
var $fa8d5cd38990dbab$export$2e2bcd8739ae039 = $fa8d5cd38990dbab$var$node;

});

parcelRegister("kBSee", function(module, exports) {

$parcel$export(module.exports, "getCurrentDate", () => $2dda53ea2598d8a8$export$adaf307e533580e2);
$parcel$export(module.exports, "calculateDateRangeFor12Weeks", () => $2dda53ea2598d8a8$export$319acc87c1d29925);
$parcel$export(module.exports, "getWeekRangeFromWeekStartDate", () => $2dda53ea2598d8a8$export$9838cd554c042ac9);

var $16v6W = parcelRequire("16v6W");

var $it1wb = parcelRequire("it1wb");

var $1GF3c = parcelRequire("1GF3c");

var $4PxOH = parcelRequire("4PxOH");
const $2dda53ea2598d8a8$export$c8fd889aef2b0b63 = (dateRange1, dateRange2)=>dateRange1.startDateInclusive.getTime() === dateRange2.startDateInclusive.getTime() && dateRange1.endDateExclusive.getTime() === dateRange2.endDateExclusive.getTime();
const $2dda53ea2598d8a8$export$9be2719b3e491366 = (obj)=>({
        startDateInclusive: obj.startDateInclusive,
        endDateExclusive: obj.endDateExclusive
    });
const $2dda53ea2598d8a8$export$adaf307e533580e2 = ()=>new Date();
const $2dda53ea2598d8a8$export$319acc87c1d29925 = (date)=>{
    const thisWeekStart = (0, $it1wb.default)((0, $1GF3c.default)(date, {
        weekStartsOn: 1
    }));
    const elevenWeeksAgo = (0, $it1wb.default)((0, $4PxOH.default)(thisWeekStart, 11));
    return {
        startDateInclusive: elevenWeeksAgo,
        endDateExclusive: (0, $16v6W.default)(elevenWeeksAgo, 12)
    };
};
const $2dda53ea2598d8a8$export$9838cd554c042ac9 = (weekStartDate)=>({
        startDateInclusive: weekStartDate,
        endDateExclusive: (0, $16v6W.default)(weekStartDate, 1)
    });

});

parcelRegister("claG0", function(module, exports) {

$parcel$export(module.exports, "isProdDataEmpty", () => $fa671eb55a55e204$export$266eb13541cd3eab);
$parcel$export(module.exports, "isDevelopmentDataEmpty", () => $fa671eb55a55e204$export$b88cee3a59d3a9c9);
$parcel$export(module.exports, "isTestingDataEmpty", () => $fa671eb55a55e204$export$58fe9f6a33beae3d);
$parcel$export(module.exports, "isStagingDataEmpty", () => $fa671eb55a55e204$export$fa52222c4dc654e5);
$parcel$export(module.exports, "isUnmappedDataEmpty", () => $fa671eb55a55e204$export$e62c68dd54f311bc);
$parcel$export(module.exports, "isDataAbsolutelyEmpty", () => $fa671eb55a55e204$export$c5f9ba67a5398ea);
$parcel$export(module.exports, "isDataAllUnmapped", () => $fa671eb55a55e204$export$5b3a91170be2499e);
$parcel$export(module.exports, "isDataUnmappedFoundWithMissingPreProdButWithProd", () => $fa671eb55a55e204$export$87ccc9f0ac24397f);
$parcel$export(module.exports, "isDataUnmappedFoundWithMissingProd", () => $fa671eb55a55e204$export$e4bdaf3ee11b5671);
$parcel$export(module.exports, "getProdDataState", () => $fa671eb55a55e204$export$24ea9186e4611e22);
$parcel$export(module.exports, "buildQueryVariables", () => $fa671eb55a55e204$export$9a3cee82e7cc08ff);
$parcel$export(module.exports, "transformResult", () => $fa671eb55a55e204$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "mergeResult", () => $fa671eb55a55e204$export$5fc0e802d3b9fa36);

var $iASWI = parcelRequire("iASWI");

var $gamDR = parcelRequire("gamDR");

var $ecd0S = parcelRequire("ecd0S");

var $hEs3t = parcelRequire("hEs3t");

var $hfmv8 = parcelRequire("hfmv8");
const $fa671eb55a55e204$export$266eb13541cd3eab = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.prod === 0);
const $fa671eb55a55e204$export$b88cee3a59d3a9c9 = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0);
const $fa671eb55a55e204$export$58fe9f6a33beae3d = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.testing === 0);
const $fa671eb55a55e204$export$fa52222c4dc654e5 = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.staging === 0);
const $fa671eb55a55e204$export$e62c68dd54f311bc = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.unmapped === 0);
const $fa671eb55a55e204$export$c5f9ba67a5398ea = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0 && weekData.deploymentCount.testing === 0 && weekData.deploymentCount.staging === 0 && weekData.deploymentCount.prod === 0 && weekData.deploymentCount.unmapped === 0 && weekData.medianIssuesPerDeployment.prod === null);
const $fa671eb55a55e204$export$48ed69e2270961d9 = (data)=>data.weeksData.filter((weekData)=>weekData.deploymentCount.prod > 0).length <= 3;
const $fa671eb55a55e204$export$5b3a91170be2499e = (data)=>data.weeksData.every((weekData)=>weekData.deploymentCount.development === 0 && weekData.deploymentCount.testing === 0 && weekData.deploymentCount.staging === 0 && weekData.deploymentCount.prod === 0 && weekData.medianIssuesPerDeployment.prod === 0) && data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0);
const $fa671eb55a55e204$export$87ccc9f0ac24397f = (data)=>data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0) && ($fa671eb55a55e204$export$b88cee3a59d3a9c9(data) || $fa671eb55a55e204$export$58fe9f6a33beae3d(data) || $fa671eb55a55e204$export$fa52222c4dc654e5(data)) && !$fa671eb55a55e204$export$266eb13541cd3eab(data);
const $fa671eb55a55e204$export$e4bdaf3ee11b5671 = (data)=>data.weeksData.some((weekData)=>weekData.deploymentCount.unmapped > 0) && $fa671eb55a55e204$export$266eb13541cd3eab(data);
const $fa671eb55a55e204$export$24ea9186e4611e22 = (data)=>{
    if ($fa671eb55a55e204$export$c5f9ba67a5398ea(data)) return 'COMPLETELY_EMPTY';
    if ($fa671eb55a55e204$export$266eb13541cd3eab(data)) return 'NO_PROD_BUT_OTHER_ENV';
    if ($fa671eb55a55e204$export$48ed69e2270961d9(data)) return 'INSUFFICIENT_FOR_TREND';
    return 'SUFFICIENT_FOR_TREND';
};
const $fa671eb55a55e204$export$9a3cee82e7cc08ff = (cloudId, projectId, dateRange)=>{
    const { startDateInclusive: startDateInclusive, endDateExclusive: endDateExclusive } = dateRange;
    return {
        filter: {
            cloudId: cloudId,
            startFromInclusive: startDateInclusive.toISOString(),
            endAtExclusive: endDateExclusive.toISOString(),
            timezoneId: (0, $hfmv8.getUserTimezone)(),
            resolution: {
                unit: 'WEEK',
                value: 1
            },
            jiraProjectIds: [
                projectId
            ]
        },
        deploymentFrequencyRollupType: {
            type: 'MEAN'
        },
        deploymentSizeRollupType: {
            type: 'PERCENTILE',
            percentile: 50
        }
    };
};
const $fa671eb55a55e204$var$getQueryErrorMessageIfExist = (error)=>error ? ` QueryErrorMessage: ${error.message}` : '';
const $fa671eb55a55e204$var$getValidatedData = (queryResult)=>{
    const deploymentFrequencyDevData = queryResult.data?.devOpsMetrics?.deploymentFrequencyDev?.data;
    const deploymentFrequencyTestingData = queryResult.data?.devOpsMetrics?.deploymentFrequencyTesting?.data;
    const deploymentFrequencyStgData = queryResult.data?.devOpsMetrics?.deploymentFrequencyStg?.data;
    const deploymentFrequencyProdData = queryResult.data?.devOpsMetrics?.deploymentFrequencyProd?.data;
    const deploymentFrequencyProdAverage = queryResult.data?.devOpsMetrics?.deploymentFrequencyProd?.aggregateData;
    const deploymentFrequencyUnmappedData = queryResult.data?.devOpsMetrics?.deploymentFrequencyUnmapped?.data;
    const deploymentSizeProdData = queryResult.data?.devOpsMetrics?.deploymentSizeProd?.data;
    const deploymentSizeProdMedian = queryResult.data?.devOpsMetrics?.deploymentSizeProd?.aggregateData;
    const { error: apolloError } = queryResult;
    const apolloErrorMessage = $fa671eb55a55e204$var$getQueryErrorMessageIfExist(apolloError);
    if (deploymentFrequencyDevData == null || deploymentFrequencyTestingData == null || deploymentFrequencyStgData == null || deploymentFrequencyProdData == null || deploymentFrequencyProdAverage == null || deploymentFrequencyUnmappedData == null || deploymentSizeProdData == null || deploymentSizeProdMedian === undefined) throw Error(`Deployment frequency report: queryResult has missing fields. ${apolloErrorMessage}. Stringified queryResult: ${JSON.stringify({
        deploymentFrequencyDevData: deploymentFrequencyDevData,
        deploymentFrequencyTestingData: deploymentFrequencyTestingData,
        deploymentFrequencyStgData: deploymentFrequencyStgData,
        deploymentFrequencyProdData: deploymentFrequencyProdData,
        deploymentFrequencyProdAverage: deploymentFrequencyProdAverage,
        deploymentFrequencyUnmappedData: deploymentFrequencyUnmappedData,
        deploymentSizeProdData: deploymentSizeProdData,
        deploymentSizeProdMedian: deploymentSizeProdMedian
    })}`);
    return {
        // @ts-expect-error - TS2322 - Type '{ frequencyDevData: { count: number | null; dateTime: any; }; frequencyTestingData: { count: number | null; dateTime: any; }; frequencyStgData: { count: number | null; dateTime: any; }; frequencyProdData: { ...; }; frequencyUnmappedData: { ...; }; sizeProdData: { ...; }; }[]' is not assignable to type 'FrequencySizeData[]'.
        data: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))((0, $ecd0S.WEEKS_IN_REPORT)).map((i)=>{
            if (deploymentFrequencyDevData?.[i]?.count == null || deploymentFrequencyDevData?.[i]?.dateTime == null || deploymentFrequencyTestingData?.[i]?.count == null || deploymentFrequencyTestingData?.[i]?.dateTime == null || deploymentFrequencyStgData?.[i]?.count == null || deploymentFrequencyStgData?.[i]?.dateTime == null || deploymentFrequencyProdData?.[i]?.count == null || deploymentFrequencyProdData?.[i]?.dateTime == null || deploymentFrequencyUnmappedData?.[i]?.count == null || deploymentFrequencyUnmappedData?.[i]?.dateTime == null || deploymentSizeProdData?.[i]?.deploymentSize === undefined || deploymentSizeProdData?.[i]?.dateTime == null) throw new Error(`Deployment frequency report: some data is missing. ${apolloErrorMessage}. Stringified data: ${JSON.stringify({
                frequencyDevData: deploymentFrequencyDevData[i],
                frequencyTestingData: deploymentFrequencyTestingData[i],
                frequencyStgData: deploymentFrequencyStgData[i],
                frequencyProdData: deploymentFrequencyProdData[i],
                frequencyUnmappedData: deploymentFrequencyUnmappedData[i],
                sizeProdData: deploymentSizeProdData[i]
            })}`);
            return {
                frequencyDevData: {
                    count: deploymentFrequencyDevData?.[i]?.count,
                    dateTime: deploymentFrequencyDevData?.[i]?.dateTime
                },
                frequencyTestingData: {
                    count: deploymentFrequencyTestingData?.[i]?.count,
                    dateTime: deploymentFrequencyTestingData?.[i]?.dateTime
                },
                frequencyStgData: {
                    count: deploymentFrequencyStgData?.[i]?.count,
                    dateTime: deploymentFrequencyStgData?.[i]?.dateTime
                },
                frequencyProdData: {
                    count: deploymentFrequencyProdData?.[i]?.count,
                    dateTime: deploymentFrequencyProdData?.[i]?.dateTime
                },
                frequencyUnmappedData: {
                    count: deploymentFrequencyUnmappedData?.[i]?.count,
                    dateTime: deploymentFrequencyUnmappedData?.[i]?.dateTime
                },
                sizeProdData: {
                    deploymentSize: deploymentSizeProdData?.[i]?.deploymentSize,
                    dateTime: deploymentSizeProdData?.[i]?.dateTime
                }
            };
        }),
        frequencyProdAverage: deploymentFrequencyProdAverage,
        sizeProdMedian: deploymentSizeProdMedian
    };
};
const $fa671eb55a55e204$export$f13b29f9ed0c5a03 = (queryResult)=>{
    const resultBase = {
        loading: queryResult.loading,
        error: queryResult.error,
        fetch: queryResult.refetch
    };
    if (queryResult.loading) return resultBase;
    try {
        const { data: data, frequencyProdAverage: frequencyProdAverage, sizeProdMedian: sizeProdMedian } = $fa671eb55a55e204$var$getValidatedData(queryResult);
        return {
            ...resultBase,
            data: {
                averageDeploymentCount: (0, (/*@__PURE__*/$parcel$interopDefault($gamDR)))(frequencyProdAverage, 1),
                medianIssuesPerDeployment: sizeProdMedian === null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($gamDR)))(sizeProdMedian, 1),
                weeksData: data.map(({ frequencyDevData: frequencyDevData, frequencyTestingData: frequencyTestingData, frequencyStgData: frequencyStgData, frequencyProdData: frequencyProdData, frequencyUnmappedData: frequencyUnmappedData, sizeProdData: sizeProdData })=>({
                        startDateInclusive: new Date(frequencyDevData.dateTime),
                        deploymentCount: {
                            development: frequencyDevData.count,
                            testing: frequencyTestingData.count,
                            staging: frequencyStgData.count,
                            prod: frequencyProdData.count,
                            unmapped: frequencyUnmappedData.count
                        },
                        medianIssuesPerDeployment: {
                            prod: sizeProdData.deploymentSize
                        }
                    }))
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            ...resultBase,
            error: (0, $hEs3t.getMaybeCombinedError)([
                queryResult.error,
                error
            ])
        };
    }
};
const $fa671eb55a55e204$export$5fc0e802d3b9fa36 = ({ data: reportData, loading: reportLoading, error: reportError, fetch: reportFetch }, { data: providerData, loading: providerLoading, error: providerError, fetch: providerFetch })=>{
    const loading = reportLoading || providerLoading;
    const error = (0, $hEs3t.getMaybeCombinedError)([
        reportError,
        providerError
    ]);
    const fetch = async ()=>{
        if (reportError && reportData == null) reportFetch();
        if (providerError && providerData == null) providerFetch();
    };
    const data = providerData && reportData ? {
        ...reportData,
        hasDeploymentProvider: providerData.length > 0
    } : undefined;
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch
    };
};

});
parcelRegister("gamDR", function(module, exports) {

var $aza9E = parcelRequire("aza9E");
/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $bc4f24b4027c5e7d$var$round = $aza9E('round');
module.exports = $bc4f24b4027c5e7d$var$round;

});
parcelRegister("aza9E", function(module, exports) {

var $1V15E = parcelRequire("1V15E");

var $kPZpS = parcelRequire("kPZpS");

var $1sXeC = parcelRequire("1sXeC");

var $jJVtR = parcelRequire("jJVtR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $7b150cc928607d87$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $1sXeC(number);
        precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
        if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($jJVtR(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $7b150cc928607d87$var$createRound;

});


parcelRegister("ecd0S", function(module, exports) {

$parcel$export(module.exports, "WEEKS_IN_REPORT", () => $baa9a527b86d4579$export$93be8d2f61c0fe4b);
$parcel$export(module.exports, "DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED", () => $baa9a527b86d4579$export$3ae97b4999104334);
$parcel$export(module.exports, "DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED", () => $baa9a527b86d4579$export$2784a2e49249b82e);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_ID", () => $baa9a527b86d4579$export$7b8e0bca5a218b);

var $gwIPs = parcelRequire("gwIPs");
const $baa9a527b86d4579$export$93be8d2f61c0fe4b = 12;
const $baa9a527b86d4579$export$3ae97b4999104334 = 'https://support.atlassian.com/jira-software-cloud/docs/plan-effectively-with-your-deployment-frequency-report';
const $baa9a527b86d4579$export$2784a2e49249b82e = 'https://support.atlassian.com/jira-software-cloud/docs/view-and-understand-your-deployment-frequency-report';
const $baa9a527b86d4579$export$7b8e0bca5a218b = '6DubDW8hmIQv9hwhu2cMQU';
const $baa9a527b86d4579$export$1c17101eae0d04af = (0, $gwIPs.gridSize) * 28;
const $baa9a527b86d4579$export$26c4fbba49422cc3 = (0, $gwIPs.gridSize) * 5;
const $baa9a527b86d4579$export$41ffe6e6fada2471 = (0, $gwIPs.gridSize) * 4;

});

parcelRegister("hEs3t", function(module, exports) {

$parcel$export(module.exports, "getMaybeCombinedError", () => $6fe769d4d58dfef3$export$b0ef34dfd385a8a7);
const $6fe769d4d58dfef3$export$b0ef34dfd385a8a7 = (errors)=>{
    let firstErrorDetected = false;
    const combinedErrorMessages = errors.reduce((acc, maybeError)=>{
        if (maybeError == null) return acc;
        const accumulatedMessage = `${acc}${firstErrorDetected ? ', ' : ''}Error: ${maybeError.message}`;
        firstErrorDetected = true;
        return accumulatedMessage;
    }, '');
    if (!firstErrorDetected) return undefined;
    return new Error(combinedErrorMessages);
};

});

parcelRegister("hfmv8", function(module, exports) {

$parcel$export(module.exports, "getUserTimezone", () => $e720a860c461686c$export$96bb40b6f4974acf);
// USER_TIME_ZONE is undefined only in IE11
const $e720a860c461686c$var$USER_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone !== 'Etc/Unknown' ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
const $e720a860c461686c$export$96bb40b6f4974acf = ()=>$e720a860c461686c$var$USER_TIME_ZONE;

});




parcelRegister("6UHF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0241365af9a98913$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3HwlS = parcelRequire("3HwlS");

var $j1sSt = parcelRequire("j1sSt");

var $3Ws3s = parcelRequire("3Ws3s");

var $iY22e = parcelRequire("iY22e");

var $gxsp4 = parcelRequire("gxsp4");

var $6vgP1 = parcelRequire("6vgP1");

var $lVXtL = parcelRequire("lVXtL");

var $ufiFS = parcelRequire("ufiFS");

var $awynr = parcelRequire("awynr");

var $1kopK = parcelRequire("1kopK");

var $3MLtm = parcelRequire("3MLtm");

var $2e0gq = parcelRequire("2e0gq");
const $0241365af9a98913$var$DeploymentFrequencyReport = ()=>{
    const { data: data } = (0, $3Ws3s.useReportCoreData)();
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $0241365af9a98913$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "welcomeMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2e0gq.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVXtL.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MLtm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$CoreChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxsp4.DeploymentFrequencyBarChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $awynr.LineChartByEnvironment), null)), !(data && data.hasDeploymentProvider === false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$DetailChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ufiFS.IssuesPerDeploymentChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$WeekBreakDownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY22e.BatchSizeChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kopK.PerDeploymentDetailTable), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6vgP1.DeploymentModal), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$DeploymentFrequencyReportContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "welcomeMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2e0gq.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVXtL.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3MLtm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$CoreChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxsp4.DeploymentFrequencyBarChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $awynr.LineChartByEnvironment), null)), !(data && data.hasDeploymentProvider === false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$DetailChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ufiFS.IssuesPerDeploymentChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0241365af9a98913$var$WeekBreakDownContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iY22e.BatchSizeChart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kopK.PerDeploymentDetailTable), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6vgP1.DeploymentModal), null));
};
var $0241365af9a98913$export$2e2bcd8739ae039 = $0241365af9a98913$var$DeploymentFrequencyReport;
const $0241365af9a98913$var$styles = {
    container: "_ca0qze3t _n3tdze3t _u5f31ejb _19bv1ejb"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0241365af9a98913$var$DeploymentFrequencyReportContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3xy5q _n3tdidpf _19bvxy5q",
            __cmplp.className
        ])
    });
});
const $0241365af9a98913$var$CoreChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _bfhkqbzx _ca0q1ejb _u5f3utpp _n3td1ejb _19bvutpp _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $0241365af9a98913$var$DetailChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _bfhkqbzx _ca0q1ejb _u5f3utpp _n3td1ejb _19bvutpp _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $0241365af9a98913$var$WeekBreakDownContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkvuon _16qszucj _19pkidpf _2hwxpxbi _otyridpf _18u0pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j1sSt", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $98b7296fd77e9435$export$1625b7ea4c7a5a23);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $98b7296fd77e9435$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReportsDeploymentFrequencyReport",
        teamName: "fusion-solaris",
        id: eventLocation
    }, children);

});

parcelRegister("iY22e", function(module, exports) {

$parcel$export(module.exports, "BatchSizeChart", () => $19e90c23be3ab6c2$export$e721189aad43c708);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $lJosW = parcelRequire("lJosW");

var $dg0Fl = parcelRequire("dg0Fl");

var $aYAc3 = parcelRequire("aYAc3");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $pa9q9 = parcelRequire("pa9q9");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $44gpy = parcelRequire("44gpy");

var $4R6GH = parcelRequire("4R6GH");

var $l8FNQ = parcelRequire("l8FNQ");

var $6RYAp = parcelRequire("6RYAp");

var $kBSee = parcelRequire("kBSee");

var $gilhC = parcelRequire("gilhC");

var $mEdYv = parcelRequire("mEdYv");

var $3Ws3s = parcelRequire("3Ws3s");

var $caivO = parcelRequire("caivO");

var $jKTxB = parcelRequire("jKTxB");

var $1y9Id = parcelRequire("1y9Id");

var $17PUx = parcelRequire("17PUx");

var $kkZmj = parcelRequire("kkZmj");

var $HHUOQ = parcelRequire("HHUOQ");
const $19e90c23be3ab6c2$var$ChartTitle = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$WeekBreakDownTitleComponent
    }, formatMessage((0, $HHUOQ.default).weekBreakDownTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $HHUOQ.default).weekBreakDownTitleTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$questionIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        LEGACY_size: "small",
        label: ""
    })))));
};
const $19e90c23be3ab6c2$export$e721189aad43c708 = ()=>{
    const onViewDeploymentFrequencyReportExperienceFail = (0, $caivO.useViewDeploymentFrequencyReportExperienceFail)();
    const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const [{ selectedWeekStart: selectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const selectedDateRange = selectedWeekStart ? (0, $kBSee.getWeekRangeFromWeekStartDate)(selectedWeekStart) : null;
    const { data: coreData, error: coreError, fetch: coreFetch } = (0, $3Ws3s.useReportCoreData)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $jKTxB.usePeriodBreakdownMetrics)(selectedDateRange);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, $mEdYv.useSelectedDeploymentActions)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'batchSizeChartDeployment'
        }));
        setSelectedDeploymentId(eventData.name);
    }, [
        createAnalyticsEvent,
        setSelectedDeploymentId
    ]);
    const events = (0, $5uXOq.useMemo)(()=>({
            click: onChartClicked
        }), [
        onChartClicked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error && data == null) {
            onViewDeploymentFrequencyReportExperienceFail('BatchSizeChart', error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'BatchSizeChartDataFailed',
                    packageName: 'jiraSoftwareDeploymentFrequencyReport',
                    teamName: 'fusion-solaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (error && data !== null) {
            // Non-fatal error - log it and show a flag
            (0, $jcw0u.default)({
                meta: {
                    id: 'DeploymentMissingInPerDeploymentMetrics',
                    packageName: 'jiraSoftwareDeploymentFrequencyReport',
                    teamName: 'fusion-solaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            showFlag({
                type: 'error',
                title: formatMessage((0, $HHUOQ.default).errorFlagTitle),
                description: formatMessage((0, $HHUOQ.default).errorFlagDescription),
                messageId: 'software-deployment-frequency-report.ui.batch-size-chart.show-flag.error',
                messageType: 'transactional'
            });
        }
    }, [
        data,
        error,
        onViewDeploymentFrequencyReportExperienceFail,
        formatMessage,
        showFlag
    ]);
    if (error && data == null) // if core data is failed, it doesn't make sense to retry on perDeploymentMetrics
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19e90c23be3ab6c2$var$ChartTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$errorUIWrapperStyles,
        testId: "software-deployment-frequency-report.ui.batch-size-chart.error-ui"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44gpy.default), {
        onRetry: coreError && coreData == null ? coreFetch : fetch
    })));
    if (loading || data == null || selectedWeekStart == null || selectedDateRange === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkZmj.LoadingSkeleton), null);
    const isEmptyState = data.perDeploymentMetrics.length === 0;
    const dataPoints = (0, $17PUx.convertToDataPoints)(data.perDeploymentMetrics);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$chartWrapperBaseStyles,
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "software-deployment-frequency-report.ui.batch-size-chart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19e90c23be3ab6c2$var$ChartTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$periodDateComponentStyles
    }, formatMessage((0, $HHUOQ.default).weekTitle, {
        date: formatDate(selectedWeekStart, {
            month: 'short',
            day: 'numeric'
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$titleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$titleComponentStyles
    }, (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $HHUOQ.default).issuesPerDeploymentIssueTermRefresh, {
        periodProdIssuesPerDeployment: formatNumber(data.periodProdIssuesPerDeployment ?? 0)
    }) : formatMessage((0, $HHUOQ.default).issuesPerDeployment, {
        periodProdIssuesPerDeployment: formatNumber(data.periodProdIssuesPerDeployment ?? 0)
    }))), data.periodProdDeployments > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$trendSummaryContainerStyles
    }, data.prodDataState === 'SUFFICIENT_FOR_TREND' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $19e90c23be3ab6c2$var$trendLozengeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8FNQ.TrendLozenge), {
        current: data.periodProdIssuesPerDeployment ?? 0,
        median: data.medianIssuesPerDeployment ?? 0,
        colorScheme: "UP_IS_BAD"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RYAp.IssuesTrendSummary), {
        weekCount: data.periodProdIssuesPerDeployment ?? 0,
        wholePeriodStatistic: data.medianIssuesPerDeployment ?? 0,
        prodDataState: data.prodDataState
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$descriptionAndLegendContainerStyles
    }, isEmptyState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $HHUOQ.default).moreDataRequired)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        as: "span",
        xcss: $19e90c23be3ab6c2$var$descriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        size: "small"
    }, formatMessage((0, $HHUOQ.default).weeklyProdDeployments, {
        weeklyProdDeployments: data.periodProdDeployments
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$legendContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$legendEntityStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$chartSymbolStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        size: "small"
    }, formatMessage((0, $HHUOQ.default).deployment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $19e90c23be3ab6c2$var$legendEntityStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small"
    }, "--"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        size: "small"
    }, formatMessage((0, $HHUOQ.default).twelveWeekMedian)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $19e90c23be3ab6c2$var$graphBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1y9Id.default), {
        dataPoints: dataPoints,
        median: data.medianIssuesPerDeployment,
        dateRange: selectedDateRange,
        onEvents: events
    })));
};
const $19e90c23be3ab6c2$var$titleContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    alignItems: 'center'
});
const $19e90c23be3ab6c2$var$descriptionStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    alignItems: 'center',
    gap: 'space.050'
});
const $19e90c23be3ab6c2$var$descriptionAndLegendContainerStyles = (0, $8CUq3.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'space.100'
});
const $19e90c23be3ab6c2$var$legendContainerStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    paddingRight: 'space.250'
});
const $19e90c23be3ab6c2$var$legendEntityStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    paddingLeft: 'space.100',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '8px',
    gap: 'space.050'
});
const $19e90c23be3ab6c2$var$trendSummaryContainerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.150',
    alignItems: 'center'
});
const $19e90c23be3ab6c2$var$errorUIWrapperStyles = (0, $8CUq3.xcss)({
    height: '272px',
    justifyContent: 'center',
    alignItems: 'center'
});
const $19e90c23be3ab6c2$var$questionIconStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    fill: 'color.icon.inverse',
    color: 'color.text',
    cursor: 'pointer',
    paddingTop: 'space.025'
});
const $19e90c23be3ab6c2$var$trendLozengeContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.050'
});
const $19e90c23be3ab6c2$var$chartSymbolStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-100, 8px)",
    height: "var(--ds-space-100, 8px)",
    borderRadius: '100%',
    backgroundColor: 'color.background.accent.blue.subtle',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'color.border.accent.blue'
});
const $19e90c23be3ab6c2$var$titleComponentStyles = (0, $8CUq3.xcss)({
    color: 'color.text'
});
const $19e90c23be3ab6c2$var$periodDateComponentStyles = (0, $8CUq3.xcss)({
    margin: 'space.0',
    color: 'color.text',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase'
});
const $19e90c23be3ab6c2$var$WeekBreakDownTitleComponent = (0, $8CUq3.xcss)({
    height: '24px',
    alignItems: 'center',
    marginBottom: 'space.200'
});
const $19e90c23be3ab6c2$var$graphBaseStyles = (0, $8CUq3.xcss)({
    height: '272px'
});
const $19e90c23be3ab6c2$var$chartWrapperBaseStyles = (0, $8CUq3.xcss)({
    padding: 'space.0'
});

});
parcelRegister("44gpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13288df9599e2e10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOrGg = parcelRequire("jOrGg");

var $bU3PY = parcelRequire("bU3PY");

var $koVbs = parcelRequire("koVbs");

var $awRUj = parcelRequire("awRUj");
const $13288df9599e2e10$var$ErrorRetry = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13288df9599e2e10$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13288df9599e2e10$var$WarnIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13288df9599e2e10$var$BottomWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13288df9599e2e10$var$Message, null, formatMessage((0, $awRUj.default).unableToLoadData)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13288df9599e2e10$var$RetryIconWrapper, {
        role: "button",
        "data-test-id": "software-devops-report-common-error-retry.retry-icon-wrapper",
        onClick: ()=>onRetry()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
        label: formatMessage((0, $awRUj.default).retry),
        LEGACY_size: "small"
    }))));
};
var $13288df9599e2e10$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $13288df9599e2e10$var$ErrorRetry;
const $13288df9599e2e10$var$RetryIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1i6y _80omtlke",
            __cmplp.className
        ])
    });
});
const $13288df9599e2e10$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $13288df9599e2e10$var$BottomWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $13288df9599e2e10$var$WarnIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrv77o",
            __cmplp.className
        ])
    });
});
const $13288df9599e2e10$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1ul91lit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("awRUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90433303028aa6a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90433303028aa6a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unableToLoadData: {
        "id": "software-devops-report-common-error-retry.unable-to-load-data",
        "defaultMessage": "Unable to load data."
    },
    retry: {
        "id": "software-devops-report-common-error-retry.retry",
        "defaultMessage": "Retry"
    }
});

});


parcelRegister("l8FNQ", function(module, exports) {

$parcel$export(module.exports, "TrendLozenge", () => $745e2f564054d8b0$export$c51784fbfb667bc5);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $aWse0 = parcelRequire("aWse0");

var $hnhKv = parcelRequire("hnhKv");

var $fQr4I = parcelRequire("fQr4I");
const $745e2f564054d8b0$export$9b5cec634eb288f8 = (current, median, colorScheme)=>{
    const trend = (0, $fQr4I.compareStatistics)(current, median);
    switch(trend){
        case 'over':
            return {
                message: (0, $hnhKv.default).over,
                appearance: colorScheme === 'UP_IS_GOOD' ? 'success' : 'moved'
            };
        case 'under':
            return {
                message: (0, $hnhKv.default).under,
                appearance: colorScheme === 'UP_IS_GOOD' ? 'moved' : 'success'
            };
        case 'equal':
            return {
                message: (0, $hnhKv.default).equal,
                appearance: 'success'
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            trend;
            throw new Error('Unknown trend is given to getLozengeProps');
    }
};
const $745e2f564054d8b0$export$c51784fbfb667bc5 = ({ current: current, median: median, colorScheme: colorScheme })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const lozengeProps = $745e2f564054d8b0$export$9b5cec634eb288f8(current, median, colorScheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: lozengeProps.appearance
    }, formatMessage(lozengeProps.message));
};

});
parcelRegister("hnhKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de8507053bf4d8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7de8507053bf4d8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    over: {
        "id": "software-deployment-frequency-report.common.trend-lozenge.over",
        "defaultMessage": "over"
    },
    under: {
        "id": "software-deployment-frequency-report.common.trend-lozenge.under",
        "defaultMessage": "under"
    },
    equal: {
        "id": "software-deployment-frequency-report.common.trend-lozenge.equal",
        "defaultMessage": "equal"
    }
});

});

parcelRegister("fQr4I", function(module, exports) {

$parcel$export(module.exports, "compareStatistics", () => $ef49c556861ec43f$export$154b4dc7335209d7);
const $ef49c556861ec43f$export$154b4dc7335209d7 = (current, median)=>{
    if (current > median) return 'over';
    if (current < median) return 'under';
    return 'equal';
};

});


parcelRegister("6RYAp", function(module, exports) {

$parcel$export(module.exports, "DeploymentsTrendSummary", () => $8e9c3c0d81e798e3$export$ab32c8bdd4c685bb);
$parcel$export(module.exports, "IssuesTrendSummary", () => $8e9c3c0d81e798e3$export$8776d2775946890f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jWct = parcelRequire("1jWct");

var $29lcr = parcelRequire("29lcr");

var $dW099 = parcelRequire("dW099");

var $8VSnu = parcelRequire("8VSnu");
const $8e9c3c0d81e798e3$var$TrendIcon = ({ prodDataState: prodDataState, trend: trend, colorScheme: colorScheme })=>{
    if (prodDataState === 'SUFFICIENT_FOR_TREND') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dW099.TrendIcon), {
        trend: trend,
        colorScheme: colorScheme
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small"
    });
};
const $8e9c3c0d81e798e3$var$TrendSummary = ({ comparisonMessage: comparisonMessage, weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState, colorScheme: colorScheme = 'UP_IS_GOOD' })=>{
    const trend = (0, $29lcr.getTrend)(weekCount, wholePeriodStatistic);
    const noTrendIcon = trend === 'equal' && prodDataState === 'SUFFICIENT_FOR_TREND';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$Comparison, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$IconWrapper, {
        noMargin: noTrendIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendIcon, {
        prodDataState: prodDataState,
        trend: trend,
        colorScheme: colorScheme
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$ComparisonText, null, comparisonMessage));
};
const $8e9c3c0d81e798e3$export$ab32c8bdd4c685bb = ({ weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState })=>{
    const comparisonMessage = (0, $8VSnu.useDeploymentsComparisonMessageTranslated)(weekCount, wholePeriodStatistic, prodDataState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendSummary, {
        comparisonMessage: comparisonMessage,
        weekCount: weekCount,
        wholePeriodStatistic: wholePeriodStatistic,
        prodDataState: prodDataState,
        colorScheme: "UP_IS_GOOD"
    });
};
const $8e9c3c0d81e798e3$export$8776d2775946890f = ({ weekCount: weekCount, wholePeriodStatistic: wholePeriodStatistic, prodDataState: prodDataState })=>{
    const comparisonMessage = (0, $8VSnu.useIssuesComparisonMessageTranslated)(weekCount, wholePeriodStatistic, prodDataState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e9c3c0d81e798e3$var$TrendSummary, {
        comparisonMessage: comparisonMessage,
        weekCount: weekCount,
        wholePeriodStatistic: wholePeriodStatistic,
        prodDataState: prodDataState,
        colorScheme: "UP_IS_BAD"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e9c3c0d81e798e3$var$Comparison = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $8e9c3c0d81e798e3$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noMargin: noMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            !__cmplp.noMargin && "_2hwx1y44",
            __cmplp.className
        ])
    });
});
const $8e9c3c0d81e798e3$var$ComparisonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29lcr", function(module, exports) {

$parcel$export(module.exports, "getTrend", () => $f1a672b10d7c8925$export$a95d8fe605e5806d);
$parcel$export(module.exports, "getTrendIconBackgroundColor", () => $f1a672b10d7c8925$export$8fffc3abc634e8a7);
const $f1a672b10d7c8925$export$a95d8fe605e5806d = (currentCount, wholePeriodCount)=>{
    if (currentCount < wholePeriodCount) return 'under';
    if (currentCount > wholePeriodCount) return 'over';
    return 'equal';
};
const $f1a672b10d7c8925$export$8fffc3abc634e8a7 = (trend, colorScheme)=>{
    // RLSS-2812 replace color.icon.subtle into color.icon.accent.gray
    if (colorScheme === 'NEUTRAL' || trend === 'equal') return "var(--ds-icon-subtle, #626F86)";
    if (colorScheme === 'UP_IS_GOOD' && trend === 'over' || colorScheme === 'UP_IS_BAD' && trend === 'under') return "var(--ds-icon-success, #22A06B)";
    if (colorScheme === 'UP_IS_GOOD' && trend === 'under' || colorScheme === 'UP_IS_BAD' && trend === 'over') return "var(--ds-icon-warning, #E56910)";
    // RLSS-2812 replace color.icon.subtle into color.icon.accent.gray
    return "var(--ds-icon-subtle, #626F86)";
};

});

parcelRegister("dW099", function(module, exports) {

$parcel$export(module.exports, "TrendIcon", () => $b1e1971ad3bd92e8$export$fba4b680946eab5);

var $5uXOq = parcelRequire("5uXOq");

var $kaj1k = parcelRequire("kaj1k");

var $7QJs7 = parcelRequire("7QJs7");

var $29lcr = parcelRequire("29lcr");
const $b1e1971ad3bd92e8$export$fba4b680946eab5 = ({ trend: trend, colorScheme: colorScheme = 'UP_IS_GOOD' })=>{
    const size = 'small';
    switch(trend){
        case 'over':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7QJs7))), {
                LEGACY_size: size,
                color: (0, $29lcr.getTrendIconBackgroundColor)('over', colorScheme),
                label: ""
            });
        case 'under':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaj1k))), {
                LEGACY_size: size,
                color: (0, $29lcr.getTrendIconBackgroundColor)('under', colorScheme),
                label: ""
            });
        case 'equal':
            return null;
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            trend;
            throw new Error('Unknown trend is given to TrendIcon component');
    }
};

});
parcelRegister("kaj1k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f151963f6bf8b4672bcc3f6646d8ced>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eae37ee2ccf6e8cc$var$_react = $eae37ee2ccf6e8cc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eae37ee2ccf6e8cc$var$_arrowDown = $eae37ee2ccf6e8cc$var$_interopRequireDefault((parcelRequire("cC5ib")));

var $eae37ee2ccf6e8cc$var$_arrowDownCircle = $eae37ee2ccf6e8cc$var$_interopRequireDefault((parcelRequire("7e6cy")));
function $eae37ee2ccf6e8cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eae37ee2ccf6e8cc$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $eae37ee2ccf6e8cc$var$_react.default.createElement($eae37ee2ccf6e8cc$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $eae37ee2ccf6e8cc$var$_arrowDownCircle.default
    }, props));
$eae37ee2ccf6e8cc$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $eae37ee2ccf6e8cc$var$_default = module.exports.default = $eae37ee2ccf6e8cc$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("7e6cy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $542ea6b72fb41deb$var$_react = $542ea6b72fb41deb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $542ea6b72fb41deb$var$_arrowDown = $542ea6b72fb41deb$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $542ea6b72fb41deb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $542ea6b72fb41deb$var$ArrowDownCircleIcon = (props)=>/*#__PURE__*/ $542ea6b72fb41deb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 0 0-1.421 0 1 1 0 0 0 0 1.416l2.994 2.977a1.01 1.01 0 0 0 1.423 0l2.994-2.977a1 1 0 0 0 0-1.416 1.01 1.01 0 0 0-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1s-1.006.448-1.006 1"/></g></svg>`
    }, props, {
        newIcon: $542ea6b72fb41deb$var$_arrowDown.default
    }));
$542ea6b72fb41deb$var$ArrowDownCircleIcon.displayName = 'ArrowDownCircleIcon';
var $542ea6b72fb41deb$var$_default = module.exports.default = $542ea6b72fb41deb$var$ArrowDownCircleIcon;

});


parcelRegister("7QJs7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08b755d43ada362c3e1e224d26e38eec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b70a5a747eca512$var$_react = $5b70a5a747eca512$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5b70a5a747eca512$var$_arrowUp = $5b70a5a747eca512$var$_interopRequireDefault((parcelRequire("kcHZS")));

var $5b70a5a747eca512$var$_arrowUpCircle = $5b70a5a747eca512$var$_interopRequireDefault((parcelRequire("Jy8W0")));
function $5b70a5a747eca512$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpIcon.
 * This component is ArrowUpIcon, with `UNSAFE_fallbackIcon` set to "ArrowUpCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b70a5a747eca512$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $5b70a5a747eca512$var$_react.default.createElement($5b70a5a747eca512$var$_arrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $5b70a5a747eca512$var$_arrowUpCircle.default
    }, props));
$5b70a5a747eca512$var$ArrowUpIcon.Name = 'ArrowUpIconMigration';
var $5b70a5a747eca512$var$_default = module.exports.default = $5b70a5a747eca512$var$ArrowUpIcon;

});
parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("Jy8W0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $088eb0319e79be2c$var$_react = $088eb0319e79be2c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $088eb0319e79be2c$var$_arrowUp = $088eb0319e79be2c$var$_interopRequireDefault((parcelRequire("kcHZS")));
function $088eb0319e79be2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $088eb0319e79be2c$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $088eb0319e79be2c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $088eb0319e79be2c$var$_arrowUp.default
    }));
$088eb0319e79be2c$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var $088eb0319e79be2c$var$_default = module.exports.default = $088eb0319e79be2c$var$ArrowUpCircleIcon;

});



parcelRegister("8VSnu", function(module, exports) {

$parcel$export(module.exports, "useDeploymentsComparisonMessageTranslated", () => $03a569651b8916b7$export$11affc69c81e2e0b);
$parcel$export(module.exports, "useIssuesComparisonMessageTranslated", () => $03a569651b8916b7$export$8d6bc349d3292310);

var $gamDR = parcelRequire("gamDR");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $29lcr = parcelRequire("29lcr");

var $fCgqT = parcelRequire("fCgqT");
const $03a569651b8916b7$export$11affc69c81e2e0b = (selectedWeekDeploymentProdCount, averageDeploymentCountWholePeriod, prodDataState)=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    if (prodDataState === 'COMPLETELY_EMPTY') return formatMessage((0, $fCgqT.default).noDataFound);
    if (prodDataState === 'INSUFFICIENT_FOR_TREND') return formatMessage((0, $fCgqT.default).insufficientData);
    if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') return formatMessage((0, $fCgqT.default).noProdButOtherEnv);
    // SUFFICIENT_FOR_TREND
    const trend = (0, $29lcr.getTrend)(selectedWeekDeploymentProdCount, averageDeploymentCountWholePeriod);
    const numDeploymentsDiff = (0, (/*@__PURE__*/$parcel$interopDefault($gamDR)))(Math.abs(selectedWeekDeploymentProdCount - averageDeploymentCountWholePeriod), 1);
    if (trend === 'over') return formatMessage((0, $fCgqT.default).deploymentsComparisonTextOver, {
        numDeploymentsDiff: formatNumber(numDeploymentsDiff)
    });
    if (trend === 'under') return formatMessage((0, $fCgqT.default).deploymentsComparisonTextUnder, {
        numDeploymentsDiff: formatNumber(numDeploymentsDiff)
    });
    return formatMessage((0, $fCgqT.default).deploymentsComparisonTextEqual);
};
const $03a569651b8916b7$export$8d6bc349d3292310 = (selectedWeekMedianIssuesProdCount, medianIssuesCountWholePeriod, prodDataState)=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    if (prodDataState === 'COMPLETELY_EMPTY') return formatMessage((0, $fCgqT.default).noDataFound);
    if (prodDataState === 'INSUFFICIENT_FOR_TREND') return formatMessage((0, $fCgqT.default).insufficientData);
    if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') return formatMessage((0, $fCgqT.default).noProdButOtherEnv);
    // SUFFICIENT_FOR_TREND
    const trend = (0, $29lcr.getTrend)(selectedWeekMedianIssuesProdCount, medianIssuesCountWholePeriod);
    const numIssuesDiff = (0, (/*@__PURE__*/$parcel$interopDefault($gamDR)))(Math.abs(selectedWeekMedianIssuesProdCount - medianIssuesCountWholePeriod), 1);
    if (trend === 'over') return formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $fCgqT.default).issuesComparisonTextOverIssueTerminologyRefreshM4 : (0, $fCgqT.default).issuesComparisonTextOver, {
        numIssuesDiff: formatNumber(numIssuesDiff)
    });
    if (trend === 'under') return formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $fCgqT.default).issuesComparisonTextUnderIssueTerminologyRefreshM4 : (0, $fCgqT.default).issuesComparisonTextUnder, {
        numIssuesDiff: formatNumber(numIssuesDiff)
    });
    return formatMessage((0, $fCgqT.default).issuesComparisonTextEqual);
};

});
parcelRegister("fCgqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7499acd5154c1f43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7499acd5154c1f43$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deploymentsComparisonTextOver: {
        "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-over",
        "defaultMessage": "{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} over 12-week average"
    },
    deploymentsComparisonTextUnder: {
        "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-under",
        "defaultMessage": "{numDeploymentsDiff} {numDeploymentsDiff, plural, one {deployment} other {deployments}} under 12-week average"
    },
    deploymentsComparisonTextEqual: {
        "id": "software-deployment-frequency-report.common.trend-summary.deployments-comparison-text-equal",
        "defaultMessage": "Equal to 12-week average"
    },
    issuesComparisonTextOver: {
        "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-over",
        "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} over 12-week median"
    },
    issuesComparisonTextUnder: {
        "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-under",
        "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {issue} other {issues}} under 12-week median"
    },
    issuesComparisonTextEqual: {
        "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-equal",
        "defaultMessage": "Equal to 12-week median"
    },
    noDataFound: {
        "id": "software-deployment-frequency-report.common.trend-summary.no-data-found",
        "defaultMessage": "No data found"
    },
    insufficientData: {
        "id": "software-deployment-frequency-report.common.trend-summary.insufficient-data",
        "defaultMessage": "Not enough data to establish a 12-week median"
    },
    noProdButOtherEnv: {
        "id": "software-deployment-frequency-report.common.trend-summary.no-prod-but-other-env",
        "defaultMessage": "No production deployment data"
    },
    issuesComparisonTextOverIssueTerminologyRefreshM4: {
        "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-over-issue-terminology-refresh-m4",
        "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {work item} other {work items}} over 12-week median"
    },
    issuesComparisonTextUnderIssueTerminologyRefreshM4: {
        "id": "software-deployment-frequency-report.common.trend-summary.issues-comparison-text-under-issue-terminology-refresh-m4",
        "defaultMessage": "{numIssuesDiff} {numIssuesDiff, plural, one {work item} other {work items}} under 12-week median"
    }
});

});



parcelRegister("gilhC", function(module, exports) {

$parcel$export(module.exports, "useSelectedWeekStore", () => $e53e3374bc08839b$export$face41c30bd4f22c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $e53e3374bc08839b$export$d4c72bab9d6cc13a = {
    selectedWeekStart: null
};
const $e53e3374bc08839b$export$e324594224ef24da = {
    setSelectedWeekStart: (newWeekStartDate)=>({ getState: getState, setState: setState })=>{
            const { selectedWeekStart: previousWeekStart } = getState();
            if (previousWeekStart === null || previousWeekStart.getTime() !== newWeekStartDate.getTime()) setState({
                selectedWeekStart: newWeekStartDate
            });
        }
};
const $e53e3374bc08839b$var$Store = (0, $iXqE5.createStore)({
    name: 'depFreqSelectedWeekStore',
    initialState: $e53e3374bc08839b$export$d4c72bab9d6cc13a,
    actions: $e53e3374bc08839b$export$e324594224ef24da
});
const $e53e3374bc08839b$export$face41c30bd4f22c = (0, $3sQ5x.createHook)($e53e3374bc08839b$var$Store); // NOTE: we cannot use this hook because two different Dates pass an equality check :(
 // possibly a bug in sweet-state. We should either store milliseconds, or just keep
 // it as is and not use a selector.
 // export const useSelectedWeekStart = createHook<State, Actions, Date | null, void>(Store, {
 //     selector: (state) => state.selectedWeekStart,
 // });

});

parcelRegister("mEdYv", function(module, exports) {

$parcel$export(module.exports, "useSelectedDeploymentId", () => $18b962388f56fd77$export$ce7d4303c8a70f4);
$parcel$export(module.exports, "useSelectedDeploymentActions", () => $18b962388f56fd77$export$22e665e7c579f44c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $18b962388f56fd77$export$d4c72bab9d6cc13a = {
    selectedDeploymentId: null
};
const $18b962388f56fd77$export$e324594224ef24da = {
    setSelectedDeploymentId: (deploymentId)=>({ setState: setState })=>setState({
                selectedDeploymentId: deploymentId
            })
};
const $18b962388f56fd77$var$Store = (0, $iXqE5.createStore)({
    name: 'selectedDeploymentId',
    initialState: $18b962388f56fd77$export$d4c72bab9d6cc13a,
    actions: $18b962388f56fd77$export$e324594224ef24da
});
const $18b962388f56fd77$export$ce7d4303c8a70f4 = (0, $3sQ5x.createHook)($18b962388f56fd77$var$Store, {
    selector: (state)=>state.selectedDeploymentId
});
const $18b962388f56fd77$export$22e665e7c579f44c = (0, $3sQ5x.createHook)($18b962388f56fd77$var$Store, {
    selector: ()=>null
});

});

parcelRegister("caivO", function(module, exports) {

$parcel$export(module.exports, "ViewDeploymentFrequencyReportExperienceStart", () => $1cc4ea7fea040619$export$dab28c629d19e62);
$parcel$export(module.exports, "useViewDeploymentFrequencyReportExperienceFail", () => $1cc4ea7fea040619$export$a304fe6bb76746c4);
$parcel$export(module.exports, "ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker", () => $1cc4ea7fea040619$export$ac1ea60836686d1f);
$parcel$export(module.exports, "ViewDeploymentFrequencyReportExperienceSuccessTracker", () => $1cc4ea7fea040619$export$c93aada635a947bf);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");

var $j1sSt = parcelRequire("j1sSt");

var $ilLj2 = parcelRequire("ilLj2");
const $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName = 'viewDeploymentFrequencyReport';
const $1cc4ea7fea040619$export$dab28c629d19e62 = ({ experienceId: experienceId })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
        analyticsSource: "deploymentFrequencyReport",
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $1cc4ea7fea040619$export$a304fe6bb76746c4 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName
    });
const $1cc4ea7fea040619$export$ac1ea60836686d1f = ({ reason: reason })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
        attributes: {
            reason: reason
        }
    });
const $1cc4ea7fea040619$export$c93aada635a947bf = ()=>{
    const projectInfo = (0, $ilLj2.useProjectAnalyticsAttributes)();
    if (projectInfo == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "viewDeploymentFrequencyReportExperienceSuccessTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $1cc4ea7fea040619$var$viewDeploymentFrequencyReportExperienceName,
        attributes: {
            ...projectInfo
        }
    }));
};

});

parcelRegister("jKTxB", function(module, exports) {

$parcel$export(module.exports, "usePeriodBreakdownMetrics", () => $4224bd69e1d83db8$export$9f571b42ec4fbca5);

var $hEs3t = parcelRequire("hEs3t");

var $3Ws3s = parcelRequire("3Ws3s");

var $i42Pk = parcelRequire("i42Pk");

var $gyB2f = parcelRequire("gyB2f");
const $4224bd69e1d83db8$export$9f571b42ec4fbca5 = (selectedDateRange)=>{
    const perDeploymentMetricsResult = (0, $i42Pk.usePerDeploymentMetrics)(selectedDateRange);
    const reportCoreDataResult = (0, $3Ws3s.useReportCoreData)();
    const isLoading = perDeploymentMetricsResult.loading || reportCoreDataResult.loading;
    const resultBase = {
        loading: isLoading,
        error: (0, $hEs3t.getMaybeCombinedError)([
            perDeploymentMetricsResult.error,
            reportCoreDataResult.error
        ]),
        fetch: perDeploymentMetricsResult.fetch
    };
    return {
        ...resultBase,
        data: reportCoreDataResult.data == null || perDeploymentMetricsResult.data == null || selectedDateRange == null ? undefined : (0, $gyB2f.transformData)(perDeploymentMetricsResult.data, reportCoreDataResult.data, selectedDateRange)
    };
};

});
parcelRegister("i42Pk", function(module, exports) {

$parcel$export(module.exports, "usePerDeploymentMetrics", () => $2bca86cc1afb07fa$export$8bd2fd3e33a2a847);

var $jSzUb = parcelRequire("jSzUb");

var $jZs4b = parcelRequire("jZs4b");

var $koeKL = parcelRequire("koeKL");

var $ilLj2 = parcelRequire("ilLj2");

var $fcVN3 = parcelRequire("fcVN3");
const $2bca86cc1afb07fa$export$8bd2fd3e33a2a847 = (dateRange)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectId = (0, $ilLj2.useProjectId)();
    const variables = dateRange ? (0, $fcVN3.buildQueryVariables)(cloudId, projectId, dateRange) : null;
    const skip = dateRange === null;
    /* eslint-disable @atlassian/relay/unused-fields */ const queryResult = (0, $jZs4b.useQuery)((0, $jSzUb.default /* eslint-enable @atlassian/relay/unused-fields */ ), {
        ...variables === null ? {} : {
            variables: {
                ...variables
            }
        },
        // @ts-expect-error - TS2345 - Argument of type '{ errorPolicy: string; skip: boolean; variables?: { filter: DevOpsMetricsPerDeploymentMetricsFilter; } | undefined; }' is not assignable to parameter of type '{ variables?: perDeploymentMetricsRelayQuery$variables | undefined; skip?: boolean | undefined; fetchPolicy?: FetchPolicy | undefined; }'.
        errorPolicy: 'all',
        skip: skip
    });
    return (0, $fcVN3.transformResult)(queryResult);
};

});
parcelRegister("jSzUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c1a5ac9502ab44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91ccd18138470c230dedc0263c524f49>>
 * @relayHash 0b80f6b190b9098f1041c5e364d95852
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69272838933688029bd3af75ee71f457c3de45b2f1a60918fa4cd89a11f6eec5
const $e5c1a5ac9502ab44$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 400
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "deploymentSize"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "issueIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "perDeploymentMetricsRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOpsMetrics",
                        "kind": "LinkedField",
                        "name": "devOpsMetrics",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
                                    "kind": "LinkedField",
                                    "name": "perDeploymentMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevOpsMetricsDeploymentMetrics",
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOpsMetrics.perDeploymentMetrics.nodes.deploymentSize"
                                                    },
                                                    {
                                                        "concreteType": "DeploymentSummary",
                                                        "kind": "LinkedField",
                                                        "name": "deployment",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.issueIds"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v5 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.displayName"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.url"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.lastUpdated"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "DevOpsEnvironment",
                                                                    "kind": "LinkedField",
                                                                    "name": "environment",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment.displayName"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.environment"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "DeploymentPipeline",
                                                                    "kind": "LinkedField",
                                                                    "name": "pipeline",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v6 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.url"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline.displayName"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "devOpsMetrics.perDeploymentMetrics.nodes.deployment.pipeline"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOpsMetrics.perDeploymentMetrics.nodes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOpsMetrics.perDeploymentMetrics"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOpsMetrics"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "perDeploymentMetricsRelayQuery",
            "selections": [
                {
                    "concreteType": "DevOpsMetrics",
                    "kind": "LinkedField",
                    "name": "devOpsMetrics",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsMetricsPerDeploymentMetricsConnection",
                            "kind": "LinkedField",
                            "name": "perDeploymentMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsMetricsDeploymentMetrics",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "DeploymentSummary",
                                            "kind": "LinkedField",
                                            "name": "deployment",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "DevOpsEnvironment",
                                                    "kind": "LinkedField",
                                                    "name": "environment",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "DeploymentPipeline",
                                                    "kind": "LinkedField",
                                                    "name": "pipeline",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "69272838933688029bd3af75ee71f457c3de45b2f1a60918fa4cd89a11f6eec5",
            "metadata": {},
            "name": "perDeploymentMetricsRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e5c1a5ac9502ab44$var$node.hash = "07de4e6dc0021f0040700e056c223679";
var $e5c1a5ac9502ab44$export$2e2bcd8739ae039 = $e5c1a5ac9502ab44$var$node;

});

parcelRegister("fcVN3", function(module, exports) {

$parcel$export(module.exports, "buildQueryVariables", () => $a4c3d849efa0d850$export$9a3cee82e7cc08ff);
$parcel$export(module.exports, "transformResult", () => $a4c3d849efa0d850$export$f13b29f9ed0c5a03);

var $dXq4S = parcelRequire("dXq4S");

var $g5X3G = parcelRequire("g5X3G");
const $a4c3d849efa0d850$export$9a3cee82e7cc08ff = (cloudId, projectId, { startDateInclusive: startDateInclusive, endDateExclusive: endDateExclusive })=>({
        filter: {
            cloudId: cloudId,
            startFromInclusive: startDateInclusive.toISOString(),
            endAtExclusive: endDateExclusive.toISOString(),
            jiraProjectIds: [
                projectId
            ],
            environmentCategories: [
                'PRODUCTION'
            ]
        }
    });
const $a4c3d849efa0d850$export$8aa413923a6a0c63 = (ariLikeString)=>{
    const ari = (0, $dXq4S.toAri)(ariLikeString);
    if (ari === undefined) throw Error('Invalid ARI');
    return (0, $dXq4S.getAriConfig)(ari).resourceId;
};
// @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
const $a4c3d849efa0d850$var$transformNode = (node)=>{
    if (node == null || node.deployment == null || node.deploymentSize == null) return null;
    const { deployment: deployment, deploymentSize: deploymentSize } = node;
    const { id: id, displayName: displayName, url: url, lastUpdated: lastUpdated, issueIds: issueIds, environment: environment, pipeline: pipeline } = deployment;
    if (id == null || displayName == null || url == null || lastUpdated == null || issueIds == null || environment == null || pipeline == null) throw Error('Incomplete deployment node');
    const { displayName: environmentDisplayName } = environment;
    const { displayName: pipelineDisplayName, url: pipelineUrl } = pipeline;
    if (environmentDisplayName == null || pipelineDisplayName == null || pipelineUrl == null) throw Error('Incomplete deployment node');
    return {
        id: id,
        issueCount: deploymentSize,
        // @ts-expect-error - TS7006 - Parameter 'issueId' implicitly has an 'any' type.
        issueIds: issueIds.map((issueId)=>(0, $g5X3G.toIssueId)($a4c3d849efa0d850$export$8aa413923a6a0c63(issueId))),
        displayName: displayName,
        url: url,
        // @ts-expect-error - TS2322 - Confusion between JS Date and GraphQL dates encoded as a string
        lastUpdated: new Date(lastUpdated),
        environment: {
            displayName: environmentDisplayName
        },
        pipeline: {
            url: pipelineUrl,
            displayName: pipelineDisplayName
        }
    };
};
const $a4c3d849efa0d850$export$f13b29f9ed0c5a03 = (queryResult)=>{
    const resultBase = {
        loading: queryResult.loading,
        error: queryResult.error,
        fetch: queryResult.refetch
    };
    const nodes = queryResult.data?.devOpsMetrics?.perDeploymentMetrics?.nodes;
    if (queryResult.loading || nodes == null) return resultBase;
    try {
        const transformedNodes = nodes.map($a4c3d849efa0d850$var$transformNode);
        return {
            ...resultBase,
            data: transformedNodes.filter(Boolean),
            ...transformedNodes.includes(null) && queryResult.error == null ? {
                error: Error('Some deployment(s) were missing from the response')
            } : {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            ...resultBase,
            error: queryResult.error ?? error
        };
    }
};

});


parcelRegister("gyB2f", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $958435368c5ac310$export$3ceb62baab058c6b);

var $claG0 = parcelRequire("claG0");
const $958435368c5ac310$export$3ceb62baab058c6b = (perDeploymentMetrics, coreReportData, selectedDateRange)=>{
    const selectedPeriod = coreReportData.weeksData.find((week)=>week.startDateInclusive.getTime() === selectedDateRange.startDateInclusive.getTime());
    if (!selectedPeriod) throw new Error('cannot find selected period in period breakdown');
    return {
        periodProdDeployments: selectedPeriod.deploymentCount.prod,
        periodProdIssuesPerDeployment: selectedPeriod.medianIssuesPerDeployment.prod,
        medianProdDeployments: coreReportData.averageDeploymentCount,
        medianIssuesPerDeployment: coreReportData.medianIssuesPerDeployment,
        prodDataState: (0, $claG0.getProdDataState)(coreReportData),
        perDeploymentMetrics: perDeploymentMetrics,
        hasDeploymentProvider: coreReportData.hasDeploymentProvider
    };
};

});


parcelRegister("1y9Id", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25f55e36105bdee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3QJ5u = parcelRequire("3QJ5u");

var $lXVui = parcelRequire("lXVui");

var $5QGgH = parcelRequire("5QGgH");
var $47isN = parcelRequire("47isN");
var $Np0DX = parcelRequire("Np0DX");

var $48mDj = parcelRequire("48mDj");
var $gLj36 = parcelRequire("gLj36");

var $ixV1I = parcelRequire("ixV1I");

var $lWgYs = parcelRequire("lWgYs");

var $dWt6p = parcelRequire("dWt6p");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");

var $fNWkd = parcelRequire("fNWkd");

var $d5cn8 = parcelRequire("d5cn8");

var $gFaMO = parcelRequire("gFaMO");

var $ayFdV = parcelRequire("ayFdV");
$ixV1I.use([
    (0, $47isN.install),
    (0, $Np0DX.install),
    (0, $5QGgH.install),
    (0, $48mDj.install),
    (0, $gLj36.install),
    (0, $lWgYs.install)
]);
const $c25f55e36105bdee$var$getAxisCommonConfig = ()=>({
        nameGap: (0, $gwIPs.gridSize) * 4,
        nameLocation: 'middle',
        nameTextStyle: {
            color: (0, $829f609a65d26a98$exports).N400,
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
        }
    });
const $c25f55e36105bdee$var$useXAxisConfig = (dateRange)=>{
    const { formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const xAxisData = (0, $3QJ5u.default)({
        start: dateRange.startDateInclusive,
        end: dateRange.endDateExclusive
    }).map((x)=>x.getTime());
    return {
        ...$c25f55e36105bdee$var$getAxisCommonConfig(),
        data: xAxisData,
        min: xAxisData[0],
        max: xAxisData[xAxisData.length - 1],
        splitNumber: xAxisData.length,
        axisLabel: {
            // @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
            formatter: (x)=>formatDate(new Date(parseInt(x, 10)), {
                    month: 'short',
                    day: 'numeric'
                }),
            showMaxLabel: true
        },
        splitLine: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: (0, $829f609a65d26a98$exports).N40,
                width: 2
            }
        },
        axisTick: {
            alignWithLabel: true
        },
        offset: 10,
        scale: true,
        type: 'time',
        axisPointer: {
            show: true,
            lineStyle: {
                type: 'dashed',
                color: (0, $829f609a65d26a98$exports).B100,
                width: 0.5
            },
            label: {
                show: false
            },
            triggerTooltip: false
        }
    };
};
const $c25f55e36105bdee$var$Chart = ({ onEvents: onEvents, dataPoints: dataPoints, median: median, dateRange: dateRange })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const tooltipFormatter = (0, $ayFdV.useTooltipFormatter)();
    const xAxisConfig = $c25f55e36105bdee$var$useXAxisConfig(dateRange);
    const echartsRef = (0, $5uXOq.useRef)();
    const [hoveredDeployment] = (0, $d5cn8.useHoveredDeployment)();
    const prefersReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const echartsInstance = echartsRef?.current?.getEchartsInstance();
        if (echartsInstance === undefined || hoveredDeployment === null) // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        echartsInstance.dispatchAction({
            type: 'highlight',
            name: hoveredDeployment
        });
        return ()=>{
            echartsInstance.dispatchAction({
                type: 'downplay',
                name: hoveredDeployment
            });
        };
    }, [
        hoveredDeployment
    ]);
    // TODO RLSS-2812: handle darkmode for echarts
    const scatterConfig = {
        type: 'effectScatter',
        data: dataPoints,
        showEffectOn: 'emphasis',
        rippleEffect: {
            brushType: 'fill',
            color: (0, $829f609a65d26a98$exports).B300,
            scale: 5
        },
        hoverAnimation: true,
        color: (0, $829f609a65d26a98$exports).B75,
        symbolSize: 8,
        itemStyle: {
            borderColor: (0, $829f609a65d26a98$exports).B100,
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                color: (0, $829f609a65d26a98$exports).N0,
                borderColor: (0, $829f609a65d26a98$exports).B300,
                borderWidth: 2,
                borderType: 'solid',
                opacity: 1
            }
        },
        lineStyle: {
            color: (0, $829f609a65d26a98$exports).B200
        }
    };
    const chartOptions = {
        animation: !prefersReducedMotion,
        tooltip: {
            backgroundColor: (0, $829f609a65d26a98$exports).N900,
            formatter: tooltipFormatter,
            confine: true,
            transitionDuration: 0,
            enterable: true
        },
        grid: {
            left: `${(0, $fNWkd.CHART_SPACE_LEFT)}px`,
            right: '20px',
            bottom: `${(0, $fNWkd.CHART_SPACE_BOTTOM)}px`
        },
        xAxis: xAxisConfig,
        yAxis: {
            ...$c25f55e36105bdee$var$getAxisCommonConfig(),
            name: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $gFaMO.default).yAxisIssueTermRefresh) : formatMessage((0, $gFaMO.default).yAxis),
            nameGap: 40,
            nameLocation: 'middle',
            minInterval: 1,
            offset: 0,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N30
                }
            }
        },
        textStyle: {
            color: (0, $829f609a65d26a98$exports).N400
        },
        series: [
            {
                ...scatterConfig,
                ...median === null ? {} : {
                    markLine: {
                        data: [
                            {
                                yAxis: median
                            }
                        ],
                        silent: true,
                        lineStyle: {
                            color: (0, $829f609a65d26a98$exports).N300,
                            width: 1,
                            opacity: 0.6
                        },
                        symbol: 'none',
                        label: {
                            show: false
                        }
                    }
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lXVui))), {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<EChartsReactCore> | undefined'.
        ref: echartsRef,
        echarts: $ixV1I,
        option: chartOptions,
        onEvents: onEvents,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            height: '100%'
        }
    });
};
var $c25f55e36105bdee$export$2e2bcd8739ae039 = $c25f55e36105bdee$var$Chart;

});
parcelRegister("lXVui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $ffdbb37eea52750b$var$react_1 = (0, $3VFsf.__importStar)((parcelRequire("5uXOq")));

var $grS0X = parcelRequire("grS0X");

var $6gLUT = parcelRequire("6gLUT");

var $eBzeD = parcelRequire("eBzeD");

var $lj6jE = parcelRequire("lj6jE");

var $1pywT = parcelRequire("1pywT");
/**
 * core component for echarts binding
 */ var $ffdbb37eea52750b$var$EChartsReactCore = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(EChartsReactCore, _super);
    function EChartsReactCore(props) {
        var _this = _super.call(this, props) || this;
        _this.echarts = props.echarts;
        _this.ele = null;
        _this.isInitialResize = true;
        return _this;
    }
    EChartsReactCore.prototype.componentDidMount = function() {
        this.renderNewEcharts();
    };
    // update
    EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
        /**
         * if shouldSetOption return false, then return, not update echarts options
         * default is true
         */ var shouldSetOption = this.props.shouldSetOption;
        if ((0, $eBzeD.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
        // 以下属性修改的时候，需要 dispose 之后再新建
        // 1. 切换 theme 的时候
        // 2. 修改 opts 的时候
        // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
        if (!(0, $1pywT.isEqual)(prevProps.theme, this.props.theme) || !(0, $1pywT.isEqual)(prevProps.opts, this.props.opts) || !(0, $1pywT.isEqual)(prevProps.onEvents, this.props.onEvents)) {
            this.dispose();
            this.renderNewEcharts(); // 重建
            return;
        }
        // when these props are not isEqual, update echarts
        var pickKeys = [
            'option',
            'notMerge',
            'lazyUpdate',
            'showLoading',
            'loadingOption'
        ];
        if (!(0, $1pywT.isEqual)((0, $6gLUT.pick)(this.props, pickKeys), (0, $6gLUT.pick)(prevProps, pickKeys))) this.updateEChartsOption();
        /**
         * when style or class name updated, change size.
         */ if (!(0, $1pywT.isEqual)(prevProps.style, this.props.style) || !(0, $1pywT.isEqual)(prevProps.className, this.props.className)) this.resize();
    };
    EChartsReactCore.prototype.componentWillUnmount = function() {
        this.dispose();
    };
    /**
     * return the echart object
     * 1. if exist, return the existed instance
     * 2. or new one instance
     */ EChartsReactCore.prototype.getEchartsInstance = function() {
        return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    };
    /**
     * dispose echarts and clear size-sensor
     */ EChartsReactCore.prototype.dispose = function() {
        if (this.ele) {
            try {
                (0, $grS0X.clear)(this.ele);
            } catch (e) {
                console.warn(e);
            }
            // dispose echarts instance
            this.echarts.dispose(this.ele);
        }
    };
    /**
     * render a new echarts instance
     */ EChartsReactCore.prototype.renderNewEcharts = function() {
        var _this = this;
        var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
        // 1. new echarts instance
        var echartsInstance = this.updateEChartsOption();
        // 2. bind events
        this.bindEvents(echartsInstance, onEvents || {});
        // 3. on chart ready
        if ((0, $eBzeD.isFunction)(onChartReady)) onChartReady(echartsInstance);
        // 4. on resize
        if (this.ele) (0, $grS0X.bind)(this.ele, function() {
            _this.resize();
        });
    };
    // bind the events
    EChartsReactCore.prototype.bindEvents = function(instance, events) {
        function _bindEvent(eventName, func) {
            // ignore the event config which not satisfy
            if ((0, $lj6jE.isString)(eventName) && (0, $eBzeD.isFunction)(func)) // binding event
            instance.on(eventName, function(param) {
                func(param, instance);
            });
        }
        // loop and bind
        for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
    };
    /**
     * render the echarts
     */ EChartsReactCore.prototype.updateEChartsOption = function() {
        var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
        // 1. get or initial the echarts object
        var echartInstance = this.getEchartsInstance();
        // 2. set the echarts option
        echartInstance.setOption(option, notMerge, lazyUpdate);
        // 3. set loading mask
        if (showLoading) echartInstance.showLoading(loadingOption);
        else echartInstance.hideLoading();
        return echartInstance;
    };
    /**
     * resize wrapper
     */ EChartsReactCore.prototype.resize = function() {
        // 1. get the echarts object
        var echartsInstance = this.getEchartsInstance();
        // 2. call echarts instance resize if not the initial resize
        // resize should not happen on first render as it will cancel initial echarts animations
        if (!this.isInitialResize) try {
            echartsInstance.resize();
        } catch (e) {
            console.warn(e);
        }
        // 3. update variable for future calls
        this.isInitialResize = false;
    };
    EChartsReactCore.prototype.render = function() {
        var _this = this;
        var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
        // default height = 300
        var newStyle = (0, $3VFsf.__assign)({
            height: 300
        }, style);
        return $ffdbb37eea52750b$var$react_1.default.createElement("div", {
            ref: function(e) {
                _this.ele = e;
            },
            style: newStyle,
            className: "echarts-for-react " + className
        });
    };
    return EChartsReactCore;
}($ffdbb37eea52750b$var$react_1.PureComponent);
module.exports.default = $ffdbb37eea52750b$var$EChartsReactCore;

});
parcelRegister("grS0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ver = module.exports.clear = module.exports.bind = void 0;

var $8x2zG = parcelRequire("8x2zG");
/**
 * Created by hustcc on 18/6/9.[高考时间]
 * Contract: i@hust.cc
 */ /**
 * bind an element with resize callback function
 * @param {*} element
 * @param {*} cb
 */ var $bf9911179e98088f$var$bind = function bind(element, cb) {
    var sensor = (0, $8x2zG.getSensor)(element); // listen with callback
    sensor.bind(cb); // return unbind function
    return function() {
        sensor.unbind(cb);
    };
};
/**
 * clear all the listener and sensor of an element
 * @param element
 */ module.exports.bind = $bf9911179e98088f$var$bind;
var $bf9911179e98088f$var$clear = function clear(element) {
    var sensor = (0, $8x2zG.getSensor)(element);
    (0, $8x2zG.removeSensor)(sensor);
};
module.exports.clear = $bf9911179e98088f$var$clear;
var $bf9911179e98088f$var$ver = "1.0.1";
module.exports.ver = $bf9911179e98088f$var$ver;

});
parcelRegister("8x2zG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeSensor = module.exports.getSensor = void 0;

var $6363670a61880ddf$var$_id = $6363670a61880ddf$var$_interopRequireDefault((parcelRequire("fiP6o")));

var $gWzBv = parcelRequire("gWzBv");

var $cdrHo = parcelRequire("cdrHo");
function $6363670a61880ddf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ /**
 * all the sensor objects.
 * sensor pool
 */ var $6363670a61880ddf$var$Sensors = {};
/**
 * get one sensor
 * @param element
 * @returns {*}
 */ var $6363670a61880ddf$var$getSensor = function getSensor(element) {
    var sensorId = element.getAttribute($cdrHo.SizeSensorId); // 1. if the sensor exists, then use it
    if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) return $6363670a61880ddf$var$Sensors[sensorId];
     // 2. not exist, then create one
    var newId = (0, $6363670a61880ddf$var$_id["default"])();
    element.setAttribute($cdrHo.SizeSensorId, newId);
    var sensor = (0, $gWzBv.createSensor)(element); // add sensor into pool
    $6363670a61880ddf$var$Sensors[newId] = sensor;
    return sensor;
};
/**
 * 移除 sensor
 * @param sensor
 */ module.exports.getSensor = $6363670a61880ddf$var$getSensor;
var $6363670a61880ddf$var$removeSensor = function removeSensor(sensor) {
    var sensorId = sensor.element.getAttribute($cdrHo.SizeSensorId); // remove attribute
    sensor.element.removeAttribute($cdrHo.SizeSensorId); // remove event, dom of the sensor used
    sensor.destroy(); // exist, then remove from pool
    if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) delete $6363670a61880ddf$var$Sensors[sensorId];
};
module.exports.removeSensor = $6363670a61880ddf$var$removeSensor;

});
parcelRegister("fiP6o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $b2402d3f57c74659$var$id = 1;
/**
 * generate unique id in application
 * @return {string}
 */ var $b2402d3f57c74659$var$_default = function _default() {
    return "".concat($b2402d3f57c74659$var$id++);
};
module.exports["default"] = $b2402d3f57c74659$var$_default;

});

parcelRegister("gWzBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $1oYX1 = parcelRequire("1oYX1");

var $gxB4H = parcelRequire("gxB4H");
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ /**
 * sensor strategies
 */ // export const createSensor = createObjectSensor;
var $c55dae5359197dfc$var$createSensor = typeof ResizeObserver !== 'undefined' ? $gxB4H.createSensor : $1oYX1.createSensor;
module.exports.createSensor = $c55dae5359197dfc$var$createSensor;

});
parcelRegister("1oYX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $10574fe90a26a00a$var$_debounce = $10574fe90a26a00a$var$_interopRequireDefault((parcelRequire("hwNQ2")));

var $cdrHo = parcelRequire("cdrHo");
function $10574fe90a26a00a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $10574fe90a26a00a$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * create object DOM of sensor
   * @returns {HTMLObjectElement}
   */ var newSensor = function newSensor() {
        // adjust style
        if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
        var obj = document.createElement('object');
        obj.onload = function() {
            obj.contentDocument.defaultView.addEventListener('resize', resizeListener); // 直接触发一次 resize
            resizeListener();
        };
        obj.style.display = 'block';
        obj.style.position = 'absolute';
        obj.style.top = '0';
        obj.style.left = '0';
        obj.style.height = '100%';
        obj.style.width = '100%';
        obj.style.overflow = 'hidden';
        obj.style.pointerEvents = 'none';
        obj.style.zIndex = '-1';
        obj.style.opacity = '0';
        obj.setAttribute('class', $cdrHo.SensorClassName);
        obj.setAttribute('tabindex', $cdrHo.SensorTabIndex);
        obj.type = 'text/html'; // append into dom
        element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
        obj.data = 'about:blank';
        return obj;
    };
    /**
   * trigger listeners
   */ var resizeListener = (0, $10574fe90a26a00a$var$_debounce["default"])(function() {
        // trigger all listener
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * listen with one callback function
   * @param cb
   */ var bind = function bind(cb) {
        // if not exist sensor, then create one
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy all
   */ var destroy = function destroy() {
        if (sensor && sensor.parentNode) {
            if (sensor.contentDocument) // remote event
            sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
             // remove dom
            sensor.parentNode.removeChild(sensor); // initial variable
            sensor = undefined;
            listeners = [];
        }
    };
    /**
   * cancel listener bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $10574fe90a26a00a$var$createSensor;

});
parcelRegister("hwNQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $cc2c15b4a43e3633$var$_default = function _default(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var timer = null;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, delay);
    };
};
module.exports["default"] = $cc2c15b4a43e3633$var$_default;

});

parcelRegister("cdrHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $8e4c2f559be5b9b7$var$SizeSensorId = 'size-sensor-id';
module.exports.SizeSensorId = $8e4c2f559be5b9b7$var$SizeSensorId;
var $8e4c2f559be5b9b7$var$SensorClassName = 'size-sensor-object';
module.exports.SensorClassName = $8e4c2f559be5b9b7$var$SensorClassName;
var $8e4c2f559be5b9b7$var$SensorTabIndex = '-1';
module.exports.SensorTabIndex = $8e4c2f559be5b9b7$var$SensorTabIndex;

});


parcelRegister("gxB4H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $c0ac7cab0e8dcc43$var$_debounce = $c0ac7cab0e8dcc43$var$_interopRequireDefault((parcelRequire("hwNQ2")));
function $c0ac7cab0e8dcc43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ var $c0ac7cab0e8dcc43$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * trigger listeners
   */ var resizeListener = (0, $c0ac7cab0e8dcc43$var$_debounce["default"])(function() {
        // trigger all
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * create ResizeObserver sensor
   * @returns
   */ var newSensor = function newSensor() {
        var s = new ResizeObserver(resizeListener); // listen element
        s.observe(element); // trigger once
        resizeListener();
        return s;
    };
    /**
   * listen with callback
   * @param cb
   */ var bind = function bind(cb) {
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy
   */ var destroy = function destroy() {
        sensor.disconnect();
        listeners = [];
        sensor = undefined;
    };
    /**
   * cancel bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $c0ac7cab0e8dcc43$var$createSensor;

});




parcelRegister("6gLUT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pick = void 0;
/**
 * 保留 object 中的部分内容
 * @param obj
 * @param keys
 */ function $490967eff7da5641$var$pick(obj, keys) {
    var r = {};
    keys.forEach(function(key) {
        r[key] = obj[key];
    });
    return r;
}
module.exports.pick = $490967eff7da5641$var$pick;

});

parcelRegister("eBzeD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFunction = void 0;
function $aa1fda532dd852be$var$isFunction(v) {
    return typeof v === 'function';
}
module.exports.isFunction = $aa1fda532dd852be$var$isFunction;

});

parcelRegister("lj6jE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isString = void 0;
function $f83045889662a498$var$isString(v) {
    return typeof v === 'string';
}
module.exports.isString = $f83045889662a498$var$isString;

});

parcelRegister("1pywT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEqual = void 0;

var $3VFsf = parcelRequire("3VFsf");

var $1072e91c08f205e9$var$fast_deep_equal_1 = (0, $3VFsf.__importDefault)((parcelRequire("1SBaA")));
module.exports.isEqual = $1072e91c08f205e9$var$fast_deep_equal_1.default;

});
parcelRegister("1SBaA", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});



parcelRegister("5QGgH", function(module, exports) {

$parcel$export(module.exports, "install", () => $442298b05d2dae48$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8MyDE = parcelRequire("8MyDE");

var $9UN8r = parcelRequire("9UN8r");

var $5xgWc = parcelRequire("5xgWc");
function $442298b05d2dae48$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $8MyDE.default));
    registers.registerSeriesModel((0, $9UN8r.default));
    registers.registerLayout((0, $5xgWc.default)('effectScatter'));
}

});
parcelRegister("8MyDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $664dace6b77f6f66$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $5DXGq = parcelRequire("5DXGq");

var $8Jx6o = parcelRequire("8Jx6o");

var $izqgC = parcelRequire("izqgC");

var $5xgWc = parcelRequire("5xgWc");

var $loerw = parcelRequire("loerw");
var $664dace6b77f6f66$var$EffectScatterView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $5DXGq.default)((0, $8Jx6o.default));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $5xgWc.default)('').reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $izqgC.clone(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = 'effectScatter';
    return EffectScatterView;
}((0, $loerw.default));
var $664dace6b77f6f66$export$2e2bcd8739ae039 = $664dace6b77f6f66$var$EffectScatterView;

});
parcelRegister("5DXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bee41b01adf88e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $lUzII = parcelRequire("lUzII");

var $bahqM = parcelRequire("bahqM");

var $gvLUt = parcelRequire("gvLUt");
function $41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx) // We do not set clipShape on group, because it will cut part of
    ) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $41bee41b01adf88e$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $bahqM.isObject)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $41bee41b01adf88e$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $gvLUt.getLabelStatesModels)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $41bee41b01adf88e$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $4KVOr.default();
        this._SymbolCtor = SymbolCtor || (0, $lUzII.default);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        }; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$41bee41b01adf88e$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl // Create a new if symbol type changed.
             || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $eYgMC.updateProps(symbolEl, target, seriesModel);
            } // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            });
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.isPersistent = function() {
        return true;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $41bee41b01adf88e$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        opt = $41bee41b01adf88e$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($41bee41b01adf88e$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
            }
        }
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data; // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            });
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $41bee41b01adf88e$export$2e2bcd8739ae039 = $41bee41b01adf88e$var$SymbolDraw;

});
parcelRegister("4KVOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $37684daaaf15bf3f$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $7KVc5 = parcelRequire("7KVc5");

var $1E3E8 = parcelRequire("1E3E8");
var $37684daaaf15bf3f$var$Group = function(_super) {
    (0, $3VFsf.__extends)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $bahqM.indexOf(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $bahqM.indexOf(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1E3E8.default).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $7KVc5.default));
$37684daaaf15bf3f$var$Group.prototype.type = 'group';
var $37684daaaf15bf3f$export$2e2bcd8739ae039 = $37684daaaf15bf3f$var$Group;

});
parcelRegister("bahqM", function(module, exports) {

$parcel$export(module.exports, "$override", () => $820e264882d7264f$export$d35a04b83ea6803e);
$parcel$export(module.exports, "guid", () => $820e264882d7264f$export$46e8f25c7328f77e);
$parcel$export(module.exports, "logError", () => $820e264882d7264f$export$58da9968c3170cb1);
$parcel$export(module.exports, "clone", () => $820e264882d7264f$export$9cd59f9826255e47);
$parcel$export(module.exports, "isPrimitive", () => $820e264882d7264f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isDom", () => $820e264882d7264f$export$9f57505b7bd8dae);
$parcel$export(module.exports, "merge", () => $820e264882d7264f$export$4950aa0f605343fb);
$parcel$export(module.exports, "isObject", () => $820e264882d7264f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isArray", () => $820e264882d7264f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isBuiltInObject", () => $820e264882d7264f$export$fa523b2c4941fd4f);
$parcel$export(module.exports, "mergeAll", () => $820e264882d7264f$export$18aef43295bbe906);
$parcel$export(module.exports, "extend", () => $820e264882d7264f$export$8b58be045bf06082);
$parcel$export(module.exports, "defaults", () => $820e264882d7264f$export$ebe90cb607ad99e);
$parcel$export(module.exports, "keys", () => $820e264882d7264f$export$ed97f33186d4b816);
$parcel$export(module.exports, "createCanvas", () => $820e264882d7264f$export$cd3d1f114b139967);
$parcel$export(module.exports, "indexOf", () => $820e264882d7264f$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "inherits", () => $820e264882d7264f$export$69f1b2dcda23c5f8);
$parcel$export(module.exports, "mixin", () => $820e264882d7264f$export$e36fc9d62a853069);
$parcel$export(module.exports, "isArrayLike", () => $820e264882d7264f$export$1e2f57719e155213);
$parcel$export(module.exports, "each", () => $820e264882d7264f$export$79b2f7037acddd43);
$parcel$export(module.exports, "map", () => $820e264882d7264f$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $820e264882d7264f$export$58adb3bec8346d0f);
$parcel$export(module.exports, "reduce", () => $820e264882d7264f$export$533b26079ad0b4b);
$parcel$export(module.exports, "filter", () => $820e264882d7264f$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $820e264882d7264f$export$71aa6c912b956294);
$parcel$export(module.exports, "bind", () => $820e264882d7264f$export$2385a24977818dd0);
$parcel$export(module.exports, "isFunction", () => $820e264882d7264f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "curry", () => $820e264882d7264f$export$c3095a23b368d1f2);
$parcel$export(module.exports, "isString", () => $820e264882d7264f$export$844ec244b1367d54);
$parcel$export(module.exports, "isStringSafe", () => $820e264882d7264f$export$29d0bb2a4e07b252);
$parcel$export(module.exports, "isNumber", () => $820e264882d7264f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isTypedArray", () => $820e264882d7264f$export$b119cc7e1840e59c);
$parcel$export(module.exports, "isGradientObject", () => $820e264882d7264f$export$fa2c283003ed971c);
$parcel$export(module.exports, "isImagePatternObject", () => $820e264882d7264f$export$a49bbf3a55dcef7b);
$parcel$export(module.exports, "isRegExp", () => $820e264882d7264f$export$49841c62b9eff15);
$parcel$export(module.exports, "eqNaN", () => $820e264882d7264f$export$7d667b9a0c48c975);
$parcel$export(module.exports, "retrieve", () => $820e264882d7264f$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "retrieve2", () => $820e264882d7264f$export$995e01f2f5c9d030);
$parcel$export(module.exports, "retrieve3", () => $820e264882d7264f$export$2e94551289abb95b);
$parcel$export(module.exports, "normalizeCssArray", () => $820e264882d7264f$export$f3a38102c49f4268);
$parcel$export(module.exports, "assert", () => $820e264882d7264f$export$a7a9523472993e97);
$parcel$export(module.exports, "trim", () => $820e264882d7264f$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "setAsPrimitive", () => $820e264882d7264f$export$112e66431016387b);
$parcel$export(module.exports, "HashMap", () => $820e264882d7264f$export$60ef0b43d585640a);
$parcel$export(module.exports, "createHashMap", () => $820e264882d7264f$export$55f8aa7ef875b0a4);
$parcel$export(module.exports, "concatArray", () => $820e264882d7264f$export$4fd8af2c48c43416);
$parcel$export(module.exports, "createObject", () => $820e264882d7264f$export$79c7e160a7743efd);
$parcel$export(module.exports, "hasOwn", () => $820e264882d7264f$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "noop", () => $820e264882d7264f$export$8793edee2d425525);
var $820e264882d7264f$var$BUILTIN_OBJECT = {
    '[object Function]': true,
    '[object RegExp]': true,
    '[object Date]': true,
    '[object Error]': true,
    '[object CanvasGradient]': true,
    '[object CanvasPattern]': true,
    '[object Image]': true,
    '[object Canvas]': true
};
var $820e264882d7264f$var$TYPED_ARRAY = {
    '[object Int8Array]': true,
    '[object Uint8Array]': true,
    '[object Uint8ClampedArray]': true,
    '[object Int16Array]': true,
    '[object Uint16Array]': true,
    '[object Int32Array]': true,
    '[object Uint32Array]': true,
    '[object Float32Array]': true,
    '[object Float64Array]': true
};
var $820e264882d7264f$var$objToString = Object.prototype.toString;
var $820e264882d7264f$var$arrayProto = Array.prototype;
var $820e264882d7264f$var$nativeForEach = $820e264882d7264f$var$arrayProto.forEach;
var $820e264882d7264f$var$nativeFilter = $820e264882d7264f$var$arrayProto.filter;
var $820e264882d7264f$var$nativeSlice = $820e264882d7264f$var$arrayProto.slice;
var $820e264882d7264f$var$nativeMap = $820e264882d7264f$var$arrayProto.map;
var $820e264882d7264f$var$ctorFunction = (function() {}).constructor;
var $820e264882d7264f$var$protoFunction = $820e264882d7264f$var$ctorFunction ? $820e264882d7264f$var$ctorFunction.prototype : null;
var $820e264882d7264f$var$protoKey = '__proto__';
var $820e264882d7264f$var$methods = {};
function $820e264882d7264f$export$d35a04b83ea6803e(name, fn) {
    $820e264882d7264f$var$methods[name] = fn;
}
var $820e264882d7264f$var$idStart = 0x0907;
function $820e264882d7264f$export$46e8f25c7328f77e() {
    return $820e264882d7264f$var$idStart++;
}
function $820e264882d7264f$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $820e264882d7264f$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $820e264882d7264f$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
        }
    } else if ($820e264882d7264f$var$TYPED_ARRAY[typeStr]) {
        if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
            }
        }
    } else if (!$820e264882d7264f$var$BUILTIN_OBJECT[typeStr] && !$820e264882d7264f$export$c3825b437cbdea5c(source) && !$820e264882d7264f$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) result[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $820e264882d7264f$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$820e264882d7264f$export$a6cdc56e425d0d0a(source) || !$820e264882d7264f$export$a6cdc56e425d0d0a(target)) return overwrite ? $820e264882d7264f$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($820e264882d7264f$export$a6cdc56e425d0d0a(sourceProp) && $820e264882d7264f$export$a6cdc56e425d0d0a(targetProp) && !$820e264882d7264f$export$43bee75e5e14138e(sourceProp) && !$820e264882d7264f$export$43bee75e5e14138e(targetProp) && !$820e264882d7264f$export$9f57505b7bd8dae(sourceProp) && !$820e264882d7264f$export$9f57505b7bd8dae(targetProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(sourceProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(targetProp) && !$820e264882d7264f$export$c3825b437cbdea5c(sourceProp) && !$820e264882d7264f$export$c3825b437cbdea5c(targetProp)) $820e264882d7264f$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $820e264882d7264f$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $820e264882d7264f$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $820e264882d7264f$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $820e264882d7264f$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $820e264882d7264f$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $820e264882d7264f$export$cd3d1f114b139967 = function() {
    return $820e264882d7264f$var$methods.createCanvas();
};
$820e264882d7264f$var$methods.createCanvas = function() {
    return document.createElement('canvas');
};
function $820e264882d7264f$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $820e264882d7264f$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $820e264882d7264f$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $820e264882d7264f$export$ebe90cb607ad99e(target, source, override);
}
function $820e264882d7264f$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $820e264882d7264f$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $820e264882d7264f$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $820e264882d7264f$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $820e264882d7264f$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $820e264882d7264f$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $820e264882d7264f$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $820e264882d7264f$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $820e264882d7264f$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $820e264882d7264f$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $820e264882d7264f$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
    };
}
var $820e264882d7264f$export$2385a24977818dd0 = $820e264882d7264f$var$protoFunction && $820e264882d7264f$export$f6e2535fb5126e54($820e264882d7264f$var$protoFunction.bind) ? $820e264882d7264f$var$protoFunction.call.bind($820e264882d7264f$var$protoFunction.bind) : $820e264882d7264f$var$bindPolyfill;
function $820e264882d7264f$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
    };
}
function $820e264882d7264f$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $820e264882d7264f$var$objToString.call(value) === '[object Array]';
}
function $820e264882d7264f$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $820e264882d7264f$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $820e264882d7264f$export$29d0bb2a4e07b252(value) {
    return $820e264882d7264f$var$objToString.call(value) === '[object String]';
}
function $820e264882d7264f$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $820e264882d7264f$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $820e264882d7264f$export$fa523b2c4941fd4f(value) {
    return !!$820e264882d7264f$var$BUILTIN_OBJECT[$820e264882d7264f$var$objToString.call(value)];
}
function $820e264882d7264f$export$b119cc7e1840e59c(value) {
    return !!$820e264882d7264f$var$TYPED_ARRAY[$820e264882d7264f$var$objToString.call(value)];
}
function $820e264882d7264f$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $820e264882d7264f$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $820e264882d7264f$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $820e264882d7264f$export$49841c62b9eff15(value) {
    return $820e264882d7264f$var$objToString.call(value) === '[object RegExp]';
}
function $820e264882d7264f$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $820e264882d7264f$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $820e264882d7264f$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $820e264882d7264f$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $820e264882d7264f$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $820e264882d7264f$var$nativeSlice.apply(arr, args);
}
function $820e264882d7264f$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $820e264882d7264f$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $820e264882d7264f$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $820e264882d7264f$var$primitiveKey = '__ec_primitive__';
function $820e264882d7264f$export$112e66431016387b(obj) {
    obj[$820e264882d7264f$var$primitiveKey] = true;
}
function $820e264882d7264f$export$c3825b437cbdea5c(obj) {
    return obj[$820e264882d7264f$var$primitiveKey];
}
var $820e264882d7264f$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        this.data = {};
        var isArr = $820e264882d7264f$export$43bee75e5e14138e(obj);
        this.data = {};
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $820e264882d7264f$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.get = function(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    };
    HashMap.prototype.set = function(key, value) {
        return this.data[key] = value;
    };
    HashMap.prototype.each = function(cb, context) {
        for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
    };
    HashMap.prototype.keys = function() {
        return $820e264882d7264f$export$ed97f33186d4b816(this.data);
    };
    HashMap.prototype.removeKey = function(key) {
        delete this.data[key];
    };
    return HashMap;
}();
function $820e264882d7264f$export$55f8aa7ef875b0a4(obj) {
    return new $820e264882d7264f$export$60ef0b43d585640a(obj);
}
function $820e264882d7264f$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $820e264882d7264f$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $820e264882d7264f$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $820e264882d7264f$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $820e264882d7264f$export$8793edee2d425525() {}

});

parcelRegister("7KVc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5931cff6ff005a$export$2e2bcd8739ae039);

var $e6gef = parcelRequire("e6gef");

var $hb2y5 = parcelRequire("hb2y5");

var $1E3E8 = parcelRequire("1E3E8");

var $bRKv5 = parcelRequire("bRKv5");

var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");

var $7y1my = parcelRequire("7y1my");

var $d6udH = parcelRequire("d6udH");

var $hZfwb = parcelRequire("hZfwb");

var $aVawM = parcelRequire("aVawM");
var $5a5931cff6ff005a$export$97b5e845c7286801 = '__zr_normal__';
var $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS = [
    'x',
    'y',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'rotation',
    'ignore'
];
var $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP = {
    x: true,
    y: true,
    scaleX: true,
    scaleY: true,
    originX: true,
    originY: true,
    rotation: true,
    ignore: false
};
var $5a5931cff6ff005a$var$tmpTextPosCalcRes = {};
var $5a5931cff6ff005a$var$tmpBoundingRect = new (0, $1E3E8.default)(0, 0, 0, 0);
var $5a5931cff6ff005a$var$Element = function() {
    function Element(props) {
        this.id = (0, $bahqM.guid)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $5a5931cff6ff005a$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $b7ZX8.calculateTextPosition)($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $5a5931cff6ff005a$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $5a5931cff6ff005a$var$tmpTextPosCalcRes.y;
                textAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $b7ZX8.parsePercent)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $b7ZX8.parsePercent)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $aVawM.REDRAW_BIT);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $7y1my.LIGHT_LABEL_COLOR) : (0, $7y1my.DARK_LABEL_COLOR);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $d6udH.parse)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $d6udH.stringify)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $bahqM.extend)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $bahqM.isObject)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $bahqM.keys)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (fromStateTransition && fromStateTransition !== $5a5931cff6ff005a$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveFinalToTarget(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($5a5931cff6ff005a$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $5a5931cff6ff005a$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $bahqM.indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $bahqM.logError)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $aVawM.REDRAW_BIT);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $aVawM.REDRAW_BIT);
            }
        }
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $bahqM.indexOf)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $bahqM.indexOf)(currentStates, oldState);
        var newStateExists = (0, $bahqM.indexOf)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $bahqM.extend)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $bahqM.extend)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $bahqM.extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $bahqM.extend)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        if (componentEl === this) throw new Error('Recursive component attachment.');
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        textEl.innerTransformable = new (0, $e6gef.default)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $bahqM.extend)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $aVawM.REDRAW_BIT);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop) {
        var target = key ? this[key] : this;
        if (!target) {
            (0, $bahqM.logError)('Property "' + key + '" is not existed in element ' + this.id);
            return;
        }
        var animator = new (0, $hb2y5.default)(target, loop);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $bahqM.indexOf)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = false;
        elProto.silent = false;
        elProto.isGroup = false;
        elProto.draggable = false;
        elProto.dragging = false;
        elProto.ignoreClip = false;
        elProto.__inHover = false;
        elProto.__dirty = (0, $aVawM.REDRAW_BIT);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    logDeprecatedError(key, xKey, yKey);
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    logDeprecatedError(key, xKey, yKey);
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty && (!(0, $hZfwb.default).browser.ie || (0, $hZfwb.default).browser.version > 8)) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $bahqM.mixin)($5a5931cff6ff005a$var$Element, (0, $bRKv5.default));
(0, $bahqM.mixin)($5a5931cff6ff005a$var$Element, (0, $e6gef.default));
function $5a5931cff6ff005a$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $5a5931cff6ff005a$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        animator.start(cfg.easing, cfg.force);
    }
    return animators;
}
function $5a5931cff6ff005a$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $5a5931cff6ff005a$var$is2DArray(value) {
    return (0, $bahqM.isArrayLike)(value[0]);
}
function $5a5931cff6ff005a$var$copyValue(target, source, key) {
    if ((0, $bahqM.isArrayLike)(source[key])) {
        if (!(0, $bahqM.isArrayLike)(target[key])) target[key] = [];
        if ((0, $bahqM.isTypedArray)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $5a5931cff6ff005a$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($5a5931cff6ff005a$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $5a5931cff6ff005a$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $5a5931cff6ff005a$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $5a5931cff6ff005a$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
    var animatableKeys = [];
    var changedKeys = [];
    var targetKeys = (0, $bahqM.keys)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $bahqM.isObject)(animationProps);
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $bahqM.isObject)(target[innerKey]) && !(0, $bahqM.isArrayLike)(target[innerKey])) {
                if (topKey) {
                    if (!reverse) {
                        source[innerKey] = target[innerKey];
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $5a5931cff6ff005a$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else {
                animatableKeys.push(innerKey);
                changedKeys.push(innerKey);
            }
        } else if (!reverse) {
            source[innerKey] = target[innerKey];
            animatable.updateDuringAnimation(topKey);
            changedKeys.push(innerKey);
        }
    }
    var keyLen = animatableKeys.length;
    if (keyLen > 0 || cfg.force && !animators.length) {
        var existsAnimators = animatable.animators;
        var existsAnimatorsOnSameTarget = [];
        for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
        if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
            var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
            if (allAborted) {
                var idx = (0, $bahqM.indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                existsAnimators.splice(idx, 1);
            }
        }
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                reversedTarget[innerKey] = source[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else source[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                sourceClone[innerKey] = (0, $hb2y5.cloneValue)(source[innerKey]);
                $5a5931cff6ff005a$var$copyValue(source, target, innerKey);
            }
        }
        var animator = new (0, $hb2y5.default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $5a5931cff6ff005a$export$2e2bcd8739ae039 = $5a5931cff6ff005a$var$Element;

});
parcelRegister("e6gef", function(module, exports) {

$parcel$export(module.exports, "default", () => $a43e36ee3f294c25$export$2e2bcd8739ae039);

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");
var $a43e36ee3f294c25$var$mIdentity = $izqgC.identity;
var $a43e36ee3f294c25$var$EPSILON = 5e-5;
function $a43e36ee3f294c25$var$isNotAroundZero(val) {
    return val > $a43e36ee3f294c25$var$EPSILON || val < -$a43e36ee3f294c25$var$EPSILON;
}
var $a43e36ee3f294c25$var$scaleTmp = [];
var $a43e36ee3f294c25$var$tmpTransform = [];
var $a43e36ee3f294c25$var$originTransform = $izqgC.create();
var $a43e36ee3f294c25$var$abs = Math.abs;
var $a43e36ee3f294c25$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $a43e36ee3f294c25$var$isNotAroundZero(this.rotation) || $a43e36ee3f294c25$var$isNotAroundZero(this.x) || $a43e36ee3f294c25$var$isNotAroundZero(this.y) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleX - 1) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleY - 1);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && $a43e36ee3f294c25$var$mIdentity(m);
            return;
        }
        m = m || $izqgC.create();
        if (needLocalTransform) this.getLocalTransform(m);
        else $a43e36ee3f294c25$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $izqgC.mul(m, parentTransform, m);
            else $izqgC.copy(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($a43e36ee3f294c25$var$scaleTmp);
            var relX = $a43e36ee3f294c25$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $a43e36ee3f294c25$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($a43e36ee3f294c25$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a43e36ee3f294c25$var$scaleTmp[0] || 0;
            var sy = (($a43e36ee3f294c25$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a43e36ee3f294c25$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $izqgC.create();
        $izqgC.invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            $izqgC.mul($a43e36ee3f294c25$var$tmpTransform, parent.invTransform, m);
            m = $a43e36ee3f294c25$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $a43e36ee3f294c25$var$originTransform[4] = ox;
            $a43e36ee3f294c25$var$originTransform[5] = oy;
            $izqgC.mul($a43e36ee3f294c25$var$tmpTransform, m, $a43e36ee3f294c25$var$originTransform);
            $a43e36ee3f294c25$var$tmpTransform[4] -= ox;
            $a43e36ee3f294c25$var$tmpTransform[5] -= oy;
            m = $a43e36ee3f294c25$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $eLEew.applyTransform(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $eLEew.applyTransform(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $a43e36ee3f294c25$var$abs(m[0] - 1) > 1e-10 && $a43e36ee3f294c25$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a43e36ee3f294c25$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        var target = this;
        for(var i = 0; i < $a43e36ee3f294c25$export$98ab6203ec3396e2.length; i++){
            var propName = $a43e36ee3f294c25$export$98ab6203ec3396e2[i];
            target[propName] = source[propName];
        }
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy) {
            m[4] = -ox * sx - skewX * oy * sy;
            m[5] = -oy * sy - skewY * ox * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $izqgC.rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.x = 0;
        proto.y = 0;
        proto.scaleX = 1;
        proto.scaleY = 1;
        proto.originX = 0;
        proto.originY = 0;
        proto.skewX = 0;
        proto.skewY = 0;
        proto.rotation = 0;
        proto.globalScaleRatio = 1;
    }();
    return Transformable;
}();
var $a43e36ee3f294c25$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
var $a43e36ee3f294c25$export$2e2bcd8739ae039 = $a43e36ee3f294c25$var$Transformable;

});
parcelRegister("izqgC", function(module, exports) {

$parcel$export(module.exports, "create", () => $d84fdef7d2e904e1$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $d84fdef7d2e904e1$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $d84fdef7d2e904e1$export$784d13d8ee351f07);
$parcel$export(module.exports, "mul", () => $d84fdef7d2e904e1$export$6e3a27864ab166fe);
$parcel$export(module.exports, "translate", () => $d84fdef7d2e904e1$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $d84fdef7d2e904e1$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $d84fdef7d2e904e1$export$dcdf75081b88279d);
$parcel$export(module.exports, "invert", () => $d84fdef7d2e904e1$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "clone", () => $d84fdef7d2e904e1$export$9cd59f9826255e47);
function $d84fdef7d2e904e1$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $d84fdef7d2e904e1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $d84fdef7d2e904e1$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $d84fdef7d2e904e1$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $d84fdef7d2e904e1$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $d84fdef7d2e904e1$export$bb628a54ab399bc9(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function $d84fdef7d2e904e1$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $d84fdef7d2e904e1$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $d84fdef7d2e904e1$export$9cd59f9826255e47(a) {
    var b = $d84fdef7d2e904e1$export$185802fd694ee1f5();
    $d84fdef7d2e904e1$export$784d13d8ee351f07(b, a);
    return b;
}

});

parcelRegister("eLEew", function(module, exports) {

$parcel$export(module.exports, "create", () => $ac04a9f644701697$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $ac04a9f644701697$export$784d13d8ee351f07);
$parcel$export(module.exports, "clone", () => $ac04a9f644701697$export$9cd59f9826255e47);
$parcel$export(module.exports, "set", () => $ac04a9f644701697$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $ac04a9f644701697$export$e16d8520af44a096);
$parcel$export(module.exports, "scaleAndAdd", () => $ac04a9f644701697$export$19cedf1da84ba854);
$parcel$export(module.exports, "sub", () => $ac04a9f644701697$export$f93b5905241a7cca);
$parcel$export(module.exports, "len", () => $ac04a9f644701697$export$fc1400facf92c78);
$parcel$export(module.exports, "lenSquare", () => $ac04a9f644701697$export$48e33bc611e4c25a);
$parcel$export(module.exports, "length", () => $ac04a9f644701697$export$f24224f1c91d8156);
$parcel$export(module.exports, "lengthSquare", () => $ac04a9f644701697$export$2f106540dd9a5136);
$parcel$export(module.exports, "mul", () => $ac04a9f644701697$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $ac04a9f644701697$export$159d9494db57879b);
$parcel$export(module.exports, "dot", () => $ac04a9f644701697$export$94132a0e348806d4);
$parcel$export(module.exports, "scale", () => $ac04a9f644701697$export$dcdf75081b88279d);
$parcel$export(module.exports, "normalize", () => $ac04a9f644701697$export$a3295358bff77e);
$parcel$export(module.exports, "distance", () => $ac04a9f644701697$export$9f17032d917177de);
$parcel$export(module.exports, "dist", () => $ac04a9f644701697$export$6c4a311cc157c764);
$parcel$export(module.exports, "distanceSquare", () => $ac04a9f644701697$export$137c0a69d1ff4a79);
$parcel$export(module.exports, "distSquare", () => $ac04a9f644701697$export$c68db45a034c13b0);
$parcel$export(module.exports, "negate", () => $ac04a9f644701697$export$aef51622e549b8b0);
$parcel$export(module.exports, "lerp", () => $ac04a9f644701697$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "applyTransform", () => $ac04a9f644701697$export$9f9dcb98c894b623);
$parcel$export(module.exports, "min", () => $ac04a9f644701697$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $ac04a9f644701697$export$8960430cfd85939f);
function $ac04a9f644701697$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $ac04a9f644701697$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $ac04a9f644701697$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $ac04a9f644701697$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $ac04a9f644701697$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $ac04a9f644701697$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $ac04a9f644701697$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $ac04a9f644701697$export$fc1400facf92c78(v) {
    return Math.sqrt($ac04a9f644701697$export$48e33bc611e4c25a(v));
}
var $ac04a9f644701697$export$f24224f1c91d8156 = $ac04a9f644701697$export$fc1400facf92c78;
function $ac04a9f644701697$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $ac04a9f644701697$export$2f106540dd9a5136 = $ac04a9f644701697$export$48e33bc611e4c25a;
function $ac04a9f644701697$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $ac04a9f644701697$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $ac04a9f644701697$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $ac04a9f644701697$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $ac04a9f644701697$export$a3295358bff77e(out, v) {
    var d = $ac04a9f644701697$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $ac04a9f644701697$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $ac04a9f644701697$export$6c4a311cc157c764 = $ac04a9f644701697$export$9f17032d917177de;
function $ac04a9f644701697$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $ac04a9f644701697$export$c68db45a034c13b0 = $ac04a9f644701697$export$137c0a69d1ff4a79;
function $ac04a9f644701697$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $ac04a9f644701697$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $ac04a9f644701697$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $ac04a9f644701697$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $ac04a9f644701697$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

});


parcelRegister("hb2y5", function(module, exports) {

$parcel$export(module.exports, "interpolateNumber", () => $c81570e1f313cc39$export$d871d53bd7eeb390);
$parcel$export(module.exports, "cloneValue", () => $c81570e1f313cc39$export$c5e92b7f105af84e);
$parcel$export(module.exports, "default", () => $c81570e1f313cc39$export$2e2bcd8739ae039);

var $kj9w6 = parcelRequire("kj9w6");

var $d6udH = parcelRequire("d6udH");

var $bahqM = parcelRequire("bahqM");
var $c81570e1f313cc39$var$arraySlice = Array.prototype.slice;
function $c81570e1f313cc39$export$d871d53bd7eeb390(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $c81570e1f313cc39$export$35d34bc0ed591a92(p0, p1, percent) {
    return percent > 0.5 ? p1 : p0;
}
function $c81570e1f313cc39$export$f8938d924b05a6eb(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i], p1[i], percent);
}
function $c81570e1f313cc39$export$3297a85eaaa37024(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
    }
}
function $c81570e1f313cc39$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $c81570e1f313cc39$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $c81570e1f313cc39$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $c81570e1f313cc39$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $c81570e1f313cc39$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $c81570e1f313cc39$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
}
function $c81570e1f313cc39$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    var len2 = p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[1] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
    }
}
function $c81570e1f313cc39$export$c5e92b7f105af84e(value) {
    if ((0, $bahqM.isArrayLike)(value)) {
        var len = value.length;
        if ((0, $bahqM.isArrayLike)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($c81570e1f313cc39$var$arraySlice.call(value[i]));
            return ret;
        }
        return $c81570e1f313cc39$var$arraySlice.call(value);
    }
    return value;
}
function $c81570e1f313cc39$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]);
    rgba[1] = Math.floor(rgba[1]);
    rgba[2] = Math.floor(rgba[2]);
    return 'rgba(' + rgba.join(',') + ')';
}
function $c81570e1f313cc39$var$guessArrayDim(value) {
    return (0, $bahqM.isArrayLike)(value && value[0]) ? 2 : 1;
}
var $c81570e1f313cc39$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $c81570e1f313cc39$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.maxTime = 0;
        this.arrDim = 0;
        this.interpolable = true;
        this._needsSort = false;
        this._isAllValueEqual = true;
        this._lastFrame = 0;
        this._lastFramePercent = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, value) {
        if (time >= this.maxTime) this.maxTime = time;
        else this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        if (this.interpolable) {
            if ((0, $bahqM.isArrayLike)(value)) {
                var arrayDim = $c81570e1f313cc39$var$guessArrayDim(value);
                if (len > 0 && this.arrDim !== arrayDim) {
                    this.interpolable = false;
                    return;
                }
                if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                    this.interpolable = false;
                    return;
                }
                if (len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this._isAllValueEqual) {
                        if (arrayDim === 1) {
                            if (!$c81570e1f313cc39$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                        } else this._isAllValueEqual = false;
                    }
                }
                this.arrDim = arrayDim;
            } else {
                if (this.arrDim > 0) {
                    this.interpolable = false;
                    return;
                }
                if (typeof value === 'string') {
                    var colorArray = $d6udH.parse(value);
                    if (colorArray) {
                        value = colorArray;
                        this.isValueColor = true;
                    } else this.interpolable = false;
                } else if (typeof value !== 'number' || isNaN(value)) {
                    this.interpolable = false;
                    return;
                }
                if (this._isAllValueEqual && len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this.isValueColor && !$c81570e1f313cc39$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                    else if (lastFrame.value !== value) this._isAllValueEqual = false;
                }
            }
        }
        var kf = {
            time: time,
            value: value,
            percent: 0
        };
        this.keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var arrDim = this.arrDim;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        for(var i = 0; i < kfsLen; i++){
            kfs[i].percent = kfs[i].time / this.maxTime;
            if (arrDim > 0 && i !== kfsLen - 1) $c81570e1f313cc39$var$fillArray(kfs[i].value, lastKf.value, arrDim);
        }
        if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (arrDim === 0) {
                    if (this.isValueColor) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                    else kfs[i].additiveValue = kfs[i].value - startValue;
                } else if (arrDim === 1) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                else if (arrDim === 2) kfs[i].additiveValue = $c81570e1f313cc39$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var keyframes = this.keyframes;
        var kfsNum = this.keyframes.length;
        var propName = this.propName;
        var arrDim = this.arrDim;
        var isValueColor = this.isValueColor;
        var frameIdx;
        if (percent < 0) frameIdx = 0;
        else if (percent < this._lastFramePercent) {
            var start = Math.min(this._lastFrame + 1, kfsNum - 1);
            for(frameIdx = start; frameIdx >= 0; frameIdx--){
                if (keyframes[frameIdx].percent <= percent) break;
            }
            frameIdx = Math.min(frameIdx, kfsNum - 2);
        } else {
            for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                if (keyframes[frameIdx].percent > percent) break;
            }
            frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
        }
        var nextFrame = keyframes[frameIdx + 1];
        var frame = keyframes[frameIdx];
        if (!(frame && nextFrame)) return;
        this._lastFrame = frameIdx;
        this._lastFramePercent = percent;
        var range = nextFrame.percent - frame.percent;
        if (range === 0) return;
        var w = (percent - frame.percent) / range;
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $c81570e1f313cc39$var$tmpRgba : target[propName];
        if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.useSpline) {
            var p1 = keyframes[frameIdx][valueKey];
            var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
            var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
            var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
            if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $c81570e1f313cc39$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
            else if (isValueColor) {
                $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = p2;
                else value = $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        } else {
            if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $c81570e1f313cc39$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
            else if (isValueColor) {
                $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = $c81570e1f313cc39$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                else value = $c81570e1f313cc39$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var arrDim = this.arrDim;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (arrDim === 0) {
            if (this.isValueColor) {
                $d6udH.parse(target[propName], $c81570e1f313cc39$var$tmpRgba);
                $c81570e1f313cc39$var$add1DArray($c81570e1f313cc39$var$tmpRgba, $c81570e1f313cc39$var$tmpRgba, additiveValue, 1);
                target[propName] = $c81570e1f313cc39$var$rgba2String($c81570e1f313cc39$var$tmpRgba);
            } else target[propName] = target[propName] + additiveValue;
        } else if (arrDim === 1) $c81570e1f313cc39$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (arrDim === 2) $c81570e1f313cc39$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $c81570e1f313cc39$var$Animator = function() {
    function Animator(target, loop, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._delay = 0;
        this._maxTime = 0;
        this._paused = false;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $bahqM.logError)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
    }
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props) {
        return this.whenWithKeys(time, props, (0, $bahqM.keys)(props));
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $c81570e1f313cc39$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.isValueColor && initialValue) initialValue = $c81570e1f313cc39$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time !== 0) track.addKeyframe(0, $c81570e1f313cc39$export$c5e92b7f105af84e(initialValue));
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $c81570e1f313cc39$export$c5e92b7f105af84e(props[propName]));
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing, forceAnimate) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            track.prepare(additiveTrack);
            if (track.needsAnimate()) tracks.push(track);
            else if (!track.interpolable) {
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) self._target[track.propName] = lastKf.value;
            }
        }
        if (tracks.length || forceAnimate) {
            var clip = new (0, $kj9w6.default)({
                life: this._maxTime,
                loop: this._loop,
                delay: this._delay,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing && easing !== 'spline') clip.easing = easing;
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var lastKf = kfs[kfs.length - 1];
            if (lastKf) {
                var val = $c81570e1f313cc39$export$c5e92b7f105af84e(lastKf.value);
                if (track.isValueColor) val = $c81570e1f313cc39$var$rgba2String(val);
                target[propName] = val;
            }
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $bahqM.keys)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $c81570e1f313cc39$export$2e2bcd8739ae039 = $c81570e1f313cc39$var$Animator;

});
parcelRegister("kj9w6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8cf6d19967f888$export$2e2bcd8739ae039);

var $2yJbE = parcelRequire("2yJbE");
var $ec8cf6d19967f888$var$Clip = function() {
    function Clip(opts) {
        this._initialized = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop == null ? false : opts.loop;
        this.gap = opts.gap || 0;
        this.easing = opts.easing || 'linear';
        this.onframe = opts.onframe;
        this.ondestroy = opts.ondestroy;
        this.onrestart = opts.onrestart;
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._initialized) {
            this._startTime = globalTime + this._delay;
            this._initialized = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easing = this.easing;
        var easingFunc = typeof easing === 'string' ? (0, $2yJbE.default)[easing] : easing;
        var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
        this.onframe && this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                this._restart(globalTime);
                this.onrestart && this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype._restart = function(globalTime) {
        var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
        this._startTime = globalTime - remainder + this.gap;
        this._pausedTime = 0;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    return Clip;
}();
var $ec8cf6d19967f888$export$2e2bcd8739ae039 = $ec8cf6d19967f888$var$Clip;

});
parcelRegister("2yJbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd1cef375de2720$export$2e2bcd8739ae039);
var $1dd1cef375de2720$var$easing = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $1dd1cef375de2720$var$easing.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $1dd1cef375de2720$var$easing.bounceIn(k * 2) * 0.5;
        return $1dd1cef375de2720$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $1dd1cef375de2720$export$2e2bcd8739ae039 = $1dd1cef375de2720$var$easing;

});


parcelRegister("d6udH", function(module, exports) {

$parcel$export(module.exports, "parse", () => $98a346fa71cc3009$export$98e6a39c04603d36);
$parcel$export(module.exports, "lift", () => $98a346fa71cc3009$export$590e8b2c435046d9);
$parcel$export(module.exports, "stringify", () => $98a346fa71cc3009$export$fac44ee5b035f737);
$parcel$export(module.exports, "toHex", () => $98a346fa71cc3009$export$7ea66e3774a60b67);
$parcel$export(module.exports, "fastLerp", () => $98a346fa71cc3009$export$66cb3c0e9efc61c8);
$parcel$export(module.exports, "fastMapToColor", () => $98a346fa71cc3009$export$daa5a65daad5df58);
$parcel$export(module.exports, "lerp", () => $98a346fa71cc3009$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "mapToColor", () => $98a346fa71cc3009$export$296e08242b78a3ec);
$parcel$export(module.exports, "modifyHSL", () => $98a346fa71cc3009$export$d898ae866e27bf18);
$parcel$export(module.exports, "modifyAlpha", () => $98a346fa71cc3009$export$ab4754bf42583a26);
$parcel$export(module.exports, "lum", () => $98a346fa71cc3009$export$16c0ec21a6f9ef95);
$parcel$export(module.exports, "random", () => $98a346fa71cc3009$export$4385e60b38654f68);

var $h4RuA = parcelRequire("h4RuA");
var $98a346fa71cc3009$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $98a346fa71cc3009$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $98a346fa71cc3009$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $98a346fa71cc3009$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $98a346fa71cc3009$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $98a346fa71cc3009$var$clampCssByte(parseInt(str, 10));
}
function $98a346fa71cc3009$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str) / 100);
    return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str));
}
function $98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $98a346fa71cc3009$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $98a346fa71cc3009$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $98a346fa71cc3009$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $98a346fa71cc3009$var$colorCache = new (0, $h4RuA.default)(20);
var $98a346fa71cc3009$var$lastRemovedArr = null;
function $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr) {
    if ($98a346fa71cc3009$var$lastRemovedArr) $98a346fa71cc3009$var$copyRgba($98a346fa71cc3009$var$lastRemovedArr, rgbaArr);
    $98a346fa71cc3009$var$lastRemovedArr = $98a346fa71cc3009$var$colorCache.put(colorStr, $98a346fa71cc3009$var$lastRemovedArr || rgbaArr.slice());
}
function $98a346fa71cc3009$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $98a346fa71cc3009$var$colorCache.get(colorStr);
    if (cached) return $98a346fa71cc3009$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $98a346fa71cc3009$var$kCSSColorTable) {
        $98a346fa71cc3009$var$copyRgba(rgbaArr, $98a346fa71cc3009$var$kCSSColorTable[str]);
        $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $98a346fa71cc3009$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $98a346fa71cc3009$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length !== 3) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, $98a346fa71cc3009$var$parseCssInt(params[0]), $98a346fa71cc3009$var$parseCssInt(params[1]), $98a346fa71cc3009$var$parseCssInt(params[2]), alpha);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsla':
                if (params.length !== 4) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $98a346fa71cc3009$var$parseCssFloat(params[3]);
                $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $98a346fa71cc3009$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $98a346fa71cc3009$var$parseCssFloat(hsla[1]);
    var l = $98a346fa71cc3009$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $98a346fa71cc3009$var$setRgba(rgba, $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $98a346fa71cc3009$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $98a346fa71cc3009$export$590e8b2c435046d9(color, level) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $98a346fa71cc3009$export$7ea66e3774a60b67(color) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $98a346fa71cc3009$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $98a346fa71cc3009$export$daa5a65daad5df58 = $98a346fa71cc3009$export$66cb3c0e9efc61c8;
function $98a346fa71cc3009$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $98a346fa71cc3009$export$fac44ee5b035f737([
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $98a346fa71cc3009$export$296e08242b78a3ec = $98a346fa71cc3009$export$3a89f8d6f6bf6c9f;
function $98a346fa71cc3009$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $98a346fa71cc3009$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $98a346fa71cc3009$var$clampCssAngle(h));
        s != null && (colorArr[1] = $98a346fa71cc3009$var$parseCssFloat(s));
        l != null && (colorArr[2] = $98a346fa71cc3009$var$parseCssFloat(l));
        return $98a346fa71cc3009$export$fac44ee5b035f737($98a346fa71cc3009$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $98a346fa71cc3009$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $98a346fa71cc3009$var$clampCssFloat(alpha);
        return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $98a346fa71cc3009$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $98a346fa71cc3009$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $98a346fa71cc3009$export$4385e60b38654f68() {
    var r = Math.round(Math.random() * 255);
    var g = Math.round(Math.random() * 255);
    var b = Math.round(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}

});
parcelRegister("h4RuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039);
var $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $c6ec4ddc95ccc3f1$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $c6ec4ddc95ccc3f1$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $c6ec4ddc95ccc3f1$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039 = $c6ec4ddc95ccc3f1$var$LRU;

});



parcelRegister("1E3E8", function(module, exports) {

$parcel$export(module.exports, "default", () => $132c5af5562dffd4$export$2e2bcd8739ae039);

var $izqgC = parcelRequire("izqgC");

var $bMDnR = parcelRequire("bMDnR");
var $132c5af5562dffd4$var$mathMin = Math.min;
var $132c5af5562dffd4$var$mathMax = Math.max;
var $132c5af5562dffd4$var$lt = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$rb = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$lb = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$rt = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$minTv = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$maxTv = new (0, $bMDnR.default)();
var $132c5af5562dffd4$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $132c5af5562dffd4$var$mathMin(other.x, this.x);
        var y = $132c5af5562dffd4$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $132c5af5562dffd4$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $132c5af5562dffd4$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $izqgC.create();
        $izqgC.translate(m, m, [
            -a.x,
            -a.y
        ]);
        $izqgC.scale(m, m, [
            sx,
            sy
        ]);
        $izqgC.translate(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, -d0, 0);
                    else (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, d0, 0);
                else (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, 0, -d2);
                    else (0, $bMDnR.default).set($132c5af5562dffd4$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, 0, d2);
                else (0, $bMDnR.default).set($132c5af5562dffd4$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $bMDnR.default).copy(mtv, overlap ? $132c5af5562dffd4$var$minTv : $132c5af5562dffd4$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $132c5af5562dffd4$var$lt.x = $132c5af5562dffd4$var$lb.x = source.x;
        $132c5af5562dffd4$var$lt.y = $132c5af5562dffd4$var$rt.y = source.y;
        $132c5af5562dffd4$var$rb.x = $132c5af5562dffd4$var$rt.x = source.x + source.width;
        $132c5af5562dffd4$var$rb.y = $132c5af5562dffd4$var$lb.y = source.y + source.height;
        $132c5af5562dffd4$var$lt.transform(m);
        $132c5af5562dffd4$var$rt.transform(m);
        $132c5af5562dffd4$var$rb.transform(m);
        $132c5af5562dffd4$var$lb.transform(m);
        target.x = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
        target.y = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
        var maxX = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
        var maxY = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $132c5af5562dffd4$export$2e2bcd8739ae039 = $132c5af5562dffd4$var$BoundingRect;

});
parcelRegister("bMDnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8942ba3a66d599f1$export$2e2bcd8739ae039);
var $8942ba3a66d599f1$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $8942ba3a66d599f1$export$2e2bcd8739ae039 = $8942ba3a66d599f1$var$Point;

});


parcelRegister("bRKv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a38b6f95cbd6cc6$export$2e2bcd8739ae039);
var $8a38b6f95cbd6cc6$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $8a38b6f95cbd6cc6$export$2e2bcd8739ae039 = $8a38b6f95cbd6cc6$var$Eventful;

});

parcelRegister("b7ZX8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT", () => $81a067b5a1d9459c$export$7d7a232b6d2cc80c);
$parcel$export(module.exports, "getWidth", () => $81a067b5a1d9459c$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getLineHeight", () => $81a067b5a1d9459c$export$56204a27a2958a55);
$parcel$export(module.exports, "adjustTextX", () => $81a067b5a1d9459c$export$eb5a525ef00ef9a4);
$parcel$export(module.exports, "adjustTextY", () => $81a067b5a1d9459c$export$bf7d6802d2badd9);
$parcel$export(module.exports, "getBoundingRect", () => $81a067b5a1d9459c$export$c381147bfed79d9f);
$parcel$export(module.exports, "parsePercent", () => $81a067b5a1d9459c$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "calculateTextPosition", () => $81a067b5a1d9459c$export$eee3603b512feab7);

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");

var $h4RuA = parcelRequire("h4RuA");
var $81a067b5a1d9459c$var$textWidthCache = {};
var $81a067b5a1d9459c$export$7d7a232b6d2cc80c = '12px sans-serif';
var $81a067b5a1d9459c$var$_ctx;
var $81a067b5a1d9459c$var$_cachedFont;
function $81a067b5a1d9459c$var$defaultMeasureText(text, font) {
    if (!$81a067b5a1d9459c$var$_ctx) $81a067b5a1d9459c$var$_ctx = (0, $bahqM.createCanvas)().getContext('2d');
    if ($81a067b5a1d9459c$var$_cachedFont !== font) $81a067b5a1d9459c$var$_cachedFont = $81a067b5a1d9459c$var$_ctx.font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
    return $81a067b5a1d9459c$var$_ctx.measureText(text);
}
var $81a067b5a1d9459c$var$methods = {
    measureText: $81a067b5a1d9459c$var$defaultMeasureText
};
function $81a067b5a1d9459c$export$d35a04b83ea6803e(name, fn) {
    $81a067b5a1d9459c$var$methods[name] = fn;
}
function $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font) {
    font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
    var cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font] = new (0, $h4RuA.default)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = $81a067b5a1d9459c$var$methods.measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $81a067b5a1d9459c$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font);
    var height = $81a067b5a1d9459c$export$56204a27a2958a55(font);
    var x = $81a067b5a1d9459c$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $81a067b5a1d9459c$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1E3E8.default)(x, y, width, height);
    return rect;
}
function $81a067b5a1d9459c$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1E3E8.default)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $81a067b5a1d9459c$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $81a067b5a1d9459c$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $81a067b5a1d9459c$export$56204a27a2958a55(font) {
    return $81a067b5a1d9459c$export$3c49c185de0c2bfc("\u56FD", font);
}
function $81a067b5a1d9459c$export$866cc30a33805630(text, font) {
    return $81a067b5a1d9459c$var$methods.measureText(text, font);
}
function $81a067b5a1d9459c$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $81a067b5a1d9459c$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

});

parcelRegister("7y1my", function(module, exports) {

$parcel$export(module.exports, "devicePixelRatio", () => $57ecc3ffeb61d50b$export$508f096bfcdaac40);
$parcel$export(module.exports, "DARK_MODE_THRESHOLD", () => $57ecc3ffeb61d50b$export$fd81e7ebc7dae256);
$parcel$export(module.exports, "DARK_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$f8ce94761f39398d);
$parcel$export(module.exports, "LIGHT_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$3c6e95f318c8369b);
$parcel$export(module.exports, "LIGHTER_LABEL_COLOR", () => $57ecc3ffeb61d50b$export$27682248795c3c6b);
var $57ecc3ffeb61d50b$var$dpr = 1;
if (typeof window !== 'undefined') $57ecc3ffeb61d50b$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $57ecc3ffeb61d50b$export$7cdcde344c85339c = 0;
var $57ecc3ffeb61d50b$export$508f096bfcdaac40 = $57ecc3ffeb61d50b$var$dpr;
var $57ecc3ffeb61d50b$export$fd81e7ebc7dae256 = 0.4;
var $57ecc3ffeb61d50b$export$f8ce94761f39398d = '#333';
var $57ecc3ffeb61d50b$export$3c6e95f318c8369b = '#ccc';
var $57ecc3ffeb61d50b$export$27682248795c3c6b = '#eee';

});

parcelRegister("hZfwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1842bbf4a5e2f15$export$2e2bcd8739ae039);
var $d1842bbf4a5e2f15$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $d1842bbf4a5e2f15$var$Env = function() {
    function Env() {
        this.browser = new $d1842bbf4a5e2f15$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.canvasSupported = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
    }
    return Env;
}();
var $d1842bbf4a5e2f15$var$env = new $d1842bbf4a5e2f15$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $d1842bbf4a5e2f15$var$env.wxa = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    $d1842bbf4a5e2f15$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    $d1842bbf4a5e2f15$var$env.worker = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
} else if (typeof navigator === 'undefined') {
    $d1842bbf4a5e2f15$var$env.node = true;
    $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    $d1842bbf4a5e2f15$var$env.svgSupported = true;
} else $d1842bbf4a5e2f15$var$detect(navigator.userAgent, $d1842bbf4a5e2f15$var$env);
function $d1842bbf4a5e2f15$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.canvasSupported = !!document.createElement('canvas').getContext;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $d1842bbf4a5e2f15$export$2e2bcd8739ae039 = $d1842bbf4a5e2f15$var$env;

});

parcelRegister("aVawM", function(module, exports) {

$parcel$export(module.exports, "REDRAW_BIT", () => $7f3764d4456adf3b$export$a7b6db622c6c7dbd);
$parcel$export(module.exports, "STYLE_CHANGED_BIT", () => $7f3764d4456adf3b$export$ada8b2beb3d76671);
$parcel$export(module.exports, "SHAPE_CHANGED_BIT", () => $7f3764d4456adf3b$export$f75fe89a33ebe115);
var $7f3764d4456adf3b$export$a7b6db622c6c7dbd = 1;
var $7f3764d4456adf3b$export$ada8b2beb3d76671 = 2;
var $7f3764d4456adf3b$export$f75fe89a33ebe115 = 4;

});



parcelRegister("fHITF", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => $b6edb2bb66445620$export$d0d5398c9d612037);
$parcel$export(module.exports, "extendPath", () => $b6edb2bb66445620$export$53b54a3137026af0);
$parcel$export(module.exports, "registerShape", () => $b6edb2bb66445620$export$2b95b62e3aaf6fdd);
$parcel$export(module.exports, "getShapeClass", () => $b6edb2bb66445620$export$51df4b5565a58189);
$parcel$export(module.exports, "makePath", () => $b6edb2bb66445620$export$aa9bab72412f5613);
$parcel$export(module.exports, "resizePath", () => $b6edb2bb66445620$export$566dbf1c62b04fc7);
$parcel$export(module.exports, "makeImage", () => $b6edb2bb66445620$export$7a2bdede98851ac5);
$parcel$export(module.exports, "mergePath", () => $b6edb2bb66445620$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "subPixelOptimizeLine", () => $b6edb2bb66445620$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $b6edb2bb66445620$export$60e2aa74957d0b9d);
$parcel$export(module.exports, "subPixelOptimize", () => $b6edb2bb66445620$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "getTransform", () => $b6edb2bb66445620$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "applyTransform", () => $b6edb2bb66445620$export$9f9dcb98c894b623);
$parcel$export(module.exports, "transformDirection", () => $b6edb2bb66445620$export$fff94e9792354cfa);
$parcel$export(module.exports, "groupTransition", () => $b6edb2bb66445620$export$64fcab7860c216ae);
$parcel$export(module.exports, "clipPointsByRect", () => $b6edb2bb66445620$export$e2f409471bbbc1dc);
$parcel$export(module.exports, "clipRectByRect", () => $b6edb2bb66445620$export$d0d3709202b8b2a);
$parcel$export(module.exports, "createIcon", () => $b6edb2bb66445620$export$274edc73af1ae9c8);
$parcel$export(module.exports, "linePolygonIntersect", () => $b6edb2bb66445620$export$4f47c855a5e9ae9);
$parcel$export(module.exports, "lineLineIntersect", () => $b6edb2bb66445620$export$6c0a70ea1d8d158b);
$parcel$export(module.exports, "setTooltipConfig", () => $b6edb2bb66445620$export$fc6410d97fab306c);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("eYgMC")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("eYgMC")).initProps);
$parcel$export(module.exports, "removeElement", () => (parcelRequire("eYgMC")).removeElement);
$parcel$export(module.exports, "removeElementWithFadeOut", () => (parcelRequire("eYgMC")).removeElementWithFadeOut);
$parcel$export(module.exports, "isElementRemoved", () => (parcelRequire("eYgMC")).isElementRemoved);
$parcel$export(module.exports, "Group", () => (parcelRequire("4KVOr")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("gcbBH")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("4gEFv")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("jjfok")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("kVeV8")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("elGBV")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("LCHOw")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("lQwBc")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("32bXc")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("7Tw7u")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("cZb1F")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("04gw0")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("ixXaU")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("6sllV")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("eGltS")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("9J7f8")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("faICo")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("1E3E8")).default);
$parcel$export(module.exports, "OrientedBoundingRect", () => (parcelRequire("lM5Gp")).default);
$parcel$export(module.exports, "Point", () => (parcelRequire("bMDnR")).default);
$parcel$export(module.exports, "Path", () => (parcelRequire("ghQ8v")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $id1Rd = parcelRequire("id1Rd");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $ghQ8v = parcelRequire("ghQ8v");

var $e6gef = parcelRequire("e6gef");

var $gcbBH = parcelRequire("gcbBH");

var $4KVOr = parcelRequire("4KVOr");

var $4gEFv = parcelRequire("4gEFv");

var $jjfok = parcelRequire("jjfok");

var $kVeV8 = parcelRequire("kVeV8");

var $elGBV = parcelRequire("elGBV");

var $LCHOw = parcelRequire("LCHOw");

var $lQwBc = parcelRequire("lQwBc");

var $32bXc = parcelRequire("32bXc");

var $7Tw7u = parcelRequire("7Tw7u");

var $cZb1F = parcelRequire("cZb1F");

var $04gw0 = parcelRequire("04gw0");

var $ixXaU = parcelRequire("ixXaU");

var $eGltS = parcelRequire("eGltS");

var $9J7f8 = parcelRequire("9J7f8");

var $faICo = parcelRequire("faICo");

var $1E3E8 = parcelRequire("1E3E8");

var $lM5Gp = parcelRequire("lM5Gp");

var $bMDnR = parcelRequire("bMDnR");

var $6sllV = parcelRequire("6sllV");

var $2az2p = parcelRequire("2az2p");

var $bahqM = parcelRequire("bahqM");

var $7QjoM = parcelRequire("7QjoM");

var $eYgMC = parcelRequire("eYgMC");
var $b6edb2bb66445620$var$mathMax = Math.max;
var $b6edb2bb66445620$var$mathMin = Math.min;
var $b6edb2bb66445620$var$_customShapeMap = {};
function $b6edb2bb66445620$export$d0d5398c9d612037(opts) {
    return (0, $ghQ8v.default).extend(opts);
}
var $b6edb2bb66445620$var$extendPathFromString = $id1Rd.extendFromString;
function $b6edb2bb66445620$export$53b54a3137026af0(pathData, opts) {
    return $b6edb2bb66445620$var$extendPathFromString(pathData, opts);
}
function $b6edb2bb66445620$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $b6edb2bb66445620$var$_customShapeMap[name] = ShapeClass;
}
function $b6edb2bb66445620$export$51df4b5565a58189(name) {
    if ($b6edb2bb66445620$var$_customShapeMap.hasOwnProperty(name)) return $b6edb2bb66445620$var$_customShapeMap[name];
}
function $b6edb2bb66445620$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $id1Rd.createFromString(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $b6edb2bb66445620$var$centerGraphic(rect, path.getBoundingRect());
        $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $b6edb2bb66445620$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $gcbBH.default)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($b6edb2bb66445620$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $b6edb2bb66445620$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $b6edb2bb66445620$export$7b1dd269fbc4e903 = $id1Rd.mergePath;
function $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $b6edb2bb66445620$export$8b4b620d7f4aad1b(param) {
    $2az2p.subPixelOptimizeLine(param.shape, param.shape, param.style);
    return param;
}
function $b6edb2bb66445620$export$60e2aa74957d0b9d(param) {
    $2az2p.subPixelOptimizeRect(param.shape, param.shape, param.style);
    return param;
}
var $b6edb2bb66445620$export$72c4fd4c1b8fcb10 = $2az2p.subPixelOptimize;
function $b6edb2bb66445620$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $izqgC.identity([]);
    while(target && target !== ancestor){
        $izqgC.mul(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $b6edb2bb66445620$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $bahqM.isArrayLike)(transform)) transform = (0, $e6gef.default).getLocalTransform(transform);
    if (invert) transform = $izqgC.invert([], transform);
    return $eLEew.applyTransform([], target, transform);
}
function $b6edb2bb66445620$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $b6edb2bb66445620$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $b6edb2bb66445620$var$isNotGroup(el) {
    return !el.isGroup;
}
function $b6edb2bb66445620$var$isPath(el) {
    return el.shape != null;
}
function $b6edb2bb66445620$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($b6edb2bb66445620$var$isPath(el)) obj.shape = (0, $bahqM.extend)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $eYgMC.updateProps)(el, newProp, animatableModel, (0, $7QjoM.getECData)(el).dataIndex);
            }
        }
    });
}
function $b6edb2bb66445620$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: this way migth be incorrect when grpahic clipped by a corner.
    // and when element have border.
    return (0, $bahqM.map)(points, function(point) {
        var x = point[0];
        x = $b6edb2bb66445620$var$mathMax(x, rect.x);
        x = $b6edb2bb66445620$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $b6edb2bb66445620$var$mathMax(y, rect.y);
        y = $b6edb2bb66445620$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $b6edb2bb66445620$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $b6edb2bb66445620$var$mathMax(targetRect.x, rect.x);
    var x2 = $b6edb2bb66445620$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $b6edb2bb66445620$var$mathMax(targetRect.y, rect.y);
    var y2 = $b6edb2bb66445620$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $b6edb2bb66445620$export$274edc73af1ae9c8(iconStr, opt, rect) {
    var innerOpts = (0, $bahqM.extend)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $bahqM.defaults)(style, rect), new (0, $gcbBH.default)(innerOpts)) : $b6edb2bb66445620$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $b6edb2bb66445620$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
    //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $b6edb2bb66445620$var$crossProduct2d(nx, ny, mx, my);
    if ($b6edb2bb66445620$var$nearZero(nmCrossProduct)) return false;
     // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $b6edb2bb66445620$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $b6edb2bb66445620$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $b6edb2bb66445620$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $bahqM.isString)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $bahqM.each)((0, $bahqM.keys)(formatterParamsExtra), function(key) {
        if (!(0, $bahqM.hasOwn)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $7QjoM.getECData)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $bahqM.defaults)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('circle', (0, $jjfok.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('ellipse', (0, $kVeV8.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('sector', (0, $elGBV.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('ring', (0, $LCHOw.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('polygon', (0, $lQwBc.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('polyline', (0, $32bXc.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('rect', (0, $7Tw7u.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('line', (0, $cZb1F.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('bezierCurve', (0, $04gw0.default));
$b6edb2bb66445620$export$2b95b62e3aaf6fdd('arc', (0, $ixXaU.default));

});
parcelRegister("id1Rd", function(module, exports) {

$parcel$export(module.exports, "createFromString", () => $d41ae1bdee61ce18$export$ae5b259626f00aeb);
$parcel$export(module.exports, "extendFromString", () => $d41ae1bdee61ce18$export$68e3a51ba2ed417c);
$parcel$export(module.exports, "mergePath", () => $d41ae1bdee61ce18$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "clonePath", () => $d41ae1bdee61ce18$export$18711d956bf1c3eb);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $aA4Ws = parcelRequire("aA4Ws");

var $cTDbe = parcelRequire("cTDbe");

var $bahqM = parcelRequire("bahqM");
var $d41ae1bdee61ce18$var$mathSqrt = Math.sqrt;
var $d41ae1bdee61ce18$var$mathSin = Math.sin;
var $d41ae1bdee61ce18$var$mathCos = Math.cos;
var $d41ae1bdee61ce18$var$PI = Math.PI;
function $d41ae1bdee61ce18$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $d41ae1bdee61ce18$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($d41ae1bdee61ce18$var$vMag(u) * $d41ae1bdee61ce18$var$vMag(v));
}
function $d41ae1bdee61ce18$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($d41ae1bdee61ce18$var$vRatio(u, v));
}
function $d41ae1bdee61ce18$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($d41ae1bdee61ce18$var$PI / 180.0);
    var xp = $d41ae1bdee61ce18$var$mathCos(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $d41ae1bdee61ce18$var$mathSin(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
        ry *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $d41ae1bdee61ce18$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * cxp - $d41ae1bdee61ce18$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * cxp + $d41ae1bdee61ce18$var$mathCos(psi) * cyp;
    var theta = $d41ae1bdee61ce18$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $d41ae1bdee61ce18$var$vAngle(u, v);
    if ($d41ae1bdee61ce18$var$vRatio(u, v) <= -1) dTheta = $d41ae1bdee61ce18$var$PI;
    if ($d41ae1bdee61ce18$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $d41ae1bdee61ce18$var$PI * 1e6) / 1e6;
        dTheta = $d41ae1bdee61ce18$var$PI * 2 + n % 2 * $d41ae1bdee61ce18$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $d41ae1bdee61ce18$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $d41ae1bdee61ce18$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $d41ae1bdee61ce18$var$createPathProxyFromString(data) {
    var path = new (0, $aA4Ws.default)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $aA4Ws.default).CMD;
    var cmdList = data.match($d41ae1bdee61ce18$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($d41ae1bdee61ce18$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $d41ae1bdee61ce18$var$SVGPath = function(_super) {
    (0, $3VFsf.__extends)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $ghQ8v.default));
function $d41ae1bdee61ce18$var$isPathProxy(path) {
    return path.setData != null;
}
function $d41ae1bdee61ce18$var$createPathOptions(str, opts) {
    var pathProxy = $d41ae1bdee61ce18$var$createPathProxyFromString(str);
    var innerOpts = (0, $bahqM.extend)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $cTDbe.default)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $d41ae1bdee61ce18$export$ae5b259626f00aeb(str, opts) {
    return new $d41ae1bdee61ce18$var$SVGPath($d41ae1bdee61ce18$var$createPathOptions(str, opts));
}
function $d41ae1bdee61ce18$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $d41ae1bdee61ce18$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $3VFsf.__extends)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($d41ae1bdee61ce18$var$SVGPath);
    return Sub;
}
function $d41ae1bdee61ce18$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $ghQ8v.default)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $d41ae1bdee61ce18$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $ghQ8v.default)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $cTDbe.default)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

});
parcelRegister("ghQ8v", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PATH_STYLE", () => $bdb6ad049d5f8c6b$export$deade517576e293a);
$parcel$export(module.exports, "default", () => $bdb6ad049d5f8c6b$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $aA4Ws = parcelRequire("aA4Ws");

var $k3yEY = parcelRequire("k3yEY");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $7y1my = parcelRequire("7y1my");

var $aVawM = parcelRequire("aVawM");
var $bdb6ad049d5f8c6b$export$deade517576e293a = (0, $bahqM.defaults)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $lBQ88.DEFAULT_COMMON_STYLE));
var $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5 = {
    style: (0, $bahqM.defaults)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $bdb6ad049d5f8c6b$var$pathCopyParams = [
    'x',
    'y',
    'rotation',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
];
var $bdb6ad049d5f8c6b$var$Path = function(_super) {
    (0, $3VFsf.__extends)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $bdb6ad049d5f8c6b$var$pathCopyParams.length; ++i)decalEl[$bdb6ad049d5f8c6b$var$pathCopyParams[i]] = this[$bdb6ad049d5f8c6b$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $aVawM.REDRAW_BIT);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $bahqM.keys)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $bahqM.extend)(this.style, value);
            } else if (key === 'shape') (0, $bahqM.extend)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $bahqM.isString)(pathFill)) {
                var fillLum = (0, $d6udH.lum)(pathFill, 0);
                if (fillLum > 0.5) return 0, $7y1my.DARK_LABEL_COLOR;
                else if (fillLum > 0.2) return 0, $7y1my.LIGHTER_LABEL_COLOR;
                return 0, $7y1my.LIGHT_LABEL_COLOR;
            } else if (pathFill) return 0, $7y1my.LIGHT_LABEL_COLOR;
        }
        return 0, $7y1my.DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $bahqM.isString)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $d6udH.lum)(textFill, 0) < (0, $7y1my.DARK_MODE_THRESHOLD);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $aVawM.SHAPE_CHANGED_BIT);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $aA4Ws.default)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectWithStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectWithStroke.width += w / lineScale;
                    rectWithStroke.height += w / lineScale;
                    rectWithStroke.x -= w / lineScale / 2;
                    rectWithStroke.y -= w / lineScale / 2;
                }
            }
            return rectWithStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($k3yEY.containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $k3yEY.contain(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $aVawM.SHAPE_CHANGED_BIT);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $bahqM.extend)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($bdb6ad049d5f8c6b$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $bahqM.extend)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $bahqM.extend)({}, normalState.shape);
                    (0, $bahqM.extend)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $bahqM.extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $bahqM.extend)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $bahqM.extend)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $bahqM.keys)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $3VFsf.__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $bahqM.clone)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $bahqM.clone)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $aVawM.REDRAW_BIT) | (0, $aVawM.STYLE_CHANGED_BIT) | (0, $aVawM.SHAPE_CHANGED_BIT);
    }();
    return Path;
}((0, $lBQ88.default));
var $bdb6ad049d5f8c6b$export$2e2bcd8739ae039 = $bdb6ad049d5f8c6b$var$Path;

});
parcelRegister("lBQ88", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COMMON_STYLE", () => $fbb57da3b649c75e$export$737672163db00fe3);
$parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", () => $fbb57da3b649c75e$export$9908943fb57fbe51);
$parcel$export(module.exports, "default", () => $fbb57da3b649c75e$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $7KVc5 = parcelRequire("7KVc5");

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");

var $aVawM = parcelRequire("aVawM");
var $fbb57da3b649c75e$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $fbb57da3b649c75e$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $fbb57da3b649c75e$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$fbb57da3b649c75e$export$737672163db00fe3[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY] = true;
var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $fbb57da3b649c75e$var$Displayable = function(_super) {
    (0, $3VFsf.__extends)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $bahqM.keys)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $fbb57da3b649c75e$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1E3E8.default)(0, 0, 0, 0));
            if (transform) (0, $1E3E8.default).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1E3E8.default)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $bahqM.extend)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $aVawM.STYLE_CHANGED_BIT);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $aVawM.STYLE_CHANGED_BIT));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $aVawM.STYLE_CHANGED_BIT);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($fbb57da3b649c75e$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $bahqM.keys)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $bahqM.keys)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $bahqM.extend)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $fbb57da3b649c75e$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $aVawM.REDRAW_BIT) | (0, $aVawM.STYLE_CHANGED_BIT);
    }();
    return Displayable;
}((0, $7KVc5.default));
var $fbb57da3b649c75e$var$tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
var $fbb57da3b649c75e$var$viewRect = new (0, $1E3E8.default)(0, 0, 0, 0);
function $fbb57da3b649c75e$var$isDisplayableCulled(el, width, height) {
    $fbb57da3b649c75e$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $fbb57da3b649c75e$var$tmpRect.applyTransform(el.transform);
    $fbb57da3b649c75e$var$viewRect.width = width;
    $fbb57da3b649c75e$var$viewRect.height = height;
    return !$fbb57da3b649c75e$var$tmpRect.intersect($fbb57da3b649c75e$var$viewRect);
}
var $fbb57da3b649c75e$export$2e2bcd8739ae039 = $fbb57da3b649c75e$var$Displayable;

});

parcelRegister("aA4Ws", function(module, exports) {

$parcel$export(module.exports, "normalizeArcAngles", () => $7b4119855d2b5b91$export$bc668021e937022a);
$parcel$export(module.exports, "default", () => $7b4119855d2b5b91$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");

var $1E3E8 = parcelRequire("1E3E8");

var $7y1my = parcelRequire("7y1my");

var $13I82 = parcelRequire("13I82");

var $dr1jo = parcelRequire("dr1jo");
var $7b4119855d2b5b91$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $7b4119855d2b5b91$var$tmpOutX = [];
var $7b4119855d2b5b91$var$tmpOutY = [];
var $7b4119855d2b5b91$var$min = [];
var $7b4119855d2b5b91$var$max = [];
var $7b4119855d2b5b91$var$min2 = [];
var $7b4119855d2b5b91$var$max2 = [];
var $7b4119855d2b5b91$var$mathMin = Math.min;
var $7b4119855d2b5b91$var$mathMax = Math.max;
var $7b4119855d2b5b91$var$mathCos = Math.cos;
var $7b4119855d2b5b91$var$mathSin = Math.sin;
var $7b4119855d2b5b91$var$mathSqrt = Math.sqrt;
var $7b4119855d2b5b91$var$mathAbs = Math.abs;
var $7b4119855d2b5b91$var$PI = Math.PI;
var $7b4119855d2b5b91$var$PI2 = $7b4119855d2b5b91$var$PI * 2;
var $7b4119855d2b5b91$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $7b4119855d2b5b91$var$tmpAngles = [];
function $7b4119855d2b5b91$var$modPI2(radian) {
    var n = Math.round(radian / $7b4119855d2b5b91$var$PI * 1e8) / 1e8;
    return n % 2 * $7b4119855d2b5b91$var$PI;
}
function $7b4119855d2b5b91$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $7b4119855d2b5b91$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $7b4119855d2b5b91$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle + $7b4119855d2b5b91$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle - $7b4119855d2b5b91$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $7b4119855d2b5b91$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, $7y1my.devicePixelRatio) / sx) || 0;
            this._uy = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, $7y1my.devicePixelRatio) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._lineDash) {
            this._lineDash = null;
            this._dashOffset = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $7b4119855d2b5b91$var$mathAbs(x - this._xi);
        var dy = $7b4119855d2b5b91$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($7b4119855d2b5b91$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $7b4119855d2b5b91$var$tmpAngles[0] = startAngle;
        $7b4119855d2b5b91$var$tmpAngles[1] = endAngle;
        $7b4119855d2b5b91$export$bc668021e937022a($7b4119855d2b5b91$var$tmpAngles, anticlockwise);
        startAngle = $7b4119855d2b5b91$var$tmpAngles[0];
        endAngle = $7b4119855d2b5b91$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($7b4119855d2b5b91$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $7b4119855d2b5b91$var$mathCos(endAngle) * r + cx;
        this._yi = $7b4119855d2b5b91$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($7b4119855d2b5b91$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($7b4119855d2b5b91$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            this._needsDash && this._dashedLineTo(x0, y0);
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.setLineDash = function(lineDash) {
        if (lineDash instanceof Array) {
            this._lineDash = lineDash;
            this._dashIdx = 0;
            var lineDashSum = 0;
            for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
            this._dashSum = lineDashSum;
            this._needsDash = true;
        } else {
            this._lineDash = null;
            this._needsDash = false;
        }
        return this;
    };
    PathProxy.prototype.setLineDashOffset = function(offset) {
        this._dashOffset = offset;
        return this;
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $7b4119855d2b5b91$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($7b4119855d2b5b91$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype._dashedLineTo = function(x1, y1) {
        var dashSum = this._dashSum;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var offset = this._dashOffset;
        var x0 = this._xi;
        var y0 = this._yi;
        var dx = x1 - x0;
        var dy = y1 - y0;
        var dist = $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        var x = x0;
        var y = y0;
        var nDash = lineDash.length;
        var dash;
        var idx;
        dx /= dist;
        dy /= dist;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        x -= offset * dx;
        y -= offset * dy;
        while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
            idx = this._dashIdx;
            dash = lineDash[idx];
            x += dx * dash;
            y += dy * dash;
            this._dashIdx = (idx + 1) % nDash;
            if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
            ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $7b4119855d2b5b91$var$mathMin(x, x1) : $7b4119855d2b5b91$var$mathMax(x, x1), dy >= 0 ? $7b4119855d2b5b91$var$mathMin(y, y1) : $7b4119855d2b5b91$var$mathMax(y, y1));
        }
        dx = x - x1;
        dy = y - y1;
        this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
        var ctx = this._ctx;
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var x0 = this._xi;
        var y0 = this._yi;
        var bezierLen = 0;
        var idx = this._dashIdx;
        var nDash = lineDash.length;
        var t;
        var dx;
        var dy;
        var x;
        var y;
        var tmpLen = 0;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        for(t = 0; t < 1; t += 0.1){
            dx = (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t);
            dy = (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t);
            bezierLen += $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        }
        for(; idx < nDash; idx++){
            tmpLen += lineDash[idx];
            if (tmpLen > offset) break;
        }
        t = (tmpLen - offset) / bezierLen;
        while(t <= 1){
            x = (0, $dr1jo.cubicAt)(x0, x1, x2, x3, t);
            y = (0, $dr1jo.cubicAt)(y0, y1, y2, y3, t);
            idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
            t += lineDash[idx] / bezierLen;
            idx = (idx + 1) % nDash;
        }
        idx % 2 !== 0 && ctx.lineTo(x3, y3);
        dx = x3 - x;
        dy = y3 - y;
        this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
        var x3 = x2;
        var y3 = y2;
        x2 = (x2 + 2 * x1) / 3;
        y2 = (y2 + 2 * y1) / 3;
        x1 = (this._xi + 2 * x1) / 3;
        y1 = (this._yi + 2 * y1) / 3;
        this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($7b4119855d2b5b91$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$min2[0] = $7b4119855d2b5b91$var$min2[1] = Number.MAX_VALUE;
        $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = $7b4119855d2b5b91$var$max2[0] = $7b4119855d2b5b91$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $7b4119855d2b5b91$var$min2[0] = x0;
                    $7b4119855d2b5b91$var$min2[1] = y0;
                    $7b4119855d2b5b91$var$max2[0] = x0;
                    $7b4119855d2b5b91$var$max2[1] = y0;
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    (0, $13I82.fromLine)(xi, yi, data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    (0, $13I82.fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    (0, $13I82.fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $13I82.fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $13I82.fromLine)(x0, y0, x0 + width, y0 + height, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $eLEew.min($7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min2);
            $eLEew.max($7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max2);
        }
        if (i === 0) $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = 0;
        return new (0, $1E3E8.default)($7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$min[1], $7b4119855d2b5b91$var$max[0] - $7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$max[1] - $7b4119855d2b5b91$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($7b4119855d2b5b91$var$mathAbs(dx) > ux || $7b4119855d2b5b91$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $dr1jo.cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $dr1jo.quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $7b4119855d2b5b91$var$mathMax(rx, ry) * $7b4119855d2b5b91$var$mathMin($7b4119855d2b5b91$var$PI2, Math.abs(delta));
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $7b4119855d2b5b91$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $7b4119855d2b5b91$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $7b4119855d2b5b91$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $7b4119855d2b5b91$var$mathAbs(x - xi);
                    var dy = $7b4119855d2b5b91$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $7b4119855d2b5b91$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $dr1jo.cubicSubdivide)(xi, x1, x2, x3, t, $7b4119855d2b5b91$var$tmpOutX);
                            (0, $dr1jo.cubicSubdivide)(yi, y1, y2, y3, t, $7b4119855d2b5b91$var$tmpOutY);
                            ctx.bezierCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2], $7b4119855d2b5b91$var$tmpOutX[3], $7b4119855d2b5b91$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $7b4119855d2b5b91$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $dr1jo.quadraticSubdivide)(xi, x1, x2, t, $7b4119855d2b5b91$var$tmpOutX);
                            (0, $dr1jo.quadraticSubdivide)(yi, y1, y2, t, $7b4119855d2b5b91$var$tmpOutY);
                            ctx.quadraticCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $7b4119855d2b5b91$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $7b4119855d2b5b91$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                        y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                    yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                    break;
                case $7b4119855d2b5b91$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $7b4119855d2b5b91$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $7b4119855d2b5b91$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $7b4119855d2b5b91$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $7b4119855d2b5b91$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $7b4119855d2b5b91$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $7b4119855d2b5b91$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._needsDash = false;
        proto._dashOffset = 0;
        proto._dashIdx = 0;
        proto._dashSum = 0;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $7b4119855d2b5b91$export$2e2bcd8739ae039 = $7b4119855d2b5b91$var$PathProxy;

});
parcelRegister("13I82", function(module, exports) {

$parcel$export(module.exports, "fromPoints", () => $0c584d4e3f9e2fa0$export$188c3cd07b4129dd);
$parcel$export(module.exports, "fromLine", () => $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c);
$parcel$export(module.exports, "fromCubic", () => $0c584d4e3f9e2fa0$export$c1bc6be456bb6609);
$parcel$export(module.exports, "fromQuadratic", () => $0c584d4e3f9e2fa0$export$16fbe795323a1f4c);
$parcel$export(module.exports, "fromArc", () => $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49);

var $eLEew = parcelRequire("eLEew");

var $dr1jo = parcelRequire("dr1jo");
var $0c584d4e3f9e2fa0$var$mathMin = Math.min;
var $0c584d4e3f9e2fa0$var$mathMax = Math.max;
var $0c584d4e3f9e2fa0$var$mathSin = Math.sin;
var $0c584d4e3f9e2fa0$var$mathCos = Math.cos;
var $0c584d4e3f9e2fa0$var$PI2 = Math.PI * 2;
var $0c584d4e3f9e2fa0$var$start = $eLEew.create();
var $0c584d4e3f9e2fa0$var$end = $eLEew.create();
var $0c584d4e3f9e2fa0$var$extremity = $eLEew.create();
function $0c584d4e3f9e2fa0$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $0c584d4e3f9e2fa0$var$mathMin(left, p[0]);
        right = $0c584d4e3f9e2fa0$var$mathMax(right, p[0]);
        top = $0c584d4e3f9e2fa0$var$mathMin(top, p[1]);
        bottom = $0c584d4e3f9e2fa0$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x1);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y1);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x1);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y1);
}
var $0c584d4e3f9e2fa0$var$xDim = [];
var $0c584d4e3f9e2fa0$var$yDim = [];
function $0c584d4e3f9e2fa0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $dr1jo.cubicExtrema;
    var cubicAt = $dr1jo.cubicAt;
    var n = cubicExtrema(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim[i]);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim[i]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y, max[1]);
    }
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, min[0]);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, max[0]);
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x3, min[0]);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x3, max[0]);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, min[1]);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, max[1]);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y3, min[1]);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y3, max[1]);
}
function $0c584d4e3f9e2fa0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $dr1jo.quadraticExtremum;
    var quadraticAt = $dr1jo.quadraticAt;
    var tx = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x2, x);
    min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y2, y);
    max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x2, x);
    max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y2, y);
}
function $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $eLEew.min;
    var vec2Max = $eLEew.max;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $0c584d4e3f9e2fa0$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $0c584d4e3f9e2fa0$var$start[0] = $0c584d4e3f9e2fa0$var$mathCos(startAngle) * rx + x;
    $0c584d4e3f9e2fa0$var$start[1] = $0c584d4e3f9e2fa0$var$mathSin(startAngle) * ry + y;
    $0c584d4e3f9e2fa0$var$end[0] = $0c584d4e3f9e2fa0$var$mathCos(endAngle) * rx + x;
    $0c584d4e3f9e2fa0$var$end[1] = $0c584d4e3f9e2fa0$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
    vec2Max(max, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
    startAngle = startAngle % $0c584d4e3f9e2fa0$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $0c584d4e3f9e2fa0$var$PI2;
    endAngle = endAngle % $0c584d4e3f9e2fa0$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $0c584d4e3f9e2fa0$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $0c584d4e3f9e2fa0$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $0c584d4e3f9e2fa0$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $0c584d4e3f9e2fa0$var$extremity[0] = $0c584d4e3f9e2fa0$var$mathCos(angle) * rx + x;
        $0c584d4e3f9e2fa0$var$extremity[1] = $0c584d4e3f9e2fa0$var$mathSin(angle) * ry + y;
        vec2Min(min, $0c584d4e3f9e2fa0$var$extremity, min);
        vec2Max(max, $0c584d4e3f9e2fa0$var$extremity, max);
    }
}

});
parcelRegister("dr1jo", function(module, exports) {

$parcel$export(module.exports, "cubicAt", () => $9c7ed07589dafe64$export$547c21de482bbcb2);
$parcel$export(module.exports, "cubicDerivativeAt", () => $9c7ed07589dafe64$export$55fce925c60b6271);
$parcel$export(module.exports, "cubicRootAt", () => $9c7ed07589dafe64$export$ca5d13faa10b167e);
$parcel$export(module.exports, "cubicExtrema", () => $9c7ed07589dafe64$export$df1a172f100d0457);
$parcel$export(module.exports, "cubicSubdivide", () => $9c7ed07589dafe64$export$a2ee23a0567039da);
$parcel$export(module.exports, "cubicProjectPoint", () => $9c7ed07589dafe64$export$dbaa3801d1284367);
$parcel$export(module.exports, "cubicLength", () => $9c7ed07589dafe64$export$af1875d576f60d7c);
$parcel$export(module.exports, "quadraticAt", () => $9c7ed07589dafe64$export$af17094a950f5073);
$parcel$export(module.exports, "quadraticDerivativeAt", () => $9c7ed07589dafe64$export$7e161e77e6fff8cb);
$parcel$export(module.exports, "quadraticRootAt", () => $9c7ed07589dafe64$export$fd895ac7ee764967);
$parcel$export(module.exports, "quadraticExtremum", () => $9c7ed07589dafe64$export$752e1f8c6e7f7e11);
$parcel$export(module.exports, "quadraticSubdivide", () => $9c7ed07589dafe64$export$117c659e21a7a060);
$parcel$export(module.exports, "quadraticProjectPoint", () => $9c7ed07589dafe64$export$81915a594fe10dee);
$parcel$export(module.exports, "quadraticLength", () => $9c7ed07589dafe64$export$8a68adee46f3cf55);

var $eLEew = parcelRequire("eLEew");
var $9c7ed07589dafe64$var$mathPow = Math.pow;
var $9c7ed07589dafe64$var$mathSqrt = Math.sqrt;
var $9c7ed07589dafe64$var$EPSILON = 1e-8;
var $9c7ed07589dafe64$var$EPSILON_NUMERIC = 1e-4;
var $9c7ed07589dafe64$var$THREE_SQRT = $9c7ed07589dafe64$var$mathSqrt(3);
var $9c7ed07589dafe64$var$ONE_THIRD = 1 / 3;
var $9c7ed07589dafe64$var$_v0 = (0, $eLEew.create)();
var $9c7ed07589dafe64$var$_v1 = (0, $eLEew.create)();
var $9c7ed07589dafe64$var$_v2 = (0, $eLEew.create)();
function $9c7ed07589dafe64$var$isAroundZero(val) {
    return val > -$9c7ed07589dafe64$var$EPSILON && val < $9c7ed07589dafe64$var$EPSILON;
}
function $9c7ed07589dafe64$var$isNotAroundZero(val) {
    return val > $9c7ed07589dafe64$var$EPSILON || val < -$9c7ed07589dafe64$var$EPSILON;
}
function $9c7ed07589dafe64$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $9c7ed07589dafe64$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $9c7ed07589dafe64$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(A) && $9c7ed07589dafe64$var$isAroundZero(B)) {
        if ($9c7ed07589dafe64$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$9c7ed07589dafe64$var$mathPow(-Y1, $9c7ed07589dafe64$var$ONE_THIRD);
            else Y1 = $9c7ed07589dafe64$var$mathPow(Y1, $9c7ed07589dafe64$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$9c7ed07589dafe64$var$mathPow(-Y2, $9c7ed07589dafe64$var$ONE_THIRD);
            else Y2 = $9c7ed07589dafe64$var$mathPow(Y2, $9c7ed07589dafe64$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $9c7ed07589dafe64$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $9c7ed07589dafe64$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(a)) {
        if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $9c7ed07589dafe64$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $9c7ed07589dafe64$var$_v0[0] = x;
    $9c7ed07589dafe64$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $9c7ed07589dafe64$var$mathSqrt(d);
}
function $9c7ed07589dafe64$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $9c7ed07589dafe64$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $9c7ed07589dafe64$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $9c7ed07589dafe64$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($9c7ed07589dafe64$var$isAroundZero(a)) {
        if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $9c7ed07589dafe64$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $9c7ed07589dafe64$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $9c7ed07589dafe64$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $9c7ed07589dafe64$var$_v0[0] = x;
    $9c7ed07589dafe64$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, _t);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, prev);
        $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, next);
            $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $eLEew.distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $9c7ed07589dafe64$var$mathSqrt(d);
}
function $9c7ed07589dafe64$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
        var y = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

});



parcelRegister("k3yEY", function(module, exports) {

$parcel$export(module.exports, "contain", () => $e99ef93372091697$export$8893e2b90ba10d92);
$parcel$export(module.exports, "containStroke", () => $e99ef93372091697$export$8d36b1b5d19157c5);

var $aA4Ws = parcelRequire("aA4Ws");

var $1oALq = parcelRequire("1oALq");

var $bTFCK = parcelRequire("bTFCK");

var $1nzVA = parcelRequire("1nzVA");

var $69jpm = parcelRequire("69jpm");

var $dr1jo = parcelRequire("dr1jo");

var $3Ytji = parcelRequire("3Ytji");
var $e99ef93372091697$var$CMD = (0, $aA4Ws.default).CMD;
var $e99ef93372091697$var$PI2 = Math.PI * 2;
var $e99ef93372091697$var$EPSILON = 1e-4;
function $e99ef93372091697$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $e99ef93372091697$var$EPSILON;
}
var $e99ef93372091697$var$roots = [
    -1,
    -1,
    -1
];
var $e99ef93372091697$var$extrema = [
    -1,
    -1
];
function $e99ef93372091697$var$swapExtrema() {
    var tmp = $e99ef93372091697$var$extrema[0];
    $e99ef93372091697$var$extrema[0] = $e99ef93372091697$var$extrema[1];
    $e99ef93372091697$var$extrema[1] = tmp;
}
function $e99ef93372091697$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $dr1jo.cubicRootAt(y0, y1, y2, y3, y, $e99ef93372091697$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $e99ef93372091697$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $dr1jo.cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $dr1jo.cubicExtrema(y0, y1, y2, y3, $e99ef93372091697$var$extrema);
                if ($e99ef93372091697$var$extrema[1] < $e99ef93372091697$var$extrema[0] && nExtrema > 1) $e99ef93372091697$var$swapExtrema();
                y0_ = $dr1jo.cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[0]);
                if (nExtrema > 1) y1_ = $dr1jo.cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $e99ef93372091697$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $e99ef93372091697$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $dr1jo.quadraticRootAt(y0, y1, y2, y, $e99ef93372091697$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $dr1jo.quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $dr1jo.quadraticAt(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $e99ef93372091697$var$roots[i] === 0 || $e99ef93372091697$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $dr1jo.quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[i]);
                if (x_ < x) continue;
                if ($e99ef93372091697$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $e99ef93372091697$var$roots[0] === 0 || $e99ef93372091697$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $dr1jo.quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $e99ef93372091697$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $e99ef93372091697$var$roots[0] = -tmp;
    $e99ef93372091697$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $e99ef93372091697$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $e99ef93372091697$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $e99ef93372091697$var$roots[0] + cx && x <= $e99ef93372091697$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $e99ef93372091697$var$PI2;
        endAngle += $e99ef93372091697$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $e99ef93372091697$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $e99ef93372091697$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $e99ef93372091697$var$PI2 >= startAngle && angle + $e99ef93372091697$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $e99ef93372091697$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $e99ef93372091697$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $e99ef93372091697$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $e99ef93372091697$var$CMD.L:
                if (isStroke) {
                    if ($1oALq.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $3Ytji.default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.C:
                if (isStroke) {
                    if ($bTFCK.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e99ef93372091697$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.Q:
                if (isStroke) {
                    if ($1nzVA.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e99ef93372091697$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e99ef93372091697$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $3Ytji.default)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($69jpm.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $e99ef93372091697$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $e99ef93372091697$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($1oALq.containStroke(x0, y0, x1, y0, lineWidth, x, y) || $1oALq.containStroke(x1, y0, x1, y1, lineWidth, x, y) || $1oALq.containStroke(x1, y1, x0, y1, lineWidth, x, y) || $1oALq.containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $3Ytji.default)(x1, y0, x1, y1, x, y);
                    w += (0, $3Ytji.default)(x0, y1, x0, y0, x, y);
                }
                break;
            case $e99ef93372091697$var$CMD.Z:
                if (isStroke) {
                    if ($1oALq.containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$e99ef93372091697$var$isAroundEqual(yi, y0)) w += (0, $3Ytji.default)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $e99ef93372091697$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $e99ef93372091697$var$containPath(pathProxy, 0, false, x, y);
}
function $e99ef93372091697$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $e99ef93372091697$var$containPath(pathProxy, lineWidth, true, x, y);
}

});
parcelRegister("1oALq", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $10448ce251a929f8$export$8d36b1b5d19157c5);
function $10448ce251a929f8$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

});

parcelRegister("bTFCK", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $8a951e6f66d6987a$export$8d36b1b5d19157c5);

var $dr1jo = parcelRequire("dr1jo");
function $8a951e6f66d6987a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $dr1jo.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("1nzVA", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $1013ceeba79e2375$export$8d36b1b5d19157c5);

var $dr1jo = parcelRequire("dr1jo");
function $1013ceeba79e2375$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $dr1jo.quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("69jpm", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $47a2a3596d9bac74$export$8d36b1b5d19157c5);

var $kvt3T = parcelRequire("kvt3T");
var $47a2a3596d9bac74$var$PI2 = Math.PI * 2;
function $47a2a3596d9bac74$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $47a2a3596d9bac74$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kvt3T.normalizeRadian)(endAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kvt3T.normalizeRadian)(startAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $47a2a3596d9bac74$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $47a2a3596d9bac74$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $47a2a3596d9bac74$var$PI2 >= startAngle && angle + $47a2a3596d9bac74$var$PI2 <= endAngle;
}

});
parcelRegister("kvt3T", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $eedd3ef967ea7890$export$d44861331f213635);
var $eedd3ef967ea7890$var$PI2 = Math.PI * 2;
function $eedd3ef967ea7890$export$d44861331f213635(angle) {
    angle %= $eedd3ef967ea7890$var$PI2;
    if (angle < 0) angle += $eedd3ef967ea7890$var$PI2;
    return angle;
}

});


parcelRegister("3Ytji", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4db612d32f7532$export$2e2bcd8739ae039);
function $2e4db612d32f7532$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

});



parcelRegister("cTDbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $96390378868b6806$export$2e2bcd8739ae039);

var $aA4Ws = parcelRequire("aA4Ws");

var $eLEew = parcelRequire("eLEew");
var $96390378868b6806$var$CMD = (0, $aA4Ws.default).CMD;
var $96390378868b6806$var$points = [
    [],
    [],
    []
];
var $96390378868b6806$var$mathSqrt = Math.sqrt;
var $96390378868b6806$var$mathAtan2 = Math.atan2;
function $96390378868b6806$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $96390378868b6806$var$CMD.M;
    var C = $96390378868b6806$var$CMD.C;
    var L = $96390378868b6806$var$CMD.L;
    var R = $96390378868b6806$var$CMD.R;
    var A = $96390378868b6806$var$CMD.A;
    var Q = $96390378868b6806$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $96390378868b6806$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $96390378868b6806$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $96390378868b6806$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $eLEew.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $eLEew.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $96390378868b6806$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $eLEew.applyTransform)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

});


parcelRegister("gcbBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6c53e2dabf533$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $1E3E8 = parcelRequire("1E3E8");

var $bahqM = parcelRequire("bahqM");
var $bca6c53e2dabf533$export$8993f922aeeac642 = (0, $bahqM.defaults)({
    x: 0,
    y: 0
}, (0, $lBQ88.DEFAULT_COMMON_STYLE));
var $bca6c53e2dabf533$export$4aba8ad70847a488 = {
    style: (0, $bahqM.defaults)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
function $bca6c53e2dabf533$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $bca6c53e2dabf533$var$ZRImage = function(_super) {
    (0, $3VFsf.__extends)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($bca6c53e2dabf533$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $bca6c53e2dabf533$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $bca6c53e2dabf533$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1E3E8.default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $lBQ88.default));
$bca6c53e2dabf533$var$ZRImage.prototype.type = 'image';
var $bca6c53e2dabf533$export$2e2bcd8739ae039 = $bca6c53e2dabf533$var$ZRImage;

});

parcelRegister("4gEFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b833f429060f54$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $h6fMM = parcelRequire("h6fMM");

var $45jlh = parcelRequire("45jlh");

var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");

var $gcbBH = parcelRequire("gcbBH");

var $7Tw7u = parcelRequire("7Tw7u");

var $1E3E8 = parcelRequire("1E3E8");

var $lBQ88 = parcelRequire("lBQ88");
var $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $31b833f429060f54$export$21aaaa0607ee0e2b = {
    style: (0, $bahqM.defaults)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $lBQ88.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $31b833f429060f54$var$ZRText = function(_super) {
    (0, $3VFsf.__extends)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $31b833f429060f54$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1E3E8.default)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {
        throw new Error('Can\'t attach text on another text');
    };
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $bahqM.extend)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $bahqM.keys)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $bahqM.extend)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $31b833f429060f54$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $b7ZX8.DEFAULT_FONT);
        var textPadding = style.padding;
        var text = $31b833f429060f54$var$getStyleText(style);
        var contentBlock = (0, $h6fMM.parsePlainText)(text, style);
        var needDrawBg = $31b833f429060f54$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $b7ZX8.adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var outerWidth_1 = contentBlock.width;
            textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
            var boxX = (0, $b7ZX8.adjustTextX)(baseX, outerWidth_1, textAlign);
            var boxY = (0, $b7ZX8.adjustTextY)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $31b833f429060f54$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $31b833f429060f54$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $31b833f429060f54$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $45jlh.default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            if (textStroke) {
                subElStyle.stroke = textStroke;
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            if (textFill) subElStyle.fill = textFill;
            subElStyle.font = textFont;
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $1E3E8.default)((0, $b7ZX8.adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, $b7ZX8.adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $31b833f429060f54$var$getStyleText(style);
        var contentBlock = (0, $h6fMM.parseRichText)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $b7ZX8.adjustTextX)(baseX, outerWidth, textAlign);
        var boxY = (0, $b7ZX8.adjustTextY)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($31b833f429060f54$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $31b833f429060f54$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $45jlh.default));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $31b833f429060f54$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $31b833f429060f54$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $b7ZX8.DEFAULT_FONT);
        subElStyle.opacity = (0, $bahqM.retrieve3)(tokenStyle.opacity, style.opacity, 1);
        if (textStroke) {
            subElStyle.lineWidth = (0, $bahqM.retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $bahqM.retrieve2)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $1E3E8.default)((0, $b7ZX8.adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $b7ZX8.adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $7Tw7u.default));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $bahqM.retrieve2)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $gcbBH.default));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $bahqM.retrieve2)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $bahqM.retrieve3)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if (style.fontSize || style.fontFamily || style.fontWeight) {
            var fontSize = '';
            if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
            else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
            else fontSize = '12px';
            font = [
                style.fontStyle,
                style.fontWeight,
                fontSize,
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && (0, $bahqM.trim)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $lBQ88.default));
var $31b833f429060f54$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
function $31b833f429060f54$export$176336068cc5371f(style) {
    $31b833f429060f54$var$normalizeStyle(style);
    (0, $bahqM.each)(style.rich, $31b833f429060f54$var$normalizeStyle);
    return style;
}
function $31b833f429060f54$var$normalizeStyle(style) {
    if (style) {
        style.font = $31b833f429060f54$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $31b833f429060f54$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $bahqM.normalizeCssArray)(style.padding);
    }
}
function $31b833f429060f54$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $31b833f429060f54$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $31b833f429060f54$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $31b833f429060f54$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $31b833f429060f54$export$2e2bcd8739ae039 = $31b833f429060f54$var$ZRText;

});
parcelRegister("h6fMM", function(module, exports) {

$parcel$export(module.exports, "truncateText", () => $c72f3dec0993863b$export$59a943b34a82e690);
$parcel$export(module.exports, "parsePlainText", () => $c72f3dec0993863b$export$5772575e34ef80f9);
$parcel$export(module.exports, "parseRichText", () => $c72f3dec0993863b$export$15ec9472ff2d721);

var $63nvx = parcelRequire("63nvx");

var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");
var $c72f3dec0993863b$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $c72f3dec0993863b$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return '';
    var textLines = (text + '').split('\n');
    options = $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c72f3dec0993863b$var$truncateSingleLine(textLines[i], options);
    return textLines.join('\n');
}
function $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $bahqM.extend)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $bahqM.retrieve2)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $bahqM.retrieve2)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $bahqM.retrieve2)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $b7ZX8.getWidth)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $b7ZX8.getWidth)('a', font);
    preparedOpts.placeholder = (0, $bahqM.retrieve2)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $b7ZX8.getWidth)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $c72f3dec0993863b$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return '';
    var lineWidth = (0, $b7ZX8.getWidth)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $c72f3dec0993863b$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $b7ZX8.getWidth)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    return textLine;
}
function $c72f3dec0993863b$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $c72f3dec0993863b$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $b7ZX8.getLineHeight)(font);
    var lineHeight = (0, $bahqM.retrieve2)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c72f3dec0993863b$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $bahqM.retrieve2)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    var outerHeight = height;
    var outerWidth = width;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        if (outerWidth != null) outerWidth += padding[1] + padding[3];
    }
    if (text && truncate && outerWidth != null) {
        var options = $c72f3dec0993863b$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $c72f3dec0993863b$var$truncateSingleLine(lines[i], options);
    }
    if (width == null) {
        var maxWidth = 0;
        for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, $b7ZX8.getWidth)(lines[i], font), maxWidth);
        width = maxWidth;
    }
    return {
        lines: lines,
        height: height,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentHeight: contentHeight,
        width: width
    };
}
var $c72f3dec0993863b$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $c72f3dec0993863b$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $c72f3dec0993863b$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $c72f3dec0993863b$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $c72f3dec0993863b$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $c72f3dec0993863b$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $c72f3dec0993863b$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $b7ZX8.getLineHeight)(font);
            var tokenHeight = (0, $bahqM.retrieve2)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $bahqM.retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $63nvx.findExistImage(bgImg);
                        if ($63nvx.isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $c72f3dec0993863b$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
                    }
                } else token.contentWidth = (0, $b7ZX8.getWidth)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $bahqM.retrieve2)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $bahqM.retrieve2)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $c72f3dec0993863b$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $b7ZX8.parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $c72f3dec0993863b$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $c72f3dec0993863b$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $b7ZX8.getWidth)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $c72f3dec0993863b$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $c72f3dec0993863b$var$RichTextLine([
            token
        ]));
    }
}
function $c72f3dec0993863b$var$isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0xFF;
}
var $c72f3dec0993863b$var$breakCharMap = (0, $bahqM.reduce)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $c72f3dec0993863b$var$isWordBreakChar(ch) {
    if ($c72f3dec0993863b$var$isLatin(ch)) {
        if ($c72f3dec0993863b$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $c72f3dec0993863b$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $b7ZX8.getWidth)(ch, font);
        var inWord = isBreakAll ? false : !$c72f3dec0993863b$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        accumWidth += currentWordWidth;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}

});
parcelRegister("63nvx", function(module, exports) {

$parcel$export(module.exports, "findExistImage", () => $468542031e7bbc2a$export$1b614f30ac2c8867);
$parcel$export(module.exports, "createOrUpdateImage", () => $468542031e7bbc2a$export$46c791b69ff9a0f);
$parcel$export(module.exports, "isImageReady", () => $468542031e7bbc2a$export$37ca7dd901d0236d);

var $h4RuA = parcelRequire("h4RuA");
var $468542031e7bbc2a$var$globalImageCache = new (0, $h4RuA.default)(50);
function $468542031e7bbc2a$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $468542031e7bbc2a$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$468542031e7bbc2a$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = new Image();
            image.onload = image.onerror = $468542031e7bbc2a$var$imageOnLoad;
            $468542031e7bbc2a$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
            image.src = image.__zrImageSrc = newImageOrSrc;
        }
        return image;
    } else return newImageOrSrc;
}
function $468542031e7bbc2a$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $468542031e7bbc2a$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}

});


parcelRegister("45jlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f96a200e6d0cf38$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $b7ZX8 = parcelRequire("b7ZX8");

var $ghQ8v = parcelRequire("ghQ8v");

var $bahqM = parcelRequire("bahqM");
var $2f96a200e6d0cf38$export$5fbb6d98091bcb56 = (0, $bahqM.defaults)({
    strokeFirst: true,
    font: (0, $b7ZX8.DEFAULT_FONT),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $ghQ8v.DEFAULT_PATH_STYLE));
var $2f96a200e6d0cf38$var$TSpan = function(_super) {
    (0, $3VFsf.__extends)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $bahqM.createObject)($2f96a200e6d0cf38$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $b7ZX8.getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $lBQ88.default));
$2f96a200e6d0cf38$var$TSpan.prototype.type = 'tspan';
var $2f96a200e6d0cf38$export$2e2bcd8739ae039 = $2f96a200e6d0cf38$var$TSpan;

});

parcelRegister("7Tw7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bf695c646bd738a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $7AySl = parcelRequire("7AySl");

var $2az2p = parcelRequire("2az2p");
var $5bf695c646bd738a$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $5bf695c646bd738a$var$subPixelOptimizeOutputShape = {};
var $5bf695c646bd738a$var$Rect = function(_super) {
    (0, $3VFsf.__extends)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $5bf695c646bd738a$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $2az2p.subPixelOptimizeRect)($5bf695c646bd738a$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $7AySl.buildPath(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $ghQ8v.default));
$5bf695c646bd738a$var$Rect.prototype.type = 'rect';
var $5bf695c646bd738a$export$2e2bcd8739ae039 = $5bf695c646bd738a$var$Rect;

});
parcelRegister("7AySl", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $5866f2ba314594b2$export$5cc7f731b5937e99);
function $5866f2ba314594b2$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

});

parcelRegister("2az2p", function(module, exports) {

$parcel$export(module.exports, "subPixelOptimizeLine", () => $1947b1c1b6b500f1$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimize", () => $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $1947b1c1b6b500f1$export$60e2aa74957d0b9d);
var $1947b1c1b6b500f1$var$round = Math.round;
function $1947b1c1b6b500f1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($1947b1c1b6b500f1$var$round(x1 * 2) === $1947b1c1b6b500f1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($1947b1c1b6b500f1$var$round(y1 * 2) === $1947b1c1b6b500f1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $1947b1c1b6b500f1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $1947b1c1b6b500f1$var$round(position * 2);
    return (doubledPosition + $1947b1c1b6b500f1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

});



parcelRegister("jjfok", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ebbb12e4687e45$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $e0ebbb12e4687e45$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $e0ebbb12e4687e45$var$Circle = function(_super) {
    (0, $3VFsf.__extends)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $e0ebbb12e4687e45$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape, inBundle) {
        if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $ghQ8v.default));
$e0ebbb12e4687e45$var$Circle.prototype.type = 'circle';
var $e0ebbb12e4687e45$export$2e2bcd8739ae039 = $e0ebbb12e4687e45$var$Circle;

});

parcelRegister("kVeV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b4b46f050115c8$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $f3b4b46f050115c8$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $f3b4b46f050115c8$var$Ellipse = function(_super) {
    (0, $3VFsf.__extends)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $f3b4b46f050115c8$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $ghQ8v.default));
$f3b4b46f050115c8$var$Ellipse.prototype.type = 'ellipse';
var $f3b4b46f050115c8$export$2e2bcd8739ae039 = $f3b4b46f050115c8$var$Ellipse;

});

parcelRegister("elGBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a724147a13426864$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $3kXtf = parcelRequire("3kXtf");
var $a724147a13426864$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
        this.innerCornerRadius = 0;
    }
    return SectorShape;
}();
var $a724147a13426864$var$Sector = function(_super) {
    (0, $3VFsf.__extends)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a724147a13426864$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $3kXtf.buildPath(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $ghQ8v.default));
$a724147a13426864$var$Sector.prototype.type = 'sector';
var $a724147a13426864$export$2e2bcd8739ae039 = $a724147a13426864$var$Sector;

});
parcelRegister("3kXtf", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $26e15f024d5166f6$export$5cc7f731b5937e99);

var $aA4Ws = parcelRequire("aA4Ws");
var $26e15f024d5166f6$var$PI = Math.PI;
var $26e15f024d5166f6$var$PI2 = $26e15f024d5166f6$var$PI * 2;
var $26e15f024d5166f6$var$mathSin = Math.sin;
var $26e15f024d5166f6$var$mathCos = Math.cos;
var $26e15f024d5166f6$var$mathACos = Math.acos;
var $26e15f024d5166f6$var$mathATan2 = Math.atan2;
var $26e15f024d5166f6$var$mathAbs = Math.abs;
var $26e15f024d5166f6$var$mathSqrt = Math.sqrt;
var $26e15f024d5166f6$var$mathMax = Math.max;
var $26e15f024d5166f6$var$mathMin = Math.min;
var $26e15f024d5166f6$var$e = 1e-4;
function $26e15f024d5166f6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0;
    var y10 = y1 - y0;
    var x32 = x3 - x2;
    var y32 = y3 - y2;
    var t = y32 * x10 - x32 * y10;
    if (t * t < $26e15f024d5166f6$var$e) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
function $26e15f024d5166f6$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $26e15f024d5166f6$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $26e15f024d5166f6$var$mathSqrt($26e15f024d5166f6$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (radius / r - 1),
        y11: cy0 * (radius / r - 1)
    };
}
function $26e15f024d5166f6$export$5cc7f731b5937e99(ctx, shape) {
    var radius = $26e15f024d5166f6$var$mathMax(shape.r, 0);
    var innerRadius = $26e15f024d5166f6$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var clockwise = !!shape.clockwise;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var arc;
    if (startAngle === endAngle) arc = 0;
    else {
        var tmpAngles = [
            startAngle,
            endAngle
        ];
        (0, $aA4Ws.normalizeArcAngles)(tmpAngles, !clockwise);
        arc = $26e15f024d5166f6$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
    }
    var x = shape.cx;
    var y = shape.cy;
    var cornerRadius = shape.cornerRadius || 0;
    var innerCornerRadius = shape.innerCornerRadius || 0;
    if (!(radius > $26e15f024d5166f6$var$e)) ctx.moveTo(x, y);
    else if (arc > $26e15f024d5166f6$var$PI2 - $26e15f024d5166f6$var$e) {
        ctx.moveTo(x + radius * $26e15f024d5166f6$var$mathCos(startAngle), y + radius * $26e15f024d5166f6$var$mathSin(startAngle));
        ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $26e15f024d5166f6$var$e) {
            ctx.moveTo(x + innerRadius * $26e15f024d5166f6$var$mathCos(endAngle), y + innerRadius * $26e15f024d5166f6$var$mathSin(endAngle));
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var halfRd = $26e15f024d5166f6$var$mathAbs(radius - innerRadius) / 2;
        var cr = $26e15f024d5166f6$var$mathMin(halfRd, cornerRadius);
        var icr = $26e15f024d5166f6$var$mathMin(halfRd, innerCornerRadius);
        var cr0 = icr;
        var cr1 = cr;
        var xrs = radius * $26e15f024d5166f6$var$mathCos(startAngle);
        var yrs = radius * $26e15f024d5166f6$var$mathSin(startAngle);
        var xire = innerRadius * $26e15f024d5166f6$var$mathCos(endAngle);
        var yire = innerRadius * $26e15f024d5166f6$var$mathSin(endAngle);
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        if (cr > $26e15f024d5166f6$var$e || icr > $26e15f024d5166f6$var$e) {
            xre = radius * $26e15f024d5166f6$var$mathCos(endAngle);
            yre = radius * $26e15f024d5166f6$var$mathSin(endAngle);
            xirs = innerRadius * $26e15f024d5166f6$var$mathCos(startAngle);
            yirs = innerRadius * $26e15f024d5166f6$var$mathSin(startAngle);
            if (arc < $26e15f024d5166f6$var$PI) {
                var it_1 = $26e15f024d5166f6$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                if (it_1) {
                    var x0 = xrs - it_1[0];
                    var y0 = yrs - it_1[1];
                    var x1 = xre - it_1[0];
                    var y1 = yre - it_1[1];
                    var a = 1 / $26e15f024d5166f6$var$mathSin($26e15f024d5166f6$var$mathACos((x0 * x1 + y0 * y1) / ($26e15f024d5166f6$var$mathSqrt(x0 * x0 + y0 * y0) * $26e15f024d5166f6$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                    var b = $26e15f024d5166f6$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                    cr0 = $26e15f024d5166f6$var$mathMin(icr, (innerRadius - b) / (a - 1));
                    cr1 = $26e15f024d5166f6$var$mathMin(cr, (radius - b) / (a + 1));
                }
            }
        }
        if (!(arc > $26e15f024d5166f6$var$e)) ctx.moveTo(x + xrs, y + yrs);
        else if (cr1 > $26e15f024d5166f6$var$e) {
            var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
            var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
            ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, radius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.moveTo(x + xrs, y + yrs);
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $26e15f024d5166f6$var$e) || !(arc > $26e15f024d5166f6$var$e)) ctx.lineTo(x + xire, y + yire);
        else if (cr0 > $26e15f024d5166f6$var$e) {
            var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
            var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
            ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, innerRadius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.lineTo(x + xire, y + yire);
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

});


parcelRegister("LCHOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $08f26a0aa2f0a2fd$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $08f26a0aa2f0a2fd$var$Ring = function(_super) {
    (0, $3VFsf.__extends)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $ghQ8v.default));
$08f26a0aa2f0a2fd$var$Ring.prototype.type = 'ring';
var $08f26a0aa2f0a2fd$export$2e2bcd8739ae039 = $08f26a0aa2f0a2fd$var$Ring;

});

parcelRegister("lQwBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe77bdccf816487a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $gLMXf = parcelRequire("gLMXf");
var $fe77bdccf816487a$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $fe77bdccf816487a$var$Polygon = function(_super) {
    (0, $3VFsf.__extends)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $fe77bdccf816487a$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $gLMXf.buildPath(ctx, shape, true);
    };
    return Polygon;
}((0, $ghQ8v.default));
$fe77bdccf816487a$var$Polygon.prototype.type = 'polygon';
var $fe77bdccf816487a$export$2e2bcd8739ae039 = $fe77bdccf816487a$var$Polygon;

});
parcelRegister("gLMXf", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $c357027dbb0e6a00$export$5cc7f731b5937e99);

var $bEkQR = parcelRequire("bEkQR");

var $4Fmqi = parcelRequire("4Fmqi");
function $c357027dbb0e6a00$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth && smooth !== 'spline') {
            var controlPoints = (0, $4Fmqi.default)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            if (smooth === 'spline') points = (0, $bEkQR.default)(points, closePath);
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}

});
parcelRegister("bEkQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b39ad613612da7$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");
function $87b39ad613612da7$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $87b39ad613612da7$export$2e2bcd8739ae039(points, isLoop) {
    var len = points.length;
    var ret = [];
    var distance = 0;
    for(var i = 1; i < len; i++)distance += (0, $eLEew.distance)(points[i - 1], points[i]);
    var segs = distance / 2;
    segs = segs < len ? len : segs;
    for(var i = 0; i < segs; i++){
        var pos = i / (segs - 1) * (isLoop ? len : len - 1);
        var idx = Math.floor(pos);
        var w = pos - idx;
        var p0 = void 0;
        var p1 = points[idx % len];
        var p2 = void 0;
        var p3 = void 0;
        if (!isLoop) {
            p0 = points[idx === 0 ? idx : idx - 1];
            p2 = points[idx > len - 2 ? len - 1 : idx + 1];
            p3 = points[idx > len - 3 ? len - 1 : idx + 2];
        } else {
            p0 = points[(idx - 1 + len) % len];
            p2 = points[(idx + 1) % len];
            p3 = points[(idx + 2) % len];
        }
        var w2 = w * w;
        var w3 = w * w2;
        ret.push([
            $87b39ad613612da7$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
            $87b39ad613612da7$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
        ]);
    }
    return ret;
}

});

parcelRegister("4Fmqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $365c6287f8cf6aea$export$2e2bcd8739ae039);

var $eLEew = parcelRequire("eLEew");
function $365c6287f8cf6aea$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $eLEew.min)(min, min, points[i]);
            (0, $eLEew.max)(max, max, points[i]);
        }
        (0, $eLEew.min)(min, min, constraint[0]);
        (0, $eLEew.max)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $eLEew.clone)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $eLEew.sub)(v, nextPoint, prevPoint);
        (0, $eLEew.scale)(v, v, smooth);
        var d0 = (0, $eLEew.distance)(point, prevPoint);
        var d1 = (0, $eLEew.distance)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $eLEew.scale)(v1, v, -d0);
        (0, $eLEew.scale)(v2, v, d1);
        var cp0 = (0, $eLEew.add)([], point, v1);
        var cp1 = (0, $eLEew.add)([], point, v2);
        if (constraint) {
            (0, $eLEew.max)(cp0, cp0, min);
            (0, $eLEew.min)(cp0, cp0, max);
            (0, $eLEew.max)(cp1, cp1, min);
            (0, $eLEew.min)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}

});



parcelRegister("32bXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $235ad4ce0d26a4ed$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $gLMXf = parcelRequire("gLMXf");
var $235ad4ce0d26a4ed$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $235ad4ce0d26a4ed$var$Polyline = function(_super) {
    (0, $3VFsf.__extends)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $235ad4ce0d26a4ed$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $gLMXf.buildPath(ctx, shape, false);
    };
    return Polyline;
}((0, $ghQ8v.default));
$235ad4ce0d26a4ed$var$Polyline.prototype.type = 'polyline';
var $235ad4ce0d26a4ed$export$2e2bcd8739ae039 = $235ad4ce0d26a4ed$var$Polyline;

});

parcelRegister("cZb1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9743bc0ad02b6789$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $2az2p = parcelRequire("2az2p");
var $9743bc0ad02b6789$var$subPixelOptimizeOutputShape = {};
var $9743bc0ad02b6789$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $9743bc0ad02b6789$var$Line = function(_super) {
    (0, $3VFsf.__extends)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $9743bc0ad02b6789$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $2az2p.subPixelOptimizeLine)($9743bc0ad02b6789$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $ghQ8v.default));
$9743bc0ad02b6789$var$Line.prototype.type = 'line';
var $9743bc0ad02b6789$export$2e2bcd8739ae039 = $9743bc0ad02b6789$var$Line;

});

parcelRegister("04gw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $00cd2f675f351e5a$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $eLEew = parcelRequire("eLEew");

var $dr1jo = parcelRequire("dr1jo");
var $00cd2f675f351e5a$var$out = [];
var $00cd2f675f351e5a$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $00cd2f675f351e5a$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 === null || cpy2 === null) return [
        (isTangent ? (0, $dr1jo.cubicDerivativeAt) : (0, $dr1jo.cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $dr1jo.cubicDerivativeAt) : (0, $dr1jo.cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $dr1jo.quadraticDerivativeAt) : (0, $dr1jo.quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $dr1jo.quadraticDerivativeAt) : (0, $dr1jo.quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $00cd2f675f351e5a$var$BezierCurve = function(_super) {
    (0, $3VFsf.__extends)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $00cd2f675f351e5a$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $dr1jo.quadraticSubdivide)(x1, cpx1, x2, percent, $00cd2f675f351e5a$var$out);
                cpx1 = $00cd2f675f351e5a$var$out[1];
                x2 = $00cd2f675f351e5a$var$out[2];
                (0, $dr1jo.quadraticSubdivide)(y1, cpy1, y2, percent, $00cd2f675f351e5a$var$out);
                cpy1 = $00cd2f675f351e5a$var$out[1];
                y2 = $00cd2f675f351e5a$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $dr1jo.cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $00cd2f675f351e5a$var$out);
                cpx1 = $00cd2f675f351e5a$var$out[1];
                cpx2 = $00cd2f675f351e5a$var$out[2];
                x2 = $00cd2f675f351e5a$var$out[3];
                (0, $dr1jo.cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $00cd2f675f351e5a$var$out);
                cpy1 = $00cd2f675f351e5a$var$out[1];
                cpy2 = $00cd2f675f351e5a$var$out[2];
                y2 = $00cd2f675f351e5a$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $00cd2f675f351e5a$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $00cd2f675f351e5a$var$someVectorAt(this.shape, t, true);
        return $eLEew.normalize(p, p);
    };
    return BezierCurve;
}((0, $ghQ8v.default));
$00cd2f675f351e5a$var$BezierCurve.prototype.type = 'bezier-curve';
var $00cd2f675f351e5a$export$2e2bcd8739ae039 = $00cd2f675f351e5a$var$BezierCurve;

});

parcelRegister("ixXaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80935fda1e22f1c$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $d80935fda1e22f1c$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $d80935fda1e22f1c$var$Arc = function(_super) {
    (0, $3VFsf.__extends)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $d80935fda1e22f1c$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $ghQ8v.default));
$d80935fda1e22f1c$var$Arc.prototype.type = 'arc';
var $d80935fda1e22f1c$export$2e2bcd8739ae039 = $d80935fda1e22f1c$var$Arc;

});

parcelRegister("eGltS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab05a69c83088c4b$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");
var $ab05a69c83088c4b$var$CompoundPath = function(_super) {
    (0, $3VFsf.__extends)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $ghQ8v.default).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $ghQ8v.default));
var $ab05a69c83088c4b$export$2e2bcd8739ae039 = $ab05a69c83088c4b$var$CompoundPath;

});

parcelRegister("9J7f8", function(module, exports) {

$parcel$export(module.exports, "default", () => $714def5c08e9d5ff$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jnhEE = parcelRequire("jnhEE");
var $714def5c08e9d5ff$var$LinearGradient = function(_super) {
    (0, $3VFsf.__extends)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $jnhEE.default));
var $714def5c08e9d5ff$export$2e2bcd8739ae039 = $714def5c08e9d5ff$var$LinearGradient;

});
parcelRegister("jnhEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1addc27dbc63739$export$2e2bcd8739ae039);
var $e1addc27dbc63739$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $e1addc27dbc63739$export$2e2bcd8739ae039 = $e1addc27dbc63739$var$Gradient;

});


parcelRegister("faICo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ba666d3a488180$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jnhEE = parcelRequire("jnhEE");
var $b0ba666d3a488180$var$RadialGradient = function(_super) {
    (0, $3VFsf.__extends)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $jnhEE.default));
var $b0ba666d3a488180$export$2e2bcd8739ae039 = $b0ba666d3a488180$var$RadialGradient;

});

parcelRegister("lM5Gp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda27d30e90880c7$export$2e2bcd8739ae039);

var $bMDnR = parcelRequire("bMDnR");
var $fda27d30e90880c7$var$extent = [
    0,
    0
];
var $fda27d30e90880c7$var$extent2 = [
    0,
    0
];
var $fda27d30e90880c7$var$minTv = new (0, $bMDnR.default)();
var $fda27d30e90880c7$var$maxTv = new (0, $bMDnR.default)();
var $fda27d30e90880c7$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $bMDnR.default)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $bMDnR.default)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $bMDnR.default).sub(axes[0], corners[1], corners[0]);
        (0, $bMDnR.default).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $fda27d30e90880c7$var$minTv.set(Infinity, Infinity);
        $fda27d30e90880c7$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $bMDnR.default).copy(mtv, overlapped ? $fda27d30e90880c7$var$minTv : $fda27d30e90880c7$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $fda27d30e90880c7$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $fda27d30e90880c7$var$extent2);
            if ($fda27d30e90880c7$var$extent[1] < $fda27d30e90880c7$var$extent2[0] || $fda27d30e90880c7$var$extent[0] > $fda27d30e90880c7$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $bMDnR.default).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $bMDnR.default).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $bMDnR.default).scale(minTv, axis, dist0 * inverse);
                    else (0, $bMDnR.default).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $fda27d30e90880c7$export$2e2bcd8739ae039 = $fda27d30e90880c7$var$OrientedBoundingRect;

});

parcelRegister("6sllV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b35ebcb0b796fce$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $lBQ88 = parcelRequire("lBQ88");

var $1E3E8 = parcelRequire("1E3E8");
var $4b35ebcb0b796fce$var$m = [];
var $4b35ebcb0b796fce$var$IncrementalDisplayable = function(_super) {
    (0, $3VFsf.__extends)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1E3E8.default)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4b35ebcb0b796fce$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $lBQ88.default));
var $4b35ebcb0b796fce$export$2e2bcd8739ae039 = $4b35ebcb0b796fce$var$IncrementalDisplayable;

});

parcelRegister("7QjoM", function(module, exports) {

$parcel$export(module.exports, "getECData", () => $5b5c6fe297852166$export$b1c39b2bacd1ddc2);
$parcel$export(module.exports, "setCommonECData", () => $5b5c6fe297852166$export$30d6736ebb8e18d5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
var $5b5c6fe297852166$export$b1c39b2bacd1ddc2 = (0, $eaKsF.makeInner)();
var $5b5c6fe297852166$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(el); // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
        });
    }
};

});
parcelRegister("eaKsF", function(module, exports) {

$parcel$export(module.exports, "normalizeToArray", () => $a5160a25a687d9b6$export$4f07b212a02c8051);
$parcel$export(module.exports, "defaultEmphasis", () => $a5160a25a687d9b6$export$abdcc6a26372f94b);
$parcel$export(module.exports, "TEXT_STYLE_OPTIONS", () => $a5160a25a687d9b6$export$df45610347a602ad);
$parcel$export(module.exports, "getDataItemValue", () => $a5160a25a687d9b6$export$2c944e12edb48d4b);
$parcel$export(module.exports, "isDataItemOption", () => $a5160a25a687d9b6$export$3e1a543f33ef6883);
$parcel$export(module.exports, "mappingToExists", () => $a5160a25a687d9b6$export$574f818966e4da87);
$parcel$export(module.exports, "isComponentIdInternal", () => $a5160a25a687d9b6$export$feece3e7d52a102b);
$parcel$export(module.exports, "convertOptionIdName", () => $a5160a25a687d9b6$export$fb1a222ba5dd6e51);
$parcel$export(module.exports, "isNameSpecified", () => $a5160a25a687d9b6$export$beae19a2652b3368);
$parcel$export(module.exports, "makeInternalComponentId", () => $a5160a25a687d9b6$export$1753133c42e665e8);
$parcel$export(module.exports, "setComponentTypeToKeyInfo", () => $a5160a25a687d9b6$export$5ac61aca2ba0282d);
$parcel$export(module.exports, "compressBatches", () => $a5160a25a687d9b6$export$6d12cabb0c9bf8e3);
$parcel$export(module.exports, "queryDataIndex", () => $a5160a25a687d9b6$export$42b26cae8b8d10);
$parcel$export(module.exports, "makeInner", () => $a5160a25a687d9b6$export$64df9f8d92ae083f);
$parcel$export(module.exports, "parseFinder", () => $a5160a25a687d9b6$export$95de80076abac814);
$parcel$export(module.exports, "preParseFinder", () => $a5160a25a687d9b6$export$fe600815775d9400);
$parcel$export(module.exports, "queryReferringComponents", () => $a5160a25a687d9b6$export$dc741340f7e5f186);
$parcel$export(module.exports, "SINGLE_REFERRING", () => $a5160a25a687d9b6$export$f076738ec84e693c);
$parcel$export(module.exports, "MULTIPLE_REFERRING", () => $a5160a25a687d9b6$export$48d598924ce4892c);
$parcel$export(module.exports, "setAttribute", () => $a5160a25a687d9b6$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "getAttribute", () => $a5160a25a687d9b6$export$735ee1799fd02602);
$parcel$export(module.exports, "getTooltipRenderMode", () => $a5160a25a687d9b6$export$cc0a17a5d27b4e17);
$parcel$export(module.exports, "groupData", () => $a5160a25a687d9b6$export$7ab5bda43e13168f);
$parcel$export(module.exports, "interpolateRawValues", () => $a5160a25a687d9b6$export$bd0439821a1869f3);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $jmSNG = parcelRequire("jmSNG");

var $hb2y5 = parcelRequire("hb2y5");

/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $a5160a25a687d9b6$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $a5160a25a687d9b6$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $a5160a25a687d9b6$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
]; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
function $a5160a25a687d9b6$export$2c944e12edb48d4b(dataItem) {
    return (0, $bahqM.isObject)(dataItem) && !(0, $bahqM.isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $a5160a25a687d9b6$export$3e1a543f33ef6883(dataItem) {
    return (0, $bahqM.isObject)(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $a5160a25a687d9b6$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $bahqM.createHashMap)(); // Validate id and name on user input option.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $bahqM.isObject)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions);
    $a5160a25a687d9b6$var$makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will ommit those items and result in incorrect result.
    return result;
}
function $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
     // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be ommited.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
         // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $a5160a25a687d9b6$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $bahqM.assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $bahqM.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) && !$a5160a25a687d9b6$export$feece3e7d52a102b(existing) && $a5160a25a687d9b6$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $bahqM.each)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
         // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while((resultItem = result[nextIdx]) && // after mapping performed, model will always be assigned with an id if user not given.
        // After that all models have id.
        // (2) If new option has id, it can only set to a hole or append to the last. It should
        // not be merged to the existings with different id. Because id should not be overwritten.
        // (3) Name can be overwritten, because axis use name as 'show label text'.
        (resultItem.newOption || $a5160a25a687d9b6$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$a5160a25a687d9b6$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $bahqM.each)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that compoennt index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $a5160a25a687d9b6$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $bahqM.createHashMap)();
    (0, $bahqM.each)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $bahqM.each)(mapResult, function(item) {
        var opt = item.newOption; // Force ensure id not duplicated.
        (0, $bahqM.assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    }); // Make name and id.
    (0, $bahqM.each)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $bahqM.isObject)(opt)) return;
         // name can be overwitten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $a5160a25a687d9b6$var$makeComparableKey(opt.name) : existing ? existing.name // Avoid diffferent series has the same name,
         : $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $a5160a25a687d9b6$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $a5160a25a687d9b6$var$makeComparableKey(val) {
    return $a5160a25a687d9b6$export$fb1a222ba5dd6e51(val, '');
}
function $a5160a25a687d9b6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    var type = typeof idOrName;
    return type === 'string' ? idOrName : type === 'number' || (0, $bahqM.isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
}
function $a5160a25a687d9b6$var$warnInvalidateIdOrName(idOrName) {}
function $a5160a25a687d9b6$var$isValidIdOrName(idOrName) {
    return (0, $bahqM.isStringSafe)(idOrName) || (0, $jmSNG.isNumeric)(idOrName);
}
function $a5160a25a687d9b6$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id).indexOf($a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $a5160a25a687d9b6$export$1753133c42e665e8(idSuffix) {
    return $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $a5160a25a687d9b6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $bahqM.each)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $bahqM.isObject)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $a5160a25a687d9b6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $a5160a25a687d9b6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
     : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $a5160a25a687d9b6$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $a5160a25a687d9b6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $a5160a25a687d9b6$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $bahqM.isArray)(payload.dataIndex) ? (0, $bahqM.map)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $bahqM.isArray)(payload.name) ? (0, $bahqM.map)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $a5160a25a687d9b6$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $a5160a25a687d9b6$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $a5160a25a687d9b6$var$innerUniqueIndex = (0, $jmSNG.getRandomIdBase)();
function $a5160a25a687d9b6$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $bahqM.isString)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $bahqM.createHashMap)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $bahqM.each)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $bahqM.indexOf)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $a5160a25a687d9b6$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $a5160a25a687d9b6$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $a5160a25a687d9b6$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $bahqM.assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    } // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $bahqM.assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $a5160a25a687d9b6$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $a5160a25a687d9b6$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $a5160a25a687d9b6$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $hZfwb.default).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $a5160a25a687d9b6$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $bahqM.createHashMap)();
    var keys = [];
    (0, $bahqM.each)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $a5160a25a687d9b6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if (typeof targetValue === 'number') {
        var value = (0, $hb2y5.interpolateNumber)(sourceValue || 0, targetValue, percent);
        return (0, $jmSNG.round)(value, isAutoPrecision ? Math.max((0, $jmSNG.getPrecision)(sourceValue || 0), (0, $jmSNG.getPrecision)(targetValue)) : precision);
    } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = (0, $hb2y5.interpolateNumber)(leftVal, rightVal, percent);
                interpolated[i] = (0, $jmSNG.round)(value, isAutoPrecision ? Math.max((0, $jmSNG.getPrecision)(leftVal), (0, $jmSNG.getPrecision)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}

});
parcelRegister("jmSNG", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => $e19a9495965944b5$export$d3f68fbaa670562);
$parcel$export(module.exports, "parsePercent", () => $e19a9495965944b5$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "round", () => $e19a9495965944b5$export$2077e0241d6afd3c);
$parcel$export(module.exports, "asc", () => $e19a9495965944b5$export$debe6e778e0a6d32);
$parcel$export(module.exports, "getPrecision", () => $e19a9495965944b5$export$e0c74b50bbd10f68);
$parcel$export(module.exports, "getPrecisionSafe", () => $e19a9495965944b5$export$6d86ba4ca4984d31);
$parcel$export(module.exports, "getPixelPrecision", () => $e19a9495965944b5$export$666260d9a2dda8a7);
$parcel$export(module.exports, "getPercentWithPrecision", () => $e19a9495965944b5$export$70cc11b075afeb90);
$parcel$export(module.exports, "addSafe", () => $e19a9495965944b5$export$d3389a301c3a5706);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $e19a9495965944b5$export$18510406f204a1b9);
$parcel$export(module.exports, "remRadian", () => $e19a9495965944b5$export$2ca6dd70a288b1c3);
$parcel$export(module.exports, "isRadianAroundZero", () => $e19a9495965944b5$export$d1df570aea2868f);
$parcel$export(module.exports, "parseDate", () => $e19a9495965944b5$export$6b862160d295c8e);
$parcel$export(module.exports, "quantity", () => $e19a9495965944b5$export$82dd68b83a44b253);
$parcel$export(module.exports, "quantityExponent", () => $e19a9495965944b5$export$97256a17b20a0c24);
$parcel$export(module.exports, "nice", () => $e19a9495965944b5$export$7a695fe44258210b);
$parcel$export(module.exports, "quantile", () => $e19a9495965944b5$export$651fb4afdb6caa4b);
$parcel$export(module.exports, "reformIntervals", () => $e19a9495965944b5$export$12f7386070bc380a);
$parcel$export(module.exports, "numericToNumber", () => $e19a9495965944b5$export$8b4007b942b45a96);
$parcel$export(module.exports, "isNumeric", () => $e19a9495965944b5$export$e90fb89750dba83f);
$parcel$export(module.exports, "getRandomIdBase", () => $e19a9495965944b5$export$474d2ec9aa44a22);
$parcel$export(module.exports, "getLeastCommonMultiple", () => $e19a9495965944b5$export$680a45b749323f49);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $bahqM = parcelRequire("bahqM");
var $e19a9495965944b5$var$RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $e19a9495965944b5$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $e19a9495965944b5$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
     // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $e19a9495965944b5$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if (typeof percent === 'string') {
        if ($e19a9495965944b5$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $e19a9495965944b5$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
     // Avoid range error
    precision = Math.min(Math.max(0, precision), $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $e19a9495965944b5$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $e19a9495965944b5$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
     // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $e19a9495965944b5$export$6d86ba4ca4984d31(val);
}
function $e19a9495965944b5$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $e19a9495965944b5$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $e19a9495965944b5$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var sum = $bahqM.reduce(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return 0;
    var digits = Math.pow(10, precision);
    var votesPerQuota = $bahqM.map(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $bahqM.map(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $bahqM.reduce(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $bahqM.map(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    }); // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
         // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats[idx] / digits;
}
function $e19a9495965944b5$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($e19a9495965944b5$export$e0c74b50bbd10f68(val0), $e19a9495965944b5$export$e0c74b50bbd10f68(val1)); // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1; // // PENDING: support more?
    return maxPrecision > $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $e19a9495965944b5$export$2077e0241d6afd3c(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.
var $e19a9495965944b5$export$18510406f204a1b9 = 9007199254740991;
function $e19a9495965944b5$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $e19a9495965944b5$export$d1df570aea2868f(val) {
    return val > -$e19a9495965944b5$var$RADIAN_EPSILON && val < $e19a9495965944b5$var$RADIAN_EPSILON;
} // eslint-disable-next-line
var $e19a9495965944b5$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $e19a9495965944b5$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if (typeof value === 'string') {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $e19a9495965944b5$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
         // Use local time when no timezone offset specifed.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $e19a9495965944b5$export$82dd68b83a44b253(val) {
    return Math.pow(10, $e19a9495965944b5$export$97256a17b20a0c24(val));
}
function $e19a9495965944b5$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $e19a9495965944b5$export$7a695fe44258210b(val, round) {
    var exponent = $e19a9495965944b5$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $e19a9495965944b5$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $e19a9495965944b5$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $e19a9495965944b5$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $e19a9495965944b5$export$e90fb89750dba83f(val) {
    return !isNaN($e19a9495965944b5$export$8b4007b942b45a96(val));
}
function $e19a9495965944b5$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $e19a9495965944b5$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $e19a9495965944b5$export$a368fd580c0d0fe4(b, a % b);
}
function $e19a9495965944b5$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $e19a9495965944b5$export$a368fd580c0d0fe4(a, b);
}

});



parcelRegister("eYgMC", function(module, exports) {

$parcel$export(module.exports, "getAnimationConfig", () => $ae63b016ce1bd907$export$5cc7add7ab591d0a);
$parcel$export(module.exports, "updateProps", () => $ae63b016ce1bd907$export$c8dce3c08436e91e);
$parcel$export(module.exports, "initProps", () => $ae63b016ce1bd907$export$a121566aadcfe021);
$parcel$export(module.exports, "isElementRemoved", () => $ae63b016ce1bd907$export$5b89d4b643713034);
$parcel$export(module.exports, "removeElement", () => $ae63b016ce1bd907$export$f883456a56996078);
$parcel$export(module.exports, "removeElementWithFadeOut", () => $ae63b016ce1bd907$export$6d0fd725cb4aee8a);
$parcel$export(module.exports, "saveOldStyle", () => $ae63b016ce1bd907$export$bca7290a9faf0ec9);
$parcel$export(module.exports, "getOldStyle", () => $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
var $ae63b016ce1bd907$export$ae7433df314f6ec3 = (0, $eaKsF.makeInner)();
function $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
    var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $bahqM.retrieve2)(extraOpts.duration, 200);
            easing = (0, $bahqM.retrieve2)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        } // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
        if (typeof duration === 'function') duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $ae63b016ce1bd907$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if (typeof dataIndex === 'function') {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $bahqM.isObject)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'remove';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('remove');
    var animationConfig = $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation(); // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props); // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $ae63b016ce1bd907$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
    $ae63b016ce1bd907$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $ae63b016ce1bd907$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'remove') return true;
    }
    return false;
}
function $ae63b016ce1bd907$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($ae63b016ce1bd907$export$5b89d4b643713034(el)) return;
    $ae63b016ce1bd907$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
}
function $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $ae63b016ce1bd907$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $ae63b016ce1bd907$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    } // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $ae63b016ce1bd907$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $ae63b016ce1bd907$export$bca7290a9faf0ec9(el) {
    $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac(el) {
    return $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle;
}

});


parcelRegister("lUzII", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff3a893c22158f47$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $7yklO = parcelRequire("7yklO");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $fIXXx = parcelRequire("fIXXx");

var $5MLZz = parcelRequire("5MLZz");

var $bahqM = parcelRequire("bahqM");

var $gvLUt = parcelRequire("gvLUt");

var $gcbBH = parcelRequire("gcbBH");

var $eYgMC = parcelRequire("eYgMC");
var $ff3a893c22158f47$var$Symbol = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll(); // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $7yklO.createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        }); // Rewrite drift method
        symbolPath.drift = $ff3a893c22158f47$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $fIXXx.enterEmphasis)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $fIXXx.leaveEmphasis)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $eYgMC.updateProps(symbolPath, target, seriesModel, idx);
            (0, $eYgMC.saveOldStyle)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $eYgMC.initProps(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop remove animation manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('remove');
        this._seriesModel = seriesModel;
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $gvLUt.getLabelStatesModels)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $7yklO.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $gcbBH.default)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $bahqM.extend)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $bahqM.extend)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
             // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $gvLUt.setLabelStyle)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        }); // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $5MLZz.getDefaultLabel)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        if (hoverScale) {
            var scaleRatio = Math.max(1.1, 3 / this._sizeY);
            emphasisState.scaleX = this._sizeX * scaleRatio;
            emphasisState.scaleY = this._sizeY * scaleRatio;
        }
        this.setSymbolScale(1);
        (0, $fIXXx.enableHoverEmphasis)(this, focus, blurScope);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, opt) {
        var symbolPath = this.childAt(0);
        var seriesModel = this._seriesModel;
        var dataIndex = (0, $7QjoM.getECData)(this).dataIndex;
        var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true; // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $eYgMC.removeElement(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $eYgMC.removeElement(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $7yklO.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
    };
    return Symbol;
}($4KVOr.default);
function $ff3a893c22158f47$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $ff3a893c22158f47$export$2e2bcd8739ae039 = $ff3a893c22158f47$var$Symbol;

});
parcelRegister("7yklO", function(module, exports) {

$parcel$export(module.exports, "symbolBuildProxies", () => $57fb7e9c020cd915$export$33fc3b478d332725);
$parcel$export(module.exports, "createSymbol", () => $57fb7e9c020cd915$export$af050e04da3a02e8);
$parcel$export(module.exports, "normalizeSymbolSize", () => $57fb7e9c020cd915$export$a84524f03e8e8dfb);
$parcel$export(module.exports, "normalizeSymbolOffset", () => $57fb7e9c020cd915$export$e3e292895c033f6d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory

var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $jjfok = parcelRequire("jjfok");
var $cZb1F = parcelRequire("cZb1F");
var $fHITF = parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");
var $7Tw7u = parcelRequire("7Tw7u");

var $1E3E8 = parcelRequire("1E3E8");

var $b7ZX8 = parcelRequire("b7ZX8");

var $jmSNG = parcelRequire("jmSNG");
/**
 * Triangle shape
 * @inner
 */ var $57fb7e9c020cd915$var$Triangle = $ghQ8v.default.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $57fb7e9c020cd915$var$Diamond = $ghQ8v.default.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $57fb7e9c020cd915$var$Pin = $ghQ8v.default.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3; // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2; // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $57fb7e9c020cd915$var$Arrow = $ghQ8v.default.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path contructors
 */ // TODO Use function to build symbol path.
var $57fb7e9c020cd915$var$symbolCtors = {
    line: $cZb1F.default,
    rect: $7Tw7u.default,
    roundRect: $7Tw7u.default,
    square: $7Tw7u.default,
    circle: $jjfok.default,
    diamond: $57fb7e9c020cd915$var$Diamond,
    pin: $57fb7e9c020cd915$var$Pin,
    arrow: $57fb7e9c020cd915$var$Arrow,
    triangle: $57fb7e9c020cd915$var$Triangle
};
var $57fb7e9c020cd915$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $57fb7e9c020cd915$export$33fc3b478d332725 = {};
(0, $bahqM.each)($57fb7e9c020cd915$var$symbolCtors, function(Ctor, name) {
    $57fb7e9c020cd915$export$33fc3b478d332725[name] = new Ctor();
});
var $57fb7e9c020cd915$var$SymbolClz = $ghQ8v.default.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $b7ZX8.calculateTextPosition)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
            }
            $57fb7e9c020cd915$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
function $57fb7e9c020cd915$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $57fb7e9c020cd915$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $fHITF.makeImage(symbolType.slice(8), new (0, $1E3E8.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $fHITF.makePath(symbolType.slice(7), {}, new (0, $1E3E8.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $57fb7e9c020cd915$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor
    symbolPath.setColor = $57fb7e9c020cd915$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $57fb7e9c020cd915$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $bahqM.isArray)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $57fb7e9c020cd915$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $bahqM.isArray)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $jmSNG.parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $jmSNG.parsePercent)((0, $bahqM.retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}

});

parcelRegister("fIXXx", function(module, exports) {

$parcel$export(module.exports, "HOVER_STATE_BLUR", () => $b72979b7cd946cce$export$1307d6a87d56baa);
$parcel$export(module.exports, "HOVER_STATE_EMPHASIS", () => $b72979b7cd946cce$export$f0f2bee145debb31);
$parcel$export(module.exports, "SPECIAL_STATES", () => $b72979b7cd946cce$export$151308dceb52d5b);
$parcel$export(module.exports, "DISPLAY_STATES", () => $b72979b7cd946cce$export$57ee5306b85ad7d5);
$parcel$export(module.exports, "Z2_EMPHASIS_LIFT", () => $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
$parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", () => $b72979b7cd946cce$export$df035d873a9de64f);
$parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", () => $b72979b7cd946cce$export$f8a2f7807cc185ea);
$parcel$export(module.exports, "SELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$89616263e7d38fe9);
$parcel$export(module.exports, "UNSELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$7636ad95c0f68a79);
$parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", () => $b72979b7cd946cce$export$1e90ed8a25542516);
$parcel$export(module.exports, "setStatesFlag", () => $b72979b7cd946cce$export$868ba38adffa9e39);
$parcel$export(module.exports, "setDefaultStateProxy", () => $b72979b7cd946cce$export$20f39bbe322fb9ab);
$parcel$export(module.exports, "enterEmphasis", () => $b72979b7cd946cce$export$b2d02638cc34c042);
$parcel$export(module.exports, "leaveEmphasis", () => $b72979b7cd946cce$export$11be6f716239ac55);
$parcel$export(module.exports, "enterBlur", () => $b72979b7cd946cce$export$207f9cb3e1099375);
$parcel$export(module.exports, "leaveBlur", () => $b72979b7cd946cce$export$fd4a9ec75456d3c1);
$parcel$export(module.exports, "enterSelect", () => $b72979b7cd946cce$export$252d028dda8ef765);
$parcel$export(module.exports, "leaveSelect", () => $b72979b7cd946cce$export$ea9a904bd6e32bd3);
$parcel$export(module.exports, "allLeaveBlur", () => $b72979b7cd946cce$export$b2a593c7b5243584);
$parcel$export(module.exports, "blurComponent", () => $b72979b7cd946cce$export$569da03256c8a55f);
$parcel$export(module.exports, "blurSeriesFromHighlightPayload", () => $b72979b7cd946cce$export$64f1fd4daefef21b);
$parcel$export(module.exports, "findComponentHighDownDispatchers", () => $b72979b7cd946cce$export$f31a644ccca0ef23);
$parcel$export(module.exports, "handleGlobalMouseOverForHighDown", () => $b72979b7cd946cce$export$416765b6198234ff);
$parcel$export(module.exports, "handleGlboalMouseOutForHighDown", () => $b72979b7cd946cce$export$2cbc9e6f4b583c84);
$parcel$export(module.exports, "toggleSelectionFromPayload", () => $b72979b7cd946cce$export$1c7d489f62372d73);
$parcel$export(module.exports, "isSelectChangePayload", () => $b72979b7cd946cce$export$72aea10e60e45351);
$parcel$export(module.exports, "updateSeriesElementSelection", () => $b72979b7cd946cce$export$e4ea08ef52e0a73);
$parcel$export(module.exports, "getAllSelectedIndices", () => $b72979b7cd946cce$export$c529643b619af6b3);
$parcel$export(module.exports, "enableHoverEmphasis", () => $b72979b7cd946cce$export$5f393df0b5aee2e7);
$parcel$export(module.exports, "setAsHighDownDispatcher", () => $b72979b7cd946cce$export$9ba15aea1e048d48);
$parcel$export(module.exports, "enableHoverFocus", () => $b72979b7cd946cce$export$24972466b2b62ac2);
$parcel$export(module.exports, "setStatesStylesFromModel", () => $b72979b7cd946cce$export$48b68047d330bbc9);
$parcel$export(module.exports, "isHighDownDispatcher", () => $b72979b7cd946cce$export$77d1445f699c58b5);
$parcel$export(module.exports, "enableComponentHighDownFeatures", () => $b72979b7cd946cce$export$4da05a9639f01954);
$parcel$export(module.exports, "getHighlightDigit", () => $b72979b7cd946cce$export$824af40eb714530d);
$parcel$export(module.exports, "isHighDownPayload", () => $b72979b7cd946cce$export$aebe71265c1b77bf);
$parcel$export(module.exports, "savePathStates", () => $b72979b7cd946cce$export$9fe78019e6f395b6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $h4RuA = parcelRequire("h4RuA");

var $bahqM = parcelRequire("bahqM");

var $7QjoM = parcelRequire("7QjoM");

var $d6udH = parcelRequire("d6udH");

var $eaKsF = parcelRequire("eaKsF");

var $ghQ8v = parcelRequire("ghQ8v");

var $b72979b7cd946cce$var$_highlightNextDigit = 1;
var $b72979b7cd946cce$var$_highlightKeyMap = {};
var $b72979b7cd946cce$var$getSavedStates = (0, $eaKsF.makeInner)();
var $b72979b7cd946cce$export$5542daa30722333e = 0;
var $b72979b7cd946cce$export$1307d6a87d56baa = 1;
var $b72979b7cd946cce$export$f0f2bee145debb31 = 2;
var $b72979b7cd946cce$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$export$1cb9fc6ed5b9836c = 10;
var $b72979b7cd946cce$export$3a2f97d39514bbc = 9;
var $b72979b7cd946cce$export$df035d873a9de64f = 'highlight';
var $b72979b7cd946cce$export$f8a2f7807cc185ea = 'downplay';
var $b72979b7cd946cce$export$89616263e7d38fe9 = 'select';
var $b72979b7cd946cce$export$7636ad95c0f68a79 = 'unselect';
var $b72979b7cd946cce$export$1e90ed8a25542516 = 'toggleSelect';
function $b72979b7cd946cce$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.
var $b72979b7cd946cce$var$liftedColorCache = new (0, $h4RuA.default)(100);
function $b72979b7cd946cce$var$liftColor(color) {
    if (typeof color !== 'string') return color;
    var liftedColor = $b72979b7cd946cce$var$liftedColorCache.get(color);
    if (!liftedColor) {
        liftedColor = $d6udH.lift(color, -0.1);
        $b72979b7cd946cce$var$liftedColorCache.put(color, liftedColor);
    }
    return liftedColor;
}
function $b72979b7cd946cce$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $b72979b7cd946cce$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $b72979b7cd946cce$var$doChangeHoverState(el, 'emphasis', $b72979b7cd946cce$export$f0f2bee145debb31);
}
function $b72979b7cd946cce$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $b72979b7cd946cce$export$f0f2bee145debb31) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
}
function $b72979b7cd946cce$var$singleEnterBlur(el) {
    $b72979b7cd946cce$var$doChangeHoverState(el, 'blur', $b72979b7cd946cce$export$1307d6a87d56baa);
}
function $b72979b7cd946cce$var$singleLeaveBlur(el) {
    if (el.hoverState === $b72979b7cd946cce$export$1307d6a87d56baa) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
}
function $b72979b7cd946cce$var$singleEnterSelect(el) {
    el.selected = true;
}
function $b72979b7cd946cce$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $b72979b7cd946cce$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $b72979b7cd946cce$var$traverseUpdateState(el, updater, commonParam) {
    $b72979b7cd946cce$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $b72979b7cd946cce$var$updateElementState(child, updater, commonParam);
    });
}
function $b72979b7cd946cce$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $b72979b7cd946cce$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $b72979b7cd946cce$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $b72979b7cd946cce$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $b72979b7cd946cce$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $b72979b7cd946cce$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition // Dont consider the animation to emphasis state.
         && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
    }
    return fromState;
}
function $b72979b7cd946cce$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $bahqM.indexOf)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $ghQ8v.default)) {
        var store = $b72979b7cd946cce$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($b72979b7cd946cce$var$hasFillOrStroke(fromFill) || $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {}; // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $bahqM.extend)({}, state);
                emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.fill) && $b72979b7cd946cce$var$hasFillOrStroke(fromFill)) {
                cloned = true; // Not modify the original value.
                state = (0, $bahqM.extend)({}, state);
                emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = $b72979b7cd946cce$var$liftColor(fromFill);
            } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.stroke) && $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $bahqM.extend)({}, state);
                    emphasisStyle = (0, $bahqM.extend)({}, emphasisStyle);
                }
                emphasisStyle.stroke = $b72979b7cd946cce$var$liftColor(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $bahqM.extend)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $b72979b7cd946cce$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $bahqM.extend)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b72979b7cd946cce$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $b72979b7cd946cce$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $bahqM.indexOf)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $b72979b7cd946cce$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $bahqM.extend)({}, state);
        blurStyle = (0, $bahqM.extend)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $b72979b7cd946cce$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $b72979b7cd946cce$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $b72979b7cd946cce$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $b72979b7cd946cce$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $b72979b7cd946cce$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
}
function $b72979b7cd946cce$export$d899507e2598e4ae(el, e) {
    !$b72979b7cd946cce$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
}
function $b72979b7cd946cce$export$784cba1f7fe58cca(el, e) {
    !$b72979b7cd946cce$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
}
function $b72979b7cd946cce$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
}
function $b72979b7cd946cce$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
}
function $b72979b7cd946cce$export$207f9cb3e1099375(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterBlur);
}
function $b72979b7cd946cce$export$fd4a9ec75456d3c1(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveBlur);
}
function $b72979b7cd946cce$export$252d028dda8ef765(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterSelect);
}
function $b72979b7cd946cce$export$ea9a904bd6e32bd3(el) {
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveSelect);
}
function $b72979b7cd946cce$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $b72979b7cd946cce$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    model.eachComponent(function(componentType, componentModel) {
        var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel); // Leave blur anyway
        view.group.traverse(function(child) {
            $b72979b7cd946cce$var$singleLeaveBlur(child);
        });
    });
}
function $b72979b7cd946cce$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $b72979b7cd946cce$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!(blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
         || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
         || focus === 'series' && sameSeries // TODO blurScope: coordinate system
        )) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                $b72979b7cd946cce$var$singleEnterBlur(child);
            });
            if ((0, $bahqM.isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $bahqM.isObject)(focus)) {
                var dataTypes = (0, $bahqM.keys)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
    });
}
function $b72979b7cd946cce$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $b72979b7cd946cce$var$singleEnterBlur(child);
    });
}
function $b72979b7cd946cce$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload); // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $bahqM.isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0; // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $7QjoM.getECData)(el);
        $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $b72979b7cd946cce$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $7QjoM.getECData)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $b72979b7cd946cce$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $7QjoM.getECData)(dispatcher);
    var _a = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $bahqM.each)(dispatchers, function(dispatcher) {
            return $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $b72979b7cd946cce$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
         // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $b72979b7cd946cce$export$2cbc9e6f4b583c84(dispatcher, e, api) {
    $b72979b7cd946cce$export$b2a593c7b5243584(api);
    var ecData = (0, $7QjoM.getECData)(dispatcher);
    var dispatchers = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $bahqM.each)(dispatchers, function(dispatcher) {
        return $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
}
function $b72979b7cd946cce$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$b72979b7cd946cce$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload);
    if (!(0, $bahqM.isArray)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $b72979b7cd946cce$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b72979b7cd946cce$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $b72979b7cd946cce$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $bahqM.each)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $b72979b7cd946cce$export$252d028dda8ef765(el) : $b72979b7cd946cce$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $b72979b7cd946cce$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $bahqM.each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $b72979b7cd946cce$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $b72979b7cd946cce$export$9ba15aea1e048d48(el, true);
    $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$export$20f39bbe322fb9ab);
    $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope);
}
function $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $7QjoM.getECData)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope; // }
    } else if (ecData.focus) ecData.focus = null;
}
var $b72979b7cd946cce$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $b72979b7cd946cce$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $b72979b7cd946cce$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $b72979b7cd946cce$var$OTHER_STATES.length; i++){
        var stateName = $b72979b7cd946cce$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName); // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$b72979b7cd946cce$var$defaultStyleGetterMap[styleType]]();
    }
}
function $b72979b7cd946cce$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
     // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $b72979b7cd946cce$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $b72979b7cd946cce$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $7QjoM.getECData)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $b72979b7cd946cce$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $b72979b7cd946cce$var$_highlightNextDigit <= 32) highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey] = $b72979b7cd946cce$var$_highlightNextDigit++;
    return highlightDigit;
}
function $b72979b7cd946cce$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $b72979b7cd946cce$export$89616263e7d38fe9 || payloadType === $b72979b7cd946cce$export$7636ad95c0f68a79 || payloadType === $b72979b7cd946cce$export$1e90ed8a25542516;
}
function $b72979b7cd946cce$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $b72979b7cd946cce$export$df035d873a9de64f || payloadType === $b72979b7cd946cce$export$f8a2f7807cc185ea;
}
function $b72979b7cd946cce$export$9fe78019e6f395b6(el) {
    var store = $b72979b7cd946cce$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}

});

parcelRegister("5MLZz", function(module, exports) {

$parcel$export(module.exports, "getDefaultLabel", () => $4366a9b1a430c1e7$export$5ff20667590927ed);
$parcel$export(module.exports, "getDefaultInterpolatedLabel", () => $4366a9b1a430c1e7$export$5f84815e91ca6775);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9OHWG = parcelRequire("9OHWG");

var $bahqM = parcelRequire("bahqM");
function $4366a9b1a430c1e7$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $9OHWG.retrieveRawValue)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $9OHWG.retrieveRawValue)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $4366a9b1a430c1e7$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $bahqM.isArray)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}

});
parcelRegister("9OHWG", function(module, exports) {

$parcel$export(module.exports, "DefaultDataProvider", () => $725adf3ea01375e6$export$b900d7c4c3952a40);
$parcel$export(module.exports, "getRawSourceItemGetter", () => $725adf3ea01375e6$export$92c8ea8642b3957d);
$parcel$export(module.exports, "getRawSourceDataCounter", () => $725adf3ea01375e6$export$803742e832f4b52c);
$parcel$export(module.exports, "getRawSourceValueGetter", () => $725adf3ea01375e6$export$1752de8084789a14);
$parcel$export(module.exports, "retrieveRawValue", () => $725adf3ea01375e6$export$cde9373da9aad801);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $20liu = parcelRequire("20liu");

var $2Rbm1 = parcelRequire("2Rbm1");
var $725adf3ea01375e6$var$_a, $725adf3ea01375e6$var$_b, $725adf3ea01375e6$var$_c; // TODO
var $725adf3ea01375e6$var$providerMethods;
var $725adf3ea01375e6$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $725adf3ea01375e6$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $20liu.isSourceInstance)(sourceParam) ? (0, $20liu.createSourceFromSeriesDataOption)(sourceParam) : sourceParam; // declare source is Source;
        this._source = source;
        var data = this._data = source.data; // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $725adf3ea01375e6$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $725adf3ea01375e6$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $725adf3ea01375e6$var$providerMethods[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $bahqM.extend)(provider, methods);
            if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $bahqM.bind)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $bahqM.bind)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $725adf3ea01375e6$var$providerMethods = (_a = {}, _a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $bahqM.each)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = {
            appendData: appendDataSimply
        }, _a[0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $725adf3ea01375e6$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $725adf3ea01375e6$var$rawSourceItemGetterMap = ($725adf3ea01375e6$var$_a = {}, $725adf3ea01375e6$var$_a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $725adf3ea01375e6$var$_a[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $725adf3ea01375e6$var$_a[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a);
function $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $725adf3ea01375e6$var$rawSourceItemGetterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $725adf3ea01375e6$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $725adf3ea01375e6$var$rawSourceDataCounterMap = ($725adf3ea01375e6$var$_b = {}, $725adf3ea01375e6$var$_b[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $725adf3ea01375e6$var$_b[(0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $725adf3ea01375e6$var$_b[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b);
function $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $725adf3ea01375e6$var$rawSourceDataCounterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $725adf3ea01375e6$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $725adf3ea01375e6$var$rawSourceValueGetterMap = ($725adf3ea01375e6$var$_c = {}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $eaKsF.getDataItemValue)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $725adf3ea01375e6$var$_c[0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c);
function $725adf3ea01375e6$export$1752de8084789a14(sourceFormat) {
    var method = $725adf3ea01375e6$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
function $725adf3ea01375e6$export$cde9373da9aad801(data, dataIndex, // Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
     // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $725adf3ea01375e6$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) result = (0, $eaKsF.getDataItemValue)(dataItem);
        return result;
    }
}
function $725adf3ea01375e6$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL) && !(0, $bahqM.isObject)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}

});
parcelRegister("20liu", function(module, exports) {

$parcel$export(module.exports, "isSourceInstance", () => $175c1a118c738be0$export$22b808bc02a60488);
$parcel$export(module.exports, "createSource", () => $175c1a118c738be0$export$1921362e86c73c88);
$parcel$export(module.exports, "detectSourceFormat", () => $175c1a118c738be0$export$52a469afa4653e57);
$parcel$export(module.exports, "createSourceFromSeriesDataOption", () => $175c1a118c738be0$export$75aef3f97c0a5edf);
$parcel$export(module.exports, "cloneSourceShallow", () => $175c1a118c738be0$export$e0365e7e3555ddd4);
$parcel$export(module.exports, "shouldRetrieveDataByName", () => $175c1a118c738be0$export$8911336b527f8517);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $cNGs8 = parcelRequire("cNGs8");
var $175c1a118c738be0$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $2Rbm1.SOURCE_FORMAT_UNKNOWN); // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $cNGs8.guessOrdinal)(this, i) === (0, $cNGs8.BE_ORDINAL).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $175c1a118c738be0$export$22b808bc02a60488(val) {
    return val instanceof $175c1a118c738be0$var$SourceImpl;
}
function $175c1a118c738be0$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
    sourceFormat = sourceFormat || $175c1a118c738be0$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $175c1a118c738be0$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $175c1a118c738be0$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $bahqM.clone)(thisMetaRawOption)
    });
    return source;
}
function $175c1a118c738be0$export$75aef3f97c0a5edf(data) {
    return new $175c1a118c738be0$var$SourceImpl({
        data: data,
        sourceFormat: (0, $bahqM.isTypedArray)(data) ? (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) : (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)
    });
}
function $175c1a118c738be0$export$e0365e7e3555ddd4(source) {
    return new $175c1a118c738be0$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $bahqM.clone)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $175c1a118c738be0$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_UNKNOWN);
    if ((0, $bahqM.isTypedArray)(data)) sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY);
    else if ((0, $bahqM.isArray)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $bahqM.isArray)(item)) {
                sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS);
                break;
            } else if ((0, $bahqM.isObject)(item)) {
                sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS);
                break;
            }
        }
    } else if ((0, $bahqM.isObject)(data)) {
        for(var key in data)if ((0, $bahqM.hasOwn)(data, key) && (0, $bahqM.isArrayLike)(data[key])) {
            sourceFormat = (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $175c1a118c738be0$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex; // PEDING: could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $175c1a118c738be0$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $bahqM.isString)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            } // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $bahqM.isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $175c1a118c738be0$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        if (!dimensionsDefine) dimensionsDefine = $175c1a118c738be0$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $bahqM.each)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var value0 = (0, $eaKsF.getDataItemValue)(data[0]);
        dimensionsDetectedCount = (0, $bahqM.isArray)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $175c1a118c738be0$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) {
        var dimensions_1 = [];
        (0, $bahqM.each)(obj, function(value, key) {
            dimensions_1.push(key);
        });
        return dimensions_1;
    }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $bahqM.createHashMap)();
    return (0, $bahqM.map)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $bahqM.isObject)(rawItem) ? rawItem : {
            name: rawItem
        }; // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        }; // User can set null in dimensions.
        // We dont auto specify name, othewise a given name may
        // cause it be refered unexpectedly.
        if (item.name == null) return item;
         // Also consider number form like 2012.
        item.name += ''; // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $175c1a118c738be0$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $175c1a118c738be0$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS);
}

});
parcelRegister("2Rbm1", function(module, exports) {

$parcel$export(module.exports, "VISUAL_DIMENSIONS", () => $214956bc17bbe3d3$export$cd51b5ca77f6f0e4);
$parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", () => $214956bc17bbe3d3$export$2823037fb9d8f0c6);
$parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", () => $214956bc17bbe3d3$export$fcd62ebf51387903);
$parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", () => $214956bc17bbe3d3$export$703ae8a2d83f441);
$parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", () => $214956bc17bbe3d3$export$6a32b42c754a3cb8);
$parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", () => $214956bc17bbe3d3$export$a918cb016a382d45);
$parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", () => $214956bc17bbe3d3$export$c78f1330778d30d);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", () => $214956bc17bbe3d3$export$7b3f3c6551b4949b);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", () => $214956bc17bbe3d3$export$d55da1467cdf7804);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $214956bc17bbe3d3$export$cd51b5ca77f6f0e4 = (0, $bahqM.createHashMap)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'seriesName'
]);
var $214956bc17bbe3d3$export$2823037fb9d8f0c6 = 'original';
var $214956bc17bbe3d3$export$fcd62ebf51387903 = 'arrayRows';
var $214956bc17bbe3d3$export$703ae8a2d83f441 = 'objectRows';
var $214956bc17bbe3d3$export$6a32b42c754a3cb8 = 'keyedColumns';
var $214956bc17bbe3d3$export$a918cb016a382d45 = 'typedArray';
var $214956bc17bbe3d3$export$c78f1330778d30d = 'unknown';
var $214956bc17bbe3d3$export$7b3f3c6551b4949b = 'column';
var $214956bc17bbe3d3$export$d55da1467cdf7804 = 'row';

});

parcelRegister("cNGs8", function(module, exports) {

$parcel$export(module.exports, "BE_ORDINAL", () => $951afdda7935b9af$export$328749e9c5b40760);
$parcel$export(module.exports, "resetSourceDefaulter", () => $951afdda7935b9af$export$b30cdea50aa00e6);
$parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", () => $951afdda7935b9af$export$37682b8fdd2e83d);
$parcel$export(module.exports, "querySeriesUpstreamDatasetModel", () => $951afdda7935b9af$export$8da66f73a1eda454);
$parcel$export(module.exports, "makeSeriesEncodeForNameBased", () => $951afdda7935b9af$export$60b8a57d1f2fed26);
$parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", () => $951afdda7935b9af$export$397ba553479711e7);
$parcel$export(module.exports, "guessOrdinal", () => $951afdda7935b9af$export$c51adf1a2be01b9c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");
var $951afdda7935b9af$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $951afdda7935b9af$var$innerGlobalModel = (0, $eaKsF.makeInner)();
function $951afdda7935b9af$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap = (0, $bahqM.createHashMap)();
}
function $951afdda7935b9af$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $bahqM.each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $bahqM.isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    }); // TODO
    // Auto detect first time axis and do arrangement.
    (0, $bahqM.each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when mutiple series share one dimension
        // category axis, series name should better use
        // the other dimsion name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $951afdda7935b9af$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) (0, $bahqM.each)(dimensionsDefine, function(dim, idx) {
        if (((0, $bahqM.isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = []; // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $951afdda7935b9af$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $951afdda7935b9af$export$328749e9c5b40760.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $951afdda7935b9af$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $951afdda7935b9af$export$328749e9c5b40760.Not) return idxRes0;
             // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $951afdda7935b9af$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ]; // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
        // So we dont set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $951afdda7935b9af$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $eaKsF.queryReferringComponents)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $eaKsF.SINGLE_REFERRING)).models[0];
}
function $951afdda7935b9af$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $eaKsF.queryReferringComponents)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $eaKsF.SINGLE_REFERRING)).models;
}
function $951afdda7935b9af$export$c51adf1a2be01b9c(source, dimIndex) {
    return $951afdda7935b9af$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $951afdda7935b9af$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result; // Experience value.
    var maxLoop = 5;
    if ((0, $bahqM.isTypedArray)(data)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
     // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $bahqM.isObject)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $bahqM.isString)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $951afdda7935b9af$export$328749e9c5b40760.Must : $951afdda7935b9af$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $2Rbm1.SERIES_LAYOUT_BY_ROW)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        var dataObjectRows = data;
        if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_KEYED_COLUMNS)) {
        var dataKeyedColumns = data;
        if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $bahqM.isTypedArray)(sample)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $eaKsF.getDataItemValue)(item);
            if (!(0, $bahqM.isArray)(val)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $bahqM.isString)(val); // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== '') return beStr ? $951afdda7935b9af$export$328749e9c5b40760.Might : $951afdda7935b9af$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $951afdda7935b9af$export$328749e9c5b40760.Must;
    }
    return $951afdda7935b9af$export$328749e9c5b40760.Not;
}

});




parcelRegister("gvLUt", function(module, exports) {

$parcel$export(module.exports, "setLabelStyle", () => $c054b479467e8395$export$9a13992917966657);
$parcel$export(module.exports, "createTextStyle", () => $c054b479467e8395$export$f8998c3d0a13de59);
$parcel$export(module.exports, "createTextConfig", () => $c054b479467e8395$export$e149afab8df6e053);
$parcel$export(module.exports, "labelInner", () => $c054b479467e8395$export$f62786d3261ab0f4);
$parcel$export(module.exports, "getLabelStatesModels", () => $c054b479467e8395$export$9739a32674be5893);
$parcel$export(module.exports, "getFont", () => $c054b479467e8395$export$155316a870a9d61e);
$parcel$export(module.exports, "setLabelValueAnimation", () => $c054b479467e8395$export$7bdbceaf9ab378f2);
$parcel$export(module.exports, "animateLabelValue", () => $c054b479467e8395$export$dd6101605f5c186);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4gEFv = parcelRequire("4gEFv");

var $bahqM = parcelRequire("bahqM");

var $fIXXx = parcelRequire("fIXXx");


var $eaKsF = parcelRequire("eaKsF");

var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");
var $c054b479467e8395$var$EMPTY_OBJ = {};
function $c054b479467e8395$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $c054b479467e8395$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $bahqM.isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $bahqM.retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $c054b479467e8395$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
    opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $4gEFv.default);
    var needsCreateText = false;
    for(var i = 0; i < (0, $fIXXx.DISPLAY_STATES).length; i++){
        var stateModel = labelStatesModels[(0, $fIXXx.DISPLAY_STATES)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $4gEFv.default)();
                targetEl.setTextContent(textContent);
            } // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $c054b479467e8395$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($c054b479467e8395$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
            var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $bahqM.retrieve2)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $c054b479467e8395$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $c054b479467e8395$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        } // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto slient is those cases.
        textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal; // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $c054b479467e8395$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $c054b479467e8395$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $c054b479467e8395$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $c054b479467e8395$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $bahqM.extend)(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $c054b479467e8395$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $bahqM.retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
     // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $c054b479467e8395$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]); // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $c054b479467e8395$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $c054b479467e8395$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $c054b479467e8395$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $bahqM.keys)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $c054b479467e8395$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign'
];
var $c054b479467e8395$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $c054b479467e8395$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $bahqM.retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $bahqM.retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
     // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    } // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $bahqM.retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_SELF.length; i++){
        var key = $c054b479467e8395$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_BOX.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $c054b479467e8395$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $bahqM.trim)([
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $c054b479467e8395$export$f62786d3261ab0f4 = (0, $eaKsF.makeInner)();
function $c054b479467e8395$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $c054b479467e8395$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $c054b479467e8395$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $c054b479467e8395$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation) return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $bahqM.retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $eaKsF.interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $c054b479467e8395$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $c054b479467e8395$export$b533918394a58529(textEl, labelText);
    }
    (labelInnerStore.prevValue == null ? (0, $eYgMC.initProps) : (0, $eYgMC.updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
}

});



parcelRegister("8Jx6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc34119bfa351f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $7yklO = parcelRequire("7yklO");

var $4KVOr = parcelRequire("4KVOr");

var $fIXXx = parcelRequire("fIXXx");

var $lUzII = parcelRequire("lUzII");
function $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === 'stroke' ? color : null,
                fill: effectCfg.brushType === 'fill' ? color : null
            }
        });
    });
}
var $65bc34119bfa351f$var$EffectSymbol = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $lUzII.default)(data, idx);
        var rippleGroup = new (0, $4KVOr.default)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $7yklO.createSymbol)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate('', true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            'symbolType',
            'period',
            'rippleScale',
            'rippleNumber'
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $65bc34119bfa351f$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $fIXXx.enterEmphasis)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $fIXXx.leaveEmphasis)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, 'symbol');
        var symbolSize = (0, $7yklO.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
        var symbolStyle = data.getItemVisual(idx, 'style');
        var color = symbolStyle && symbolStyle.fill;
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle('fill', color);
        });
        var symbolOffset = (0, $7yklO.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get('showEffectOn');
        effectCfg.rippleScale = itemModel.get([
            'rippleEffect',
            'scale'
        ]);
        effectCfg.brushType = itemModel.get([
            'rippleEffect',
            'brushType'
        ]);
        effectCfg.period = itemModel.get([
            'rippleEffect',
            'period'
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow('z') || 0;
        effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            'rippleEffect',
            'color'
        ]);
        effectCfg.rippleNumber = itemModel.get([
            'rippleEffect',
            'number'
        ]);
        this.off('mouseover').off('mouseout').off('emphasis').off('normal');
        if (effectCfg.showEffectOn === 'render') {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === 'emphasis') {
                    if (effectCfg.showEffectOn !== 'render') _this.startEffectAnimation(effectCfg);
                } else if (toState === 'normal') {
                    if (effectCfg.showEffectOn !== 'render') _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $fIXXx.enableHoverEmphasis)(this);
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        this.off('mouseover').off('mouseout');
        cb && cb();
    };
    return EffectSymbol;
}((0, $4KVOr.default));
var $65bc34119bfa351f$export$2e2bcd8739ae039 = $65bc34119bfa351f$var$EffectSymbol;

});

parcelRegister("5xgWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $407d2c4ef7fb34bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9irlK = parcelRequire("9irlK");

var $5R8Hi = parcelRequire("5R8Hi");

var $8fK8Y = parcelRequire("8fK8Y");
function $407d2c4ef7fb34bc$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $9irlK.default)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $bahqM.map)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $5R8Hi.isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $5R8Hi.isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $8fK8Y.createFloat32Array)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}

});
parcelRegister("9irlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4b0292c57cf773$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
function $6c4b0292c57cf773$export$2e2bcd8739ae039() {
    var inner = (0, $eaKsF.makeInner)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}

});

parcelRegister("5R8Hi", function(module, exports) {

$parcel$export(module.exports, "enableDataStack", () => $4438a61210f14409$export$f2165f9e8499b278);
$parcel$export(module.exports, "isDimensionStacked", () => $4438a61210f14409$export$1dedc39359ae35c);
$parcel$export(module.exports, "getStackedDimension", () => $4438a61210f14409$export$909db2be4938fbdf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Om11 = parcelRequire("2Om11");
function $4438a61210f14409$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    } // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $bahqM.each)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $bahqM.isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
             // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
     // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $bahqM.each)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $2Om11.isSeriesDataSchema)(dimensionsInput.schema);
}
function $4438a61210f14409$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $4438a61210f14409$export$909db2be4938fbdf(data, targetDim) {
    return $4438a61210f14409$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

});
parcelRegister("2Om11", function(module, exports) {

$parcel$export(module.exports, "SeriesDataSchema", () => $20c1541ff90227ce$export$a1ef064685775f3e);
$parcel$export(module.exports, "ensureSourceDimNameMap", () => $20c1541ff90227ce$export$be39ae17310c33f7);
$parcel$export(module.exports, "shouldOmitUnusedDimensions", () => $20c1541ff90227ce$export$238b87930d825d87);
$parcel$export(module.exports, "isSeriesDataSchema", () => $20c1541ff90227ce$export$fafbc856132a3a0e);
$parcel$export(module.exports, "createDimNameMap", () => $20c1541ff90227ce$export$a477f5bebfd07944);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $20liu = parcelRequire("20liu");
var $20c1541ff90227ce$var$inner = (0, $eaKsF.makeInner)();
var $20c1541ff90227ce$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $20c1541ff90227ce$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $20c1541ff90227ce$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $bahqM.retrieve2)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $20liu.shouldRetrieveDataByName)(this.source);
        var makeHashStrict = !$20c1541ff90227ce$export$238b87930d825d87(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            }); // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Becuase in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
             && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
             ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
             : property;
            dimHash += '$';
            dimHash += $20c1541ff90227ce$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        } // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++; // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $20c1541ff90227ce$export$fafbc856132a3a0e(schema) {
    return schema instanceof $20c1541ff90227ce$export$a1ef064685775f3e;
}
function $20c1541ff90227ce$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $bahqM.createHashMap)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $bahqM.isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $20c1541ff90227ce$export$be39ae17310c33f7(source) {
    var innerSource = $20c1541ff90227ce$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $20c1541ff90227ce$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $20c1541ff90227ce$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}

});


parcelRegister("8fK8Y", function(module, exports) {

$parcel$export(module.exports, "createFloat32Array", () => $602384a5ad582433$export$21d2298f3f56bbaf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
/* global Float32Array */ var $602384a5ad582433$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $602384a5ad582433$var$Float32ArrayCtor = !$602384a5ad582433$var$supportFloat32Array ? Array : Float32Array;
function $602384a5ad582433$export$21d2298f3f56bbaf(arg) {
    if ((0, $bahqM.isArray)(arg)) // Return self directly if don't support TypedArray.
    return $602384a5ad582433$var$supportFloat32Array ? new Float32Array(arg) : arg;
     // Else is number
    return new $602384a5ad582433$var$Float32ArrayCtor(arg);
}

});


parcelRegister("loerw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9270aeb44680e6f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");

var $eaKsF = parcelRequire("eaKsF");

var $fIXXx = parcelRequire("fIXXx");

var $92IK1 = parcelRequire("92IK1");

var $9irlK = parcelRequire("9irlK");
var $f9270aeb44680e6f$var$inner = $eaKsF.makeInner();
var $f9270aeb44680e6f$var$renderPlanner = (0, $9irlK.default)();
var $f9270aeb44680e6f$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $4KVOr.default)();
        this.uid = $jvo6O.getUID('viewChart');
        this.renderTask = (0, $92IK1.createTask)({
            plan: $f9270aeb44680e6f$var$renderTaskPlan,
            reset: $f9270aeb44680e6f$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $f9270aeb44680e6f$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit) {
    if (el) (state === 'emphasis' ? (0, $fIXXx.enterEmphasis) : (0, $fIXXx.leaveEmphasis))(el, highlightDigit);
}
function $f9270aeb44680e6f$var$toggleHighlight(data, payload, state) {
    var dataIndex = $eaKsF.queryDataIndex(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $fIXXx.getHighlightDigit)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $bahqM.each)($eaKsF.normalizeToArray(dataIndex), function(dataIdx) {
        $f9270aeb44680e6f$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit);
    });
}
$aLwh0.enableClassExtend($f9270aeb44680e6f$var$ChartView, [
    'dispose'
]);
$aLwh0.enableClassManagement($f9270aeb44680e6f$var$ChartView);
function $f9270aeb44680e6f$var$renderTaskPlan(context) {
    return $f9270aeb44680e6f$var$renderPlanner(context.model);
}
function $f9270aeb44680e6f$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload; // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $f9270aeb44680e6f$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
     : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $f9270aeb44680e6f$var$progressMethodMap[methodName];
}
var $f9270aeb44680e6f$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $f9270aeb44680e6f$export$2e2bcd8739ae039 = $f9270aeb44680e6f$var$ChartView;

});
parcelRegister("jvo6O", function(module, exports) {

$parcel$export(module.exports, "getUID", () => $e3339d183aa6ce79$export$6d2b3473b0986646);
$parcel$export(module.exports, "enableSubTypeDefaulter", () => $e3339d183aa6ce79$export$b9faf30b7d655a6f);
$parcel$export(module.exports, "enableTopologicalTravel", () => $e3339d183aa6ce79$export$ce592d345a3ec040);
$parcel$export(module.exports, "inheritDefaultOption", () => $e3339d183aa6ce79$export$68acc510e46fef2);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $aLwh0 = parcelRequire("aLwh0");

var $e3339d183aa6ce79$var$base = Math.round(Math.random() * 10);
function $e3339d183aa6ce79$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $e3339d183aa6ce79$var$base++
    ].join('_');
}
function $e3339d183aa6ce79$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $aLwh0.parseClassType)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $aLwh0.parseClassType)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $e3339d183aa6ce79$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $bahqM.each(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $bahqM.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $bahqM.each(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        } // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $bahqM.each(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $bahqM.each(availableDeps, function(dependentName) {
                if ($bahqM.indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($bahqM.indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $bahqM.each(originalDeps, function(dep) {
            $bahqM.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $e3339d183aa6ce79$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $bahqM.merge($bahqM.merge({}, superOption, true), subOption, true);
}

});
parcelRegister("aLwh0", function(module, exports) {

$parcel$export(module.exports, "parseClassType", () => $7d6753f3a830ddbc$export$fbe18865d303bf01);
$parcel$export(module.exports, "isExtendedClass", () => $7d6753f3a830ddbc$export$4f3b818f3dd2d182);
$parcel$export(module.exports, "enableClassExtend", () => $7d6753f3a830ddbc$export$cd4c3a4dca301c70);
$parcel$export(module.exports, "mountExtend", () => $7d6753f3a830ddbc$export$c9c2d87774f1275d);
$parcel$export(module.exports, "enableClassCheck", () => $7d6753f3a830ddbc$export$e1aac4552ae82081);
$parcel$export(module.exports, "enableClassManagement", () => $7d6753f3a830ddbc$export$241315e45585454d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");
var $7d6753f3a830ddbc$var$TYPE_DELIMITER = '.';
var $7d6753f3a830ddbc$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $7d6753f3a830ddbc$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($7d6753f3a830ddbc$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $7d6753f3a830ddbc$var$checkClassType(componentType) {
    $bahqM.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $7d6753f3a830ddbc$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS]);
}
function $7d6753f3a830ddbc$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this; // For backward compat, we both support ts class inheritance and this
        // "extend" approach.
        // The constructor should keep the same behavior as ts class inheritance:
        // If this constructor/$constructor is not declared, auto invoke the super
        // constructor.
        // If this constructor/$constructor is declared, it is responsible for
        // calling the super constructor.
        function ExtendedClass() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!proto.$constructor) {
                if (!$7d6753f3a830ddbc$var$isESClass(superClass)) // Will throw error if superClass is an es6 native class.
                superClass.apply(this, arguments);
                else {
                    var ins = $bahqM.createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, $3VFsf.__spreadArray)([
                        void 0
                    ], args)))());
                    return ins;
                }
            } else proto.$constructor.apply(this, arguments);
        }
        ExtendedClass[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS] = true;
        $bahqM.extend(ExtendedClass.prototype, proto);
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $7d6753f3a830ddbc$var$superCall;
        ExtendedClass.superApply = $7d6753f3a830ddbc$var$superApply;
        $bahqM.inherits(ExtendedClass, this);
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $7d6753f3a830ddbc$var$isESClass(fn) {
    return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $7d6753f3a830ddbc$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
} // A random offset.
var $7d6753f3a830ddbc$var$classBase = Math.round(Math.random() * 10);
function $7d6753f3a830ddbc$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $7d6753f3a830ddbc$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function $7d6753f3a830ddbc$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7d6753f3a830ddbc$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $7d6753f3a830ddbc$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance memeber".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we stil support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $7d6753f3a830ddbc$var$checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $7d6753f3a830ddbc$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$7d6753f3a830ddbc$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER]) $bahqM.each(obj, function(o, type) {
            type !== $7d6753f3a830ddbc$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $bahqM.each(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$7d6753f3a830ddbc$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$7d6753f3a830ddbc$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }

});


parcelRegister("92IK1", function(module, exports) {

$parcel$export(module.exports, "createTask", () => $6957019fc0d13ee5$export$f7292ab7796be73c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
function $6957019fc0d13ee5$export$f7292ab7796be73c(define) {
    return new $6957019fc0d13ee5$export$2dea7024bcdd7731(define);
}
var $6957019fc0d13ee5$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip; // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
         // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
         // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $bahqM.isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $6957019fc0d13ee5$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $6957019fc0d13ee5$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            } // To simplify no progress checking, array must has item.
            if ((0, $bahqM.isArray)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happend in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the setted end, in case
        // that the stub of dataZoom perform again and earse the
        // setted end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $6957019fc0d13ee5$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
         : current;
        current++;
        return result;
    }
}(); ///////////////////////////////////////////////////////////
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };

});



parcelRegister("9UN8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f753c775d35e6$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bAY5l = parcelRequire("bAY5l");

var $1O7Ua = parcelRequire("1O7Ua");
var $737f753c775d35e6$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = 'series.effectScatter';
    EffectScatterSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: 'ripple',
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: 'render',
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: 'fill',
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: 'clone'
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $1O7Ua.default));
var $737f753c775d35e6$export$2e2bcd8739ae039 = $737f753c775d35e6$var$EffectScatterSeriesModel;

});
parcelRegister("bAY5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8711aa3240a9c687$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $liBXN = parcelRequire("liBXN");

var $h9jiS = parcelRequire("h9jiS");

var $bnVGB = parcelRequire("bnVGB");

var $eaKsF = parcelRequire("eaKsF");

var $gyhNQ = parcelRequire("gyhNQ");

var $lhMGv = parcelRequire("lhMGv");

var $20liu = parcelRequire("20liu");

var $5R8Hi = parcelRequire("5R8Hi");

var $cNGs8 = parcelRequire("cNGs8");

var $2Rbm1 = parcelRequire("2Rbm1");
function $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $gyhNQ.default).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $bahqM.map(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $bnVGB.getDimensionTypeByAxis)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $8711aa3240a9c687$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $bahqM.each(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8711aa3240a9c687$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $20liu.createSourceFromSeriesDataOption)(sourceRaw);
    } else {
        source = sourceManager.getSource(); // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL);
    }
    var coordSysInfo = (0, $lhMGv.getCoordSysInfoBySeries)(seriesModel);
    var coordSysDimDefs = $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $bahqM.isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $bahqM.curry((0, $cNGs8.makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $h9jiS.default)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8711aa3240a9c687$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $5R8Hi.enableDataStack)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $liBXN.default)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL)) {
        var sampleItem = $8711aa3240a9c687$var$firstDataNotNull(source.data || []);
        return sampleItem != null && !$bahqM.isArray((0, $eaKsF.getDataItemValue)(sampleItem));
    }
}
function $8711aa3240a9c687$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8711aa3240a9c687$export$2e2bcd8739ae039 = $8711aa3240a9c687$var$createSeriesData;

});
parcelRegister("liBXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f818ba28c897a2f2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 
var $bahqM = parcelRequire("bahqM");

var $gaMkj = parcelRequire("gaMkj");

var $4wWkb = parcelRequire("4wWkb");

var $9OHWG = parcelRequire("9OHWG");

var $bnVGB = parcelRequire("bnVGB");

var $dhxbO = parcelRequire("dhxbO");

var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $7QjoM = parcelRequire("7QjoM");

var $20liu = parcelRequire("20liu");

var $8c3gC = parcelRequire("8c3gC");

var $2Om11 = parcelRequire("2Om11");
var $f818ba28c897a2f2$var$isObject = $bahqM.isObject;
var $f818ba28c897a2f2$var$map = $bahqM.map;
var $f818ba28c897a2f2$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var $f818ba28c897a2f2$var$ID_PREFIX = 'e\0\0';
var $f818ba28c897a2f2$var$INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;
var $f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $f818ba28c897a2f2$var$CLONE_PROPERTIES = [
    '_approximateExtent'
]; // -----------------------------
// Internal method declarations:
// -----------------------------
var $f818ba28c897a2f2$var$prepareInvertedIndex;
var $f818ba28c897a2f2$var$getId;
var $f818ba28c897a2f2$var$getIdNameFromStore;
var $f818ba28c897a2f2$var$normalizeDimensions;
var $f818ba28c897a2f2$var$transferProperties;
var $f818ba28c897a2f2$var$cloneListForMapAndSample;
var $f818ba28c897a2f2$var$makeIdFromName;
var $f818ba28c897a2f2$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = []; // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {}; // Globel layout properties.
        this._layout = {}; // Item visual properties after visual coding
        this._itemVisuals = []; // Item layout properties after layout
        this._itemLayouts = []; // Graphic elemnents
        this._graphicEls = []; // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {}; // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'lttbDownSample',
            'map'
        ]; // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $2Om11.isSeriesDataSchema)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $bahqM.isString(dimInfoInput) ? new (0, $dhxbO.default)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $dhxbO.default)) ? new (0, $dhxbO.default)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $bahqM.createHashMap();
            $bahqM.each(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Becuause of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
         // Retrieve from series dimension definition becuase it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatbility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recogonized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if (typeof dim === 'number' // If being a number-like string but not being defined as a dimension name.
         || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $8c3gC.default)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $20liu.isSourceInstance)(data) || $bahqM.isArrayLike(data) ? new (0, $9OHWG.DefaultDataProvider)(data, dimensions.length) : data;
            store = new (0, $8c3gC.default)();
            var dimensionInfos = $f818ba28c897a2f2$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store; // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $bnVGB.summarizeDimensions)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exaclty cooresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $f818ba28c897a2f2$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $eaKsF.isDataItemOption)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $eaKsF.convertOptionIdName)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $eaKsF.convertOptionIdName)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$f818ba28c897a2f2$var$makeIdFromName(this, idx);
        $f818ba28c897a2f2$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculte extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $f818ba28c897a2f2$var$isObject(key) ? $bahqM.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Becuase:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $f818ba28c897a2f2$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Becuase:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $f818ba28c897a2f2$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $bahqM.isArray(dimensions) ? store.getValues($f818ba28c897a2f2$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Inlcuding '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retreive the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $bahqM.keys(range);
        var dimIndices = [];
        $bahqM.each(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict'; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, becuase `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each sereis
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $bahqM.bind(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $gaMkj.default)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $4wWkb.default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $f818ba28c897a2f2$var$getId(otherList, idx);
        }, function(idx) {
            return $f818ba28c897a2f2$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($f818ba28c897a2f2$var$isObject(kvObj)) $bahqM.extend(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key); // TODO Performance?
            if ($bahqM.isArray(val)) val = val.slice();
            else if ($f818ba28c897a2f2$var$isObject(val)) val = $bahqM.extend({}, val);
            itemVisual[key] = val;
        }
        return val;
    }; // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($f818ba28c897a2f2$var$isObject(key)) $bahqM.extend(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        if ($f818ba28c897a2f2$var$isObject(key)) {
            for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
            return;
        }
        this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $bahqM.extend(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $7QjoM.setCommonECData)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $bahqM.each(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $f818ba28c897a2f2$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $f818ba28c897a2f2$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (typeof originalMethod !== 'function') return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($bahqM.slice(arguments)));
        };
    }; // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $f818ba28c897a2f2$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $bahqM.each(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $f818ba28c897a2f2$var$CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $f818ba28c897a2f2$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $eaKsF.convertOptionIdName)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $f818ba28c897a2f2$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $f818ba28c897a2f2$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $f818ba28c897a2f2$var$ID_PREFIX + rawIndex;
            return id;
        };
        $f818ba28c897a2f2$var$normalizeDimensions = function(dimensions) {
            if (!$bahqM.isArray(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transfered.
     */ $f818ba28c897a2f2$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $f818ba28c897a2f2$var$map(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
            $f818ba28c897a2f2$var$transferProperties(list, original);
            return list;
        };
        $f818ba28c897a2f2$var$transferProperties = function(target, source) {
            $bahqM.each($f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $bahqM.each($f818ba28c897a2f2$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $bahqM.clone(source[propName]);
            });
            target._calculationInfo = $bahqM.extend({}, source._calculationInfo);
        };
        $f818ba28c897a2f2$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $f818ba28c897a2f2$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $f818ba28c897a2f2$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $f818ba28c897a2f2$export$2e2bcd8739ae039 = $f818ba28c897a2f2$var$SeriesData;

});
parcelRegister("gaMkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc63113067804ddc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hZfwb = parcelRequire("hZfwb");

var $aLwh0 = parcelRequire("aLwh0");

var $8P3Or = parcelRequire("8P3Or");

var $hyGik = parcelRequire("hyGik");

var $46U6E = parcelRequire("46U6E");

var $4rldO = parcelRequire("4rldO");

var $bahqM = parcelRequire("bahqM");
var $bc63113067804ddc$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $bahqM.merge)(this.option, option, true);
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'xxx.yyy.zzz' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * Squash option stack into one.
   * parentModel will be removed after squashed.
   *
   * NOTE: resolveParentPath will not be applied here for simplicity. DON'T use this function
   * if resolveParentPath is modified.
   *
   * @param deepMerge If do deep merge. Default to be false.
   */ // squash(
    //     deepMerge?: boolean,
    //     handleCallback?: (func: () => object) => object
    // ) {
    //     const optionStack = [];
    //     let model: Model = this;
    //     while (model) {
    //         if (model.option) {
    //             optionStack.push(model.option);
    //         }
    //         model = model.parentModel;
    //     }
    //     const newOption = {} as Opt;
    //     let option;
    //     while (option = optionStack.pop()) {    // Top down merge
    //         if (isFunction(option) && handleCallback) {
    //             option = handleCallback(option);
    //         }
    //         if (deepMerge) {
    //             merge(newOption, option);
    //         }
    //         else {
    //             extend(newOption, option);
    //         }
    //     }
    //     // Remove parentModel
    //     this.option = newOption;
    //     this.parentModel = null;
    // }
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {}; // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $bahqM.clone)(this.option));
    }; // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    }; // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    }; // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $hZfwb.default).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
             // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
(0, $aLwh0.enableClassExtend)($bc63113067804ddc$var$Model);
(0, $aLwh0.enableClassCheck)($bc63113067804ddc$var$Model);
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $46U6E.LineStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $4rldO.ItemStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $8P3Or.AreaStyleMixin));
(0, $bahqM.mixin)($bc63113067804ddc$var$Model, (0, $hyGik.default));
var $bc63113067804ddc$export$2e2bcd8739ae039 = $bc63113067804ddc$var$Model;

});
parcelRegister("8P3Or", function(module, exports) {

$parcel$export(module.exports, "AreaStyleMixin", () => $66c60b4522f41760$export$a3a0ed7e2dd84c9e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $66c60b4522f41760$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $66c60b4522f41760$var$getAreaStyle = (0, $1BJbl.default)($66c60b4522f41760$export$52de6e304d934d85);
var $66c60b4522f41760$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $66c60b4522f41760$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();

});
parcelRegister("1BJbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bc4b5222290b4b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

var $bahqM = parcelRequire("bahqM");
function $12bc4b5222290b4b$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $bahqM.indexOf(excludes, propName) >= 0 || includes && $bahqM.indexOf(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        } // TODO Text or image?
        return style;
    };
}

});


parcelRegister("hyGik", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc866b770f3f8e08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gvLUt = parcelRequire("gvLUt");

var $4gEFv = parcelRequire("4gEFv");
var $cc866b770f3f8e08$var$PATH_COLOR = [
    'textStyle',
    'color'
]; // TODO Performance improvement?
var $cc866b770f3f8e08$var$tmpRichText = new (0, $4gEFv.default)();
var $cc866b770f3f8e08$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($cc866b770f3f8e08$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $gvLUt.getFont)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        $cc866b770f3f8e08$var$tmpRichText.useStyle({
            text: text,
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily'),
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
            padding: this.getShallow('padding'),
            lineHeight: this.getShallow('lineHeight'),
            rich: this.getShallow('rich')
        });
        $cc866b770f3f8e08$var$tmpRichText.update();
        return $cc866b770f3f8e08$var$tmpRichText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $cc866b770f3f8e08$export$2e2bcd8739ae039 = $cc866b770f3f8e08$var$TextStyleMixin;

});

parcelRegister("46U6E", function(module, exports) {

$parcel$export(module.exports, "LINE_STYLE_KEY_MAP", () => $2fe33e7a8dd518cd$export$9f34de5b59222949);
$parcel$export(module.exports, "LineStyleMixin", () => $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $2fe33e7a8dd518cd$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $2fe33e7a8dd518cd$var$getLineStyle = (0, $1BJbl.default)($2fe33e7a8dd518cd$export$9f34de5b59222949);
var $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $2fe33e7a8dd518cd$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();

});

parcelRegister("4rldO", function(module, exports) {

$parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", () => $33ba2539bbc4d618$export$ffb0bba5dde0130b);
$parcel$export(module.exports, "ItemStyleMixin", () => $33ba2539bbc4d618$export$e4f01e48d6fda412);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1BJbl = parcelRequire("1BJbl");
var $33ba2539bbc4d618$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $33ba2539bbc4d618$var$getItemStyle = (0, $1BJbl.default)($33ba2539bbc4d618$export$ffb0bba5dde0130b);
var $33ba2539bbc4d618$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $33ba2539bbc4d618$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();

});


parcelRegister("4wWkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c7649bb9fc460b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $34c7649bb9fc460b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $34c7649bb9fc460b$var$defaultKeyGetter(item) {
    return item;
}
var $34c7649bb9fc460b$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter; // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
             // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, map, // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $34c7649bb9fc460b$export$2e2bcd8739ae039 = $34c7649bb9fc460b$var$DataDiffer;

});

parcelRegister("bnVGB", function(module, exports) {

$parcel$export(module.exports, "summarizeDimensions", () => $849e96f8af2f129f$export$505a22c3734846f1);
$parcel$export(module.exports, "getDimensionTypeByAxis", () => $849e96f8af2f129f$export$af1622903e71278e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2Rbm1 = parcelRequire("2Rbm1");
var $849e96f8af2f129f$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $849e96f8af2f129f$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $bahqM.createHashMap)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $bahqM.each)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($849e96f8af2f129f$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                 // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $849e96f8af2f129f$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $2Rbm1.VISUAL_DIMENSIONS).each(function(v, otherDim) {
            var encodeArr = $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $bahqM.map)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
    // in this way. Use label.formatter instead. May be remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $849e96f8af2f129f$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
} // FIXME:TS should be type `AxisType`
function $849e96f8af2f129f$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $849e96f8af2f129f$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }

});

parcelRegister("dhxbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab69ba7880d9dc2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $9ab69ba7880d9dc2$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $bahqM.extend(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $9ab69ba7880d9dc2$export$2e2bcd8739ae039 = $9ab69ba7880d9dc2$var$SeriesDimensionDefine;

});

parcelRegister("8c3gC", function(module, exports) {

$parcel$export(module.exports, "CtorInt32Array", () => $5f71fa7e68f8e2cf$export$b60d945128546f53);
$parcel$export(module.exports, "default", () => $5f71fa7e68f8e2cf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");

var $20liu = parcelRequire("20liu");
var $5f71fa7e68f8e2cf$var$UNDEFINED = 'undefined';
var $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 = typeof Uint32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint32Array;
var $5f71fa7e68f8e2cf$export$78cf73566f32c185 = typeof Uint16Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint16Array;
var $5f71fa7e68f8e2cf$export$b60d945128546f53 = typeof Int32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Int32Array;
var $5f71fa7e68f8e2cf$export$365b104db51a490a = typeof Float64Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $5f71fa7e68f8e2cf$var$dataCtors = {
    'float': $5f71fa7e68f8e2cf$export$365b104db51a490a,
    'int': $5f71fa7e68f8e2cf$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $5f71fa7e68f8e2cf$export$365b104db51a490a
};
var $5f71fa7e68f8e2cf$var$defaultDimValueGetters;
function $5f71fa7e68f8e2cf$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 : $5f71fa7e68f8e2cf$export$78cf73566f32c185;
}
function $5f71fa7e68f8e2cf$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $5f71fa7e68f8e2cf$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $5f71fa7e68f8e2cf$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $5f71fa7e68f8e2cf$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $5f71fa7e68f8e2cf$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = []; // It will not be calculated util needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $bahqM.createHashMap)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider; // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $5f71fa7e68f8e2cf$var$defaultDimValueGetters[source.sourceFormat]; // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $20liu.shouldRetrieveDataByName)(source);
        this._dimensions = (0, $bahqM.map)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $5f71fa7e68f8e2cf$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
            dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start; // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $5f71fa7e68f8e2cf$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $bahqM.map)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem); // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end; // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions; // TODO get all from store?
            dimensions = []; // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = []; // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        }); // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count(); // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retreive the index with given raw data index
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
         // Indices are ascending
        var indices = this._indices; // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we chose the one that `diff >= 0` in this csae.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i); // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        } // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $bahqM.keys)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        } // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    }; // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2); // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart; // Find a point from current frame that construct a triangel with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                 // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        } // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $5f71fa7e68f8e2cf$var$getInitialExtent();
        var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i); // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                     // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $5f71fa7e68f8e2cf$var$getInitialExtent();
        if (!dimData) return initialExtent;
         // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $bahqM.reduce)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $5f71fa7e68f8e2cf$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $bahqM.clone)(this._extent);
        target._rawExtent = (0, $bahqM.clone)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $2G90t.parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $5f71fa7e68f8e2cf$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $2G90t.parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $2G90t.parseDataValue)(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
                 : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $5f71fa7e68f8e2cf$export$2e2bcd8739ae039 = $5f71fa7e68f8e2cf$var$DataStore;

});
parcelRegister("2G90t", function(module, exports) {

$parcel$export(module.exports, "parseDataValue", () => $1f367d921e7af2c3$export$cc7175145baad076);
$parcel$export(module.exports, "getRawValueParser", () => $1f367d921e7af2c3$export$c88237b7c265b36b);
$parcel$export(module.exports, "SortOrderComparator", () => $1f367d921e7af2c3$export$ed75a5d7b0144167);
$parcel$export(module.exports, "createFilterComparator", () => $1f367d921e7af2c3$export$f2644c3485f94c4e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $bahqM = parcelRequire("bahqM");

var $2cFRc = parcelRequire("2cFRc");
function $1f367d921e7af2c3$export$cc7175145baad076(value, opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' // spead up when using timestamp
     && typeof value !== 'number' && value != null && value !== '-') value = +(0, $jmSNG.parseDate)(value);
     // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
     : +value;
}
var $1f367d921e7af2c3$var$valueParserMap = (0, $bahqM.createHashMap)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have by defualt `numericToNumber`.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $jmSNG.parseDate)(val);
    },
    'trim': function(val) {
        return typeof val === 'string' ? (0, $bahqM.trim)(val) : val;
    }
});
function $1f367d921e7af2c3$export$c88237b7c265b36b(type) {
    return $1f367d921e7af2c3$var$valueParserMap.get(type);
}
var $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $1f367d921e7af2c3$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (typeof rval !== 'number') {
            var errMsg = '';
            (0, $2cFRc.throwError)(errMsg);
        }
        this._opFn = $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $jmSNG.numericToNumber)(rval);
    } // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $jmSNG.numericToNumber)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $1f367d921e7af2c3$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by defualt: 'asc'
   * @param incomparable by defualt: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE]
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    } // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalTypeof = typeof lval;
        var rvalTypeof = typeof rval;
        var lvalFloat = lvalTypeof === 'number' ? lval : (0, $jmSNG.numericToNumber)(lval);
        var rvalFloat = rvalTypeof === 'number' ? rval : (0, $jmSNG.numericToNumber)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = lvalTypeof === 'string';
            var rvalIsStr = rvalTypeof === 'string';
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $1f367d921e7af2c3$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $jmSNG.numericToNumber)(rval);
    } // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $jmSNG.numericToNumber)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $1f367d921e7af2c3$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $1f367d921e7af2c3$var$FilterEqualityComparator(op === 'eq', rval) : (0, $bahqM.hasOwn)($1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP, op) ? new $1f367d921e7af2c3$var$FilterOrderComparator(op, rval) : null;
}

});
parcelRegister("2cFRc", function(module, exports) {

$parcel$export(module.exports, "warn", () => $19ad2baf23da1928$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $19ad2baf23da1928$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "deprecateLog", () => $19ad2baf23da1928$export$4a9c0b74eb885aa1);
$parcel$export(module.exports, "throwError", () => $19ad2baf23da1928$export$8bf7aba4a9e09055);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $19ad2baf23da1928$var$ECHARTS_PREFIX = '[ECharts] ';
var $19ad2baf23da1928$var$storedLogs = {};
var $19ad2baf23da1928$var$hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
 && console.warn && console.log;
function $19ad2baf23da1928$export$bef1f36f5486a6a3(str) {
    if ($19ad2baf23da1928$var$hasConsole) // eslint-disable-next-line
    console.log($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$c106dd0671a0fc2d(str) {
    if ($19ad2baf23da1928$var$hasConsole) console.warn($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$a3bc9b8ed74fc(str) {
    if ($19ad2baf23da1928$var$hasConsole) console.error($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
}
function $19ad2baf23da1928$export$4a9c0b74eb885aa1(str) {}
function $19ad2baf23da1928$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $19ad2baf23da1928$export$c3747c611a35af25() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
}
function $19ad2baf23da1928$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $19ad2baf23da1928$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}

});




parcelRegister("h9jiS", function(module, exports) {

$parcel$export(module.exports, "createDimensions", () => $c7c240344387234c$export$8066c1b52b2e9504);
$parcel$export(module.exports, "default", () => $c7c240344387234c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2Rbm1 = parcelRequire("2Rbm1");

var $dhxbO = parcelRequire("dhxbO");

var $bahqM = parcelRequire("bahqM");

var $20liu = parcelRequire("20liu");

var $8c3gC = parcelRequire("8c3gC");

var $eaKsF = parcelRequire("eaKsF");

var $cNGs8 = parcelRequire("cNGs8");

var $2Om11 = parcelRequire("2Om11");
function $c7c240344387234c$export$8066c1b52b2e9504(source, opt) {
    return $c7c240344387234c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $c7c240344387234c$export$2e2bcd8739ae039(source, opt) {
    if (!(0, $20liu.isSourceInstance)(source)) source = (0, $20liu.createSourceFromSeriesDataOption)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $bahqM.createHashMap)();
    var resultList = [];
    var dimCount = $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unsed dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $2Om11.shouldOmitUnusedDimensions)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $2Om11.ensureSourceDimNameMap)(source) : (0, $2Om11.createDimNameMap)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $bahqM.createHashMap)(encodeDef);
    var indicesMap = new (0, $8c3gC.CtorInt32Array)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $bahqM.isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $dhxbO.default)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be diplayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
     // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $eaKsF.normalizeToArray)(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $bahqM.isString)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $bahqM.each)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $bahqM.isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    }); // Apply templetes and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $bahqM.each)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $bahqM.isString)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $bahqM.extend)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $eaKsF.normalizeToArray)(dataDims); // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
         // Apply templates.
        (0, $bahqM.each)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $bahqM.defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $bahqM.isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $bahqM.defaults)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $2Rbm1.VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    } // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    } // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $c7c240344387234c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $cNGs8.guessOrdinal)(source, resultDimIdx) === (0, $cNGs8.BE_ORDINAL).Must // Consider the case:
         || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $bahqM.each)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        }); // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $c7c240344387234c$var$removeDuplication(resultList);
    return new (0, $2Om11.SeriesDataSchema)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $c7c240344387234c$var$removeDuplication(result) {
    var duplicationMap = (0, $bahqM.createHashMap)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $bahqM.each)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $bahqM.isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $c7c240344387234c$var$genCoordDimName(name, map, fromZero) {
    var mapData = map.data;
    if (fromZero || mapData.hasOwnProperty(name)) {
        var i = 0;
        while(mapData.hasOwnProperty(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}

});

parcelRegister("gyhNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cda1a15c9ef40a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $c0cda1a15c9ef40a$var$coordinateSystemCreators = {};
var $c0cda1a15c9ef40a$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $bahqM.each($c0cda1a15c9ef40a$var$coordinateSystemCreators, function(creater, type) {
            var list = creater.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $bahqM.each(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $c0cda1a15c9ef40a$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $c0cda1a15c9ef40a$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $c0cda1a15c9ef40a$export$2e2bcd8739ae039 = $c0cda1a15c9ef40a$var$CoordinateSystemManager;

});

parcelRegister("lhMGv", function(module, exports) {

$parcel$export(module.exports, "getCoordSysInfoBySeries", () => $f7f0f3461c4b4907$export$f2befeb2f4933656);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $f7f0f3461c4b4907$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $bahqM.createHashMap)();
        this.categoryAxisMap = (0, $bahqM.createHashMap)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $f7f0f3461c4b4907$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $f7f0f3461c4b4907$var$CoordSysInfo(coordSysName);
    var fetch = $f7f0f3461c4b4907$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $f7f0f3461c4b4907$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($f7f0f3461c4b4907$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($f7f0f3461c4b4907$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($f7f0f3461c4b4907$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $bahqM.each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($f7f0f3461c4b4907$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $f7f0f3461c4b4907$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}

});


parcelRegister("1O7Ua", function(module, exports) {

$parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", () => $151097b3612ce5ca$export$e960441116ae2799);
$parcel$export(module.exports, "default", () => $151097b3612ce5ca$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $eaKsF = parcelRequire("eaKsF");

var $h4UlH = parcelRequire("h4UlH");

var $aCu4v = parcelRequire("aCu4v");

var $guzSc = parcelRequire("guzSc");

var $65MS1 = parcelRequire("65MS1");

var $92IK1 = parcelRequire("92IK1");

var $aLwh0 = parcelRequire("aLwh0");

var $jTNWo = parcelRequire("jTNWo");

var $d88IV = parcelRequire("d88IV");
var $151097b3612ce5ca$var$inner = $eaKsF.makeInner();
function $151097b3612ce5ca$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $151097b3612ce5ca$export$e960441116ae2799 = '__universalTransitionEnabled';
var $151097b3612ce5ca$var$SeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Becuase this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $92IK1.createTask)({
            count: $151097b3612ce5ca$var$dataTaskCount,
            reset: $151097b3612ce5ca$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager = new (0, $jTNWo.SourceManager)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $151097b3612ce5ca$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $151097b3612ce5ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
        var inputPositionParams = layoutMode ? (0, $65MS1.getLayoutParams)(option) : {}; // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $h4UlH.default).hasClass(themeSubType)) themeSubType += 'Series';
        $bahqM.merge(option, ecModel.getTheme().get(this.subType));
        $bahqM.merge(option, this.getDefaultOption()); // Default label emphasis `show`
        $eaKsF.defaultEmphasis(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $65MS1.mergeLayoutParam)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $bahqM.merge(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
        if (layoutMode) (0, $65MS1.mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $151097b3612ce5ca$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
        $151097b3612ce5ca$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$bahqM.isTypedArray(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $eaKsF.defaultEmphasis(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overriden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $151097b3612ce5ca$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $151097b3612ce5ca$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $151097b3612ce5ca$var$getCurrentTask(this);
        if (task) {
            var context = task.context; // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data; // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $151097b3612ce5ca$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $bahqM.createHashMap(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $151097b3612ce5ca$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $151097b3612ce5ca$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem; // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $d88IV.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        if ((0, $hZfwb.default).node) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel; // PENDING
        var color = (0, $aCu4v.PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    }; // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var data = this.getData(dataType);
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $bahqM.keys(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
        return selectedMap[nameOrId] || false;
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$151097b3612ce5ca$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition; // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
         // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var selectedMode = this.option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'multiple') {
            var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i]; // TODO diffrent types of data share same object.
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, lastDataIndex);
            this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    }; // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $h4UlH.default).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $h4UlH.default));
$bahqM.mixin($151097b3612ce5ca$var$SeriesModel, (0, $guzSc.DataFormatMixin));
$bahqM.mixin($151097b3612ce5ca$var$SeriesModel, (0, $aCu4v.PaletteMixin));
(0, $aLwh0.mountExtend)($151097b3612ce5ca$var$SeriesModel, (0, $h4UlH.default));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $151097b3612ce5ca$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$eaKsF.isNameSpecified(seriesModel)) seriesModel.name = $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) || name;
}
function $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $bahqM.each(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $151097b3612ce5ca$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $151097b3612ce5ca$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $151097b3612ce5ca$var$dataTaskProgress;
}
function $151097b3612ce5ca$var$dataTaskProgress(param, context) {
    // Avoid repead cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
} // TODO refactor
function $151097b3612ce5ca$var$wrapData(data, seriesModel) {
    $bahqM.each($bahqM.concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $bahqM.curry($151097b3612ce5ca$var$onDataChange, seriesModel));
    });
}
function $151097b3612ce5ca$var$onDataChange(seriesModel, newList) {
    var task = $151097b3612ce5ca$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $151097b3612ce5ca$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $151097b3612ce5ca$export$2e2bcd8739ae039 = $151097b3612ce5ca$var$SeriesModel;

});
parcelRegister("h4UlH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ee8520f4778ed8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $gaMkj = parcelRequire("gaMkj");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");

var $eaKsF = parcelRequire("eaKsF");

var $65MS1 = parcelRequire("65MS1");
var $c6ee8520f4778ed8$var$inner = (0, $eaKsF.makeInner)();
var $c6ee8520f4778ed8$var$ComponentModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $jvo6O.getUID('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $65MS1.fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? $65MS1.getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        $bahqM.merge(option, themeModel.get(this.mainType));
        $bahqM.merge(option, this.getDefaultOption());
        if (layoutMode) $65MS1.mergeLayoutParam(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $bahqM.merge(this.option, option, true);
        var layoutMode = $65MS1.fetchLayoutMode(this);
        if (layoutMode) $65MS1.mergeLayoutParam(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component';
   * import {XxxModel, XxxOption} from './XxxModel';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor; // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $aLwh0.isExtendedClass)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
         // FIXME: remove this approach?
        var fields = $c6ee8520f4778ed8$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $bahqM.merge(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $eaKsF.queryReferringComponents)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $gaMkj.default));
(0, $aLwh0.mountExtend)($c6ee8520f4778ed8$var$ComponentModel, (0, $gaMkj.default));
(0, $aLwh0.enableClassManagement)($c6ee8520f4778ed8$var$ComponentModel);
$jvo6O.enableSubTypeDefaulter($c6ee8520f4778ed8$var$ComponentModel);
$jvo6O.enableTopologicalTravel($c6ee8520f4778ed8$var$ComponentModel, $c6ee8520f4778ed8$var$getDependencies);
function $c6ee8520f4778ed8$var$getDependencies(componentType) {
    var deps = [];
    $bahqM.each($c6ee8520f4778ed8$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    }); // Ensure main type.
    deps = $bahqM.map(deps, function(type) {
        return (0, $aLwh0.parseClassType)(type).main;
    }); // Hack dataset for convenience.
    if (componentType !== 'dataset' && $bahqM.indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $c6ee8520f4778ed8$export$2e2bcd8739ae039 = $c6ee8520f4778ed8$var$ComponentModel;

});
parcelRegister("65MS1", function(module, exports) {

$parcel$export(module.exports, "LOCATION_PARAMS", () => $46f91e567ea0ce35$export$a9aa2cc018afbed);
$parcel$export(module.exports, "box", () => $46f91e567ea0ce35$export$827f4ee28efc37);
$parcel$export(module.exports, "getAvailableSize", () => $46f91e567ea0ce35$export$145a8938a85a22b1);
$parcel$export(module.exports, "getLayoutRect", () => $46f91e567ea0ce35$export$4517a5ca639a7293);
$parcel$export(module.exports, "positionElement", () => $46f91e567ea0ce35$export$74054bd96b5eeef1);
$parcel$export(module.exports, "sizeCalculable", () => $46f91e567ea0ce35$export$7ede609e8ebc9650);
$parcel$export(module.exports, "fetchLayoutMode", () => $46f91e567ea0ce35$export$3968a28a7cbd6063);
$parcel$export(module.exports, "mergeLayoutParam", () => $46f91e567ea0ce35$export$1754cb91f16ca028);
$parcel$export(module.exports, "getLayoutParams", () => $46f91e567ea0ce35$export$4b0d20af19c9875e);
$parcel$export(module.exports, "copyLayoutParams", () => $46f91e567ea0ce35$export$7438999faea9b6cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning

var $bahqM = parcelRequire("bahqM");

var $1E3E8 = parcelRequire("1E3E8");

var $jmSNG = parcelRequire("jmSNG");

var $dCJrM = parcelRequire("dCJrM");
var $46f91e567ea0ce35$var$each = $bahqM.each;
var $46f91e567ea0ce35$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $46f91e567ea0ce35$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $46f91e567ea0ce35$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $46f91e567ea0ce35$export$827f4ee28efc37 = $46f91e567ea0ce35$var$boxLayout;
var $46f91e567ea0ce35$export$be20d9158c17374c = $bahqM.curry($46f91e567ea0ce35$var$boxLayout, 'vertical');
var $46f91e567ea0ce35$export$ae65a483d943e7a7 = $bahqM.curry($46f91e567ea0ce35$var$boxLayout, 'horizontal');
function $46f91e567ea0ce35$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $jmSNG.parsePercent)(positionInfo.left, containerWidth);
    var y = (0, $jmSNG.parsePercent)(positionInfo.top, containerHeight);
    var x2 = (0, $jmSNG.parsePercent)(positionInfo.right, containerWidth);
    var y2 = (0, $jmSNG.parsePercent)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $dCJrM.normalizeCssArray(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $46f91e567ea0ce35$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $dCJrM.normalizeCssArray(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $jmSNG.parsePercent)(positionInfo.left, containerWidth);
    var top = (0, $jmSNG.parsePercent)(positionInfo.top, containerHeight);
    var right = (0, $jmSNG.parsePercent)(positionInfo.right, containerWidth);
    var bottom = (0, $jmSNG.parsePercent)(positionInfo.bottom, containerHeight);
    var width = (0, $jmSNG.parsePercent)(positionInfo.width, containerWidth);
    var height = (0, $jmSNG.parsePercent)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        } // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    } // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
     // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    } // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1E3E8.default)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $46f91e567ea0ce35$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    if (!h && !v) return;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $1E3E8.default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    } // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $46f91e567ea0ce35$export$4517a5ca639a7293($bahqM.defaults({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        el.x = dx;
        el.y = dy;
    } else {
        el.x += dx;
        el.y += dy;
    }
    el.markRedraw();
}
function $46f91e567ea0ce35$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $46f91e567ea0ce35$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $bahqM.isObject(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $46f91e567ea0ce35$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$bahqM.isArray(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[1], 1);
    copy($46f91e567ea0ce35$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($46f91e567ea0ce35$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $46f91e567ea0ce35$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $46f91e567ea0ce35$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        } // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $46f91e567ea0ce35$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $46f91e567ea0ce35$export$4b0d20af19c9875e(source) {
    return $46f91e567ea0ce35$export$7438999faea9b6cc({}, source);
}
function $46f91e567ea0ce35$export$7438999faea9b6cc(target, source) {
    source && target && $46f91e567ea0ce35$var$each($46f91e567ea0ce35$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}

});
parcelRegister("dCJrM", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => $9eb213cc0c822e32$export$b6fe44657ce35c42);
$parcel$export(module.exports, "toCamelCase", () => $9eb213cc0c822e32$export$86f54f62aa7a7514);
$parcel$export(module.exports, "normalizeCssArray", () => $9eb213cc0c822e32$export$f3a38102c49f4268);
$parcel$export(module.exports, "encodeHTML", () => $9eb213cc0c822e32$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "makeValueReadable", () => $9eb213cc0c822e32$export$3cd8db88714decfc);
$parcel$export(module.exports, "formatTpl", () => $9eb213cc0c822e32$export$2028496a35766e41);
$parcel$export(module.exports, "formatTplSimple", () => $9eb213cc0c822e32$export$2fa08233ee42f8e1);
$parcel$export(module.exports, "getTooltipMarker", () => $9eb213cc0c822e32$export$1987a3dbdf3c45ca);
$parcel$export(module.exports, "formatTime", () => $9eb213cc0c822e32$export$3203edd9e5edd663);
$parcel$export(module.exports, "capitalFirst", () => $9eb213cc0c822e32$export$38a1e7552f497c0e);
$parcel$export(module.exports, "convertToColorString", () => $9eb213cc0c822e32$export$cda04d03233e5555);
$parcel$export(module.exports, "windowOpen", () => $9eb213cc0c822e32$export$13e13f9b96dbe8fa);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");


var $h6fMM = parcelRequire("h6fMM");

var $2emZ2 = parcelRequire("2emZ2");
function $9eb213cc0c822e32$export$b6fe44657ce35c42(x) {
    if (!(0, $jmSNG.isNumeric)(x)) return $bahqM.isString(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $9eb213cc0c822e32$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $9eb213cc0c822e32$export$f3a38102c49f4268 = $bahqM.normalizeCssArray;
var $9eb213cc0c822e32$var$replaceReg = /([&<>"'])/g;
var $9eb213cc0c822e32$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $9eb213cc0c822e32$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($9eb213cc0c822e32$var$replaceReg, function(str, c) {
        return $9eb213cc0c822e32$var$replaceMap[c];
    });
}
function $9eb213cc0c822e32$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $bahqM.trim(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $jmSNG.parseDate)(value) : value;
        if (!isNaN(+date)) return (0, $bc1Ad.format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
         // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $bahqM.isStringSafe(value) ? stringToUserReadable(value) : $bahqM.isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
     // By default.
    var numericResult = (0, $jmSNG.numericToNumber)(value);
    return isNumberUserReadable(numericResult) ? $9eb213cc0c822e32$export$b6fe44657ce35c42(numericResult) : $bahqM.isStringSafe(value) ? stringToUserReadable(value) : '-';
}
var $9eb213cc0c822e32$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $9eb213cc0c822e32$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $9eb213cc0c822e32$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$bahqM.isArray(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $9eb213cc0c822e32$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar(alias), $9eb213cc0c822e32$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar($9eb213cc0c822e32$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(val) : val);
    }
    return tpl;
}
function $9eb213cc0c822e32$export$2fa08233ee42f8e1(tpl, param, encode) {
    $bahqM.each(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(value) : value);
    });
    return tpl;
}
function $9eb213cc0c822e32$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $bahqM.isString(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' // Only support string
     + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $9eb213cc0c822e32$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $jmSNG.parseDate)(value);
    var utc = isUTC ? 'UTC' : '';
    var y = date['get' + utc + 'FullYear']();
    var M = date['get' + utc + 'Month']() + 1;
    var d = date['get' + utc + 'Date']();
    var h = date['get' + utc + 'Hours']();
    var m = date['get' + utc + 'Minutes']();
    var s = date['get' + utc + 'Seconds']();
    var S = date['get' + utc + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $bc1Ad.pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, $bc1Ad.pad)(d, 2)).replace('d', d).replace('hh', (0, $bc1Ad.pad)(h, 2)).replace('h', h).replace('mm', (0, $bc1Ad.pad)(m, 2)).replace('m', m).replace('ss', (0, $bc1Ad.pad)(s, 2)).replace('s', s).replace('SSS', (0, $bc1Ad.pad)(S, 3));
    return tpl;
}
function $9eb213cc0c822e32$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $9eb213cc0c822e32$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $bahqM.isString(color) ? color : $bahqM.isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $9eb213cc0c822e32$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}

});
parcelRegister("bc1Ad", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $82620b17ee17a85a$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $82620b17ee17a85a$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $82620b17ee17a85a$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $82620b17ee17a85a$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_YEAR", () => $82620b17ee17a85a$export$99cafda57477293d);
$parcel$export(module.exports, "fullLeveledFormatter", () => $82620b17ee17a85a$export$445bdbd8d2334e40);
$parcel$export(module.exports, "timeUnits", () => $82620b17ee17a85a$export$833c398a55654bb7);
$parcel$export(module.exports, "pad", () => $82620b17ee17a85a$export$5d04458e2a6c373e);
$parcel$export(module.exports, "getPrimaryTimeUnit", () => $82620b17ee17a85a$export$1da4b91a25d7e1c8);
$parcel$export(module.exports, "isPrimaryTimeUnit", () => $82620b17ee17a85a$export$beb5920b69c13da);
$parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", () => $82620b17ee17a85a$export$124c820721c4f66b);
$parcel$export(module.exports, "format", () => $82620b17ee17a85a$export$d9468344d3651243);
$parcel$export(module.exports, "fullYearGetterName", () => $82620b17ee17a85a$export$8d046fefed9a548e);
$parcel$export(module.exports, "monthGetterName", () => $82620b17ee17a85a$export$5c242a801a23eec7);
$parcel$export(module.exports, "dateGetterName", () => $82620b17ee17a85a$export$4189e6cbc9753260);
$parcel$export(module.exports, "hoursGetterName", () => $82620b17ee17a85a$export$8b40b55b3c06cbe2);
$parcel$export(module.exports, "minutesGetterName", () => $82620b17ee17a85a$export$8807847c5c71eded);
$parcel$export(module.exports, "secondsGetterName", () => $82620b17ee17a85a$export$8f49e73e2eebd168);
$parcel$export(module.exports, "millisecondsGetterName", () => $82620b17ee17a85a$export$312207a92d041116);
$parcel$export(module.exports, "leveledFormat", () => $82620b17ee17a85a$export$fe777b6293828b5d);
$parcel$export(module.exports, "getUnitValue", () => $82620b17ee17a85a$export$e04e41a1e24ffd3f);
$parcel$export(module.exports, "fullYearSetterName", () => $82620b17ee17a85a$export$43fbeac90913b151);
$parcel$export(module.exports, "monthSetterName", () => $82620b17ee17a85a$export$233f59998ed71c09);
$parcel$export(module.exports, "dateSetterName", () => $82620b17ee17a85a$export$82fd379a67f37fa0);
$parcel$export(module.exports, "hoursSetterName", () => $82620b17ee17a85a$export$b6f943e8d23c15bb);
$parcel$export(module.exports, "minutesSetterName", () => $82620b17ee17a85a$export$50303078793fc7d);
$parcel$export(module.exports, "secondsSetterName", () => $82620b17ee17a85a$export$a4a908acda9c3118);
$parcel$export(module.exports, "millisecondsSetterName", () => $82620b17ee17a85a$export$c047afab75f6d84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $3OMoQ = parcelRequire("3OMoQ");

var $gaMkj = parcelRequire("gaMkj");
var $82620b17ee17a85a$export$32c0454ceff7f92d = 1000;
var $82620b17ee17a85a$export$35acaebf644db34e = $82620b17ee17a85a$export$32c0454ceff7f92d * 60;
var $82620b17ee17a85a$export$82541edf19e5e3b0 = $82620b17ee17a85a$export$35acaebf644db34e * 60;
var $82620b17ee17a85a$export$a97a1358cbb650ab = $82620b17ee17a85a$export$82541edf19e5e3b0 * 24;
var $82620b17ee17a85a$export$99cafda57477293d = $82620b17ee17a85a$export$a97a1358cbb650ab * 365;
var $82620b17ee17a85a$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $82620b17ee17a85a$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $82620b17ee17a85a$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $82620b17ee17a85a$var$fullDayFormatter,
    hour: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.hour,
    minute: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.minute,
    second: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.second,
    millisecond: $82620b17ee17a85a$export$f7854271ddbda64e.none
};
var $82620b17ee17a85a$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $82620b17ee17a85a$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $82620b17ee17a85a$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $82620b17ee17a85a$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit);
}
function $82620b17ee17a85a$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $82620b17ee17a85a$export$d9468344d3651243(// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $jmSNG.parseDate(time);
    var y = date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
    var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 4) + 1;
    var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
    var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $gaMkj.default) ? lang : (0, $3OMoQ.getLocaleModel)(lang || (0, $3OMoQ.SYSTEM_LANG)) || (0, $3OMoQ.getDefaultLocaleModel)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $82620b17ee17a85a$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if (typeof formatter === 'string') // Single formatter for all units at all levels
    template = formatter;
    else if (typeof formatter === 'function') // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $bahqM.extend({}, $82620b17ee17a85a$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $82620b17ee17a85a$export$87100da04d711986.length; ++i)defaults[$82620b17ee17a85a$export$87100da04d711986[i]] = "{primary|" + defaults[$82620b17ee17a85a$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $bahqM.defaults(formatter, defaults) : defaults;
        var unit = $82620b17ee17a85a$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $82620b17ee17a85a$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($bahqM.isArray(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $82620b17ee17a85a$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $jmSNG.parseDate(value);
    var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
    var h = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
    var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $82620b17ee17a85a$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = typeof value === 'number' ? $jmSNG.parseDate(value) : value;
    unit = unit || $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
    }
}
function $82620b17ee17a85a$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $82620b17ee17a85a$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $82620b17ee17a85a$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $82620b17ee17a85a$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $82620b17ee17a85a$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $82620b17ee17a85a$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $82620b17ee17a85a$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $82620b17ee17a85a$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $82620b17ee17a85a$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $82620b17ee17a85a$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $82620b17ee17a85a$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $82620b17ee17a85a$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $82620b17ee17a85a$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

});
parcelRegister("3OMoQ", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", () => $2c7b95ca3b098ed0$export$9a2147b3808d4c6b);
$parcel$export(module.exports, "registerLocale", () => $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd);
$parcel$export(module.exports, "createLocaleObject", () => $2c7b95ca3b098ed0$export$ddc371781a6af754);
$parcel$export(module.exports, "getLocaleModel", () => $2c7b95ca3b098ed0$export$37cc638e0e11865f);
$parcel$export(module.exports, "getDefaultLocaleModel", () => $2c7b95ca3b098ed0$export$1188f179b2597821);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gaMkj = parcelRequire("gaMkj");

var $hZfwb = parcelRequire("hZfwb");

var $dHSx1 = parcelRequire("dHSx1");

var $1VLoR = parcelRequire("1VLoR");

var $bahqM = parcelRequire("bahqM");
var $2c7b95ca3b098ed0$var$LOCALE_ZH = 'ZH';
var $2c7b95ca3b098ed0$var$LOCALE_EN = 'EN';
var $2c7b95ca3b098ed0$var$DEFAULT_LOCALE = $2c7b95ca3b098ed0$var$LOCALE_EN;
var $2c7b95ca3b098ed0$var$localeStorage = {};
var $2c7b95ca3b098ed0$var$localeModels = {};
var $2c7b95ca3b098ed0$export$9a2147b3808d4c6b = !(0, $hZfwb.default).domSupported ? $2c7b95ca3b098ed0$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
    return langStr.indexOf($2c7b95ca3b098ed0$var$LOCALE_ZH) > -1 ? $2c7b95ca3b098ed0$var$LOCALE_ZH : $2c7b95ca3b098ed0$var$DEFAULT_LOCALE;
}();
function $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $2c7b95ca3b098ed0$var$localeModels[locale] = new (0, $gaMkj.default)(localeObj);
    $2c7b95ca3b098ed0$var$localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
function $2c7b95ca3b098ed0$export$ddc371781a6af754(locale) {
    if ((0, $bahqM.isString)(locale)) {
        var localeObj = $2c7b95ca3b098ed0$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $2c7b95ca3b098ed0$var$LOCALE_ZH || locale === $2c7b95ca3b098ed0$var$LOCALE_EN) return (0, $bahqM.clone)(localeObj);
        else return (0, $bahqM.merge)((0, $bahqM.clone)(localeObj), (0, $bahqM.clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
    } else return (0, $bahqM.merge)((0, $bahqM.clone)(locale), (0, $bahqM.clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
}
function $2c7b95ca3b098ed0$export$37cc638e0e11865f(lang) {
    return $2c7b95ca3b098ed0$var$localeModels[lang];
}
function $2c7b95ca3b098ed0$export$1188f179b2597821() {
    return $2c7b95ca3b098ed0$var$localeModels[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE];
} // Default locale
$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_EN, (0, $dHSx1.default));
$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_ZH, (0, $1VLoR.default));

});
parcelRegister("dHSx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa9975bdbfffeb9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Language: English.
 */ var $9fa9975bdbfffeb9$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};

});

parcelRegister("1VLoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $167fe1fc3be0ec4c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $167fe1fc3be0ec4c$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};

});



parcelRegister("2emZ2", function(module, exports) {

$parcel$export(module.exports, "getTextRect", () => $19feb79b579d02ba$export$372ffda650a6e70d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4gEFv = parcelRequire("4gEFv");

var $2cFRc = parcelRequire("2cFRc");
function $19feb79b579d02ba$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    (0, $2cFRc.deprecateLog)('getTextRect is deprecated.');
    var textEl = new (0, $4gEFv.default)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? 'truncate' : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}

});




parcelRegister("aCu4v", function(module, exports) {

$parcel$export(module.exports, "PaletteMixin", () => $7bb4c79f78d718b0$export$55a3c39e852b90f4);
$parcel$export(module.exports, "getDecalFromPalette", () => $7bb4c79f78d718b0$export$e4d892222945a227);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");
var $7bb4c79f78d718b0$var$innerColor = (0, $eaKsF.makeInner)();
var $7bb4c79f78d718b0$var$innerDecal = (0, $eaKsF.makeInner)();
var $7bb4c79f78d718b0$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $eaKsF.normalizeToArray)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $7bb4c79f78d718b0$var$getFromPalette(this, $7bb4c79f78d718b0$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $7bb4c79f78d718b0$var$clearPalette(this, $7bb4c79f78d718b0$var$innerColor);
    };
    return PaletteMixin;
}();
function $7bb4c79f78d718b0$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $eaKsF.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $7bb4c79f78d718b0$var$getFromPalette(ecModel, $7bb4c79f78d718b0$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $7bb4c79f78d718b0$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length; // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $7bb4c79f78d718b0$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $7bb4c79f78d718b0$var$getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $7bb4c79f78d718b0$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}

});

parcelRegister("guzSc", function(module, exports) {

$parcel$export(module.exports, "DataFormatMixin", () => $c01b465ef25e12c0$export$f23396ae04ea95a7);
$parcel$export(module.exports, "normalizeTooltipFormatResult", () => $c01b465ef25e12c0$export$2d16fa82a50c4741);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9OHWG = parcelRequire("9OHWG");

var $dCJrM = parcelRequire("dCJrM");

var $c01b465ef25e12c0$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $c01b465ef25e12c0$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $bahqM.isArray(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex); // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if (typeof formatter === 'function') {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if (typeof formatter === 'string') {
            var str = (0, $dCJrM.formatTpl)(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($c01b465ef25e12c0$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $9OHWG.retrieveRawValue)(data, dataIndex, dimLoose);
                if (extendParams && $bahqM.isArray(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $9OHWG.retrieveRawValue)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $c01b465ef25e12c0$export$2d16fa82a50c4741(result // markersExisting: Dictionary<ColorString>
) {
    var markupText; // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($bahqM.isObject(result)) {
        if (result.type) markupFragment = result;
         // else {
    } else markupText = result;
    return {
        markupText: markupText,
        // markers: markers || markersExisting,
        markupFragment: markupFragment
    };
}

});

parcelRegister("jTNWo", function(module, exports) {

$parcel$export(module.exports, "SourceManager", () => $e7c9e4985e212cda$export$af4db9ec7e200ea2);
$parcel$export(module.exports, "disableTransformOptionMerge", () => $e7c9e4985e212cda$export$9451f4e9047441ec);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $20liu = parcelRequire("20liu");

var $2Rbm1 = parcelRequire("2Rbm1");

var $cNGs8 = parcelRequire("cNGs8");

var $05ab4 = parcelRequire("05ab4");

var $8c3gC = parcelRequire("8c3gC");

var $9OHWG = parcelRequire("9OHWG");
/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transfroms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $e7c9e4985e212cda$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = []; // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0; // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $bahqM.isTypedArray)(data) ? (0, $2Rbm1.SOURCE_FORMAT_TYPED_ARRAY) : (0, $2Rbm1.SOURCE_FORMAT_ORIGINAL);
                upstreamSignList = [];
            } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $bahqM.retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $bahqM.retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null; // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $bahqM.retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
            // to avoid extra memroy cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $20liu.createSource)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost; // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $20liu.createSource)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $e7c9e4985e212cda$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $bahqM.each)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $e7c9e4985e212cda$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $05ab4.applyDataTransform)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $20liu.cloneSourceShallow)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
         // All sourceList is from the some upsteam.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By defualt 0, means "main source".
   *                    Most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($e7c9e4985e212cda$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $8c3gC.default)(); // Always create store from source of series.
                cachedStore.initData(new (0, $9OHWG.DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PEDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // no need to update them when change happen.
        var sourceHost = this._sourceHost;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            var datasetModel = (0, $cNGs8.querySeriesUpstreamDatasetModel)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $bahqM.map)((0, $cNGs8.queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $e7c9e4985e212cda$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $bahqM.setAsPrimitive)(datasetModel.option.transform);
}
function $e7c9e4985e212cda$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $e7c9e4985e212cda$var$doThrow(errMsg) {
    throw new Error(errMsg);
}

});
parcelRegister("05ab4", function(module, exports) {

$parcel$export(module.exports, "registerExternalTransform", () => $00f85ccb3288f539$export$92c96c6d8b255b7d);
$parcel$export(module.exports, "applyDataTransform", () => $00f85ccb3288f539$export$42a68f09db16803f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2Rbm1 = parcelRequire("2Rbm1");

var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $9OHWG = parcelRequire("9OHWG");

var $2G90t = parcelRequire("2G90t");

var $2cFRc = parcelRequire("2cFRc");

var $20liu = parcelRequire("20liu");
/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $00f85ccb3288f539$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * becuase transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $2G90t.parseDataValue)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $00f85ccb3288f539$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $00f85ccb3288f539$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN)) (0, $2cFRc.throwError)(errMsg);
     // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Becuase the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is relialbe and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $bahqM.each)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt); // Users probably not sepcify dimension name. For simplicity, data transform
        // do not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbid name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $bahqM.hasOwn)(dimsByName, name)) (0, $2cFRc.throwError)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
     // Implement public methods:
    var rawItemGetter = (0, $9OHWG.getRawSourceItemGetter)(sourceFormat, (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $bahqM.bind)($00f85ccb3288f539$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $bahqM.bind)($00f85ccb3288f539$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $9OHWG.getRawSourceDataCounter)(sourceFormat, (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN));
    extSource.count = (0, $bahqM.bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $9OHWG.getRawSourceValueGetter)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $bahqM.bind)($00f85ccb3288f539$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $bahqM.bind)($00f85ccb3288f539$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $00f85ccb3288f539$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2cFRc.throwError)(errMsg);
    }
    return upstream.data;
}
function $00f85ccb3288f539$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2cFRc.throwError)(errMsg);
    }
    if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $bahqM.extend)({}, data[i]));
        return result;
    }
}
function $00f85ccb3288f539$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
     // Keep the same logic as `List::getDimension` did.
    if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
     || !isNaN(dim) && !(0, $bahqM.hasOwn)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $bahqM.hasOwn)(dimsByName, dim)) return dimsByName[dim];
}
function $00f85ccb3288f539$var$cloneAllDimensionInfo(dimensions) {
    return (0, $bahqM.clone)(dimensions);
}
var $00f85ccb3288f539$var$externalTransformMap = (0, $bahqM.createHashMap)();
function $00f85ccb3288f539$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $bahqM.clone)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $2cFRc.throwError)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $2cFRc.throwError)(errMsg);
     // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $00f85ccb3288f539$var$externalTransformMap.set(type, externalTransform);
}
function $00f85ccb3288f539$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $eaKsF.normalizeToArray)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $2cFRc.throwError)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $00f85ccb3288f539$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $00f85ccb3288f539$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $2cFRc.throwError)(errMsg);
    if (!(0, $bahqM.isObject)(transOption)) (0, $2cFRc.throwError)(errMsg);
    var transType = transOption.type;
    var externalTransform = $00f85ccb3288f539$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $2cFRc.throwError)(errMsg);
     // Prepare source
    var extUpSourceList = (0, $bahqM.map)(upSourceList, function(upSource) {
        return $00f85ccb3288f539$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $eaKsF.normalizeToArray)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $bahqM.clone)(transOption.config)
    }));
    var printStrArr;
    return (0, $bahqM.map)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $bahqM.isObject)(result)) (0, $2cFRc.throwError)(errMsg);
        if (!result.data) (0, $2cFRc.throwError)(errMsg);
        var sourceFormat = (0, $20liu.detectSourceFormat)(result.data);
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) (0, $2cFRc.throwError)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
         && !result.dimensions) {
            var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result becuase:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $2Rbm1.SERIES_LAYOUT_BY_COLUMN),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $20liu.createSource)(result.data, resultMetaRawOption, null);
    });
}
function $00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, $2Rbm1.SOURCE_FORMAT_OBJECT_ROWS);
}

});


parcelRegister("d88IV", function(module, exports) {

$parcel$export(module.exports, "defaultSeriesFormatTooltip", () => $98f2ca07d9209b02$export$3a110b9fb5c88b34);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $j5lKL = parcelRequire("j5lKL");

var $9OHWG = parcelRequire("9OHWG");

var $eaKsF = parcelRequire("eaKsF");
function $98f2ca07d9209b02$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $bahqM.isArray)(value);
    var markerColor = (0, $j5lKL.retrieveVisualColorForTooltipMarker)(series, dataIndex); // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $9OHWG.retrieveRawValue)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
     // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $eaKsF.isNameSpecified)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $j5lKL.createTooltipMarkup)('section', {
        header: seriesName,
        // When series name not specified, do not show a header line with only '-'.
        // This case alway happen in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $j5lKL.createTooltipMarkup)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $bahqM.trim)(inlineName),
                value: inlineValue,
                valueType: inlineValueType
            })
        ].concat(subBlocks || [])
    });
}
function $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $bahqM.reduce)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $bahqM.each)(tooltipDims, function(dim) {
        setEachItem((0, $9OHWG.retrieveRawValue)(data, dataIndex, dim), dim);
    }) // By default, all dims is used on tooltip.
     : (0, $bahqM.each)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $j5lKL.createTooltipMarkup)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}

});
parcelRegister("j5lKL", function(module, exports) {

$parcel$export(module.exports, "createTooltipMarkup", () => $de4f5bb7bbbcf45e$export$cf63b23ce77d1921);
$parcel$export(module.exports, "buildTooltipMarkup", () => $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a);
$parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", () => $de4f5bb7bbbcf45e$export$ea15628039c0fa93);
$parcel$export(module.exports, "getPaddingFromTooltipModel", () => $de4f5bb7bbbcf45e$export$3048212c802df496);
$parcel$export(module.exports, "TooltipMarkupStyleCreator", () => $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");

var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");

var $jmSNG = parcelRequire("jmSNG");
var $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option
function $de4f5bb7bbbcf45e$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $dCJrM.encodeHTML)(nameFontSize + '') + "px;color:" + (0, $dCJrM.encodeHTML)(nameFontColor) + ";font-weight:" + (0, $dCJrM.encodeHTML)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $dCJrM.encodeHTML)(valueFontSize + '') + "px;color:" + (0, $dCJrM.encodeHTML)(valueFontColor) + ";font-weight:" + (0, $dCJrM.encodeHTML)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $de4f5bb7bbbcf45e$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
]; // eslint-disable-next-line max-len
function $de4f5bb7bbbcf45e$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $de4f5bb7bbbcf45e$var$getBuilder(fragment) {
    return (0, $bahqM.hasOwn)($de4f5bb7bbbcf45e$var$builderMap, fragment.type) && $de4f5bb7bbbcf45e$var$builderMap[fragment.type];
}
var $de4f5bb7bbbcf45e$var$builderMap = {
    /**
   * A `section` block is like:
   * ```
   * header
   * subBlock
   * subBlock
   * ...
   * ```
   */ section: {
        planLayout: function(fragment) {
            var subBlockLen = fragment.blocks.length;
            var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
            var thisGapLevelBetweenSubBlocks = 0;
            (0, $bahqM.each)(fragment.blocks, function(subBlock) {
                $de4f5bb7bbbcf45e$var$getBuilder(subBlock).planLayout(subBlock);
                var subGapLevel = subBlock.__gapLevelBetweenSubBlocks; // If the some of the sub-blocks have some gaps (like 10px) inside, this block
                // should use a larger gap (like 20px) to distinguish those sub-blocks.
                if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel // If no header, always keep the sub gap level. Otherwise
                 || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
            });
            fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var noHeader = fragment.noHeader;
            var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
            var subMarkupText = $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
            if (noHeader) return subMarkupText;
            var displayableHeader = (0, $dCJrM.makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
            var nameStyle = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
            if (ctx.renderMode === 'richText') return $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
            else return $de4f5bb7bbbcf45e$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, $dCJrM.encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
        }
    },
    /**
   * A `nameValue` block is like:
   * ```
   * marker  name  value
   * ```
   */ nameValue: {
        planLayout: function(fragment) {
            fragment.__gapLevelBetweenSubBlocks = 0;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var renderMode = ctx.renderMode;
            var noName = fragment.noName;
            var noValue = fragment.noValue;
            var noMarker = !fragment.markerType;
            var name = fragment.name;
            var value = fragment.value;
            var useUTC = ctx.useUTC;
            if (noName && noValue) return;
            var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
            var readableName = noName ? '' : (0, $dCJrM.makeValueReadable)(name, 'ordinal', useUTC);
            var valueTypeOption = fragment.valueType;
            var readableValueList = noValue ? [] : (0, $bahqM.isArray)(value) ? (0, $bahqM.map)(value, function(val, idx) {
                return (0, $dCJrM.makeValueReadable)(val, (0, $bahqM.isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
            }) : [
                (0, $dCJrM.makeValueReadable)(value, (0, $bahqM.isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
            ];
            var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.
            var valueCloseToMarker = !noMarker && noName;
            var _a = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
            return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, readableName, nameStyle) // Value has commas inside, so use ' ' as delimiter for multiple values.
            ) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $de4f5bb7bbbcf45e$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
        }
    }
};
function $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $bahqM.assert)(!subBlocks || (0, $bahqM.isArray)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $bahqM.hasOwn)(orderMap, orderMode)) {
            var comparator_1 = new (0, $2G90t.SortOrderComparator)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
    (0, $bahqM.each)(subBlocks, function(subBlock, idx) {
        var subMarkupText = $de4f5bb7bbbcf45e$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    if (!subMarkupTextList.length) return;
    return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $de4f5bb7bbbcf45e$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
}
function $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $de4f5bb7bbbcf45e$var$getBuilder(fragment);
    builder.planLayout(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator
    };
    return builder.build(ctx, fragment, 0, toolTipTextStyle);
}
function $de4f5bb7bbbcf45e$var$getGap(fragment) {
    var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
    return {
        html: $de4f5bb7bbbcf45e$var$HTML_GAPS[gapLevelBetweenSubBlocks],
        richText: $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
    };
}
function $de4f5bb7bbbcf45e$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return "<div style=\"" + marginCSS + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $dCJrM.encodeHTML)(name) + '</span>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
     + (0, $bahqM.map)(valueList, function(value) {
        return (0, $dCJrM.encodeHTML)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    }); // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
}
function $de4f5bb7bbbcf45e$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $dCJrM.convertToColorString)(color);
}
function $de4f5bb7bbbcf45e$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding // We give slightly different to look pretty.
     : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
        // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $jmSNG.getRandomIdBase)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $dCJrM.getTooltipMarker)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $bahqM.isString)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $bahqM.isArray)(styles)) (0, $bahqM.each)(styles, function(stl) {
            return (0, $bahqM.extend)(finalStl, stl);
        });
        else (0, $bahqM.extend)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();

});





parcelRegister("47isN", function(module, exports) {

$parcel$export(module.exports, "install", () => $2ff6234e7db26f51$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jvYs5 = parcelRequire("jvYs5");

var $cDBtZ = parcelRequire("cDBtZ");

var $5xgWc = parcelRequire("5xgWc");

var $7jcIW = parcelRequire("7jcIW");
function $2ff6234e7db26f51$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cDBtZ.default));
    registers.registerSeriesModel((0, $jvYs5.default));
    registers.registerLayout((0, $5xgWc.default)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData(); // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    }); // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $7jcIW.default)('line'));
}

});
parcelRegister("jvYs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34fce1556fedd5e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bAY5l = parcelRequire("bAY5l");

var $1O7Ua = parcelRequire("1O7Ua");

var $7yklO = parcelRequire("7yklO");

var $4KVOr = parcelRequire("4KVOr");
var $e34fce1556fedd5e$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $4KVOr.default)();
        var line = (0, $7yklO.createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $7yklO.createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = '#fff';
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true,
            lineStyle: {
                width: 'bolder'
            }
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return LineSeriesModel;
}((0, $1O7Ua.default));
var $e34fce1556fedd5e$export$2e2bcd8739ae039 = $e34fce1556fedd5e$var$LineSeriesModel;

});

parcelRegister("cDBtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $933633d411d7f701$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $5DXGq = parcelRequire("5DXGq");

var $lUzII = parcelRequire("lUzII");

var $7HTYE = parcelRequire("7HTYE");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");
var $9J7f8 = parcelRequire("9J7f8");
var $4gEFv = parcelRequire("4gEFv");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $eaKsF = parcelRequire("eaKsF");

var $jconq = parcelRequire("jconq");

var $loerw = parcelRequire("loerw");

var $JBb7Y = parcelRequire("JBb7Y");

var $5fMzf = parcelRequire("5fMzf");

var $40dMe = parcelRequire("40dMe");

var $fIXXx = parcelRequire("fIXXx");

var $gvLUt = parcelRequire("gvLUt");

var $5MLZz = parcelRequire("5MLZz");

var $7QjoM = parcelRequire("7QjoM");

var $8fK8Y = parcelRequire("8fK8Y");

var $dCJrM = parcelRequire("dCJrM");

var $d6udH = parcelRequire("d6udH");
function $933633d411d7f701$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $933633d411d7f701$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $933633d411d7f701$var$getBoundingDiff(points1, points2) {
    var _a = $933633d411d7f701$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $933633d411d7f701$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1]; // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $933633d411d7f701$var$getSmooth(smooth) {
    return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
}
function $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $8fK8Y.createFloat32Array)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $JBb7Y.getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
function $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    for(; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    } // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $933633d411d7f701$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $d6udH.lerp)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
             // All following stop will be out of range. So just ignore them.
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $933633d411d7f701$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
     // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $bahqM.map(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $933633d411d7f701$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 0; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $bahqM.each(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $9J7f8.default(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
     // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto // Simplify the logic, do not determine label overlap here.
     && $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
     // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $bahqM.each(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $933633d411d7f701$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In mose cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $lUzII.default).getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
        )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
         * 1.5 > availSize) return false;
    }
    return true;
}
function $933633d411d7f701$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $933633d411d7f701$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$933633d411d7f701$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $933633d411d7f701$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $933633d411d7f701$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        if (seriesModel.get([
            (0, $fIXXx.SPECIAL_STATES)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $933633d411d7f701$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $40dMe.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $933633d411d7f701$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $5fMzf.createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during); // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        } // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $5fMzf.createPolarClipPath)(coordSys, hasAnimation, seriesModel);
}
function $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $933633d411d7f701$var$LineView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $4KVOr.default();
        var symbolDraw = new (0, $5DXGq.default)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $JBb7Y.prepareDataCoordInfo)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $933633d411d7f701$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $933633d411d7f701$var$getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        }); // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup); // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $933633d411d7f701$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                // TODO If stacked series is not step
                points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
             // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $dCJrM.convertToColorString)(visualColor));
            lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            } // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $dCJrM.convertToColorString)(visualColor));
             // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $933633d411d7f701$var$createLineClipPath(this, coordSys, false, seriesModel);
                $eYgMC.initProps(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($933633d411d7f701$var$createLineClipPath(this, coordSys, true, seriesModel));
             // Always update, or it is wrong in the case turning on legend
            // because points are not changed
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            }); // In the case data zoom triggerred refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing
            if (!$933633d411d7f701$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$933633d411d7f701$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $933633d411d7f701$var$turnPointsIntoStep(points, coordSys, step);
                        if (stackedOnPoints) stackedOnPoints = $933633d411d7f701$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var focus = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        polyline.useStyle($bahqM.defaults(lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $fIXXx.setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        } // Needs seriesIndex for focus
        (0, $7QjoM.getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $fIXXx.enableHoverEmphasis)(polyline, focus, blurScope);
        var smooth = $933633d411d7f701$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        var connectNulls = seriesModel.get('connectNulls');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($bahqM.defaults(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $933633d411d7f701$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $fIXXx.setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus
            (0, $7QjoM.getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $fIXXx.enableHoverEmphasis)(polygon, focus, blurScope);
        }
        var changePolyState = function(toState) {
            _this._changePolyState(toState);
        };
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data; // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
    };
    LineView.prototype.dispose = function() {};
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $eaKsF.queryDataIndex(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                 // fix #11360: should't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel');
                var z = seriesModel.get('z');
                symbol = new (0, $lUzII.default)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $loerw.default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $eaKsF.queryDataIndex(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $loerw.default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $fIXXx.setStatesFlag)(this._polyline, toState);
        polygon && (0, $fIXXx.setStatesFlag)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline; // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $jconq.ECPolyline)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon; // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $jconq.ECPolygon)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if (typeof seriesDuration === 'function') seriesDuration = seriesDuration(null);
        var seriesDalay = seriesModel.get('animationDelay') || 0;
        var seriesDalayValue = typeof seriesDalay === 'function' ? seriesDalay(null) : seriesDalay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = typeof seriesDalay === 'function' ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($933633d411d7f701$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $4gEFv.default({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            } // Find last non-NaN data to display data
            var dataIndex = $933633d411d7f701$var$getLastIndexNotNull(data_2.getLayout('points'));
            if (dataIndex >= 0) {
                (0, $gvLUt.setLabelStyle)(polyline, (0, $gvLUt.getLabelStatesModels)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $5MLZz.getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, $5MLZz.getDefaultLabel)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $933633d411d7f701$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $933633d411d7f701$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $933633d411d7f701$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $eaKsF.interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $933633d411d7f701$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) (0, $gvLUt.labelInner)(endLabel).setLabelText(value);
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $7HTYE.default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $933633d411d7f701$var$turnPointsIntoStep(diff.current, coordSys, step);
            stackedOnCurrent = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
            next = $933633d411d7f701$var$turnPointsIntoStep(diff.next, coordSys, step);
            stackedOnNext = $933633d411d7f701$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
        } // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($933633d411d7f701$var$getBoundingDiff(current, next) > 3000 || polygon && $933633d411d7f701$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        }; // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
         // Stop previous animation.
        polyline.stopAnimation();
        $eYgMC.updateProps(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $eYgMC.updateProps(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel); // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $loerw.default));
var $933633d411d7f701$export$2e2bcd8739ae039 = $933633d411d7f701$var$LineView;

});
parcelRegister("7HTYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c7f87717a036e4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $JBb7Y = parcelRequire("JBb7Y");

var $8fK8Y = parcelRequire("8fK8Y");
function $59c7f87717a036e4$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $59c7f87717a036e4$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $59c7f87717a036e4$var$diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = []; // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $JBb7Y.prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $JBb7Y.getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        } // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    } // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedNextPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedCurrStackedPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedNextStackedPoints = (0, $8fK8Y.createFloat32Array)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}

});
parcelRegister("JBb7Y", function(module, exports) {

$parcel$export(module.exports, "prepareDataCoordInfo", () => $08910af48116f194$export$b488a529581b37e);
$parcel$export(module.exports, "getStackedOnPoint", () => $08910af48116f194$export$c1601aa630e7b5f8);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5R8Hi = parcelRequire("5R8Hi");

var $bahqM = parcelRequire("bahqM");
function $08910af48116f194$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $08910af48116f194$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $bahqM.map)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $5R8Hi.isDimensionStacked)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $5R8Hi.isDimensionStacked)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $08910af48116f194$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
         // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $08910af48116f194$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}

});


parcelRegister("jconq", function(module, exports) {

$parcel$export(module.exports, "ECPolyline", () => $dfa20c0939f7b781$export$bf7c0585b8f7d00f);
$parcel$export(module.exports, "ECPolygon", () => $dfa20c0939f7b781$export$6042a400d113f2bd);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $aA4Ws = parcelRequire("aA4Ws");

var $dr1jo = parcelRequire("dr1jo");
var $dfa20c0939f7b781$var$mathMin = Math.min;
var $dfa20c0939f7b781$var$mathMax = Math.max;
function $dfa20c0939f7b781$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $dfa20c0939f7b781$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($dfa20c0939f7b781$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY; // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($dfa20c0939f7b781$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0; // Is last point
                if (tmpK >= segLen || $dfa20c0939f7b781$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        cpx1 = x - lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + lenPrevSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        cpx1 = x;
                        cpy1 = y - lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + lenPrevSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $dfa20c0939f7b781$var$mathMin(nextCpx0, $dfa20c0939f7b781$var$mathMax(nextX, x));
                        nextCpy0 = $dfa20c0939f7b781$var$mathMin(nextCpy0, $dfa20c0939f7b781$var$mathMax(nextY, y));
                        nextCpx0 = $dfa20c0939f7b781$var$mathMax(nextCpx0, $dfa20c0939f7b781$var$mathMin(nextX, x));
                        nextCpy0 = $dfa20c0939f7b781$var$mathMax(nextCpy0, $dfa20c0939f7b781$var$mathMin(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $dfa20c0939f7b781$var$mathMin(cpx1, $dfa20c0939f7b781$var$mathMax(prevX, x));
                        cpy1 = $dfa20c0939f7b781$var$mathMin(cpy1, $dfa20c0939f7b781$var$mathMax(prevY, y));
                        cpx1 = $dfa20c0939f7b781$var$mathMax(cpx1, $dfa20c0939f7b781$var$mathMin(prevX, x));
                        cpy1 = $dfa20c0939f7b781$var$mathMax(cpy1, $dfa20c0939f7b781$var$mathMin(prevY, y)); // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $dfa20c0939f7b781$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $dfa20c0939f7b781$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $dfa20c0939f7b781$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $aA4Ws.default).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $dr1jo.cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, $dr1jo.cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $dr1jo.cubicAt)(y0, y, y2, y3, t_1) : (0, $dr1jo.cubicAt)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $ghQ8v.default));
var $dfa20c0939f7b781$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($dfa20c0939f7b781$var$ECPolylineShape);
var $dfa20c0939f7b781$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $dfa20c0939f7b781$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$dfa20c0939f7b781$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$dfa20c0939f7b781$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $dfa20c0939f7b781$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $dfa20c0939f7b781$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $ghQ8v.default));

});

parcelRegister("5fMzf", function(module, exports) {

$parcel$export(module.exports, "createGridClipPath", () => $3d3406f7f3673e0b$export$83958787eb658d14);
$parcel$export(module.exports, "createPolarClipPath", () => $3d3406f7f3673e0b$export$13dc2b2230df3cb5);
$parcel$export(module.exports, "createClipPath", () => $3d3406f7f3673e0b$export$e0fe5081209d01c9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");
var $elGBV = parcelRequire("elGBV");

var $jmSNG = parcelRequire("jmSNG");
function $3d3406f7f3673e0b$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
    x = Math.floor(x);
    width = Math.round(width);
    var clipPath = new $7Tw7u.default({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = typeof during === 'function' ? function(percent) {
            during(percent, clipPath);
        } : null;
        $eYgMC.initProps(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $3d3406f7f3673e0b$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $jmSNG.round)(sectorArea.r0, 1);
    var r = (0, $jmSNG.round)(sectorArea.r, 1);
    var clipPath = new $elGBV.default({
        shape: {
            cx: (0, $jmSNG.round)(polar.cx, 1),
            cy: (0, $jmSNG.round)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $eYgMC.initProps(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $3d3406f7f3673e0b$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $3d3406f7f3673e0b$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $3d3406f7f3673e0b$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}

});

parcelRegister("40dMe", function(module, exports) {

$parcel$export(module.exports, "isCoordinateSystemType", () => $2ea1d953c3a29c60$export$8567506e6336616);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2ea1d953c3a29c60$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}

});


parcelRegister("7jcIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $55242d779d1fe9b5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $55242d779d1fe9b5$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
         // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $55242d779d1fe9b5$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $55242d779d1fe9b5$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if (typeof sampling === 'string') sampler = $55242d779d1fe9b5$var$samplers[sampling];
                    else if (typeof sampling === 'function') sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $55242d779d1fe9b5$var$indexSampler));
                }
            }
        }
    };
}

});


parcelRegister("Np0DX", function(module, exports) {

$parcel$export(module.exports, "install", () => $0947fa0f3730af30$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $alpND = parcelRequire("alpND");

var $eQgZJ = parcelRequire("eQgZJ");

var $jBLJn = parcelRequire("jBLJn");

var $iWOYl = parcelRequire("iWOYl");

var $5xgWc = parcelRequire("5xgWc");
function $0947fa0f3730af30$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $alpND.use)((0, $iWOYl.install));
    registers.registerSeriesModel((0, $eQgZJ.default));
    registers.registerChartView((0, $jBLJn.default));
    registers.registerLayout((0, $5xgWc.default)('scatter'));
}

});
parcelRegister("alpND", function(module, exports) {

$parcel$export(module.exports, "use", () => $787fe0d1b8504a01$export$1f96ae73734a86cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8pqpA = parcelRequire("8pqpA");

var $fkskt = parcelRequire("fkskt");

var $loerw = parcelRequire("loerw");

var $h4UlH = parcelRequire("h4UlH");

var $1O7Ua = parcelRequire("1O7Ua");

var $bahqM = parcelRequire("bahqM");

var $9Y5KT = parcelRequire("9Y5KT");
var $787fe0d1b8504a01$var$extensions = [];
var $787fe0d1b8504a01$var$extensionRegisters = {
    registerPreprocessor: (0, $8pqpA.registerPreprocessor),
    registerProcessor: (0, $8pqpA.registerProcessor),
    registerPostInit: (0, $8pqpA.registerPostInit),
    registerPostUpdate: (0, $8pqpA.registerPostUpdate),
    registerUpdateLifecycle: (0, $8pqpA.registerUpdateLifecycle),
    registerAction: (0, $8pqpA.registerAction),
    registerCoordinateSystem: (0, $8pqpA.registerCoordinateSystem),
    registerLayout: (0, $8pqpA.registerLayout),
    registerVisual: (0, $8pqpA.registerVisual),
    registerTransform: (0, $8pqpA.registerTransform),
    registerLoading: (0, $8pqpA.registerLoading),
    registerMap: (0, $8pqpA.registerMap),
    PRIORITY: (0, $8pqpA.PRIORITY),
    ComponentModel: (0, $h4UlH.default),
    ComponentView: (0, $fkskt.default),
    SeriesModel: (0, $1O7Ua.default),
    ChartView: (0, $loerw.default),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $h4UlH.default).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $fkskt.default).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $1O7Ua.default).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $loerw.default).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $h4UlH.default).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $9Y5KT.registerPainter)(painterType, PainterCtor);
    }
};
function $787fe0d1b8504a01$export$1f96ae73734a86cc(ext) {
    if ((0, $bahqM.isArray)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $bahqM.each)(ext, function(singleExt) {
            $787fe0d1b8504a01$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $bahqM.indexOf)($787fe0d1b8504a01$var$extensions, ext) >= 0) return;
    $787fe0d1b8504a01$var$extensions.push(ext);
    if ((0, $bahqM.isFunction)(ext)) ext = {
        install: ext
    };
    ext.install($787fe0d1b8504a01$var$extensionRegisters);
}

});
parcelRegister("8pqpA", function(module, exports) {

$parcel$export(module.exports, "version", () => $61f525521022d020$export$83d89fbfd8236492);
$parcel$export(module.exports, "dependencies", () => $61f525521022d020$export$b74ff737e0e298b5);
$parcel$export(module.exports, "PRIORITY", () => $61f525521022d020$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "init", () => $61f525521022d020$export$2cd8252107eb640b);
$parcel$export(module.exports, "getInstanceByDom", () => $61f525521022d020$export$33b6fbccd4f643f8);
$parcel$export(module.exports, "connect", () => $61f525521022d020$export$64605811ab45167f);
$parcel$export(module.exports, "disConnect", () => $61f525521022d020$export$87cd6834112ecb52);
$parcel$export(module.exports, "disconnect", () => $61f525521022d020$export$37dfea93db2e14ed);
$parcel$export(module.exports, "dispose", () => $61f525521022d020$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "getInstanceById", () => $61f525521022d020$export$89b4be35062c4a3f);
$parcel$export(module.exports, "registerTheme", () => $61f525521022d020$export$f9c59eed5de5ff80);
$parcel$export(module.exports, "registerPreprocessor", () => $61f525521022d020$export$77095792a057b768);
$parcel$export(module.exports, "registerProcessor", () => $61f525521022d020$export$d575e6557ac1729f);
$parcel$export(module.exports, "registerPostInit", () => $61f525521022d020$export$c8c249911ee8c1ed);
$parcel$export(module.exports, "registerUpdateLifecycle", () => $61f525521022d020$export$c9ec4b5faef04865);
$parcel$export(module.exports, "registerPostUpdate", () => $61f525521022d020$export$99560909c18c76bb);
$parcel$export(module.exports, "registerAction", () => $61f525521022d020$export$408c24786cd729c6);
$parcel$export(module.exports, "registerCoordinateSystem", () => $61f525521022d020$export$1dd5e025a8a37dd);
$parcel$export(module.exports, "getCoordinateSystemDimensions", () => $61f525521022d020$export$fc2638719e4159b9);
$parcel$export(module.exports, "registerLayout", () => $61f525521022d020$export$d768f97700ca6bea);
$parcel$export(module.exports, "registerVisual", () => $61f525521022d020$export$5f32c1eb94c381bb);
$parcel$export(module.exports, "registerLoading", () => $61f525521022d020$export$e06b68a82007c015);
$parcel$export(module.exports, "setCanvasCreator", () => $61f525521022d020$export$10425ea7a243b114);
$parcel$export(module.exports, "registerMap", () => $61f525521022d020$export$d456de060be2dba1);
$parcel$export(module.exports, "getMap", () => $61f525521022d020$export$b8586192aead8a7e);
$parcel$export(module.exports, "registerTransform", () => $61f525521022d020$export$f01d71dd0389d7e4);
$parcel$export(module.exports, "dataTool", () => $61f525521022d020$export$73cae5e090579589);
$parcel$export(module.exports, "registerLocale", () => (parcelRequire("3OMoQ")).registerLocale);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $3VFsf = parcelRequire("3VFsf");

var $9Y5KT = parcelRequire("9Y5KT");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $hZfwb = parcelRequire("hZfwb");

var $aVBu2 = parcelRequire("aVBu2");

var $bRKv5 = parcelRequire("bRKv5");

var $74g78 = parcelRequire("74g78");

var $iEvqc = parcelRequire("iEvqc");

var $gyhNQ = parcelRequire("gyhNQ");

var $6LzFt = parcelRequire("6LzFt");

var $driCQ = parcelRequire("driCQ");

var $iMppY = parcelRequire("iMppY");

var $1O7Ua = parcelRequire("1O7Ua");

var $fkskt = parcelRequire("fkskt");

var $loerw = parcelRequire("loerw");
parcelRequire("fHITF");
var $gcbBH = parcelRequire("gcbBH");
var $ghQ8v = parcelRequire("ghQ8v");
var $7Tw7u = parcelRequire("7Tw7u");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $fIXXx = parcelRequire("fIXXx");

var $eaKsF = parcelRequire("eaKsF");

var $ljaBy = parcelRequire("ljaBy");

var $cvEVp = parcelRequire("cvEVp");

var $4G956 = parcelRequire("4G956");

var $14WFd = parcelRequire("14WFd");

var $31FQc = parcelRequire("31FQc");

var $dMJCs = parcelRequire("dMJCs");

var $aLwh0 = parcelRequire("aLwh0");

var $cbv5T = parcelRequire("cbv5T");

var $7wiHx = parcelRequire("7wiHx");

var $fk5Gm = parcelRequire("fk5Gm");

var $2cFRc = parcelRequire("2cFRc");

var $1nKsD = parcelRequire("1nKsD");

var $05ab4 = parcelRequire("05ab4");

var $3OMoQ = parcelRequire("3OMoQ");

var $6IsbX = parcelRequire("6IsbX");

var $g2DhS = parcelRequire("g2DhS");

var $fEzwg = parcelRequire("fEzwg");

var $8cCW2 = parcelRequire("8cCW2");
var $61f525521022d020$var$hasWindow = typeof window !== 'undefined';
var $61f525521022d020$export$83d89fbfd8236492 = '5.2.1';
var $61f525521022d020$export$b74ff737e0e298b5 = {
    zrender: '5.2.1'
};
var $61f525521022d020$var$TEST_FRAME_REMAIN_TIME = 1;
var $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the begining of data processing.
var $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $61f525521022d020$var$PRIORITY_VISUAL_CHART = 3000;
var $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $61f525521022d020$var$PRIORITY_VISUAL_BRUSH = 5000;
var $61f525521022d020$var$PRIORITY_VISUAL_ARIA = 6000;
var $61f525521022d020$var$PRIORITY_VISUAL_DECAL = 7000;
var $61f525521022d020$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $61f525521022d020$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $61f525521022d020$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $61f525521022d020$var$PRIORITY_VISUAL_ARIA,
        DECAL: $61f525521022d020$var$PRIORITY_VISUAL_DECAL
    }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $61f525521022d020$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $61f525521022d020$var$PENDING_UPDATE = '__pendingUpdate';
var $61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $61f525521022d020$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $61f525521022d020$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $61f525521022d020$var$CONNECT_STATUS_PENDING = 0;
var $61f525521022d020$var$CONNECT_STATUS_UPDATING = 1;
var $61f525521022d020$var$CONNECT_STATUS_UPDATED = 2;
function $61f525521022d020$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $61f525521022d020$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $bRKv5.default).prototype[method].apply(host, args);
}
var $61f525521022d020$var$MessageCenter = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $bRKv5.default));
var $61f525521022d020$var$messageCenterProto = $61f525521022d020$var$MessageCenter.prototype;
$61f525521022d020$var$messageCenterProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('on');
$61f525521022d020$var$messageCenterProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $61f525521022d020$var$prepare;
var $61f525521022d020$var$prepareView;
var $61f525521022d020$var$updateDirectly;
var $61f525521022d020$var$updateMethods;
var $61f525521022d020$var$doConvertPixel;
var $61f525521022d020$var$updateStreamModes;
var $61f525521022d020$var$doDispatchAction;
var $61f525521022d020$var$flushPendingActions;
var $61f525521022d020$var$triggerUpdatedEvent;
var $61f525521022d020$var$bindRenderedEvent;
var $61f525521022d020$var$bindMouseEvent;
var $61f525521022d020$var$clearColorPalette;
var $61f525521022d020$var$render;
var $61f525521022d020$var$renderComponents;
var $61f525521022d020$var$renderSeries;
var $61f525521022d020$var$createExtensionAPI;
var $61f525521022d020$var$enableConnect;
var $61f525521022d020$var$markStatusToUpdate;
var $61f525521022d020$var$applyChangedStates;
var $61f525521022d020$var$ECharts = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECharts, _super);
    function ECharts(dom, theme, opts) {
        var _this = _super.call(this, new (0, $cbv5T.ECEventProcessor)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {}; // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {}; // Get theme by name
        if (typeof theme === 'string') theme = $61f525521022d020$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultUseDirtyRect = false;
        var root, devUseDirtyRect;
        var zr = _this._zr = $9Y5KT.init(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
        }); // Expect 60 fps.
        _this._throttledZrFlush = (0, $ljaBy.throttle)((0, $bahqM.bind)(zr.flush, zr), 17);
        theme = (0, $bahqM.clone)(theme);
        theme && (0, $driCQ.default)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $3OMoQ.createLocaleObject)(opts.locale || (0, $3OMoQ.SYSTEM_LANG));
        _this._coordSysMgr = new (0, $gyhNQ.default)();
        var api = _this._api = $61f525521022d020$var$createExtensionAPI(_this); // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $aVBu2.default)($61f525521022d020$var$visualFuncs, prioritySortFunc);
        (0, $aVBu2.default)($61f525521022d020$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $14WFd.default)(_this, api, $61f525521022d020$var$dataProcessorFuncs, $61f525521022d020$var$visualFuncs);
        _this._messageCenter = new $61f525521022d020$var$MessageCenter(); // Init mouse events
        _this._initEvents(); // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $bahqM.bind)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $61f525521022d020$var$bindRenderedEvent(zr, _this);
        $61f525521022d020$var$bindMouseEvent(zr, _this); // ECharts instance can be used as value.
        (0, $bahqM.setAsPrimitive)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $61f525521022d020$var$applyChangedStates(this);
        var scheduler = this._scheduler; // Lazy update
        if (this[$61f525521022d020$var$PENDING_UPDATE]) {
            var silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, null, this[$61f525521022d020$var$PENDING_UPDATE].updateParams); // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $61f525521022d020$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $61f525521022d020$var$updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determin in the first frame (the
                // frame is executed immedietely after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $61f525521022d020$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
             // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $bahqM.isObject)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $6LzFt.default)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $74g78.default)();
            ecModel.scheduler = this._scheduler;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $61f525521022d020$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$61f525521022d020$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, null, updateParams); // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            this._zr.flush();
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @DEPRECATED
   */ ECharts.prototype.setTheme = function() {
        console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    }; // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || $61f525521022d020$var$hasWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        if (!(0, $hZfwb.default).canvasSupported) return;
        opts = opts || {};
        return this._zr.painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $hZfwb.default).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList(); // Stop animations
        (0, $bahqM.each)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $bahqM.each)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $bahqM.each)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $hZfwb.default).canvasSupported) return;
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($61f525521022d020$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $bahqM.each)($61f525521022d020$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, $bahqM.clone)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $bahqM.createCanvas)();
            var zr_1 = $9Y5KT.init(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $bahqM.each)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $7Tw7u.default({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $bahqM.each)(canvasList_1, function(item) {
                    var img = new $gcbBH.default({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $61f525521022d020$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $61f525521022d020$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $eaKsF.parseFinder(ecModel, finder);
        (0, $bahqM.each)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $bahqM.each)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $eaKsF.parseFinder(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $fk5Gm.getItemVisualFromData)(data, dataIndexInside, visualType) : (0, $fk5Gm.getVisualFromData)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $bahqM.each)($61f525521022d020$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $6IsbX.findEventDispatcher)(el, function(parent) {
                    var ecData = (0, $7QjoM.getECData)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $bahqM.extend)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                 // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            }; // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $bahqM.each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        }); // Extra events
        // TODO register?
        (0, $bahqM.each)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $1nKsD.handleLegacySelectEvents)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        $eaKsF.setAttribute(this.getDom(), $61f525521022d020$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $bahqM.each)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $bahqM.each)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        }); // Dispose after all views disposed
        chart._zr.dispose(); // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $61f525521022d020$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model; // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent; // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$61f525521022d020$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$61f525521022d020$var$PENDING_UPDATE] = null;
        }
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
        needPrepare && $61f525521022d020$var$prepare(this);
        $61f525521022d020$var$updateMethods.update.call(this, {
            type: 'resize',
            animation: (0, $bahqM.extend)({
                // Disable animation
                duration: 0
            }, opts && opts.animation)
        });
        this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
        $61f525521022d020$var$flushPendingActions.call(this, silent);
        $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if ((0, $bahqM.isObject)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$61f525521022d020$var$loadingEffects[name]) return;
        var el = $61f525521022d020$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $bahqM.extend)({}, eventObj);
        payload.type = $61f525521022d020$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $bahqM.isObject)(opt)) opt = {
            silent: !!opt
        };
        if (!$61f525521022d020$var$actions[payload.type]) return;
         // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
         // May dispatchAction in rendering procedure
        if (this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $hZfwb.default).browser.weChat) // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh util user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $61f525521022d020$var$flushPendingActions.call(this, silent);
        $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8cCW2.default).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $61f525521022d020$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    }; // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $61f525521022d020$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $61f525521022d020$var$prepareView(ecIns, true);
            $61f525521022d020$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $61f525521022d020$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By defaut view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView; // This command should not work twice.
                model.__requireNewView = false; // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $aLwh0.parseClassType)(model.type);
                    var Clazz = isComponent ? (0, $fkskt.default).getClass(classType.main, classType.sub) : // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $loerw.default).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $61f525521022d020$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload); // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $bahqM.each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $bahqM.createHashMap)();
                (0, $bahqM.each)($eaKsF.normalizeToArray(excludeSeriesId), function(id) {
                    var modelId = $eaKsF.convertOptionIdName(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            if ((0, $fIXXx.isHighDownPayload)(payload)) (0, $fIXXx.allLeaveBlur)(ecIns._api);
             // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                if ((0, $fIXXx.isHighDownPayload)(payload)) {
                    if (model instanceof (0, $1O7Ua.default)) {
                        if (payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, $fIXXx.blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $fIXXx.findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, $fIXXx.blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                         // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $bahqM.each)(dispatchers, function(dispatcher) {
                            payload.type === (0, $fIXXx.HIGHLIGHT_ACTION_TYPE) ? (0, $fIXXx.enterEmphasis)(dispatcher) : (0, $fIXXx.leaveEmphasis)(dispatcher);
                        });
                    }
                } else if ((0, $fIXXx.isSelectChangePayload)(payload)) // TODO geo
                {
                    if (model instanceof (0, $1O7Ua.default)) {
                        (0, $fIXXx.toggleSelectionFromPayload)(model, payload, ecIns._api);
                        (0, $fIXXx.updateSeriesElementSelection)(model);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $61f525521022d020$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel); // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the orignal point
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // deteming whether use progressive rendering.
                $61f525521022d020$var$updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not requied in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                $61f525521022d020$var$clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $61f525521022d020$var$render(this, ecModel, api, payload, updateParams); // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode'); // In IE8
                if (!(0, $hZfwb.default).canvasSupported) {
                    var colorArr = $d6udH.parse(backgroundColor);
                    backgroundColor = $d6udH.stringify(colorArr, 'rgb');
                    if (colorArr[3] === 0) backgroundColor = 'transparent';
                } else {
                    zr.setBackgroundColor(backgroundColor); // Force set dark mode.
                    if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                }
                (0, $8cCW2.default).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $bahqM.createHashMap)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                }); // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $61f525521022d020$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8cCW2.default).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $loerw.default).markUpdateMethod(payload, 'updateView');
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $61f525521022d020$var$render(this, ecModel, this._api, payload, {});
                (0, $8cCW2.default).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                }); // Perform visual
                (0, $loerw.default).markUpdateMethod(payload, 'updateVisual');
                $61f525521022d020$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8cCW2.default).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $61f525521022d020$var$updateMethods.update.call(this, payload);
            }
        };
        $61f525521022d020$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $61f525521022d020$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $eaKsF.parseFinder(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $61f525521022d020$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $61f525521022d020$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $61f525521022d020$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $aLwh0.parseClassType)(cptTypeTmp[0]);
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false; // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $bahqM.map)(payload.batch, function(item) {
                    item = (0, $bahqM.defaults)((0, $bahqM.extend)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $fIXXx.isSelectChangePayload)(payload);
            var isHighDown = (0, $fIXXx.isHighDownPayload)(payload);
            (0, $bahqM.each)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside
                eventObj = eventObj || (0, $bahqM.extend)({}, batchItem); // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $eaKsF.preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $61f525521022d020$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $61f525521022d020$var$markStatusToUpdate(_this);
                } else if (cptType) $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                // Still dirty
                if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                    $61f525521022d020$var$prepare(this);
                    $61f525521022d020$var$updateMethods.update.call(this, payload);
                    this[$61f525521022d020$var$PENDING_UPDATE] = null;
                } else $61f525521022d020$var$updateMethods[updateMethod].call(this, payload);
            } // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $fIXXx.getAllSelectedIndices)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $61f525521022d020$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $61f525521022d020$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $61f525521022d020$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatly,
                // so it should only be triggered when rendering indeed happend
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$61f525521022d020$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $61f525521022d020$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, (0, $fIXXx.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $fIXXx.handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, (0, $fIXXx.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $fIXXx.handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $6IsbX.findEventDispatcher)(el, function(target) {
                    return (0, $7QjoM.getECData)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $7QjoM.getECData)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        $61f525521022d020$var$clearColorPalette = function(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        };
        $61f525521022d020$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            $61f525521022d020$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $bahqM.each)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $61f525521022d020$var$renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts
            (0, $bahqM.each)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $61f525521022d020$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $bahqM.each)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $61f525521022d020$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $bahqM.extend)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            }); // TODO progressive?
            (0, $8cCW2.default).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload); // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
                // increamental render (alway render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $fIXXx.updateSeriesElementSelection)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8cCW2.default).trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.
            (0, $8cCW2.default).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            }); // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8cCW2.default).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $61f525521022d020$var$markStatusToUpdate = function(ecIns) {
            ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $61f525521022d020$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($eYgMC.isElementRemoved(el)) return;
                applyElementStates(el);
            });
            ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates; // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            } // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $fIXXx.HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $fIXXx.HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $hZfwb.default).node && !(0, $hZfwb.default).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.group.traverse(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.group.traverse(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DONT mark the element dirty. In case element is incremental and don't wan't to rerender.
                el.style.blend = blendMode;
                if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                    displayable.style.blend = blendMode;
                });
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
             // Set z and zlevel
            _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
        }
        function _updateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                // el.traverse((childEl: Element) => _updateZ(childEl, z, zlevel));
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            } // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel; // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        } // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.group.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($eYgMC.isElementRemoved(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                 // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')
            } : null;
            view.group.traverse(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($eYgMC.isElementRemoved(el)) return;
                    if (el instanceof $ghQ8v.default) (0, $fIXXx.savePathStates)(el);
                     // Only updated on changed element. In case element is incremental and don't wan't to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates; // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    } // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    } // The use higlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $61f525521022d020$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $3VFsf.__extends)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $fIXXx.enterEmphasis)(el, highlightDigit);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $fIXXx.leaveEmphasis)(el, highlightDigit);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $fIXXx.enterBlur)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $fIXXx.leaveBlur)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $fIXXx.enterSelect)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $fIXXx.leaveSelect)(el);
                    $61f525521022d020$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $iEvqc.default)))(ecIns);
        };
        $61f525521022d020$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $bahqM.each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($61f525521022d020$var$connectedGroups[chart.group] && chart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $bahqM.each)($61f525521022d020$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_PENDING);
                        (0, $bahqM.each)(otherCharts_1, function(otherChart) {
                            if (otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $bRKv5.default));
var $61f525521022d020$var$echartsProto = $61f525521022d020$var$ECharts.prototype;
$61f525521022d020$var$echartsProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('on');
$61f525521022d020$var$echartsProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$61f525521022d020$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $2cFRc.deprecateLog)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2); // @ts-ignore
        self.off(eventName, wrapped);
    }
    this.on.call(this, eventName, wrapped, ctx);
}; // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         let isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
var $61f525521022d020$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $61f525521022d020$var$disposedWarning(id) {}
var $61f525521022d020$var$actions = {};
/**
 * Map eventType to actionType
 */ var $61f525521022d020$var$eventActionMap = {};
var $61f525521022d020$var$dataProcessorFuncs = [];
var $61f525521022d020$var$optionPreprocessorFuncs = [];
var $61f525521022d020$var$visualFuncs = [];
var $61f525521022d020$var$themeStorage = {};
var $61f525521022d020$var$loadingEffects = {};
var $61f525521022d020$var$instances = {};
var $61f525521022d020$var$connectedGroups = {};
var $61f525521022d020$var$idBase = +new Date() - 0;
var $61f525521022d020$var$groupIdBase = +new Date() - 0;
var $61f525521022d020$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $61f525521022d020$export$2cd8252107eb640b(dom, theme, opts) {
    var existInstance = $61f525521022d020$export$33b6fbccd4f643f8(dom);
    if (existInstance) return existInstance;
    var chart = new $61f525521022d020$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $61f525521022d020$var$idBase++;
    $61f525521022d020$var$instances[chart.id] = chart;
    $eaKsF.setAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY, chart.id);
    $61f525521022d020$var$enableConnect(chart);
    (0, $8cCW2.default).trigger('afterinit', chart);
    return chart;
}
function $61f525521022d020$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $bahqM.isArray)(groupId)) {
        var charts = groupId;
        groupId = null; // If any chart has group
        (0, $bahqM.each)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $61f525521022d020$var$groupIdBase++;
        (0, $bahqM.each)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $61f525521022d020$var$connectedGroups[groupId] = true;
    return groupId;
}
function $61f525521022d020$export$87cd6834112ecb52(groupId) {
    $61f525521022d020$var$connectedGroups[groupId] = false;
}
var $61f525521022d020$export$37dfea93db2e14ed = $61f525521022d020$export$87cd6834112ecb52;
function $61f525521022d020$export$fcfbbcec2cb820d5(chart) {
    if (typeof chart === 'string') chart = $61f525521022d020$var$instances[chart];
    else if (!(chart instanceof $61f525521022d020$var$ECharts)) // Try to treat as dom
    chart = $61f525521022d020$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $61f525521022d020$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $61f525521022d020$export$33b6fbccd4f643f8(dom) {
    return $61f525521022d020$var$instances[$eaKsF.getAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY)];
}
function $61f525521022d020$export$89b4be35062c4a3f(key) {
    return $61f525521022d020$var$instances[key];
}
function $61f525521022d020$export$f9c59eed5de5ff80(name, theme) {
    $61f525521022d020$var$themeStorage[name] = theme;
}
function $61f525521022d020$export$77095792a057b768(preprocessorFunc) {
    if ((0, $bahqM.indexOf)($61f525521022d020$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $61f525521022d020$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $61f525521022d020$export$d575e6557ac1729f(priority, processor) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$dataProcessorFuncs, priority, processor, $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $61f525521022d020$export$c8c249911ee8c1ed(postInitFunc) {
    $61f525521022d020$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $61f525521022d020$export$99560909c18c76bb(postUpdateFunc) {
    $61f525521022d020$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $61f525521022d020$export$c9ec4b5faef04865(name, cb) {
    (0, $8cCW2.default).on(name, cb);
}
function $61f525521022d020$export$408c24786cd729c6(actionInfo, eventName, action) {
    if (typeof eventName === 'function') {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $bahqM.isObject)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0]; // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($61f525521022d020$var$eventActionMap[eventName]) // Already registered.
    return;
     // Validate action type and event name.
    (0, $bahqM.assert)($61f525521022d020$var$ACTION_REG.test(actionType) && $61f525521022d020$var$ACTION_REG.test(eventName));
    if (!$61f525521022d020$var$actions[actionType]) $61f525521022d020$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $61f525521022d020$var$eventActionMap[eventName] = actionType;
}
function $61f525521022d020$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $gyhNQ.default).register(type, coordSysCreator);
}
function $61f525521022d020$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $gyhNQ.default).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $61f525521022d020$export$d768f97700ca6bea(priority, layoutTask) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, layoutTask, $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $61f525521022d020$export$5f32c1eb94c381bb(priority, visualTask) {
    $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, visualTask, $61f525521022d020$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $61f525521022d020$var$registeredTasks = [];
function $61f525521022d020$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $bahqM.isFunction)(priority) || (0, $bahqM.isObject)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    if ((0, $bahqM.indexOf)($61f525521022d020$var$registeredTasks, fn) >= 0) return;
    $61f525521022d020$var$registeredTasks.push(fn);
    var stageHandler = (0, $14WFd.default).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $61f525521022d020$export$e06b68a82007c015(name, loadingFx) {
    $61f525521022d020$var$loadingEffects[name] = loadingFx;
}
function $61f525521022d020$export$10425ea7a243b114(creator) {
    (0, $bahqM.$override)('createCanvas', creator);
}
function $61f525521022d020$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    (0, $fEzwg.default).registerMap(mapName, geoJson, specialAreas);
}
function $61f525521022d020$export$b8586192aead8a7e(mapName) {
    return (0, $fEzwg.default).getMapForUser(mapName);
}
var $61f525521022d020$export$f01d71dd0389d7e4 = (0, $05ab4.registerExternalTransform);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Buitlin global visual
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, $cvEVp.seriesStyleTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $cvEVp.dataStyleTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $cvEVp.dataColorPaletteTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, $7wiHx.seriesSymbolTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $7wiHx.dataSymbolTask));
$61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_DECAL, (0, $g2DhS.default));
$61f525521022d020$export$77095792a057b768((0, $driCQ.default));
$61f525521022d020$export$d575e6557ac1729f($61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK, (0, $iMppY.default));
$61f525521022d020$export$e06b68a82007c015('default', (0, $4G956.default)); // Default actions
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE),
    event: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE),
    update: (0, $fIXXx.HIGHLIGHT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.DOWNPLAY_ACTION_TYPE),
    event: (0, $fIXXx.DOWNPLAY_ACTION_TYPE),
    update: (0, $fIXXx.DOWNPLAY_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.SELECT_ACTION_TYPE),
    event: (0, $fIXXx.SELECT_ACTION_TYPE),
    update: (0, $fIXXx.SELECT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.UNSELECT_ACTION_TYPE),
    event: (0, $fIXXx.UNSELECT_ACTION_TYPE),
    update: (0, $fIXXx.UNSELECT_ACTION_TYPE)
}, (0, $bahqM.noop));
$61f525521022d020$export$408c24786cd729c6({
    type: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE),
    event: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE),
    update: (0, $fIXXx.TOGGLE_SELECT_ACTION_TYPE)
}, (0, $bahqM.noop)); // Default theme
$61f525521022d020$export$f9c59eed5de5ff80('light', (0, $31FQc.default));
$61f525521022d020$export$f9c59eed5de5ff80('dark', (0, $dMJCs.default)); // For backward compatibility, where the namespace `dataTool` will
var $61f525521022d020$export$73cae5e090579589 = {};

});
parcelRegister("9Y5KT", function(module, exports) {

$parcel$export(module.exports, "init", () => $741e2e865750343c$export$2cd8252107eb640b);
$parcel$export(module.exports, "dispose", () => $741e2e865750343c$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "disposeAll", () => $741e2e865750343c$export$825f692fb04800ef);
$parcel$export(module.exports, "getInstance", () => $741e2e865750343c$export$8bedcca5bbd73999);
$parcel$export(module.exports, "registerPainter", () => $741e2e865750343c$export$a3e793ccb11823a5);
$parcel$export(module.exports, "version", () => $741e2e865750343c$export$83d89fbfd8236492);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $hZfwb = parcelRequire("hZfwb");

var $bahqM = parcelRequire("bahqM");

var $jaJTK = parcelRequire("jaJTK");

var $66sfA = parcelRequire("66sfA");

var $F44Dl = parcelRequire("F44Dl");

var $bHSYT = parcelRequire("bHSYT");

var $d6udH = parcelRequire("d6udH");

var $7y1my = parcelRequire("7y1my");

var $4KVOr = parcelRequire("4KVOr");
var $741e2e865750343c$var$useVML = !(0, $hZfwb.default).canvasSupported;
var $741e2e865750343c$var$painterCtors = {};
var $741e2e865750343c$var$instances = {};
function $741e2e865750343c$var$delInstance(id) {
    delete $741e2e865750343c$var$instances[id];
}
function $741e2e865750343c$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $d6udH.lum)(backgroundColor, 1) < (0, $7y1my.DARK_MODE_THRESHOLD);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $d6udH.lum)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $7y1my.DARK_MODE_THRESHOLD);
    }
    return false;
}
var $741e2e865750343c$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $66sfA.default)();
        var rendererType = opts.renderer || 'canvas';
        if ($741e2e865750343c$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
        if (!$741e2e865750343c$var$painterCtors[rendererType]) rendererType = $bahqM.keys($741e2e865750343c$var$painterCtors)[0];
        if (!$741e2e865750343c$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $741e2e865750343c$var$painterCtors[rendererType](dom, storage, opts, id);
        this.storage = storage;
        this.painter = painter;
        var handerProxy = !(0, $hZfwb.default).node && !(0, $hZfwb.default).worker ? new (0, $bHSYT.default)(painter.getViewportRoot(), painter.root) : null;
        this.handler = new (0, $jaJTK.default)(storage, painter, handerProxy, painter.root);
        this.animation = new (0, $F44Dl.default)({
            stage: {
                update: function() {
                    return _this._flush(true);
                }
            }
        });
        this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (!el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (!el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $741e2e865750343c$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = new Date().getTime();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = new Date().getTime();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.addHover = function(el) {};
    ZRender.prototype.removeHover = function(el) {};
    ZRender.prototype.clearHover = function() {};
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        return this.painter.getHeight();
    };
    ZRender.prototype.pathToImage = function(e, dpr) {
        if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $4KVOr.default)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        $741e2e865750343c$var$delInstance(this.id);
    };
    return ZRender;
}();
function $741e2e865750343c$export$2cd8252107eb640b(dom, opts) {
    var zr = new $741e2e865750343c$var$ZRender($bahqM.guid(), dom, opts);
    $741e2e865750343c$var$instances[zr.id] = zr;
    return zr;
}
function $741e2e865750343c$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $741e2e865750343c$export$825f692fb04800ef() {
    for(var key in $741e2e865750343c$var$instances)if ($741e2e865750343c$var$instances.hasOwnProperty(key)) $741e2e865750343c$var$instances[key].dispose();
    $741e2e865750343c$var$instances = {};
}
function $741e2e865750343c$export$8bedcca5bbd73999(id) {
    return $741e2e865750343c$var$instances[id];
}
function $741e2e865750343c$export$a3e793ccb11823a5(name, Ctor) {
    $741e2e865750343c$var$painterCtors[name] = Ctor;
}
var $741e2e865750343c$export$83d89fbfd8236492 = '5.2.1';

});
parcelRegister("jaJTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $df528de50090e0a1$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eLEew = parcelRequire("eLEew");

var $8qDpt = parcelRequire("8qDpt");

var $bRKv5 = parcelRequire("bRKv5");

var $65X4x = parcelRequire("65X4x");

var $jYjcX = parcelRequire("jYjcX");
var $df528de50090e0a1$var$SILENT = 'silent';
function $df528de50090e0a1$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $df528de50090e0a1$var$stopEvent
    };
}
function $df528de50090e0a1$var$stopEvent() {
    $65X4x.stop(this.event);
}
var $df528de50090e0a1$var$EmptyProxy = function(_super) {
    (0, $3VFsf.__extends)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $bRKv5.default));
var $df528de50090e0a1$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $df528de50090e0a1$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $df528de50090e0a1$var$Handler = function(_super) {
    (0, $3VFsf.__extends)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot) {
        var _this = _super.call(this) || this;
        _this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        proxy = proxy || new $df528de50090e0a1$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $8qDpt.default)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $bahqM.each($df528de50090e0a1$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $df528de50090e0a1$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $df528de50090e0a1$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $df528de50090e0a1$var$HoveredResult(x, y);
        for(var i = list.length - 1; i >= 0; i--){
            var hoverCheckResult = void 0;
            if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $df528de50090e0a1$var$isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== $df528de50090e0a1$var$SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $jYjcX.GestureMgr)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $df528de50090e0a1$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $bRKv5.default));
$bahqM.each([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $df528de50090e0a1$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $eLEew.dist(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $df528de50090e0a1$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
                if (el.silent) isSilent = true;
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $df528de50090e0a1$var$SILENT : true;
    }
    return false;
}
function $df528de50090e0a1$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $df528de50090e0a1$export$2e2bcd8739ae039 = $df528de50090e0a1$var$Handler;

});
parcelRegister("8qDpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $622f526eb8ccffa3$export$2e2bcd8739ae039);
var $622f526eb8ccffa3$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $622f526eb8ccffa3$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $622f526eb8ccffa3$export$2e2bcd8739ae039 = $622f526eb8ccffa3$var$Draggable;

});

parcelRegister("65X4x", function(module, exports) {

$parcel$export(module.exports, "clientToLocal", () => $47010835ddffd941$export$7d5fecde839eee88);
$parcel$export(module.exports, "getNativeEvent", () => $47010835ddffd941$export$4abe0e945399ac1d);
$parcel$export(module.exports, "normalizeEvent", () => $47010835ddffd941$export$40fadb093aebad71);
$parcel$export(module.exports, "addEventListener", () => $47010835ddffd941$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $47010835ddffd941$export$8ff9f68337b520c0);
$parcel$export(module.exports, "stop", () => $47010835ddffd941$export$fa6813432f753b0d);
$parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", () => $47010835ddffd941$export$b7ae4cded3e71bd2);


var $hZfwb = parcelRequire("hZfwb");

var $6AZf6 = parcelRequire("6AZf6");
var $47010835ddffd941$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var $47010835ddffd941$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $47010835ddffd941$var$_calcOut = [];
function $47010835ddffd941$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate || !(0, $hZfwb.default).canvasSupported) $47010835ddffd941$var$calculateZrXY(el, e, out);
    else if ((0, $hZfwb.default).browser.firefox && (0, $hZfwb.default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $47010835ddffd941$var$calculateZrXY(el, e, out);
    return out;
}
function $47010835ddffd941$var$calculateZrXY(el, e, out) {
    if ((0, $hZfwb.default).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $6AZf6.isCanvasEl)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $6AZf6.transformCoordWithViewport)($47010835ddffd941$var$_calcOut, el, ex, ey)) {
            out.zrX = $47010835ddffd941$var$_calcOut[0];
            out.zrY = $47010835ddffd941$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $47010835ddffd941$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $47010835ddffd941$export$40fadb093aebad71(el, e, calculate) {
    e = $47010835ddffd941$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $47010835ddffd941$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $47010835ddffd941$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $47010835ddffd941$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $47010835ddffd941$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $47010835ddffd941$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $47010835ddffd941$export$3f65cefe8380dbea(el, name, handler, opt) {
    if ($47010835ddffd941$var$isDomLevel2) el.addEventListener(name, handler, opt);
    else el.attachEvent('on' + name, handler);
}
function $47010835ddffd941$export$8ff9f68337b520c0(el, name, handler, opt) {
    if ($47010835ddffd941$var$isDomLevel2) el.removeEventListener(name, handler, opt);
    else el.detachEvent('on' + name, handler);
}
var $47010835ddffd941$export$fa6813432f753b0d = $47010835ddffd941$var$isDomLevel2 ? function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
} : function(e) {
    e.returnValue = false;
    e.cancelBubble = true;
};
function $47010835ddffd941$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}
function $47010835ddffd941$export$a564e1c0090572c3(e) {
    return e.which > 1;
}

});
parcelRegister("6AZf6", function(module, exports) {

$parcel$export(module.exports, "transformLocalCoord", () => $4cd59c60322a6a09$export$8c5c02e118307e20);
$parcel$export(module.exports, "transformCoordWithViewport", () => $4cd59c60322a6a09$export$1219648acc517df4);
$parcel$export(module.exports, "isCanvasEl", () => $4cd59c60322a6a09$export$1b92e4fe606eff6d);

var $hZfwb = parcelRequire("hZfwb");

var $8QVDM = parcelRequire("8QVDM");
var $4cd59c60322a6a09$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $4cd59c60322a6a09$var$_calcOut = [];
function $4cd59c60322a6a09$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $4cd59c60322a6a09$export$1219648acc517df4($4cd59c60322a6a09$var$_calcOut, elFrom, inX, inY, true) && $4cd59c60322a6a09$export$1219648acc517df4(out, elTarget, $4cd59c60322a6a09$var$_calcOut[0], $4cd59c60322a6a09$var$_calcOut[1]);
}
function $4cd59c60322a6a09$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $hZfwb.default).domSupported && !$4cd59c60322a6a09$export$1b92e4fe606eff6d(el)) {
        var saved = el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] || (el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] = {});
        var markers = $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved);
        var transformer = $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $8QVDM.buildTransformer)(destCoords, srcCoords) : (0, $8QVDM.buildTransformer)(srcCoords, destCoords));
}
function $4cd59c60322a6a09$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}

});
parcelRegister("8QVDM", function(module, exports) {

$parcel$export(module.exports, "buildTransformer", () => $671fe44ca8a82f31$export$fbdb2748a8171a7e);
var $671fe44ca8a82f31$var$LN2 = Math.log(2);
function $671fe44ca8a82f31$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $671fe44ca8a82f31$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $671fe44ca8a82f31$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $671fe44ca8a82f31$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $671fe44ca8a82f31$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $671fe44ca8a82f31$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

});



parcelRegister("jYjcX", function(module, exports) {

$parcel$export(module.exports, "GestureMgr", () => $e8a28537c27906ba$export$f7557d6f27e9503);

var $65X4x = parcelRequire("65X4x");
var $e8a28537c27906ba$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $65X4x.clientToLocal(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $e8a28537c27906ba$var$recognizers)if ($e8a28537c27906ba$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $e8a28537c27906ba$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $e8a28537c27906ba$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $e8a28537c27906ba$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $e8a28537c27906ba$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $e8a28537c27906ba$var$dist(pinchEnd) / $e8a28537c27906ba$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $e8a28537c27906ba$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

});


parcelRegister("66sfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4719378990e09024$export$2e2bcd8739ae039);

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $aVBu2 = parcelRequire("aVBu2");

var $aVawM = parcelRequire("aVawM");
var $4719378990e09024$var$invalidZErrorLogged = false;
function $4719378990e09024$var$logInvalidZError() {
    if ($4719378990e09024$var$invalidZErrorLogged) return;
    $4719378990e09024$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $4719378990e09024$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $4719378990e09024$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $4719378990e09024$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $hZfwb.default).canvasSupported && (0, $aVBu2.default)(displayList, $4719378990e09024$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $aVawM.REDRAW_BIT);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $4719378990e09024$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $4719378990e09024$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $4719378990e09024$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $bahqM.indexOf(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $4719378990e09024$export$2e2bcd8739ae039 = $4719378990e09024$var$Storage;

});
parcelRegister("aVBu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4c4daf73fbe3de$export$2e2bcd8739ae039);
var $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE = 32;
var $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING = 7;
var $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
function $7f4c4daf73fbe3de$var$minRunLength(n) {
    var r = 0;
    while(n >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $7f4c4daf73fbe3de$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $7f4c4daf73fbe3de$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $7f4c4daf73fbe3de$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $7f4c4daf73fbe3de$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $7f4c4daf73fbe3de$var$TimSort(array, compare) {
    var minGallop = $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $7f4c4daf73fbe3de$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $7f4c4daf73fbe3de$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $7f4c4daf73fbe3de$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $7f4c4daf73fbe3de$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $7f4c4daf73fbe3de$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $7f4c4daf73fbe3de$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $7f4c4daf73fbe3de$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE) {
        runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
        $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $7f4c4daf73fbe3de$var$TimSort(array, compare);
    var minRun = $7f4c4daf73fbe3de$var$minRunLength(remaining);
    do {
        runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}

});


parcelRegister("F44Dl", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b6fd689a4caf84$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bRKv5 = parcelRequire("bRKv5");

var $04xko = parcelRequire("04xko");

var $hb2y5 = parcelRequire("hb2y5");
var $07b6fd689a4caf84$var$Animation = function(_super) {
    (0, $3VFsf.__extends)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        _this.onframe = opts.onframe || function() {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
        else {
            this._clipsTail.next = clip;
            clip.prev = this._clipsTail;
            clip.next = null;
            this._clipsTail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._clipsHead = next;
        if (next) next.prev = prev;
        else this._clipsTail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = new Date().getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy && clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.onframe(delta);
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $04xko.default)(step);
                !self._paused && self.update();
            }
        }
        (0, $04xko.default)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = new Date().getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = new Date().getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += new Date().getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._clipsHead = this._clipsTail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._clipsHead == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $hb2y5.default)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $bRKv5.default));
var $07b6fd689a4caf84$export$2e2bcd8739ae039 = $07b6fd689a4caf84$var$Animation;

});
parcelRegister("04xko", function(module, exports) {

$parcel$export(module.exports, "default", () => $00da3a149d316342$export$2e2bcd8739ae039);
var $00da3a149d316342$var$requestAnimationFrame;
$00da3a149d316342$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $00da3a149d316342$export$2e2bcd8739ae039 = $00da3a149d316342$var$requestAnimationFrame;

});


parcelRegister("bHSYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $885e5bfc09439923$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $65X4x = parcelRequire("65X4x");

var $bahqM = parcelRequire("bahqM");

var $bRKv5 = parcelRequire("bRKv5");

var $hZfwb = parcelRequire("hZfwb");
var $885e5bfc09439923$var$TOUCH_CLICK_DELAY = 300;
var $885e5bfc09439923$var$globalEventSupported = (0, $hZfwb.default).domSupported;
var $885e5bfc09439923$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $bahqM.map(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $885e5bfc09439923$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $885e5bfc09439923$var$wheelEventSupported = false;
function $885e5bfc09439923$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $885e5bfc09439923$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $885e5bfc09439923$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $885e5bfc09439923$var$normalizeGlobalEvent(instance, event) {
    return (0, $65X4x.normalizeEvent)(instance.dom, new $885e5bfc09439923$var$FakeGlobalEvent(instance, event), true);
}
function $885e5bfc09439923$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $885e5bfc09439923$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $bahqM.noop;
        this.stopImmediatePropagation = $bahqM.noop;
        this.preventDefault = $bahqM.noop;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $885e5bfc09439923$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$885e5bfc09439923$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $885e5bfc09439923$var$wheelEventSupported = true;
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($885e5bfc09439923$var$wheelEventSupported) return;
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        $885e5bfc09439923$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $885e5bfc09439923$var$TOUCH_CLICK_DELAY) $885e5bfc09439923$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$bahqM.each([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $885e5bfc09439923$var$localDOMHandlers[name] = function(event) {
        event = (0, $65X4x.normalizeEvent)(this.dom, event);
        this.trigger(name, event);
    };
});
var $885e5bfc09439923$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $885e5bfc09439923$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $885e5bfc09439923$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $hZfwb.default).pointerEventsSupported) $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $hZfwb.default).touchEventsSupported) $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.touch, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $885e5bfc09439923$var$setTouchTimer(scope);
            });
        });
        $bahqM.each($885e5bfc09439923$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $65X4x.getNativeEvent)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $885e5bfc09439923$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $hZfwb.default).pointerEventsSupported) $bahqM.each($885e5bfc09439923$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $hZfwb.default).touchEventsSupported) $bahqM.each($885e5bfc09439923$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $65X4x.getNativeEvent)(event);
            if (!$885e5bfc09439923$var$isLocalEl(instance, event.target)) {
                event = $885e5bfc09439923$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $65X4x.addEventListener)(scope.domTarget, nativeEventName, listener, opt);
}
function $885e5bfc09439923$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $65X4x.removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $885e5bfc09439923$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $885e5bfc09439923$var$HandlerDomProxy = function(_super) {
    (0, $3VFsf.__extends)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(dom, $885e5bfc09439923$var$localDOMHandlers);
        if ($885e5bfc09439923$var$globalEventSupported) _this._globalHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(document, $885e5bfc09439923$var$globalDOMHandlers);
        $885e5bfc09439923$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $885e5bfc09439923$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($885e5bfc09439923$var$globalEventSupported) $885e5bfc09439923$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($885e5bfc09439923$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $885e5bfc09439923$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $885e5bfc09439923$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $bRKv5.default));
var $885e5bfc09439923$export$2e2bcd8739ae039 = $885e5bfc09439923$var$HandlerDomProxy;

});


parcelRegister("74g78", function(module, exports) {

$parcel$export(module.exports, "default", () => $525568051e570380$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $gaMkj = parcelRequire("gaMkj");

var $h4UlH = parcelRequire("h4UlH");

var $34Vzq = parcelRequire("34Vzq");

var $cNGs8 = parcelRequire("cNGs8");

var $iSVvO = parcelRequire("iSVvO");

var $aCu4v = parcelRequire("aCu4v");

var $2cFRc = parcelRequire("2cFRc");
// Internal method names:
// -----------------------
var $525568051e570380$var$reCreateSeriesIndices;
var $525568051e570380$var$assertSeriesInitialized;
var $525568051e570380$var$initBase;
var $525568051e570380$var$OPTION_INNER_KEY = '\0_ec_inner';
var $525568051e570380$var$OPTION_INNER_VALUE = 1;
var $525568051e570380$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $525568051e570380$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $525568051e570380$var$componetsMissingLogPrinted = {};
function $525568051e570380$var$checkMissingComponents(option) {
    (0, $bahqM.each)(option, function(componentOption, mainType) {
        if (!(0, $h4UlH.default).hasClass(mainType)) {
            var componentImportName = $525568051e570380$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$525568051e570380$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $2cFRc.error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $525568051e570380$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $525568051e570380$var$GlobalModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $gaMkj.default)(theme);
        this._locale = new (0, $gaMkj.default)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $525568051e570380$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $525568051e570380$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $525568051e570380$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
         // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Becuase either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $bahqM.each)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $bahqM.createHashMap)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $cNGs8.resetSourceDefaulter)(this); // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $bahqM.each)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $h4UlH.default).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $bahqM.clone)(componentOption) : (0, $bahqM.merge)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $h4UlH.default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $h4UlH.default).topologicalTravel(newCmptTypes, (0, $h4UlH.default).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $iSVvO.concatInternalOptions)(this, mainType, $eaKsF.normalizeToArray(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $eaKsF.mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.
            $eaKsF.setComponentTypeToKeyInfo(mappingResult, mainType, (0, $h4UlH.default)); // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            (0, $bahqM.each)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    } // If no both `resultItem.exist` and `resultItem.option`,
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $h4UlH.default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $bahqM.extend)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`
                        (0, $bahqM.extend)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.
            if (mainType === 'series') $525568051e570380$var$reCreateSeriesIndices(this);
        } // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $525568051e570380$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $bahqM.clone)(this.option);
        (0, $bahqM.each)(option, function(optInMainType, mainType) {
            if ((0, $h4UlH.default).hasClass(mainType)) {
                var opts = $eaKsF.normalizeToArray(optInMainType); // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$eaKsF.isComponentIdInternal(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$525568051e570380$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $bahqM.each)($eaKsF.normalizeToArray(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $525568051e570380$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $525568051e570380$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $bahqM.filter)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $525568051e570380$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
         : (0, $bahqM.filter)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($525568051e570380$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $bahqM.filter)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $bahqM.isFunction)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $bahqM.isString)(mainType) ? componentsMap.get(mainType) : (0, $bahqM.isObject)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $eaKsF.convertOptionIdName(name, null);
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $bahqM.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * frome raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        (0, $bahqM.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $bahqM.each)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * frome raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        (0, $bahqM.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $bahqM.each)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $525568051e570380$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $525568051e570380$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $bahqM.each)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $bahqM.createHashMap)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $525568051e570380$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $h4UlH.default).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $h4UlH.default).topologicalTravel(componentTypes, (0, $h4UlH.default).getAllClassMainTypes(), function(componentType) {
            (0, $bahqM.each)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$525568051e570380$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $525568051e570380$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $bahqM.each)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $bahqM.createHashMap)(seriesIndices);
        };
        $525568051e570380$var$assertSeriesInitialized = function(ecModel) {};
        $525568051e570380$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option can not be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
            ecModel.option = {};
            ecModel.option[$525568051e570380$var$OPTION_INNER_KEY] = $525568051e570380$var$OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $bahqM.createHashMap)({
                series: []
            });
            ecModel._componentsCount = (0, $bahqM.createHashMap)(); // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $bahqM.isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $525568051e570380$var$mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property
            (0, $bahqM.merge)(baseOption, (0, $34Vzq.default), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $gaMkj.default));
function $525568051e570380$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $525568051e570380$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $bahqM.each)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
         // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $h4UlH.default).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $bahqM.clone)(themeItem) : (0, $bahqM.merge)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $525568051e570380$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $bahqM.isArray)(idOrName)) {
        var keyMap_1 = (0, $bahqM.createHashMap)();
        (0, $bahqM.each)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $eaKsF.convertOptionIdName(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $bahqM.filter)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $eaKsF.convertOptionIdName(idOrName, null);
        return (0, $bahqM.filter)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $525568051e570380$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $bahqM.filter)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $525568051e570380$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $bahqM.createHashMap)();
    opts && (0, $bahqM.each)($eaKsF.normalizeToArray(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $bahqM.mixin)($525568051e570380$var$GlobalModel, (0, $aCu4v.PaletteMixin));
var $525568051e570380$export$2e2bcd8739ae039 = $525568051e570380$var$GlobalModel;

});
parcelRegister("34Vzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $23de6718d94f8f53$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $23de6718d94f8f53$var$platform = ''; // Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $23de6718d94f8f53$var$platform = navigator.platform || '';
var $23de6718d94f8f53$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $23de6718d94f8f53$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $23de6718d94f8f53$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $23de6718d94f8f53$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};

});

parcelRegister("iSVvO", function(module, exports) {

$parcel$export(module.exports, "registerInternalOptionCreator", () => $dbf9e1d336044ced$export$5a90be4668898d38);
$parcel$export(module.exports, "concatInternalOptions", () => $dbf9e1d336044ced$export$c713a6a3b43f401d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $dbf9e1d336044ced$var$internalOptionCreatorMap = (0, $bahqM.createHashMap)();
function $dbf9e1d336044ced$export$5a90be4668898d38(mainType, creator) {
    (0, $bahqM.assert)($dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $dbf9e1d336044ced$var$internalOptionCreatorMap.set(mainType, creator);
}
function $dbf9e1d336044ced$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}

});


parcelRegister("iEvqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9445617d131115d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $d9445617d131115d$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    'getOption',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $d9445617d131115d$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $bahqM.each($d9445617d131115d$var$availableMethods, function(methodName) {
            this[methodName] = $bahqM.bind(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $d9445617d131115d$export$2e2bcd8739ae039 = $d9445617d131115d$var$ExtensionAPI;

});

parcelRegister("6LzFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed2ccc95e9b6d0d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $4ed2ccc95e9b6d0d$var$QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $4ed2ccc95e9b6d0d$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $bahqM.each)((0, $eaKsF.normalizeToArray)(rawOption.series), function(series) {
                series && series.data && (0, $bahqM.isTypedArray)(series.data) && (0, $bahqM.setAsPrimitive)(series.data);
            });
            (0, $bahqM.each)((0, $eaKsF.normalizeToArray)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $bahqM.isTypedArray)(dataset.source) && (0, $bahqM.setAsPrimitive)(dataset.source);
            });
        } // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $bahqM.clone)(rawOption); // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, becuase in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline opitons will not be merged to the formers, but just substitude them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $bahqM.clone)(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
         ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $bahqM.clone)(timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = []; // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
         // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($4ed2ccc95e9b6d0d$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
         // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$4ed2ccc95e9b6d0d$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $bahqM.map)(indices, function(index) {
            return (0, $bahqM.clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
         // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption; // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $bahqM.isArray)(mediaOnRoot)) (0, $bahqM.each)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $bahqM.each)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $bahqM.each)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $bahqM.each)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $4ed2ccc95e9b6d0d$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lowser case for convenientce.
    };
    var applicatable = true;
    (0, $bahqM.each)(query, function(value, attr) {
        var matched = attr.match($4ed2ccc95e9b6d0d$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$4ed2ccc95e9b6d0d$var$compare(realMap[realAttr], value, operator)) applicatable = false;
    });
    return applicatable;
}
function $4ed2ccc95e9b6d0d$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $4ed2ccc95e9b6d0d$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$4ed2ccc95e9b6d0d$export$2e2bcd8739ae039 = $4ed2ccc95e9b6d0d$var$OptionManager;

});

parcelRegister("driCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8c3e9bb43407b9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $9rY8k = parcelRequire("9rY8k");

var $eaKsF = parcelRequire("eaKsF");

function $9c8c3e9bb43407b9$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $9c8c3e9bb43407b9$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $9c8c3e9bb43407b9$var$compatLayoutProperties(option) {
    option && (0, $bahqM.each)($9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $9c8c3e9bb43407b9$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $9c8c3e9bb43407b9$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $9c8c3e9bb43407b9$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $9c8c3e9bb43407b9$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $9c8c3e9bb43407b9$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $9c8c3e9bb43407b9$var$traverseTree(data[i].children, cb);
    }
}
function $9c8c3e9bb43407b9$export$2e2bcd8739ae039(option, isTheme) {
    (0, $9rY8k.default)(option, isTheme); // Make sure series array for model initialization.
    option.series = (0, $eaKsF.normalizeToArray)(option.series);
    (0, $bahqM.each)(option.series, function(seriesOpt) {
        if (!(0, $bahqM.isObject)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $9c8c3e9bb43407b9$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $bahqM.isTypedArray)(data)) for(var i = 0; i < data.length; i++)$9c8c3e9bb43407b9$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $9c8c3e9bb43407b9$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $9c8c3e9bb43407b9$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt);
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $bahqM.isTypedArray)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i]);
                    $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $9c8c3e9bb43407b9$var$compatSunburstState(seriesOpt);
            $9c8c3e9bb43407b9$var$traverseTree(seriesOpt.data, $9c8c3e9bb43407b9$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $9c8c3e9bb43407b9$var$compatGraphFocus(seriesOpt); // TODO nodes, edges?
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $bahqM.defaults)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $9c8c3e9bb43407b9$var$compatLayoutProperties(seriesOpt);
    }); // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $bahqM.each)($9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $bahqM.isArray)(options)) options = [
                options
            ];
            (0, $bahqM.each)(options, function(option) {
                $9c8c3e9bb43407b9$var$compatLayoutProperties(option);
            });
        }
    });
}

});
parcelRegister("9rY8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e1547e334933782$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $6e1547e334933782$var$each = $bahqM.each;
var $6e1547e334933782$var$isObject = $bahqM.isObject;
var $6e1547e334933782$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $6e1547e334933782$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $6e1547e334933782$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $6e1547e334933782$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $bahqM.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $bahqM.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $6e1547e334933782$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $bahqM.defaults(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $6e1547e334933782$var$removeEC3NormalStatus(opt) {
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'itemStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'lineStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'areaStyle');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'label');
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'labelLine'); // treemap
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'upperLabel'); // graph
    $6e1547e334933782$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $6e1547e334933782$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $6e1547e334933782$var$isObject(opt) && opt[propName];
    var textStyle = $6e1547e334933782$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $eaKsF.TEXT_STYLE_OPTIONS.length; i < len; i++){
        var textPropName = $eaKsF.TEXT_STYLE_OPTIONS[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $6e1547e334933782$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $6e1547e334933782$var$removeEC3NormalStatus(opt);
        $6e1547e334933782$var$compatTextStyle(opt, 'label');
        opt.emphasis && $6e1547e334933782$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $6e1547e334933782$var$processSeries(seriesOpt) {
    if (!$6e1547e334933782$var$isObject(seriesOpt)) return;
    $6e1547e334933782$var$compatEC2ItemStyle(seriesOpt);
    $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt);
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'label'); // treemap
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'upperLabel'); // graph
    $6e1547e334933782$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
        $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $6e1547e334933782$var$compatEC2ItemStyle(markPoint);
        $6e1547e334933782$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $6e1547e334933782$var$compatEC2ItemStyle(markLine);
        $6e1547e334933782$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $6e1547e334933782$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$bahqM.isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(edgeData[i]);
        $bahqM.each(seriesOpt.categories, function(opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$bahqM.isTypedArray(data)) for(var i = 0; i < data.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(data[i]);
     // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(mpData[i]);
    } // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($bahqM.isArray(mlData[i])) {
            $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][0]);
            $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][1]);
        } else $6e1547e334933782$var$compatEC3CommonStyles(mlData[i]);
    } // Series
    if (seriesOpt.type === 'gauge') {
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'axisLabel');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'title');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $6e1547e334933782$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $bahqM.each(seriesOpt.levels, function(opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt.leaves);
     // sunburst starts from ec4, so it does not need to compat levels.
}
function $6e1547e334933782$var$toArr(o) {
    return $bahqM.isArray(o) ? o : o ? [
        o
    ] : [];
}
function $6e1547e334933782$var$toObj(o) {
    return ($bahqM.isArray(o) ? o[0] : o) || {};
}
function $6e1547e334933782$export$2e2bcd8739ae039(option, isTheme) {
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.series), function(seriesOpt) {
        $6e1547e334933782$var$isObject(seriesOpt) && $6e1547e334933782$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $6e1547e334933782$var$each(axes, function(axisName) {
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $6e1547e334933782$var$compatTextStyle(axisOpt, 'axisLabel');
                $6e1547e334933782$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $6e1547e334933782$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $6e1547e334933782$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.calendar), function(calendarOpt) {
        $6e1547e334933782$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'dayLabel');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'monthLabel');
        $6e1547e334933782$var$compatTextStyle(calendarOpt, 'yearLabel');
    }); // radar.name.textStyle
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.radar), function(radarOpt) {
        $6e1547e334933782$var$compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.geo), function(geoOpt) {
        if ($6e1547e334933782$var$isObject(geoOpt)) {
            $6e1547e334933782$var$compatEC3CommonStyles(geoOpt);
            $6e1547e334933782$var$each($6e1547e334933782$var$toArr(geoOpt.regions), function(regionObj) {
                $6e1547e334933782$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.timeline), function(timelineOpt) {
        $6e1547e334933782$var$compatEC3CommonStyles(timelineOpt);
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'label');
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $bahqM.isArray(data) && $bahqM.each(data, function(item) {
            if ($bahqM.isObject(item)) {
                $6e1547e334933782$var$convertNormalEmphasis(item, 'label');
                $6e1547e334933782$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.toolbox), function(toolboxOpt) {
        $6e1547e334933782$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $6e1547e334933782$var$each(toolboxOpt.feature, function(featureOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.axisPointer), 'label');
    $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.tooltip).axisPointer, 'label'); // Clean logs
// storedLogs = {};
}

});


parcelRegister("iMppY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac06d23d0856818$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");
function $dac06d23d0856818$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $bahqM.createHashMap)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            }; // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($dac06d23d0856818$var$calculateStack);
}
function $dac06d23d0856818$var$calculateStack(stackInfoList) {
    (0, $bahqM.each)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
             // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
                    if (sum >= 0 && val > 0 || // Positive stack
                    sum <= 0 && val < 0 // Negative stack
                    ) {
                        // The sum should be as less as possible to be effected
                        // by floating arithmetic problem. A wrong result probably
                        // filtered incorrectly by axis min/max.
                        sum = (0, $jmSNG.addSafe)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}

});

parcelRegister("fkskt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28eb2e2a247a7d9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");

var $jvo6O = parcelRequire("jvo6O");

var $aLwh0 = parcelRequire("aLwh0");
var $b28eb2e2a247a7d9$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $4KVOr.default)();
        this.uid = $jvo6O.getUID('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
    /**
   * Hook for blur target series.
   * Can be used in marker for blur the markers
   */ ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
    return ComponentView;
}();
$aLwh0.enableClassExtend($b28eb2e2a247a7d9$var$ComponentView);
$aLwh0.enableClassManagement($b28eb2e2a247a7d9$var$ComponentView);
var $b28eb2e2a247a7d9$export$2e2bcd8739ae039 = $b28eb2e2a247a7d9$var$ComponentView;

});

parcelRegister("ljaBy", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $f833992c62ea3b89$export$de363e709c412c8a);
$parcel$export(module.exports, "createOrUpdate", () => $f833992c62ea3b89$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "clear", () => $f833992c62ea3b89$export$42ffd38884aecdac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $f833992c62ea3b89$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $f833992c62ea3b89$var$RATE = '\0__throttleRate';
var $f833992c62ea3b89$var$THROTTLE_TYPE = '\0__throttleType';
function $f833992c62ea3b89$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $f833992c62ea3b89$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$f833992c62ea3b89$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$f833992c62ea3b89$var$THROTTLE_TYPE];
    var lastRate = fn[$f833992c62ea3b89$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $f833992c62ea3b89$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$f833992c62ea3b89$var$ORIGIN_METHOD] = originFn;
        fn[$f833992c62ea3b89$var$THROTTLE_TYPE] = throttleType;
        fn[$f833992c62ea3b89$var$RATE] = rate;
    }
    return fn;
}
function $f833992c62ea3b89$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$f833992c62ea3b89$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$f833992c62ea3b89$var$ORIGIN_METHOD];
}

});

parcelRegister("cvEVp", function(module, exports) {

$parcel$export(module.exports, "seriesStyleTask", () => $91b820231b41a759$export$7ce4d65f9b69240);
$parcel$export(module.exports, "dataStyleTask", () => $91b820231b41a759$export$f7dcb66a065003d1);
$parcel$export(module.exports, "dataColorPaletteTask", () => $91b820231b41a759$export$cf9758b0d6dc0aa9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $1BJbl = parcelRequire("1BJbl");

var $4rldO = parcelRequire("4rldO");

var $46U6E = parcelRequire("46U6E");

var $gaMkj = parcelRequire("gaMkj");

var $eaKsF = parcelRequire("eaKsF");
var $91b820231b41a759$var$inner = (0, $eaKsF.makeInner)();
var $91b820231b41a759$var$defaultStyleMappers = {
    itemStyle: (0, $1BJbl.default)((0, $4rldO.ITEM_STYLE_KEY_MAP), true),
    lineStyle: (0, $1BJbl.default)((0, $46U6E.LINE_STYLE_KEY_MAP), true)
};
var $91b820231b41a759$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $91b820231b41a759$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return $91b820231b41a759$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $91b820231b41a759$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $91b820231b41a759$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        } // TODO
        var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey]; // TODO style callback
        var colorCallback = (0, $bahqM.isFunction)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: if some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Bacause some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $bahqM.extend)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $91b820231b41a759$var$sharedModel = new (0, $gaMkj.default)();
var $91b820231b41a759$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $91b820231b41a759$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($91b820231b41a759$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $bahqM.extend)(existsStyle, style);
                    if ($91b820231b41a759$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $91b820231b41a759$var$sharedModel.option.decal);
                        $91b820231b41a759$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $91b820231b41a759$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series use one scope.
        // Pie and funnel are using diferrent scopes
        var paletteScopeGroupByType = (0, $bahqM.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $91b820231b41a759$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $91b820231b41a759$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            }); // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};

});

parcelRegister("4G956", function(module, exports) {

$parcel$export(module.exports, "default", () => $3682210406d5dc21$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $ixXaU = parcelRequire("ixXaU");
var $7Tw7u = parcelRequire("7Tw7u");
var $4KVOr = parcelRequire("4KVOr");
var $4gEFv = parcelRequire("4gEFv");
var $3682210406d5dc21$var$PI = Math.PI;
function $3682210406d5dc21$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $bahqM.defaults(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $4KVOr.default();
    var mask = new $7Tw7u.default({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $4gEFv.default({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $7Tw7u.default({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $ixXaU.default({
            shape: {
                startAngle: -$3682210406d5dc21$var$PI / 2,
                endAngle: -$3682210406d5dc21$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $3682210406d5dc21$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $3682210406d5dc21$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    } // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2 // only show the text
        ) + (opts.showSpinner ? 0 : textWidth / 2 // only show the spinner
        ) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}

});

parcelRegister("14WFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c93ab8c51628eb2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $92IK1 = parcelRequire("92IK1");

var $jvo6O = parcelRequire("jvo6O");

var $74g78 = parcelRequire("74g78");

var $iEvqc = parcelRequire("iEvqc");

var $eaKsF = parcelRequire("eaKsF");
var $0c93ab8c51628eb2$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $bahqM.createHashMap)();
        this.ecInstance = ecInstance;
        this.api = api; // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    }; // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $bahqM.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $bahqM.each)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $bahqM.assert)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $bahqM.each)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
                // if intending to decalare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because is a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operaions
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $bahqM.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $92IK1.createTask)({
                plan: $0c93ab8c51628eb2$var$seriesTaskPlan,
                reset: $0c93ab8c51628eb2$var$seriesTaskReset,
                count: $0c93ab8c51628eb2$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
         || (0, $92IK1.createTask)({
            reset: $0c93ab8c51628eb2$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $bahqM.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $bahqM.assert)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $bahqM.each)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $92IK1.createTask)({
                reset: $0c93ab8c51628eb2$var$stubReset,
                onDirty: $0c93ab8c51628eb2$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress // FIXME:TS never used, so comment it
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $bahqM.isFunction)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $0c93ab8c51628eb2$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $jvo6O.getUID)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $0c93ab8c51628eb2$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $0c93ab8c51628eb2$var$stubReset(context) {
    return context.overallProgress && $0c93ab8c51628eb2$var$stubProgress;
}
function $0c93ab8c51628eb2$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $0c93ab8c51628eb2$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $0c93ab8c51628eb2$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $0c93ab8c51628eb2$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $eaKsF.normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $bahqM.map)(resetDefines, function(v, idx) {
        return $0c93ab8c51628eb2$var$makeSeriesTaskProgress(idx);
    }) : $0c93ab8c51628eb2$var$singleSeriesTaskProgress;
}
var $0c93ab8c51628eb2$var$singleSeriesTaskProgress = $0c93ab8c51628eb2$var$makeSeriesTaskProgress(0);
function $0c93ab8c51628eb2$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $0c93ab8c51628eb2$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $0c93ab8c51628eb2$var$detectSeriseType(legacyFunc) {
    $0c93ab8c51628eb2$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($0c93ab8c51628eb2$var$ecModelMock, $0c93ab8c51628eb2$var$apiMock);
    } catch (e) {}
    return $0c93ab8c51628eb2$var$seriesType;
}
var $0c93ab8c51628eb2$var$ecModelMock = {};
var $0c93ab8c51628eb2$var$apiMock = {};
var $0c93ab8c51628eb2$var$seriesType;
$0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$ecModelMock, (0, $74g78.default));
$0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$apiMock, (0, $iEvqc.default));
$0c93ab8c51628eb2$var$ecModelMock.eachSeriesByType = $0c93ab8c51628eb2$var$ecModelMock.eachRawSeriesByType = function(type) {
    $0c93ab8c51628eb2$var$seriesType = type;
};
$0c93ab8c51628eb2$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $0c93ab8c51628eb2$var$seriesType = cond.subType;
};
function $0c93ab8c51628eb2$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $bahqM.noop);
/* eslint-enable */ }
var $0c93ab8c51628eb2$export$2e2bcd8739ae039 = $0c93ab8c51628eb2$var$Scheduler;

});

parcelRegister("31FQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2341ebce6d7d92ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2341ebce6d7d92ac$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $2341ebce6d7d92ac$export$2e2bcd8739ae039 = {
    color: $2341ebce6d7d92ac$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $2341ebce6d7d92ac$var$colorAll
    ]
};

});

parcelRegister("dMJCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a093251ea09c66fc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a093251ea09c66fc$var$contrastColor = '#B9B8CE';
var $a093251ea09c66fc$var$backgroundColor = '#100C2A';
var $a093251ea09c66fc$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $a093251ea09c66fc$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $a093251ea09c66fc$var$theme = {
    darkMode: true,
    color: $a093251ea09c66fc$var$colorPalette,
    backgroundColor: $a093251ea09c66fc$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    textStyle: {
        color: $a093251ea09c66fc$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $a093251ea09c66fc$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        label: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        controlStyle: {
            color: $a093251ea09c66fc$var$contrastColor,
            borderColor: $a093251ea09c66fc$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $a093251ea09c66fc$var$backgroundColor
        },
        dayLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        monthLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        yearLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        }
    },
    timeAxis: $a093251ea09c66fc$var$axisCommon(),
    logAxis: $a093251ea09c66fc$var$axisCommon(),
    valueAxis: $a093251ea09c66fc$var$axisCommon(),
    categoryAxis: $a093251ea09c66fc$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $a093251ea09c66fc$var$colorPalette
    },
    gauge: {
        title: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92' // borderColor: '#ca2824',
        }
    }
};
$a093251ea09c66fc$var$theme.categoryAxis.splitLine.show = false;
var $a093251ea09c66fc$export$2e2bcd8739ae039 = $a093251ea09c66fc$var$theme;

});

parcelRegister("cbv5T", function(module, exports) {

$parcel$export(module.exports, "ECEventProcessor", () => $8deea1bcfc845e61$export$d0fd09f950257b52);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $aLwh0 = parcelRequire("aLwh0");
/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $8deea1bcfc845e61$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
        if ($bahqM.isString(query)) {
            var condCptType = (0, $aLwh0.parseClassType)(query); // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $bahqM.each(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view; // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo wont be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();

});

parcelRegister("7wiHx", function(module, exports) {

$parcel$export(module.exports, "seriesSymbolTask", () => $579a0738784e30ca$export$144ac3beded415d9);
$parcel$export(module.exports, "dataSymbolTask", () => $579a0738784e30ca$export$435b956f7f1071fb);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $579a0738784e30ca$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolType = seriesModel.get('symbol');
        var symbolSize = seriesModel.get('symbolSize');
        var keepAspect = seriesModel.get('symbolKeepAspect');
        var symbolRotate = seriesModel.get('symbolRotate');
        var symbolOffset = seriesModel.get('symbolOffset');
        var hasSymbolTypeCallback = (0, $bahqM.isFunction)(symbolType);
        var hasSymbolSizeCallback = (0, $bahqM.isFunction)(symbolSize);
        var hasSymbolRotateCallback = (0, $bahqM.isFunction)(symbolRotate);
        var hasSymbolOffsetCallback = (0, $bahqM.isFunction)(symbolOffset);
        var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
        var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
        var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
        var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
        var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
        data.setVisual({
            legendIcon: seriesModel.legendIcon || seriesSymbol,
            // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
            // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
            // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
            // some cases but generally it is not recommanded.
            symbol: seriesSymbol,
            symbolSize: seriesSymbolSize,
            symbolKeepAspect: keepAspect,
            symbolRotate: seriesSymbolRotate,
            symbolOffset: seriesSymbolOffset
        }); // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
            hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
            hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
            hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $579a0738784e30ca$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
         // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var itemSymbolType = itemModel.getShallow('symbol', true);
            var itemSymbolSize = itemModel.getShallow('symbolSize', true);
            var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
            var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
            var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
            if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
            if (itemSymbolSize != null) // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
            if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
            if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
            if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};

});

parcelRegister("fk5Gm", function(module, exports) {

$parcel$export(module.exports, "getItemVisualFromData", () => $b27d21a8d98c0d1c$export$91d919a86b2df624);
$parcel$export(module.exports, "getVisualFromData", () => $b27d21a8d98c0d1c$export$d76e333a86ea1a2);
$parcel$export(module.exports, "setItemVisualFromData", () => $b27d21a8d98c0d1c$export$3aab879e9d0e7c75);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $b27d21a8d98c0d1c$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $b27d21a8d98c0d1c$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $b27d21a8d98c0d1c$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}

});

parcelRegister("1nKsD", function(module, exports) {

$parcel$export(module.exports, "createLegacyDataSelectAction", () => $101bfa9c2a38d115$export$62942ba95693dbfc);
$parcel$export(module.exports, "handleLegacySelectEvents", () => $101bfa9c2a38d115$export$2575c83262e49d0c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");


var $eaKsF = parcelRequire("eaKsF");
function $101bfa9c2a38d115$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $bahqM.each)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $bahqM.extend)({}, payload);
            api.dispatchAction((0, $bahqM.extend)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $eaKsF.queryDataIndex)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $bahqM.isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $bahqM.extend)({}, seriesModel.option.selectedMap)
            });
        }
    });
}
function $101bfa9c2a38d115$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}

});

parcelRegister("6IsbX", function(module, exports) {

$parcel$export(module.exports, "findEventDispatcher", () => $4e3cb87918e3df6d$export$8a4fca9e04eb4df6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4e3cb87918e3df6d$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}

});

parcelRegister("g2DhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $badb4ee06d190426$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9LEsz = parcelRequire("9LEsz");
function $badb4ee06d190426$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $9LEsz.createOrUpdatePatternFromDecal)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $9LEsz.createOrUpdatePatternFromDecal)(decal, api);
        }
    });
}

});
parcelRegister("9LEsz", function(module, exports) {

$parcel$export(module.exports, "createOrUpdatePatternFromDecal", () => $71c7e35019979000$export$a3ba048e1a648972);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $822uQ = parcelRequire("822uQ");

var $h4RuA = parcelRequire("h4RuA");

var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $7yklO = parcelRequire("7yklO");

var $aSzOj = parcelRequire("aSzOj");
var $71c7e35019979000$var$decalMap = new (0, $822uQ.default)();
var $71c7e35019979000$var$decalCache = new (0, $h4RuA.default)(100);
var $71c7e35019979000$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $71c7e35019979000$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $71c7e35019979000$var$decalMap["delete"](decalObject);
    var oldPattern = $71c7e35019979000$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $bahqM.defaults)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $71c7e35019979000$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $71c7e35019979000$var$decalKeys.length; ++i){
            var value = decalOpt[$71c7e35019979000$var$decalKeys[i]];
            var valueType = typeof value;
            if (value != null && !(0, $bahqM.isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $71c7e35019979000$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $71c7e35019979000$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $71c7e35019979000$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $71c7e35019979000$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $71c7e35019979000$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $71c7e35019979000$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $bahqM.createCanvas)();
        var svgRoot = isSVG && zr.painter.createSVGElement('g');
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $71c7e35019979000$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minumum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minumum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $jmSNG.getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $jmSNG.getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                         // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $7yklO.createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                else // Paint to canvas for all other renderers.
                (0, $aSzOj.brushSingle)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $71c7e35019979000$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if (typeof symbol === 'string') return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
        isAllString = false;
        break;
    }
    if (isAllString) return $71c7e35019979000$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $71c7e35019979000$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if (typeof dash === 'number') {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $71c7e35019979000$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $bahqM.map)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $71c7e35019979000$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if (typeof dash === 'number') {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $bahqM.map)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash arrary of X or Y
 * @return {number[]} block length of each line
 */ function $71c7e35019979000$var$getLineBlockLengthX(dash) {
    return (0, $bahqM.map)(dash, function(line) {
        return $71c7e35019979000$var$getLineBlockLengthY(line);
    });
}
function $71c7e35019979000$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}

});
parcelRegister("822uQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9072624d2c732b$export$2e2bcd8739ae039);
var $5d9072624d2c732b$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $5d9072624d2c732b$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $5d9072624d2c732b$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $5d9072624d2c732b$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($5d9072624d2c732b$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $5d9072624d2c732b$export$2e2bcd8739ae039 = $5d9072624d2c732b$var$WeakMap;

});

parcelRegister("aSzOj", function(module, exports) {

$parcel$export(module.exports, "createCanvasPattern", () => $7ebab9bfc20d8461$export$8eb5db6b7bc27903);
$parcel$export(module.exports, "brushSingle", () => $7ebab9bfc20d8461$export$567881adfc3eb7f3);
$parcel$export(module.exports, "brush", () => $7ebab9bfc20d8461$export$da5d6544e8c27bc1);

var $lBQ88 = parcelRequire("lBQ88");

var $aA4Ws = parcelRequire("aA4Ws");

var $63nvx = parcelRequire("63nvx");

var $dPYp9 = parcelRequire("dPYp9");

var $ghQ8v = parcelRequire("ghQ8v");

var $gcbBH = parcelRequire("gcbBH");

var $45jlh = parcelRequire("45jlh");

var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");

var $cpB91 = parcelRequire("cpB91");

var $6sllV = parcelRequire("6sllV");

var $aVawM = parcelRequire("aVawM");
var $7ebab9bfc20d8461$var$pathProxyForDraw = new (0, $aA4Ws.default)(true);
function $7ebab9bfc20d8461$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $7ebab9bfc20d8461$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $7ebab9bfc20d8461$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $7ebab9bfc20d8461$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $7ebab9bfc20d8461$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $63nvx.createOrUpdateImage)(pattern.image, pattern.__image, el);
    if ((0, $63nvx.isImageReady)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $7ebab9bfc20d8461$var$brushPath(ctx, el, style, inBatch) {
    var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
    var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $7ebab9bfc20d8461$var$pathProxyForDraw;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = el.__dirty ? (0, $dPYp9.getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = el.__dirty ? (0, $dPYp9.getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = el.__dirty || !el.__canvasFillPattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = el.__dirty || !el.__canvasStrokePattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var lineDash = style.lineDash && style.lineWidth > 0 && (0, $cpB91.normalizeLineDash)(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash;
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $bahqM.map)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    var needsRebuild = true;
    if (firstDraw || el.__dirty & (0, $aVawM.SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        if (lineDash && !ctxLineDash) {
            path.setLineDash(lineDash);
            path.setLineDashOffset(lineDashOffset);
        }
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash && ctxLineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
            if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
            if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash && ctxLineDash) ctx.setLineDash([]);
}
function $7ebab9bfc20d8461$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $63nvx.createOrUpdateImage)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $63nvx.isImageReady)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $7ebab9bfc20d8461$var$brushText(ctx, el, style) {
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $b7ZX8.DEFAULT_FONT);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var hasLineDash = void 0;
        if (ctx.setLineDash) {
            var lineDash = style.lineDash && style.lineWidth > 0 && (0, $cpB91.normalizeLineDash)(style.lineDash, style.lineWidth);
            var lineDashOffset = style.lineDashOffset;
            if (lineDash) {
                var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                if (lineScale_2 && lineScale_2 !== 1) {
                    lineDash = (0, $bahqM.map)(lineDash, function(rawVal) {
                        return rawVal / lineScale_2;
                    });
                    lineDashOffset /= lineScale_2;
                }
                ctx.setLineDash(lineDash);
                ctx.lineDashOffset = lineDashOffset;
                hasLineDash = true;
            }
        }
        if (style.strokeFirst) {
            if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (hasLineDash) ctx.setLineDash([]);
    }
}
var $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $7ebab9bfc20d8461$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $lBQ88.DEFAULT_COMMON_STYLE).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $lBQ88.DEFAULT_COMMON_STYLE).blend;
    }
    for(var i = 0; i < $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $lBQ88.DEFAULT_COMMON_STYLE).shadowColor;
    }
    return styleChanged;
}
function $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $7ebab9bfc20d8461$var$STROKE_PROPS.length; i++){
        var prop = $7ebab9bfc20d8461$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $7ebab9bfc20d8461$var$bindCommonProps(ctx, $7ebab9bfc20d8461$var$getStyle(el, scope.inHover), prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $7ebab9bfc20d8461$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $7ebab9bfc20d8461$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $7ebab9bfc20d8461$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $7ebab9bfc20d8461$var$DRAW_TYPE_PATH = 1;
var $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE = 2;
var $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT = 3;
var $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL = 4;
function $7ebab9bfc20d8461$var$canPathBatch(style) {
    var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
    var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $7ebab9bfc20d8461$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $7ebab9bfc20d8461$export$567881adfc3eb7f3(ctx, el) {
    $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $aVawM.REDRAW_BIT);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $dPYp9.isClipPathChanged)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $ghQ8v.default) && el.autoBatch && $7ebab9bfc20d8461$var$canPathBatch(el.style);
    if (forceSetTransform || $7ebab9bfc20d8461$var$isTransformChanged(m, prevEl.transform)) {
        $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        $7ebab9bfc20d8461$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
    var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $ghQ8v.default)) {
        if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_PATH;
        }
        $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $7ebab9bfc20d8461$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $45jlh.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT;
            }
            $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $7ebab9bfc20d8461$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $gcbBH.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE;
            }
            $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $7ebab9bfc20d8461$var$brushImage(ctx, el, style);
        } else if (el instanceof (0, $6sllV.default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL;
            }
            $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

});
parcelRegister("dPYp9", function(module, exports) {

$parcel$export(module.exports, "getCanvasGradient", () => $a12ee4e4c244a026$export$3dab6afd018d48c7);
$parcel$export(module.exports, "isClipPathChanged", () => $a12ee4e4c244a026$export$beeddc5150cb2e83);
function $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) : $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $a12ee4e4c244a026$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}

});

parcelRegister("cpB91", function(module, exports) {

$parcel$export(module.exports, "normalizeLineDash", () => $9094a1fa7d97ce08$export$9efb2ae8a603855d);

var $bahqM = parcelRequire("bahqM");
function $9094a1fa7d97ce08$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    lineWidth = lineWidth || 1;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $bahqM.isNumber)(lineType) ? [
        lineType
    ] : (0, $bahqM.isArray)(lineType) ? lineType : null;
}

});




parcelRegister("fEzwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65624d7bef03239$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fBEGW = parcelRequire("fBEGW");

var $2iWFB = parcelRequire("2iWFB");
var $b65624d7bef03239$var$storage = (0, $bahqM.createHashMap)();
var $b65624d7bef03239$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $fBEGW.GeoSVGResource)(mapName, rawDef.svg);
            $b65624d7bef03239$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $2iWFB.GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
            $b65624d7bef03239$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $b65624d7bef03239$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $b65624d7bef03239$var$storage.get(mapName); // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $b65624d7bef03239$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};

});
parcelRegister("fBEGW", function(module, exports) {

$parcel$export(module.exports, "GeoSVGResource", () => $b5c9e032bcec003b$export$be52c950efae1f84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $KN3aA = parcelRequire("KN3aA");

var $4KVOr = parcelRequire("4KVOr");

var $7Tw7u = parcelRequire("7Tw7u");

var $bahqM = parcelRequire("bahqM");

var $1E3E8 = parcelRequire("1E3E8");

var $bsT8u = parcelRequire("bsT8u");

var $b8QyH = parcelRequire("b8QyH");
/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $bahqM.createHashMap)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $b5c9e032bcec003b$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $bahqM.createHashMap)(); // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName; // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $bsT8u.parseXML)(svg);
    }
    GeoSVGResource.prototype.load = function() /* nameMap: NameMap */ {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $b5c9e032bcec003b$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $KN3aA.parseSVG)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $bahqM.assert)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        } // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $4KVOr.default)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only suport `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            } // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1E3E8.default)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $KN3aA.makeViewBoxTransform)(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $7Tw7u.default)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $bahqM.each)(result.named, function(namedItem) {
            if ($b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $b5c9e032bcec003b$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
         || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $b5c9e032bcec003b$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false; // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $b5c9e032bcec003b$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $bahqM.createHashMap)(); // Create resions only for the first graphic.
    (0, $bahqM.each)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $b8QyH.GeoSVGRegion)(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }

});
parcelRegister("KN3aA", function(module, exports) {

$parcel$export(module.exports, "makeViewBoxTransform", () => $08ca58536684a52b$export$3e2db4420f14f50f);
$parcel$export(module.exports, "parseSVG", () => $08ca58536684a52b$export$1919f5101c220601);

var $4KVOr = parcelRequire("4KVOr");

var $gcbBH = parcelRequire("gcbBH");

var $jjfok = parcelRequire("jjfok");

var $7Tw7u = parcelRequire("7Tw7u");

var $kVeV8 = parcelRequire("kVeV8");

var $cZb1F = parcelRequire("cZb1F");

var $lQwBc = parcelRequire("lQwBc");

var $32bXc = parcelRequire("32bXc");

var $izqgC = parcelRequire("izqgC");

var $id1Rd = parcelRequire("id1Rd");

var $bahqM = parcelRequire("bahqM");

var $9J7f8 = parcelRequire("9J7f8");

var $faICo = parcelRequire("faICo");

var $45jlh = parcelRequire("45jlh");

var $bsT8u = parcelRequire("bsT8u");
var $08ca58536684a52b$var$nodeParsers;
var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $bahqM.keys)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $bahqM.keys)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP);
var $08ca58536684a52b$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $bsT8u.parseXML)(xml);
        if (!svg) throw new Error('Illegal svg');
        this._defsUsePending = [];
        var root = new (0, $4KVOr.default)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $08ca58536684a52b$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $08ca58536684a52b$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $08ca58536684a52b$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $4KVOr.default)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $7Tw7u.default)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $08ca58536684a52b$var$nodeParsers[nodeName];
                if (parser_1 && (0, $bahqM.hasOwn)($08ca58536684a52b$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $08ca58536684a52b$var$paintServerParsers[nodeName];
            if (parser && (0, $bahqM.hasOwn)($08ca58536684a52b$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $45jlh.default)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $08ca58536684a52b$var$inheritStyle(parentGroup, text);
        $08ca58536684a52b$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $08ca58536684a52b$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $08ca58536684a52b$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $7Tw7u.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, rect);
                $08ca58536684a52b$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $jjfok.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, circle);
                $08ca58536684a52b$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $cZb1F.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, line);
                $08ca58536684a52b$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $kVeV8.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, ellipse);
                $08ca58536684a52b$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                var polygon = new (0, $lQwBc.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $08ca58536684a52b$var$inheritStyle(parentGroup, polygon);
                $08ca58536684a52b$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                var polyline = new (0, $32bXc.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $08ca58536684a52b$var$inheritStyle(parentGroup, polyline);
                $08ca58536684a52b$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $gcbBH.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, img);
                $08ca58536684a52b$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $4KVOr.default)();
                $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $id1Rd.createFromString)(d);
                $08ca58536684a52b$var$inheritStyle(parentGroup, path);
                $08ca58536684a52b$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $08ca58536684a52b$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $9J7f8.default)(x1, y1, x2, y2);
        $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
        $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $faICo.default)(cx, cy, r);
        $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
        $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $08ca58536684a52b$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $08ca58536684a52b$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $bahqM.defaults)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $08ca58536684a52b$var$parsePoints(pointsString) {
    var list = $08ca58536684a52b$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $08ca58536684a52b$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $08ca58536684a52b$var$parseTransformAttribute(xmlNode, el);
        $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $bahqM.each)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $bahqM.each)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $bahqM.map)($08ca58536684a52b$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $08ca58536684a52b$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $08ca58536684a52b$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $08ca58536684a52b$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($08ca58536684a52b$var$urlRegex);
    if (urlMatch) {
        var url = (0, $bahqM.trim)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $08ca58536684a52b$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $08ca58536684a52b$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $08ca58536684a52b$var$splitNumberSequence(rawStr) {
    return rawStr.match($08ca58536684a52b$var$numberReg) || [];
}
var $08ca58536684a52b$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $08ca58536684a52b$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $08ca58536684a52b$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($08ca58536684a52b$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $08ca58536684a52b$var$splitNumberSequence(value);
            mt = mt || $izqgC.create();
            switch(type){
                case 'translate':
                    $izqgC.translate(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $izqgC.scale(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $izqgC.rotate(mt, mt, -parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    $izqgC.mul(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                    $izqgC.mul(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $08ca58536684a52b$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $08ca58536684a52b$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $08ca58536684a52b$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $bahqM.hasOwn)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $bahqM.hasOwn)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $08ca58536684a52b$export$1919f5101c220601(xml, opt) {
    var parser = new $08ca58536684a52b$var$SVGParser();
    return parser.parse(xml, opt);
}

});
parcelRegister("bsT8u", function(module, exports) {

$parcel$export(module.exports, "parseXML", () => $858d140ea42b55af$export$eacefc55fad2867e);

var $bahqM = parcelRequire("bahqM");
function $858d140ea42b55af$export$eacefc55fad2867e(svg) {
    if ((0, $bahqM.isString)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}

});


parcelRegister("b8QyH", function(module, exports) {

$parcel$export(module.exports, "GeoJSONRegion", () => $81c9361a69c93c5f$export$ee84fcb463f24b3d);
$parcel$export(module.exports, "GeoSVGRegion", () => $81c9361a69c93c5f$export$5f3d89e7254f3e69);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $1E3E8 = parcelRequire("1E3E8");

var $13I82 = parcelRequire("13I82");

var $eLEew = parcelRequire("eLEew");

var $hjZ9y = parcelRequire("hjZ9y");

var $izqgC = parcelRequire("izqgC");
var $81c9361a69c93c5f$var$TMP_TRANSFORM = [];
var $81c9361a69c93c5f$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        return;
    };
    return Region;
}();
var $81c9361a69c93c5f$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        if (!cp) {
            var rect = _this.getBoundingRect();
            cp = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        } else cp = [
            cp[0],
            cp[1]
        ];
        _this._center = cp;
        return _this;
    }
    GeoJSONRegion.prototype.getBoundingRect = function() {
        var rect = this._rect;
        if (rect) return rect;
        var MAX_NUMBER = Number.MAX_VALUE;
        var min = [
            MAX_NUMBER,
            MAX_NUMBER
        ];
        var max = [
            -MAX_NUMBER,
            -MAX_NUMBER
        ];
        var min2 = [];
        var max2 = [];
        var geometries = this.geometries;
        var i = 0;
        for(; i < geometries.length; i++){
            // Only support polygon
            if (geometries[i].type !== 'polygon') continue;
             // Doesn't consider hole
            var exterior = geometries[i].exterior;
            $13I82.fromPoints(exterior, min2, max2);
            $eLEew.min(min, min, min2);
            $eLEew.max(max, max, max2);
        } // No data
        if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
        return this._rect = new (0, $1E3E8.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            if ($hjZ9y.contain(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($hjZ9y.contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1E3E8.default)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            for(var p = 0; p < exterior.length; p++)$eLEew.applyTransform(exterior[p], exterior[p], transform);
            for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)$eLEew.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
        rect = this._rect;
        rect.copy(target); // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    GeoJSONRegion.prototype.getCenter = function() {
        return this._center;
    };
    GeoJSONRegion.prototype.setCenter = function(center) {
        this._center = center;
    };
    return GeoJSONRegion;
}($81c9361a69c93c5f$export$b1f97c3099fc6872);
var $81c9361a69c93c5f$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this._calculateCenter();
        return center;
    };
    GeoSVGRegion.prototype._calculateCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $izqgC.identity($81c9361a69c93c5f$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $izqgC.mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $izqgC.invert(mat, mat);
        $eLEew.applyTransform(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($81c9361a69c93c5f$export$b1f97c3099fc6872);

});
parcelRegister("hjZ9y", function(module, exports) {

$parcel$export(module.exports, "contain", () => $c9c3a5bccc65a1b5$export$8893e2b90ba10d92);

var $3Ytji = parcelRequire("3Ytji");
var $c9c3a5bccc65a1b5$var$EPSILON = 1e-8;
function $c9c3a5bccc65a1b5$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $c9c3a5bccc65a1b5$var$EPSILON;
}
function $c9c3a5bccc65a1b5$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $3Ytji.default)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$c9c3a5bccc65a1b5$var$isAroundEqual(p[0], p0[0]) || !$c9c3a5bccc65a1b5$var$isAroundEqual(p[1], p0[1])) w += (0, $3Ytji.default)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}

});



parcelRegister("2iWFB", function(module, exports) {

$parcel$export(module.exports, "GeoJSONResource", () => $1adac5d85fe37b79$export$859cf85c67f2df51);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $gyzY7 = parcelRequire("gyzY7");

var $eEvpA = parcelRequire("eEvpA");

var $5i7yG = parcelRequire("5i7yG");

var $huNXv = parcelRequire("huNXv");

var $ducHh = parcelRequire("ducHh");

var $1E3E8 = parcelRequire("1E3E8");
var $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY = 'name';
var $1adac5d85fe37b79$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $bahqM.createHashMap)();
        this._mapName = mapName;
        this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $1adac5d85fe37b79$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $1adac5d85fe37b79$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $bahqM.createHashMap)();
        var finalRegions = [];
        (0, $bahqM.each)(parsed.regions, function(region) {
            var regionName = region.name; // Try use the alias in geoNameMap
            if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1E3E8.default)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions; // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $gyzY7.default)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $eEvpA.default)(mapName, rawRegions);
        (0, $bahqM.each)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $5i7yG.default)(mapName, region);
            (0, $huNXv.default)(mapName, region);
            (0, $ducHh.default)(mapName, region); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $1adac5d85fe37b79$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $1adac5d85fe37b79$var$parseInput(source) {
    return !(0, $bahqM.isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

});
parcelRegister("gyzY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0dbb8f34f2c3106$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
var $bahqM = parcelRequire("bahqM");

var $b8QyH = parcelRequire("b8QyH");
function $c0dbb8f34f2c3106$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    for(var f = 0; f < features.length; f++){
        var feature = features[f];
        var geometry = feature.geometry;
        if (geometry.type === 'Polygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++)coordinates[c] = $c0dbb8f34f2c3106$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
        } else if (geometry.type === 'MultiPolygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++){
                var coordinate = coordinates[c];
                for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $c0dbb8f34f2c3106$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
            }
        }
    } // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $c0dbb8f34f2c3106$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1); // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y; // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $c0dbb8f34f2c3106$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $c0dbb8f34f2c3106$var$decode(geoJson);
    return $bahqM.map($bahqM.filter(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        if (geo.type === 'Polygon') {
            var coordinates = geo.coordinates;
            geometries.push({
                type: 'polygon',
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                exterior: coordinates[0],
                interiors: coordinates.slice(1)
            });
        }
        if (geo.type === 'MultiPolygon') {
            var coordinates = geo.coordinates;
            $bahqM.each(coordinates, function(item) {
                if (item[0]) geometries.push({
                    type: 'polygon',
                    exterior: item[0],
                    interiors: item.slice(1)
                });
            });
        }
        var region = new (0, $b8QyH.GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}

});

parcelRegister("eEvpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaad2ad12dd4ec6c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛

var $bahqM = parcelRequire("bahqM");

var $b8QyH = parcelRequire("b8QyH");
var $aaad2ad12dd4ec6c$var$geoCoord = [
    126,
    25
];
var $aaad2ad12dd4ec6c$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $aaad2ad12dd4ec6c$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $aaad2ad12dd4ec6c$var$i = 0; $aaad2ad12dd4ec6c$var$i < $aaad2ad12dd4ec6c$var$points.length; $aaad2ad12dd4ec6c$var$i++)for(var $aaad2ad12dd4ec6c$var$k = 0; $aaad2ad12dd4ec6c$var$k < $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i].length; $aaad2ad12dd4ec6c$var$k++){
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] /= 10.5;
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] /= -14;
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] += $aaad2ad12dd4ec6c$var$geoCoord[0];
    $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] += $aaad2ad12dd4ec6c$var$geoCoord[1];
}
function $aaad2ad12dd4ec6c$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $aaad2ad12dd4ec6c$var$nanhaiName) return;
        }
        regions.push(new (0, $b8QyH.GeoJSONRegion)($aaad2ad12dd4ec6c$var$nanhaiName, $bahqM.map($aaad2ad12dd4ec6c$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $aaad2ad12dd4ec6c$var$geoCoord));
    }
}

});

parcelRegister("5i7yG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da47f1dbbeac6bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3da47f1dbbeac6bc$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    //'北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $3da47f1dbbeac6bc$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $3da47f1dbbeac6bc$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("huNXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcbfdc69414efb9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cbcbfdc69414efb9$var$geoCoordMap = {
    'Russia': [
        100,
        60
    ],
    'United States': [
        -99,
        38
    ],
    'United States of America': [
        -99,
        38
    ]
};
function $cbcbfdc69414efb9$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'world') {
        var geoCoord = $cbcbfdc69414efb9$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = [
                geoCoord[0],
                geoCoord[1]
            ];
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("ducHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d17ed1a4c54aaef$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $9d17ed1a4c54aaef$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $9d17ed1a4c54aaef$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $9d17ed1a4c54aaef$var$points[0]
    });
}

});



parcelRegister("8cCW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8da56db6246248$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bRKv5 = parcelRequire("bRKv5");
var $5f8da56db6246248$var$lifecycle = new (0, $bRKv5.default)();
var $5f8da56db6246248$export$2e2bcd8739ae039 = $5f8da56db6246248$var$lifecycle;

});



parcelRegister("eQgZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace31acda01d4651$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bAY5l = parcelRequire("bAY5l");

var $1O7Ua = parcelRequire("1O7Ua");
var $ace31acda01d4651$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get('progressive');
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.type = 'series.scatter';
    ScatterSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8 // color: 各异
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        universalTransition: {
            divideShape: 'clone'
        } // progressive: null
    };
    return ScatterSeriesModel;
}((0, $1O7Ua.default));
var $ace31acda01d4651$export$2e2bcd8739ae039 = $ace31acda01d4651$var$ScatterSeriesModel;

});

parcelRegister("jBLJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4667f5e3d4c581e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $5DXGq = parcelRequire("5DXGq");

var $7tGln = parcelRequire("7tGln");

var $5xgWc = parcelRequire("5xgWc");

var $loerw = parcelRequire("loerw");
var $e4667f5e3d4c581e$var$ScatterView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) return {
            update: true
        };
        else {
            var res = (0, $5xgWc.default)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $7tGln.default)() : new (0, $5DXGq.default)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = 'scatter';
    return ScatterView;
}((0, $loerw.default));
var $e4667f5e3d4c581e$export$2e2bcd8739ae039 = $e4667f5e3d4c581e$var$ScatterView;

});
parcelRegister("7tGln", function(module, exports) {

$parcel$export(module.exports, "default", () => $571c16701c52f758$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $4KVOr = parcelRequire("4KVOr");parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");

var $7yklO = parcelRequire("7yklO");

var $6sllV = parcelRequire("6sllV");

var $7QjoM = parcelRequire("7QjoM");
var $571c16701c52f758$var$BOOST_SIZE_THRESHOLD = 4;
var $571c16701c52f758$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $571c16701c52f758$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        return _super.call(this, opts) || this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $571c16701c52f758$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $571c16701c52f758$var$BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        if (!ctx) return;
         // PENDING If style or other canvas status changed?
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
             // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4); // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    return LargeSymbolPath;
}($ghQ8v.default);
var $571c16701c52f758$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $4KVOr.default();
    }
    LargeSymbolDraw.prototype.isPersistent = function() {
        return !this._incremental;
    };
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this.group.removeAll();
        var symbolEl = new $571c16701c52f758$var$LargeSymbolPath({
            rectHover: true,
            cursor: 'default'
        });
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, false, opt);
        this.group.add(symbolEl);
        this._incremental = null;
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        if (this._incremental) return;
        var points = data.getLayout('points');
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape('points', points);
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
        // PENDING Incremental data?
        if (data.count() > 2e6) {
            if (!this._incremental) this._incremental = new (0, $6sllV.default)({
                silent: true
            });
            this.group.add(this._incremental);
        } else this._incremental = null;
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var symbolEl;
        if (this._incremental) {
            symbolEl = new $571c16701c52f758$var$LargeSymbolPath();
            this._incremental.addDisplayable(symbolEl, true);
        } else {
            symbolEl = new $571c16701c52f758$var$LargeSymbolPath({
                rectHover: true,
                cursor: 'default',
                startIndex: taskParams.start,
                endIndex: taskParams.end
            });
            symbolEl.incremental = true;
            this.group.add(symbolEl);
        }
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, !!this._incremental, opt);
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, isIncremental, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual('symbolSize');
        symbolEl.setShape('size', size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $7yklO.createSymbol)(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $571c16701c52f758$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
            'color',
            'shadowBlur',
            'shadowColor'
        ] : [
            'color'
        ]));
        var globalStyle = data.getVisual('style');
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        if (!isIncremental) {
            var ecData_1 = (0, $7QjoM.getECData)(symbolEl); // Enable tooltip
            // PENDING May have performance issue when path is extremely large
            ecData_1.seriesIndex = hostModel.seriesIndex;
            symbolEl.on('mousemove', function(e) {
                ecData_1.dataIndex = null;
                var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
                if (dataIndex >= 0) // Provide dataIndex for tooltip
                ecData_1.dataIndex = dataIndex + (symbolEl.startIndex || 0);
            });
        }
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clearIncremental();
        this._incremental = null;
        this.group.removeAll();
    };
    LargeSymbolDraw.prototype._clearIncremental = function() {
        var incremental = this._incremental;
        if (incremental) incremental.clearDisplaybles();
    };
    return LargeSymbolDraw;
}();
var $571c16701c52f758$export$2e2bcd8739ae039 = $571c16701c52f758$var$LargeSymbolDraw;

});


parcelRegister("iWOYl", function(module, exports) {

$parcel$export(module.exports, "install", () => $dcb52eca8f57248f$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fkskt = parcelRequire("fkskt");

var $9sf2Q = parcelRequire("9sf2Q");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $bahqM = parcelRequire("bahqM");

var $1UrP6 = parcelRequire("1UrP6");

var $aLiaH = parcelRequire("aLiaH");

var $1xCHp = parcelRequire("1xCHp");

var $2rHnA = parcelRequire("2rHnA");
var $dcb52eca8f57248f$var$GridView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $7Tw7u.default)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $bahqM.defaults)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $fkskt.default));
var $dcb52eca8f57248f$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $dcb52eca8f57248f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($dcb52eca8f57248f$var$GridView);
    registers.registerComponentModel((0, $9sf2Q.default));
    registers.registerCoordinateSystem('cartesian2d', (0, $1xCHp.default));
    (0, $aLiaH.default)(registers, 'x', (0, $1UrP6.CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
    (0, $aLiaH.default)(registers, 'y', (0, $1UrP6.CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
    registers.registerComponentView((0, $2rHnA.CartesianXAxisView));
    registers.registerComponentView((0, $2rHnA.CartesianYAxisView));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}

});
parcelRegister("9sf2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e226630804759b0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $6e226630804759b0$var$GridModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $h4UlH.default));
var $6e226630804759b0$export$2e2bcd8739ae039 = $6e226630804759b0$var$GridModel;

});

parcelRegister("1UrP6", function(module, exports) {

$parcel$export(module.exports, "CartesianAxisModel", () => $16409a80acd4e1a4$export$483dc37e6ad83a3c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $h4UlH = parcelRequire("h4UlH");

var $5pBRm = parcelRequire("5pBRm");

var $eaKsF = parcelRequire("eaKsF");
var $16409a80acd4e1a4$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $eaKsF.SINGLE_REFERRING)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $h4UlH.default));
$bahqM.mixin($16409a80acd4e1a4$export$483dc37e6ad83a3c, (0, $5pBRm.AxisModelCommonMixin));
var $16409a80acd4e1a4$export$2e2bcd8739ae039 = $16409a80acd4e1a4$export$483dc37e6ad83a3c;

});
parcelRegister("5pBRm", function(module, exports) {

$parcel$export(module.exports, "AxisModelCommonMixin", () => $3f0ca7b2a67ba541$export$5c54b224726edb5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3f0ca7b2a67ba541$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();

});


parcelRegister("aLiaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d5c63a9e257cb04$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $erX9x = parcelRequire("erX9x");

var $65MS1 = parcelRequire("65MS1");

var $6Vrdy = parcelRequire("6Vrdy");

var $7vTvv = parcelRequire("7vTvv");

var $bahqM = parcelRequire("bahqM");
function $7d5c63a9e257cb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $bahqM.each)((0, $7vTvv.AXIS_TYPES), function(v, axisType) {
        var defaultOption = (0, $bahqM.merge)((0, $bahqM.merge)({}, (0, $erX9x.default)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $3VFsf.__extends)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $65MS1.fetchLayoutMode)(this);
                var inputPositionParams = layoutMode ? (0, $65MS1.getLayoutParams)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $bahqM.merge)(option, themeModel.get(axisType + 'Axis'));
                (0, $bahqM.merge)(option, this.getDefaultOption());
                option.type = $7d5c63a9e257cb04$var$getAxisType(option);
                if (layoutMode) (0, $65MS1.mergeLayoutParam)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $6Vrdy.default).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option; // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $7d5c63a9e257cb04$var$getAxisType);
}
function $7d5c63a9e257cb04$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}

});
parcelRegister("erX9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85178cf0b0fc4bc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $a85178cf0b0fc4bc$var$defaultOption = {
    show: true,
    zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $a85178cf0b0fc4bc$var$categoryAxis = $bahqM.merge({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $a85178cf0b0fc4bc$var$defaultOption);
var $a85178cf0b0fc4bc$var$valueAxis = $bahqM.merge({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Lenght of minor tick
        length: 3,
        // Line style
        lineStyle: {}
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $a85178cf0b0fc4bc$var$defaultOption);
var $a85178cf0b0fc4bc$var$timeAxis = $bahqM.merge({
    scale: true,
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $a85178cf0b0fc4bc$var$valueAxis);
var $a85178cf0b0fc4bc$var$logAxis = $bahqM.defaults({
    scale: true,
    logBase: 10
}, $a85178cf0b0fc4bc$var$valueAxis);
var $a85178cf0b0fc4bc$export$2e2bcd8739ae039 = {
    category: $a85178cf0b0fc4bc$var$categoryAxis,
    value: $a85178cf0b0fc4bc$var$valueAxis,
    time: $a85178cf0b0fc4bc$var$timeAxis,
    log: $a85178cf0b0fc4bc$var$logAxis
};

});

parcelRegister("6Vrdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ad2dcdb048637a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $50ad2dcdb048637a$var$uidBase = 0;
var $50ad2dcdb048637a$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$50ad2dcdb048637a$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $bahqM.map)(data, $50ad2dcdb048637a$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (typeof category !== 'string' && !needCollect) return category;
         // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap(); // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category; // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    }; // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $bahqM.createHashMap)(this.categories));
    };
    return OrdinalMeta;
}();
function $50ad2dcdb048637a$var$getName(obj) {
    if ((0, $bahqM.isObject)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $50ad2dcdb048637a$export$2e2bcd8739ae039 = $50ad2dcdb048637a$var$OrdinalMeta;

});

parcelRegister("7vTvv", function(module, exports) {

$parcel$export(module.exports, "AXIS_TYPES", () => $57867c39181fdac2$export$2e0057d176d6f690);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $57867c39181fdac2$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};

});


parcelRegister("1xCHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f6e45ff2a10529$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 
var $bahqM = parcelRequire("bahqM");

var $65MS1 = parcelRequire("65MS1");

var $3GIoT = parcelRequire("3GIoT");

var $SsPct = parcelRequire("SsPct");

var $kBKMx = parcelRequire("kBKMx");

var $eaKsF = parcelRequire("eaKsF");

var $dBIJY = parcelRequire("dBIJY");
var $11f6e45ff2a10529$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $SsPct.cartesian2DDimensions);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        (0, $bahqM.each)(axesMap.x, function(xAxis) {
            (0, $3GIoT.niceScaleExtent)(xAxis.scale, xAxis.model);
        });
        (0, $bahqM.each)(axesMap.y, function(yAxis) {
            (0, $3GIoT.niceScaleExtent)(yAxis.scale, yAxis.model);
        }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $bahqM.each)(axesMap.x, function(xAxis) {
            $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $bahqM.each)(axesMap.y, function(yAxis) {
            $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        }); // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $65MS1.getLayoutRect)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes(); // Minus label size
        if (isContainLabel) {
            (0, $bahqM.each)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $3GIoT.estimateLabelUnionRect)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $bahqM.each)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $bahqM.each)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $11f6e45ff2a10529$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0]; // if (axisIndex == null) {
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $bahqM.isObject)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $eaKsF.SINGLE_REFERRING)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $bahqM.indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        }; /// Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap; /// Create cartesian2d
        (0, $bahqM.each)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $bahqM.each)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $SsPct.default)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $kBKMx.default)(dimName, (0, $3GIoT.createScaleByModel)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
                axisModel.axis = axis; // Inject axisModel into axis
                axis.model = axisModel; // Inject grid info axis
                axis.grid = grid; // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $bahqM.each)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $dBIJY.isCartesian2DSeries)(seriesModel)) {
                var axesModelMap = (0, $dBIJY.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$11f6e45ff2a10529$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                if (data.type === 'list') {
                    unionExtent(data, xAxis);
                    unionExtent(data, yAxis);
                }
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $bahqM.each)((0, $3GIoT.getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $bahqM.each)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $bahqM.indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $bahqM.indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        }); // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $dBIJY.isCartesian2DSeries)(seriesModel)) return;
            var axesModelMap = (0, $dBIJY.findAxisModels)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    }; // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $SsPct.cartesian2DDimensions);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    }; // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
     // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
         && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $11f6e45ff2a10529$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $3GIoT.ifAxisCrossZero)(axis);
}
function $11f6e45ff2a10529$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $11f6e45ff2a10529$export$2e2bcd8739ae039 = $11f6e45ff2a10529$var$Grid;

});
parcelRegister("3GIoT", function(module, exports) {

$parcel$export(module.exports, "getScaleExtent", () => $2af7bc5b57211b12$export$9c0ba8df7eb7b328);
$parcel$export(module.exports, "niceScaleExtent", () => $2af7bc5b57211b12$export$51f3e70a54405d5a);
$parcel$export(module.exports, "createScaleByModel", () => $2af7bc5b57211b12$export$8941c4cacdc8f5a5);
$parcel$export(module.exports, "ifAxisCrossZero", () => $2af7bc5b57211b12$export$3eac36a69f37d52);
$parcel$export(module.exports, "makeLabelFormatter", () => $2af7bc5b57211b12$export$742f19a75415b2ae);
$parcel$export(module.exports, "getAxisRawValue", () => $2af7bc5b57211b12$export$a5a32f324c1fa457);
$parcel$export(module.exports, "estimateLabelUnionRect", () => $2af7bc5b57211b12$export$fef1c7f0af0b48d);
$parcel$export(module.exports, "getOptionCategoryInterval", () => $2af7bc5b57211b12$export$6d0bc2429155c088);
$parcel$export(module.exports, "shouldShowAllLabels", () => $2af7bc5b57211b12$export$c2911c025243d6a6);
$parcel$export(module.exports, "getDataDimensionsOnAxis", () => $2af7bc5b57211b12$export$e4cf30b1e74cd69d);
$parcel$export(module.exports, "unionAxisExtentFromData", () => $2af7bc5b57211b12$export$635fe7f20d0f4c70);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $acOy6 = parcelRequire("acOy6");

var $6kObD = parcelRequire("6kObD");

var $fEgWg = parcelRequire("fEgWg");

var $eL4bi = parcelRequire("eL4bi");

var $1E3E8 = parcelRequire("1E3E8");

var $1MU9l = parcelRequire("1MU9l");

var $73kgw = parcelRequire("73kgw");

var $5R8Hi = parcelRequire("5R8Hi");

var $lo2Vo = parcelRequire("lo2Vo");
function $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $lo2Vo.ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time') {
        var barSeriesModels = (0, $eL4bi.prepareLayoutBarSeries)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $bahqM.each(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $eL4bi.makeColumnLayout)(barSeriesModels); // Adjust axis min and max to account for overflow
            var adjustedScale = $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $eL4bi.retrieveColumnLayout)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $bahqM.each(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $bahqM.each(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
} // Precondition of calling this method:
function $2af7bc5b57211b12$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $73kgw.default)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    scale.setExtent(extent[0], extent[1]);
    scale.niceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
        maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
    }); // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    var interval = model.get('interval');
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2af7bc5b57211b12$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $acOy6.default)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $1MU9l.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $fEgWg.default).getClass(axisType) || (0, $6kObD.default))();
    }
}
function $2af7bc5b57211b12$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2af7bc5b57211b12$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'string') return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'function') return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $2af7bc5b57211b12$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $acOy6.default)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $2af7bc5b57211b12$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1; // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $2af7bc5b57211b12$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $2af7bc5b57211b12$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $1E3E8.default)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $2af7bc5b57211b12$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $2af7bc5b57211b12$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $2af7bc5b57211b12$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $bahqM.each(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $5R8Hi.getStackedDimension)(data, dataDim)] = true;
    });
    return $bahqM.keys(dataDimMap);
}
function $2af7bc5b57211b12$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $bahqM.each($2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}

});
parcelRegister("acOy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e23c609ca21282$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fEgWg = parcelRequire("fEgWg");

var $6Vrdy = parcelRequire("6Vrdy");

var $32MHg = parcelRequire("32MHg");

var $bahqM = parcelRequire("bahqM");
var $76e23c609ca21282$var$OrdinalScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $6Vrdy.default)({});
        if ((0, $bahqM.isArray)(ordinalMeta)) ordinalMeta = new (0, $6Vrdy.default)({
            categories: (0, $bahqM.map)(ordinalMeta, function(item) {
                return (0, $bahqM.isObject)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
         : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $32MHg.contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $32MHg.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($32MHg.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        } // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.niceTicks = function() {};
    OrdinalScale.prototype.niceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $fEgWg.default));
(0, $fEgWg.default).registerClass($76e23c609ca21282$var$OrdinalScale);
var $76e23c609ca21282$export$2e2bcd8739ae039 = $76e23c609ca21282$var$OrdinalScale;

});
parcelRegister("fEgWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b647bb1e30834d31$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $aLwh0 = parcelRequire("aLwh0");
var $b647bb1e30834d31$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$aLwh0.enableClassManagement($b647bb1e30834d31$var$Scale);
var $b647bb1e30834d31$export$2e2bcd8739ae039 = $b647bb1e30834d31$var$Scale;

});

parcelRegister("32MHg", function(module, exports) {

$parcel$export(module.exports, "intervalScaleNiceTicks", () => $2377552e030bbd2b$export$eeea879a611eb991);
$parcel$export(module.exports, "getIntervalPrecision", () => $2377552e030bbd2b$export$86a060b060d3d31a);
$parcel$export(module.exports, "contain", () => $2377552e030bbd2b$export$8893e2b90ba10d92);
$parcel$export(module.exports, "normalize", () => $2377552e030bbd2b$export$a3295358bff77e);
$parcel$export(module.exports, "scale", () => $2377552e030bbd2b$export$dcdf75081b88279d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");
var $2377552e030bbd2b$var$roundNumber = $jmSNG.round;
function $2377552e030bbd2b$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = $jmSNG.nice(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
     // Tow more digital for tick.
    var precision = result.intervalPrecision = $2377552e030bbd2b$export$86a060b060d3d31a(interval); // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        $2377552e030bbd2b$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
        $2377552e030bbd2b$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $2377552e030bbd2b$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return $jmSNG.getPrecision(interval) + 2;
}
function $2377552e030bbd2b$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $2377552e030bbd2b$var$clamp(niceTickExtent, 0, extent);
    $2377552e030bbd2b$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $2377552e030bbd2b$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $2377552e030bbd2b$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $2377552e030bbd2b$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}

});


parcelRegister("6kObD", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cb8a61b3174199$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $jmSNG = parcelRequire("jmSNG");

var $dCJrM = parcelRequire("dCJrM");

var $fEgWg = parcelRequire("fEgWg");

var $32MHg = parcelRequire("32MHg");
var $49cb8a61b3174199$var$roundNumber = $jmSNG.round;
var $49cb8a61b3174199$var$IntervalScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval'; // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $32MHg.contain(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $32MHg.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $32MHg.scale(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent; // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
        // We assume user wan't to set both interval, min, max to get a better result
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $32MHg.getIntervalPrecision(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
         // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $49cb8a61b3174199$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            }); // Avoid rounding error
            tick = $49cb8a61b3174199$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        } // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $49cb8a61b3174199$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $49cb8a61b3174199$var$roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $jmSNG.getPrecision(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
         // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $49cb8a61b3174199$var$roundNumber(data.value, precision, true);
        return $dCJrM.addCommas(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
         // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $32MHg.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                var expandSize = extent[0]; // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $49cb8a61b3174199$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $49cb8a61b3174199$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $fEgWg.default));
(0, $fEgWg.default).registerClass($49cb8a61b3174199$var$IntervalScale);
var $49cb8a61b3174199$export$2e2bcd8739ae039 = $49cb8a61b3174199$var$IntervalScale;

});

parcelRegister("eL4bi", function(module, exports) {

$parcel$export(module.exports, "getLayoutOnAxis", () => $abe8b2c5f70c8df4$export$658df087977b9e84);
$parcel$export(module.exports, "prepareLayoutBarSeries", () => $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4);
$parcel$export(module.exports, "makeColumnLayout", () => $abe8b2c5f70c8df4$export$20769dafc84e0299);
$parcel$export(module.exports, "retrieveColumnLayout", () => $abe8b2c5f70c8df4$export$35920bb6556da1c2);
$parcel$export(module.exports, "layout", () => $abe8b2c5f70c8df4$export$b3219800bda33a1f);
$parcel$export(module.exports, "largeLayout", () => $abe8b2c5f70c8df4$export$1fcd87ee6628f095);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $5R8Hi = parcelRequire("5R8Hi");

var $9irlK = parcelRequire("9irlK");
var $abe8b2c5f70c8df4$var$STACK_PREFIX = '__ec_stack_';
var $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH = 0.5;
var $abe8b2c5f70c8df4$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
function $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $abe8b2c5f70c8df4$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $abe8b2c5f70c8df4$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $abe8b2c5f70c8df4$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push($bahqM.defaults({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $abe8b2c5f70c8df4$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$abe8b2c5f70c8df4$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) && !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    $bahqM.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
             // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            } // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $abe8b2c5f70c8df4$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    $bahqM.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $jmSNG.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $jmSNG.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $jmSNG.parsePercent)(// the auto-calculated bar width might be less than 1.
        seriesModel.get('barMinWidth') || 1, bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $abe8b2c5f70c8df4$var$getAxisKey(baseAxis),
            stackId: $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)
        });
    });
    return $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    $bahqM.each(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        }; // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $bahqM.each(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = $bahqM.keys(stacks).length; // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $jmSNG.parsePercent)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $jmSNG.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $bahqM.each(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                 // `minWidth` has higher priority. `minWidth` decide that wheter the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Becuase barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                 // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $bahqM.each(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $bahqM.each(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $abe8b2c5f70c8df4$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $abe8b2c5f70c8df4$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $abe8b2c5f70c8df4$export$20769dafc84e0299(seriesModels);
    var lastStackCoords = {};
    $bahqM.each(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $5R8Hi.isDimensionStacked)(data, valueDim);
        var isValueAxisH = valueAxis.isHorizontal();
        var valueAxisStart = $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked);
        var store = data.getStore();
        var valueDimIdx = data.getDimensionIndex(valueDim);
        var baseDimIdx = data.getDimensionIndex(baseDim);
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var value = store.get(valueDimIdx, idx);
            var baseValue = store.get(baseDimIdx, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            if (stacked) {
                // Only ordinal axis can be stacked.
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (isValueAxisH) {
                var coord = cartesian.dataToPoint([
                    value,
                    baseValue
                ]);
                x = baseCoord;
                y = coord[1] + columnOffset;
                width = coord[0] - valueAxisStart;
                height = columnWidth;
                if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
            } else {
                var coord = cartesian.dataToPoint([
                    baseValue,
                    value
                ]);
                x = coord[0] + columnOffset;
                y = baseCoord;
                width = columnWidth;
                height = coord[1] - valueAxisStart;
                if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
            }
            data.setItemLayout(idx, {
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    });
} // TODO: Do not support stack in large mode yet.
var $abe8b2c5f70c8df4$export$1fcd87ee6628f095 = {
    seriesType: 'bar',
    plan: (0, $9irlK.default)(),
    reset: function(seriesModel) {
        if (!$abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) || !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) return;
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var coordLayout = cartesian.master.getRect();
        var baseAxis = cartesian.getBaseAxis();
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
        var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var valueAxisHorizontal = valueAxis.isHorizontal();
        var valueDimIdx = valueAxisHorizontal ? 0 : 1;
        var barWidth = $abe8b2c5f70c8df4$export$35920bb6556da1c2($abe8b2c5f70c8df4$export$20769dafc84e0299([
            seriesModel
        ]), baseAxis, seriesModel).width;
        if (!(barWidth > $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH)) // jshint ignore:line
        barWidth = $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH;
        return {
            progress: function(params, data) {
                var count = params.count;
                var largePoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                var largeBackgroundPoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                var largeDataIndices = new $abe8b2c5f70c8df4$var$LargeArr(count);
                var dataIndex;
                var coord = [];
                var valuePair = [];
                var pointsOffset = 0;
                var idxOffset = 0;
                var store = data.getStore();
                while((dataIndex = params.next()) != null){
                    valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                    valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                    coord = cartesian.dataToPoint(valuePair, null); // Data index might not be in order, depends on `progressiveChunkMode`.
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                    largePoints[pointsOffset++] = coord[0];
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                    largePoints[pointsOffset++] = coord[1];
                    largeDataIndices[idxOffset++] = dataIndex;
                }
                data.setLayout({
                    largePoints: largePoints,
                    largeDataIndices: largeDataIndices,
                    largeBackgroundPoints: largeBackgroundPoints,
                    barWidth: barWidth,
                    valueAxisStart: $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, false),
                    backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                    valueAxisHorizontal: valueAxisHorizontal
                });
            }
        };
    }
};
function $abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $abe8b2c5f70c8df4$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

});

parcelRegister("1MU9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d5d447dd592e99$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");

var $32MHg = parcelRequire("32MHg");

var $6kObD = parcelRequire("6kObD");

var $fEgWg = parcelRequire("fEgWg");


var $bahqM = parcelRequire("bahqM");
var $14d5d447dd592e99$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $14d5d447dd592e99$var$TimeScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $bc1Ad.format)(tick.value, (0, $bc1Ad.fullLeveledFormatter)[(0, $bc1Ad.getDefaultFormatPrecisionOfInterval)((0, $bc1Ad.getPrimaryTimeUnit)(this._minLevelUnit))] || (0, $bc1Ad.fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $bc1Ad.leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ TimeScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $14d5d447dd592e99$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $bc1Ad.ONE_DAY);
            extent[1] += (0, $bc1Ad.ONE_DAY);
        } // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $bc1Ad.ONE_DAY);
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $14d5d447dd592e99$var$scaleIntervals.length;
        var idx = Math.min($14d5d447dd592e99$var$bisect($14d5d447dd592e99$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks
        this._interval = $14d5d447dd592e99$var$scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $14d5d447dd592e99$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return typeof val === 'number' ? val : +$jmSNG.parseDate(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $32MHg.contain(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $32MHg.normalize(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $32MHg.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $6kObD.default));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $14d5d447dd592e99$var$scaleIntervals = [
    [
        'second',
        (0, $bc1Ad.ONE_SECOND)
    ],
    [
        'minute',
        (0, $bc1Ad.ONE_MINUTE)
    ],
    [
        'hour',
        (0, $bc1Ad.ONE_HOUR)
    ],
    [
        'quarter-day',
        (0, $bc1Ad.ONE_HOUR) * 6
    ],
    [
        'half-day',
        (0, $bc1Ad.ONE_HOUR) * 12
    ],
    [
        'day',
        (0, $bc1Ad.ONE_DAY) * 1.2
    ],
    [
        'half-week',
        (0, $bc1Ad.ONE_DAY) * 3.5
    ],
    [
        'week',
        (0, $bc1Ad.ONE_DAY) * 7
    ],
    [
        'month',
        (0, $bc1Ad.ONE_DAY) * 31
    ],
    [
        'quarter',
        (0, $bc1Ad.ONE_DAY) * 95
    ],
    [
        'half-year',
        (0, $bc1Ad.ONE_YEAR) / 2
    ],
    [
        'year',
        (0, $bc1Ad.ONE_YEAR)
    ] // 1Y
];
function $14d5d447dd592e99$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $jmSNG.parseDate(valueA);
    var dateB = $jmSNG.parseDate(valueB);
    var isSame = function(unit) {
        return (0, $bc1Ad.getUnitValue)(dateA, unit, isUTC) === (0, $bc1Ad.getUnitValue)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $14d5d447dd592e99$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $bc1Ad.ONE_DAY);
    return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick betwen two month.
     : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $bc1Ad.ONE_DAY);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $bc1Ad.ONE_HOUR);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $bc1Ad.ONE_MINUTE) : (0, $bc1Ad.ONE_SECOND);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval) {
    return $jmSNG.nice(approxInterval, true);
}
function $14d5d447dd592e99$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $bc1Ad.getPrimaryTimeUnit)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $bc1Ad.monthSetterName)(isUTC)](0);
        case 'day':
            outDate[(0, $bc1Ad.dateSetterName)(isUTC)](1);
        case 'hour':
            outDate[(0, $bc1Ad.hoursSetterName)(isUTC)](0);
        case 'minute':
            outDate[(0, $bc1Ad.minutesSetterName)(isUTC)](0);
        case 'second':
            outDate[(0, $bc1Ad.secondsSetterName)(isUTC)](0);
            outDate[(0, $bc1Ad.millisecondsSetterName)(isUTC)](0);
    }
    return outDate.getTime();
}
function $14d5d447dd592e99$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $bc1Ad.timeUnits);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName](); // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        } // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($14d5d447dd592e99$var$isUnitValueSame((0, $bc1Ad.getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $14d5d447dd592e99$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $bc1Ad.ONE_DAY) / 365));
                    getterName = (0, $bc1Ad.fullYearGetterName)(isUTC);
                    setterName = (0, $bc1Ad.fullYearSetterName)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $14d5d447dd592e99$var$getMonthInterval(approxInterval);
                    getterName = (0, $bc1Ad.monthGetterName)(isUTC);
                    setterName = (0, $bc1Ad.monthSetterName)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $14d5d447dd592e99$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $bc1Ad.dateGetterName)(isUTC);
                    setterName = (0, $bc1Ad.dateSetterName)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $14d5d447dd592e99$var$getHourInterval(approxInterval);
                    getterName = (0, $bc1Ad.hoursGetterName)(isUTC);
                    setterName = (0, $bc1Ad.hoursSetterName)(isUTC);
                    break;
                case 'minute':
                    interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $bc1Ad.minutesGetterName)(isUTC);
                    setterName = (0, $bc1Ad.minutesSetterName)(isUTC);
                    break;
                case 'second':
                    interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $bc1Ad.secondsGetterName)(isUTC);
                    setterName = (0, $bc1Ad.secondsSetterName)(isUTC);
                    break;
                case 'millisecond':
                    interval = $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $bc1Ad.millisecondsGetterName)(isUTC);
                    setterName = (0, $bc1Ad.millisecondsSetterName)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
         // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $bc1Ad.getPrimaryTimeUnit)(unitNames[i]);
        if (!(0, $bc1Ad.isPrimaryTimeUnit)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $bc1Ad.getPrimaryTimeUnit)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                 // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            } // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $bahqM.filter)((0, $bahqM.map)(levelsTicks, function(levelTicks) {
        return (0, $bahqM.filter)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    }); // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $fEgWg.default).registerClass($14d5d447dd592e99$var$TimeScale);
var $14d5d447dd592e99$export$2e2bcd8739ae039 = $14d5d447dd592e99$var$TimeScale;

});

parcelRegister("73kgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5228888966b0d10c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $fEgWg = parcelRequire("fEgWg");

var $jmSNG = parcelRequire("jmSNG");

var $32MHg = parcelRequire("32MHg");

var $6kObD = parcelRequire("6kObD");
var $5228888966b0d10c$var$scaleProto = (0, $fEgWg.default).prototype; // FIXME:TS refactor: not good to call it directly with `this`?
var $5228888966b0d10c$var$intervalScaleProto = (0, $6kObD.default).prototype;
var $5228888966b0d10c$var$roundingErrorFix = $jmSNG.round;
var $5228888966b0d10c$var$mathFloor = Math.floor;
var $5228888966b0d10c$var$mathCeil = Math.ceil;
var $5228888966b0d10c$var$mathPow = Math.pow;
var $5228888966b0d10c$var$mathLog = Math.log;
var $5228888966b0d10c$var$LogScale = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $6kObD.default)(); // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $5228888966b0d10c$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $bahqM.map(ticks, function(tick) {
            var val = tick.value;
            var powVal = $jmSNG.round($5228888966b0d10c$var$mathPow(this.base, val)); // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = this.base;
        start = $5228888966b0d10c$var$mathLog(start) / $5228888966b0d10c$var$mathLog(base);
        end = $5228888966b0d10c$var$mathLog(end) / $5228888966b0d10c$var$mathLog(base);
        $5228888966b0d10c$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $5228888966b0d10c$var$scaleProto.getExtent.call(this);
        extent[0] = $5228888966b0d10c$var$mathPow(base, extent[0]);
        extent[1] = $5228888966b0d10c$var$mathPow(base, extent[1]); // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $5228888966b0d10c$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $5228888966b0d10c$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $5228888966b0d10c$var$mathLog(extent[0]) / $5228888966b0d10c$var$mathLog(base);
        extent[1] = $5228888966b0d10c$var$mathLog(extent[1]) / $5228888966b0d10c$var$mathLog(base);
        $5228888966b0d10c$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.niceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $jmSNG.quantity(span);
        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
         // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $jmSNG.round($5228888966b0d10c$var$mathCeil(extent[0] / interval) * interval),
            $jmSNG.round($5228888966b0d10c$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.niceExtent = function(opt) {
        $5228888966b0d10c$var$intervalScaleProto.niceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
        return $32MHg.contain(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
        return $32MHg.normalize(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $32MHg.scale(val, this._extent);
        return $5228888966b0d10c$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $fEgWg.default));
var $5228888966b0d10c$var$proto = $5228888966b0d10c$var$LogScale.prototype;
$5228888966b0d10c$var$proto.getMinorTicks = $5228888966b0d10c$var$intervalScaleProto.getMinorTicks;
$5228888966b0d10c$var$proto.getLabel = $5228888966b0d10c$var$intervalScaleProto.getLabel;
function $5228888966b0d10c$var$fixRoundingError(val, originalVal) {
    return $5228888966b0d10c$var$roundingErrorFix(val, $jmSNG.getPrecision(originalVal));
}
(0, $fEgWg.default).registerClass($5228888966b0d10c$var$LogScale);
var $5228888966b0d10c$export$2e2bcd8739ae039 = $5228888966b0d10c$var$LogScale;

});

parcelRegister("lo2Vo", function(module, exports) {

$parcel$export(module.exports, "parseAxisModelMinMax", () => $f91e1bac53937426$export$d02f2e65dfc3c2b);
$parcel$export(module.exports, "ensureScaleRawExtentInfo", () => $f91e1bac53937426$export$5c3dbcbeb9ce7f5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");
var $f91e1bac53937426$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on ouside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get('min', true);
        if ((0, $bahqM.isFunction)(modelMinRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $bahqM.isFunction)(modelMaxRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $bahqM.isArray)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $b7ZX8.parsePercent)(boundaryGapArr[0], 1),
                (0, $b7ZX8.parsePercent)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        if (min > max) {
            min = NaN;
            max = NaN;
        }
        var isBlank = (0, $bahqM.eqNaN)(min) || (0, $bahqM.eqNaN)(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0; // minFixed = true;
             // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0; // maxFixed = true;
             // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$f91e1bac53937426$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $f91e1bac53937426$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $f91e1bac53937426$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $f91e1bac53937426$export$c35454f678e99c82(scale, model, originalExtent); // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $bahqM.eqNaN)(minMax) ? NaN : scale.parse(minMax);
}

});


parcelRegister("SsPct", function(module, exports) {

$parcel$export(module.exports, "cartesian2DDimensions", () => $0a3b6744500b73ac$export$988a008d2b9120f4);
$parcel$export(module.exports, "default", () => $0a3b6744500b73ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $1E3E8 = parcelRequire("1E3E8");

var $7j9L9 = parcelRequire("7j9L9");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");
var $0a3b6744500b73ac$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $0a3b6744500b73ac$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $0a3b6744500b73ac$var$Cartesian2D = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $0a3b6744500b73ac$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$0a3b6744500b73ac$var$canCalculateAffineTransform(xAxisScale) || !$0a3b6744500b73ac$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
         // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $izqgC.invert)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1]; // Fast path
        if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
         && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $eLEew.applyTransform)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $eLEew.applyTransform)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function() {
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]);
        var y = Math.min(yExtent[0], yExtent[1]);
        var width = Math.max(xExtent[0], xExtent[1]) - x;
        var height = Math.max(yExtent[0], yExtent[1]) - y;
        return new (0, $1E3E8.default)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $7j9L9.default));
var $0a3b6744500b73ac$export$2e2bcd8739ae039 = $0a3b6744500b73ac$var$Cartesian2D;

});
parcelRegister("7j9L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5521e0c9b22643f8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
var $5521e0c9b22643f8$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $bahqM.map(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $bahqM.filter(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $5521e0c9b22643f8$export$2e2bcd8739ae039 = $5521e0c9b22643f8$var$Cartesian;

});


parcelRegister("kBKMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00b8d3b69958a3f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $g6Gq1 = parcelRequire("g6Gq1");
var $f00b8d3b69958a3f$var$Axis2D = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $g6Gq1.default));
var $f00b8d3b69958a3f$export$2e2bcd8739ae039 = $f00b8d3b69958a3f$var$Axis2D;

});
parcelRegister("g6Gq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb9e1c59fe00c8ac$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $jmSNG = parcelRequire("jmSNG");

var $ftAX6 = parcelRequire("ftAX6");
var $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $bb9e1c59fe00c8ac$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $jmSNG.getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $jmSNG.linearMap)(data, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $jmSNG.linearMap)(coord, extent, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $ftAX6.createAxisTicks)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $bahqM.map)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber'); // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $bahqM.map)(minorTicks, function(minorTicksGroup) {
            return (0, $bahqM.map)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $ftAX6.createAxisLabels)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $ftAX6.calculateCategoryInterval)(this);
    };
    return Axis;
}();
function $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[0]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $bahqM.each)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unecessary tick added.
        a = (0, $jmSNG.round)(a);
        b = (0, $jmSNG.round)(b);
        return inverse ? a > b : a < b;
    }
}
var $bb9e1c59fe00c8ac$export$2e2bcd8739ae039 = $bb9e1c59fe00c8ac$var$Axis;

});
parcelRegister("ftAX6", function(module, exports) {

$parcel$export(module.exports, "createAxisLabels", () => $b4463a620840f7ae$export$10216ebd3e3e485e);
$parcel$export(module.exports, "createAxisTicks", () => $b4463a620840f7ae$export$7cccf6836ae8323c);
$parcel$export(module.exports, "calculateCategoryInterval", () => $b4463a620840f7ae$export$9ea1d3f146a5a65f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $b7ZX8 = parcelRequire("b7ZX8");

var $eaKsF = parcelRequire("eaKsF");

var $3GIoT = parcelRequire("3GIoT");
var $b4463a620840f7ae$var$inner = (0, $eaKsF.makeInner)();
function $b4463a620840f7ae$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryLabels(axis) : $b4463a620840f7ae$var$makeRealNumberLabels(axis);
}
function $b4463a620840f7ae$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $bahqM.map(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $b4463a620840f7ae$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $b4463a620840f7ae$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $3GIoT.getOptionCategoryInterval)(labelModel);
    var result = $b4463a620840f7ae$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($bahqM.isFunction(optionLabelInterval)) labels = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    } // Cache to avoid calling interval function repeatly.
    return $b4463a620840f7ae$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $b4463a620840f7ae$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $3GIoT.getOptionCategoryInterval)(tickModel);
    var result = $b4463a620840f7ae$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($bahqM.isFunction(optionTickInterval)) ticks = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $bahqM.map(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.
    return $b4463a620840f7ae$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $b4463a620840f7ae$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    return {
        labels: $bahqM.map(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $b4463a620840f7ae$var$getListCache(axis, prop) {
    // Because key can be funciton, and cache size always be small, we use array cache.
    return $b4463a620840f7ae$var$inner(axis)[prop] || ($b4463a620840f7ae$var$inner(axis)[prop] = []);
}
function $b4463a620840f7ae$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $b4463a620840f7ae$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) {
    var result = $b4463a620840f7ae$var$inner(axis).autoInterval;
    return result != null ? result : $b4463a620840f7ae$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $b4463a620840f7ae$export$9ea1d3f146a5a65f(axis) {
    var params = $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0; // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0; // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $b7ZX8.getBoundingRect(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top'); // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3; // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $b4463a620840f7ae$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
     && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
     && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
     // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $3GIoT.shouldShowAllLabels)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
     // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $3GIoT.makeLabelFormatter)(axis);
    var result = [];
    $bahqM.each(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}

});



parcelRegister("dBIJY", function(module, exports) {

$parcel$export(module.exports, "layout", () => $9e816f987642cbea$export$b3219800bda33a1f);
$parcel$export(module.exports, "isCartesian2DSeries", () => $9e816f987642cbea$export$c2a0b77974c5e35d);
$parcel$export(module.exports, "findAxisModels", () => $9e816f987642cbea$export$8220131ac1d61d28);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
function $9e816f987642cbea$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    } // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ]; // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($bahqM.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
     // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $9e816f987642cbea$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $9e816f987642cbea$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $bahqM.each(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $eaKsF.SINGLE_REFERRING)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}

});


parcelRegister("2rHnA", function(module, exports) {

$parcel$export(module.exports, "CartesianXAxisView", () => $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8);
$parcel$export(module.exports, "CartesianYAxisView", () => $1c7fc0a7283d68cb$export$417e1bdd0616e0dc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");
var $fHITF = parcelRequire("fHITF");
var $cZb1F = parcelRequire("cZb1F");

var $asa08 = parcelRequire("asa08");

var $atJL7 = parcelRequire("atJL7");

var $dBIJY = parcelRequire("dBIJY");

var $6dLRi = parcelRequire("6dLRi");
var $1c7fc0a7283d68cb$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $1c7fc0a7283d68cb$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $1c7fc0a7283d68cb$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $4KVOr.default();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $dBIJY.layout(gridModel, axisModel);
        var axisBuilder = new (0, $asa08.default)(axisModel, $bahqM.extend({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                    if (otherAxisType === 'value' || otherAxisType === 'log') // Still show axis tick or axisLine if other axis is value / log
                    return true;
                } // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $bahqM.each($1c7fc0a7283d68cb$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $bahqM.each($1c7fc0a7283d68cb$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $1c7fc0a7283d68cb$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this); // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $fHITF.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $6dLRi.rectCoordAxisHandleRemove)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $atJL7.default));
var $1c7fc0a7283d68cb$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = $bahqM.isArray(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            axisGroup.add(new $cZb1F.default({
                anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $bahqM.defaults({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            }));
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            axisGroup.add(new $cZb1F.default({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            }));
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $6dLRi.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($1c7fc0a7283d68cb$var$CartesianAxisView);
var $1c7fc0a7283d68cb$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($1c7fc0a7283d68cb$var$CartesianAxisView);
var $1c7fc0a7283d68cb$export$2e2bcd8739ae039 = $1c7fc0a7283d68cb$var$CartesianAxisView;

});
parcelRegister("asa08", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c446f32aef3809$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4KVOr = parcelRequire("4KVOr");parcelRequire("fHITF");
var $cZb1F = parcelRequire("cZb1F");
var $fHITF = parcelRequire("fHITF");
var $4gEFv = parcelRequire("4gEFv");

var $7QjoM = parcelRequire("7QjoM");

var $gvLUt = parcelRequire("gvLUt");

var $gaMkj = parcelRequire("gaMkj");

var $jmSNG = parcelRequire("jmSNG");

var $7yklO = parcelRequire("7yklO");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $3GIoT = parcelRequire("3GIoT");

var $3LB2b = parcelRequire("3LB2b");
var $79c446f32aef3809$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $79c446f32aef3809$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $4KVOr.default();
        this.opt = opt;
        this.axisModel = axisModel; // Default value
        (0, $bahqM.defaults)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        }); // FIXME Not use a seperate text group?
        var transformGroup = new $4KVOr.default({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        }); // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$79c446f32aef3809$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $79c446f32aef3809$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $jmSNG.remRadian)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $jmSNG.isRadianAroundZero)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $79c446f32aef3809$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
         || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $79c446f32aef3809$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        if (matrix) {
            (0, $eLEew.applyTransform)(pt1, pt1, matrix);
            (0, $eLEew.applyTransform)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $bahqM.extend)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $cZb1F.default({
            // Id for animation
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if (typeof arrows === 'string') // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if (typeof arrowSize === 'string' || typeof arrowSize === 'number') // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $7yklO.normalizeSymbolOffset)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $bahqM.each)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $7yklO.createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt1[0] + r * Math.cos(opt.rotation),
                        y: pt1[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $3LB2b.prepareLayoutList)((0, $bahqM.map)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $3LB2b.hideOverlap)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $bahqM.retrieve)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            $79c446f32aef3809$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $79c446f32aef3809$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($79c446f32aef3809$var$isNameLocationCenter(nameLocation)) labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
        else {
            labelLayout = $79c446f32aef3809$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $bahqM.retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $4gEFv.default({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $gvLUt.createTextStyle)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $fHITF.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name; // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $7QjoM.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $79c446f32aef3809$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $jmSNG.remRadian)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $jmSNG.isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $79c446f32aef3809$var$PI * 1.5 && rotationDiff > $79c446f32aef3809$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $3GIoT.shouldShowAllLabels)(axisModel.axis)) return;
     // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]); // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $79c446f32aef3809$var$ignoreEl(firstLabel);
        $79c446f32aef3809$var$ignoreEl(firstTick);
    } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $79c446f32aef3809$var$ignoreEl(nextLabel);
            $79c446f32aef3809$var$ignoreEl(nextTick);
        } else {
            $79c446f32aef3809$var$ignoreEl(firstLabel);
            $79c446f32aef3809$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $79c446f32aef3809$var$ignoreEl(lastLabel);
        $79c446f32aef3809$var$ignoreEl(lastTick);
    } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $79c446f32aef3809$var$ignoreEl(prevLabel);
            $79c446f32aef3809$var$ignoreEl(prevTick);
        } else {
            $79c446f32aef3809$var$ignoreEl(lastLabel);
            $79c446f32aef3809$var$ignoreEl(lastTick);
        }
    }
}
function $79c446f32aef3809$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $79c446f32aef3809$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
     // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $izqgC.identity([]);
    $izqgC.rotate(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($izqgC.mul([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($izqgC.mul([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $79c446f32aef3809$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $79c446f32aef3809$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $eLEew.applyTransform)(pt1, pt1, tickTransform);
            (0, $eLEew.applyTransform)(pt2, pt2, tickTransform);
        } // Tick line, Not use group transform to have better line draw
        var tickEl = new $cZb1F.default({
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $79c446f32aef3809$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $bahqM.defaults)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $bahqM.defaults)(lineStyleModel.getLineStyle(), (0, $bahqM.defaults)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $79c446f32aef3809$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $bahqM.retrieve)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels(); // Special label rotate.
    var labelRotation = ((0, $bahqM.retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $79c446f32aef3809$var$PI / 180;
    var labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $bahqM.each)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $bahqM.isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $gaMkj.default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var textEl = new $4gEFv.default({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $gvLUt.createTextStyle)(itemLabelModel, {
                text: formattedLabel,
                align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                fill: typeof textColor === 'function' ? textColor(// index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user repalce ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue; // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            (0, $7QjoM.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $79c446f32aef3809$export$2e2bcd8739ae039 = $79c446f32aef3809$var$AxisBuilder;

});
parcelRegister("3LB2b", function(module, exports) {

$parcel$export(module.exports, "prepareLayoutList", () => $2be27d213439fed1$export$6c403cad1ae3e239);
$parcel$export(module.exports, "shiftLayoutOnX", () => $2be27d213439fed1$export$b6b2b07f8ed32bd6);
$parcel$export(module.exports, "shiftLayoutOnY", () => $2be27d213439fed1$export$118c25e0932528e4);
$parcel$export(module.exports, "hideOverlap", () => $2be27d213439fed1$export$8ce774e164a49410);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1E3E8 = parcelRequire("1E3E8");
var $lM5Gp = parcelRequire("lM5Gp");
function $2be27d213439fed1$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $lM5Gp.default)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $2be27d213439fed1$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
     // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    } // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent; // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $2be27d213439fed1$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $2be27d213439fed1$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $2be27d213439fed1$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
    return $2be27d213439fed1$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $2be27d213439fed1$export$8ce774e164a49410(labelList) {
    var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $1E3E8.default)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j]; // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $lM5Gp.default)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $lM5Gp.default)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        } // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}

});


parcelRegister("atJL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a101b97b7710a5f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $8QSpd = parcelRequire("8QSpd");

var $fkskt = parcelRequire("fkskt");
var $7a101b97b7710a5f$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $7a101b97b7710a5f$var$AxisView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $8QSpd.fixValue(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $8QSpd.getAxisPointerModel(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $7a101b97b7710a5f$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $7a101b97b7710a5f$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $fkskt.default));
var $7a101b97b7710a5f$export$2e2bcd8739ae039 = $7a101b97b7710a5f$var$AxisView;

});
parcelRegister("8QSpd", function(module, exports) {

$parcel$export(module.exports, "collect", () => $671d61e645e8595c$export$bb44f104e3c54dae);
$parcel$export(module.exports, "makeKey", () => $671d61e645e8595c$export$d01b444bafb1a792);
$parcel$export(module.exports, "fixValue", () => $671d61e645e8595c$export$f5ea32e3629d8043);
$parcel$export(module.exports, "getAxisInfo", () => $671d61e645e8595c$export$bd39458db76002ab);
$parcel$export(module.exports, "getAxisPointerModel", () => $671d61e645e8595c$export$3b06fce3f68b734);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gaMkj = parcelRequire("gaMkj");

var $bahqM = parcelRequire("bahqM");
function $671d61e645e8595c$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $671d61e645e8595c$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = []; // Collect axes info.
    (0, $bahqM.each)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $671d61e645e8595c$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
        // for user. So we enable seting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $bahqM.each)(coordSys.getAxes(), (0, $bahqM.curry)(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
         && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $bahqM.each)(tooltipAxes.baseAxes, (0, $bahqM.curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $bahqM.each)(tooltipAxes.otherAxes, (0, $bahqM.curry)(saveTooltipAxisInfo, 'cross', false));
        } // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$671d61e645e8595c$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var axisKey = $671d61e645e8595c$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $671d61e645e8595c$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $bahqM.each)(fields, function(field) {
        volatileOption[field] = (0, $bahqM.clone)(tooltipAxisPointerModel.get(field));
    }); // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
    // Only these properties can be overrided from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $bahqM.defaults)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $gaMkj.default)(volatileOption, globalAxisPointerModel, ecModel));
}
function $671d61e645e8595c$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $bahqM.each)(result.coordSysAxesInfo[$671d61e645e8595c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $671d61e645e8595c$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $bahqM.isArray)(linkPropValue) && (0, $bahqM.indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $671d61e645e8595c$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $671d61e645e8595c$var$isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
     || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $671d61e645e8595c$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$671d61e645e8595c$export$d01b444bafb1a792(axisModel)];
}
function $671d61e645e8595c$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $671d61e645e8595c$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $671d61e645e8595c$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}

});


parcelRegister("6dLRi", function(module, exports) {

$parcel$export(module.exports, "rectCoordAxisBuildSplitArea", () => $487914b46b0b3c46$export$c80b7ef1527ec8c9);
$parcel$export(module.exports, "rectCoordAxisHandleRemove", () => $487914b46b0b3c46$export$48ebf2d6ce8ad076);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $eaKsF = parcelRequire("eaKsF");
var $487914b46b0b3c46$var$inner = (0, $eaKsF.makeInner)();
function $487914b46b0b3c46$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
     // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
     // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $487914b46b0b3c46$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $bahqM.createHashMap();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $bahqM.isArray(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $7Tw7u.default({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $bahqM.defaults({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $487914b46b0b3c46$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $487914b46b0b3c46$export$48ebf2d6ce8ad076(axisView) {
    $487914b46b0b3c46$var$inner(axisView).splitAreaColors = null;
}

});




parcelRegister("48mDj", function(module, exports) {

$parcel$export(module.exports, "install", () => $3029774200831710$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $hpWan = parcelRequire("hpWan");

var $9wang = parcelRequire("9wang");

var $ce402 = parcelRequire("ce402");
function $3029774200831710$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $9wang.default));
    registers.registerComponentView((0, $ce402.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hpWan.default)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

});
parcelRegister("hpWan", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae1e41edf2dca89$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");
function $cae1e41edf2dca89$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $bahqM.isArray)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}

});

parcelRegister("9wang", function(module, exports) {

$parcel$export(module.exports, "default", () => $6edf264d439d7d08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h8Fle = parcelRequire("h8Fle");
var $6edf264d439d7d08$var$MarkLineModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        //symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $h8Fle.default));
var $6edf264d439d7d08$export$2e2bcd8739ae039 = $6edf264d439d7d08$var$MarkLineModel;

});
parcelRegister("h8Fle", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a34092fe996af9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $guzSc = parcelRequire("guzSc");

var $h4UlH = parcelRequire("h4UlH");

var $eaKsF = parcelRequire("eaKsF");

var $j5lKL = parcelRequire("j5lKL");
function $c7a34092fe996af9$var$fillLabel(opt) {
    (0, $eaKsF.defaultEmphasis)(opt, 'label', [
        'show'
    ]);
} // { [componentType]: MarkerModel }
var $c7a34092fe996af9$var$inner = (0, $eaKsF.makeInner)();
var $c7a34092fe996af9$var$MarkerModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $hZfwb.default).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $c7a34092fe996af9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $c7a34092fe996af9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $c7a34092fe996af9$var$fillLabel(markerOpt);
                $bahqM.each(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $c7a34092fe996af9$var$fillLabel(item[0]);
                        $c7a34092fe996af9$var$fillLabel(item[1]);
                    } else $c7a34092fe996af9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $bahqM.extend(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $c7a34092fe996af9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $j5lKL.createTooltipMarkup)('section', {
            header: this.name,
            blocks: [
                (0, $j5lKL.createTooltipMarkup)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, componentType) {
        return $c7a34092fe996af9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $h4UlH.default));
$bahqM.mixin($c7a34092fe996af9$var$MarkerModel, (0, $guzSc.DataFormatMixin).prototype);
var $c7a34092fe996af9$export$2e2bcd8739ae039 = $c7a34092fe996af9$var$MarkerModel;

});


parcelRegister("ce402", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e69e51972a54af1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $liBXN = parcelRequire("liBXN");

var $jmSNG = parcelRequire("jmSNG");

var $gjRnj = parcelRequire("gjRnj");

var $2JPY0 = parcelRequire("2JPY0");

var $k3pUt = parcelRequire("k3pUt");

var $5R8Hi = parcelRequire("5R8Hi");

var $40dMe = parcelRequire("40dMe");

var $7QjoM = parcelRequire("7QjoM");

var $h8Fle = parcelRequire("h8Fle");

var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");

var $fk5Gm = parcelRequire("fk5Gm");
var $8e69e51972a54af1$var$inner = (0, $eaKsF.makeInner)();
var $8e69e51972a54af1$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $bahqM.isArray)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
         || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $bahqM.retrieve)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $gjRnj.getAxisInfo(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $5R8Hi.getStackedDimension)(data, axisInfo.valueDataDim);
                value = $gjRnj.numCalculate(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point
            var mlFrom = (0, $bahqM.clone)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && typeof value === 'number') value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $gjRnj.dataTransform(seriesModel, itemArray[0]),
        $gjRnj.dataTransform(seriesModel, itemArray[1]),
        (0, $bahqM.extend)({}, itemArray[2])
    ]; // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option
    (0, $bahqM.merge)(normalizedItem[2], normalizedItem[0]);
    (0, $bahqM.merge)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $8e69e51972a54af1$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim
function $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $8e69e51972a54af1$var$isInifinity(fromCoord[otherDimIndex]) && $8e69e51972a54af1$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $8e69e51972a54af1$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord; // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($8e69e51972a54af1$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $8e69e51972a54af1$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $gjRnj.dataFilter(coordSys, item[0]) && $gjRnj.dataFilter(coordSys, item[1]);
}
function $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $jmSNG.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = $jmSNG.parsePercent(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $40dMe.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($8e69e51972a54af1$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($8e69e51972a54af1$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $8e69e51972a54af1$var$MarkLineView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $8e69e51972a54af1$var$inner(mlModel).from;
                var toData_1 = $8e69e51972a54af1$var$inner(mlModel).to; // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $8e69e51972a54af1$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $8e69e51972a54af1$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                }); // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $2JPY0.default)());
        this.group.add(lineDraw.group);
        var mlData = $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $8e69e51972a54af1$var$inner(mlModel).from = fromData;
        $8e69e51972a54af1$var$inner(mlModel).to = toData; // Line data for tooltip and formatter
        mlModel.setData(lineData); // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint
        if (!(0, $bahqM.isArray)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $bahqM.isArray)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $bahqM.isArray)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $bahqM.isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
         // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        }); // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData); // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el, idx) {
            el.traverse(function(child) {
                (0, $7QjoM.getECData)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $8e69e51972a54af1$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $fk5Gm.getVisualFromData)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $bahqM.retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $bahqM.retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $bahqM.retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $bahqM.retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $k3pUt.default));
function $8e69e51972a54af1$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $bahqM.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $bahqM.extend)((0, $bahqM.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $liBXN.default)(coordDimsInfos, mlModel);
    var toData = new (0, $liBXN.default)(coordDimsInfos, mlModel); // No dimensions
    var lineData = new (0, $liBXN.default)([], mlModel);
    var optData = (0, $bahqM.map)(mlModel.get('data'), (0, $bahqM.curry)($8e69e51972a54af1$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $bahqM.filter)(optData, (0, $bahqM.curry)($8e69e51972a54af1$var$markLineFilter, coordSys));
    var dimValueGetter = $gjRnj.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    fromData.initData((0, $bahqM.map)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $bahqM.map)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $bahqM.map)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $8e69e51972a54af1$export$2e2bcd8739ae039 = $8e69e51972a54af1$var$MarkLineView;

});
parcelRegister("gjRnj", function(module, exports) {

$parcel$export(module.exports, "numCalculate", () => $be17d2d7c679ee45$export$18ddefb55c03640b);
$parcel$export(module.exports, "dataTransform", () => $be17d2d7c679ee45$export$3eebd2d54b98c04f);
$parcel$export(module.exports, "getAxisInfo", () => $be17d2d7c679ee45$export$bd39458db76002ab);
$parcel$export(module.exports, "dataFilter", () => $be17d2d7c679ee45$export$179695f4a9040f73);
$parcel$export(module.exports, "createMarkerDimValueGetter", () => $be17d2d7c679ee45$export$a53767c3c8f69cf7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $5R8Hi = parcelRequire("5R8Hi");

var $bahqM = parcelRequire("bahqM");

var $2G90t = parcelRequire("2G90t");
function $be17d2d7c679ee45$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $be17d2d7c679ee45$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $be17d2d7c679ee45$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $5R8Hi.isDimensionStacked)(data, targetDataDim);
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $be17d2d7c679ee45$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
    var precision = $jmSNG.getPrecision(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
} // TODO Specified percent
var $be17d2d7c679ee45$var$markerTypeCalculator = {
    min: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $bahqM.curry)($be17d2d7c679ee45$var$markerTypeCalculatorWithExtent, 'median')
};
function $be17d2d7c679ee45$export$3eebd2d54b98c04f(seriesModel, item) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (item && !$be17d2d7c679ee45$var$hasXAndY(item) && !(0, $bahqM.isArray)(item.coord) && coordSys) {
        var dims = coordSys.dimensions;
        var axisInfo = $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel); // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $bahqM.clone)(item);
        if (item.type && $be17d2d7c679ee45$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $bahqM.indexOf)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $bahqM.indexOf)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $be17d2d7c679ee45$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0]; // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else {
            // FIXME Only has one of xAxis and yAxis.
            var coord = [
                item.xAxis != null ? item.xAxis : item.radiusAxis,
                item.yAxis != null ? item.yAxis : item.angleAxis
            ]; // Each coord support max, min, average
            for(var i = 0; i < 2; i++)if ($be17d2d7c679ee45$var$markerTypeCalculator[coord[i]]) coord[i] = $be17d2d7c679ee45$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
            item.coord = coord;
        }
    }
    return item;
}
function $be17d2d7c679ee45$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $be17d2d7c679ee45$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $be17d2d7c679ee45$export$179695f4a9040f73(coordSys, item) {
    // Alwalys return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$be17d2d7c679ee45$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $be17d2d7c679ee45$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 // x, y, radius, angle
         ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $2G90t.parseDataValue)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $2G90t.parseDataValue)(item.value, dims[dimIndex]);
    };
}
function $be17d2d7c679ee45$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}

});

parcelRegister("2JPY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe8183fc890aada$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4KVOr = parcelRequire("4KVOr");

var $hKTLM = parcelRequire("hKTLM");

var $gvLUt = parcelRequire("gvLUt");
var $1fe8183fc890aada$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $4KVOr.default();
        this._LineCtor = LineCtor || (0, $hKTLM.default);
    }
    LineDraw.prototype.isPersistent = function() {
        return true;
    };
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData; // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $1fe8183fc890aada$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$1fe8183fc890aada$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$1fe8183fc890aada$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$1fe8183fc890aada$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $1fe8183fc890aada$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $1fe8183fc890aada$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: hostModel.getModel([
            'emphasis',
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        labelStatesModels: (0, $gvLUt.getLabelStatesModels)(hostModel)
    };
}
function $1fe8183fc890aada$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $1fe8183fc890aada$var$lineNeedsDraw(pts) {
    return !$1fe8183fc890aada$var$isPointNaN(pts[0]) && !$1fe8183fc890aada$var$isPointNaN(pts[1]);
}
var $1fe8183fc890aada$export$2e2bcd8739ae039 = $1fe8183fc890aada$var$LineDraw;

});
parcelRegister("hKTLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced1fe40d771d409$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $eLEew = parcelRequire("eLEew");

var $7yklO = parcelRequire("7yklO");

var $iUQRt = parcelRequire("iUQRt");

var $4KVOr = parcelRequire("4KVOr");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $fIXXx = parcelRequire("fIXXx");

var $gvLUt = parcelRequire("gvLUt");

var $jmSNG = parcelRequire("jmSNG");
var $ced1fe40d771d409$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */ function $ced1fe40d771d409$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $7yklO.normalizeSymbolSize(symbolSize);
    var symbolOffsetArr = $7yklO.normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $7yklO.createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $ced1fe40d771d409$var$createLine(points) {
    var line = new (0, $iUQRt.default)({
        name: 'line',
        subPixelOptimize: true
    });
    $ced1fe40d771d409$var$setLinePoints(line.shape, points);
    return line;
}
function $ced1fe40d771d409$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $ced1fe40d771d409$var$Line = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $ced1fe40d771d409$var$createLine(linePoints);
        line.shape.percent = 0;
        $eYgMC.initProps(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    }; // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $ced1fe40d771d409$var$setLinePoints(target.shape, linePoints);
        $eYgMC.updateProps(line, target, seriesModel, idx);
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = lineData.getItemVisual(idx, symbolCategory);
            var key = $ced1fe40d771d409$var$makeSymbolTypeKey(symbolCategory); // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $ced1fe40d771d409$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels; // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            emphasisLineStyle = itemModel.getModel([
                'emphasis',
                'lineStyle'
            ]).getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            labelStatesModels = (0, $gvLUt.getLabelStatesModels)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle; // Update symbol
        (0, $bahqM.each)($ced1fe40d771d409$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
                    var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $gvLUt.setLabelStyle)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || '#000',
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $jmSNG.round)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $bahqM.isArray)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $fIXXx.enableHoverEmphasis)(this);
    };
    Line.prototype.highlight = function() {
        (0, $fIXXx.enterEmphasis)(this);
    };
    Line.prototype.downplay = function() {
        (0, $fIXXx.leaveEmphasis)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $ced1fe40d771d409$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent(); // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line'); // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $eLEew.sub([], toPos, fromPos);
        $eLEew.normalize(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($4KVOr.default);
var $ced1fe40d771d409$export$2e2bcd8739ae039 = $ced1fe40d771d409$var$Line;

});
parcelRegister("iUQRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc56761fbff4269e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");
parcelRequire("fHITF");
var $04gw0 = parcelRequire("04gw0");
var $cZb1F = parcelRequire("cZb1F");
var $ghQ8v = parcelRequire("ghQ8v");

var $eLEew = parcelRequire("eLEew");
var $dc56761fbff4269e$var$straightLineProto = $cZb1F.default.prototype;
var $dc56761fbff4269e$var$bezierCurveProto = $04gw0.default.prototype;
var $dc56761fbff4269e$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0; // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $dc56761fbff4269e$var$CurveShape = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($dc56761fbff4269e$var$StraightLineShape);
function $dc56761fbff4269e$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $dc56761fbff4269e$var$ECLinePath = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $dc56761fbff4269e$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($dc56761fbff4269e$var$isStraightLine(shape)) $dc56761fbff4269e$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $dc56761fbff4269e$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($dc56761fbff4269e$var$isStraightLine(this.shape)) return $dc56761fbff4269e$var$straightLineProto.pointAt.call(this, t);
        else return $dc56761fbff4269e$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $dc56761fbff4269e$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $dc56761fbff4269e$var$bezierCurveProto.tangentAt.call(this, t);
        return $eLEew.normalize(p, p);
    };
    return ECLinePath;
}($ghQ8v.default);
var $dc56761fbff4269e$export$2e2bcd8739ae039 = $dc56761fbff4269e$var$ECLinePath;

});



parcelRegister("k3pUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9982f98742e3477$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fkskt = parcelRequire("fkskt");

var $bahqM = parcelRequire("bahqM");

var $h8Fle = parcelRequire("h8Fle");

var $eaKsF = parcelRequire("eaKsF");

var $fIXXx = parcelRequire("fIXXx");
var $e9982f98742e3477$var$inner = (0, $eaKsF.makeInner)();
var $e9982f98742e3477$var$MarkerView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $bahqM.createHashMap)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $e9982f98742e3477$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$e9982f98742e3477$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $e9982f98742e3477$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.blurSeries = function(seriesModelList) {
        var _this = this;
        (0, $bahqM.each)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) (0, $fIXXx.enterBlur)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $fkskt.default));
var $e9982f98742e3477$export$2e2bcd8739ae039 = $e9982f98742e3477$var$MarkerView;

});



parcelRegister("gLj36", function(module, exports) {

$parcel$export(module.exports, "install", () => $c33fcfdcc4592871$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hi3Y7 = parcelRequire("hi3Y7");

var $alpND = parcelRequire("alpND");

var $ixwqj = parcelRequire("ixwqj");

var $kfWc4 = parcelRequire("kfWc4");
function $c33fcfdcc4592871$export$4b3e715f166fdd78(registers) {
    (0, $alpND.use)((0, $hi3Y7.install));
    registers.registerComponentModel((0, $ixwqj.default));
    registers.registerComponentView((0, $kfWc4.default));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, function() {});
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, function() {});
}

});
parcelRegister("hi3Y7", function(module, exports) {

$parcel$export(module.exports, "install", () => $c9673230869c3336$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $atJL7 = parcelRequire("atJL7");

var $4SGoL = parcelRequire("4SGoL");

var $5UrR7 = parcelRequire("5UrR7");

var $gPvBV = parcelRequire("gPvBV");

var $bahqM = parcelRequire("bahqM");

var $8QSpd = parcelRequire("8QSpd");

var $5TxwA = parcelRequire("5TxwA");
function $c9673230869c3336$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $atJL7.default).registerAxisPointerClass('CartesianAxisPointer', (0, $4SGoL.default));
    registers.registerComponentModel((0, $5UrR7.default));
    registers.registerComponentView((0, $gPvBV.default));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $bahqM.isArray)(link)) option.axisPointer.link = [
                link
            ];
        }
    }); // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $8QSpd.collect)(ecModel, api);
    }); // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $5TxwA.default));
}

});
parcelRegister("4SGoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $38dd17fca85a901b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $fOZs6 = parcelRequire("fOZs6");

var $eSE0c = parcelRequire("eSE0c");

var $dBIJY = parcelRequire("dBIJY");
var $38dd17fca85a901b$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $eSE0c.buildElStyle(axisPointerModel);
            var pointerOption = $38dd17fca85a901b$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $dBIJY.layout(grid.model, axisModel);
        $eSE0c.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $dBIJY.layout(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        }); // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $eSE0c.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $fOZs6.default));
function $38dd17fca85a901b$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $38dd17fca85a901b$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $eSE0c.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $38dd17fca85a901b$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $eSE0c.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $38dd17fca85a901b$var$getAxisDimIndex(axis))
        };
    }
};
function $38dd17fca85a901b$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $38dd17fca85a901b$export$2e2bcd8739ae039 = $38dd17fca85a901b$var$CartesianAxisPointer;

});
parcelRegister("fOZs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b84b31aa9defeeb8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fHITF = parcelRequire("fHITF");

var $8QSpd = parcelRequire("8QSpd");

var $65X4x = parcelRequire("65X4x");

var $ljaBy = parcelRequire("ljaBy");

var $eaKsF = parcelRequire("eaKsF");
var $b84b31aa9defeeb8$var$inner = (0, $eaKsF.makeInner)();
var $b84b31aa9defeeb8$var$clone = $bahqM.clone;
var $b84b31aa9defeeb8$var$bind = $bahqM.bind;
/**
 * Base axis pointer class in 2D.
 */ var $b84b31aa9defeeb8$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api; // Optimize: `render` will be called repeatly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show(); // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $fHITF.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $bahqM.curry($b84b31aa9defeeb8$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
             // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $8QSpd.getAxisInfo(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent(); // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl = new $fHITF[pointerOption.type]($b84b31aa9defeeb8$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl = new $fHITF.Text($b84b31aa9defeeb8$var$clone(elOption.label));
            group.add(labelEl);
            $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $fHITF.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // Fot mobile devicem, prevent screen slider on the button.
                    $65X4x.stop(e.event);
                },
                onmousedown: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this),
                ondragend: $b84b31aa9defeeb8$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $b84b31aa9defeeb8$var$updateMandatoryProps(handle, axisPointerModel, false); // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ])); // update position
        var handleSize = handleModel.get('size');
        if (!$bahqM.isArray(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $ljaBy.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $b84b31aa9defeeb8$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b84b31aa9defeeb8$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true; // Persistent for throttle.
        var trans = this.updateHandleTransform($b84b31aa9defeeb8$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($b84b31aa9defeeb8$var$getHandleTransProps(trans));
        $b84b31aa9defeeb8$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {};
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $b84b31aa9defeeb8$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$b84b31aa9defeeb8$var$propsEqual($b84b31aa9defeeb8$var$inner(el).lastProp, props)) {
        $b84b31aa9defeeb8$var$inner(el).lastProp = props;
        moveAnimation ? $fHITF.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $b84b31aa9defeeb8$var$propsEqual(lastProps, newProps) {
    if ($bahqM.isObject(lastProps) && $bahqM.isObject(newProps)) {
        var equals_1 = true;
        $bahqM.each(newProps, function(item, key) {
            equals_1 = equals_1 && $b84b31aa9defeeb8$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $b84b31aa9defeeb8$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $b84b31aa9defeeb8$export$2e2bcd8739ae039 = $b84b31aa9defeeb8$var$BaseAxisPointer;

});

parcelRegister("eSE0c", function(module, exports) {

$parcel$export(module.exports, "buildElStyle", () => $ad552373bbd775da$export$b7fe459c7cc50060);
$parcel$export(module.exports, "buildLabelElOption", () => $ad552373bbd775da$export$8206a9937c45910f);
$parcel$export(module.exports, "getValueLabel", () => $ad552373bbd775da$export$7cffee0f9aed39d0);
$parcel$export(module.exports, "getTransformedPosition", () => $ad552373bbd775da$export$4bb66440324c3a3d);
$parcel$export(module.exports, "buildCartesianSingleLabelElOption", () => $ad552373bbd775da$export$fd3eb3812211a173);
$parcel$export(module.exports, "makeLineShape", () => $ad552373bbd775da$export$885fa0ad5a826207);
$parcel$export(module.exports, "makeRectShape", () => $ad552373bbd775da$export$a8b35248bcc02756);
$parcel$export(module.exports, "makeSectorShape", () => $ad552373bbd775da$export$b0cf82e7ebc0d7d0);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $fHITF = parcelRequire("fHITF");

var $b7ZX8 = parcelRequire("b7ZX8");

var $dCJrM = parcelRequire("dCJrM");

var $izqgC = parcelRequire("izqgC");

var $3GIoT = parcelRequire("3GIoT");

var $asa08 = parcelRequire("asa08");

var $gvLUt = parcelRequire("gvLUt");
function $ad552373bbd775da$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $ad552373bbd775da$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $dCJrM.normalizeCssArray(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $b7ZX8.getBoundingRect(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
    $ad552373bbd775da$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $gvLUt.createTextStyle)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Lable should be over axisPointer.
        z2: 10
    };
} // Do not overflow ec container
function $ad552373bbd775da$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $ad552373bbd775da$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $3GIoT.getAxisRawValue(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $bahqM.each(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($bahqM.isString(formatter)) text = formatter.replace('{value}', text);
        else if ($bahqM.isFunction(formatter)) text = formatter(params_1);
    }
    return text;
}
function $ad552373bbd775da$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $izqgC.create();
    $izqgC.rotate(transform, transform, layoutInfo.rotation);
    $izqgC.translate(transform, transform, layoutInfo.position);
    return $fHITF.applyTransform([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $ad552373bbd775da$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $asa08.default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $ad552373bbd775da$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $ad552373bbd775da$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $ad552373bbd775da$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $ad552373bbd775da$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}

});


parcelRegister("5UrR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d7ca4f96167e1d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $44d7ca4f96167e1d$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $h4UlH.default));
var $44d7ca4f96167e1d$export$2e2bcd8739ae039 = $44d7ca4f96167e1d$var$AxisPointerModel;

});

parcelRegister("gPvBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c409edfe4aa8d133$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $iNebh = parcelRequire("iNebh");

var $fkskt = parcelRequire("fkskt");
var $c409edfe4aa8d133$var$AxisPointerView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $iNebh.register('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $iNebh.unregister('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $iNebh.unregister('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $fkskt.default));
var $c409edfe4aa8d133$export$2e2bcd8739ae039 = $c409edfe4aa8d133$var$AxisPointerView;

});
parcelRegister("iNebh", function(module, exports) {

$parcel$export(module.exports, "register", () => $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $dae7cd9e0e79e4d2$export$d07f55d4c15c0440);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $eaKsF = parcelRequire("eaKsF");
var $dae7cd9e0e79e4d2$var$inner = (0, $eaKsF.makeInner)();
var $dae7cd9e0e79e4d2$var$each = $bahqM.each;
function $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $hZfwb.default).node) return;
    var zr = api.getZr();
    $dae7cd9e0e79e4d2$var$inner(zr).records || ($dae7cd9e0e79e4d2$var$inner(zr).records = {});
    $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api);
    var record = $dae7cd9e0e79e4d2$var$inner(zr).records[key] || ($dae7cd9e0e79e4d2$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api) {
    if ($dae7cd9e0e79e4d2$var$inner(zr).initialized) return;
    $dae7cd9e0e79e4d2$var$inner(zr).initialized = true;
    useHandler('click', $bahqM.curry($dae7cd9e0e79e4d2$var$doEnter, 'click'));
    useHandler('mousemove', $bahqM.curry($dae7cd9e0e79e4d2$var$doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
    useHandler('globalout', $dae7cd9e0e79e4d2$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $dae7cd9e0e79e4d2$var$makeDispatchAction(api);
            $dae7cd9e0e79e4d2$var$each($dae7cd9e0e79e4d2$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $dae7cd9e0e79e4d2$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $dae7cd9e0e79e4d2$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $dae7cd9e0e79e4d2$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    }; // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $dae7cd9e0e79e4d2$export$d07f55d4c15c0440(key, api) {
    if ((0, $hZfwb.default).node) return;
    var zr = api.getZr();
    var record = ($dae7cd9e0e79e4d2$var$inner(zr).records || {})[key];
    if (record) $dae7cd9e0e79e4d2$var$inner(zr).records[key] = null;
}

});


parcelRegister("5TxwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $44ac1811f8c8020d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $8QSpd = parcelRequire("8QSpd");

var $4LkI5 = parcelRequire("4LkI5");

var $bahqM = parcelRequire("bahqM");
var $44ac1811f8c8020d$var$inner = (0, $eaKsF.makeInner)();
function $44ac1811f8c8020d$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $bahqM.bind)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($44ac1811f8c8020d$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4LkI5.default)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $44ac1811f8c8020d$var$illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $44ac1811f8c8020d$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $bahqM.curry)($44ac1811f8c8020d$var$showPointer, showValueMap),
        showTooltip: (0, $bahqM.curry)($44ac1811f8c8020d$var$showTooltip, dataByCoordSys)
    }; // Process for triggered axes.
    (0, $bahqM.each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $bahqM.each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $44ac1811f8c8020d$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    }); // Process for linked axes.
    var linkTriggers = {};
    (0, $bahqM.each)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $bahqM.each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $44ac1811f8c8020d$var$makeMapperParam(srcAxisInfo), $44ac1811f8c8020d$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $bahqM.each)(linkTriggers, function(val, tarKey) {
        $44ac1811f8c8020d$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $44ac1811f8c8020d$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    } // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $44ac1811f8c8020d$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $bahqM.extend)(outputFinder, payloadBatch[0]);
     // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $44ac1811f8c8020d$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $bahqM.each)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff); // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $bahqM.each)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $44ac1811f8c8020d$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $44ac1811f8c8020d$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $8QSpd.makeKey(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $bahqM.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value; // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
         // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($44ac1811f8c8020d$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    } // In most case only one axis (or event one series is used). It is
    // convinient to fetch payload.seriesIndex and payload.dataIndex
    // dirtectly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification shoule be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] || {};
    var newHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $bahqM.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && (0, $bahqM.each)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    }); // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $bahqM.each)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $bahqM.each)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $44ac1811f8c8020d$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $44ac1811f8c8020d$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

});
parcelRegister("4LkI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $377b9dcb49ed57dc$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eaKsF = parcelRequire("eaKsF");
function $377b9dcb49ed57dc$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $eaKsF.queryDataIndex(data, finder);
    if (dataIndex == null || dataIndex < 0 || $bahqM.isArray(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($bahqM.map(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}

});



parcelRegister("ixwqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f475abbf81e4fb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h4UlH = parcelRequire("h4UlH");
var $d7f475abbf81e4fb$var$TooltipModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        displayMode: 'single',
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: '#fff',
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: '#999',
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            } // lineStyle and shadowStyle should not be specified here,
        },
        textStyle: {
            color: '#666',
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $h4UlH.default));
var $d7f475abbf81e4fb$export$2e2bcd8739ae039 = $d7f475abbf81e4fb$var$TooltipModel;

});

parcelRegister("kfWc4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf2596432d1aebb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $hZfwb = parcelRequire("hZfwb");

var $lh5Tz = parcelRequire("lh5Tz");

var $bf1zw = parcelRequire("bf1zw");

var $dCJrM = parcelRequire("dCJrM");

var $jmSNG = parcelRequire("jmSNG");
parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");

var $4LkI5 = parcelRequire("4LkI5");

var $65MS1 = parcelRequire("65MS1");

var $gaMkj = parcelRequire("gaMkj");

var $iNebh = parcelRequire("iNebh");

var $3GIoT = parcelRequire("3GIoT");

var $eSE0c = parcelRequire("eSE0c");

var $eaKsF = parcelRequire("eaKsF");

var $fkskt = parcelRequire("fkskt");

var $bc1Ad = parcelRequire("bc1Ad");

var $7QjoM = parcelRequire("7QjoM");

var $l3AHA = parcelRequire("l3AHA");

var $guzSc = parcelRequire("guzSc");

var $j5lKL = parcelRequire("j5lKL");

var $6IsbX = parcelRequire("6IsbX");

var $ljaBy = parcelRequire("ljaBy");
var $ebf2596432d1aebb$var$bind = $bahqM.bind;
var $ebf2596432d1aebb$var$each = $bahqM.each;
var $ebf2596432d1aebb$var$parsePercent = $jmSNG.parsePercent;
var $ebf2596432d1aebb$var$proxyRect = new $7Tw7u.default({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $ebf2596432d1aebb$var$TooltipView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $hZfwb.default).node) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = tooltipModel.get('renderMode');
        this._renderMode = (0, $eaKsF.getTooltipRenderMode)(renderMode);
        this._tooltipContent = this._renderMode === 'richText' ? new (0, $bf1zw.default)(api) : new (0, $lh5Tz.default)(api.getDom(), api, {
            appendToBody: tooltipModel.get('appendToBody', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $hZfwb.default).node) return;
         // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        /**
     * @private
     * @type {boolean}
     */ this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow(); // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the updatePosition was also called very frequently.
        // In Chrome with devtools open and Firefox, tooltip looks lagged and shaked around. See #14695.
        // To avoid the frequent triggering,
        // consider throttling it in 50ms. (the tested result may need to validate)
        this._updatePosition = this._renderMode === 'html' ? (0, $ljaBy.throttle)($ebf2596432d1aebb$var$bind(this._doUpdatePosition, this), 50) : this._doUpdatePosition;
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $iNebh.register('itemTooltip', this._api, $ebf2596432d1aebb$var$bind(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api; // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
         && tooltipModel.get('triggerOn') !== 'none') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $hZfwb.default).node) return;
        var dispatchAction = $ebf2596432d1aebb$var$makeDispatchAction(payload, api); // Reset ticket
        this._ticket = ''; // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $ebf2596432d1aebb$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $7QjoM.getECData)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            }; // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4LkI5.default)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($ebf2596432d1aebb$var$makeDispatchAction(payload, api));
    }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex; // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $ebf2596432d1aebb$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
         // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $6IsbX.findEventDispatcher)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $7QjoM.getECData)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                } // Tooltip provided directly. Like legend.
                if ((0, $7QjoM.getECData)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = $bahqM.bind(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $j5lKL.createTooltipMarkup)('section', {
            blocks: [],
            noHeader: true
        }); // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)();
        $ebf2596432d1aebb$var$each(dataByCoordSys, function(itemCoordSys) {
            $ebf2596432d1aebb$var$each(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $eSE0c.getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $j5lKL.createTooltipMarkup)('section', {
                    header: axisValueLabel,
                    noHeader: !$bahqM.trim(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                $bahqM.each(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex); // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $3GIoT.getAxisRawValue(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', $dCJrM.convertToColorString(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $guzSc.normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                    if (seriesTooltipResult.markupFragment) axisSectionMarkup.blocks.push(seriesTooltipResult.markupFragment);
                    if (seriesTooltipResult.markupText) markupTextArrLegacy.push(seriesTooltipResult.markupText);
                    cbParamsList.push(cbParams);
                });
            });
        }); // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $j5lKL.buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $7QjoM.getECData)(dispatcher); // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $ebf2596432d1aebb$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)(); // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', $dCJrM.convertToColorString(params.color), renderMode);
        var seriesTooltipResult = (0, $guzSc.normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var markupText = seriesTooltipResult.markupFragment ? (0, $j5lKL.buildTooltipMarkup)(seriesTooltipResult.markupFragment, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.markupText;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        }); // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var ecData = (0, $7QjoM.getECData)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        if ($bahqM.isString(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
         // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they can not share the same formatter. Since the global tooltip formatter is used for series
        // by convension, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $ebf2596432d1aebb$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $j5lKL.TooltipMarkupStyleCreator)(); // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = $bahqM.clone(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        }); // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ($bahqM.isString(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = $bahqM.isArray(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $bc1Ad.format)(params0.axisValue, html, useUTC);
                html = $dCJrM.formatTpl(html, params, true);
            } else if ($bahqM.isFunction(formatter)) {
                var callback = $ebf2596432d1aebb$var$bind(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === 'axis' || $bahqM.isArray(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
        };
        if (!$bahqM.isArray(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._doUpdatePosition = function(tooltipModel, positionExpr, x, y, content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ($bahqM.isFunction(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ($bahqM.isArray(positionExpr)) {
            x = $ebf2596432d1aebb$var$parsePercent(positionExpr[0], viewWidth);
            y = $ebf2596432d1aebb$var$parsePercent(positionExpr[1], viewHeight);
        } else if ($bahqM.isObject(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = $65MS1.getLayoutRect(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null; // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ($bahqM.isString(positionExpr) && el) {
            var pos = $ebf2596432d1aebb$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $ebf2596432d1aebb$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $ebf2596432d1aebb$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $l3AHA.shouldTooltipConfine)(tooltipModel)) {
            var pos = $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    }; // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && $ebf2596432d1aebb$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && $ebf2596432d1aebb$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && $ebf2596432d1aebb$var$each(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                }); // check is cbParams data value changed
                lastCbParamsList && $bahqM.each(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $hZfwb.default).node) return;
        this._tooltipContent.dispose();
        $iNebh.unregister('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $fkskt.default));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $ebf2596432d1aebb$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $gaMkj.default)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $gaMkj.default)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $gaMkj.default)) tooltipOpt = tooltipOpt.get('tooltip', true);
             // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ($bahqM.isString(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $gaMkj.default)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $ebf2596432d1aebb$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || $bahqM.bind(api.dispatchAction, api);
}
function $ebf2596432d1aebb$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in defaut tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $ebf2596432d1aebb$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $ebf2596432d1aebb$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $eaKsF.preParseFinder)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $eaKsF.queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $7QjoM.getECData)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $ebf2596432d1aebb$export$2e2bcd8739ae039 = $ebf2596432d1aebb$var$TooltipView;

});
parcelRegister("lh5Tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cfc2302c12dfb3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $65X4x = parcelRequire("65X4x");

var $6AZf6 = parcelRequire("6AZf6");

var $hZfwb = parcelRequire("hZfwb");

var $dCJrM = parcelRequire("dCJrM");

var $l3AHA = parcelRequire("l3AHA");

var $j5lKL = parcelRequire("j5lKL");
/* global document, window */ var $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR = (0, $l3AHA.toCSSVendorPrefix)((0, $l3AHA.TRANSITION_VENDOR), 'transition');
var $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR = (0, $l3AHA.toCSSVendorPrefix)((0, $l3AHA.TRANSFORM_VENDOR), 'transform'); // eslint-disable-next-line
var $f7cfc2302c12dfb3$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $hZfwb.default).transform3dSupported ? 'will-change:transform;' : '');
function $f7cfc2302c12dfb3$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $bahqM.isString)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $dCJrM.convertToColorString)(borderColor);
    var arrowPos = $f7cfc2302c12dfb3$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $bahqM.indexOf)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $f7cfc2302c12dfb3$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $hZfwb.default).transformSupported ? "," + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $f7cfc2302c12dfb3$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $f7cfc2302c12dfb3$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.
    if (!(0, $hZfwb.default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
     // support transform
    var is3d = (0, $hZfwb.default).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $f7cfc2302c12dfb3$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $l3AHA.TRANSFORM_VENDOR),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $f7cfc2302c12dfb3$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    fontSize // @ts-ignore, leave it to the tooltip refactor.
     && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $bahqM.each)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $j5lKL.getPaddingFromTooltipModel)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($f7cfc2302c12dfb3$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) {
        if ((0, $hZfwb.default).canvasSupported) cssText.push('background-color:' + backgroundColor);
        else {
            // for ie
            cssText.push('background-color:#' + (0, $d6udH.toHex)(backgroundColor));
            cssText.push('filter:alpha(opacity=70)');
        }
    } // Border style
    (0, $bahqM.each)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $dCJrM.toCamelCase)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    }); // Text style
    cssText.push($f7cfc2302c12dfb3$var$assembleFont(textStyleModel)); // Padding
    if (padding != null) cssText.push('padding:' + (0, $dCJrM.normalizeCssArray)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.
function $f7cfc2302c12dfb3$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (appendToBody) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $6AZf6.transformLocalCoord)(out, zrViewportRoot, document.body, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $f7cfc2302c12dfb3$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(container, api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $hZfwb.default).wxa) return null;
        var el = document.createElement('div'); // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendToBody = this._appendToBody = opt && opt.appendToBody;
        $f7cfc2302c12dfb3$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
        if (appendToBody) document.body.appendChild(el);
        else container.appendChild(el);
        this._container = container; // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $65X4x.normalizeEvent)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        var container = this._container;
        var position = (0, $l3AHA.getComputedStyle)(container, 'position');
        var domStyle = container.style;
        if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
         // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized(); // update className
        this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $f7cfc2302c12dfb3$var$gCssText + $f7cfc2302c12dfb3$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
         + $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $dCJrM.convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '' // If mouse occasionally move over the tooltip, a mouseout event will be
        ) + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $bahqM.isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $l3AHA.shouldTooltipConfine)(tooltipModel)) arrow = $f7cfc2302c12dfb3$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $bahqM.isString)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $bahqM.isArray)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $bahqM.isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
             // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return [
            el.offsetWidth,
            el.offsetHeight
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $f7cfc2302c12dfb3$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $f7cfc2302c12dfb3$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $bahqM.each)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = 'hidden';
        style.opacity = '0';
        (0, $hZfwb.default).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $bahqM.bind)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        this.el.parentNode.removeChild(this.el);
    };
    return TooltipHTMLContent;
}();
var $f7cfc2302c12dfb3$export$2e2bcd8739ae039 = $f7cfc2302c12dfb3$var$TooltipHTMLContent;

});
parcelRegister("l3AHA", function(module, exports) {

$parcel$export(module.exports, "shouldTooltipConfine", () => $f54659081207367d$export$a309528050824ba4);
$parcel$export(module.exports, "TRANSFORM_VENDOR", () => $f54659081207367d$export$7b4286b1e4a23439);
$parcel$export(module.exports, "TRANSITION_VENDOR", () => $f54659081207367d$export$70a631ae991b5e76);
$parcel$export(module.exports, "toCSSVendorPrefix", () => $f54659081207367d$export$5886acafe29a08d1);
$parcel$export(module.exports, "getComputedStyle", () => $f54659081207367d$export$3735103072e4a80);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");

var $hZfwb = parcelRequire("hZfwb");
function $f54659081207367d$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
     : tooltipModel.get('renderMode') === 'richText';
}
function $f54659081207367d$var$testStyle(styleProps) {
    if (!(0, $hZfwb.default).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $f54659081207367d$export$7b4286b1e4a23439 = $f54659081207367d$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $f54659081207367d$export$70a631ae991b5e76 = $f54659081207367d$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $f54659081207367d$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $dCJrM.toCamelCase)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $f54659081207367d$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}

});


parcelRegister("bf1zw", function(module, exports) {

$parcel$export(module.exports, "default", () => $82f2508e80aaa8db$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $4gEFv = parcelRequire("4gEFv");

var $j5lKL = parcelRequire("j5lKL");

var $2cFRc = parcelRequire("2cFRc");
var $82f2508e80aaa8db$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._zr = api.getZr();
        $82f2508e80aaa8db$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        if ($bahqM.isObject(content)) (0, $2cFRc.throwError)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $4gEFv.default)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                backgroundColor: tooltipModel.get('backgroundColor'),
                borderRadius: tooltipModel.get('borderRadius'),
                borderWidth: 1,
                borderColor: borderColor,
                shadowColor: tooltipModel.get('shadowColor'),
                shadowBlur: tooltipModel.get('shadowBlur'),
                shadowOffsetX: tooltipModel.get('shadowOffsetX'),
                shadowOffsetY: tooltipModel.get('shadowOffsetY'),
                textShadowColor: textStyleModel.get('textShadowColor'),
                textShadowBlur: textStyleModel.get('textShadowBlur') || 0,
                textShadowOffsetX: textStyleModel.get('textShadowOffsetX') || 0,
                textShadowOffsetY: textStyleModel.get('textShadowOffsetY') || 0,
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $j5lKL.getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $82f2508e80aaa8db$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $82f2508e80aaa8db$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $82f2508e80aaa8db$var$calcShadowOuterSize(style); // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($bahqM.bind(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $82f2508e80aaa8db$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $82f2508e80aaa8db$var$calcShadowOuterSize(style) {
    var shadowBlur = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $82f2508e80aaa8db$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $82f2508e80aaa8db$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $82f2508e80aaa8db$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $82f2508e80aaa8db$export$2e2bcd8739ae039 = $82f2508e80aaa8db$var$TooltipRichContent;

});



parcelRegister("ixV1I", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jtdCU = parcelRequire("jtdCU");
$parcel$exportWildcard(module.exports, $jtdCU);

});
parcelRegister("jtdCU", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Core API from echarts/src/echarts

var $8pqpA = parcelRequire("8pqpA");

var $a7GWb = parcelRequire("a7GWb");

var $alpND = parcelRequire("alpND");

var $fKViU = parcelRequire("fKViU");
(0, $alpND.use)((0, $fKViU.installLabelLayout));
$parcel$exportWildcard(module.exports, $8pqpA);
$parcel$exportWildcard(module.exports, $a7GWb);

});
parcelRegister("a7GWb", function(module, exports) {

$parcel$export(module.exports, "extendComponentModel", () => $75ebdd55a0204a2b$export$4dd01020bb736662);
$parcel$export(module.exports, "extendComponentView", () => $75ebdd55a0204a2b$export$a4336148da8ef02);
$parcel$export(module.exports, "extendSeriesModel", () => $75ebdd55a0204a2b$export$fe6d3114e3fc260c);
$parcel$export(module.exports, "extendChartView", () => $75ebdd55a0204a2b$export$c750883d1b603e83);
$parcel$export(module.exports, "zrender", () => (parcelRequire("9Y5KT")));
$parcel$export(module.exports, "matrix", () => (parcelRequire("izqgC")));
$parcel$export(module.exports, "vector", () => (parcelRequire("eLEew")));
$parcel$export(module.exports, "zrUtil", () => (parcelRequire("bahqM")));
$parcel$export(module.exports, "color", () => (parcelRequire("d6udH")));
$parcel$export(module.exports, "throttle", () => (parcelRequire("ljaBy")).throttle);
$parcel$export(module.exports, "helper", () => (parcelRequire("anaTl")));
$parcel$export(module.exports, "use", () => (parcelRequire("alpND")).use);
$parcel$export(module.exports, "parseGeoJSON", () => (parcelRequire("gyzY7")).default);
$parcel$export(module.exports, "parseGeoJson", () => (parcelRequire("gyzY7")).default);
$parcel$export(module.exports, "number", () => (parcelRequire("hJg2M")));
$parcel$export(module.exports, "time", () => (parcelRequire("ats4w")));
$parcel$export(module.exports, "graphic", () => (parcelRequire("fwli1")));
$parcel$export(module.exports, "format", () => (parcelRequire("byxPd")));
$parcel$export(module.exports, "util", () => (parcelRequire("fvUv7")));
$parcel$export(module.exports, "env", () => (parcelRequire("hZfwb")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("liBXN")).default);
$parcel$export(module.exports, "Model", () => (parcelRequire("gaMkj")).default);
$parcel$export(module.exports, "Axis", () => (parcelRequire("g6Gq1")).default);
$parcel$export(module.exports, "ComponentModel", () => (parcelRequire("h4UlH")).default);
$parcel$export(module.exports, "ComponentView", () => (parcelRequire("fkskt")).default);
$parcel$export(module.exports, "SeriesModel", () => (parcelRequire("1O7Ua")).default);
$parcel$export(module.exports, "ChartView", () => (parcelRequire("loerw")).default);
$parcel$export(module.exports, "innerDrawElementOnCanvas", () => (parcelRequire("aSzOj")).brushSingle);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.

var $h4UlH = parcelRequire("h4UlH");

var $fkskt = parcelRequire("fkskt");

var $1O7Ua = parcelRequire("1O7Ua");

var $loerw = parcelRequire("loerw");

var $liBXN = parcelRequire("liBXN");

var $9Y5KT = parcelRequire("9Y5KT");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $bahqM = parcelRequire("bahqM");

var $d6udH = parcelRequire("d6udH");

var $ljaBy = parcelRequire("ljaBy");

var $anaTl = parcelRequire("anaTl");

var $alpND = parcelRequire("alpND");

var $gyzY7 = parcelRequire("gyzY7");

var $hJg2M = parcelRequire("hJg2M");

var $ats4w = parcelRequire("ats4w");

var $fwli1 = parcelRequire("fwli1");

var $byxPd = parcelRequire("byxPd");

var $fvUv7 = parcelRequire("fvUv7");

var $hZfwb = parcelRequire("hZfwb");

var $gaMkj = parcelRequire("gaMkj");

var $g6Gq1 = parcelRequire("g6Gq1");

var $aSzOj = parcelRequire("aSzOj");
function $75ebdd55a0204a2b$export$4dd01020bb736662(proto) {
    var Model = (0, $h4UlH.default).extend(proto);
    (0, $h4UlH.default).registerClass(Model);
    return Model;
}
function $75ebdd55a0204a2b$export$a4336148da8ef02(proto) {
    var View = (0, $fkskt.default).extend(proto);
    (0, $fkskt.default).registerClass(View);
    return View;
}
function $75ebdd55a0204a2b$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $1O7Ua.default).extend(proto);
    (0, $1O7Ua.default).registerClass(Model);
    return Model;
}
function $75ebdd55a0204a2b$export$c750883d1b603e83(proto) {
    var View = (0, $loerw.default).extend(proto);
    (0, $loerw.default).registerClass(View);
    return View;
}

});
parcelRegister("anaTl", function(module, exports) {

$parcel$export(module.exports, "createList", () => $78d480381111bb0c$export$5897d8d7c7a3d871);
$parcel$export(module.exports, "dataStack", () => $78d480381111bb0c$export$d6100971d5a3a0a7);
$parcel$export(module.exports, "createScale", () => $78d480381111bb0c$export$587d9c3c553380c6);
$parcel$export(module.exports, "mixinAxisModelCommonMethods", () => $78d480381111bb0c$export$4665cbe3470e4d57);
$parcel$export(module.exports, "createTextStyle", () => $78d480381111bb0c$export$f8998c3d0a13de59);
$parcel$export(module.exports, "getLayoutRect", () => (parcelRequire("65MS1")).getLayoutRect);
$parcel$export(module.exports, "createDimensions", () => (parcelRequire("h9jiS")).createDimensions);
$parcel$export(module.exports, "createSymbol", () => (parcelRequire("7yklO")).createSymbol);
$parcel$export(module.exports, "getECData", () => (parcelRequire("7QjoM")).getECData);
$parcel$export(module.exports, "enableHoverEmphasis", () => (parcelRequire("fIXXx")).enableHoverEmphasis);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 
var $bahqM = parcelRequire("bahqM");

var $bAY5l = parcelRequire("bAY5l");

var $3GIoT = parcelRequire("3GIoT");

var $5pBRm = parcelRequire("5pBRm");

var $gaMkj = parcelRequire("gaMkj");

var $65MS1 = parcelRequire("65MS1");

var $5R8Hi = parcelRequire("5R8Hi");

var $7QjoM = parcelRequire("7QjoM");

var $gvLUt = parcelRequire("gvLUt");

var $h9jiS = parcelRequire("h9jiS");

var $7yklO = parcelRequire("7yklO");

var $fIXXx = parcelRequire("fIXXx");
function $78d480381111bb0c$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $bAY5l.default)(null, seriesModel);
} // export function createGraph(seriesModel) {
var $78d480381111bb0c$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $5R8Hi.isDimensionStacked),
    enableDataStack: (0, $5R8Hi.enableDataStack),
    getStackedDimension: (0, $5R8Hi.getStackedDimension)
};
function $78d480381111bb0c$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $gaMkj.default))) axisModel = new (0, $gaMkj.default)(option); // FIXME
    var scale = $3GIoT.createScaleByModel(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $3GIoT.niceScaleExtent(scale, axisModel);
    return scale;
}
function $78d480381111bb0c$export$4665cbe3470e4d57(Model) {
    $bahqM.mixin(Model, (0, $5pBRm.AxisModelCommonMixin));
}
function $78d480381111bb0c$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $gvLUt.createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
}

});

parcelRegister("hJg2M", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => (parcelRequire("jmSNG")).linearMap);
$parcel$export(module.exports, "round", () => (parcelRequire("jmSNG")).round);
$parcel$export(module.exports, "asc", () => (parcelRequire("jmSNG")).asc);
$parcel$export(module.exports, "getPrecision", () => (parcelRequire("jmSNG")).getPrecision);
$parcel$export(module.exports, "getPrecisionSafe", () => (parcelRequire("jmSNG")).getPrecisionSafe);
$parcel$export(module.exports, "getPixelPrecision", () => (parcelRequire("jmSNG")).getPixelPrecision);
$parcel$export(module.exports, "getPercentWithPrecision", () => (parcelRequire("jmSNG")).getPercentWithPrecision);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => (parcelRequire("jmSNG")).MAX_SAFE_INTEGER);
$parcel$export(module.exports, "remRadian", () => (parcelRequire("jmSNG")).remRadian);
$parcel$export(module.exports, "isRadianAroundZero", () => (parcelRequire("jmSNG")).isRadianAroundZero);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("jmSNG")).parseDate);
$parcel$export(module.exports, "quantity", () => (parcelRequire("jmSNG")).quantity);
$parcel$export(module.exports, "quantityExponent", () => (parcelRequire("jmSNG")).quantityExponent);
$parcel$export(module.exports, "nice", () => (parcelRequire("jmSNG")).nice);
$parcel$export(module.exports, "quantile", () => (parcelRequire("jmSNG")).quantile);
$parcel$export(module.exports, "reformIntervals", () => (parcelRequire("jmSNG")).reformIntervals);
$parcel$export(module.exports, "isNumeric", () => (parcelRequire("jmSNG")).isNumeric);
$parcel$export(module.exports, "numericToNumber", () => (parcelRequire("jmSNG")).numericToNumber);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

});

parcelRegister("ats4w", function(module, exports) {

$parcel$export(module.exports, "parse", () => (parcelRequire("jmSNG")).parseDate);
$parcel$export(module.exports, "format", () => (parcelRequire("bc1Ad")).format);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jmSNG = parcelRequire("jmSNG");

var $bc1Ad = parcelRequire("bc1Ad");

});

parcelRegister("fwli1", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => (parcelRequire("fHITF")).extendShape);
$parcel$export(module.exports, "extendPath", () => (parcelRequire("fHITF")).extendPath);
$parcel$export(module.exports, "makePath", () => (parcelRequire("fHITF")).makePath);
$parcel$export(module.exports, "makeImage", () => (parcelRequire("fHITF")).makeImage);
$parcel$export(module.exports, "mergePath", () => (parcelRequire("fHITF")).mergePath);
$parcel$export(module.exports, "resizePath", () => (parcelRequire("fHITF")).resizePath);
$parcel$export(module.exports, "createIcon", () => (parcelRequire("fHITF")).createIcon);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("eYgMC")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("eYgMC")).initProps);
$parcel$export(module.exports, "getTransform", () => (parcelRequire("fHITF")).getTransform);
$parcel$export(module.exports, "clipPointsByRect", () => (parcelRequire("fHITF")).clipPointsByRect);
$parcel$export(module.exports, "clipRectByRect", () => (parcelRequire("fHITF")).clipRectByRect);
$parcel$export(module.exports, "registerShape", () => (parcelRequire("fHITF")).registerShape);
$parcel$export(module.exports, "getShapeClass", () => (parcelRequire("fHITF")).getShapeClass);
$parcel$export(module.exports, "Group", () => (parcelRequire("4KVOr")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("gcbBH")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("4gEFv")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("jjfok")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("kVeV8")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("elGBV")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("LCHOw")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("lQwBc")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("32bXc")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("7Tw7u")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("cZb1F")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("04gw0")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("ixXaU")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("6sllV")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("eGltS")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("9J7f8")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("faICo")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("1E3E8")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("fHITF");
var $ixXaU = parcelRequire("ixXaU");
var $04gw0 = parcelRequire("04gw0");
var $jjfok = parcelRequire("jjfok");
var $fHITF = parcelRequire("fHITF");
var $kVeV8 = parcelRequire("kVeV8");
var $gcbBH = parcelRequire("gcbBH");
var $cZb1F = parcelRequire("cZb1F");
var $lQwBc = parcelRequire("lQwBc");
var $32bXc = parcelRequire("32bXc");
var $7Tw7u = parcelRequire("7Tw7u");
var $LCHOw = parcelRequire("LCHOw");
var $elGBV = parcelRequire("elGBV");
var $eYgMC = parcelRequire("eYgMC");
var $1E3E8 = parcelRequire("1E3E8");
var $eGltS = parcelRequire("eGltS");
var $4KVOr = parcelRequire("4KVOr");
var $6sllV = parcelRequire("6sllV");
var $eYgMC = parcelRequire("eYgMC");
var $9J7f8 = parcelRequire("9J7f8");
var $faICo = parcelRequire("faICo");
var $4gEFv = parcelRequire("4gEFv");

});

parcelRegister("byxPd", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => (parcelRequire("dCJrM")).addCommas);
$parcel$export(module.exports, "toCamelCase", () => (parcelRequire("dCJrM")).toCamelCase);
$parcel$export(module.exports, "normalizeCssArray", () => (parcelRequire("dCJrM")).normalizeCssArray);
$parcel$export(module.exports, "encodeHTML", () => (parcelRequire("dCJrM")).encodeHTML);
$parcel$export(module.exports, "formatTpl", () => (parcelRequire("dCJrM")).formatTpl);
$parcel$export(module.exports, "getTooltipMarker", () => (parcelRequire("dCJrM")).getTooltipMarker);
$parcel$export(module.exports, "formatTime", () => (parcelRequire("dCJrM")).formatTime);
$parcel$export(module.exports, "capitalFirst", () => (parcelRequire("dCJrM")).capitalFirst);
$parcel$export(module.exports, "truncateText", () => (parcelRequire("h6fMM")).truncateText);
$parcel$export(module.exports, "getTextRect", () => (parcelRequire("2emZ2")).getTextRect);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $dCJrM = parcelRequire("dCJrM");
var $2emZ2 = parcelRequire("2emZ2");
var $h6fMM = parcelRequire("h6fMM");

});

parcelRegister("fvUv7", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("bahqM")).map);
$parcel$export(module.exports, "each", () => (parcelRequire("bahqM")).each);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("bahqM")).indexOf);
$parcel$export(module.exports, "inherits", () => (parcelRequire("bahqM")).inherits);
$parcel$export(module.exports, "reduce", () => (parcelRequire("bahqM")).reduce);
$parcel$export(module.exports, "filter", () => (parcelRequire("bahqM")).filter);
$parcel$export(module.exports, "bind", () => (parcelRequire("bahqM")).bind);
$parcel$export(module.exports, "curry", () => (parcelRequire("bahqM")).curry);
$parcel$export(module.exports, "isArray", () => (parcelRequire("bahqM")).isArray);
$parcel$export(module.exports, "isString", () => (parcelRequire("bahqM")).isString);
$parcel$export(module.exports, "isObject", () => (parcelRequire("bahqM")).isObject);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("bahqM")).isFunction);
$parcel$export(module.exports, "extend", () => (parcelRequire("bahqM")).extend);
$parcel$export(module.exports, "defaults", () => (parcelRequire("bahqM")).defaults);
$parcel$export(module.exports, "clone", () => (parcelRequire("bahqM")).clone);
$parcel$export(module.exports, "merge", () => (parcelRequire("bahqM")).merge);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

});


parcelRegister("fKViU", function(module, exports) {

$parcel$export(module.exports, "installLabelLayout", () => $b7879a416965ee89$export$5320d1b3745c02a5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eaKsF = parcelRequire("eaKsF");

var $JIQqQ = parcelRequire("JIQqQ");
var $b7879a416965ee89$var$getLabelManager = (0, $eaKsF.makeInner)();
function $b7879a416965ee89$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager = new (0, $JIQqQ.default)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

});
parcelRegister("JIQqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0896fd4d6c482b72$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.

var $1E3E8 = parcelRequire("1E3E8");
var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $jmSNG = parcelRequire("jmSNG");

var $e6gef = parcelRequire("e6gef");

var $fxCHE = parcelRequire("fxCHE");

var $eaKsF = parcelRequire("eaKsF");

var $bahqM = parcelRequire("bahqM");

var $3LB2b = parcelRequire("3LB2b");

var $gvLUt = parcelRequire("gvLUt");
function $0896fd4d6c482b72$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $0896fd4d6c482b72$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $0896fd4d6c482b72$var$dummyTransformable = new (0, $e6gef.default)();
var $0896fd4d6c482b72$var$labelLayoutInnerStore = (0, $eaKsF.makeInner)();
var $0896fd4d6c482b72$var$labelLineAnimationStore = (0, $eaKsF.makeInner)();
function $0896fd4d6c482b72$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $0896fd4d6c482b72$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1E3E8.default).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $0896fd4d6c482b72$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $0896fd4d6c482b72$var$dummyTransformable.x = $0896fd4d6c482b72$var$dummyTransformable.y = $0896fd4d6c482b72$var$dummyTransformable.rotation = $0896fd4d6c482b72$var$dummyTransformable.originX = $0896fd4d6c482b72$var$dummyTransformable.originY = 0;
            $0896fd4d6c482b72$var$dummyTransformable.scaleX = $0896fd4d6c482b72$var$dummyTransformable.scaleY = 1;
        }
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1E3E8.default).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $0896fd4d6c482b72$var$dummyTransformable.x,
                y: $0896fd4d6c482b72$var$dummyTransformable.y,
                scaleX: $0896fd4d6c482b72$var$dummyTransformable.scaleX,
                scaleY: $0896fd4d6c482b72$var$dummyTransformable.scaleY,
                rotation: $0896fd4d6c482b72$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $bahqM.isFunction)(layoutOption) || (0, $bahqM.keys)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
             // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $7QjoM.getECData)(child); // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $fxCHE.updateLabelLinePoints)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0; // TODO A global layout option?
            if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $jmSNG.parsePercent)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $jmSNG.parsePercent)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    }); // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $3LB2b.prepareLayoutList)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $3LB2b.shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
        (0, $3LB2b.shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $bahqM.filter)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $3LB2b.hideOverlap)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $bahqM.each)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $0896fd4d6c482b72$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent(); // Update label line style.
        var ecData = (0, $7QjoM.getECData)(el);
        var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            var visualType = data.getVisual('drawType'); // Default to be same with main color
            defaultStyle.stroke = visualStyle[visualType];
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $fxCHE.setLabelLineStyle)(el, (0, $fxCHE.getLabelLineStatesModels)(itemModel), defaultStyle);
            (0, $fxCHE.updateLabelLinePoints)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine(); // Animate
        if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $eYgMC.isElementRemoved)(el)) {
            var layoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $7QjoM.getECData)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps); // Disable fade in animation if value animation is enabled.
                if (!(0, $gvLUt.labelInner)(textEl).valueAnimation) {
                    var oldOpacity = (0, $bahqM.retrieve2)(textEl.style.opacity, 1); // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $eYgMC.initProps)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout); // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $bahqM.indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $bahqM.indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $eYgMC.updateProps)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, textEl.states.select, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
            }
            (0, $gvLUt.animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $0896fd4d6c482b72$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $eYgMC.initProps)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $eYgMC.updateProps)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $0896fd4d6c482b72$export$2e2bcd8739ae039 = $0896fd4d6c482b72$var$LabelManager;

});
parcelRegister("fxCHE", function(module, exports) {

$parcel$export(module.exports, "updateLabelLinePoints", () => $02eb7bb47d256bbb$export$cc93ba643cd97d83);
$parcel$export(module.exports, "limitTurnAngle", () => $02eb7bb47d256bbb$export$ac52062003fbe6a);
$parcel$export(module.exports, "limitSurfaceAngle", () => $02eb7bb47d256bbb$export$973e1fdb2708f71b);
$parcel$export(module.exports, "setLabelLineStyle", () => $02eb7bb47d256bbb$export$c09e0b0574bdd2dc);
$parcel$export(module.exports, "getLabelLineStatesModels", () => $02eb7bb47d256bbb$export$2979fdbf5ebce521);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");
var $32bXc = parcelRequire("32bXc");
var $bMDnR = parcelRequire("bMDnR");

var $aA4Ws = parcelRequire("aA4Ws");

var $kvt3T = parcelRequire("kvt3T");

var $dr1jo = parcelRequire("dr1jo");

var $bahqM = parcelRequire("bahqM");

var $izqgC = parcelRequire("izqgC");

var $eLEew = parcelRequire("eLEew");

var $fIXXx = parcelRequire("fIXXx");
var $02eb7bb47d256bbb$var$PI2 = Math.PI * 2;
var $02eb7bb47d256bbb$var$CMD = (0, $aA4Ws.default).CMD;
var $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $02eb7bb47d256bbb$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d; // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $02eb7bb47d256bbb$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kvt3T.normalizeRadian)(endAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kvt3T.normalizeRadian)(startAngle);
        endAngle = (0, $kvt3T.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $02eb7bb47d256bbb$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $02eb7bb47d256bbb$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $02eb7bb47d256bbb$var$PI2 >= startAngle && angle + $02eb7bb47d256bbb$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $02eb7bb47d256bbb$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen; // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $02eb7bb47d256bbb$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $02eb7bb47d256bbb$var$tmpPt = [];
function $02eb7bb47d256bbb$var$nearestPointOnRect(pt, rect, out) {
    var dist = $02eb7bb47d256bbb$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $02eb7bb47d256bbb$var$tmpPt);
    out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $02eb7bb47d256bbb$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $02eb7bb47d256bbb$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $02eb7bb47d256bbb$var$CMD.L:
                d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.C:
                d = (0, $dr1jo.cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.Q:
                d = (0, $dr1jo.quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $02eb7bb47d256bbb$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++]; // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $02eb7bb47d256bbb$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $02eb7bb47d256bbb$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $02eb7bb47d256bbb$var$projectPointToRect(x0, y0, width, height, x, y, $02eb7bb47d256bbb$var$tmpPt);
                break;
            case $02eb7bb47d256bbb$var$CMD.Z:
                d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, x0, y0, x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
        }
    }
    return minDist;
} // Temporal varible for intermediate usage.
var $02eb7bb47d256bbb$var$pt0 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$pt1 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$pt2 = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$dir = new (0, $bMDnR.default)();
var $02eb7bb47d256bbb$var$dir2 = new (0, $bMDnR.default)();
function $02eb7bb47d256bbb$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent(); // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $izqgC.invert)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $02eb7bb47d256bbb$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $02eb7bb47d256bbb$var$getCandidateAnchor(candidate, 0, labelRect, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir);
        (0, $bMDnR.default).scaleAndAdd($02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir, len); // Transform to target coord space.
        $02eb7bb47d256bbb$var$pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($02eb7bb47d256bbb$var$pt1) : target instanceof (0, $ghQ8v.default) ? $02eb7bb47d256bbb$var$nearestPointOnPath($02eb7bb47d256bbb$var$pt1, target.path, $02eb7bb47d256bbb$var$pt2) : $02eb7bb47d256bbb$var$nearestPointOnRect($02eb7bb47d256bbb$var$pt1, boundingRect, $02eb7bb47d256bbb$var$pt2); // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist; // Transform back to global space.
            $02eb7bb47d256bbb$var$pt1.transform(targetTransform);
            $02eb7bb47d256bbb$var$pt2.transform(targetTransform);
            $02eb7bb47d256bbb$var$pt2.toArray(points[0]);
            $02eb7bb47d256bbb$var$pt1.toArray(points[1]);
            $02eb7bb47d256bbb$var$pt0.toArray(points[2]);
        }
    }
    $02eb7bb47d256bbb$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
} // Temporal variable for the limitTurnAngle function
var $02eb7bb47d256bbb$var$tmpArr = [];
var $02eb7bb47d256bbb$var$tmpProjPoint = new (0, $bMDnR.default)();
function $02eb7bb47d256bbb$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
    $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
    $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$pt1);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
    var len1 = $02eb7bb47d256bbb$var$dir.len();
    var len2 = $02eb7bb47d256bbb$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $02eb7bb47d256bbb$var$dir.scale(1 / len1);
    $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
    var angleCos = $02eb7bb47d256bbb$var$dir.dot($02eb7bb47d256bbb$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
        $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point
        $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.
        var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
        else if (t > 1) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $02eb7bb47d256bbb$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
    $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
    $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0);
    (0, $bMDnR.default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
    var len1 = $02eb7bb47d256bbb$var$dir.len();
    var len2 = $02eb7bb47d256bbb$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $02eb7bb47d256bbb$var$dir.scale(1 / len1);
    $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
    var angleCos = $02eb7bb47d256bbb$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
        $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($02eb7bb47d256bbb$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.
            var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
            else if (t > 1) (0, $bMDnR.default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
        }
        $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $02eb7bb47d256bbb$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.
    stateObj.ignore = ignore; // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $02eb7bb47d256bbb$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $eLEew.dist(points[0], points[1]);
        var len2 = $eLEew.dist(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $eLEew.lerp([], points[1], points[0], moveLen / len1);
        var midPoint2 = $eLEew.lerp([], points[1], points[2], moveLen / len2);
        var midPoint1 = $eLEew.lerp([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $02eb7bb47d256bbb$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $fIXXx.DISPLAY_STATES).length; i++){
        var stateName = (0, $fIXXx.DISPLAY_STATES)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $bahqM.retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $bahqM.retrieve2)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                if (stateObj) stateObj.ignore = true;
                continue;
            } // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $32bXc.default)();
                targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $02eb7bb47d256bbb$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                 // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $02eb7bb47d256bbb$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $bahqM.defaults)(labelLine.style, defaultStyle); // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.
        labelLine.buildPath = $02eb7bb47d256bbb$var$buildLabelLinePath;
    }
}
function $02eb7bb47d256bbb$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $fIXXx.SPECIAL_STATES).length; i++){
        var stateName = (0, $fIXXx.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}

});





parcelRegister("lWgYs", function(module, exports) {

$parcel$export(module.exports, "install", () => $ff8c2e783e169ee8$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e0x7p = parcelRequire("e0x7p");
function $ff8c2e783e169ee8$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('canvas', (0, $e0x7p.default));
}

});
parcelRegister("e0x7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32ac17084074784$export$2e2bcd8739ae039);

var $7y1my = parcelRequire("7y1my");

var $bahqM = parcelRequire("bahqM");

var $kNXN5 = parcelRequire("kNXN5");

var $04xko = parcelRequire("04xko");

var $gcbBH = parcelRequire("gcbBH");

var $hZfwb = parcelRequire("hZfwb");

var $aSzOj = parcelRequire("aSzOj");

var $aVawM = parcelRequire("aVawM");
var $a32ac17084074784$var$HOVER_LAYER_ZLEVEL = 1e5;
var $a32ac17084074784$var$CANVAS_ZLEVEL = 314159;
var $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $a32ac17084074784$var$INCREMENTAL_INC = 0.001;
function $a32ac17084074784$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $a32ac17084074784$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
    return true;
}
function $a32ac17084074784$var$createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var $a32ac17084074784$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = $bahqM.extend({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $7y1my.devicePixelRatio);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            rootStyle.webkitTapHighlightColor = 'transparent';
            rootStyle.webkitUserSelect = 'none';
            rootStyle.userSelect = 'none';
            rootStyle['-webkit-touch-callout'] = 'none';
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = this._getSize(0);
            this._height = this._getSize(1);
            var domRoot = this._domRoot = $a32ac17084074784$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $kNXN5.default)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$a32ac17084074784$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $a32ac17084074784$var$CANVAS_ZLEVEL;
            zlevelList.push($a32ac17084074784$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($a32ac17084074784$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $aSzOj.brush)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($a32ac17084074784$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $aSzOj.brushSingle)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $04xko.default)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($a32ac17084074784$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $hZfwb.default).wxa) $bahqM.each(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $aSzOj.brush)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $aSzOj.brush)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $a32ac17084074784$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $kNXN5.default)('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $bahqM.merge(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC]) $bahqM.merge(layer, this._layerConfig[zlevel - $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) {
            $bahqM.logError('ZLevel ' + zlevel + ' has been used already');
            return;
        }
        if (!$a32ac17084074784$var$isLayerValid(layer)) {
            $bahqM.logError('Layer of zlevel ' + zlevel + ' is not valid');
            return;
        }
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.__painter = this;
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $a32ac17084074784$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $bahqM.logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $aVawM.REDRAW_BIT) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $bahqM.each(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $bahqM.merge(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $a32ac17084074784$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $bahqM.merge(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($bahqM.indexOf(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($a32ac17084074784$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = this._getSize(0);
            height = this._getSize(1);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$a32ac17084074784$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $kNXN5.default)('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $aSzOj.brush)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    CanvasPainter.prototype._getSize = function(whIdx) {
        var opts = this._opts;
        var wh = [
            'width',
            'height'
        ][whIdx];
        var cwh = [
            'clientWidth',
            'clientHeight'
        ][whIdx];
        var plt = [
            'paddingLeft',
            'paddingTop'
        ][whIdx];
        var prb = [
            'paddingRight',
            'paddingBottom'
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
        var root = this.root;
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $a32ac17084074784$var$parseInt10(stl[wh]) || $a32ac17084074784$var$parseInt10(root.style[wh])) - ($a32ac17084074784$var$parseInt10(stl[plt]) || 0) - ($a32ac17084074784$var$parseInt10(stl[prb]) || 0) | 0;
    };
    CanvasPainter.prototype.pathToImage = function(path, dpr) {
        dpr = dpr || this.dpr;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var rect = path.getBoundingRect();
        var style = path.style;
        var shadowBlurSize = style.shadowBlur * dpr;
        var shadowOffsetX = style.shadowOffsetX * dpr;
        var shadowOffsetY = style.shadowOffsetY * dpr;
        var lineWidth = path.hasStroke() ? style.lineWidth : 0;
        var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
        var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
        var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
        var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
        var width = rect.width + leftMargin + rightMargin;
        var height = rect.height + topMargin + bottomMargin;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);
        ctx.dpr = dpr;
        var pathTransform = {
            x: path.x,
            y: path.y,
            scaleX: path.scaleX,
            scaleY: path.scaleY,
            rotation: path.rotation,
            originX: path.originX,
            originY: path.originY
        };
        path.x = leftMargin - rect.x;
        path.y = topMargin - rect.y;
        path.rotation = 0;
        path.scaleX = 1;
        path.scaleY = 1;
        path.updateTransform();
        if (path) (0, $aSzOj.brush)(ctx, path, {
            inHover: false,
            viewWidth: this._width,
            viewHeight: this._height
        }, true);
        var imgShape = new (0, $gcbBH.default)({
            style: {
                x: 0,
                y: 0,
                image: canvas
            }
        });
        $bahqM.extend(path, pathTransform);
        return imgShape;
    };
    return CanvasPainter;
}();
var $a32ac17084074784$export$2e2bcd8739ae039 = $a32ac17084074784$var$CanvasPainter;

});
parcelRegister("kNXN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f256c37231bc47c1$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $bahqM = parcelRequire("bahqM");

var $7y1my = parcelRequire("7y1my");

var $bRKv5 = parcelRequire("bRKv5");

var $dPYp9 = parcelRequire("dPYp9");

var $aSzOj = parcelRequire("aSzOj");

var $1E3E8 = parcelRequire("1E3E8");

var $aVawM = parcelRequire("aVawM");
function $f256c37231bc47c1$var$returnFalse() {
    return false;
}
function $f256c37231bc47c1$var$createDom(id, painter, dpr) {
    var newDom = $bahqM.createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $f256c37231bc47c1$var$Layer = function(_super) {
    (0, $3VFsf.__extends)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $7y1my.devicePixelRatio);
        if (typeof id === 'string') dom = $f256c37231bc47c1$var$createDom(id, painter, dpr);
        else if ($bahqM.isObject(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            dom.onselectstart = $f256c37231bc47c1$var$returnFalse;
            domStyle.webkitUserSelect = 'none';
            domStyle.userSelect = 'none';
            domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
            domStyle['-webkit-touch-callout'] = 'none';
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.domBack = null;
        _this.ctxBack = null;
        _this.painter = painter;
        _this.config = null;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $f256c37231bc47c1$var$createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $1E3E8.default)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $1E3E8.default)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $1E3E8.default)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $1E3E8.default)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $aVawM.REDRAW_BIT) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $aVawM.REDRAW_BIT) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if ($bahqM.isGradientObject(clearColor)) {
                    clearColorGradientOrPattern = clearColor.__canvasGradient || (0, $dPYp9.getCanvasGradient)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                } else if ($bahqM.isImagePatternObject(clearColor)) clearColorGradientOrPattern = (0, $aSzOj.createCanvasPattern)(ctx, clearColor, {
                    dirty: function() {
                        self.setUnpainted();
                        self.__painter.refresh();
                    }
                });
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $bahqM.each(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $bRKv5.default));
var $f256c37231bc47c1$export$2e2bcd8739ae039 = $f256c37231bc47c1$var$Layer;

});



var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("fNWkd", function(module, exports) {

$parcel$export(module.exports, "CHART_SPACE_LEFT", () => $b95ac19a479554c0$export$ffe1d6b5e0d7a6e5);
$parcel$export(module.exports, "CHART_SPACE_BOTTOM", () => $b95ac19a479554c0$export$bc204b53394e9283);

var $gwIPs = parcelRequire("gwIPs");
const $b95ac19a479554c0$export$ffe1d6b5e0d7a6e5 = (0, $gwIPs.gridSize) * 10;
const $b95ac19a479554c0$export$bc204b53394e9283 = (0, $gwIPs.gridSize) * 7.5;

});

parcelRegister("d5cn8", function(module, exports) {

$parcel$export(module.exports, "useHoveredDeployment", () => $4bd2cac2596c5544$export$83b9a91e43f24aaa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $4bd2cac2596c5544$export$d4c72bab9d6cc13a = {
    hoveredDeployment: null
};
const $4bd2cac2596c5544$export$e324594224ef24da = {
    setHoveredDeployment: (deploymentId)=>({ setState: setState })=>setState({
                hoveredDeployment: deploymentId
            })
};
const $4bd2cac2596c5544$var$Store = (0, $iXqE5.createStore)({
    name: 'hoveredDeployment',
    initialState: $4bd2cac2596c5544$export$d4c72bab9d6cc13a,
    actions: $4bd2cac2596c5544$export$e324594224ef24da
});
const $4bd2cac2596c5544$export$83b9a91e43f24aaa = (0, $3sQ5x.createHook)($4bd2cac2596c5544$var$Store, {
    selector: (state)=>state.hoveredDeployment
});

});

parcelRegister("gFaMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2c46eb38aef0ec8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d2c46eb38aef0ec8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yAxis: {
        "id": "software-deployment-frequency-report.batch-size-chart.chart.y-axis",
        "defaultMessage": "Batch size (issues per deployment)"
    },
    yAxisIssueTermRefresh: {
        "id": "software-deployment-frequency-report.batch-size-chart.chart.y-axis-issue-term-refresh",
        "defaultMessage": "Batch size (work items per deployment)"
    }
});

});

parcelRegister("ayFdV", function(module, exports) {

$parcel$export(module.exports, "useTooltipFormatter", () => $89cb3114dbae05b3$export$8d71e8328e9bd59b);

var $6JUGo = parcelRequire("6JUGo");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");


var $7Ra8A = parcelRequire("7Ra8A");
const $89cb3114dbae05b3$export$8d71e8328e9bd59b = ()=>{
    const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    // TODO RLSS-2812: handle dark mode with echarts
    return ({ data: data })=>{
        const { value: [dateTimeInMilliSeconds], customInfo: { issueCount: issueCount, environment: { displayName: environmentName }, pipeline: { url: pipelineUrl, displayName: pipelineName } } } = data;
        const formattedLastUpdated = formatDate(new Date(dateTimeInMilliSeconds), {
            day: 'numeric',
            month: 'short'
        });
        const issuePerDeploymentTranslated = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $7Ra8A.default).issuesPerDeploymentIssueTermRefresh, {
            numIssues: formatNumber(issueCount)
        }) : formatMessage((0, $7Ra8A.default).issuesPerDeployment, {
            numIssues: formatNumber(issueCount)
        });
        return `<div style="${$89cb3114dbae05b3$var$container}">
            <div style="${$89cb3114dbae05b3$var$header}">
                <span style="${$89cb3114dbae05b3$var$uploadIconStyled}">${0, $5496c072511293de$export$e789e90053a546bb}</span>
                <a href="${(0, (/*@__PURE__*/$parcel$interopDefault($6JUGo)))(pipelineUrl)}" target="_blank" style="${$89cb3114dbae05b3$var$pipelineNameStyled}">${(0, (/*@__PURE__*/$parcel$interopDefault($6JUGo)))(pipelineName)}</a>
                <span>${formattedLastUpdated}</span>
            </div>
            <p style="${$89cb3114dbae05b3$var$issuesPerDeployment}">${issuePerDeploymentTranslated}</p>
            <p style="${$89cb3114dbae05b3$var$environmentNameStyled}">${(0, (/*@__PURE__*/$parcel$interopDefault($6JUGo)))(environmentName)}</p>
        </div>`;
    };
};
const $89cb3114dbae05b3$var$container = `
    padding: 0 ${(0, $gwIPs.gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, $gwIPs.borderRadius)};
    color: ${(0, $829f609a65d26a98$exports).N0};
    font: ${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
    max-width: ${(0, $gwIPs.gridSize) * 26}px;
`;
const $89cb3114dbae05b3$var$header = `
    display: flex;
    align-items: center;
    height: ${(0, $gwIPs.gridSize) * 2}px;
    margin: 0 0 ${(0, $gwIPs.gridSize)}px -2px;
`;
const $89cb3114dbae05b3$var$pipelineNameStyled = `
    color: ${(0, $829f609a65d26a98$exports).N0};
    text-decoration-line: underline;
    margin: 0 ${(0, $gwIPs.gridSize) * 0.5}px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex: 1;
`;
const $89cb3114dbae05b3$var$iconBase = `
    margin-top: -1px;
    height: 16px;
    width: 16px;
`;
const $89cb3114dbae05b3$var$uploadIconStyled = `
    ${$89cb3114dbae05b3$var$iconBase}
`;
const $89cb3114dbae05b3$var$issuesPerDeployment = `
    color: ${(0, $829f609a65d26a98$exports).N0};
    margin: 0;
`;
const $89cb3114dbae05b3$var$environmentNameStyled = `
    margin: 0;
`;

});
parcelRegister("6JUGo", function(module, exports) {

var $8SMZJ = parcelRequire("8SMZJ");

var $jJVtR = parcelRequire("jJVtR");
/** Used to match HTML entities and HTML characters. */ var $4e82ea10714905a8$var$reUnescapedHtml = /[&<>"']/g, $4e82ea10714905a8$var$reHasUnescapedHtml = RegExp($4e82ea10714905a8$var$reUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */ function $4e82ea10714905a8$var$escape(string) {
    string = $jJVtR(string);
    return string && $4e82ea10714905a8$var$reHasUnescapedHtml.test(string) ? string.replace($4e82ea10714905a8$var$reUnescapedHtml, $8SMZJ) : string;
}
module.exports = $4e82ea10714905a8$var$escape;

});
parcelRegister("8SMZJ", function(module, exports) {

var $h2dNA = parcelRequire("h2dNA");
/** Used to map characters to HTML entities. */ var $67795f32b2638007$var$htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */ var $67795f32b2638007$var$escapeHtmlChar = $h2dNA($67795f32b2638007$var$htmlEscapes);
module.exports = $67795f32b2638007$var$escapeHtmlChar;

});


const $5496c072511293de$export$e789e90053a546bb = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fillRule="evenodd"><path d="M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"></path><path d="M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"></path><path d="M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"></path></g></svg>';

parcelRegister("7Ra8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad953448d7fcca83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad953448d7fcca83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuesPerDeployment: {
        "id": "software-deployment-frequency-report.batch-size-chart.chart.tooltip.issues-per-deployment",
        "defaultMessage": "{numIssues} {numIssues, plural, one {issue} other {issues}} per deployment"
    },
    issuesPerDeploymentIssueTermRefresh: {
        "id": "software-deployment-frequency-report.batch-size-chart.chart.tooltip.issues-per-deployment-issue-term-refresh",
        "defaultMessage": "{numIssues} {numIssues, plural, one {work item} other {work items}} per deployment"
    }
});

});



parcelRegister("17PUx", function(module, exports) {

$parcel$export(module.exports, "convertToDataPoints", () => $db5597352cd6a469$export$46e7be3ed3c4cb4b);
const $db5597352cd6a469$export$46e7be3ed3c4cb4b = (data)=>data.map((deployment)=>({
            name: deployment.id,
            // @ts-expect-error - TS2339 - Confusion between JS Date and GraphQL date scalar
            value: [
                deployment.lastUpdated.getTime(),
                deployment.issueCount
            ],
            customInfo: {
                issueCount: deployment.issueCount,
                pipeline: deployment.pipeline,
                environment: deployment.environment
            }
        }));

});

parcelRegister("kkZmj", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $89be1a510e31b7be$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4McSe = parcelRequire("4McSe");
const $89be1a510e31b7be$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$ChartWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $89be1a510e31b7be$var$weekBreakdownTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "168px",
        height: "16px",
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "248px",
        height: "20px",
        margin: `0 ${"var(--ds-space-100, 8px)"} 0 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "192px",
        height: "var(--ds-space-100, 8px)",
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$SubTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "192px",
        height: "var(--ds-space-100, 8px)",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "208px",
        height: "var(--ds-space-100, 8px)",
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphYLabelArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "var(--ds-space-100, 8px)",
        height: "144px",
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphAreaWithXLabelArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThick), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89be1a510e31b7be$var$GraphXLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "36px",
        height: "12px",
        margin: "0"
    })))));
const $89be1a510e31b7be$var$graphBaseStyles = null;
const $89be1a510e31b7be$var$chartWrapperBaseStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $89be1a510e31b7be$var$ChartWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$weekBreakdownTitleStyles = (0, $8CUq3.xcss)({
    height: 'space.300',
    marginBottom: 'space.400'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89be1a510e31b7be$var$TitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$SubTitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3i1tcg _u5f3v47k",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$GraphWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iclpc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$GraphYLabelArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbys9h _n3td1wqb _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qxncg",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$GraphAreaWithXLabelArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$GraphArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1fhb _ca0qxncg _u5f3v47k",
            __cmplp.className
        ])
    });
});
const $89be1a510e31b7be$var$GraphXLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1wqb _1e0c1txw _1bah1h6o _4cvresu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4McSe", function(module, exports) {

$parcel$export(module.exports, "SkeletonItem", () => $946e5acbe6dc1a80$export$fbc0ea7debdb77e);
$parcel$export(module.exports, "LineThin", () => $946e5acbe6dc1a80$export$ca55a3be779efc57);
$parcel$export(module.exports, "LineThick", () => $946e5acbe6dc1a80$export$611028b9a8d16761);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $946e5acbe6dc1a80$var$shimmerN20A = null;
const $946e5acbe6dc1a80$var$shimmerN30 = null;
const $946e5acbe6dc1a80$var$shimmerN40 = null;
const $946e5acbe6dc1a80$var$animationOptionStyles = null;
const $946e5acbe6dc1a80$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146ducd": (0, $lD23V.default)(`${__cmplp.margin}`),
            "--_dfjz0w": (0, $lD23V.default)(`${__cmplp.height}`),
            "--_1icprf0": (0, $lD23V.default)(`${__cmplp.width}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8j3fp _2rko1crf _bfhkn82g _4t3i16wa _1bsbb8e1 _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hq1xs8",
            __cmplp.className
        ])
    });
});
const $946e5acbe6dc1a80$export$ca55a3be779efc57 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1icprf0": (0, $lD23V.default)(`${__cmplp.width}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkn82g _4t3it94y _1bsbb8e1 _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hqe9je",
            __cmplp.className
        ])
    });
});
const $946e5acbe6dc1a80$export$611028b9a8d16761 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1icprf0": (0, $lD23V.default)(`${__cmplp.width}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkn82g _4t3iyh40 _1bsbb8e1 _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _j7hqe9je",
            __cmplp.className
        ])
    });
});

});


parcelRegister("HHUOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $860e2a495503fa1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $860e2a495503fa1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weeklyProdDeployments: {
        "id": "software-deployment-frequency-report.batch-size-chart.weekly-prod-deployments",
        "defaultMessage": "{weeklyProdDeployments, plural, =0 {No weekly production deployments} one {1 weekly production deployment} other {# weekly production deployments}}"
    },
    issuesPerDeployment: {
        "id": "software-deployment-frequency-report.batch-size-chart.issues-per-deployment",
        "defaultMessage": "{periodProdIssuesPerDeployment} {periodProdIssuesPerDeployment, plural, one {median issue per deployment} other {median issues per deployment}}"
    },
    issuesPerDeploymentIssueTermRefresh: {
        "id": "software-deployment-frequency-report.batch-size-chart.issues-per-deployment-issue-term-refresh",
        "defaultMessage": "{periodProdIssuesPerDeployment} {periodProdIssuesPerDeployment, plural, one {median work item} other {median work items}} per deployment"
    },
    weekTitle: {
        "id": "software-deployment-frequency-report.batch-size-chart.week-title",
        "defaultMessage": "week of {date}"
    },
    moreDataRequired: {
        "id": "software-deployment-frequency-report.batch-size-chart.more-data-required",
        "defaultMessage": "more data required"
    },
    deployment: {
        "id": "software-deployment-frequency-report.batch-size-chart.deployment",
        "defaultMessage": "Deployment"
    },
    twelveWeekMedian: {
        "id": "software-deployment-frequency-report.batch-size-chart.twelve-week-median",
        "defaultMessage": "12-week median"
    },
    weekBreakDownTitle: {
        "id": "software-deployment-frequency-report.batch-size-chart.week-break-down-title",
        "defaultMessage": "Week breakdown"
    },
    weekBreakDownTitleTooltip: {
        "id": "software-deployment-frequency-report.batch-size-chart.week-break-down-title-tooltip",
        "defaultMessage": "Identify the risk of your deployments by analyzing their batch sizes. Deployments with many changes tend to be riskier."
    },
    errorFlagTitle: {
        "id": "software-deployment-frequency-report.batch-size-chart.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "software-deployment-frequency-report.batch-size-chart.error-flag-description",
        "defaultMessage": "Some deployments may be missing."
    }
});

});


parcelRegister("gxsp4", function(module, exports) {

$parcel$export(module.exports, "DeploymentFrequencyBarChart", () => $881ef776211735a3$export$494b0cc8adc03bd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $44gpy = parcelRequire("44gpy");

var $6wHbz = parcelRequire("6wHbz");

var $gilhC = parcelRequire("gilhC");

var $l8ekP = parcelRequire("l8ekP");

var $3Ws3s = parcelRequire("3Ws3s");

var $claG0 = parcelRequire("claG0");

var $caivO = parcelRequire("caivO");

var $baXtj = parcelRequire("baXtj");

var $fg7Dg = parcelRequire("fg7Dg");

var $gabu1 = parcelRequire("gabu1");

var $bHI5p = parcelRequire("bHI5p");

var $c7V0L = parcelRequire("c7V0L");

var $aD53o = parcelRequire("aD53o");

var $iitmC = parcelRequire("iitmC");
const $881ef776211735a3$var$Title = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartTitle, null, formatMessage((0, $c7V0L.default).chartTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $c7V0L.default).titleHelpTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$QuestionIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        LEGACY_size: "small",
        label: ""
    })))));
};
const $881ef776211735a3$export$494b0cc8adc03bd4 = ()=>{
    const onViewDeploymentFrequencyReportExperienceFail = (0, $caivO.useViewDeploymentFrequencyReportExperienceFail)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $3Ws3s.useReportCoreData)();
    const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'deploymentFrequencyBar',
            actionSubjectId: 'deploymentFrequencyReport'
        }));
        setSelectedWeekStart(eventData.customInfo.startDateInclusive);
    }, [
        createAnalyticsEvent,
        setSelectedWeekStart
    ]);
    const events = (0, $5uXOq.useMemo)(()=>({
            click: onChartClicked
        }), [
        onChartClicked
    ]); // @ts-expect-error - TS2345 - Argument of type '(newWeekStartDate: Date) => void | Promise<void>' is not assignable to parameter of type '(newWeekStartDate: Date) => Action<State>'.
    (0, $l8ekP.useSmartWeekSelect)(data, selectedWeekStart, setSelectedWeekStart);
    (0, $5uXOq.useEffect)(()=>{
        if (error && data == null) {
            onViewDeploymentFrequencyReportExperienceFail('BarChart', error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'BarChartDataFailed',
                    packageName: 'jiraSoftwareDeploymentFrequencyReport',
                    teamName: 'fusion-solaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        data,
        error,
        onViewDeploymentFrequencyReportExperienceFail
    ]);
    if (error && data == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ErrorUIWrapper, {
        "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.error-ui"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44gpy.default), {
        onRetry: fetch
    })));
    if (loading || data == null || selectedWeekStart === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHI5p.LoadingSkeleton), null);
    error;
    const { averageDeploymentCount: averageDeploymentCountWholePeriod, hasDeploymentProvider: hasDeploymentProvider } = data;
    if (hasDeploymentProvider === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD53o.NoProvider), null);
    const prodDataState = (0, $claG0.getProdDataState)(data);
    const dataPoints = (0, $fg7Dg.convertReportCoreToChartDataPoints)(data, selectedWeekStart);
    const selectedWeekData = (0, $l8ekP.getSelectedWeekData)(data.weeksData, selectedWeekStart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6wHbz.PerformanceTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$Title, null), prodDataState === 'COMPLETELY_EMPTY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$EmptyMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gabu1.EmptyDataMessage), null)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartContainer, {
        "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$ChartItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $baXtj.Chart), {
        dataPoints: dataPoints,
        averageDeploymentsWholePeriod: averageDeploymentCountWholePeriod,
        onEvents: events,
        shouldDisplayAverageLine: prodDataState === 'SUFFICIENT_FOR_TREND'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($881ef776211735a3$var$SelectionDetailItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iitmC.SelectionDetail), {
        weekCount: selectedWeekData.deploymentCount.prod,
        weekStartDate: selectedWeekData.startDateInclusive,
        wholePeriodAverage: averageDeploymentCountWholePeriod,
        prodDataState: prodDataState
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$ErrorUIWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1dup _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$ChartTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyrftgi _18u0idpf _4t3i1tcg _1e0c1txw _4cvr1h6o _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$QuestionIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _lswu5w2r _syazwdcn _80omtlke _ca0qv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$EmptyMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$ChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3iko4j",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$ChartItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbqrhd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $881ef776211735a3$var$SelectionDetailItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb194s _1ul9194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bah1h6o _n3tdvbgk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6wHbz", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracker", () => $cc795357cc224acb$export$57a2c9a4973f6a35);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $5rqex = parcelRequire("5rqex");

var $j1sSt = parcelRequire("j1sSt");
const $cc795357cc224acb$var$deploymentFrequencyReportPageLoad = (0, $dGrdR.metrics).pageLoad({
    key: 'software.deployment.frequency.report',
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $cc795357cc224acb$export$57a2c9a4973f6a35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "performanceTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "jira-software-deployment-frequency-report",
        ttrSlo: 1000,
        ttiSlo: 4000,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: $cc795357cc224acb$var$deploymentFrequencyReportPageLoad
    }));

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("l8ekP", function(module, exports) {

$parcel$export(module.exports, "getSelectedWeekData", () => $e92b654218278618$export$47a56b6f44681bf3);
$parcel$export(module.exports, "useSmartWeekSelect", () => $e92b654218278618$export$84b064975722115b);

var $5uXOq = parcelRequire("5uXOq");

var $hIkqU = parcelRequire("hIkqU");

var $hYfgW = parcelRequire("hYfgW");
const $e92b654218278618$export$47a56b6f44681bf3 = (weeksData, selectedWeekStartDate)=>{
    const foundWeekData = weeksData.find((weekData)=>weekData.startDateInclusive.getTime() === selectedWeekStartDate.getTime());
    if (foundWeekData === undefined) throw new Error('Could not find the selected week data for the given selected date range');
    return foundWeekData;
};
const $e92b654218278618$export$84b064975722115b = (data, selectedWeekStart, setSelectedWeekStart)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (data != null) {
            const selectLatestWeekWithDataNotCurrentWeek = ()=>{
                const selectedWeekData = (0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))(data.weeksData, (weekData)=>weekData.deploymentCount.prod, data.weeksData.length - 2);
                if (selectedWeekData) // @ts-expect-error - TS2339 - Property 'startDateInclusive' does not exist on type 'number | DeploymentFrequencyReportWeekData | { <S extends DeploymentFrequencyReportWeekData>(predicate: (value: DeploymentFrequencyReportWeekData, index: number, array: DeploymentFrequencyReportWeekData[]) => value is S, thisArg?: any): this is S[]; (predicate: (value: DeploymentFrequencyReportWeekData, index: numbe...'.
                setSelectedWeekStart(selectedWeekData.startDateInclusive);
                else // if we can't find any week with data, select the current week
                // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                setSelectedWeekStart((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(data.weeksData).startDateInclusive);
            };
            if (selectedWeekStart === null || $e92b654218278618$export$47a56b6f44681bf3(data.weeksData, selectedWeekStart).deploymentCount.prod === 0) selectLatestWeekWithDataNotCurrentWeek();
        }
    }, [
        data,
        selectedWeekStart,
        setSelectedWeekStart
    ]);
};

});
parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});



parcelRegister("baXtj", function(module, exports) {

$parcel$export(module.exports, "Chart", () => $315a4060370e985e$export$acaa6426d77a227e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");

var $gJBT6 = parcelRequire("gJBT6");

var $lXVui = parcelRequire("lXVui");

var $bkcQi = parcelRequire("bkcQi");
var $47isN = parcelRequire("47isN");

var $6OGL8 = parcelRequire("6OGL8");
var $48mDj = parcelRequire("48mDj");
var $gLj36 = parcelRequire("gLj36");

var $ixV1I = parcelRequire("ixV1I");

var $lWgYs = parcelRequire("lWgYs");

var $dWt6p = parcelRequire("dWt6p");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $hyYD4 = parcelRequire("hyYD4");


var $lz0GT = parcelRequire("lz0GT");

var $9zuj3 = parcelRequire("9zuj3");
$ixV1I.use([
    (0, $47isN.install),
    (0, $bkcQi.install),
    (0, $48mDj.install),
    (0, $gLj36.install),
    (0, $6OGL8.install),
    (0, $lWgYs.install)
]);
const $315a4060370e985e$export$acaa6426d77a227e = ({ dataPoints: dataPoints, averageDeploymentsWholePeriod: averageDeploymentsWholePeriod, shouldDisplayAverageLine: shouldDisplayAverageLine, onEvents: onEvents })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const tooltipFormatter = (0, $9zuj3.useTooltipFormatter)(averageDeploymentsWholePeriod);
    const prefersReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const axisCommonStyle = {
        nameGap: (0, $gwIPs.gridSize) * 4,
        nameLocation: 'middle',
        nameTextStyle: {
            color: (0, $829f609a65d26a98$exports).N400,
            // This cannot be replaced with a token as ECharts requires a numeric pixel value.
            // Background: https://atlassian.slack.com/archives/C071DCS8MDL/p1733289846954599
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 12
        }
    };
    const TOOLTIP_ANIMATION = null;
    const TOOLTIP_APPEAR_TOP = {
        backgroundColor: (0, $829f609a65d26a98$exports).N900,
        borderWidth: 0,
        transitionDuration: 0,
        extraCssText: `animation: ${TOOLTIP_ANIMATION} 0.15s ease-out`,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((pos, params, dom, rect, size)=>({
                top: rect.y - size.contentSize[1] - (0, $gwIPs.gridSize),
                left: rect.x + 10 - size.contentSize[0] / 2
            }), (pos, params)=>// memoize based on the index
            // otherwise we see calculation on mouse move and the tooltip jitters
            `${params.componentSubType}-${params.name}-${params.dataIndex}`)
    };
    // TODO RLSS-2812 handle darkmode for echarts
    const chartOptions = {
        animation: !prefersReducedMotion,
        tooltip: {
            ...TOOLTIP_APPEAR_TOP,
            formatter: tooltipFormatter
        },
        itemStyle: {
            borderRadius: [
                2,
                2,
                0,
                0
            ]
        },
        grid: {
            left: (0, $hyYD4.CHART_SPACE_LEFT),
            right: (0, $hyYD4.CHART_SPACE_RIGHT),
            top: (0, $gwIPs.gridSize) * 2,
            bottom: (0, $gwIPs.gridSize) * 8
        },
        xAxis: {
            data: dataPoints.map((data)=>{
                const weekStartDateTranslated = formatDate(data.customInfo.startDateInclusive, {
                    month: 'short',
                    day: 'numeric'
                });
                return data.customInfo.emphasisColor !== null ? {
                    value: weekStartDateTranslated,
                    textStyle: {
                        color: data.customInfo.emphasisColor
                    }
                } : weekStartDateTranslated;
            }),
            axisLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N40,
                    width: 2
                }
            },
            axisTick: {
                alignWithLabel: true
            },
            offset: (0, $gwIPs.gridSize) * 2,
            ...axisCommonStyle
        },
        yAxis: {
            name: formatMessage((0, $lz0GT.default).yAxisLabel),
            ...axisCommonStyle,
            axisLine: {
                show: false
            },
            splitNumber: 4,
            axisTick: false,
            splitLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N30
                }
            }
        },
        textStyle: {
            color: (0, $829f609a65d26a98$exports).N400
        },
        backgroundColor: 'transparent',
        series: [
            {
                type: 'bar',
                data: dataPoints,
                color: (0, $829f609a65d26a98$exports).B100,
                barWidth: (0, $b41c313de361af34$export$5b067f596a486882),
                ...averageDeploymentsWholePeriod !== null && shouldDisplayAverageLine ? {
                    markLine: {
                        data: [
                            {
                                yAxis: averageDeploymentsWholePeriod
                            }
                        ],
                        silent: true,
                        lineStyle: {
                            color: (0, $829f609a65d26a98$exports).N300,
                            width: 1
                        },
                        symbol: 'none',
                        label: {
                            show: false
                        }
                    }
                } : {}
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lXVui))), {
        echarts: $ixV1I,
        option: chartOptions,
        style: {
            height: '100%'
        },
        onEvents: onEvents
    });
};

});
parcelRegister("bkcQi", function(module, exports) {

$parcel$export(module.exports, "install", () => $83eb863ca14abd03$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bahqM = parcelRequire("bahqM");

var $eL4bi = parcelRequire("eL4bi");

var $7jcIW = parcelRequire("7jcIW");

var $1b1Ai = parcelRequire("1b1Ai");

var $hrdVR = parcelRequire("hrdVR");
function $83eb863ca14abd03$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $hrdVR.default));
    registers.registerSeriesModel((0, $1b1Ai.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $bahqM.curry((0, $eL4bi.layout), 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
    // only exist in this module, but probably also exist in other modules, like `barPolar`.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $eL4bi.largeLayout)); // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $7jcIW.default)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

});
parcelRegister("1b1Ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db80c291205dc61$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $6GWLU = parcelRequire("6GWLU");

var $bAY5l = parcelRequire("bAY5l");

var $jvo6O = parcelRequire("jvo6O");
var $0db80c291205dc61$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $jvo6O.inheritDefaultOption)((0, $6GWLU.default).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $6GWLU.default));
var $0db80c291205dc61$export$2e2bcd8739ae039 = $0db80c291205dc61$var$BarSeriesModel;

});
parcelRegister("6GWLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df4412f90ffd718$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $1O7Ua = parcelRequire("1O7Ua");

var $bAY5l = parcelRequire("bAY5l");
var $4df4412f90ffd718$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $bAY5l.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var pt = coordSys.dataToPoint(coordSys.clampData(value));
            var data = this.getData();
            var offset = data.getLayout('offset');
            var size = data.getLayout('size');
            var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
            pt[offsetIndex] += offset + size / 2;
            return pt;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod'
    };
    return BaseBarSeriesModel;
}((0, $1O7Ua.default));
(0, $1O7Ua.default).registerClass($4df4412f90ffd718$var$BaseBarSeriesModel);
var $4df4412f90ffd718$export$2e2bcd8739ae039 = $4df4412f90ffd718$var$BaseBarSeriesModel;

});


parcelRegister("hrdVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1fc3f08c69a560$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $ghQ8v = parcelRequire("ghQ8v");

var $4KVOr = parcelRequire("4KVOr");

var $bahqM = parcelRequire("bahqM");

var $eYgMC = parcelRequire("eYgMC");parcelRequire("fHITF");
var $7Tw7u = parcelRequire("7Tw7u");
var $elGBV = parcelRequire("elGBV");
var $eYgMC = parcelRequire("eYgMC");

var $7QjoM = parcelRequire("7QjoM");

var $fIXXx = parcelRequire("fIXXx");

var $gvLUt = parcelRequire("gvLUt");

var $ljaBy = parcelRequire("ljaBy");

var $5fMzf = parcelRequire("5fMzf");

var $eaQLm = parcelRequire("eaQLm");

var $loerw = parcelRequire("loerw");

var $40dMe = parcelRequire("40dMe");

var $5MLZz = parcelRequire("5MLZz");


var $9dNYG = parcelRequire("9dNYG");

var $eYgMC = parcelRequire("eYgMC");
var $cb1fc3f08c69a560$var$_eventPos = [
    0,
    0
];
var $cb1fc3f08c69a560$var$mathMax = Math.max;
var $cb1fc3f08c69a560$var$mathMin = Math.min;
function $cb1fc3f08c69a560$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $40dMe.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $cb1fc3f08c69a560$var$BarView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel); // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $cb1fc3f08c69a560$var$getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
        group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
             // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
            var el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $eYgMC.initProps)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex);
                var shape = $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $eYgMC.updateProps)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $eYgMC.saveOldStyle)(el);
             // Not change anything if only order changed.
            // Especially not change label.
            if (!isChangeOrder) $cb1fc3f08c69a560$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $eYgMC.updateProps)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $eYgMC.removeElementWithFadeOut)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $4KVOr.default)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) ? (0, $5fMzf.createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this; // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                if (el) {
                    var shape = el.shape; // If data is NaN, shape.xxx may be NaN, so use || 0 here in case
                    return (baseAxis.isHorizontal() // The result should be consistent with the initial sort by data value.
                     ? Math.abs(shape.height) : Math.abs(shape.width)) || 0;
                } else return 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $bahqM.map)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 // If some tick have no bar, the tick will be treated as min.
             ? Number.MIN_VALUE // PENDING: if dataZoom on baseAxis exits, is it a performance issue?
             : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $eYgMC.removeElementWithFadeOut)(el, model, (0, $7QjoM.getECData)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $loerw.default));
var $cb1fc3f08c69a560$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $cb1fc3f08c69a560$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $cb1fc3f08c69a560$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $cb1fc3f08c69a560$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $cb1fc3f08c69a560$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y; // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Beause if data changed and the bar show again, its transition animaiton
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y; // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $cb1fc3f08c69a560$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $cb1fc3f08c69a560$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0; // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $cb1fc3f08c69a560$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $7Tw7u.default)({
            shape: (0, $bahqM.extend)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $eaQLm.default) : (0, $elGBV.default);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $9dNYG.createSectorCalculateTextPosition)(positionMap, {
            isRoundCap: ShapeClass === (0, $eaQLm.default)
        }); // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $eYgMC.updateProps) : (0, $eYgMC.initProps))(sector, {
                shape: animateTarget // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue
            }, animationModel);
        }
        return sector;
    }
};
function $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $eYgMC.updateProps) : (0, $eYgMC.initProps))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $eYgMC.updateProps) : (0, $eYgMC.initProps))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $cb1fc3f08c69a560$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $cb1fc3f08c69a560$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $cb1fc3f08c69a560$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $cb1fc3f08c69a560$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$rectPropties);
    },
    polar: function(layout) {
        return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$polarPropties);
    }
};
var $cb1fc3f08c69a560$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $cb1fc3f08c69a560$var$getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $cb1fc3f08c69a560$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) el.setShape('r', itemModel.get([
        'itemStyle',
        'borderRadius'
    ]) || 0);
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $gvLUt.getLabelStatesModels)(itemModel);
    (0, $gvLUt.setLabelStyle)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $5MLZz.getDefaultLabel)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $9dNYG.setSectorTextRotation)(el, position === 'outside' ? labelPositionOutside : position, $cb1fc3f08c69a560$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $gvLUt.setLabelValueAnimation)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $5MLZz.getDefaultInterpolatedLabel)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $fIXXx.enableHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
    (0, $fIXXx.setStatesStylesFromModel)(el, itemModel);
    if ($cb1fc3f08c69a560$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $bahqM.each)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
} // In case width or height are too small.
function $cb1fc3f08c69a560$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0; // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $cb1fc3f08c69a560$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $cb1fc3f08c69a560$var$LargePath = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $cb1fc3f08c69a560$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var startPoint = this.__startPoint;
        var baseDimIdx = this.__baseDimIdx;
        for(var i = 0; i < points.length; i += 2){
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            ctx.moveTo(startPoint[0], startPoint[1]);
            ctx.lineTo(points[i], points[i + 1]);
        }
    };
    return LargePath;
}((0, $ghQ8v.default));
function $cb1fc3f08c69a560$var$createLarge(seriesModel, group, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var startPoint = [];
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('barWidth');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var drawBackground = seriesModel.get('showBackground', true);
    if (drawBackground) {
        var points = data.getLayout('largeBackgroundPoints');
        var backgroundStartPoint = [];
        backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
        var bgEl = new $cb1fc3f08c69a560$var$LargePath({
            shape: {
                points: points
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.__startPoint = backgroundStartPoint;
        bgEl.__baseDimIdx = baseDimIdx;
        bgEl.__largeDataIndices = largeDataIndices;
        bgEl.__barWidth = barWidth;
        $cb1fc3f08c69a560$var$setLargeBackgroundStyle(bgEl, backgroundModel, data);
        group.add(bgEl);
    }
    var el = new $cb1fc3f08c69a560$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental
    });
    el.__startPoint = startPoint;
    el.__baseDimIdx = baseDimIdx;
    el.__largeDataIndices = largeDataIndices;
    el.__barWidth = barWidth;
    group.add(el);
    $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
    (0, $7QjoM.getECData)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
        el.on('mousemove', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
    }
} // Use throttle to avoid frequently traverse to find dataIndex.
var $cb1fc3f08c69a560$var$largePathUpdateDataIndex = (0, $ljaBy.throttle)(function(event) {
    var largePath = this;
    var dataIndex = $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $7QjoM.getECData)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.__baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.__largeDataIndices;
    var barWidthHalf = Math.abs(largePath.__barWidth / 2);
    var startValueVal = largePath.__startPoint[valueDimIdx];
    $cb1fc3f08c69a560$var$_eventPos[0] = x;
    $cb1fc3f08c69a560$var$_eventPos[1] = y;
    var pointerBaseVal = $cb1fc3f08c69a560$var$_eventPos[baseDimIdx];
    var pointerValueVal = $cb1fc3f08c69a560$var$_eventPos[1 - baseDimIdx];
    var baseLowerBound = pointerBaseVal - barWidthHalf;
    var baseUpperBound = pointerBaseVal + barWidthHalf;
    for(var i = 0, len = points.length / 2; i < len; i++){
        var ii = i * 2;
        var barBaseVal = points[ii + baseDimIdx];
        var barValueVal = points[ii + valueDimIdx];
        if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) return largeDataIndices[i];
    }
    return -1;
}
function $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data) {
    var globalStyle = data.getVisual('style');
    el.useStyle((0, $bahqM.extend)({}, globalStyle)); // Use stroke instead of fill.
    el.style.fill = null;
    el.style.stroke = globalStyle.fill;
    el.style.lineWidth = data.getLayout('barWidth');
}
function $cb1fc3f08c69a560$var$setLargeBackgroundStyle(el, backgroundModel, data) {
    var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
    var itemStyle = backgroundModel.getItemStyle();
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
    el.style.lineWidth = data.getLayout('barWidth');
}
function $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $40dMe.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $elGBV.default) : (0, $7Tw7u.default);
    return new ElementClz({
        shape: $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $cb1fc3f08c69a560$export$2e2bcd8739ae039 = $cb1fc3f08c69a560$var$BarView;

});
parcelRegister("eaQLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51aed73fd415b38$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");
parcelRequire("fHITF");
var $ghQ8v = parcelRequire("ghQ8v");
/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $a51aed73fd415b38$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $a51aed73fd415b38$var$SausagePath = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $a51aed73fd415b38$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
            ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
        }
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
        ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) {
            ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
            ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
        }
        ctx.closePath();
    };
    return SausagePath;
}((0, $ghQ8v.default));
var $a51aed73fd415b38$export$2e2bcd8739ae039 = $a51aed73fd415b38$var$SausagePath;

});

parcelRegister("9dNYG", function(module, exports) {

$parcel$export(module.exports, "createSectorCalculateTextPosition", () => $6b6c187953b9d25e$export$359a1e2d210ed734);
$parcel$export(module.exports, "setSectorTextRotation", () => $6b6c187953b9d25e$export$672ce504c0db395a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b7ZX8 = parcelRequire("b7ZX8");

var $bahqM = parcelRequire("bahqM");
function $6b6c187953b9d25e$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $b7ZX8.calculateTextPosition)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin; // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $b7ZX8.calculateTextPosition)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $6b6c187953b9d25e$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if (typeof rotateType === 'number') {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $bahqM.isArray)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $6b6c187953b9d25e$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $6b6c187953b9d25e$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}

});



parcelRegister("6OGL8", function(module, exports) {

$parcel$export(module.exports, "install", () => $4f6894ac64afab25$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $iWOYl = parcelRequire("iWOYl");

var $hi3Y7 = parcelRequire("hi3Y7");

var $alpND = parcelRequire("alpND");
function $4f6894ac64afab25$export$4b3e715f166fdd78(registers) {
    (0, $alpND.use)((0, $iWOYl.install));
    (0, $alpND.use)((0, $hi3Y7.install));
}

});

parcelRegister("hyYD4", function(module, exports) {

$parcel$export(module.exports, "CHART_SPACE_LEFT", () => $91e77936c1049368$export$ffe1d6b5e0d7a6e5);
$parcel$export(module.exports, "CHART_SPACE_RIGHT", () => $91e77936c1049368$export$990d773ada9107e0);

var $gwIPs = parcelRequire("gwIPs");
const $91e77936c1049368$export$ffe1d6b5e0d7a6e5 = (0, $gwIPs.gridSize) * 8;
const $91e77936c1049368$export$990d773ada9107e0 = (0, $gwIPs.gridSize) * 4;
const $91e77936c1049368$export$ad3c2ee386592d19 = (0, $gwIPs.gridSize) * 38;
const $91e77936c1049368$export$304a9c3520780858 = (0, $gwIPs.gridSize) * 8;
const $91e77936c1049368$export$3d957908be204f46 = (0, $gwIPs.gridSize) * 3;
const $91e77936c1049368$export$45a30b115b114e0f = (0, $gwIPs.gridSize);

});

const $b41c313de361af34$export$5b067f596a486882 = 18;

parcelRegister("lz0GT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d873bf2f897cf375$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d873bf2f897cf375$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yAxisLabel: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.y-axis-label",
        "defaultMessage": "Deployment frequency"
    }
});

});

parcelRegister("9zuj3", function(module, exports) {

$parcel$export(module.exports, "useTooltipFormatter", () => $c15ef68f5cb15c93$export$8d71e8328e9bd59b);


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");


var $9LRCK = parcelRequire("9LRCK");
const $c15ef68f5cb15c93$var$getIconInfo = (value, deploymentsComparisonTarget)=>{
    let iconHtml = '';
    let style = '';
    if (deploymentsComparisonTarget === null) return {
        style: style,
        iconHtml: iconHtml
    };
    if (value < deploymentsComparisonTarget) {
        iconHtml = (0, $7b9f1098797f5d28$export$f97d6df82c759e48);
        style = $c15ef68f5cb15c93$var$iconWarn;
    }
    if (value > deploymentsComparisonTarget) {
        iconHtml = (0, $7b9f1098797f5d28$export$ae6cac6e77684f0f);
        style = $c15ef68f5cb15c93$var$iconGood;
    }
    return {
        style: style,
        iconHtml: iconHtml
    };
};
const $c15ef68f5cb15c93$export$8d71e8328e9bd59b = (deploymentsComparisonTarget)=>{
    const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    return ({ data: data })=>{
        const { value: numDeployments, customInfo: { medianIssuesPerDeployment: medianIssuesPerDeployment, startDateInclusive: startDateInclusive } } = data;
        const weekStartDateText = formatMessage((0, $9LRCK.default).weekStartDate, {
            date: formatDate(startDateInclusive, {
                day: 'numeric',
                month: 'short'
            })
        });
        const numIssuesText = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $9LRCK.default).medianIssuesPerDeploymentsIssueTermRefresh, {
            numIssues: formatNumber(medianIssuesPerDeployment ?? 0)
        }) : formatMessage((0, $9LRCK.default).medianIssuesPerDeployments, {
            numIssues: formatNumber(medianIssuesPerDeployment ?? 0)
        });
        const numProdDeploymentsText = formatMessage((0, $9LRCK.default).numProdDeployments, {
            numDeployments: numDeployments
        });
        const { style: comparisonIconStyle, iconHtml: iconHtml } = $c15ef68f5cb15c93$var$getIconInfo(numDeployments, deploymentsComparisonTarget);
        return `
            <div style="${$c15ef68f5cb15c93$var$container}">
                <div style="${$c15ef68f5cb15c93$var$headerWeekStartText}">
                    ${weekStartDateText}
                </div>
                <div style="${$c15ef68f5cb15c93$var$deploymentCountTextContainer}${iconHtml !== '' ? $c15ef68f5cb15c93$var$deploymentCountIconPositioner : ''}">
                    <span style="${comparisonIconStyle}">${iconHtml}</span>
                    ${numProdDeploymentsText}
                </div>
                <div style="${$c15ef68f5cb15c93$var$medianIssuesPerDeploymentTextContainer}">
                    <span style="${$c15ef68f5cb15c93$var$issuesIconStyled}">${0, $7b9f1098797f5d28$export$51f43fae9c774cb5}</span>
                    ${numIssuesText}
                </div>
            </div>
        `;
    };
};
const $c15ef68f5cb15c93$var$container = `
    height: ${(0, $gwIPs.gridSize) * 9}px;
    padding: 0 ${(0, $gwIPs.gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, $gwIPs.borderRadius)};
    font: ${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
    color: ${(0, $829f609a65d26a98$exports).N0};
`;
const $c15ef68f5cb15c93$var$headerWeekStartText = `
    display: flex;
    align-items: center;
    height: ${(0, $gwIPs.gridSize) * 2}px;
    margin-bottom: ${(0, $gwIPs.gridSize)}px;
    text-decoration-line: underline;
`;
const $c15ef68f5cb15c93$var$iconBase = `
    transform: scale(0.666);
    margin-top: 2px;
`;
const $c15ef68f5cb15c93$var$iconGood = `
    ${$c15ef68f5cb15c93$var$iconBase}
    fill: ${(0, $829f609a65d26a98$exports).N800};
    color: ${(0, $829f609a65d26a98$exports).G300}
`;
const $c15ef68f5cb15c93$var$iconWarn = `
    ${$c15ef68f5cb15c93$var$iconBase}
    fill: ${(0, $829f609a65d26a98$exports).N800};
    color: ${(0, $829f609a65d26a98$exports).Y400}
`;
const $c15ef68f5cb15c93$var$issuesIconStyled = `
    ${$c15ef68f5cb15c93$var$iconBase}
    margin-left: -5px;
`;
const $c15ef68f5cb15c93$var$deploymentCountTextContainer = `
    display: flex;
    align-items: center;
    height: ${(0, $gwIPs.gridSize) * 2}px;
    margin-bottom: ${(0, $gwIPs.gridSize)}px;
`;
const $c15ef68f5cb15c93$var$deploymentCountIconPositioner = `
    margin-left: -5px;
`;
const $c15ef68f5cb15c93$var$medianIssuesPerDeploymentTextContainer = `
    display: flex;
    align-items: center;
    height: ${(0, $gwIPs.gridSize) * 2}px;
`;

});
const $7b9f1098797f5d28$export$ae6cac6e77684f0f = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fillRule="evenodd"><circle fill="currentColor" fillRule="nonzero" cx="12" cy="12" r="10"></circle><path d="M11.288 7.293L8.294 10.27a1.002 1.002 0 000 1.416 1.01 1.01 0 001.421 0l1.279-1.272V16c0 .552.451 1 1.006 1 .555 0 1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 001.421 0 .998.998 0 000-1.416l-2.994-2.977a1.01 1.01 0 00-1.423 0z" fill="inherit"></path></g></svg>';
const $7b9f1098797f5d28$export$f97d6df82c759e48 = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fillRule="evenodd"><circle fill="currentColor" fillRule="nonzero" cx="12" cy="12" r="10"></circle><path d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 00-1.421 0 .998.998 0 000 1.416l2.994 2.977a1.01 1.01 0 001.423 0l2.994-2.977a.998.998 0 000-1.416 1.01 1.01 0 00-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1-.555 0-1.006.448-1.006 1z" fill="inherit"></path></g></svg>';
const $7b9f1098797f5d28$export$51f43fae9c774cb5 = '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fillRule="evenodd"><path d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z" fillRule="nonzero"></path><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"></path></g></svg>';

parcelRegister("9LRCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6ae3ba996a3d80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fe6ae3ba996a3d80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numProdDeployments: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.num-prod-deployments",
        "defaultMessage": "{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}"
    },
    medianIssuesPerDeployments: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.median-issues-per-deployments",
        "defaultMessage": "{numIssues} median {numIssues, plural, one {issue} other {issues}} per deployment"
    },
    weekStartDate: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.week-start-date",
        "defaultMessage": "Week of {date}"
    },
    medianIssuesPerDeploymentsIssueTermRefresh: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.median-issues-per-deployments-issue-term-refresh",
        "defaultMessage": "{numIssues} median {numIssues, plural, one {work item} other {work items}} per deployment"
    }
});

});



parcelRegister("fg7Dg", function(module, exports) {

$parcel$export(module.exports, "convertReportCoreToChartDataPoints", () => $8a79902ec6236f8b$export$5050f1e61745475);


var $ecd0S = parcelRequire("ecd0S");

var $claG0 = parcelRequire("claG0");
const $8a79902ec6236f8b$var$getEmphasisColor = (prodDeploymentsCount, wholePeriodStatistic)=>prodDeploymentsCount >= wholePeriodStatistic ? (0, $829f609a65d26a98$exports).G300 : (0, $829f609a65d26a98$exports).Y300;
const $8a79902ec6236f8b$export$5050f1e61745475 = (deploymentFrequencyReportData, selectedStartDateInclusive)=>{
    const isProdDataEmpty = (0, $claG0.isProdDataEmpty)(deploymentFrequencyReportData);
    return deploymentFrequencyReportData.weeksData.map((weekData, i)=>{
        const prodDeploymentsCount = weekData.deploymentCount.prod;
        const isSelectedData = !isProdDataEmpty && selectedStartDateInclusive.getTime() === weekData.startDateInclusive.getTime();
        const emphasisColor = $8a79902ec6236f8b$var$getEmphasisColor(prodDeploymentsCount, deploymentFrequencyReportData.averageDeploymentCount);
        const isCurrentWeekData = i === (0, $ecd0S.WEEKS_IN_REPORT) - 1;
        const isCurrentWeekEmpty = prodDeploymentsCount === 0;
        const barColor = isCurrentWeekData ? (0, $829f609a65d26a98$exports).N60 : (0, $829f609a65d26a98$exports).N100;
        return {
            value: prodDeploymentsCount,
            itemStyle: {
                color: isSelectedData ? emphasisColor : barColor,
                borderType: isCurrentWeekData && !isCurrentWeekEmpty ? 'dashed' : undefined,
                borderColor: isCurrentWeekData && !isCurrentWeekEmpty ? (0, $829f609a65d26a98$exports).N300 : undefined
            },
            emphasis: {
                itemStyle: {
                    color: emphasisColor
                }
            },
            customInfo: {
                startDateInclusive: weekData.startDateInclusive,
                medianIssuesPerDeployment: weekData.medianIssuesPerDeployment.prod,
                // This will be used for x-axis label color
                emphasisColor: isSelectedData ? emphasisColor : null
            }
        };
    });
};

});

parcelRegister("gabu1", function(module, exports) {

$parcel$export(module.exports, "EmptyDataMessage", () => $b06fdae3b98cfd3a$export$11485e91fe85c41b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $ecd0S = parcelRequire("ecd0S");

var $f70oV = parcelRequire("f70oV");

var $ilLj2 = parcelRequire("ilLj2");

var $e6qXf = parcelRequire("e6qXf");

var $epPK7 = parcelRequire("epPK7");
const $b06fdae3b98cfd3a$export$11485e91fe85c41b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSimplified = (0, $ilLj2.useProjectSimplified)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$Wrapper, {
        "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.empty-data-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e6qXf))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, formatMessage((0, $epPK7.default).emptyDataMessageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$BottomMessage, null, formatMessage((0, $epPK7.default).emptyDataMessageDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b06fdae3b98cfd3a$var$LearnMore, {
        target: "_blank",
        href: isSimplified === true ? (0, $ecd0S.DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED) : (0, $ecd0S.DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED)
    }, formatMessage((0, $f70oV.default).learnMore)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b06fdae3b98cfd3a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1n8h _1e0c1txw _4cvr1fhb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b06fdae3b98cfd3a$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $b06fdae3b98cfd3a$var$BottomMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1fxt _19pk1b66",
            __cmplp.className
        ])
    });
});
const $b06fdae3b98cfd3a$var$LearnMore = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz14q2 _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f70oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2f42315e6c3dae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de2f42315e6c3dae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    learnMore: {
        "id": "software-deployment-frequency-report.common.learn-more",
        "defaultMessage": "Learn more"
    },
    development: {
        "id": "software-deployment-frequency-report.common.development",
        "defaultMessage": "Development"
    },
    testing: {
        "id": "software-deployment-frequency-report.common.testing",
        "defaultMessage": "Testing"
    },
    staging: {
        "id": "software-deployment-frequency-report.common.staging",
        "defaultMessage": "Staging"
    },
    production: {
        "id": "software-deployment-frequency-report.common.production",
        "defaultMessage": "Production"
    },
    unmapped: {
        "id": "software-deployment-frequency-report.common.unmapped",
        "defaultMessage": "Unmapped"
    }
});

});

parcelRegister("e6qXf", function(module, exports) {
module.exports = new URL("magnifying_glass.f802f9ab.svg", import.meta.url).toString();

});

parcelRegister("epPK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7302e4cd782e16b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b7302e4cd782e16b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyDataMessageTitle: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-title",
        "defaultMessage": "Get the last 12 weeks' data from your deployment tools"
    },
    emptyDataMessageDescription: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.empty-data-message.empty-data-message-description",
        "defaultMessage": "To view this report, you need deployment events from your CI/CD tool and commit events from your source code management tool."
    }
});

});


parcelRegister("bHI5p", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $637286eb13198c47$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $4McSe = parcelRequire("4McSe");
const $637286eb13198c47$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $637286eb13198c47$var$chartTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 21}px`,
        height: `${(0, $gwIPs.gridSize) * 2}px`,
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$ChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$ChartLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 1.5}px`,
        height: `${(0, $gwIPs.gridSize) * 16}px`,
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$Chart, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThick), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($637286eb13198c47$var$SelectionDetail, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 14}px`,
        height: `${(0, $gwIPs.gridSize) * 1.5}px`,
        margin: `0 0 ${(0, $gwIPs.gridSize) * 1.5}px 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 6.5}px`,
        height: `${(0, $gwIPs.gridSize) * 2.5}px`,
        margin: `0 0 ${(0, $gwIPs.gridSize) * 1.5}px 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 26.5}px`,
        height: `${(0, $gwIPs.gridSize) * 1.5}px`,
        margin: `0 0 ${(0, $gwIPs.gridSize) * 1.5}px 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 26.5}px`,
        height: `${(0, $gwIPs.gridSize)}px`,
        margin: "0"
    }))));
const $637286eb13198c47$var$chartTitleStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200',
    height: 'space.300',
    paddingLeft: 'space.250'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $637286eb13198c47$var$ChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3iko4j",
            __cmplp.className
        ])
    });
});
const $637286eb13198c47$var$ChartLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1jfw _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdxy5q _19bvv47k",
            __cmplp.className
        ])
    });
});
const $637286eb13198c47$var$Chart = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1yt4c4ro _1e0c1txw _2lx21bp4 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $637286eb13198c47$var$SelectionDetail = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdvbgk _19bv1ylp _1bsb194s _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c7V0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $57906f48a3afc873$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $57906f48a3afc873$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTitle: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.chart-title",
        "defaultMessage": "Deployment frequency"
    },
    titleHelpTooltip: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.title-help-tooltip",
        "defaultMessage": "Use the 12-week average to see how your team is performing and what corrective actions you need to make based on the deployment frequency comparisons."
    }
});

});

parcelRegister("aD53o", function(module, exports) {

$parcel$export(module.exports, "NoProvider", () => $b6c470d76524dae4$export$1834160caae1409b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $letJZ = parcelRequire("letJZ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $f70oV = parcelRequire("f70oV");

var $eebCH = parcelRequire("eebCH");

var $6dmc7 = parcelRequire("6dmc7");

var $dVe8e = parcelRequire("dVe8e");

var $bxTEa = parcelRequire("bxTEa");
const $b6c470d76524dae4$export$1834160caae1409b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // TODO RLSS-2812 handle darkmode github icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Wrapper, {
        "data-test-id": "software-deployment-frequency-report.ui.deployment-frequency-bar-chart.no-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$TitleText, null, formatMessage((0, $bxTEa.default).noProviderTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $letJZ.BitbucketIcon), {
        size: "xlarge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eebCH))),
        alt: "GitHub"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6dmc7))),
        alt: "GitLab"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$JenkinsIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dVe8e))),
        alt: "Jenkins",
        height: "50"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$Description, null, formatMessage((0, $bxTEa.default).noProviderDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c470d76524dae4$var$LearnMoreWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyStateLearnMore');
        },
        target: "_blank",
        href: "https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started"
    }, formatMessage((0, $f70oV.default).learnMore)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6c470d76524dae4$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iy1l4 _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6c470d76524dae4$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fzreg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b6c470d76524dae4$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1ejb _4t3ickbl _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b6c470d76524dae4$var$TitleText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxu2gc _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $b6c470d76524dae4$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $b6c470d76524dae4$var$JenkinsIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b6c470d76524dae4$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $b6c470d76524dae4$var$LearnMoreWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _1e0c1txw _1bsb1osq _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eebCH", function(module, exports) {
module.exports = new URL("github.d9710574.svg", import.meta.url).toString();

});

parcelRegister("6dmc7", function(module, exports) {
module.exports = new URL("gitlab.411423f1.svg", import.meta.url).toString();

});

parcelRegister("dVe8e", function(module, exports) {
module.exports = new URL("jenkins.77ef5ed5.svg", import.meta.url).toString();

});

parcelRegister("bxTEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f06570c467f701f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f06570c467f701f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTitle: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.chart-title",
        "defaultMessage": "Weekly comparison"
    },
    titleHelpTooltip: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.title-help-tooltip",
        "defaultMessage": "A 12-week data feed that helps you compare your deployment frequencies to your batch size. This helps you analyze and evaluate the risk to your deployments."
    },
    noProviderTitle: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-title",
        "defaultMessage": "Connect your source code management and CI/CD tools"
    },
    noProviderDescription: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.no-provider.no-provider-description",
        "defaultMessage": "Based on the data from your tools, you'll see the comparison between batch sizes and production deployments, and much more."
    }
});

});


parcelRegister("iitmC", function(module, exports) {

$parcel$export(module.exports, "SelectionDetail", () => $a382008e3e771548$export$e4886591ccee2d0c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $6RYAp = parcelRequire("6RYAp");

var $jD6af = parcelRequire("jD6af");
const $a382008e3e771548$export$e4886591ccee2d0c = ({ weekCount: weekCount, weekStartDate: weekStartDate, wholePeriodAverage: wholePeriodAverage, prodDataState: prodDataState })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $koVbs.default)();
    const weekStartDateText = formatMessage((0, $jD6af.default).weekStartDate, {
        date: formatDate(weekStartDate, {
            day: 'numeric',
            month: 'short'
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeekStartDate, null, weekStartDateText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$DeploymentCount, null, weekCount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeeklyProductionDeployments, null, formatMessage((0, $jD6af.default).weeklyProductionDeployment, {
        deploymentCount: weekCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RYAp.DeploymentsTrendSummary), {
        weekCount: weekCount,
        wholePeriodStatistic: wholePeriodAverage,
        prodDataState: prodDataState
    }));
};
const $a382008e3e771548$var$WeekStartDate = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeekStartDateComponent, props));
const $a382008e3e771548$var$DeploymentCount = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xlarge",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$DeploymentCountComponent, props));
const $a382008e3e771548$var$WeeklyProductionDeployments = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a382008e3e771548$var$WeeklyProductionDeploymentsComponent, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a382008e3e771548$var$WeekStartDateComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _19pkxy5q _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a382008e3e771548$var$DeploymentCountComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _19pkze3t",
            __cmplp.className
        ])
    });
});
const $a382008e3e771548$var$WeeklyProductionDeploymentsComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _19pkze3t _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jD6af", function(module, exports) {

$parcel$export(module.exports, "default", () => $17669a6cebcc714b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $17669a6cebcc714b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weeklyProductionDeployment: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.weekly-production-deployment",
        "defaultMessage": "Weekly production {deploymentCount, plural, one {deployment} other {deployments}}"
    },
    weekStartDate: {
        "id": "software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.week-start-date",
        "defaultMessage": "Week of {date}"
    }
});

});



parcelRegister("6vgP1", function(module, exports) {

$parcel$export(module.exports, "DeploymentModal", () => $6fd9816f90cd9c52$export$223e94cc0d2e1af8);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $l4U91 = parcelRequire("l4U91");

var $kBSee = parcelRequire("kBSee");

var $j1sSt = parcelRequire("j1sSt");

var $gilhC = parcelRequire("gilhC");

var $mEdYv = parcelRequire("mEdYv");

var $jKTxB = parcelRequire("jKTxB");

var $aJIPS = parcelRequire("aJIPS");
const $6fd9816f90cd9c52$export$223e94cc0d2e1af8 = ()=>{
    const [{ selectedWeekStart: selectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const selectedDateRange = selectedWeekStart ? (0, $kBSee.getWeekRangeFromWeekStartDate)(selectedWeekStart) : null;
    const { loading: loading, data: data } = (0, $jKTxB.usePeriodBreakdownMetrics)(selectedDateRange);
    const [selectedDeploymentId, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, $mEdYv.useSelectedDeploymentId)();
    if (loading || data == null) return null;
    const selectedDeployment = data.perDeploymentMetrics.find((deployment)=>deployment.id === selectedDeploymentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        eventLocation: "deploymentDetailsDialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, selectedDeployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4U91.default), {
        issueIds: selectedDeployment.issueIds,
        hasPermissionForAllIssues: (0, $aJIPS.hasPermissionForAllIssues)(selectedDeployment),
        deploymentDisplayName: selectedDeployment.displayName,
        deploymentUrl: selectedDeployment.url,
        onClose: ()=>{
            setSelectedDeploymentId(null);
        }
    })));
};

});
parcelRegister("l4U91", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd4d34dade2db561$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $7Dl4r = parcelRequire("7Dl4r");
const $cd4d34dade2db561$var$DeploymentDetailsDialog = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Dl4r.default), props));
var $cd4d34dade2db561$export$2e2bcd8739ae039 = $cd4d34dade2db561$var$DeploymentDetailsDialog;

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7Dl4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0216752b3c8170d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $7NYq5 = parcelRequire("7NYq5");

var $iXVV6 = parcelRequire("iXVV6");

var $7LHuW = parcelRequire("7LHuW");

var $2uWzn = parcelRequire("2uWzn");
const $c0216752b3c8170d$var$DeploymentDetailsModal = ({ issueIds: issueIds, deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, hasPermissionForAllIssues: hasPermissionForAllIssues, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "deploymentNavigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        width: (0, $gwIPs.gridSize) * 116,
        height: (0, $gwIPs.gridSize) * 67,
        autoFocus: false,
        onClose: onClose,
        messageId: "software-deployment-frequency-report-deployment-details-dialog.ui.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2uWzn.default), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LHuW.default), {
        issueIds: issueIds,
        deploymentUrl: deploymentUrl,
        deploymentDisplayName: deploymentDisplayName,
        hasPermissionForAllIssues: hasPermissionForAllIssues
    }))));
var $c0216752b3c8170d$export$2e2bcd8739ae039 = $c0216752b3c8170d$var$DeploymentDetailsModal;

});
parcelRegister("7LHuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5356d4eb94a5d9a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");

var $5oFIy = parcelRequire("5oFIy");

var $gUDZO = parcelRequire("gUDZO");

var $aEwe3 = parcelRequire("aEwe3");

var $3h2r6 = parcelRequire("3h2r6");

var $3lx3f = parcelRequire("3lx3f");
const $b5356d4eb94a5d9a$var$Body = ({ issueIds: issueIds, deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, hasPermissionForAllIssues: hasPermissionForAllIssues })=>{
    const { loading: loading, error: error, data: issues } = (0, $gUDZO.useIssues)(issueIds);
    if (!loading && issues === undefined) throw error ?? Error('Unknown error');
    if (issueIds.length === 0 && !hasPermissionForAllIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lx3f.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aEwe3.default), {
        issueCount: issueIds.length,
        deploymentDisplayName: deploymentDisplayName,
        deploymentUrl: deploymentUrl,
        hasPermissionForAllIssues: hasPermissionForAllIssues
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3h2r6.default), {
        issues: issues ?? 'loading'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            noPermissionForAnyIssues: false
        }
    }));
};
var $b5356d4eb94a5d9a$export$2e2bcd8739ae039 = $b5356d4eb94a5d9a$var$Body;

});
parcelRegister("gUDZO", function(module, exports) {

$parcel$export(module.exports, "useIssues", () => $542ab43d37a86178$export$fdf0b908e72b6bef);

var $5tTFS = parcelRequire("5tTFS");

var $b7zL1 = parcelRequire("b7zL1");

var $ii9iW = parcelRequire("ii9iW");
const $542ab43d37a86178$export$fdf0b908e72b6bef = (issueIds)=>{
    const queryResult = (0, $5tTFS.useQuery)((0, $b7zL1.ISSUE_DETAILS_QUERY), {
        variables: {
            ...(0, $ii9iW.buildQueryVariables)(issueIds)
        },
        errorPolicy: 'all'
    });
    return (0, $ii9iW.transformResult)(queryResult);
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("b7zL1", function(module, exports) {

$parcel$export(module.exports, "ISSUE_DETAILS_QUERY", () => $81cab6d627586083$export$b7ad3811e7929cf8);

var $5cllN = parcelRequire("5cllN");
const $81cab6d627586083$export$b7ad3811e7929cf8 = (0, $5cllN.default)`
    query jira_deploymentFrequencyReportDeploymentDetails_issueDetails_Query($jql: String, $first: Int!) {
        issues(first: $first, jql: $jql) {
            nodes {
                id
                issuekey {
                    stringValue
                }
                issuetype {
                    iconUrl
                }
                issuekey {
                    stringValue
                }
                summary {
                    textValue
                }
                assignee {
                    userValue {
                        displayName
                        avatarUrl
                    }
                }
                status {
                    name
                    statusCategoryId
                }
            }
        }
    }
`;

});

parcelRegister("ii9iW", function(module, exports) {

$parcel$export(module.exports, "buildQueryVariables", () => $f60040039dab7dde$export$9a3cee82e7cc08ff);
$parcel$export(module.exports, "transformResult", () => $f60040039dab7dde$export$f13b29f9ed0c5a03);

var $gULOk = parcelRequire("gULOk");

var $g5X3G = parcelRequire("g5X3G");
// At most 100 issues can be associated with a deployment.
// This also corresponds with the maximum page size supported by the JQL search field.
const $f60040039dab7dde$var$PAGE_SIZE = 100;
const $f60040039dab7dde$var$buildJql = (issueIds)=>issueIds.length > 0 ? `id IN (${issueIds.join(',')})` : '';
const $f60040039dab7dde$export$9a3cee82e7cc08ff = (issueIds)=>({
        first: $f60040039dab7dde$var$PAGE_SIZE,
        jql: $f60040039dab7dde$var$buildJql(issueIds)
    });
const $f60040039dab7dde$var$transformNode = (node)=>{
    const key = node?.issuekey?.stringValue;
    const summary = node?.summary?.textValue;
    const issueTypeIconUrl = node?.issuetype?.iconUrl;
    const assigneeDisplayName = node?.assignee?.userValue?.displayName;
    const assigneeAvatarUrl = node?.assignee?.userValue?.avatarUrl;
    const statusName = node?.status?.name;
    const statusCategory = (0, $gULOk.statusCategoryForId)(node?.status?.statusCategoryId ?? undefined);
    if (key == null || summary == null || statusName == null || issueTypeIconUrl == null) throw Error('Invalid issue node');
    const assignee = assigneeDisplayName == null || assigneeAvatarUrl == null ? 'unassigned' : {
        displayName: assigneeDisplayName,
        avatarUrl: assigneeAvatarUrl
    };
    return {
        key: (0, $g5X3G.toIssueKey)(key),
        summary: summary,
        issueType: {
            iconUrl: issueTypeIconUrl
        },
        assignee: assignee,
        status: {
            name: statusName,
            category: statusCategory
        }
    };
};
const $f60040039dab7dde$export$f13b29f9ed0c5a03 = (queryResult)=>{
    const resultBase = {
        loading: queryResult.loading,
        error: queryResult.error
    };
    const nodes = queryResult.data?.issues?.nodes;
    if (queryResult.loading || nodes == null) return resultBase;
    try {
        return {
            ...resultBase,
            data: nodes.map($f60040039dab7dde$var$transformNode)
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            ...resultBase,
            error: queryResult.error ?? error
        };
    }
};

});


parcelRegister("aEwe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b20ef06f611c1394$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $lJosW = parcelRequire("lJosW");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $gIl2t = parcelRequire("gIl2t");

var $3u3yu = parcelRequire("3u3yu");
const $b20ef06f611c1394$var$DeploymentSummary = ({ deploymentDisplayName: deploymentDisplayName, deploymentUrl: deploymentUrl, issueCount: issueCount, hasPermissionForAllIssues: hasPermissionForAllIssues })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let issuesShippedMessage;
    if (hasPermissionForAllIssues) issuesShippedMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3u3yu.default).issuesShippedIssueTermRefresh : (0, $3u3yu.default).issuesShipped;
    else issuesShippedMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $3u3yu.default).issuesShippedLimitedPermissionsIssueTermRefresh : (0, $3u3yu.default).issuesShippedLimitedPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$DeploymentLink, {
        href: deploymentUrl,
        target: "_blank"
    }, deploymentDisplayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b20ef06f611c1394$var$IssuesShippedContainer, {
        "data-test-id": "software-deployment-frequency-report-deployment-details-dialog.ui.body.deployment-summary.issues-shipped-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_18u01b66"
        ])
    }, formatMessage(issuesShippedMessage, {
        issueCount: issueCount
    })), !hasPermissionForAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIl2t.default), {
        message: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $3u3yu.default).issuesShippedLimitedPermissionsTooltipIssueTermRefresh) : formatMessage((0, $3u3yu.default).issuesShippedLimitedPermissionsTooltip),
        testId: "software-deployment-frequency-report-deployment-details-dialog.ui.body.deployment-summary.help-icon" // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & Props'.ts(2322)
        ,
        className: (0, $bwpsq.default)([
            "_18u01b66"
        ])
    })));
};
var $b20ef06f611c1394$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b20ef06f611c1394$var$DeploymentSummary;
const $b20ef06f611c1394$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b20ef06f611c1394$var$DeploymentLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _syaz14q2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b20ef06f611c1394$var$IssuesShippedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b20ef06f611c1394$var$marginLeftStyles = null;

});
parcelRegister("gIl2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $539d60c3ccd9e923$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");
const $539d60c3ccd9e923$var$HelpIcon = ({ message: message, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539d60c3ccd9e923$var$HelpIconContainer, {
        "data-test-id": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small",
        label: ""
    })));
var $539d60c3ccd9e923$export$2e2bcd8739ae039 = $539d60c3ccd9e923$var$HelpIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $539d60c3ccd9e923$var$HelpIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3u3yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf1793fbf4098740$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bf1793fbf4098740$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuesShipped: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production"
    },
    issuesShippedIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-issue-term-refresh",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} shipped to production"
    },
    issuesShippedLimitedPermissions: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions",
        "defaultMessage": "Showing {issueCount} {issueCount, plural, one {issue} other {issues}} shipped to production"
    },
    issuesShippedLimitedPermissionsIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-issue-term-refresh",
        "defaultMessage": "Showing {issueCount} {issueCount, plural, one {work item} other {work items}} shipped to production"
    },
    issuesShippedLimitedPermissionsTooltip: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-tooltip",
        "defaultMessage": "You are viewing the issues based on the permissions. Contact admin for details."
    },
    issuesShippedLimitedPermissionsTooltipIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.deployment-summary.issues-shipped-limited-permissions-tooltip-issue-term-refresh",
        "defaultMessage": "You are viewing the work items based on the permissions. Contact admin for details."
    }
});

});


parcelRegister("3h2r6", function(module, exports) {

$parcel$export(module.exports, "default", () => $485323c55f5a9010$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k3qRI = parcelRequire("k3qRI");

var $iy3HT = parcelRequire("iy3HT");
const $485323c55f5a9010$var$ROWS_PER_PAGE = 7;
const $485323c55f5a9010$var$IssueTable = ({ issues: issues })=>{
    const head = (0, $iy3HT.useTableHead)();
    const rows = (0, $iy3HT.useTableRows)(issues === 'loading' ? [] : issues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        rowsPerPage: // Only show the pagination buttons if there is more than one page of issues
        issues !== 'loading' && issues.length > $485323c55f5a9010$var$ROWS_PER_PAGE ? $485323c55f5a9010$var$ROWS_PER_PAGE : undefined,
        isLoading: issues === 'loading',
        isFixedSize: true,
        head: head,
        rows: rows
    });
};
var $485323c55f5a9010$export$2e2bcd8739ae039 = $485323c55f5a9010$var$IssueTable;

});
parcelRegister("k3qRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e4f0159aa1c87c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $gS5Cm = parcelRequire("gS5Cm");

var $dHbUn = parcelRequire("dHbUn");
class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $eGmKJ.default),
            onSort: (0, $eGmKJ.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dHbUn.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $gS5Cm.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $3zBQA = parcelRequire("3zBQA");

var $14Kfa = parcelRequire("14Kfa");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($3zBQA))) : (0, (/*@__PURE__*/$parcel$interopDefault($14Kfa)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("3zBQA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a1ffa1f260b277$var$_react = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $29a1ffa1f260b277$var$_chevronLeft = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("ks8FD")));

var $29a1ffa1f260b277$var$_chevronLeftLarge = $29a1ffa1f260b277$var$_interopRequireDefault((parcelRequire("a88oa")));
function $29a1ffa1f260b277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29a1ffa1f260b277$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $29a1ffa1f260b277$var$_react.default.createElement($29a1ffa1f260b277$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $29a1ffa1f260b277$var$_chevronLeftLarge.default
    }, props));
$29a1ffa1f260b277$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $29a1ffa1f260b277$var$_default = module.exports.default = $29a1ffa1f260b277$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("14Kfa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c8a092ead4633f0$var$_react = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0c8a092ead4633f0$var$_chevronRight = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("bpC55")));

var $0c8a092ead4633f0$var$_chevronRightLarge = $0c8a092ead4633f0$var$_interopRequireDefault((parcelRequire("h1toL")));
function $0c8a092ead4633f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c8a092ead4633f0$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0c8a092ead4633f0$var$_react.default.createElement($0c8a092ead4633f0$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0c8a092ead4633f0$var$_chevronRightLarge.default
    }, props));
$0c8a092ead4633f0$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0c8a092ead4633f0$var$_default = module.exports.default = $0c8a092ead4633f0$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $d9c80f4a483cfd6a$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});


parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});



parcelRegister("iy3HT", function(module, exports) {

$parcel$export(module.exports, "useTableHead", () => $1dcad16b66d94292$export$c1593f9fc5eec62b);
$parcel$export(module.exports, "useTableRows", () => $1dcad16b66d94292$export$a190e1af00082b41);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $2EwJD = parcelRequire("2EwJD");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $difD3 = parcelRequire("difD3");

var $kun5c = parcelRequire("kun5c");

var $eUfvr = parcelRequire("eUfvr");
const $1dcad16b66d94292$export$c1593f9fc5eec62b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return {
        cells: [
            {
                width: 55,
                key: 'issue',
                content: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $kun5c.default).issueIssueTermRefresh) : formatMessage((0, $kun5c.default).issue)
            },
            {
                width: 25,
                key: 'assignee',
                content: formatMessage((0, $kun5c.default).assignee)
            },
            {
                width: 20,
                key: 'status',
                content: formatMessage((0, $kun5c.default).status)
            }
        ]
    };
};
const $1dcad16b66d94292$export$a190e1af00082b41 = (issues)=>issues.map(({ key: key, summary: summary, issueType: issueType, assignee: assignee, status: status })=>({
            cells: [
                {
                    key: key,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUfvr.default), {
                        issueKey: key,
                        issueTypeIconUrl: issueType.iconUrl,
                        summary: summary
                    })
                },
                {
                    key: key,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $difD3.default), {
                        assignee: assignee
                    })
                },
                {
                    key: key,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
                        name: status.name,
                        category: status.category
                    })
                }
            ]
        }));

});
parcelRegister("2EwJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd41c6095391bfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $gULOk = parcelRequire("gULOk");
const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("difD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdaceead66c5adeb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $fdaceead66c5adeb$var$AssigneeCell = ({ assignee: assignee })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdaceead66c5adeb$var$Container, null, assignee === 'unassigned' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: assignee.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdaceead66c5adeb$var$Name, null, assignee.displayName)));
var $fdaceead66c5adeb$export$2e2bcd8739ae039 = $fdaceead66c5adeb$var$AssigneeCell;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fdaceead66c5adeb$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg _8mocu2gc",
            __cmplp.className
        ])
    });
});
const $fdaceead66c5adeb$var$Name = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kun5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a94a439d5d7d0921$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a94a439d5d7d0921$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issue: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.issue",
        "defaultMessage": "Issue"
    },
    issueIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.issue-issue-term-refresh",
        "defaultMessage": "Work item"
    },
    assignee: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.assignee",
        "defaultMessage": "Assignee"
    },
    status: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.issue-table.status",
        "defaultMessage": "Status"
    }
});

});

parcelRegister("eUfvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27e549efb4b13e4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hjSul = parcelRequire("hjSul");
const $f27e549efb4b13e4$var$SummaryCell = ({ issueKey: issueKey, summary: summary, issueTypeIconUrl: issueTypeIconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueTypeIcon, {
        src: issueTypeIconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueKeyLink, {
        href: `/browse/${issueKey}`,
        target: "_blank"
    }, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f27e549efb4b13e4$var$IssueSummary, null, summary));
var $f27e549efb4b13e4$export$2e2bcd8739ae039 = $f27e549efb4b13e4$var$SummaryCell;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f27e549efb4b13e4$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f27e549efb4b13e4$var$IssueTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwxu2gc _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $f27e549efb4b13e4$var$IssueSummary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f27e549efb4b13e4$var$IssueKeyLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});



parcelRegister("3lx3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d57e97d7d913613$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $l1N8i = parcelRequire("l1N8i");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $3Uttp = parcelRequire("3Uttp");

var $4R6GH = parcelRequire("4R6GH");

var $1rWqg = parcelRequire("1rWqg");

var $jUO7W = parcelRequire("jUO7W");
const $6d57e97d7d913613$var$useHelpLink = ()=>{
    const isSimplified = (0, $3Uttp.useProjectSimplified)();
    if (isSimplified === null) return undefined;
    return isSimplified ? 'https://support.atlassian.com/jira-software-cloud/docs/next-gen-permissions/#Overviewofpermissionsinnextgenprojects-Projectpermissions' : 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects';
};
const $6d57e97d7d913613$var$NoPermissionForAnyIssues = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const helpLink = $6d57e97d7d913613$var$useHelpLink();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d57e97d7d913613$var$Container, {
        "data-test-id": "software-deployment-frequency-report-deployment-details-dialog.ui.body.no-permission.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            noPermissionForAnyIssues: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1rWqg))),
        alt: "",
        width: 14 * (0, $gwIPs.gridSize)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d57e97d7d913613$var$Explanation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $jUO7W.default).titleIssueTermRefresh) : formatMessage((0, $jUO7W.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $jUO7W.default).descriptionIssueTermRefresh) : formatMessage((0, $jUO7W.default).description), (0, $4R6GH.fg)('replace-anchor-with-link__fusion-solaris') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: helpLink || '',
        target: "_blank"
    }, formatMessage((0, $jUO7W.default).learnMore)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: helpLink,
        target: "_blank"
    }, formatMessage((0, $jUO7W.default).learnMore)))));
};
var $6d57e97d7d913613$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6d57e97d7d913613$var$NoPermissionForAnyIssues;
const $6d57e97d7d913613$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ixilx _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d57e97d7d913613$var$Explanation = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1pna _18u0xncg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Uttp", function(module, exports) {

$parcel$export(module.exports, "useProjectSimplified", () => $f12a03f526c05746$export$9f0c70b531288073);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $f12a03f526c05746$export$b6a91b2d78273787);

var $dAfqg = parcelRequire("dAfqg");

var $g5X3G = parcelRequire("g5X3G");

var $bmKPg = parcelRequire("bmKPg");
const $f12a03f526c05746$export$f87be37f8e8be65 = ()=>{
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $g5X3G.toProjectKey)(projectKey);
};
const $f12a03f526c05746$export$16d1475ed6c26568 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return data === null ? null : (0, $g5X3G.toProjectId)(`${data.projectId}`);
};
const $f12a03f526c05746$export$4d975d76445a6650 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    if (data === null) return null;
    const { isProjectAdmin: isProjectAdmin } = data;
    return isProjectAdmin === undefined ? null : isProjectAdmin;
};
const $f12a03f526c05746$export$9f0c70b531288073 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return data === null ? null : data.simplified;
};
const $f12a03f526c05746$export$b6a91b2d78273787 = ()=>{
    const projectId = $f12a03f526c05746$export$16d1475ed6c26568();
    const isProjectAdmin = $f12a03f526c05746$export$4d975d76445a6650();
    const isProjectSimplified = $f12a03f526c05746$export$9f0c70b531288073();
    if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
    return {
        isSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});

parcelRegister("1rWqg", function(module, exports) {
module.exports = new URL("lock-closed.123c4a2f.svg", import.meta.url).toString();

});

parcelRegister("jUO7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49dd5f0e1b6e809$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c49dd5f0e1b6e809$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.title",
        "defaultMessage": "Limited issue permissions"
    },
    titleIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.title-issue-term-refresh",
        "defaultMessage": "Limited work item permissions"
    },
    description: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.description",
        "defaultMessage": "You don't have permission to view the issues included in this deployment. Contact project admin for details."
    },
    descriptionIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.description-issue-term-refresh",
        "defaultMessage": "You don't have permission to view the work items included in this deployment. Contact project admin for details."
    },
    learnMore: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.body.no-permission.learn-more",
        "defaultMessage": "Learn more."
    }
});

});



parcelRegister("2uWzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a64c4135f12f24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $gIl2t = parcelRequire("gIl2t");

var $lmtHl = parcelRequire("lmtHl");

var $3VYpx = parcelRequire("3VYpx");
const $03a64c4135f12f24$var$CloseButton = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClose,
        spacing: "none",
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$CloseIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        spacing: "spacious",
        label: formatMessage((0, $3VYpx.default).closeButtonLabel)
    })));
};
const $03a64c4135f12f24$var$Header = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$LeftSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $3VYpx.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03a64c4135f12f24$var$helpIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIl2t.default), {
        message: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $3VYpx.default).helpTooltipIssueTermRefresh) : formatMessage((0, $3VYpx.default).helpTooltip)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$RightSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $03a64c4135f12f24$var$feedbackButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lmtHl.FeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03a64c4135f12f24$var$CloseButton, {
        onClose: onClose
    })));
};
var $03a64c4135f12f24$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $03a64c4135f12f24$var$Header;
const $03a64c4135f12f24$var$LeftSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $03a64c4135f12f24$var$helpIconWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03a64c4135f12f24$var$RightSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $03a64c4135f12f24$var$feedbackButtonWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03a64c4135f12f24$var$CloseIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lmtHl", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $bf37f71af7cf7cad$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $fMtXj = parcelRequire("fMtXj");

var $fPB66 = parcelRequire("fPB66");

var $3Uttp = parcelRequire("3Uttp");
const $bf37f71af7cf7cad$var$FEEDBACK_COLLECTOR_LOCATION = 'reports.deployment-frequency.deployment-details-dialog';
const $bf37f71af7cf7cad$export$116fedbe5e2e2bd8 = ()=>{
    const { data: deploymentProviders, error: errorDeploymentProviders } = (0, $fMtXj.useDeploymentProviders)();
    const projectAttributes = (0, $3Uttp.useProjectAnalyticsAttributes)();
    if (projectAttributes === null) return null;
    if (errorDeploymentProviders) throw new Error(`Getting deployment providers failed when using useDeploymentProviders while attempting to display Deployment Frequency Report feedback button. Details: ${errorDeploymentProviders.message}`);
    const additionalFeedbackEntries = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $bf37f71af7cf7cad$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: projectAttributes.isSimplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: projectAttributes.isProjectAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).DEPLOYMENT_PROVIDERS,
            value: deploymentProviders ? (0, $fPB66.hideUGCProviderName)(deploymentProviders).map((deploymentProvider)=>deploymentProvider.name).join(', ') : ''
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || '',
        "aria-haspopup": "dialog"
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901u28 _16hgp7j4 _1fh11u28 _u1mb1jkz _r7smdh45 _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});



parcelRegister("3VYpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $27866dc30ad89711$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $27866dc30ad89711$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.header.title",
        "defaultMessage": "Deployment navigator"
    },
    helpTooltip: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.header.help-tooltip",
        "defaultMessage": "Drill-down to your deployment to understand what issues were included with it."
    },
    helpTooltipIssueTermRefresh: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.header.help-tooltip-issue-term-refresh",
        "defaultMessage": "Drill-down to your deployment to understand what work items were included with it."
    },
    closeButtonLabel: {
        "id": "software-deployment-frequency-report-deployment-details-dialog.header.close-button-label",
        "defaultMessage": "Close"
    }
});

});




parcelRegister("aJIPS", function(module, exports) {

$parcel$export(module.exports, "hasPermissionForAllIssues", () => $ecdd2e247f4b9faa$export$3bc7b8d402ccf8a);
const $ecdd2e247f4b9faa$export$3bc7b8d402ccf8a = (deployment)=>deployment.issueCount === deployment.issueIds.length;

});


parcelRegister("lVXtL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c55c6a1238404e7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $jS4lj = parcelRequire("jS4lj");

var $41j30 = parcelRequire("41j30");

var $cS37j = parcelRequire("cS37j");

var $koVbs = parcelRequire("koVbs");

var $auDmG = parcelRequire("auDmG");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9F5Tv = parcelRequire("9F5Tv");

var $doZTA = parcelRequire("doZTA");

var $ecd0S = parcelRequire("ecd0S");

var $j1sSt = parcelRequire("j1sSt");

var $ilLj2 = parcelRequire("ilLj2");

var $1yYqj = parcelRequire("1yYqj");

var $kk2bk = parcelRequire("kk2bk");
const $7c55c6a1238404e7$var$Header = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSimplified = (0, $ilLj2.useProjectSimplified)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null);
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const boardId = match.params.boardId ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs,
        truncateTitle: true,
        disableTitleStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$HeaderTopContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $kk2bk.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1sSt.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "feedbackButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yYqj.FeedbackButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F5Tv.JswShareButton), {
        boardId: boardId
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$HeaderContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c55c6a1238404e7$var$PageDescription, null, formatMessage((0, $kk2bk.default).description), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auDmG.HelpPanelButton), {
        articleId: (0, $ecd0S.IN_PRODUCT_HELP_ARTICLE_ID),
        appearance: "link",
        spacing: "none",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'deploymentFrequencyLearnMore'
            }));
        },
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            href: isSimplified === true ? (0, $ecd0S.DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED) : (0, $ecd0S.DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED),
            target: "_blank",
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'deploymentFrequencyLearnMore'
                }));
            }
        }, formatMessage((0, $kk2bk.default).learnMore))
    }, formatMessage((0, $kk2bk.default).learnMore)))));
};
var $7c55c6a1238404e7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7c55c6a1238404e7$var$Header;
const $7c55c6a1238404e7$var$HeaderTopContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _4t3izwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c55c6a1238404e7$var$TitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c55c6a1238404e7$var$PageDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c55c6a1238404e7$var$HeaderContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("auDmG", function(module, exports) {

$parcel$export(module.exports, "HelpPanelButton", () => $c4b9c1de653fb6b2$export$4b6bbd2e0136b372);

var $5uXOq = parcelRequire("5uXOq");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $c4b9c1de653fb6b2$export$4b6bbd2e0136b372 = ({ HelpButtonLink: HelpButtonLink = (0, $5Zxxp.HelpPanelLink), articleId: articleId, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useCallback: useCallback = (0, $5uXOq.useCallback), ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = useCallback(()=>fireUIAnalytics(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'sidebar', {
            helpArticleId: articleId,
            itemId: 'learnMore'
        }), [
        articleId,
        createAnalyticsEvent,
        fireUIAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HelpButtonLink, {
        articleId: articleId,
        type: "HELP_ARTICLE",
        appearance: "subtle-link",
        spacing: "none",
        onClick: onClick,
        ...rest
    });
};

});

parcelRegister("9F5Tv", function(module, exports) {

$parcel$export(module.exports, "JswShareButton", () => $71a62af6dae27b53$export$54c54e47ce207cc8);

var $5uXOq = parcelRequire("5uXOq");

var $6BtlL = parcelRequire("6BtlL");

var $koVbs = parcelRequire("koVbs");

var $5GqLe = parcelRequire("5GqLe");

var $iL8EU = parcelRequire("iL8EU");

var $koeKL = parcelRequire("koeKL");

var $lwYh5 = parcelRequire("lwYh5");
const $71a62af6dae27b53$var$REPORT_SHARE_CONTENT_TYPE = 'report';
const $71a62af6dae27b53$export$54c54e47ce207cc8 = ({ boardId: boardId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!boardId) return null;
    const objectAri = (0, $6BtlL.JiraSoftwareBoardAri).create({
        boardId: String(boardId),
        siteId: cloudId
    }).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        integrationType: (0, $5GqLe.integrationTypes).CLASSIC_BOARD,
        triggerButtonStyle: "icon-only",
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: formatMessage((0, $lwYh5.default).shareTitle),
        shareFormTitle: formatMessage((0, $lwYh5.default).shareFormTitle),
        shareContentType: $71a62af6dae27b53$var$REPORT_SHARE_CONTENT_TYPE,
        objectAri: objectAri,
        copyTooltipText: formatMessage((0, $lwYh5.default).shareTooltipText),
        shareFormHelperMessage: formatMessage((0, $lwYh5.default).shareHelperMessage),
        poSpotlightShareButtonId: "po-spotlight-share-button"
    });
};

});
parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $0970fea694a8095f$export$f7109619a5e9e0d6);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};
const $0970fea694a8095f$export$f7109619a5e9e0d6 = 'growthShareButton';

});

parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButtonSync", () => $4e5335f44d688bbf$export$9b6a83af27cc7de5);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $7aU9g = parcelRequire("7aU9g");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("7aU9g"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$9b6a83af27cc7de5 = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props)));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("7aU9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraShareButton", () => $4e0ba5939e9454a3$export$1b9334aba47cc461);
$parcel$export(module.exports, "default", () => $4e0ba5939e9454a3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $81zXP = parcelRequire("81zXP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $dAfqg = parcelRequire("dAfqg");

var $cSD7y = parcelRequire("cSD7y");

var $lIxty = parcelRequire("lIxty");

var $3Qkpk = parcelRequire("3Qkpk");

var $ly021 = parcelRequire("ly021");

var $3Misg = parcelRequire("3Misg");

var $cvSAQ = parcelRequire("cvSAQ");

var $60DYE = parcelRequire("60DYE");

var $cRUzY = parcelRequire("cRUzY");

var $fG2b8 = parcelRequire("fG2b8");

var $hn0BX = parcelRequire("hn0BX");

var $1uAgh = parcelRequire("1uAgh");

var $ckpyh = parcelRequire("ckpyh");
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $4e0ba5939e9454a3$var$JiraShareButtonOld = (props)=>{
    const { triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, poSpotlightShareButtonId: poSpotlightShareButtonId, additionalTabs: additionalTabs, shareIntegrations: shareIntegrations, shareFieldsFooter: shareFieldsFooterProp, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $3Qkpk.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $ly021.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $lIxty.useIsHipaaComplianceService)();
    const [isAutoOpen, setIsAutoOpen] = (0, $5uXOq.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $5uXOq.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $jcw0u.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $jcw0u.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userPermissionError) (0, $jcw0u.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: projectAccessData, fetch: fetchProjectAccessLevels, loading: isProjectAccessLoading } = (0, $3Misg.useProjectAccessLevel)();
    const { data: userRoles, fetch: fetchUserRoles, loading: userRolesLoading } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    const shareFieldsFooter = isExtendedShareDialogEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraShareButtonProjectAccessLevel",
        packageName: "jiraShareButton",
        teamName: "a4t-pandora",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckpyh.ProjectAccessLevelSelectContainer), {
        currentAccessLevel: projectAccessData?.accessLevel,
        accessLevels: projectAccessData?.availableAccessLevels,
        getProjectAccessLevels: fetchProjectAccessLevels,
        isLoading: isProjectAccessLoading
    })), shareFieldsFooterProp) : shareFieldsFooterProp;
    const isOutgoingMailDisabled = outgoingMailStatus?.isEmailEnabled === false;
    const isDisabledDueToEmail = isOutgoingMailDisabled && (additionalTabs?.length ?? 0) === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (outgoingMailStatus === undefined || isDisabledDueToEmail || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hn0BX.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        ...isExtendedShareDialogEnabled && {
            getUserRoles: fetchUserRoles
        },
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    }), outgoingMailStatus !== undefined && !isDisabledDueToEmail && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uAgh.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $4R6GH.fg)('jira_share_button-enable_jira_workspace_ari') ? (0, $81zXP.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        additionalTabs: additionalTabs,
        shareIntegrations: isOutgoingMailDisabled ? [] : shareIntegrations,
        isOutgoingMailDisabled: isOutgoingMailDisabled,
        shareFieldsFooter: isOutgoingMailDisabled ? (0, $cRUzY.default)({
            canUserEnableEmail: outgoingMailStatus?.canUserEnableEmail
        }) : shareFieldsFooter,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        ...isExtendedShareDialogEnabled && {
            userRoles: userRoles,
            userRolesLoading: userRolesLoading,
            accessLevel: projectAccessData?.accessLevel.value
        },
        ...otherProps
    }));
};
const $4e0ba5939e9454a3$var$MemoedJiraShareButton = /*#__PURE__*/ (0, $5uXOq.memo)($4e0ba5939e9454a3$var$JiraShareButtonOld);
const $4e0ba5939e9454a3$export$1b9334aba47cc461 = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $4e0ba5939e9454a3$var$MemoedJiraShareButton, $4e0ba5939e9454a3$var$JiraShareButtonOld);
var $4e0ba5939e9454a3$export$2e2bcd8739ae039 = $4e0ba5939e9454a3$export$1b9334aba47cc461;

});
parcelRegister("lIxty", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $8b53c07d7b6353b9$export$dad138577ca71048);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b53c07d7b6353b9$var$getHipaaComplianceStatus = async ()=>(0, $eusud.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $8b53c07d7b6353b9$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $ld2hZ.useService)($8b53c07d7b6353b9$var$getHipaaComplianceStatus);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("3Qkpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b79009b50ad613d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b79009b50ad613d$var$getEmailSettings = async ()=>(0, $eusud.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $8b79009b50ad613d$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $ld2hZ.useService)($8b79009b50ad613d$var$getEmailSettings);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $8b79009b50ad613d$export$2e2bcd8739ae039 = $8b79009b50ad613d$export$5f20fafd52370aae;

});

parcelRegister("ly021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c761b58cac213d$export$2e2bcd8739ae039);

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $b3c761b58cac213d$var$getUserPermission = async ()=>(0, $eusud.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $b3c761b58cac213d$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $ld2hZ.useService)($b3c761b58cac213d$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $b3c761b58cac213d$export$2e2bcd8739ae039 = $b3c761b58cac213d$export$ce7974a7294500be;

});

parcelRegister("3Misg", function(module, exports) {

$parcel$export(module.exports, "useProjectAccessLevel", () => $da4bace31cc40a76$export$e262f937bd216199);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $dAfqg = parcelRequire("dAfqg");
const $da4bace31cc40a76$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $eusud.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $da4bace31cc40a76$var$getProjectAccessLevels = async ()=>{
    return (0, $eusud.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $da4bace31cc40a76$var$updateProjectAccessLevel = async ({ projectId: projectId, projectKey: projectKey, accessLevel: accessLevel })=>{
    if (!projectId || !projectKey) throw new Error('Project ID and/or Key is missing while updating project access level.');
    return (0, $eusud.performPutRequest)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        body: JSON.stringify({
            accessLevel: accessLevel,
            key: projectKey
        })
    });
};
const $da4bace31cc40a76$export$e262f937bd216199 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { projectId: projectId, projectKey: projectKey } = (0, $5uXOq.useMemo)(()=>({
            projectId: projectContext?.projectId,
            projectKey: projectContext?.projectKey
        }), [
        projectContext
    ]);
    const fetchProjectAccessLevels = (0, $5uXOq.useCallback)(()=>Promise.all([
            $da4bace31cc40a76$var$getProjectAccessLevel(projectId),
            $da4bace31cc40a76$var$getProjectAccessLevels()
        ]).then(([accessLevel, availableAccessLevels])=>({
                accessLevel: accessLevel,
                availableAccessLevels: availableAccessLevels
            })), [
        projectId
    ]);
    const sendProjectAccessLevelUpdate = (0, $5uXOq.useCallback)(({ accessLevel: accessLevel })=>$da4bace31cc40a76$var$updateProjectAccessLevel({
            projectId: projectId,
            projectKey: projectKey,
            accessLevel: accessLevel
        }), [
        projectId,
        projectKey
    ]);
    const { loading: isLoading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(fetchProjectAccessLevels);
    const { loading: isUpdating, error: updateError, fetch: update } = (0, $ld2hZ.useService)(sendProjectAccessLevelUpdate);
    return {
        loading: isLoading || isUpdating,
        error: error || updateError,
        data: data,
        fetch: fetch,
        update: update
    };
};

});

parcelRegister("cvSAQ", function(module, exports) {

$parcel$export(module.exports, "useIsExtendedShareDialogEnabled", () => $8c2efaed9c82d207$export$1000ebfdeca10b3c);

var $6s1PB = parcelRequire("6s1PB");

var $3HwlS = parcelRequire("3HwlS");

var $lODMY = parcelRequire("lODMY");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");
const $8c2efaed9c82d207$export$1000ebfdeca10b3c = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const projectType = projectContextData?.projectType;
    const isBusinessOrSoftwareProject = projectType === 'business' || projectType === 'software';
    const shouldShowInNav3View = (0, $lODMY.useIsActiveRoute)(new Set([
        'software-timeline',
        'software-boards',
        'software-backlog',
        'issue'
    ]));
    return ((0, $3HwlS.getWillShowNav4)() || shouldShowInNav3View) && isBusinessOrSoftwareProject && isTMP && (isAdmin || isProjectAdmin) && (0, $6s1PB.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false);
};

});

parcelRegister("60DYE", function(module, exports) {

$parcel$export(module.exports, "useUserRole", () => $13fb2e5bc2538e40$export$77101ee802ae0455);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $13fb2e5bc2538e40$var$getUserRolesService = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $13fb2e5bc2538e40$var$addUserRoleService = ({ projectKey: projectKey, roleId: roleId, groups: groups, users: users })=>{
    if (!projectKey) throw new Error('Project key is required to add user role');
    return (0, $eusud.performPostRequest)(`/rest/projectconfig/latest/roles/${projectKey}/${roleId}`, {
        body: JSON.stringify({
            groups: groups,
            users: users
        })
    });
};
const $13fb2e5bc2538e40$export$77101ee802ae0455 = (projectKey)=>{
    const { data: data, fetch: fetch, loading: isFetching, error: fetchError } = (0, $ld2hZ.useService)(()=>$13fb2e5bc2538e40$var$getUserRolesService(projectKey));
    const { loading: isAdding, error: addError, fetch: addUserRoleInternal } = (0, $ld2hZ.useService)($13fb2e5bc2538e40$var$addUserRoleService);
    const add = (0, $5uXOq.useCallback)((roleId, { users: users, groups: groups })=>addUserRoleInternal({
            projectKey: projectKey,
            roleId: roleId,
            users: users,
            groups: groups
        }), [
        addUserRoleInternal,
        projectKey
    ]);
    return {
        fetch: fetch,
        add: add,
        data: data,
        loading: isFetching || isAdding,
        error: fetchError || addError
    };
};

});

parcelRegister("cRUzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2333dcf1c6e1c11b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $cGLqe = parcelRequire("cGLqe");
const $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage = ({ canUserEnableEmail: canUserEnableEmail })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            href: "/secure/admin/OutgoingMailServers.jspa"
        }, formatMessage((0, $cGLqe.default).outgoingMailSettingsLink)),
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).nonAdminWarningMessage)));
};
var $2333dcf1c6e1c11b$export$2e2bcd8739ae039 = $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage;

});
parcelRegister("cGLqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5118dd1ca51be8cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5118dd1ca51be8cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    },
    disabledWarningMessageIfHipaaIssueTermRefresh: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa-issue-term-refresh",
        "defaultMessage": "You can't share work item as your organization has signed up for HIPAA compliance"
    },
    outgoingMailSettingsLink: {
        "id": "share-button.pre-share-view.warning-content.enable-outgoing-mail-link",
        "defaultMessage": "Set up email sharing"
    }
});

});


parcelRegister("fG2b8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a915a4d87397f963$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a915a4d87397f963$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("hn0BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6286a7fcdb67d585$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $empdx = parcelRequire("empdx");

var $kOEld = parcelRequire("kOEld");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");

var $ggimd = parcelRequire("ggimd");

var $6P8F6 = parcelRequire("6P8F6");
const $6286a7fcdb67d585$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ggimd.default).shareTriggerButtonText),
        position: "top"
    }, children);
};
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $6286a7fcdb67d585$var$PreShareViewOld = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, getUserRoles: getUserRoles, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount, poSpotlightShareButtonId: poSpotlightShareButtonId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
            getUserRoles && getUserRoles();
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus,
        getUserRoles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $gwIPs.layers).modal,
        messageId: "share-button.ui.pre-share-view.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6P8F6.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ggimd.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$ConditionalTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-pre-share-button"
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                isDisabled: loading,
                label: formatMessage((0, $ggimd.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                        spacing: "spacious",
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText),
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText),
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $ggimd.default).shareTriggerButtonText) : null)))
    });
};
const $6286a7fcdb67d585$var$MemoedPreShareView = /*#__PURE__*/ (0, $5uXOq.memo)($6286a7fcdb67d585$var$PreShareViewOld);
const $6286a7fcdb67d585$export$412417a0122f041e = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $6286a7fcdb67d585$var$MemoedPreShareView, $6286a7fcdb67d585$var$PreShareViewOld);
var $6286a7fcdb67d585$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6286a7fcdb67d585$export$412417a0122f041e;
const $6286a7fcdb67d585$var$DialogLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ggimd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3676909909c5a34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3676909909c5a34$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("6P8F6", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $ecad3da73effb00b$export$b7eb687edfdfe752);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $cGLqe = parcelRequire("cGLqe");
function $ecad3da73effb00b$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cGLqe.default).disabledWarningMessageIfHipaaIssueTermRefresh : (0, $cGLqe.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});


parcelRegister("1uAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $379ea30a2af32bdf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $dsCiy = parcelRequire("dsCiy");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $pa9q9 = parcelRequire("pa9q9");
var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $kAdLR = parcelRequire("kAdLR");

var $aYuZy = parcelRequire("aYuZy");

var $kwHgU = parcelRequire("kwHgU");

var $8HBuB = parcelRequire("8HBuB");

var $cvSAQ = parcelRequire("cvSAQ");

var $3Misg = parcelRequire("3Misg");

var $b4Qrh = parcelRequire("b4Qrh");

var $60DYE = parcelRequire("60DYE");

var $5GqLe = parcelRequire("5GqLe");
const $379ea30a2af32bdf$var$USER_PICKER_LIMIT = 20;
class $379ea30a2af32bdf$export$e980dfbc2840e8bc extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props), this.getOriginTracingInstance = ()=>new (0, $2gQ83.default)({
                product: this.props.productId
            }), this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$379ea30a2af32bdf$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $7f4tk.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        }, this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService?.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                    messageType: 'transactional'
                });
            });
        }, this.cloudId = '';
        this.cloudId = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $aYuZy.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isOutgoingMailDisabled: isOutgoingMailDisabled, customHeader: customHeader, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $kAdLR.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            isSubmitShareDisabled: isOutgoingMailDisabled,
            customHeader: customHeader,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
            additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
                roles: userRoles,
                isLoading: !!userRolesLoading
            }),
            CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
            onSubmit: onSubmit
        });
    }
}
const $379ea30a2af32bdf$var$messages = (0, $7VHMR.defineMessages)({
    projectAccessLevelUpdated: {
        "id": "share-button.ui.share-view.project-access-level-updated.non-final",
        "defaultMessage": "Access updated"
    },
    errorUpdateProjectAccessLevel: {
        "id": "share-button.ui.share-view.error-update-project-access-level.non-final",
        "defaultMessage": "Error updating project access level"
    },
    errorAddingUsersToRole: {
        "id": "share-button.ui.share-view.error-adding-users-to-role.non-final",
        "defaultMessage": "Error adding users to role"
    }
});
const $379ea30a2af32bdf$var$noop = ()=>null;
const $379ea30a2af32bdf$var$ShareButtonFC = ({ objectAri: objectAri, triggerButtonAppearance: triggerButtonAppearance = 'subtle', onTriggerButtonClick: onTriggerButtonClick = $379ea30a2af32bdf$var$noop, integrationMode: integrationMode = 'off', isBrowseUsersEnabled: isBrowseUsersEnabled, isOutgoingMailDisabled: isOutgoingMailDisabled, legacyShareClientConfig: legacyShareClientConfig, shouldAutoDismissFlag: shouldAutoDismissFlag = false, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading, accessLevel: accessLevel, ...props })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const legacyShareClient = (0, $5uXOq.useMemo)(()=>legacyShareClientConfig && new (0, $aYuZy.default)(legacyShareClientConfig), [
        legacyShareClientConfig
    ]);
    const getOriginTracingInstance = (0, $5uXOq.useCallback)(()=>{
        return new (0, $2gQ83.default)({
            product: 'jira'
        });
    }, []);
    const showFlags = (0, $5uXOq.useCallback)((flags)=>{
        if (showFlag) flags.forEach((flag)=>{
            showFlag({
                type: flag.appearance,
                title: flag.title.defaultMessage,
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                messageType: 'transactional'
            });
        });
    }, [
        showFlag,
        shouldAutoDismissFlag
    ]);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { update: updateProjectAccessLevel, error: projectAccessLevelError } = (0, $3Misg.useProjectAccessLevel)();
    const { add: addToUserRole, error: useRoleError } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    (0, $5uXOq.useEffect)(()=>{
        if (projectAccessLevelError) showFlag({
            type: 'error',
            title: formatMessage($379ea30a2af32bdf$var$messages.errorUpdateProjectAccessLevel),
            isAutoDismiss: shouldAutoDismissFlag,
            messageId: 'share-button.ui.share-view.show-flag.error.update-project-access-level',
            messageType: 'transactional'
        });
    }, [
        projectAccessLevelError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (useRoleError) showFlag({
            type: 'error',
            title: formatMessage($379ea30a2af32bdf$var$messages.errorAddingUsersToRole),
            isAutoDismiss: shouldAutoDismissFlag,
            messageId: 'share-button.ui.share-view.show-flag.error.adding-users-to-role.1',
            messageType: 'transactional'
        });
    }, [
        useRoleError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag
    ]);
    const handleOnSubmit = (0, $5uXOq.useCallback)((data)=>{
        if (isExtendedShareDialogEnabled) {
            if (data?.projectAccessLevel?.value && data?.projectAccessLevel?.value !== accessLevel) updateProjectAccessLevel({
                accessLevel: data?.projectAccessLevel.value
            }).then((response)=>{
                if (!response) return;
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'changeAccessButton', {
                    source: (0, $5GqLe.ANALYTICS_SOURCE),
                    projectType: projectContext?.projectType,
                    isTmp: true,
                    updatedItems: [
                        'projectAccess'
                    ],
                    accessLevel: data?.projectAccessLevel?.value
                });
                if (!data.users?.length) showFlag({
                    type: 'success',
                    title: formatMessage($379ea30a2af32bdf$var$messages.projectAccessLevelUpdated),
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: 'share-button.ui.share-view.show-flag.success.project-access-level-updated',
                    messageType: 'transactional'
                });
            });
            if (data.users?.length > 0 && data?.userRole?.value) {
                const { value: roleId, label: roleName } = data.userRole;
                const userIds = data.users.filter((user)=>user.type === 'user').map((user)=>user.id);
                const groupIds = data.users.filter((user)=>user.type === 'group').map((group)=>group.id);
                addToUserRole(roleId, {
                    users: userIds,
                    groups: groupIds
                }).then((response)=>{
                    if (!response) return;
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'roleOption', {
                        source: (0, $5GqLe.ANALYTICS_SOURCE),
                        roleId: roleId,
                        roleName: roleName,
                        numberOfExistingUsersAdded: userIds.length,
                        numberOfExistingGroupsAdded: groupIds.length
                    });
                });
            }
        }
        onSubmit && onSubmit(data);
    }, [
        isExtendedShareDialogEnabled,
        onSubmit,
        accessLevel,
        updateProjectAccessLevel,
        createAnalyticsEvent,
        projectContext?.projectType,
        showFlag,
        formatMessage,
        shouldAutoDismissFlag,
        addToUserRole
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
        shareClient: legacyShareClient,
        cloudId: cloudId,
        loadUserOptions: legacyShareClient && (0, $kwHgU.loadUsers),
        // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
        originTracingFactory: getOriginTracingInstance,
        shareAri: objectAri || (0, $kAdLR.createAri)(props.subProductId, cloudId),
        showFlags: showFlags,
        enableSmartUserPicker: !legacyShareClient,
        product: "jira",
        isBrowseUsersDisabled: isBrowseUsersEnabled === false,
        isSubmitShareDisabled: isOutgoingMailDisabled,
        triggerButtonAppearance: triggerButtonAppearance,
        onTriggerButtonClick: onTriggerButtonClick,
        integrationMode: integrationMode,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        onSubmit: handleOnSubmit,
        CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
        additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
            accessLevel: accessLevel,
            roles: userRoles,
            isLoading: !!userRolesLoading
        }),
        ...props
    });
};
var $379ea30a2af32bdf$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira-growth-share-button-refactor-fc'), $379ea30a2af32bdf$var$ShareButtonFC, (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($379ea30a2af32bdf$export$e980dfbc2840e8bc)));

});
parcelRegister("dsCiy", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $dd0122880035a80e$export$78b28896b43ae5d6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1SBaA = parcelRequire("1SBaA");

var $8QpSo = parcelRequire("8QpSo");

var $ousew = parcelRequire("ousew");

var $3joPi = parcelRequire("3joPi");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $9b5JR = parcelRequire("9b5JR");

var $inlXa = parcelRequire("inlXa");

var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $2sAb4 = parcelRequire("2sAb4");

var $7ZU6o = parcelRequire("7ZU6o");

var $7v5Ga = parcelRequire("7v5Ga");

var $4gTjW = parcelRequire("4gTjW");
const $dd0122880035a80e$var$COPY_LINK_EVENT = (0, $b2oBK.copyLinkButtonClicked)({
    start: 0
});
const $dd0122880035a80e$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $dd0122880035a80e$var$memoizedFormatCopyLink = (0, $8QpSo.default)((origin, link)=>origin.addToUrl(link));
function $dd0122880035a80e$var$getCurrentPageUrl() {
    return window.location.href;
}
class $dd0122880035a80e$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props), this._isMounted = false, this._urlShorteningRequestCounter = 0, this._lastUrlShorteningWasTooSlow = false, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $65uFp.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $65uFp.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $dd0122880035a80e$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $hQWyD.isValidFailedExperience)((0, $65uFp.renderShareDialogExp), errObj);
                }
            });
        }, this.handleSubmitShare = ({ users: users, comment: comment, ...rest })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            this.props.onSubmit?.({
                users: users,
                comment: comment,
                ...rest
            });
            if (isExtendedShareDialogEnabled && users.length === 0) return Promise.resolve();
            return this.shareClient.share(content, (0, $4gTjW.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        }, this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        }, this.decorateAnalytics = (payload)=>{
            if (payload.type === $dd0122880035a80e$var$COPY_LINK_EVENT.type && payload.action === $dd0122880035a80e$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $dd0122880035a80e$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        }, // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $8QpSo.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        }), // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $8QpSo.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        }), this.getUpToDateShortenedCopyLink = (0, $8QpSo.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $b2oBK.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $b2oBK.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $b2oBK.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))), this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $3joPi.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $inlXa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $9b5JR.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $dd0122880035a80e$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $dd0122880035a80e$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2sAb4.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZU6o.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7v5Ga.ShareDialogWithTrigger), {
                    onTriggerButtonClick: onTriggerButtonClick,
                    isAutoOpenDialog: isAutoOpenDialog,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    copyLink: this.getCopyLink(),
                    analyticsDecorator: this.decorateAnalytics,
                    dialogPlacement: dialogPlacement,
                    loadUserOptions: loadUserOptions,
                    onDialogOpen: this.handleDialogOpen,
                    onShareSubmit: this.handleSubmitShare,
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    shareContentType: shareContentType,
                    shareContentSubType: shareContentSubType,
                    shareContentId: shareContentId,
                    shareFormTitle: shareFormTitle,
                    shareFormHelperMessage: shareFormHelperMessage,
                    copyLinkOrigin: this.getCopyLinkOriginTracing(),
                    formShareOrigin: this.getFormShareOriginTracing(),
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    showFlags: showFlags,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    triggerButtonAppearance: triggerButtonAppearance,
                    triggerButtonIcon: triggerButtonIcon,
                    triggerButtonStyle: triggerButtonStyle,
                    triggerButtonTooltipPosition: triggerButtonTooltipPosition,
                    triggerButtonTooltipText: triggerButtonTooltipText,
                    bottomMessage: bottomMessage,
                    submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $idKBS.messages).inviteTriggerButtonText
                    }),
                    product: product,
                    productAttributes: productAttributes,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: customFooter,
                    onUserSelectionChange: onUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isCopyDisabled: isCopyDisabled,
                    isPublicLink: isPublicLink,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    shareAri: shareAri,
                    tabIndex: tabIndex,
                    copyTooltipText: copyTooltipText,
                    onDialogClose: onDialogClose,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })
            })
        });
    }
}
const $dd0122880035a80e$export$78b28896b43ae5d6 = (0, $cb25w.default)()($dd0122880035a80e$export$bc8c417f2da43f4);

});
parcelRegister("9b5JR", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $db8e8ad360042aaf$export$8fed7002650b52ef);
class $db8e8ad360042aaf$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("inlXa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $17bc358e1d85e6d0$export$ee05f3e1f0248b62);

var $dS9cn = parcelRequire("dS9cn");
const $17bc358e1d85e6d0$export$a7d7a4246bdd7a12 = 'share';
const $17bc358e1d85e6d0$export$1a440d9a41e6ce3e = 'share/configuration';
const $17bc358e1d85e6d0$export$7745139d0aa6183c = '/gateway/api';
class $17bc358e1d85e6d0$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $17bc358e1d85e6d0$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $17bc358e1d85e6d0$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$17bc358e1d85e6d0$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("idKBS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $990cec53807f67a0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $990cec53807f67a0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    extendedDialogCommentLabel: {
        id: 'fabric.elements.share.form.extended.dialog.comment.label',
        defaultMessage: 'Message',
        description: 'Label for the comment field in the extended share dialog.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    infoMessageDefaultJiraIssueTermRefresh: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh',
        defaultMessage: 'Recipients will see the name of the work item and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("b2oBK", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $5f90f772f4877396$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5f90f772f4877396$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $5f90f772f4877396$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $5f90f772f4877396$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $5f90f772f4877396$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $5f90f772f4877396$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $5f90f772f4877396$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $5f90f772f4877396$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $5f90f772f4877396$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $5f90f772f4877396$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $5f90f772f4877396$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $5f90f772f4877396$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $5f90f772f4877396$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $5f90f772f4877396$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $5f90f772f4877396$export$e2e6cacbe383cb80);

var $3smIt = parcelRequire("3smIt");
const $5f90f772f4877396$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $5f90f772f4877396$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $5f90f772f4877396$export$f7109619a5e9e0d6 = 'shareModal';
const $5f90f772f4877396$export$8944b0a832f27e18 = 'integrationShareDialog';
const $5f90f772f4877396$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$5f90f772f4877396$var$createScreenEvent($5f90f772f4877396$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $5f90f772f4877396$export$eab30ffadcd0ab75 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $5f90f772f4877396$export$f04d85d45801fef1 = (type = '')=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $5f90f772f4877396$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$584e8ee8b04ff145 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $5f90f772f4877396$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$b4731c87331a8174 = (start)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start)
    });
const $5f90f772f4877396$export$35781a2d50f9fba9 = ()=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$e78d65558f8d859a = (start, tooSlow)=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        tooSlow: tooSlow
    });
const $5f90f772f4877396$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin)
    });
const $5f90f772f4877396$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isUser));
    const externalUsers = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isExternalUser));
    const groups = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isGroup));
    const teams = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isTeam));
    const teamUserCounts = $5f90f772f4877396$var$extractMemberCountsFromTeams(data, (0, $3smIt.isTeam));
    const emails = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isEmail));
    return $5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $5f90f772f4877396$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $5f90f772f4877396$var$duration = (start)=>Date.now() - start;
const $5f90f772f4877396$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $5f90f772f4877396$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $5f90f772f4877396$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});

parcelRegister("hQWyD", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $4557ff6e37d018ec$export$883079293b9cad76);
const $4557ff6e37d018ec$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $4557ff6e37d018ec$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($4557ff6e37d018ec$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("65uFp", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $8388968bcc7a2bcd$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $8388968bcc7a2bcd$export$31627ee726f40567);

var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");
const $8388968bcc7a2bcd$export$99c0383421ae57eb = new (0, $boHLC.UFOExperience)('render-share-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $8388968bcc7a2bcd$export$31627ee726f40567 = new (0, $boHLC.UFOExperience)('share-submit-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});

parcelRegister("2sAb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d485dd997db54c76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $b2oBK = parcelRequire("b2oBK");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d485dd997db54c76$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $b2oBK.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $b2oBK.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
var $d485dd997db54c76$export$2e2bcd8739ae039 = (0, $cb25w.default)()($d485dd997db54c76$var$ErrorBoundary);

});

parcelRegister("7ZU6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3769956cd18ef333$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $55GMe = parcelRequire("55GMe");
const $3769956cd18ef333$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $55GMe.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US",
        children: children
    });
};
var $3769956cd18ef333$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3769956cd18ef333$var$MessagesIntlProvider);

});
parcelRegister("55GMe", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $8fc7d6e642efa1c9$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ 
var $aiyiV = parcelRequire("aiyiV");
var $c7HRD = parcelRequire("c7HRD");
var $gdvwP = parcelRequire("gdvwP");
var $1mT6n = parcelRequire("1mT6n");
var $axcS0 = parcelRequire("axcS0");
var $gM6wy = parcelRequire("gM6wy");
var $jCrgt = parcelRequire("jCrgt");
var $ddwcq = parcelRequire("ddwcq");
var $2Slqk = parcelRequire("2Slqk");
var $byDyk = parcelRequire("byDyk");
var $9y8hX = parcelRequire("9y8hX");
var $bMFAQ = parcelRequire("bMFAQ");
var $4JZF5 = parcelRequire("4JZF5");
var $dzumV = parcelRequire("dzumV");
var $fH3rr = parcelRequire("fH3rr");
var $16RW6 = parcelRequire("16RW6");
var $hrNSu = parcelRequire("hrNSu");
var $ioYTp = parcelRequire("ioYTp");
var $iQCSg = parcelRequire("iQCSg");
var $hkr2R = parcelRequire("hkr2R");
var $7dbDF = parcelRequire("7dbDF");
var $8zZLq = parcelRequire("8zZLq");
var $dGOFQ = parcelRequire("dGOFQ");
var $64yeQ = parcelRequire("64yeQ");
var $iTJhG = parcelRequire("iTJhG");
const $8fc7d6e642efa1c9$var$localesMessagesMap = {
    cs: $aiyiV.default,
    da: $c7HRD.default,
    de: $gdvwP.default,
    en: $1mT6n.default,
    en_GB: $axcS0.default,
    en_ZZ: $gM6wy.default,
    es: $jCrgt.default,
    et: $ddwcq.default,
    fi: $2Slqk.default,
    fr: $byDyk.default,
    hu: $9y8hX.default,
    is: $bMFAQ.default,
    it: $4JZF5.default,
    ja: $dzumV.default,
    ko: $fH3rr.default,
    nb: $16RW6.default,
    nl: $hrNSu.default,
    pl: $ioYTp.default,
    pt_BR: $iQCSg.default,
    'pt-BR': (0, $iQCSg.default),
    pt_PT: $hkr2R.default,
    'pt-PT': (0, $hkr2R.default),
    ro: $7dbDF.default,
    ru: $8zZLq.default,
    sk: $dGOFQ.default,
    sv: $64yeQ.default,
    zh: $iTJhG.default
};
const $8fc7d6e642efa1c9$export$d0a3169680473b6c = (locale)=>{
    let messages = $8fc7d6e642efa1c9$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $8fc7d6e642efa1c9$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $1mT6n.default);
    return messages;
};

});
parcelRegister("aiyiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03a8517fda6267e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b03a8517fda6267e$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("c7HRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40449a444ce6f8c1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $40449a444ce6f8c1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Modtagere f\xe5r vist navnet p\xe5 sagen og din besked",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("gdvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad081aeac1c38f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c9ad081aeac1c38f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("1mT6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae943d78330d54c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5ae943d78330d54c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("axcS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de2c962853eb1a7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $4de2c962853eb1a7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("gM6wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca0de856e819520$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8ca0de856e819520$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u2063\u2062Recipients will see the name of the work item and your message\u061C\u206B\u200D\u206B\u206D\u2060\u200D\u200C\u200C\x90\x8f\u206D\u2060\u200C\x8f\u206E\u206B\x9d\x9d\u206E\x8f\u2060\x90\u206F\u2060\x9d\u206D\u2060\u206F\x81\u206B\u206B\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("jCrgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d05b5c2cb0939$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $fa4d05b5c2cb0939$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Los destinatarios ver\xe1n el nombre de la actividad y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("ddwcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a813df19fa2152$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $f8a813df19fa2152$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("2Slqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8abdec291b18f8c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c8abdec291b18f8c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Vastaanottajat n\xe4kev\xe4t ty\xf6teht\xe4v\xe4n nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("byDyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bb494a2b2c3eb5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $f1bb494a2b2c3eb5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9y8hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ac209639193ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7b7ac209639193ae$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("bMFAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567821fb7188ce82$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $567821fb7188ce82$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("4JZF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9f8422b31a9859$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $ee9f8422b31a9859$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("dzumV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb77872613c037b3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $eb77872613c037b3$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u53D7\u4FE1\u8005\u306B\u4F5C\u696D\u9805\u76EE\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("fH3rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c880483be1fc144$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $6c880483be1fc144$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\uC218\uC2E0\uC790\uAC00 \uC5C5\uBB34 \uD56D\uBAA9 \uC774\uB984 \uBC0F \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("16RW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1be7e35603d5ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $fa1be7e35603d5ed$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottakerne vil se navnet p\xe5 arbeidsoppgaven og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("hrNSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf381178f2c2c61$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $9cf381178f2c2c61$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Ontvangers zien de naam van het werkitem en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("ioYTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d711b9dc04d41d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $f7d711b9dc04d41d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i\xa0Tw\xf3j komunikat.",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("iQCSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2341ebeae6083b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $b2341ebeae6083b8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Os destinat\xe1rios v\xe3o ver o nome do ticket e a mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("hkr2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $362c0a09cda3dcd7$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $362c0a09cda3dcd7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("7dbDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc047a07085c3fb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $6bc047a07085c3fb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});

parcelRegister("8zZLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d906580aa8a5e1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $7d906580aa8a5e1c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("dGOFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd5c80c863bfbe9$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $9cd5c80c863bfbe9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("64yeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $643613031271747a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $643613031271747a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottagare ser namnet p\xe5 arbetsuppgiften och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("iTJhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $65937a71b1200549$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $65937a71b1200549$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u5DE5\u4F5C\u9879\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});



parcelRegister("7v5Ga", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $2879aae105082725$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $1t1FK = parcelRequire("1t1FK");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
function $2879aae105082725$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2879aae105082725$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $2879aae105082725$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $2879aae105082725$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $2879aae105082725$export$e927f7ec13b9edc0 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $2879aae105082725$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
            content: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $KNlKW.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isMenuItemSelected: isMenuItemSelected,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8nZq.default), {
            zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.selectPortalRef
        }))));
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($2879aae105082725$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, createAnalyticsEvent: createAnalyticsEvent, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shared',
                    actionSubject: 'page',
                    source: (0, $b2oBK.ANALYTICS_SOURCE),
                    attributes: {
                        contentType: shareContentType,
                        subContentType: shareContentSubType,
                        shareData: data
                    }
                }
            }).fire();
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $2879aae105082725$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $idKBS.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $2879aae105082725$export$bc20a02e9bc30e54 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1t1FK.ShareDialogWithTriggerInternal), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)($2879aae105082725$export$e927f7ec13b9edc0, props);
const $2879aae105082725$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($2879aae105082725$export$bc20a02e9bc30e54));

});
const $dcbcc8fabc474606$export$9540ac9c843b8743 = 'object-shared';
const $dcbcc8fabc474606$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("KNlKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9c92562d0fe90f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");

var $iXiUJ = parcelRequire("iXiUJ");
function $7b9c92562d0fe90f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b9c92562d0fe90f$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $7b9c92562d0fe90f$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lhRB1")));
const $7b9c92562d0fe90f$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7b9c92562d0fe90f$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), null)));
};
var $7b9c92562d0fe90f$export$2e2bcd8739ae039 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iXiUJ.default), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        })
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LazyShareFormLazy, props));

});
parcelRegister("dZbU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $018ce6039808fd6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $idKBS = parcelRequire("idKBS");

var $6OqtU = parcelRequire("6OqtU");

var $10MNJ = parcelRequire("10MNJ");

var $i3XHT = parcelRequire("i3XHT");
const $018ce6039808fd6c$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, header: header = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ContentWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogContentWrapper) : (0, $i3XHT.InlineDialogContentWrapper);
    const FormWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogFormWrapper) : (0, $i3XHT.InlineDialogFormWrapper);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(ContentWrapper, {
        label: formatMessage((0, $idKBS.messages).formTitle),
        children: [
            (0, $VSDnB.fg)('platform_share_custom_header_prop') && header,
            /*#__PURE__*/ (0, $2OMIu.jsxs)(FormWrapper, {
                integrationMode: integrationMode,
                isMenuItemSelected: isMenuItemSelected,
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                children: [
                    shouldShowTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6OqtU.ShareHeader), {
                        title: shareFormTitle
                    }),
                    children
                ]
            }),
            footer
        ]
    });
};
var $018ce6039808fd6c$export$2e2bcd8739ae039 = $018ce6039808fd6c$var$ShareFormWrapper;

});
parcelRegister("6OqtU", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $b6372b3118718628$export$77192fbb468e5af8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $idKBS = parcelRequire("idKBS");
const $b6372b3118718628$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 'space.400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.400'
});
const $b6372b3118718628$var$headerWrapperExtraSpaceStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $b6372b3118718628$export$77192fbb468e5af8 = ({ isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, title: title })=>{
    const headingSize = isExtendedShareDialogEnabled ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $b6372b3118718628$var$headerWrapperStyles,
            isExtendedShareDialogEnabled && $b6372b3118718628$var$headerWrapperExtraSpaceStyles
        ],
        children: (0, $VSDnB.fg)('share-header-accessibility') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            as: "h2",
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        })
    });
};

});

parcelRegister("10MNJ", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $923a8f62c8def5db$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $923a8f62c8def5db$export$a05835e82fd98f96);
/* compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $923a8f62c8def5db$var$styles = {
    menuNotSelectedAndMenuIntegration: "_1bsbpk3t",
    tabsIntegration: "_1bsb1wug",
    default: "_1bsb1j89",
    extendedDefault: "_1bsb1op3",
    inlineDialogContentWrapper: "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
};
const $923a8f62c8def5db$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    if (!isMenuItemSelected && integrationMode === 'menu') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.menuNotSelectedAndMenuIntegration),
        children: children
    });
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.tabsIntegration),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(isExtendedShareDialogEnabled ? $923a8f62c8def5db$var$styles.extendedDefault : $923a8f62c8def5db$var$styles.default),
        children: children
    });
};
const $923a8f62c8def5db$export$a05835e82fd98f96 = ({ children: children, label: label })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $923a8f62c8def5db$var$styles.inlineDialogContentWrapper,
        children: children
    });

});

parcelRegister("i3XHT", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $cd74a614dabf2b1c$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $cd74a614dabf2b1c$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $MaS1v = parcelRequire("MaS1v");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $cd74a614dabf2b1c$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const formWidth = `${isExtendedShareDialogEnabled ? 452 : 352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $MaS1v.menuWrapperWidth;
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return 'auto';
    }
    return formWidth;
};
const $cd74a614dabf2b1c$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const styles = {
        width: $cd74a614dabf2b1c$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
        })
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $cd74a614dabf2b1c$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("MaS1v", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $604fc1c02fbeee92$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $604fc1c02fbeee92$export$1cd8104f92c0e299);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $604fc1c02fbeee92$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $604fc1c02fbeee92$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($604fc1c02fbeee92$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...labelId
        })
    });
const $604fc1c02fbeee92$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $604fc1c02fbeee92$var$iconContainerStyles,
        children: icon
    });
const $604fc1c02fbeee92$export$1cd8104f92c0e299 = '102px';

});



parcelRegister("iXiUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d94c1e278a7cbd$export$2e2bcd8739ae039);
/* lazyNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");
const $61d94c1e278a7cbd$var$styles = {
    spinnerWrapperStyles: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _ae4v1h6o"
};

const $61d94c1e278a7cbd$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pN3k")));
const $61d94c1e278a7cbd$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($61d94c1e278a7cbd$var$styles.spinnerWrapperStyles),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
        })
    });
};
var $61d94c1e278a7cbd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LazyShareFormLazy, {
            ...props
        })
    });

});
parcelRegister("2pN3k", function(module, exports) {

let $1c23f763c8bd0f91$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c23f763c8bd0f91$var$load("ffQaD"),
    $1c23f763c8bd0f91$var$load("kvRbA"),
    $1c23f763c8bd0f91$var$load("c2PGS")
]).then(()=>parcelRequire('6GxX7'));

});


parcelRegister("lhRB1", function(module, exports) {

let $f7f4c298928f54d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f7f4c298928f54d1$var$load("ffQaD"),
    $f7f4c298928f54d1$var$load("kvRbA"),
    $f7f4c298928f54d1$var$load("3AP4i")
]).then(()=>parcelRequire('1haaP'));

});


parcelRegister("bked4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c623df2911700361$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
const $c623df2911700361$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        id: "share-trigger-btn",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props,
        children: text
    });
});
$c623df2911700361$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $c623df2911700361$export$2e2bcd8739ae039 = $c623df2911700361$export$e980dfbc2840e8bc;

});

parcelRegister("1t1FK", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTriggerInternal", () => $38a31715b9b420dd$export$bc20a02e9bc30e54);
/* ShareDialogWithTriggerNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $3JT92 = parcelRequire("3JT92");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $MHKc7 = parcelRequire("MHKc7");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
const $38a31715b9b420dd$var$styles = {
    shareButtonWrapperStyles: "_12ji1r31 _1qu2glyw _12y31o36 _1e0c116y",
    outlineNone: "_12ji1r31 _1qu2glyw _12y31o36"
};
const $38a31715b9b420dd$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $38a31715b9b420dd$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $38a31715b9b420dd$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($38a31715b9b420dd$var$styles.shareButtonWrapperStyles, typeof tabIndex !== 'undefined' && tabIndex >= 0 && $38a31715b9b420dd$var$styles.outlineNone),
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: this.containerRef,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KNlKW.default), {
                                Content: selectedIntegration && selectedIntegration.Content,
                                selectedIntegration: selectedIntegration,
                                copyLink: copyLink,
                                showIntegrationForm: showIntegrationForm,
                                bottomMessage: bottomMessage,
                                customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                                customFooter: footer,
                                loadOptions: loadUserOptions,
                                isSharing: isSharing,
                                shareFormTitle: shareFormTitle,
                                showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                                shareFormHelperMessage: shareFormHelperMessage,
                                shareError: shareError,
                                defaultValue: defaultValue,
                                config: config,
                                isFetchingConfig: isFetchingConfig,
                                setIsLoading: this.setIsLoading,
                                submitButtonLabel: submitButtonLabel,
                                product: product,
                                productAttributes: productAttributes,
                                enableSmartUserPicker: enableSmartUserPicker,
                                loggedInAccountId: loggedInAccountId,
                                cloudId: cloudId,
                                orgId: orgId,
                                onUserSelectionChange: this.handleOnUserSelectionChange,
                                shareFieldsFooter: shareFieldsFooter,
                                isPublicLink: isPublicLink,
                                copyTooltipText: copyTooltipText,
                                integrationMode: integrationMode,
                                shareIntegrations: shareIntegrations,
                                additionalTabs: additionalTabs,
                                builtInTabContentWidth: builtInTabContentWidth,
                                isMenuItemSelected: isMenuItemSelected,
                                isSubmitShareDisabled: isSubmitShareDisabled,
                                // actions
                                onLinkCopy: this.handleCopyLink,
                                onSubmit: this.handleShareSubmit,
                                onDismiss: this.handleFormDismiss,
                                onDialogClose: this.handleCloseDialog,
                                onTabChange: this.onTabChange,
                                onMenuItemChange: this.onMenuItemChange,
                                //ref
                                selectPortalRef: this.selectPortalRef,
                                isBrowseUsersDisabled: isBrowseUsersDisabled,
                                userPickerOptions: userPickerOptions,
                                additionalUserFields: additionalUserFields,
                                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                                CustomSubmitButton: CustomSubmitButton
                            })
                        }),
                    isOpen: isDialogOpen,
                    onClose: this.handleCloseDialog,
                    placement: dialogPlacement,
                    trigger: this.renderShareTriggerButton,
                    zIndex: dialogZIndex,
                    label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
                    role: "dialog",
                    // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
                    offset: this.calculatePopupOffset({
                        isMenuItemSelected: isMenuItemSelected,
                        dialogPlacement: dialogPlacement
                    }),
                    shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                    zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ref: this.selectPortalRef
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($38a31715b9b420dd$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $38a31715b9b420dd$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $idKBS.messages).shareTriggerButtonText
                }) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true,
                children: button
            });
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $38a31715b9b420dd$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($38a31715b9b420dd$export$bc20a02e9bc30e54));

});
parcelRegister("cnQaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $595b694e7cdc0462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $42CjB = parcelRequire("42CjB");
var $7E6BG = parcelRequire("7E6BG");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $kEVMo = parcelRequire("kEVMo");

var $VSDnB = parcelRequire("VSDnB");


var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $4kfPc = parcelRequire("4kfPc");
// span
const $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $595b694e7cdc0462$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $idKBS.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $595b694e7cdc0462$var$IntegrationButtonWrapper = ({ children: children })=>// The css has no discernible effect on the button, so it is not included in the migration
    (0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles
    }, children);
const $595b694e7cdc0462$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $5uXOq.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $b2oBK.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-people-and-')
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$IntegrationButtonWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4kfPc.default), {
            textColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $595b694e7cdc0462$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$595b694e7cdc0462$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $595b694e7cdc0462$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7E6BG.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("7E6BG", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $2f706a5180e21ed2$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $icwyz = parcelRequire("icwyz");

var $jvAlz = parcelRequire("jvAlz");
const $2f706a5180e21ed2$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
const $2f706a5180e21ed2$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $2f706a5180e21ed2$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $2f706a5180e21ed2$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $2f706a5180e21ed2$var$dividerStyles.baseDivider,
            isDefaultDivider && $2f706a5180e21ed2$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $2f706a5180e21ed2$var$dividerHeightStyles[spacing],
            isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerAppearanceStyles[appearance],
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
const $2f706a5180e21ed2$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
const $2f706a5180e21ed2$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$buttonStyles.defaultAppearanceContainer,
            $2f706a5180e21ed2$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $2f706a5180e21ed2$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $jvAlz.getActions)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $2f706a5180e21ed2$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("jvAlz", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $425b7dc91147601e$export$fe3955935f564b31);

var $5uXOq = parcelRequire("5uXOq");

var $6cAn5 = parcelRequire("6cAn5");
const $425b7dc91147601e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $5uXOq.Children).toArray(children);
    typeof $6cAn5;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("4kfPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe469c80a3193c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $VSDnB = parcelRequire("VSDnB");


var $dsMCa = parcelRequire("dsMCa");
function $0fe469c80a3193c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $0fe469c80a3193c7$var$IntegrationButtonInner = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), restProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text))));
};
const $0fe469c80a3193c7$var$IntegrationButton = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsMCa.default), {
        text: props.text,
        onClick: props.onClick,
        IntegrationIcon: props.IntegrationIcon
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)($0fe469c80a3193c7$var$IntegrationButtonInner, props);
$0fe469c80a3193c7$var$IntegrationButton.displayName = 'IntegrationButton';
var $0fe469c80a3193c7$export$2e2bcd8739ae039 = $0fe469c80a3193c7$var$IntegrationButton;

});
parcelRegister("dsMCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb233873498bd3e7$export$2e2bcd8739ae039);
/* IntegrationButtonNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");
const $eb233873498bd3e7$var$styles = {
    integrationButtonCopyWrapperStyle: "_1e0c1txw _1bah1e5h _syaz10s3",
    integrationIconWrapperStyle: "_19pkv77o _2hwxu2gc _otyrze3t _18u0ze3t"
};
const $eb233873498bd3e7$var$IntegrationButton = (props)=>{
    const { text: text, IntegrationIcon: IntegrationIcon } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            as: "span",
            xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationButtonCopyWrapperStyle),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationIconWrapperStyle),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationIcon, {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    color: "color.text",
                    children: text
                })
            ]
        })
    });
};
$eb233873498bd3e7$var$IntegrationButton.displayName = 'IntegrationButton';
var $eb233873498bd3e7$export$2e2bcd8739ae039 = $eb233873498bd3e7$var$IntegrationButton;

});



parcelRegister("4gTjW", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $e2b0620d8e0c6274$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $e2b0620d8e0c6274$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $e2b0620d8e0c6274$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $e2b0620d8e0c6274$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $e2b0620d8e0c6274$export$6900a66855146901);

var $k5uoT = parcelRequire("k5uoT");
const $e2b0620d8e0c6274$export$ff1a1e5addedc4cc = 10;
const $e2b0620d8e0c6274$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $k5uoT.layers).modal() + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
    return dialogZIndex + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
};
const $e2b0620d8e0c6274$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $e2b0620d8e0c6274$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $e2b0620d8e0c6274$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $e2b0620d8e0c6274$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});




parcelRegister("kAdLR", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57);
const $63eb1b2c0e2cfff4$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$63eb1b2c0e2cfff4$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("aYuZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea05149486244917$export$2e2bcd8739ae039);

var $2gQ83 = parcelRequire("2gQ83");

var $inlXa = parcelRequire("inlXa");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
class $ea05149486244917$export$2e2bcd8739ae039 extends (0, $inlXa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $2gQ83.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $eusud.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("kwHgU", function(module, exports) {

$parcel$export(module.exports, "loadUsers", () => $2adfecc7864678ee$export$2c3a8e05396a78be);
// @ts-expect-error - TS2305 - Module '"@atlaskit/share"' has no exported member 'OptionData'.

var $7f4tk = parcelRequire("7f4tk");
const $2adfecc7864678ee$var$USER_PICKER_LIMIT = 20;
const $2adfecc7864678ee$export$2c3a8e05396a78be = async (searchText = '')=>{
    const searchTextEncoded = encodeURIComponent(searchText);
    const url = `/rest/api/3/groupuserpicker?maxResults=${$2adfecc7864678ee$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
    const groupsAndUsers = await (0, $7f4tk.default)(url);
    return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>({
            type: 'user',
            id: user.accountId,
            name: user.displayName,
            avatarUrl: user.avatarUrl
        }));
};

});

parcelRegister("8HBuB", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $bbdf16990b710a51$export$eb3485a690c2f0b8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $bbdf16990b710a51$var$styles = {
    userRoleSelect: "_16jlkb7n _i0dlidpf _1ul91obz _ca0q1ejb"
};
const $bbdf16990b710a51$var$messages = (0, $7VHMR.defineMessages)({
    userRoleLabel: {
        "id": "share-button.user-role.user-role-label.non-final",
        "defaultMessage": "User role"
    }
});
const $bbdf16990b710a51$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "medium"
    }, data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, data.description)));
};
const $bbdf16990b710a51$var$getDefaultUserRole = (userRoleOptions)=>userRoleOptions.find((role)=>role.default) || userRoleOptions[0];
const $bbdf16990b710a51$export$eb3485a690c2f0b8 = ({ accessLevel: accessLevel, roles: roles, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        values: true
    });
    const shouldShowUserRole = (0, $5uXOq.useMemo)(()=>{
        const projectAccessLevel = formData?.values.projectAccessLevel?.value || accessLevel;
        return roles.length > 0 && projectAccessLevel && projectAccessLevel !== 'OPEN';
    }, [
        accessLevel,
        formData?.values.projectAccessLevel?.value,
        roles.length
    ]);
    const userRoleOptions = (0, $5uXOq.useMemo)(()=>roles.map((role)=>({
                label: role.name,
                value: role.id,
                description: role.description,
                default: role.default || false
            })), [
        roles
    ]);
    const [currentUserRole, setCurrentUserRole] = (0, $5uXOq.useState)($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    (0, $5uXOq.useEffect)(()=>{
        if (!currentUserRole && userRoleOptions.length > 0) // If currentUserRole is not set, we set it to the default role from options.
        // This happens when the component is rendered before userRoleOptions are fetched.
        setCurrentUserRole($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    }, [
        currentUserRole,
        userRoleOptions
    ]);
    if (!shouldShowUserRole) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "userRole",
        defaultValue: currentUserRole
    }, ({ fieldProps: { onChange: onChange, value: value, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $bbdf16990b710a51$var$styles.userRoleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            isLoading: isLoading,
            options: userRoleOptions,
            value: currentUserRole,
            onChange: (userRoleOption)=>{
                if (!userRoleOption) return;
                onChange(userRoleOption);
                setCurrentUserRole(userRoleOption);
            },
            label: formatMessage($bbdf16990b710a51$var$messages.userRoleLabel),
            components: {
                Option: $bbdf16990b710a51$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                control: (base)=>({
                        ...base,
                        minHeight: '44px',
                        height: '100%',
                        width: '100%'
                    }),
                menu: (base)=>({
                        ...base,
                        width: 'fit-content',
                        position: 'absolute',
                        right: 0
                    }),
                option: (base)=>({
                        ...base,
                        width: '320px'
                    })
            },
            menuPortalTarget: globalThis.document.body
        })));
};

});

parcelRegister("b4Qrh", function(module, exports) {

$parcel$export(module.exports, "CustomShareSubmitButton", () => $0164a6f1ecd00b94$export$acf0d09f1a6f345b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $dD7Zc = parcelRequire("dD7Zc");

var $eCeGD = parcelRequire("eCeGD");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $0164a6f1ecd00b94$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formSharePublic: {
        "id": "share-button.custom-share-submit.form-share-public",
        "defaultMessage": "Share public link"
    },
    formSendPublic: {
        "id": "share-button.custom-share-submit.form-send-public",
        "defaultMessage": "Send public link"
    },
    formSave: {
        "id": "share-button.custom-share-submit.form-save",
        "defaultMessage": "Save"
    },
    formShare: {
        "id": "share-button.custom-share-submit.form-share",
        "defaultMessage": "Share"
    },
    formRetry: {
        "id": "share-button.custom-share-submit.form-retry",
        "defaultMessage": "Retry"
    },
    shareFailureMessage: {
        "id": "share-button.custom-share-submit.share-failure-message",
        "defaultMessage": "Unable to share"
    },
    shareFailureIconLabel: {
        "id": "share-button.custom-share-submit.share-failure-icon-label",
        "defaultMessage": "Error icon"
    }
});
const $0164a6f1ecd00b94$var$styles = {
    submitButtonWrapper: "_1e0c1txw _18u01wug",
    centerAlignedIconWrapper: "_1rjcze3t _18zrutpp _1e0c1txw _1wpz1h6o"
};
const $0164a6f1ecd00b94$export$acf0d09f1a6f345b = ({ isPublicLink: isPublicLink = false, shareError: shareError, isSharing: isSharing = false, isDisabled: isDisabled = false, isSubmitShareDisabled: isSubmitShareDisabled = false, integrationMode: integrationMode, submitButtonLabel: submitButtonLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        dirtyFields: true,
        values: true
    });
    const [shouldShowButton, setShouldShowButton] = (0, $5uXOq.useState)(false); // We use `useLayoutEffect` to ensure we show/hide the button before the button text is updated to avoid content flickering
    (0, $5uXOq.useLayoutEffect)(()=>{
        // If the form has not provided any state, we don't do anything
        if (!formData) return;
         /**
       * We hide the submit button based on 2 fields:
       * - User picker field
       * - Project access level field (provided by consumers)
       *
       * If both are unchanged, we hide the submit button.
       */ 
        const userPickerValues = formData?.values.users;
        if (userPickerValues?.length > 0 || formData?.dirtyFields?.projectAccessLevel) setShouldShowButton(true);
        else setShouldShowButton(false);
    }, [
        formData
    ]);
    const isRetryableError = !!shareError?.retryable;
    const isNonRetryableError = shareError && !shareError.retryable;
    const shouldShowWarning = isRetryableError && !isSharing;
    const buttonAppearance = !shouldShowWarning ? 'primary' : 'warning';
    const tabMode = integrationMode === 'tabs';
    const formPublicLabel = tabMode ? $0164a6f1ecd00b94$export$defe85febe8b728c.formSharePublic : $0164a6f1ecd00b94$export$defe85febe8b728c.formSendPublic;
    const formSendLabel = (0, $5uXOq.useMemo)(()=>{
        /**
     * We change the submit button label based on 2 fields:
     * - User picker field
     * - Project access level field (provided by consumers)
     *
     * If the project access level field is changed but the user picker field is pristine, we show a `Save` button.
     * If the user picker field is changed, we show a `Share` button.
     */ const userPickerValues = formData?.values?.users;
        if (userPickerValues && userPickerValues.length > 0) return $0164a6f1ecd00b94$export$defe85febe8b728c.formShare;
        return $0164a6f1ecd00b94$export$defe85febe8b728c.formSave;
    }, [
        formData?.values.users
    ]);
    const sendLabel = isPublicLink ? formPublicLabel : formSendLabel;
    const buttonLabel = isRetryableError ? $0164a6f1ecd00b94$export$defe85febe8b728c.formRetry : sendLabel;
    const buttonDisabled = isDisabled || isNonRetryableError || isSubmitShareDisabled;
    const ButtonLabelWrapper = buttonAppearance === 'warning' ? 'strong' : (0, $5uXOq.Fragment);
    if (!shouldShowButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.submitButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.centerAlignedIconWrapper
    }, shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: buttonAppearance,
        type: "submit",
        isLoading: isSharing,
        isDisabled: buttonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonLabelWrapper, null, submitButtonLabel || formatMessage(buttonLabel))));
};

});


parcelRegister("ckpyh", function(module, exports) {

$parcel$export(module.exports, "ProjectAccessLevelSelectContainer", () => $324557b9f7ca6aa3$export$be750a3a70b4f271);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $MHKc7 = parcelRequire("MHKc7");
var $joKkQ = parcelRequire("joKkQ");
var $dS3PR = parcelRequire("dS3PR");

var $fptva = parcelRequire("fptva");

var $bwyQI = parcelRequire("bwyQI");

var $jHgVl = parcelRequire("jHgVl");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $1wbtX = parcelRequire("1wbtX");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $324557b9f7ca6aa3$var$gridStyles = {
    root: "_yv0e5bpd _1lmcpt3h"
};
const $324557b9f7ca6aa3$var$FIELD_NAME = 'projectAccessLevel';
const $324557b9f7ca6aa3$var$styles = {
    iconContainer: "_nd5l2ec4 _18zru2gc _1wpz1h6o _18u0x0bf",
    dropdownContainer: "_nd5l1ba5",
    descriptionContainer: "_nd5ltgt2 _1bsb1ns9 _18u0u2gc",
    optionDescriptionContainer: "_nd5ltgt2 _1bsb1ns9",
    field: "_1i53muej _15a5nqa1 _uwhke4h9 _otyrutpp _18u010v4 _2hwx10v4 _19bv1ejb _u5f31ejb",
    skeleton: "_otyrutpp"
}; // `css` is used to customise the styles of the Select components, `cssMap` / `xcss` don't work here
const $324557b9f7ca6aa3$var$controlStyles = null;
const $324557b9f7ca6aa3$var$valueContainerStyles = null;
const $324557b9f7ca6aa3$var$messages = (0, $7VHMR.defineMessages)({
    projectAccessLevelLabel: {
        "id": "share-dialog.fields.ProjectAccessLevelField.project-access-level-label.non-final",
        "defaultMessage": "Project access"
    }
});
const $324557b9f7ca6aa3$var$SelectControl = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
        ...props,
        appearance: "subtle",
        isCompact: true,
        className: (0, $bwpsq.default)([
            "_1bsb1ns9"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectValueContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, {
        ...props,
        className: (0, $bwpsq.default)([
            "_k48pmoej"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        xcss: $324557b9f7ca6aa3$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.iconContainer
    }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(data.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "bold"
    }, data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.optionDescriptionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtle",
        size: "small"
    }, data.description))));
};
const $324557b9f7ca6aa3$export$16b26cd5e98d9100 = (icon)=>{
    const localProps = {
        label: '',
        color: "var(--ds-icon-accent-gray, #758195)",
        LEGACY_size: 'medium',
        spacing: 'spacious'
    };
    switch(icon){
        case 'private':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), localProps);
        case 'limited':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), localProps);
        case 'open':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHgVl))), localProps);
    }
};
const $324557b9f7ca6aa3$var$transformToSelectOption = (level)=>({
        label: level.displayName,
        value: level.value,
        iconName: level.iconName,
        description: level.description
    });
const $324557b9f7ca6aa3$export$be750a3a70b4f271 = ({ isLoading: isLoading, currentAccessLevel: currentAccessLevel, accessLevels: accessLevels, getProjectAccessLevels: getProjectAccessLevels })=>{
    (0, $5uXOq.useEffect)(()=>{
        getProjectAccessLevels(); // only used to fetch the project access levels when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!accessLevels && isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "20px"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($324557b9f7ca6aa3$var$ProjectAccessLevelSelect, {
        currentAccessLevel: currentAccessLevel,
        accessLevels: accessLevels,
        getProjectAccessLevels: getProjectAccessLevels
    });
};
const $324557b9f7ca6aa3$var$ProjectAccessLevelSelect = ({ currentAccessLevel: currentAccessLevel, accessLevels: accessLevels })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectContainerRef = (0, $5uXOq.useRef)(null);
    const selectOptions = (0, $5uXOq.useMemo)(()=>accessLevels?.map((level)=>$324557b9f7ca6aa3$var$transformToSelectOption(level)), [
        accessLevels
    ]);
    const defaultValue = (0, $5uXOq.useMemo)(()=>selectOptions?.find((option)=>option.value === currentAccessLevel?.value), [
        currentAccessLevel,
        selectOptions
    ]);
    const [currentValue, setCurrentValue] = (0, $5uXOq.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: $324557b9f7ca6aa3$var$FIELD_NAME,
        label: formatMessage($324557b9f7ca6aa3$var$messages.projectAccessLevelLabel),
        defaultValue: defaultValue
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
            xcss: $324557b9f7ca6aa3$var$gridStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.iconContainer,
            testId: "share-button.ui.project-access-level.box"
        }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(currentValue?.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer,
            ref: selectContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            value: currentValue,
            options: selectOptions,
            onChange: (value)=>{
                if (!value) return;
                setCurrentValue(value);
                onChange(value);
            },
            isSearchable: false,
            menuPortalTarget: globalThis.document.body,
            components: {
                Control: $324557b9f7ca6aa3$var$SelectControl,
                ValueContainer: $324557b9f7ca6aa3$var$SelectValueContainer,
                Option: $324557b9f7ca6aa3$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999,
                        width: selectContainerRef.current?.offsetWidth
                    })
            },
            menuPosition: "fixed",
            spacing: "compact"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.descriptionContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            color: "color.text.subtle",
            size: "small"
        }, currentValue?.description)))));
};

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});

parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});



parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("1qTOc"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1qTOc", function(module, exports) {

let $10b38293cb9c1f72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b38293cb9c1f72$var$load("lMH7t").then(()=>parcelRequire('8kufr'));

});



parcelRegister("lwYh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff1e0b1d39c1a6b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff1e0b1d39c1a6b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTitle: {
        "id": "software-report-header-common.share-button.share-title",
        "defaultMessage": "Report"
    },
    shareFormTitle: {
        "id": "software-report-header-common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "software-report-header-common.share-button.share-tooltip-text",
        "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
    },
    shareHelperMessage: {
        "id": "software-report-header-common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("1yYqj", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $7681f5fa49600865$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $fPB66 = parcelRequire("fPB66");

var $3Uttp = parcelRequire("3Uttp");

var $auW2i = parcelRequire("auW2i");
const $7681f5fa49600865$var$FEEDBACK_COLLECTOR_LOCATION = 'reports.deployment-frequency';
const $7681f5fa49600865$export$116fedbe5e2e2bd8 = ()=>{
    const { data: deploymentProviders, error: errorDeploymentProviders } = (0, $auW2i.useDeploymentProviders)();
    const projectAttributes = (0, $3Uttp.useProjectAnalyticsAttributes)();
    if (projectAttributes === null) return null;
    if (errorDeploymentProviders) throw new Error(`Getting deployment providers failed when using useDeploymentProviders while attempting to display Deployment Frequency Report feedback button. Details: ${errorDeploymentProviders.message}`);
    const additionalFeedbackEntries = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $7681f5fa49600865$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: projectAttributes.isSimplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: projectAttributes.isProjectAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).DEPLOYMENT_PROVIDERS,
            value: deploymentProviders ? (0, $fPB66.hideUGCProviderName)(deploymentProviders).map((deploymentProvider)=>deploymentProvider.name).join(', ') : ''
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};

});

parcelRegister("kk2bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $224cbb6e7085777e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $224cbb6e7085777e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-deployment-frequency-report.header.title",
        "defaultMessage": "Deployment frequency"
    },
    description: {
        "id": "software-deployment-frequency-report.header.description",
        "defaultMessage": "Understand your project\u2019s deployment frequency to see how often you are shipping value to your customers. Using data from your deployment provider, correlate your batch size to how often your team deploys."
    },
    learnMore: {
        "id": "software-deployment-frequency-report.header.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("ufiFS", function(module, exports) {

$parcel$export(module.exports, "IssuesPerDeploymentChart", () => $fba6654212593696$export$b2095980f919734e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $gilhC = parcelRequire("gilhC");

var $l8ekP = parcelRequire("l8ekP");

var $3Ws3s = parcelRequire("3Ws3s");

var $claG0 = parcelRequire("claG0");

var $cwqx0 = parcelRequire("cwqx0");

var $7fqGi = parcelRequire("7fqGi");

var $JMEgp = parcelRequire("JMEgp");

var $e0ycG = parcelRequire("e0ycG");

var $baXQH = parcelRequire("baXQH");
const $fba6654212593696$var$Title = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartTitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $e0ycG.default).chartTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $e0ycG.default).titleHelpTooltipIssueTermRefresh) : formatMessage((0, $e0ycG.default).titleHelpTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$QuestionIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        LEGACY_size: "small",
        label: ""
    }))));
};
const $fba6654212593696$export$b2095980f919734e = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3Ws3s.useReportCoreData)();
    const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const onChartClicked = (0, $5uXOq.useCallback)(({ data: eventData })=>{
        setSelectedWeekStart(eventData.customInfo.startDateInclusive);
    }, [
        setSelectedWeekStart
    ]);
    const events = (0, $5uXOq.useMemo)(()=>({
            click: onChartClicked
        }), [
        onChartClicked
    ]); // @ts-expect-error - TS2345 - Argument of type '(newWeekStartDate: Date) => void | Promise<void>' is not assignable to parameter of type '(newWeekStartDate: Date) => Action<State>'.
    (0, $l8ekP.useSmartWeekSelect)(data, selectedWeekStart, setSelectedWeekStart);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JMEgp.LoadingSkeleton), null);
    if (error && data == null) // When error happens, retry button will be displayed by the bar chart together as two charts use the same service
    return null;
    if (data == null || selectedWeekStart === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JMEgp.LoadingSkeleton), null);
    error;
    if (data.hasDeploymentProvider === false) // when deployment provider is missing, the installation guide will be displayed by the bar chart.
    return null;
    const prodDataState = (0, $claG0.getProdDataState)(data);
    const dataPoints = (0, $7fqGi.convertReportCoreToChartDataPoints)(data, selectedWeekStart);
    const selectedWeekData = (0, $l8ekP.getSelectedWeekData)(data.weeksData, selectedWeekStart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartContainer, {
        "data-test-id": "software-deployment-frequency-report.ui.issues-per-deployment-chart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$ChartItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwqx0.default), {
        dataPoints: dataPoints,
        medianIssues: prodDataState === 'SUFFICIENT_FOR_TREND' ? data.medianIssuesPerDeployment : null,
        onEvents: events
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fba6654212593696$var$SelectionDetailItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $baXQH.SelectionDetail), {
        medianIssuesPerDeployment: selectedWeekData.medianIssuesPerDeployment.prod,
        wholePeriodMedian: data.medianIssuesPerDeployment,
        prodDataState: prodDataState
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba6654212593696$var$ChartTitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _19pkidpf _2hwxidpf _otyrpxbi _18u0idpf _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba6654212593696$var$QuestionIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _lswu5w2r _syazwdcn _80omtlke _ca0qv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba6654212593696$var$ChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i68cl _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba6654212593696$var$ChartItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbqrhd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba6654212593696$var$SelectionDetailItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb194s _1ul9194s _1e0c1txw _2lx21bp4 _1bah1h6o _19bv1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cwqx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f5195bd43b375a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");

var $apUNl = parcelRequire("apUNl");

var $gJBT6 = parcelRequire("gJBT6");

var $e4v2N = parcelRequire("e4v2N");

var $lXVui = parcelRequire("lXVui");

var $bkcQi = parcelRequire("bkcQi");
var $47isN = parcelRequire("47isN");

var $6OGL8 = parcelRequire("6OGL8");
var $48mDj = parcelRequire("48mDj");
var $hnoNV = parcelRequire("hnoNV");
var $gLj36 = parcelRequire("gLj36");

var $ixV1I = parcelRequire("ixV1I");

var $lWgYs = parcelRequire("lWgYs");

var $dWt6p = parcelRequire("dWt6p");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");

var $dUmnn = parcelRequire("dUmnn");

var $7u8Z9 = parcelRequire("7u8Z9");

var $3O9mo = parcelRequire("3O9mo");

var $ghL9R = parcelRequire("ghL9R");

var $4ghCC = parcelRequire("4ghCC");
$ixV1I.use([
    (0, $47isN.install),
    (0, $bkcQi.install),
    (0, $hnoNV.install),
    (0, $48mDj.install),
    (0, $gLj36.install),
    (0, $6OGL8.install),
    (0, $lWgYs.install)
]);
const $44f5195bd43b375a$var$Chart = ({ dataPoints: dataPoints, medianIssues: medianIssues, onEvents: onEvents })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const tooltipFormatter = (0, $4ghCC.useTooltipFormatter)();
    const prefersReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const selectedIndex = dataPoints.findIndex((dataPoint)=>dataPoint.customInfo.isSelectedData);
    const lastCompleteWeekIndexWithData = (0, (/*@__PURE__*/$parcel$interopDefault($apUNl)))(dataPoints, (dataPoint)=>dataPoint.value !== null, dataPoints.length - 2);
    const selectedPoint = selectedIndex === -1 ? null : dataPoints[selectedIndex];
    const axisCommonStyle = {
        nameGap: (0, $gwIPs.gridSize) * 4,
        nameLocation: 'middle',
        nameTextStyle: {
            color: (0, $829f609a65d26a98$exports).N400,
            // This cannot be replaced with a token as ECharts requires a numeric pixel value.
            // Background: https://atlassian.slack.com/archives/C071DCS8MDL/p1733289846954599
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 12
        }
    };
    const TOOLTIP_ANIMATION = null;
    const TOOLTIP_APPEAR_TOP = {
        backgroundColor: (0, $829f609a65d26a98$exports).N900,
        borderWidth: 0,
        transitionDuration: 0,
        extraCssText: `animation: ${TOOLTIP_ANIMATION} 0.15s ease-out`,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((pos, params, dom, rect, size)=>({
                top: rect.y - size.contentSize[1] - (0, $gwIPs.gridSize),
                left: rect.x + 10 - size.contentSize[0] / 2
            }), (pos, params)=>// memoize based on the index
            // otherwise we see calculation on mouse move and the tooltip jitters
            `${params.componentSubType}-${params.name}-${params.dataIndex}`)
    }; // RLSS-2812 Support echarts with darkmode
    const chartOptions = {
        animation: !prefersReducedMotion,
        tooltip: {
            ...TOOLTIP_APPEAR_TOP,
            formatter: tooltipFormatter
        },
        grid: {
            left: (0, $dUmnn.CHART_SPACE_LEFT),
            right: (0, $dUmnn.CHART_SPACE_RIGHT),
            top: (0, $gwIPs.gridSize) * 2,
            bottom: (0, $gwIPs.gridSize) * 3
        },
        xAxis: {
            data: dataPoints.map((data)=>{
                const { startDateInclusive: startDateInclusive } = data.customInfo;
                return formatDate(startDateInclusive, {
                    month: 'short',
                    day: 'numeric'
                });
            }),
            axisLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N40,
                    width: 1
                }
            },
            axisTick: {
                alignWithLabel: true
            },
            ...axisCommonStyle
        },
        yAxis: {
            name: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $ghL9R.default).yAxisLabelIssueTermRefresh) : formatMessage((0, $ghL9R.default).yAxisLabel),
            ...axisCommonStyle,
            axisLine: {
                show: false
            },
            splitNumber: 2,
            axisTick: false,
            splitLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N30
                }
            }
        },
        textStyle: {
            color: (0, $829f609a65d26a98$exports).N400
        },
        series: [
            {
                type: 'line',
                connectNulls: true,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($e4v2N)))(dataPoints, dataPoints.length - 1),
                color: (0, $829f609a65d26a98$exports).B100,
                lineStyle: {
                    width: 1
                },
                symbol: `image://${(0, (/*@__PURE__*/$parcel$interopDefault($3O9mo)))}`,
                symbolSize: 9,
                ...selectedPoint && selectedPoint.value !== null ? {
                    markPoint: {
                        symbol: `image://${0, (/*@__PURE__*/$parcel$interopDefault($7u8Z9))}`,
                        silent: true,
                        symbolSize: 22,
                        data: [
                            {
                                coord: [
                                    selectedIndex,
                                    `${selectedPoint.value}`
                                ]
                            }
                        ]
                    }
                } : {},
                ...medianIssues !== null ? {
                    markLine: {
                        data: [
                            {
                                yAxis: medianIssues
                            }
                        ],
                        silent: true,
                        lineStyle: {
                            color: (0, $829f609a65d26a98$exports).N300,
                            width: 1
                        },
                        symbol: 'none',
                        label: {
                            show: false
                        }
                    }
                } : {}
            },
            {
                type: 'line',
                connectNulls: true,
                data: dataPoints.map((dataPoint, i)=>i < lastCompleteWeekIndexWithData ? null : dataPoint),
                color: (0, $829f609a65d26a98$exports).B100,
                symbol: `image://${(0, (/*@__PURE__*/$parcel$interopDefault($3O9mo)))}`,
                symbolSize: 9,
                lineStyle: {
                    width: 1,
                    type: 'dashed',
                    color: (0, $829f609a65d26a98$exports).B100
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lXVui))), {
        echarts: $ixV1I,
        option: chartOptions,
        onEvents: onEvents,
        style: {
            height: '100%'
        }
    });
};
var $44f5195bd43b375a$export$2e2bcd8739ae039 = $44f5195bd43b375a$var$Chart;

});
parcelRegister("e4v2N", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");

var $kPZpS = parcelRequire("kPZpS");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $a3e985251d714418$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : $kPZpS(n);
    return $dM3Z8(array, 0, n < 0 ? 0 : n);
}
module.exports = $a3e985251d714418$var$take;

});

parcelRegister("hnoNV", function(module, exports) {

$parcel$export(module.exports, "install", () => $ca67d33ebd24fc06$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $hpWan = parcelRequire("hpWan");

var $9CmBI = parcelRequire("9CmBI");

var $btF6F = parcelRequire("btF6F");
function $ca67d33ebd24fc06$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $9CmBI.default));
    registers.registerComponentView((0, $btF6F.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $hpWan.default)(opt.series, 'markPoint')) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

});
parcelRegister("9CmBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $700932fc8326c357$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $h8Fle = parcelRequire("h8Fle");
var $700932fc8326c357$var$MarkPointModel = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = 'markPoint';
    MarkPointModel.defaultOption = {
        zlevel: 0,
        z: 5,
        symbol: 'pin',
        symbolSize: 50,
        //symbolRotate: 0,
        //symbolOffset: [0, 0]
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'inside'
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $h8Fle.default));
var $700932fc8326c357$export$2e2bcd8739ae039 = $700932fc8326c357$var$MarkPointModel;

});

parcelRegister("btF6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $85b24a0e23bf3142$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $5DXGq = parcelRequire("5DXGq");

var $jmSNG = parcelRequire("jmSNG");

var $liBXN = parcelRequire("liBXN");

var $gjRnj = parcelRequire("gjRnj");

var $k3pUt = parcelRequire("k3pUt");

var $h8Fle = parcelRequire("h8Fle");

var $bahqM = parcelRequire("bahqM");

var $7QjoM = parcelRequire("7QjoM");

var $fk5Gm = parcelRequire("fk5Gm");
function $85b24a0e23bf3142$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $jmSNG.parsePercent(itemModel.get('x'), api.getWidth());
        var yPx = $jmSNG.parsePercent(itemModel.get('y'), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $85b24a0e23bf3142$var$MarkPointView = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $h8Fle.default).getMarkerModelFromSeries(seriesModel, 'markPoint');
            if (mpModel) {
                $85b24a0e23bf3142$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $5DXGq.default)());
        var mpData = $85b24a0e23bf3142$var$createData(coordSys, seriesModel, mpModel); // FIXME
        mpModel.setData(mpData);
        $85b24a0e23bf3142$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow('symbol');
            var symbolSize = itemModel.getShallow('symbolSize');
            var symbolRotate = itemModel.getShallow('symbolRotate');
            var symbolOffset = itemModel.getShallow('symbolOffset');
            var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect'); // TODO: refactor needed: single data item should not support callback function
            if ((0, $bahqM.isFunction)(symbol) || (0, $bahqM.isFunction)(symbolSize) || (0, $bahqM.isFunction)(symbolRotate) || (0, $bahqM.isFunction)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $bahqM.isFunction)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $bahqM.isFunction)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $bahqM.isFunction)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $bahqM.isFunction)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel('itemStyle').getItemStyle();
            var color = (0, $fk5Gm.getVisualFromData)(seriesData, 'color');
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        }); // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group); // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $7QjoM.getECData)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
    };
    MarkPointView.type = 'markPoint';
    return MarkPointView;
}((0, $k3pUt.default));
function $85b24a0e23bf3142$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $bahqM.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $bahqM.extend)((0, $bahqM.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var mpData = new (0, $liBXN.default)(coordDimsInfos, mpModel);
    var dataOpt = (0, $bahqM.map)(mpModel.get('data'), (0, $bahqM.curry)($gjRnj.dataTransform, seriesModel));
    if (coordSys) dataOpt = (0, $bahqM.filter)(dataOpt, (0, $bahqM.curry)($gjRnj.dataFilter, coordSys));
    var dimValueGetter = $gjRnj.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $85b24a0e23bf3142$export$2e2bcd8739ae039 = $85b24a0e23bf3142$var$MarkPointView;

});


parcelRegister("dUmnn", function(module, exports) {

$parcel$export(module.exports, "CHART_SPACE_LEFT", () => $90b64bc8f4f4e83e$export$ffe1d6b5e0d7a6e5);
$parcel$export(module.exports, "CHART_SPACE_RIGHT", () => $90b64bc8f4f4e83e$export$990d773ada9107e0);

var $gwIPs = parcelRequire("gwIPs");
const $90b64bc8f4f4e83e$export$ffe1d6b5e0d7a6e5 = (0, $gwIPs.gridSize) * 8;
const $90b64bc8f4f4e83e$export$990d773ada9107e0 = (0, $gwIPs.gridSize) * 4;
const $90b64bc8f4f4e83e$export$ad3c2ee386592d19 = (0, $gwIPs.gridSize) * 15;

});

parcelRegister("7u8Z9", function(module, exports) {
module.exports = new URL("circle-selected.bac10034.svg", import.meta.url).toString();

});

parcelRegister("3O9mo", function(module, exports) {
module.exports = new URL("circle.d95eea97.svg", import.meta.url).toString();

});

parcelRegister("ghL9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b948ad41186897$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7b948ad41186897$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yAxisLabel: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.y-axis-label",
        "defaultMessage": "Median issues"
    },
    xAxisLabel: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.x-axis-label",
        "defaultMessage": "Week commencing"
    },
    yAxisLabelIssueTermRefresh: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.y-axis-label-issue-term-refresh",
        "defaultMessage": "Median work items"
    }
});

});

parcelRegister("4ghCC", function(module, exports) {

$parcel$export(module.exports, "useTooltipFormatter", () => $c909316caf7163ff$export$8d71e8328e9bd59b);

var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");


var $lpLgi = parcelRequire("lpLgi");
const $c909316caf7163ff$var$getIconInfo = (value, deploymentsComparisonTarget)=>{
    if (deploymentsComparisonTarget === null) return {
        style: $c909316caf7163ff$var$iconBase,
        iconHtml: ''
    };
    if (value < deploymentsComparisonTarget) return {
        style: $c909316caf7163ff$var$iconWarn,
        iconHtml: (0, $d0cd9e09b6d842bf$export$f97d6df82c759e48)
    };
    if (value > deploymentsComparisonTarget) return {
        style: $c909316caf7163ff$var$iconGood,
        iconHtml: (0, $d0cd9e09b6d842bf$export$ae6cac6e77684f0f)
    };
    return {
        style: $c909316caf7163ff$var$iconBase,
        iconHtml: ''
    };
};
const $c909316caf7163ff$export$8d71e8328e9bd59b = ()=>{
    const { formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    return ({ data: data })=>{
        const { value: value, customInfo: { numProdDeployments: numProdDeployments, medianProdDeployments: medianProdDeployments, startDateInclusive: startDateInclusive } } = data;
        const weekStartDateText = formatMessage((0, $lpLgi.default).weekStartDate, {
            date: formatDate(startDateInclusive, {
                day: 'numeric',
                month: 'short'
            })
        });
        const statisticsText = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $lpLgi.default).medianIssuesPerDeploymentIssueTermRefresh, {
            medianIssuesPerDeployment: formatNumber(value ?? 0)
        }) : formatMessage((0, $lpLgi.default).medianIssuesPerDeployment, {
            medianIssuesPerDeployment: formatNumber(value ?? 0)
        });
        const numProductionDeploymentsText = formatMessage((0, $lpLgi.default).numProductionDeployments, {
            numProdDeployments: numProdDeployments
        });
        const { style: comparisonIconStyle, iconHtml: iconHtml } = $c909316caf7163ff$var$getIconInfo(numProdDeployments, medianProdDeployments);
        return `
            <div style="${$c909316caf7163ff$var$container}">
                <div style="${$c909316caf7163ff$var$header}">
                    <span style="${$c909316caf7163ff$var$weekStart}">${weekStartDateText}</span>
                </div>
                <div>
                    <div style="${$c909316caf7163ff$var$stack}">
                        <span style="${$c909316caf7163ff$var$issuesIconStyled}">${0, $d0cd9e09b6d842bf$export$51f43fae9c774cb5}</span>
                        <span style="${$c909316caf7163ff$var$statistics}">${statisticsText}</span>
                    </div>
                    <div style="${$c909316caf7163ff$var$stack}">
                        <span style="${comparisonIconStyle}">${iconHtml}</span>
                        <span style="${$c909316caf7163ff$var$statistics}">${numProductionDeploymentsText}</span>
                    </div>
                </div>
            </div>
        `;
    };
};
const $c909316caf7163ff$var$container = `
    height: ${(0, $gwIPs.gridSize) * 9}px;
    padding: 0 ${(0, $gwIPs.gridSize) / 2}px;
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: ${(0, $gwIPs.borderRadius)};
    font: ${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
    color: ${"var(--ds-text-inverse, #FFFFFF)"};
`;
const $c909316caf7163ff$var$header = `
    display: flex;
    justify-content: space-between;
    height: ${(0, $gwIPs.gridSize) * 2}px;
    margin-bottom: ${(0, $gwIPs.gridSize)}px;
`;
const $c909316caf7163ff$var$iconBase = `
    margin-top: -1px;
    height: 16px;
    width: 16px;
`;
const $c909316caf7163ff$var$iconGood = `
    ${$c909316caf7163ff$var$iconBase}
    fill: ${"var(--ds-text, #172B4D)"};
    color: ${"var(--ds-icon-success, #22A06B)"}
`;
const $c909316caf7163ff$var$iconWarn = `
    ${$c909316caf7163ff$var$iconBase}
    fill: ${"var(--ds-surface, #FFFFFF)"};
    color: ${"var(--ds-icon-warning, #E56910)"}
`;
const $c909316caf7163ff$var$weekStart = `
    text-decoration-line: underline;
    margin-right: ${(0, $gwIPs.gridSize) * 2.5}px;
`;
const $c909316caf7163ff$var$issuesIconStyled = `
    ${$c909316caf7163ff$var$iconBase}
`;
const $c909316caf7163ff$var$statistics = `
  margin-left: ${(0, $gwIPs.gridSize) / 2}px;
`;
const $c909316caf7163ff$var$stack = `
    display: flex;
    align-items: center;
`;

});
const $d0cd9e09b6d842bf$export$ae6cac6e77684f0f = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fillRule="evenodd"><circle fill="currentColor" fillRule="nonzero" cx="12" cy="12" r="10"></circle><path d="M11.288 7.293L8.294 10.27a1.002 1.002 0 000 1.416 1.01 1.01 0 001.421 0l1.279-1.272V16c0 .552.451 1 1.006 1 .555 0 1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 001.421 0 .998.998 0 000-1.416l-2.994-2.977a1.01 1.01 0 00-1.423 0z" fill="inherit"></path></g></svg>';
const $d0cd9e09b6d842bf$export$f97d6df82c759e48 = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fillRule="evenodd"><circle fill="currentColor" fillRule="nonzero" cx="12" cy="12" r="10"></circle><path d="M10.994 8v5.586l-1.279-1.272a1.01 1.01 0 00-1.421 0 .998.998 0 000 1.416l2.994 2.977a1.01 1.01 0 001.423 0l2.994-2.977a.998.998 0 000-1.416 1.01 1.01 0 00-1.421 0l-1.279 1.272V8c0-.552-.45-1-1.005-1-.555 0-1.006.448-1.006 1z" fill="inherit"></path></g></svg>';
const $d0cd9e09b6d842bf$export$51f43fae9c774cb5 = '<svg width="16" height="16" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fillRule="evenodd"><path d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z" fillRule="nonzero"></path><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"></path></g></svg>';

parcelRegister("lpLgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3b8da66f92651b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a3b8da66f92651b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    medianIssuesPerDeployment: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.median-issues-per-deployment",
        "defaultMessage": "{medianIssuesPerDeployment} {medianIssuesPerDeployment, plural, one {median issue} other {median issues}} per deployment"
    },
    numProductionDeployments: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.num-production-deployments",
        "defaultMessage": "{numProdDeployments} {numProdDeployments, plural, one {production deployment} other {production deployments}}"
    },
    weekStartDate: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.week-start-date",
        "defaultMessage": "Week of {date}"
    },
    medianIssuesPerDeploymentIssueTermRefresh: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart.tooltip.median-issues-per-deployment-issue-term-refresh",
        "defaultMessage": "{medianIssuesPerDeployment} {medianIssuesPerDeployment, plural, one {median work item} other {median work items}} per deployment"
    }
});

});



parcelRegister("7fqGi", function(module, exports) {

$parcel$export(module.exports, "convertReportCoreToChartDataPoints", () => $a631b5560540b504$export$5050f1e61745475);

const $a631b5560540b504$export$5050f1e61745475 = (deploymentFrequencyReportData, selectedWeekStart)=>deploymentFrequencyReportData.weeksData.map((weekData)=>{
        const isSelectedData = selectedWeekStart ? selectedWeekStart?.getTime() === weekData.startDateInclusive.getTime() : false;
        return {
            value: weekData.medianIssuesPerDeployment.prod,
            itemStyle: {
                color: (0, $829f609a65d26a98$exports).N80
            },
            customInfo: {
                startDateInclusive: weekData.startDateInclusive,
                numProdDeployments: weekData.deploymentCount.prod,
                medianProdDeployments: deploymentFrequencyReportData.averageDeploymentCount,
                isSelectedData: isSelectedData
            }
        };
    });

});

parcelRegister("JMEgp", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $42ab6fb23a17515f$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gwIPs = parcelRequire("gwIPs");

var $4McSe = parcelRequire("4McSe");
const $42ab6fb23a17515f$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$ChartTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 14}px`,
        height: `${(0, $gwIPs.gridSize) * 2}px`,
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$ChartLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 1.5}px`,
        height: `${(0, $gwIPs.gridSize) * 8.5}px`,
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$Chart, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThin), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThick), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42ab6fb23a17515f$var$SelectionDetail, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 6.5}px`,
        height: `${(0, $gwIPs.gridSize) * 2.5}px`,
        margin: `0 0 ${(0, $gwIPs.gridSize) * 1.5}px 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 26.5}px`,
        height: `${(0, $gwIPs.gridSize) * 1.5}px`,
        margin: `0 0 ${(0, $gwIPs.gridSize) * 1.5}px 0`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 26.5}px`,
        height: `${(0, $gwIPs.gridSize)}px`,
        margin: "0"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42ab6fb23a17515f$var$ChartTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _4t3i1tcg _19bvv47k",
            __cmplp.className
        ])
    });
});
const $42ab6fb23a17515f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i68cl",
            __cmplp.className
        ])
    });
});
const $42ab6fb23a17515f$var$ChartLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ady _1e0c1txw _4cvr1h6o _19bvv47k _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $42ab6fb23a17515f$var$Chart = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1yb4 _ca0qu2gc _u5f3zwfg _n3td1ejb",
            __cmplp.className
        ])
    });
});
const $42ab6fb23a17515f$var$SelectionDetail = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("e0ycG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af165b8da18b0f2d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af165b8da18b0f2d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTitle: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.chart-title",
        "defaultMessage": "Batch Size"
    },
    titleHelpTooltip: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.title-help-tooltip",
        "defaultMessage": "Analyze your issues per deployment over the 12-week median and how it impacts your team's deployment frequency."
    },
    titleHelpTooltipIssueTermRefresh: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.title-help-tooltip-issue-term-refresh",
        "defaultMessage": "Analyze your work items per deployment over the 12-week median and how it impacts your team's deployment frequency."
    }
});

});

parcelRegister("baXQH", function(module, exports) {

$parcel$export(module.exports, "SelectionDetail", () => $914f8cc71c001855$export$e4886591ccee2d0c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");

var $6RYAp = parcelRequire("6RYAp");

var $FGQEy = parcelRequire("FGQEy");
const $914f8cc71c001855$export$e4886591ccee2d0c = ({ medianIssuesPerDeployment: medianIssuesPerDeployment, wholePeriodMedian: wholePeriodMedian, prodDataState: prodDataState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, medianIssuesPerDeployment !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$PrimaryValue, null, formatNumber(medianIssuesPerDeployment)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$WeeklyProductionDeployments, null, (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $FGQEy.default).medianIssuesPerProductionDeploymentIssueTermRefresh) : formatMessage((0, $FGQEy.default).medianIssuesPerProductionDeployment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RYAp.IssuesTrendSummary), {
        weekCount: medianIssuesPerDeployment ?? 0,
        wholePeriodStatistic: wholePeriodMedian ?? 0,
        prodDataState: prodDataState
    }));
};
const $914f8cc71c001855$var$PrimaryValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$PrimaryValueComponent, props));
const $914f8cc71c001855$var$WeeklyProductionDeployments = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($914f8cc71c001855$var$WeeklyProductionDeploymentsComponent, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $914f8cc71c001855$var$PrimaryValueComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _19pkidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $914f8cc71c001855$var$WeeklyProductionDeploymentsComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _otyru2gc _19pkidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("FGQEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0fedcb350dd6083$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a0fedcb350dd6083$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    medianIssuesPerProductionDeployment: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.selection-detail.median-issues-per-production-deployment",
        "defaultMessage": "Median issues per production deployment"
    },
    weekStartDate: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.selection-detail.week-start-date",
        "defaultMessage": "Week of {date}"
    },
    medianIssuesPerProductionDeploymentIssueTermRefresh: {
        "id": "software-deployment-frequency-report.issues-per-deployment-chart.selection-detail.median-issues-per-production-deployment-issue-term-refresh",
        "defaultMessage": "Median work items per production deployment"
    }
});

});



parcelRegister("awynr", function(module, exports) {

$parcel$export(module.exports, "LineChartByEnvironment", () => $0b508310b680e794$export$4a838fde7591e9ca);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kEVMo = parcelRequire("kEVMo");

var $c9nft = parcelRequire("c9nft");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dg0Fl = parcelRequire("dg0Fl");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $gilhC = parcelRequire("gilhC");

var $3Ws3s = parcelRequire("3Ws3s");

var $claG0 = parcelRequire("claG0");

var $fc3EB = parcelRequire("fc3EB");

var $7psL7 = parcelRequire("7psL7");

var $kRE16 = parcelRequire("kRE16");

var $8PdvU = parcelRequire("8PdvU");

var $hoNfM = parcelRequire("hoNfM");
const $0b508310b680e794$var$Title = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartTitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $hoNfM.default).chartTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $hoNfM.default).titleHelpTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$QuestionIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        LEGACY_size: "small",
        label: ""
    })))));
};
const $0b508310b680e794$var$ExpandableContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isOpen ? children : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconAfter: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9nft))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        onClick: ()=>{
            setIsOpen(!isOpen);
        }
    }, isOpen ? formatMessage((0, $hoNfM.default).dropDownButtonOpenDescription) : formatMessage((0, $hoNfM.default).dropDownButtonDescription)));
};
const $0b508310b680e794$export$4a838fde7591e9ca = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: data, loading: loading, error: error } = (0, $3Ws3s.useReportCoreData)();
    const [{ selectedWeekStart: selectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    if (error && data == null) // When error happens, retry button will be displayed by the bar chart, but this chart will display loading skeleton as per the design spec
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PdvU.LoadingSkeleton), null);
    if (loading || data == null || selectedWeekStart === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PdvU.LoadingSkeleton), null);
    error;
    const lineSeries = (0, $7psL7.convertReportCoreToChartDataPoints)(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ExpandableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$Title, null), ((0, $claG0.isDataAllUnmapped)(data) || (0, $claG0.isDataUnmappedFoundWithMissingProd)(data)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "unmappedDeploymentsMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0b508310b680e794$var$noProdContainerStyles
    }, (0, $claG0.isDataAllUnmapped)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $hoNfM.default).noMappedWarningTitle),
        appearance: "discovery"
    }, formatMessage((0, $hoNfM.default).noMappedWarningDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $hoNfM.default).nonProdWarningTitle),
        appearance: "discovery"
    }, formatMessage((0, $hoNfM.default).nonProdWarningDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fc3EB.Chart), {
        series: lineSeries
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b508310b680e794$var$ChartLegend, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kRE16.Legend), {
        deploymentReportData: data,
        selectedWeekStart: selectedWeekStart
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b508310b680e794$var$ChartTitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _19pkidpf _2hwxidpf _otyrpxbi _18u0idpf _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b508310b680e794$var$QuestionIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _lswu5w2r _syazwdcn _80omtlke _ca0qv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b508310b680e794$var$ChartContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1lit",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b508310b680e794$var$ChartItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbqrhd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b508310b680e794$var$ChartLegend = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb194s _1ul9194s _19bv1ylp _1e0c1txw _2lx21bp4 _1bahv2br",
            __cmplp.className
        ])
    });
});
const $0b508310b680e794$var$noProdContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200',
    paddingLeft: 'space.200'
});

});
parcelRegister("c9nft", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::636414aaf061bfcc39e7053bfa952962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d885bfbdbf100db$var$_react = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d885bfbdbf100db$var$_chevronUp = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("dVd7B")));

var $8d885bfbdbf100db$var$_chevronUp2 = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("6Pmud")));
function $8d885bfbdbf100db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d885bfbdbf100db$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $8d885bfbdbf100db$var$_react.default.createElement($8d885bfbdbf100db$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $8d885bfbdbf100db$var$_chevronUp2.default
    }, props));
$8d885bfbdbf100db$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $8d885bfbdbf100db$var$_default = module.exports.default = $8d885bfbdbf100db$var$ChevronUpIcon;

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("dVd7B")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});


parcelRegister("fc3EB", function(module, exports) {

$parcel$export(module.exports, "Chart", () => $b7a20d98b2b1bb0c$export$acaa6426d77a227e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");

var $hYfgW = parcelRequire("hYfgW");

var $lXVui = parcelRequire("lXVui");

var $bkcQi = parcelRequire("bkcQi");
var $47isN = parcelRequire("47isN");

var $6OGL8 = parcelRequire("6OGL8");
var $48mDj = parcelRequire("48mDj");
var $gLj36 = parcelRequire("gLj36");

var $ixV1I = parcelRequire("ixV1I");

var $lWgYs = parcelRequire("lWgYs");

var $dWt6p = parcelRequire("dWt6p");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $4snLl = parcelRequire("4snLl");

var $7h73N = parcelRequire("7h73N");

var $hwC24 = parcelRequire("hwC24");
$ixV1I.use([
    (0, $47isN.install),
    (0, $bkcQi.install),
    (0, $48mDj.install),
    (0, $gLj36.install),
    (0, $6OGL8.install),
    (0, $lWgYs.install)
]);
const $b7a20d98b2b1bb0c$export$acaa6426d77a227e = ({ series: series })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const tooltipFormatter = (0, $hwC24.useTooltipFormatter)();
    const prefersReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    // RLSS-2812: support dark mode for echarts
    const axisCommonStyle = {
        nameGap: (0, $gwIPs.gridSize) * 4,
        nameLocation: 'middle',
        nameTextStyle: {
            color: (0, $829f609a65d26a98$exports).N400,
            // This cannot be replaced with a token as ECharts requires a numeric pixel value.
            // Background: https://atlassian.slack.com/archives/C071DCS8MDL/p1733289846954599
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 12
        }
    };
    const chartOptions = {
        animation: !prefersReducedMotion,
        tooltip: {
            backgroundColor: (0, $829f609a65d26a98$exports).N900,
            formatter: tooltipFormatter,
            transitionDuration: 0,
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    type: 'dashed',
                    color: (0, $829f609a65d26a98$exports).B100,
                    width: 0.5
                }
            },
            confine: true
        },
        grid: {
            left: (0, $4snLl.CHART_SPACE_LEFT),
            right: (0, $4snLl.CHART_SPACE_RIGHT),
            top: (0, $gwIPs.gridSize) * 2,
            bottom: (0, $gwIPs.gridSize) * 8
        },
        xAxis: {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            data: (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(series).data.map(({ customInfo: { startDateInclusive: startDateInclusive } })=>formatDate(startDateInclusive, {
                    month: 'short',
                    day: 'numeric'
                })),
            axisLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N40,
                    width: 2
                }
            },
            axisTick: {
                alignWithLabel: true
            },
            offset: (0, $gwIPs.gridSize) * 2,
            ...axisCommonStyle
        },
        yAxis: {
            name: formatMessage((0, $7h73N.default).yAxisLabel),
            ...axisCommonStyle,
            axisLine: {
                show: false
            },
            minInterval: 1,
            splitNumber: 4,
            axisTick: false,
            splitLine: {
                lineStyle: {
                    color: (0, $829f609a65d26a98$exports).N30
                }
            }
        },
        textStyle: {
            color: (0, $829f609a65d26a98$exports).N400
        },
        backgroundColor: 'transparent',
        series: series
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lXVui))), {
        echarts: $ixV1I,
        option: chartOptions,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            height: '100%'
        }
    });
};

});
parcelRegister("4snLl", function(module, exports) {

$parcel$export(module.exports, "CHART_SPACE_LEFT", () => $ffbbb531ca1515a3$export$ffe1d6b5e0d7a6e5);
$parcel$export(module.exports, "CHART_SPACE_RIGHT", () => $ffbbb531ca1515a3$export$990d773ada9107e0);

var $gwIPs = parcelRequire("gwIPs");
const $ffbbb531ca1515a3$export$ffe1d6b5e0d7a6e5 = (0, $gwIPs.gridSize) * 8;
const $ffbbb531ca1515a3$export$990d773ada9107e0 = (0, $gwIPs.gridSize) * 4;
const $ffbbb531ca1515a3$export$ad3c2ee386592d19 = (0, $gwIPs.gridSize) * 20;

});

parcelRegister("7h73N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c57e1dbcc6d489$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c9c57e1dbcc6d489$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    yAxisLabel: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.y-axis-label",
        "defaultMessage": "Deployment frequency"
    }
});

});

parcelRegister("hwC24", function(module, exports) {

$parcel$export(module.exports, "useTooltipFormatter", () => $9711af028c55d997$export$8d71e8328e9bd59b);

var $hYfgW = parcelRequire("hYfgW");


var $gwIPs = parcelRequire("gwIPs");

var $aWse0 = parcelRequire("aWse0");

var $fuOE9 = parcelRequire("fuOE9");
const $9711af028c55d997$var$getCountsByEnvironment = (series)=>{
    const developmentSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'development' && chartSeries.data.value !== null);
    const testingSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'testing' && chartSeries.data.value !== null);
    const stagingSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'staging' && chartSeries.data.value !== null);
    const productionSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'production' && chartSeries.data.value !== null);
    const unmappedSeries = series.find((chartSeries)=>chartSeries.data.customInfo.environment === 'unmapped' && chartSeries.data.value !== null);
    return {
        developmentCount: developmentSeries ? developmentSeries.data.value : null,
        testingCount: testingSeries ? testingSeries.data.value : null,
        stagingCount: stagingSeries ? stagingSeries.data.value : null,
        productionCount: productionSeries ? productionSeries.data.value : null,
        unmappedCount: unmappedSeries ? unmappedSeries.data.value : null
    };
};
const $9711af028c55d997$export$8d71e8328e9bd59b = ()=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return (series)=>{
        const weekStartDateText = formatMessage((0, $fuOE9.default).weekStartDate, {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            date: formatDate((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(series).data.customInfo.startDateInclusive, {
                day: 'numeric',
                month: 'short'
            })
        });
        const { developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount } = $9711af028c55d997$var$getCountsByEnvironment(series);
        if (developmentCount === null && testingCount === null && stagingCount === null && productionCount === null && unmappedCount === null) return null;
        let resultHTML = `<div style="${$9711af028c55d997$var$container}"><div style="${$9711af028c55d997$var$headerWeekStartText}">${weekStartDateText}</div>`;
        if (developmentCount !== null) {
            const message = formatMessage((0, $fuOE9.default).numDevelopmentDeployments, {
                numDeployments: developmentCount
            });
            resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
        }
        if (testingCount !== null) {
            const message = formatMessage((0, $fuOE9.default).numTestingDeployments, {
                numDeployments: testingCount
            });
            resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
        }
        if (stagingCount !== null) {
            const message = formatMessage((0, $fuOE9.default).numStagingDeployments, {
                numDeployments: stagingCount
            });
            resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
        }
        if (productionCount !== null) {
            const message = formatMessage((0, $fuOE9.default).numProductionDeployments, {
                numDeployments: productionCount
            });
            resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
        }
        if (unmappedCount !== null) {
            const message = formatMessage((0, $fuOE9.default).numUnmappedDeployments, {
                numDeployments: unmappedCount
            });
            resultHTML += `<p style="${$9711af028c55d997$var$countRow}">${message}</p>`;
        }
        resultHTML += '</div>';
        return resultHTML;
    };
};
const $9711af028c55d997$var$container = `
    padding: 0 ${(0, $gwIPs.gridSize) / 2}px;
    background-color: ${(0, $829f609a65d26a98$exports).N900};
    border-radius: ${(0, $gwIPs.borderRadius)};
    font: ${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
`;
const $9711af028c55d997$var$headerWeekStartText = `
    height: ${(0, $gwIPs.gridSize) * 2}px;
    margin-bottom: ${(0, $gwIPs.gridSize)}px;
    text-decoration-line: underline;
    color: ${(0, $829f609a65d26a98$exports).N0};
    line-height: ${(0, $gwIPs.gridSize) * 2}px;
`;
const $9711af028c55d997$var$countRow = `
    margin: 0px;
    padding: 0px;
`;

});
parcelRegister("fuOE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe5c2270eedaa0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfe5c2270eedaa0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numDevelopmentDeployments: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-development-deployments",
        "defaultMessage": "{numDeployments} development {numDeployments, plural, one {deployment} other {deployments}}"
    },
    numTestingDeployments: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-testing-deployments",
        "defaultMessage": "{numDeployments} testing {numDeployments, plural, one {deployment} other {deployments}}"
    },
    numStagingDeployments: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-staging-deployments",
        "defaultMessage": "{numDeployments} staging {numDeployments, plural, one {deployment} other {deployments}}"
    },
    numProductionDeployments: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-production-deployments",
        "defaultMessage": "{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}"
    },
    numUnmappedDeployments: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-unmapped-deployments",
        "defaultMessage": "{numDeployments} unmapped {numDeployments, plural, one {deployment} other {deployments}}"
    },
    weekStartDate: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.week-start-date",
        "defaultMessage": "Week of {date}"
    }
});

});



parcelRegister("7psL7", function(module, exports) {

$parcel$export(module.exports, "convertReportCoreToChartDataPoints", () => $8c6613932f8c18c1$export$5050f1e61745475);

var $3W61W = parcelRequire("3W61W");

var $eYoUo = parcelRequire("eYoUo");

var $cQgql = parcelRequire("cQgql");

var $3F2eM = parcelRequire("3F2eM");

var $82rct = parcelRequire("82rct");

var $eZlou = parcelRequire("eZlou");
const $8c6613932f8c18c1$var$getEnvironmentSeries = (startDatesAndCounts, lineColor, baseLineType, icon, symbolSize)=>{
    const commonProps = {
        type: 'line',
        color: lineColor,
        symbol: `image://${icon}`,
        symbolSize: symbolSize,
        symbolKeepAspect: false
    };
    const isCompletelyEmpty = startDatesAndCounts.every(({ count: count })=>count === 0);
    return [
        // @ts-expect-error - TS2322 - Type '{ data: { value: number | null; customInfo: { startDateInclusive: Date; environment: Environment; }; }[]; lineStyle: { type: "dashed" | "solid"; width: number; }; type: string; color: string; symbol: string; symbolSize: number; symbolKeepAspect: boolean; }' is not assignable to type 'LineChartByEnvSeries'.
        {
            ...commonProps,
            data: startDatesAndCounts.map(({ startDateInclusive: startDateInclusive, count: count, environment: environment }, i)=>{
                const isCurrentWeek = i === startDatesAndCounts.length - 1;
                const value = isCompletelyEmpty || isCurrentWeek ? null : count;
                return {
                    value: value,
                    customInfo: {
                        startDateInclusive: startDateInclusive,
                        environment: environment
                    }
                };
            }),
            lineStyle: {
                type: baseLineType,
                width: 2
            }
        },
        // @ts-expect-error - TS2322 - Type '{ data: { value: number | null; customInfo: { startDateInclusive: Date; environment: Environment; }; }[]; lineStyle: { type: string; width: number; }; type: string; color: string; symbol: string; symbolSize: number; symbolKeepAspect: boolean; }' is not assignable to type 'LineChartByEnvSeries'.
        {
            ...commonProps,
            data: startDatesAndCounts.map(({ startDateInclusive: startDateInclusive, count: count, environment: environment }, i)=>{
                const isNotLastTwoWeeks = i < startDatesAndCounts.length - 2;
                const value = isCompletelyEmpty || isNotLastTwoWeeks ? null : count;
                return {
                    value: value,
                    customInfo: {
                        startDateInclusive: startDateInclusive,
                        environment: environment
                    }
                };
            }),
            lineStyle: {
                type: 'dashed',
                width: 2
            }
        }
    ];
};
const $8c6613932f8c18c1$export$5050f1e61745475 = (reportData)=>[
        ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                count: weekData.deploymentCount.development,
                startDateInclusive: weekData.startDateInclusive,
                environment: 'development'
            })), (0, $eZlou.LINE_COLOR_MAP).development, 'solid', (0, (/*@__PURE__*/$parcel$interopDefault($3W61W))), 8),
        ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                count: weekData.deploymentCount.testing,
                startDateInclusive: weekData.startDateInclusive,
                environment: 'testing'
            })), (0, $eZlou.LINE_COLOR_MAP).testing, 'solid', (0, (/*@__PURE__*/$parcel$interopDefault($3F2eM))), 6),
        ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                count: weekData.deploymentCount.staging,
                startDateInclusive: weekData.startDateInclusive,
                environment: 'staging'
            })), (0, $eZlou.LINE_COLOR_MAP).staging, 'solid', (0, (/*@__PURE__*/$parcel$interopDefault($cQgql))), 6),
        ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                count: weekData.deploymentCount.prod,
                startDateInclusive: weekData.startDateInclusive,
                environment: 'production'
            })), (0, $eZlou.LINE_COLOR_MAP).prod, 'solid', (0, (/*@__PURE__*/$parcel$interopDefault($eYoUo))), 6),
        ...$8c6613932f8c18c1$var$getEnvironmentSeries(reportData.weeksData.map((weekData)=>({
                count: weekData.deploymentCount.unmapped,
                startDateInclusive: weekData.startDateInclusive,
                environment: 'unmapped'
            })), (0, $eZlou.LINE_COLOR_MAP).unmapped, 'dashed', (0, (/*@__PURE__*/$parcel$interopDefault($82rct))), 6)
    ];

});
parcelRegister("3W61W", function(module, exports) {
module.exports = new URL("line-chart-development.6278a877.svg", import.meta.url).toString();

});

parcelRegister("eYoUo", function(module, exports) {
module.exports = new URL("line-chart-production.cf5ea457.svg", import.meta.url).toString();

});

parcelRegister("cQgql", function(module, exports) {
module.exports = new URL("line-chart-staging.0cc32c4b.svg", import.meta.url).toString();

});

parcelRegister("3F2eM", function(module, exports) {
module.exports = new URL("line-chart-testing.75b26c7f.svg", import.meta.url).toString();

});

parcelRegister("82rct", function(module, exports) {
module.exports = new URL("line-chart-unmapped.3a47f8c5.svg", import.meta.url).toString();

});

parcelRegister("eZlou", function(module, exports) {

$parcel$export(module.exports, "LINE_COLOR_MAP", () => $c44f581d396673db$export$7aa99c2d78620887);

const $c44f581d396673db$export$7aa99c2d78620887 = {
    development: (0, $829f609a65d26a98$exports).B200,
    testing: (0, $829f609a65d26a98$exports).T300,
    staging: (0, $829f609a65d26a98$exports).T500,
    prod: (0, $829f609a65d26a98$exports).B400,
    unmapped: (0, $829f609a65d26a98$exports).P200
};

});


parcelRegister("kRE16", function(module, exports) {

$parcel$export(module.exports, "Legend", () => $37f589fb03b6c0b6$export$ed247974535929c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dg0Fl = parcelRequire("dg0Fl");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $f70oV = parcelRequire("f70oV");

var $claG0 = parcelRequire("claG0");

var $9ZBZe = parcelRequire("9ZBZe");

var $au9Ka = parcelRequire("au9Ka");

var $hPGu3 = parcelRequire("hPGu3");

var $fcRUo = parcelRequire("fcRUo");

var $8fMt0 = parcelRequire("8fMt0");

var $g7PDF = parcelRequire("g7PDF");

var $2jMxH = parcelRequire("2jMxH");
const $37f589fb03b6c0b6$var$EnvironmentLegend = ({ iconSrc: iconSrc, environment: environment, shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendIcon, {
        src: iconSrc,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LegendLabel, null, formatMessage((0, $f70oV.default)[environment])), shouldDisplayTooltipForUnmappedLegend && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $37f589fb03b6c0b6$var$tooltipContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $g7PDF.default).unmappedTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$QuestionIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        LEGACY_size: "small",
        label: ""
    })))));
};
const $37f589fb03b6c0b6$var$LeftContent = ({ developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount, shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, developmentCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($9ZBZe))),
        environment: "development",
        shouldDisplayTooltipForUnmappedLegend: false
    }), testingCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($fcRUo))),
        environment: "testing",
        shouldDisplayTooltipForUnmappedLegend: false
    }), stagingCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($hPGu3))),
        environment: "staging",
        shouldDisplayTooltipForUnmappedLegend: false
    }), productionCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($au9Ka))),
        environment: "production",
        shouldDisplayTooltipForUnmappedLegend: false
    }), unmappedCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$EnvironmentLegend, {
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8fMt0))),
        environment: "unmapped",
        shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend
    })));
const $37f589fb03b6c0b6$var$RightContent = ({ developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, developmentCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, developmentCount), testingCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, testingCount), stagingCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, stagingCount), productionCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, productionCount), unmappedCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$WeekDeploymentCountRow, null, unmappedCount));
const $37f589fb03b6c0b6$export$ed247974535929c7 = ({ deploymentReportData: deploymentReportData, selectedWeekStart: selectedWeekStart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { developmentCount: developmentCount, testingCount: testingCount, stagingCount: stagingCount, productionCount: productionCount, unmappedCount: unmappedCount } = (0, $2jMxH.getPotentialCounts)(deploymentReportData, selectedWeekStart);
    const shouldDisplayTooltipForUnmappedLegend = (0, $claG0.isDataUnmappedFoundWithMissingPreProdButWithProd)(deploymentReportData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LeftContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$TitleLeftContainer, null, formatMessage((0, $g7PDF.default).environmentTypeTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$LeftContent, {
        developmentCount: developmentCount,
        testingCount: testingCount,
        stagingCount: stagingCount,
        productionCount: productionCount,
        unmappedCount: unmappedCount,
        shouldDisplayTooltipForUnmappedLegend: shouldDisplayTooltipForUnmappedLegend
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$RightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$TitleRightContainer, null, formatMessage((0, $g7PDF.default).weeklyDeploymentTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37f589fb03b6c0b6$var$RightContent, {
        developmentCount: developmentCount,
        testingCount: testingCount,
        stagingCount: stagingCount,
        productionCount: productionCount,
        unmappedCount: unmappedCount
    })));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$LeftContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$RightContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $37f589fb03b6c0b6$var$rowCommonStyles = null;
const $37f589fb03b6c0b6$var$titleCommonStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $37f589fb03b6c0b6$var$TitleLeftContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz1gjq _k48pmoej _4t3ipxbi _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $37f589fb03b6c0b6$var$TitleRightContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz1gjq _k48pmoej _4t3ipxbi _otyru2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$LegendRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyru2gc _4t3ipxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$LegendIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$LegendLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $37f589fb03b6c0b6$var$WeekDeploymentCountRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _otyru2gc _4t3ipxbi _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37f589fb03b6c0b6$var$QuestionIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _lswu5w2r _syazwdcn _80omtlke",
            __cmplp.className
        ])
    });
});
const $37f589fb03b6c0b6$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.negative.050'
});

});
parcelRegister("9ZBZe", function(module, exports) {
module.exports = new URL("development.ce6d1083.svg", import.meta.url).toString();

});

parcelRegister("au9Ka", function(module, exports) {
module.exports = new URL("production.a13364ef.svg", import.meta.url).toString();

});

parcelRegister("hPGu3", function(module, exports) {
module.exports = new URL("staging.daa5274a.svg", import.meta.url).toString();

});

parcelRegister("fcRUo", function(module, exports) {
module.exports = new URL("testing.d27e57ac.svg", import.meta.url).toString();

});

parcelRegister("8fMt0", function(module, exports) {
module.exports = new URL("unmapped.f52bfa1f.png", import.meta.url).toString();

});

parcelRegister("g7PDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a93bbe05943003$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e1a93bbe05943003$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    environmentTypeTitle: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.legend.environment-type-title",
        "defaultMessage": "Environment type"
    },
    weeklyDeploymentTitle: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.legend.weekly-deployment-title",
        "defaultMessage": "Week Deployments"
    },
    unmappedTooltip: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.legend.unmapped-tooltip",
        "defaultMessage": "Unmapped or missing environments. Configure your deployment tool to map your deployment to the environment type."
    }
});

});

parcelRegister("2jMxH", function(module, exports) {

$parcel$export(module.exports, "getPotentialCounts", () => $070d4d1aa5386367$export$847b2a18518cd2fc);

var $l8ekP = parcelRequire("l8ekP");

var $claG0 = parcelRequire("claG0");
const $070d4d1aa5386367$var$getPotentialCount = (isDataAbsolutelyEmpty, isEnvironmentDataEmpty, isDataUnmappedFoundWithMissingProd, count)=>{
    if (isDataAbsolutelyEmpty) return 0;
    if (isDataUnmappedFoundWithMissingProd && isEnvironmentDataEmpty) return '-';
    return isEnvironmentDataEmpty ? undefined : count;
};
const $070d4d1aa5386367$export$847b2a18518cd2fc = (reportData, selectedWeekStart)=>{
    const isDataAbsolutelyEmpty = (0, $claG0.isDataAbsolutelyEmpty)(reportData);
    const isDevelopmentDataEmpty = (0, $claG0.isDevelopmentDataEmpty)(reportData);
    const isTestingDataEmpty = (0, $claG0.isTestingDataEmpty)(reportData);
    const isStagingDataEmpty = (0, $claG0.isStagingDataEmpty)(reportData);
    const isProdDataEmpty = (0, $claG0.isProdDataEmpty)(reportData);
    const isUnmappedDataEmpty = (0, $claG0.isUnmappedDataEmpty)(reportData);
    const isDataUnmappedFoundWithMissingProd = (0, $claG0.isDataUnmappedFoundWithMissingProd)(reportData);
    const selectedWeekData = (0, $l8ekP.getSelectedWeekData)(reportData.weeksData, selectedWeekStart);
    return {
        developmentCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isDevelopmentDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.development),
        testingCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isTestingDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.testing),
        stagingCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isStagingDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.staging),
        productionCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isProdDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.prod),
        unmappedCount: $070d4d1aa5386367$var$getPotentialCount(isDataAbsolutelyEmpty, isUnmappedDataEmpty, isDataUnmappedFoundWithMissingProd, selectedWeekData.deploymentCount.unmapped)
    };
};

});


parcelRegister("8PdvU", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $92961529bda703e4$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gwIPs = parcelRequire("gwIPs");

var $4McSe = parcelRequire("4McSe");
const $92961529bda703e4$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92961529bda703e4$var$ChartTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 30}px`,
        height: `${(0, $gwIPs.gridSize) * 2}px`,
        margin: "0"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92961529bda703e4$var$ChartTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _4t3i1tcg _19bvv47k",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hoNfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $337c5ca2b1e7dcd9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $337c5ca2b1e7dcd9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTitle: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.chart-title",
        "defaultMessage": "All deployment environment types"
    },
    titleHelpTooltip: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.title-help-tooltip",
        "defaultMessage": "Compare your deployment frequency for all environment types. To avoid risky deployments, try to deploy to production more often, or equally to other environments."
    },
    noMappedWarningTitle: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-title",
        "defaultMessage": "No mapped deployment data"
    },
    noMappedWarningDescription: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-description",
        "defaultMessage": "To make full use of this report, configure your deployment tool to map your deployments to environment types."
    },
    nonProdWarningTitle: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-title",
        "defaultMessage": "No production deployment data"
    },
    nonProdWarningDescription: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-description",
        "defaultMessage": "To make full use of this report, configure your deployment tool to map your production deployments to the production environment."
    },
    dropDownButtonDescription: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.drop-down-button-description",
        "defaultMessage": "Show all deployment environment types"
    },
    dropDownButtonOpenDescription: {
        "id": "software-deployment-frequency-report.line-chart-by-environment.drop-down-button-open-description",
        "defaultMessage": "Hide all deployment environment types"
    }
});

});


parcelRegister("1kopK", function(module, exports) {

$parcel$export(module.exports, "PerDeploymentDetailTable", () => $0c7ef676cf134889$export$a4efc4887401308e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k3qRI = parcelRequire("k3qRI");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kBSee = parcelRequire("kBSee");

var $gilhC = parcelRequire("gilhC");

var $mEdYv = parcelRequire("mEdYv");

var $caivO = parcelRequire("caivO");

var $jKTxB = parcelRequire("jKTxB");

var $krJkJ = parcelRequire("krJkJ");

var $lvKVW = parcelRequire("lvKVW");

var $8FGd5 = parcelRequire("8FGd5");
const $0c7ef676cf134889$var$Title = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$TableTitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $lvKVW.default).chartTitle)));
};
const $0c7ef676cf134889$export$a4efc4887401308e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ selectedWeekStart: selectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const [, { setSelectedDeploymentId: setSelectedDeploymentId }] = (0, $mEdYv.useSelectedDeploymentId)();
    const { data: data, loading: loading, error: error } = (0, $jKTxB.usePeriodBreakdownMetrics)(selectedWeekStart !== null ? (0, $kBSee.getWeekRangeFromWeekStartDate)(selectedWeekStart) : null);
    const selectDeployment = (deployment)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issuesPerDeploymentCell'
        }));
        setSelectedDeploymentId(deployment.id);
    };
    const rows = (0, $8FGd5.useTableRows)(data?.perDeploymentMetrics, data?.medianIssuesPerDeployment, selectDeployment);
    const header = (0, $8FGd5.useTableHeader)();
    if (error && rows === null || loading || rows === null || selectedWeekStart === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krJkJ.LoadingSkeleton), null);
    error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$IssueTableContainer, {
        "data-test-id": "software-deployment-frequency-report.ui.per-deployment-detail-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caivO.ViewDeploymentFrequencyReportExperienceSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c7ef676cf134889$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default // This is to forcibly trigger re-rendering when selectedWeekStart is changed. Some weeks have 5 pages,
    ), {
        // some weeks have less pages than 5, which will make table stay in a wrong page if we don't do this
        key: JSON.stringify(selectedWeekStart),
        head: header,
        rows: rows,
        rowsPerPage: !loading && rows.length > 10 ? 10 : undefined,
        defaultPage: 1,
        loadingSpinnerSize: "large",
        isLoading: loading,
        isFixedSize: true,
        defaultSortKey: "jiraIssuesPerDeployment",
        defaultSortOrder: "DESC"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7ef676cf134889$var$TableTitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _19pkidpf _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7ef676cf134889$var$IssueTableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { faded: faded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _4t3isby8",
            __cmplp.faded ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("krJkJ", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $3c5215eff0dfb8ae$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4McSe = parcelRequire("4McSe");
const $3c5215eff0dfb8ae$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3c5215eff0dfb8ae$var$tableTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "120px",
        height: "16px",
        margin: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeaderLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "76px",
        height: "12px",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "76px",
        height: "12px",
        margin: `0 0 0 ${"var(--ds-space-500, 40px)"}px`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "32px",
        height: "12px",
        margin: `0 0 0 ${"var(--ds-space-500, 40px)"}px`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c5215eff0dfb8ae$var$TableHeaderRight, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "76px",
        height: "12px",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "56px",
        height: "12px",
        margin: `0 0 0 ${"var(--ds-space-400, 32px)"}px`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: "84px",
        height: "12px",
        margin: `0 0 0 ${"var(--ds-space-800, 64px)"}px`
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.LineThick), null)));
const $3c5215eff0dfb8ae$var$tableTitleStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200',
    height: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c5215eff0dfb8ae$var$TableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3isby8",
            __cmplp.className
        ])
    });
});
const $3c5215eff0dfb8ae$var$TableHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3ixy5q _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $3c5215eff0dfb8ae$var$TableHeaderLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2hwx1ber _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $3c5215eff0dfb8ae$var$TableHeaderRight = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lvKVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $93315d73ef3acb1e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93315d73ef3acb1e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chartTitle: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.chart-title",
        "defaultMessage": "Deployments"
    },
    jiraIssuePerDeploymentColumnHead: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issue-per-deployment-column-head",
        "defaultMessage": "Jira issues per deployments"
    },
    deploymentColumnHead: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.deployment-column-head",
        "defaultMessage": "Deployment"
    },
    environmentNameColumnHead: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.environment-name-column-head",
        "defaultMessage": "Environment name"
    },
    pipelineColumnHead: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.pipeline-column-head",
        "defaultMessage": "Pipeline"
    },
    dateDeployedColumnHead: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.date-deployed-column-head",
        "defaultMessage": "Date deployed"
    },
    jiraIssuePerDeploymentColumnHeadIssueTermRefresh: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issue-per-deployment-column-head-issue-term-refresh",
        "defaultMessage": "Jira work items per deployments"
    }
});

});

parcelRegister("8FGd5", function(module, exports) {

$parcel$export(module.exports, "useTableHeader", () => $5124ddaec0d6668d$export$7fbbd6f6958548dc);
$parcel$export(module.exports, "useTableRows", () => $5124ddaec0d6668d$export$a190e1af00082b41);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");

var $4R6GH = parcelRequire("4R6GH");

var $d5cn8 = parcelRequire("d5cn8");

var $bgPrG = parcelRequire("bgPrG");

var $lvKVW = parcelRequire("lvKVW");
const $5124ddaec0d6668d$export$7fbbd6f6958548dc = ()=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    return {
        cells: [
            {
                key: 'jiraIssuesPerDeployment',
                content: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $lvKVW.default).jiraIssuePerDeploymentColumnHeadIssueTermRefresh) : formatMessage((0, $lvKVW.default).jiraIssuePerDeploymentColumnHead),
                isSortable: true,
                width: 180
            },
            {
                key: 'deployment',
                content: formatMessage((0, $lvKVW.default).deploymentColumnHead),
                isSortable: true,
                width: 140
            },
            {
                key: 'environmentName',
                content: formatMessage((0, $lvKVW.default).environmentNameColumnHead),
                isSortable: true,
                width: 200
            },
            {
                key: 'pipeline',
                content: formatMessage((0, $lvKVW.default).pipelineColumnHead),
                isSortable: true,
                width: 360
            },
            {
                key: 'dateDeployed',
                content: formatMessage((0, $lvKVW.default).dateDeployedColumnHead),
                isSortable: true,
                width: 100
            }
        ]
    };
};
const $5124ddaec0d6668d$export$a190e1af00082b41 = (data, medianIssuesPerDeployment, selectDeployment)=>{
    const { formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const [, actions] = (0, $d5cn8.useHoveredDeployment)();
    if (data == null || medianIssuesPerDeployment === undefined) return null;
    if (medianIssuesPerDeployment === null) return [];
    return data.map((deployment)=>{
        const { id: id, issueCount: issueCount, displayName: deploymentName, url: deploymentUrl, environment: { displayName: environmentName }, lastUpdated: dateDeployed, pipeline: { url: pipelineUrl, displayName: pipelineName } } = deployment;
        return {
            'data-deployment-id': id,
            // @ts-expect-error - TS7006 - Parameter 'evt' implicitly has an 'any' type.
            onMouseEnter: (evt)=>{
                actions.setHoveredDeployment(evt.currentTarget.dataset.deploymentId);
            },
            onMouseLeave: ()=>{
                actions.setHoveredDeployment(null);
            },
            cells: [
                {
                    key: `${issueCount} ${id}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgPrG.JiraIssuesPerDeploymentCellContent), {
                        medianIssuesPerDeployment: medianIssuesPerDeployment,
                        issueCount: issueCount,
                        onClick: ()=>selectDeployment(deployment)
                    })
                },
                {
                    key: `${deploymentName} ${id}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContentLink, {
                        href: deploymentUrl,
                        target: "_blank"
                    }, deploymentName)
                },
                {
                    key: `${environmentName} ${id}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContent, null, environmentName)
                },
                {
                    key: `${pipelineName} ${id}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContentLink, {
                        href: pipelineUrl,
                        target: "_blank"
                    }, pipelineName)
                },
                {
                    // @ts-expect-error - TS2339 - Confusion between JS Date and GraphQL Date scalar
                    key: `${dateDeployed.getTime()} ${id}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        content: formatDate(dateDeployed, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric'
                        }),
                        position: "top-start"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5124ddaec0d6668d$var$CellContent, null, formatDate(dateDeployed, {
                        month: 'short',
                        day: 'numeric'
                    })))
                }
            ]
        };
    });
};
const $5124ddaec0d6668d$var$contentCommonCssStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5124ddaec0d6668d$var$CellContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _4t3izwfg _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5124ddaec0d6668d$var$CellContentLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4bfu18uv _1hmsglyw _ajmmnqa1 _1bto1l2s _o5721q9c _4t3izwfg _1e0c1txw _2lx21bp4 _1bah1h6o _syaz14q2 _80omtlke _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bgPrG", function(module, exports) {

$parcel$export(module.exports, "JiraIssuesPerDeploymentCellContent", () => $0fe50fc915321385$export$cfadf0aa0c81a4ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $dW099 = parcelRequire("dW099");

var $29lcr = parcelRequire("29lcr");

var $fDJCJ = parcelRequire("fDJCJ");
const $0fe50fc915321385$var$getIconTooltipTranslatedMessage = (trend, formatMessage)=>{
    switch(trend){
        case 'under':
            return formatMessage((0, $fDJCJ.default).underTwelveWeekMedian);
        case 'over':
            return formatMessage((0, $fDJCJ.default).overTwelveWeekMedian);
        case 'equal':
            return '';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            trend;
            throw new Error('Unknown trend is given to getIconTooltipTranslatedMessage');
    }
};
const $0fe50fc915321385$export$cfadf0aa0c81a4ad = ({ medianIssuesPerDeployment: medianIssuesPerDeployment, issueCount: issueCount, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const trend = (0, $29lcr.getTrend)(issueCount, medianIssuesPerDeployment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$Wrapper, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: $0fe50fc915321385$var$getIconTooltipTranslatedMessage(trend, formatMessage),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$TrendIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dW099.TrendIcon), {
        trend: trend,
        colorScheme: "UP_IS_BAD"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0fe50fc915321385$var$IssueCount, null, (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $fDJCJ.default).numIssuesIssueTermRefresh, {
        numIssues: issueCount
    }) : formatMessage((0, $fDJCJ.default).numIssues, {
        numIssues: issueCount
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fe50fc915321385$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $0fe50fc915321385$var$TrendIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz",
            __cmplp.className
        ])
    });
});
const $0fe50fc915321385$var$IssueCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _1bto1l2s _o5721q9c _18u01b66 _syaz14q2 _80omtlke _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fDJCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b5ec44b18633c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f2b5ec44b18633c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numIssues: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.num-issues",
        "defaultMessage": "{numIssues} {numIssues, plural, one {issue} other {issues}}"
    },
    overTwelveWeekMedian: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.over-twelve-week-median",
        "defaultMessage": "Over 12-week median"
    },
    underTwelveWeekMedian: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.under-twelve-week-median",
        "defaultMessage": "Under 12-week median"
    },
    numIssuesIssueTermRefresh: {
        "id": "software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.num-issues-issue-term-refresh",
        "defaultMessage": "{numIssues} {numIssues, plural, one {work item} other {work items}}"
    }
});

});




parcelRegister("3MLtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7e66be432feacc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $b9dFI = parcelRequire("b9dFI");

var $jcw0u = parcelRequire("jcw0u");

var $aWse0 = parcelRequire("aWse0");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gilhC = parcelRequire("gilhC");

var $3Ws3s = parcelRequire("3Ws3s");

var $claG0 = parcelRequire("claG0");

var $82EMK = parcelRequire("82EMK");

var $7moEc = parcelRequire("7moEc");

var $jDAXZ = parcelRequire("jDAXZ");
const $ae7e66be432feacc$var$PeriodFilter = ()=>{
    const [{ selectedWeekStart: selectedWeekStart }, { setSelectedWeekStart: setSelectedWeekStart }] = (0, $gilhC.useSelectedWeekStore)();
    const { data: coreData, loading: coreDataLoading, error: coreDataError } = (0, $3Ws3s.useReportCoreData)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const hasReportedError = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const weekStartDates = (0, $5uXOq.useMemo)(()=>coreData ? (0, $jDAXZ.getDateOptionsFromCoreData)(coreData) : [], [
        coreData
    ]);
    const options = (0, $5uXOq.useMemo)(()=>coreData ? [
            {
                label: formatMessage((0, $7moEc.default).weekCommencing),
                options: weekStartDates.map((singleBarData)=>({
                        label: formatDate(singleBarData.startDateInclusive, {
                            month: 'short',
                            day: 'numeric'
                        }),
                        value: singleBarData.startDateInclusive
                    }))
            }
        ] : [], [
        coreData,
        weekStartDates,
        formatDate,
        formatMessage
    ]);
    if (coreDataError && !hasReportedError.current) {
        hasReportedError.current = true;
        (0, $jcw0u.default)({
            error: coreDataError,
            meta: {
                id: 'periodFilterAGGError',
                packageName: 'jiraSoftwareDeploymentFrequencyReport',
                teamName: 'fusion-solaris'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    if (coreDataLoading || selectedWeekStart === null || coreData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82EMK.LoadingSkeleton), null);
    const prodDataState = (0, $claG0.getProdDataState)(coreData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae7e66be432feacc$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "software-deployment-frequency-report.ui.period-filter.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        classNamePrefix: "period-filter-popup-select",
        searchThreshold: 100,
        options: options,
        value: options[0].options.find((o)=>o.value.getTime() === selectedWeekStart.getTime()),
        onChange: ({ label: label, value: value }, { action: action })=>{
            if (action === 'select-option') {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'selectedWeek',
                    actionSubjectId: 'deploymentFrequencyReport'
                }));
                const singleBarData = weekStartDates.find((x)=>x.startDateInclusive === value);
                if (!singleBarData) throw new Error(`cannot find dateRange from ${label}`);
                setSelectedWeekStart(singleBarData.startDateInclusive);
            }
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    label: "",
                    size: "small"
                }),
                isDisabled: prodDataState === 'COMPLETELY_EMPTY'
            }, formatMessage((0, $7moEc.default).weekOf, {
                date: formatDate(selectedWeekStart, {
                    month: 'short',
                    day: 'numeric'
                })
            }))
    })));
};
var $ae7e66be432feacc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ae7e66be432feacc$var$PeriodFilter;
const $ae7e66be432feacc$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("82EMK", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $f5c6ed9fd949cc8e$export$44c18d210d5de37b);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $4McSe = parcelRequire("4McSe");
const $f5c6ed9fd949cc8e$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4McSe.SkeletonItem), {
        width: `${(0, $gwIPs.gridSize) * 20}px`,
        height: `${(0, $gwIPs.gridSize) * 4}px`,
        margin: "0"
    });

});

parcelRegister("7moEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf92a315d14a0d0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cdf92a315d14a0d0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weekOf: {
        "id": "software-deployment-frequency-report.period-filter.week-of",
        "defaultMessage": "Week of {date}"
    },
    weekCommencing: {
        "id": "software-deployment-frequency-report.period-filter.week-commencing",
        "defaultMessage": "Week Commencing"
    }
});

});

parcelRegister("jDAXZ", function(module, exports) {

$parcel$export(module.exports, "getDateOptionsFromCoreData", () => $7dcd82cda3e5b584$export$e97b09724433dfb3);
const $7dcd82cda3e5b584$var$mostRecentDateComparator = (a, b)=>b.startDateInclusive.getTime() - a.startDateInclusive.getTime();
const $7dcd82cda3e5b584$export$e97b09724433dfb3 = (coreData)=>coreData.weeksData.filter((weekData)=>weekData.deploymentCount.prod > 0).map((weekData)=>({
            startDateInclusive: weekData.startDateInclusive
        })).sort($7dcd82cda3e5b584$var$mostRecentDateComparator);

});


parcelRegister("2e0gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c0b5cadf066765$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $evqT3 = parcelRequire("evqT3");

var $koVbs = parcelRequire("koVbs");

var $4CzOU = parcelRequire("4CzOU");

var $1CKbE = parcelRequire("1CKbE");

var $hHPkh = parcelRequire("hHPkh");
const $36c0b5cadf066765$var$WelcomeMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hasSeenReport, setHasSeenReportToTrue] = (0, $4CzOU.useHasSeenReport)();
    if (hasSeenReport) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evqT3.default), {
        actions: [
            {
                onClick: ()=>{
                    setHasSeenReportToTrue();
                },
                text: formatMessage((0, $hHPkh.default).gotIt)
            }
        ],
        heading: formatMessage((0, $hHPkh.default).heading),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1CKbE)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $hHPkh.default).firstParagraph)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c0b5cadf066765$var$List, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $hHPkh.default).point1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $hHPkh.default).point2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $hHPkh.default).lastParagraph)));
};
var $36c0b5cadf066765$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $36c0b5cadf066765$var$WelcomeMessage;
const $36c0b5cadf066765$var$List = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0pxbi _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("evqT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $44afc303b109e730$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $dkK4L = parcelRequire("dkK4L");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $kdO7l = parcelRequire("kdO7l");

var $jSZUh = parcelRequire("jSZUh");

var $lPfex = parcelRequire("lPfex");
class $44afc303b109e730$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $kdO7l.useModal)();
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSZUh.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            autoFocus: true,
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jSZUh.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $2OMIu.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSZUh.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dkK4L.default).Provider, {
                    value: (0, $lPfex.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSZUh.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSZUh.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("jSZUh", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $1c1428422690040b$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $1c1428422690040b$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $1c1428422690040b$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $1c1428422690040b$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $1c1428422690040b$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MHKc7 = parcelRequire("MHKc7");
const $1c1428422690040b$var$modalBodyStyles = null;
const $1c1428422690040b$var$modalHeadingStyles = null;
const $1c1428422690040b$var$modalImageStyles = null;
const $1c1428422690040b$var$modalActionContainerStyles = null;
const $1c1428422690040b$var$modalActionContainerReversedStyles = null;
const $1c1428422690040b$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $1c1428422690040b$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    });
const $1c1428422690040b$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        id: id,
        className: (0, $bwpsq.default)([
            "_11c8lodh _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
};
const $1c1428422690040b$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"
        ])
    });
const $1c1428422690040b$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    });
const $1c1428422690040b$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $1c1428422690040b$var$modalActionItemStyles.root,
        children: children
    });

});


parcelRegister("4CzOU", function(module, exports) {

$parcel$export(module.exports, "useHasSeenReport", () => $404627c6e1526f46$export$cda1c287b31cf7d3);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $90yGq = parcelRequire("90yGq");
const $404627c6e1526f46$var$PROPERTY_KEY = 'hasSeenDeploymentFrequencyReport';
const $404627c6e1526f46$export$cda1c287b31cf7d3 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const [hasSeen, setHasSeen] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        const fetchHasSeenDeploymentFrequencyReport = async ()=>{
            if (accountId == null) return;
            try {
                const res = await (0, $89SaW.getUserProperty)(accountId, $404627c6e1526f46$var$PROPERTY_KEY);
                setHasSeen(res);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                if (err.statusCode === 404) // if the property does not exist it returns 404
                setHasSeen(false);
                else throw err;
            }
        };
        fetchHasSeenDeploymentFrequencyReport();
    }, [
        accountId
    ]);
    return [
        hasSeen,
        ()=>{
            if (accountId == null) return;
            setHasSeen(true);
            (0, $89SaW.setUserProperties)(accountId, $404627c6e1526f46$var$PROPERTY_KEY, 'true');
        }
    ];
};

});

parcelRegister("1CKbE", function(module, exports) {
module.exports = new URL("deployment-frequency-welcome.4b7bb70b.svg", import.meta.url).toString();

});

parcelRegister("hHPkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $00613e984fcb72b4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00613e984fcb72b4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "software-deployment-frequency-report.welcome-message.heading",
        "defaultMessage": "View and improve your deployment frequency"
    },
    firstParagraph: {
        "id": "software-deployment-frequency-report.welcome-message.first-paragraph",
        "defaultMessage": "The Deployment frequency report leverages your deployments data to get you visibility into:"
    },
    point1: {
        "id": "software-deployment-frequency-report.welcome-message.point-1",
        "defaultMessage": "How often your team is deploying to production"
    },
    point2: {
        "id": "software-deployment-frequency-report.welcome-message.point-2",
        "defaultMessage": "Whether your deployment frequency is effective in managing risk"
    },
    lastParagraph: {
        "id": "software-deployment-frequency-report.welcome-message.last-paragraph",
        "defaultMessage": "Take it for a spin and let us know what you think."
    },
    gotIt: {
        "id": "software-deployment-frequency-report.welcome-message.got-it",
        "defaultMessage": "Got it"
    }
});

});




parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("rkyoD")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("rkyoD", function(module, exports) {

let $052277489b40dfb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $052277489b40dfb1$var$load("kNFvF"),
    $052277489b40dfb1$var$load("1EEDl")
]).then(()=>parcelRequire('eX102'));

});


parcelRegister("2O3HP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b027e3a953156ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b027e3a953156ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reports: {
        "id": "spa-apps-software-reports-deployment-frequency-report.reports",
        "defaultMessage": "Reports"
    },
    browserTitle: {
        "id": "spa-apps-software-reports-deployment-frequency-report.browser-title",
        "defaultMessage": "Deployment frequency"
    }
});

});

parcelRegister("fGFTb", function(module, exports) {

$parcel$export(module.exports, "PreconditionCheck", () => $a346006ab91bf465$export$ef543003424a5eae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $4Bwc0 = parcelRequire("4Bwc0");

var $caivO = parcelRequire("caivO");

var $2YP9W = parcelRequire("2YP9W");

var $7rdrV = parcelRequire("7rdrV");
const $a346006ab91bf465$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a346006ab91bf465$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $a346006ab91bf465$var$isConditionSatisfied = ({ hasViewDevToolsPermission: hasViewDevToolsPermission, hasViewAggregateDataPermission: hasViewAggregateDataPermission })=>hasViewDevToolsPermission && hasViewAggregateDataPermission;
const $a346006ab91bf465$export$ef543003424a5eae = ({ children: children, projectKey: projectKey })=>{
    const { data: preconditionData, error: preconditionError, loading: preconditionLoading } = (0, $2YP9W.useResource)((0, $4Bwc0.devOpsReportPreconditionResource));
    if (preconditionError) throw preconditionError;
    if (preconditionLoading || preconditionData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a346006ab91bf465$export$669f6ea7d267feaf, null);
    if ($a346006ab91bf465$var$isConditionSatisfied(preconditionData)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caivO.ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker), {
        reason: "User does not have permission to view the page"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7rdrV.NoPermissionPage), {
        projectKey: projectKey
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a346006ab91bf465$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7rdrV", function(module, exports) {

$parcel$export(module.exports, "NoPermissionPage", () => $63cc104529566fec$export$4032ea5637bc0ae3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dhE0n = parcelRequire("dhE0n");

var $1iZKm = parcelRequire("1iZKm");
const $63cc104529566fec$var$getProjectUrl = (projectKey)=>`/browse/${projectKey}`;
const $63cc104529566fec$export$4032ea5637bc0ae3 = ({ projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$PageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$BodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$DescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $63cc104529566fec$var$titleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $1iZKm.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$Description, null, formatMessage((0, $1iZKm.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        href: $63cc104529566fec$var$getProjectUrl(projectKey)
    }, formatMessage((0, $1iZKm.default).goBackToProject))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63cc104529566fec$var$IllustrationWrapper, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dhE0n))),
        "aria-hidden": true
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63cc104529566fec$var$PageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $63cc104529566fec$var$BodyWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsbweo2",
            __cmplp.className
        ])
    });
});
const $63cc104529566fec$var$DescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _u5f3xncg",
            __cmplp.className
        ])
    });
});
const $63cc104529566fec$var$IllustrationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1obz",
            __cmplp.className
        ])
    });
});
const $63cc104529566fec$var$titleWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63cc104529566fec$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dhE0n", function(module, exports) {
module.exports = new URL("lock_closed.80a15025.svg", import.meta.url).toString();

});

parcelRegister("1iZKm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c80056132f38396$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3c80056132f38396$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.title",
        "defaultMessage": "Limited project permissions"
    },
    description: {
        "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.description",
        "defaultMessage": "You do not have permission to view this report. Contact admin for details."
    },
    goBackToProject: {
        "id": "spa-apps-software-reports-deployment-frequency-report.precondition.not-available-page.go-back-to-project",
        "defaultMessage": "Go back to project"
    }
});

});



parcelRegister("8Gk6V", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $c3d84cde46071772$export$476aa014e2fd89d5);
const $c3d84cde46071772$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $c3d84cde46071772$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $c3d84cde46071772$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $c3d84cde46071772$var$NetworkErrorMessages = new Set([
    $c3d84cde46071772$var$ERROR_MESSAGE_CHROME,
    $c3d84cde46071772$var$ERROR_MESSAGE_FIREFOX,
    $c3d84cde46071772$var$ERROR_MESSAGE_OTHER
]);
const $c3d84cde46071772$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $c3d84cde46071772$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});



//# sourceMappingURL=async-deployment-frequency-report-entrypoint.01ec6057.js.map
